import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
  JSONObject: any;
  Upload: any;
};

export type AccountPage = {
  __typename?: 'AccountPage';
  alreadyRecord?: Maybe<Scalars['Boolean']>;
  clientId?: Maybe<Scalars['String']>;
  haveInstagramAccount?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isGlobal?: Maybe<Scalars['Boolean']>;
  isLinked?: Maybe<Scalars['Boolean']>;
  isUsingWebHook?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  networkReferer?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AccountsResponse = {
  __typename?: 'AccountsResponse';
  accounts?: Maybe<Array<Maybe<AccountPage>>>;
  nextToken?: Maybe<Scalars['String']>;
  previousToken?: Maybe<Scalars['String']>;
};

export type AdAccountsResponse = {
  __typename?: 'AdAccountsResponse';
  adAccounts?: Maybe<Array<Maybe<AmplifyAccount>>>;
  nextToken?: Maybe<Scalars['String']>;
  previousToken?: Maybe<Scalars['String']>;
};

export type AddEditedProductToCartResult = {
  __typename?: 'AddEditedProductToCartResult';
  subId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AdditionalInfo = {
  __typename?: 'AdditionalInfo';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AdditionalInfoInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  additionalAddress?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  codeStore?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  locationCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  salespoint?: Maybe<SalesPoint>;
  storeId?: Maybe<Scalars['ID']>;
};

export type Addresses = {
  __typename?: 'Addresses';
  billing?: Maybe<Address>;
  shipping?: Maybe<Address>;
};

export type AddressesInput = {
  billing?: InputMaybe<AddressInput>;
  shipping?: InputMaybe<Array<InputMaybe<AddressInput>>>;
};

export type AddressInput = {
  additionalAddress?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type AddSocialPostPayload = {
  __typename?: 'AddSocialPostPayload';
  post?: Maybe<SocialMediaPost>;
  validationRequiredCount?: Maybe<Scalars['Int']>;
};

export enum AllowedProductType {
  Media = 'media',
  Pack = 'pack',
  Physical = 'physical'
}

export type AmplifyAccount = {
  __typename?: 'AmplifyAccount';
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isLinked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AmplifyAccountPagination = {
  __typename?: 'AmplifyAccountPagination';
  accounts?: Maybe<Array<Maybe<AmplifyAccount>>>;
  count?: Maybe<Scalars['Int']>;
};

export enum AmplifyAdCampaignStatus {
  Done = 'done',
  Error = 'error',
  InProgress = 'in_progress',
  PendingPostAction = 'pending_post_action',
  PendingPostDate = 'pending_post_date',
  PostedWithError = 'posted_with_error',
  Stopped = 'stopped',
  Terminated = 'terminated'
}

export type AmplifyAdsListSortArgs = {
  criteria?: InputMaybe<AmplifyAdsListSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum AmplifyAdsListSortCriteria {
  Cpi = 'cpi',
  Interactions = 'interactions',
  Reach = 'reach',
  TotalSpend = 'total_spend'
}

export type AmplifyCampaign = {
  __typename?: 'AmplifyCampaign';
  adsCount?: Maybe<Scalars['Int']>;
  advantagePlusOption: Scalars['Boolean'];
  ageTargeting?: Maybe<Scalars['Boolean']>;
  author?: Maybe<User>;
  authorRole?: Maybe<SocialAuthorRole>;
  callToAction?: Maybe<Scalars['Int']>;
  cityKeysTarget?: Maybe<OrganicTargetingObject>;
  connection?: Maybe<AmplifyCampaignConnectionTypes>;
  cpi?: Maybe<Scalars['Float']>;
  endAt?: Maybe<Scalars['Date']>;
  geoRadius?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  isDefaultChalandiseZone?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  maxAgeTarget?: Maybe<Scalars['Int']>;
  minAgeTarget?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optimizationGoal?: Maybe<AmplifyCampaignGoalStrategy>;
  perPostBudget?: Maybe<Scalars['Float']>;
  post?: Maybe<SocialMediaPost>;
  sexOfTarget?: Maybe<Scalars['String']>;
  sexTargeting?: Maybe<Scalars['Boolean']>;
  socialNetwork?: Maybe<Scalars['String']>;
  specialCategories?: Maybe<Array<Maybe<AmplifyCampaignSpecialCategory>>>;
  spentBudget?: Maybe<Scalars['Float']>;
  spentInteraction?: Maybe<Scalars['Float']>;
  spentReach?: Maybe<Scalars['Float']>;
  startAt?: Maybe<Scalars['Date']>;
  status?: Maybe<AmplifyAdCampaignStatus>;
  target?: Maybe<AmplifyCampaignTargeting>;
  targetingCountries?: Maybe<Array<Maybe<OrganicTargetingObject>>>;
  targetingGeolocations?: Maybe<Array<Maybe<OrganicTargetingObject>>>;
  targetingInterests?: Maybe<Array<Maybe<OrganicTargetingObject>>>;
  totalBudget?: Maybe<Scalars['Float']>;
  totalStatus?: Maybe<AmplifyCampaignTotalStatus>;
};

export type AmplifyCampaignAd = {
  __typename?: 'AmplifyCampaignAd';
  cpi?: Maybe<Scalars['Float']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  spentBudget?: Maybe<Scalars['Float']>;
  spentInteraction?: Maybe<Scalars['Int']>;
  spentReach?: Maybe<Scalars['Int']>;
  status?: Maybe<AmplifyAdCampaignStatus>;
  stoppedDate?: Maybe<Scalars['Date']>;
  target?: Maybe<SalesPoint>;
  totalBudget?: Maybe<Scalars['Float']>;
};

export type AmplifyCampaignAdsList = {
  __typename?: 'AmplifyCampaignAdsList';
  ads?: Maybe<Array<Maybe<AmplifyCampaignAd>>>;
  count?: Maybe<Scalars['Int']>;
};

export type AmplifyCampaignAvailableTargets = {
  __typename?: 'AmplifyCampaignAvailableTargets';
  isGlobalConnectionOptionAvailable?: Maybe<Scalars['Boolean']>;
  isValidCatchmentForCategory?: Maybe<Scalars['Boolean']>;
  onGlobals?: Maybe<Scalars['Boolean']>;
  salesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
};

export enum AmplifyCampaignConnectionTypes {
  All = 'all',
  Fanfriends = 'fanfriends',
  Fans = 'fans',
  Noconnection = 'noconnection'
}

export enum AmplifyCampaignGoalStrategy {
  BrandAwareness = 'BRAND_AWARENESS',
  OutcomeAwareness = 'OUTCOME_AWARENESS',
  OutcomeEngagement = 'OUTCOME_ENGAGEMENT',
  OutcomeLeads = 'OUTCOME_LEADS',
  OutcomeSales = 'OUTCOME_SALES',
  OutcomeTraffic = 'OUTCOME_TRAFFIC'
}

export type AmplifyCampaignsList = {
  __typename?: 'AmplifyCampaignsList';
  campaigns?: Maybe<Array<Maybe<AmplifyCampaign>>>;
  count?: Maybe<Scalars['Int']>;
};

export type AmplifyCampaignsListSortArgs = {
  criteria?: InputMaybe<AmplifyCampaignsListSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum AmplifyCampaignsListSortCriteria {
  Budget = 'budget',
  Date = 'date',
  Interactions = 'interactions',
  Reach = 'reach'
}

export enum AmplifyCampaignSpecialCategory {
  Employment = 'EMPLOYMENT',
  FinancialProductsServices = 'FINANCIAL_PRODUCTS_SERVICES'
}

export type AmplifyCampaignsTotalMetrics = {
  __typename?: 'AmplifyCampaignsTotalMetrics';
  campaignsCount?: Maybe<Scalars['Int']>;
  spentBudget?: Maybe<Scalars['Float']>;
  spentInteractions?: Maybe<Scalars['Float']>;
  spentReach?: Maybe<Scalars['Float']>;
};

export type AmplifyCampaignTargeting = {
  __typename?: 'AmplifyCampaignTargeting';
  onGlobals?: Maybe<Scalars['Boolean']>;
  salesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
  type?: Maybe<TargetType>;
};

export type AmplifyCampaignTotalStatus = {
  __typename?: 'AmplifyCampaignTotalStatus';
  done?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['Int']>;
  terminated?: Maybe<Scalars['Int']>;
};

export type AmplifyTargeting = {
  onGlobals: Scalars['Boolean'];
  salesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type: AmplifyTargetingTypes;
};

export enum AmplifyTargetingTypes {
  AllTarget = 'all_target',
  SalesPoint = 'sales_point'
}

export type AnalyzeComparisonStat = {
  __typename?: 'AnalyzeComparisonStat';
  national: Scalars['Int'];
  salesPoint: Scalars['Int'];
};

export type AnalyzeComparisonStats = {
  __typename?: 'AnalyzeComparisonStats';
  engagement: AnalyzeComparisonStat;
  fans: AnalyzeComparisonStat;
  reach: AnalyzeComparisonStat;
};

export type AnalyzeMonthlyStats = {
  __typename?: 'AnalyzeMonthlyStats';
  date: Scalars['Date'];
  stats: AnalyzeTotalStats;
};

export type AnalyzeQueryArgs = {
  clusters?: InputMaybe<Array<Scalars['ID']>>;
  endAt?: InputMaybe<Scalars['Date']>;
  globals?: InputMaybe<Array<Scalars['String']>>;
  salesPoints?: InputMaybe<Array<Scalars['ID']>>;
  socialNetwork: SocialNetwork;
  startAt?: InputMaybe<Scalars['Date']>;
  target: TargetType;
};

export type AnalyzeSalesPointStatsList = {
  __typename?: 'AnalyzeSalesPointStatsList';
  count: Scalars['Int'];
  data: Array<AnalyzeSalesPointStatsListData>;
  pageInfos: PageInfos;
  success: Scalars['Boolean'];
};

export type AnalyzeSalesPointStatsListData = {
  __typename?: 'AnalyzeSalesPointStatsListData';
  engagement: Scalars['Int'];
  fans: Scalars['Int'];
  fansAdded: Scalars['Int'];
  fansLost: Scalars['Int'];
  followers: Scalars['Int'];
  id: Scalars['ID'];
  posts: Scalars['Int'];
  reach: Scalars['Int'];
  salesPoint?: Maybe<SalesPoint>;
  url: Scalars['String'];
};

export type AnalyzeSalesPointStatsListQueryArgs = {
  clusters?: InputMaybe<Array<Scalars['ID']>>;
  endAt?: InputMaybe<Scalars['Date']>;
  globals?: InputMaybe<Array<Scalars['String']>>;
  salesPoints?: InputMaybe<Array<Scalars['ID']>>;
  socialNetwork: SocialNetwork;
  startAt?: InputMaybe<Scalars['Date']>;
  target: TargetType;
};

export enum AnalyzeSalesPointStatsListQueryOrderBy {
  Engagement = 'engagement',
  Fans = 'fans',
  FansAdded = 'fansAdded',
  FansLost = 'fansLost',
  Followers = 'followers',
  Posts = 'posts',
  Reach = 'reach'
}

export type AnalyzeSocialCityStats = {
  __typename?: 'AnalyzeSocialCityStats';
  fans: Scalars['Int'];
  name: Scalars['String'];
  popularityPercent: Scalars['Float'];
};

export type AnalyzeSocialDemographicStats = {
  __typename?: 'AnalyzeSocialDemographicStats';
  age: Array<AnalyzeStat>;
  gender: Array<AnalyzeStat>;
  locale: Array<AnalyzeStat>;
};

export type AnalyzeStat = {
  __typename?: 'AnalyzeStat';
  key: Scalars['String'];
  total: Scalars['Int'];
};

export type AnalyzeTotalStats = {
  __typename?: 'AnalyzeTotalStats';
  engagement: Scalars['Int'];
  fans: Scalars['Int'];
  fansAdded?: Maybe<Scalars['Int']>;
  fansLost?: Maybe<Scalars['Int']>;
  followers: Scalars['Int'];
  posts?: Maybe<Scalars['Int']>;
  reach: Scalars['Int'];
};

export type AnswerTemplate = {
  __typename?: 'AnswerTemplate';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  language?: Maybe<AvailableLanguages>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rating?: Maybe<Array<Maybe<AnswerTemplateRating>>>;
  types?: Maybe<Array<Maybe<NotificationsTypes>>>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type AnswerTemplateInput = {
  clientId: Scalars['String'];
  enabled: Scalars['Boolean'];
  language?: InputMaybe<AvailableLanguages>;
  message: Scalars['String'];
  name: Scalars['String'];
  rating: Array<AnswerTemplateRating>;
  types: Array<NotificationsTypes>;
};

export type AnswerTemplateListInputParams = {
  haveDefault?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<AvailableLanguages>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Array<InputMaybe<AnswerTemplateRating>>>;
  salesPointId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<SortInput>;
  types?: InputMaybe<Array<InputMaybe<NotificationsTypes>>>;
};

export type AnswerTemplatePayload = {
  __typename?: 'AnswerTemplatePayload';
  answerTemplates?: Maybe<Array<Maybe<AnswerTemplate>>>;
  count?: Maybe<Scalars['Int']>;
};

export enum AnswerTemplateRating {
  All = 'all',
  Negative = 'negative',
  Neutral = 'neutral',
  Positive = 'positive'
}

export type AnswerTemplatesOverride = {
  __typename?: 'AnswerTemplatesOverride';
  answerTemplateId: Scalars['ID'];
  clientId: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  enabled: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type AnswerTemplateUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<AvailableLanguages>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Array<InputMaybe<AnswerTemplateRating>>>;
  types?: InputMaybe<Array<InputMaybe<NotificationsTypes>>>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  apiKey?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export type ApiKeyUserInfo = {
  __typename?: 'ApiKeyUserInfo';
  clientId?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  userId?: Maybe<Scalars['ID']>;
};

export type AuthBridgeRouterLink = {
  __typename?: 'AuthBridgeRouterLink';
  link: Scalars['String'];
};

export enum AvailableLang {
  Ar = 'ar',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  He = 'he',
  It = 'it',
  Nl = 'nl'
}

export enum AvailableLangs {
  Ar = 'ar',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  He = 'he',
  It = 'it',
  Nl = 'nl'
}

export enum AvailableLanguages {
  All = 'all',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Nl = 'nl'
}

export type AvailableQuantity = {
  __typename?: 'AvailableQuantity';
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  additionalAddress?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

export type BillingAddressInput = {
  additionalAddress?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type BlacklistPayload = {
  __typename?: 'BlacklistPayload';
  blacklist?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BridgeRouterLinkList = {
  __typename?: 'BridgeRouterLinkList';
  label: Scalars['String'];
  slug: Scalars['String'];
};

export type Brief = BriefInterface & {
  __typename?: 'Brief';
  attachments?: Maybe<Array<Maybe<BriefMedia>>>;
  attachmentsPageLastVisite?: Maybe<Scalars['Date']>;
  attribute?: Maybe<Scalars['String']>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  awaitingNewConception?: Maybe<Scalars['Boolean']>;
  briefNumber?: Maybe<Scalars['Int']>;
  briefSpecClient?: Maybe<Array<Maybe<BriefSpecClient>>>;
  budget?: Maybe<Scalars['Float']>;
  campaign?: Maybe<Campaign>;
  campaignEnd?: Maybe<Scalars['Date']>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignStart?: Maybe<Scalars['Date']>;
  campaignType?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  clusterIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comment?: Maybe<Scalars['String']>;
  conception?: Maybe<Array<Maybe<BriefMedia>>>;
  contacts?: Maybe<Array<Maybe<BriefContact>>>;
  contextGoalsIssues?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  customerJourney?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['Int']>;
  deliveryDeadline?: Maybe<Scalars['Date']>;
  deliveryOption?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  internalReference?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCommentEnabled?: Maybe<Scalars['Boolean']>;
  isProduct?: Maybe<Scalars['Boolean']>;
  latestStatusUpdate?: Maybe<BriefActivity>;
  medium?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  other?: Maybe<Scalars['String']>;
  productAttribute?: Maybe<Scalars['JSON']>;
  productId?: Maybe<Scalars['ID']>;
  providerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  quoteOptions?: Maybe<BriefQuoteOptions>;
  reference?: Maybe<Scalars['String']>;
  referenceVisuals?: Maybe<Array<Maybe<BriefMedia>>>;
  salesPoint?: Maybe<SalesPoint>;
  salesPointId?: Maybe<Scalars['ID']>;
  shippingAddresses?: Maybe<Array<Maybe<BriefShippingAddress>>>;
  status?: Maybe<BriefStatus>;
  targeting?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  useLaunchDate?: Maybe<Scalars['Boolean']>;
  useValidDate?: Maybe<Scalars['Boolean']>;
  validEndDate?: Maybe<Scalars['Date']>;
  validStartDate?: Maybe<Scalars['Date']>;
};

export enum BriefAction {
  ConceptionDecisionTaken = 'conception_decision_taken',
  CreateBrief = 'create_brief',
  DeleteFile = 'delete_file',
  EditBrief = 'edit_brief',
  NewComment = 'new_comment',
  SubmitConception = 'submit_conception',
  UpdateStatus = 'update_status',
  UploadFile = 'upload_file',
  ValidateBrief = 'validate_brief'
}

export type BriefActivitiesSpecs = {
  __typename?: 'BriefActivitiesSpecs';
  api?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BriefActivity = {
  __typename?: 'BriefActivity';
  action?: Maybe<BriefAction>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  brief?: Maybe<Brief>;
  briefId?: Maybe<Scalars['ID']>;
  comment?: Maybe<BriefComment>;
  content?: Maybe<BriefActivityContent>;
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
};

export type BriefActivityContent = {
  __typename?: 'BriefActivityContent';
  decision?: Maybe<BriefConceptionDecision>;
  file?: Maybe<BriefMedia>;
  status?: Maybe<BriefStatusFromTo>;
  updatedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BriefActivityFilter = {
  actions?: InputMaybe<Array<InputMaybe<BriefAction>>>;
};

export type BriefActivityPagination = {
  __typename?: 'BriefActivityPagination';
  activity?: Maybe<Array<Maybe<BriefActivity>>>;
  count?: Maybe<Scalars['Int']>;
};

export type BriefActivitySort = {
  criteria?: InputMaybe<BriefActivitySortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum BriefActivitySortCriteria {
  CreatedAt = 'createdAt'
}

export type BriefAllFields = {
  __typename?: 'BriefAllFields';
  activityType?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<BriefMedia>>>;
  attachmentsPageLastVisite?: Maybe<Scalars['Date']>;
  attribute?: Maybe<Scalars['String']>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  awaitingNewConception?: Maybe<Scalars['Boolean']>;
  briefNumber?: Maybe<Scalars['Int']>;
  briefSpecClient?: Maybe<Array<Maybe<BriefSpecClient>>>;
  briefType?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  budgetType?: Maybe<Scalars['String']>;
  campaign?: Maybe<Campaign>;
  campaignEnd?: Maybe<Scalars['Date']>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignStart?: Maybe<Scalars['Date']>;
  campaignType?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  clusterIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comment?: Maybe<Scalars['String']>;
  communicationType?: Maybe<Scalars['String']>;
  conception?: Maybe<Array<Maybe<BriefMedia>>>;
  contacts?: Maybe<Array<Maybe<BriefContact>>>;
  contextGoalsIssues?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  customerJourney?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['Int']>;
  deliveryDeadline?: Maybe<Scalars['Date']>;
  deliveryOption?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  internalReference?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCommentEnabled?: Maybe<Scalars['Boolean']>;
  isProduct?: Maybe<Scalars['Boolean']>;
  latestStatusUpdate?: Maybe<BriefActivity>;
  medium?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  other?: Maybe<Scalars['String']>;
  productAttribute?: Maybe<Scalars['JSON']>;
  productId?: Maybe<Scalars['ID']>;
  providerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  quoteOptions?: Maybe<BriefQuoteOptions>;
  reference?: Maybe<Scalars['String']>;
  referenceVisuals?: Maybe<Array<Maybe<BriefMedia>>>;
  salesPoint?: Maybe<SalesPoint>;
  salesPointId?: Maybe<Scalars['ID']>;
  shippingAddresses?: Maybe<Array<Maybe<BriefShippingAddress>>>;
  status?: Maybe<BriefStatus>;
  targeting?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  typesLabel?: Maybe<TypesLabel>;
  useLaunchDate?: Maybe<Scalars['Boolean']>;
  useValidDate?: Maybe<Scalars['Boolean']>;
  validEndDate?: Maybe<Scalars['Date']>;
  validStartDate?: Maybe<Scalars['Date']>;
};

export enum BriefApi {
  Attachments = 'attachments',
  ProofHq = 'proofHQ',
  Ziflow = 'ziflow'
}

export type BriefBudgetTypeSpecs = {
  __typename?: 'BriefBudgetTypeSpecs';
  api?: Maybe<Scalars['String']>;
  communications?: Maybe<Array<Maybe<BriefCommunicationSpecs>>>;
  models?: Maybe<Array<Maybe<BriefModelSpecs>>>;
  value?: Maybe<Scalars['String']>;
};

export type BriefCampaignType = {
  __typename?: 'BriefCampaignType';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BriefComment = {
  __typename?: 'BriefComment';
  activity?: Maybe<BriefActivity>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  briefId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type BriefCommentsPagination = {
  __typename?: 'BriefCommentsPagination';
  comments?: Maybe<Array<Maybe<BriefComment>>>;
  count?: Maybe<Scalars['Int']>;
};

export type BriefCommentsSort = {
  criteria?: BriefCommentsSortCriteria;
  direction?: InputMaybe<Direction>;
};

export enum BriefCommentsSortCriteria {
  CreatedAt = 'createdAt'
}

export type BriefCommunicationSpecs = {
  __typename?: 'BriefCommunicationSpecs';
  api?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum BriefConceptionDecision {
  Approved = 'approved',
  Refused = 'refused'
}

export type BriefContact = {
  __typename?: 'BriefContact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type BriefContactsPagination = {
  __typename?: 'BriefContactsPagination';
  contacts?: Maybe<Array<Maybe<BriefContact>>>;
  count?: Maybe<Scalars['Int']>;
};

export enum BriefExportType {
  Xls = 'xls',
  Xlsx = 'xlsx'
}

export type BriefFormatSpecs = {
  __typename?: 'BriefFormatSpecs';
  defaultDescription?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BriefForPlanning = {
  __typename?: 'BriefForPlanning';
  briefSpecClient?: Maybe<Array<Maybe<BriefSpecClient>>>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  salesPointId?: Maybe<Scalars['String']>;
  status?: Maybe<BriefStatus>;
  validEndDate?: Maybe<Scalars['Date']>;
  validStartDate?: Maybe<Scalars['Date']>;
};

export type BriefHyundai = BriefInterface & {
  __typename?: 'BriefHyundai';
  activityType?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Maybe<BriefMedia>>>;
  attachmentsPageLastVisite?: Maybe<Scalars['Date']>;
  attribute?: Maybe<Scalars['String']>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  awaitingNewConception?: Maybe<Scalars['Boolean']>;
  briefNumber?: Maybe<Scalars['Int']>;
  briefSpecClient?: Maybe<Array<Maybe<BriefSpecClient>>>;
  briefType?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Float']>;
  budgetType?: Maybe<Scalars['String']>;
  campaign?: Maybe<Campaign>;
  campaignEnd?: Maybe<Scalars['Date']>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignStart?: Maybe<Scalars['Date']>;
  campaignType?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  clusterIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comment?: Maybe<Scalars['String']>;
  communicationType?: Maybe<Scalars['String']>;
  conception?: Maybe<Array<Maybe<BriefMedia>>>;
  contacts?: Maybe<Array<Maybe<BriefContact>>>;
  contextGoalsIssues?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  customerJourney?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['Int']>;
  deliveryDeadline?: Maybe<Scalars['Date']>;
  deliveryOption?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  internalReference?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCommentEnabled?: Maybe<Scalars['Boolean']>;
  isProduct?: Maybe<Scalars['Boolean']>;
  latestStatusUpdate?: Maybe<BriefActivity>;
  medium?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  other?: Maybe<Scalars['String']>;
  productAttribute?: Maybe<Scalars['JSON']>;
  productId?: Maybe<Scalars['ID']>;
  providerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  quoteOptions?: Maybe<BriefQuoteOptions>;
  reference?: Maybe<Scalars['String']>;
  referenceVisuals?: Maybe<Array<Maybe<BriefMedia>>>;
  salesPoint?: Maybe<SalesPoint>;
  salesPointId?: Maybe<Scalars['ID']>;
  shippingAddresses?: Maybe<Array<Maybe<BriefShippingAddress>>>;
  status?: Maybe<BriefStatus>;
  targeting?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  typesLabel?: Maybe<TypesLabel>;
  useLaunchDate?: Maybe<Scalars['Boolean']>;
  useValidDate?: Maybe<Scalars['Boolean']>;
  validEndDate?: Maybe<Scalars['Date']>;
  validStartDate?: Maybe<Scalars['Date']>;
};

export type BriefHyundaiOptions = BriefOptionsType & {
  __typename?: 'BriefHyundaiOptions';
  activityType?: Maybe<Scalars['Boolean']>;
  briefType?: Maybe<Scalars['Boolean']>;
  budget?: Maybe<Scalars['Boolean']>;
  budgetType?: Maybe<Scalars['Boolean']>;
  campaignDates?: Maybe<Scalars['Boolean']>;
  campaignLevel?: Maybe<Scalars['Boolean']>;
  campaignType?: Maybe<Scalars['Boolean']>;
  communicationType?: Maybe<Scalars['Boolean']>;
  contextGoalsIssues?: Maybe<Scalars['Boolean']>;
  crm?: Maybe<Scalars['Boolean']>;
  customerJourney?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['Boolean']>;
  governance?: Maybe<Scalars['Boolean']>;
  groupedNotifications?: Maybe<Scalars['Boolean']>;
  internalReference?: Maybe<Scalars['Boolean']>;
  launchDates?: Maybe<Scalars['Boolean']>;
  lever?: Maybe<Scalars['Boolean']>;
  modelType?: Maybe<Scalars['Boolean']>;
  offer?: Maybe<Scalars['Boolean']>;
  quoteAmount?: Maybe<Scalars['Boolean']>;
  quoteComment?: Maybe<Scalars['Boolean']>;
  support?: Maybe<Scalars['Boolean']>;
  targeting?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['Boolean']>;
  validityDates?: Maybe<Scalars['Boolean']>;
  visualReference?: Maybe<Scalars['Boolean']>;
  wishDelivery?: Maybe<Scalars['Boolean']>;
  workflow?: Maybe<BriefWorkflow>;
  workType?: Maybe<Scalars['Boolean']>;
};

export type BriefInterface = {
  attachments?: Maybe<Array<Maybe<BriefMedia>>>;
  attachmentsPageLastVisite?: Maybe<Scalars['Date']>;
  attribute?: Maybe<Scalars['String']>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  awaitingNewConception?: Maybe<Scalars['Boolean']>;
  briefNumber?: Maybe<Scalars['Int']>;
  briefSpecClient?: Maybe<Array<Maybe<BriefSpecClient>>>;
  budget?: Maybe<Scalars['Float']>;
  campaign?: Maybe<Campaign>;
  campaignEnd?: Maybe<Scalars['Date']>;
  campaignId?: Maybe<Scalars['ID']>;
  campaignStart?: Maybe<Scalars['Date']>;
  campaignType?: Maybe<Scalars['String']>;
  client?: Maybe<Client>;
  clusterIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  comment?: Maybe<Scalars['String']>;
  conception?: Maybe<Array<Maybe<BriefMedia>>>;
  contacts?: Maybe<Array<Maybe<BriefContact>>>;
  contextGoalsIssues?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  customerJourney?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['Int']>;
  deliveryDeadline?: Maybe<Scalars['Date']>;
  deliveryOption?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  internalReference?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCommentEnabled?: Maybe<Scalars['Boolean']>;
  isProduct?: Maybe<Scalars['Boolean']>;
  latestStatusUpdate?: Maybe<BriefActivity>;
  medium?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  offer?: Maybe<Scalars['String']>;
  other?: Maybe<Scalars['String']>;
  productAttribute?: Maybe<Scalars['JSON']>;
  productId?: Maybe<Scalars['ID']>;
  providerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  quoteOptions?: Maybe<BriefQuoteOptions>;
  reference?: Maybe<Scalars['String']>;
  referenceVisuals?: Maybe<Array<Maybe<BriefMedia>>>;
  salesPoint?: Maybe<SalesPoint>;
  salesPointId?: Maybe<Scalars['ID']>;
  shippingAddresses?: Maybe<Array<Maybe<BriefShippingAddress>>>;
  status?: Maybe<BriefStatus>;
  targeting?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  useLaunchDate?: Maybe<Scalars['Boolean']>;
  useValidDate?: Maybe<Scalars['Boolean']>;
  validEndDate?: Maybe<Scalars['Date']>;
  validStartDate?: Maybe<Scalars['Date']>;
};

export type BriefMedia = {
  __typename?: 'BriefMedia';
  api?: Maybe<BriefApi>;
  createdAt?: Maybe<Scalars['Date']>;
  createdBy?: Maybe<User>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mimetype?: Maybe<Scalars['String']>;
  tag?: Maybe<BriefMediaTag>;
  thumbnail?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type BriefMediaFilters = {
  tags?: InputMaybe<Array<BriefMediaTag>>;
};

export type BriefMediaPagination = {
  __typename?: 'BriefMediaPagination';
  count?: Maybe<Scalars['Int']>;
  medias?: Maybe<Array<Maybe<BriefMedia>>>;
};

export type BriefMediaSort = {
  criteria?: InputMaybe<BriefMediaSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum BriefMediaSortCriteria {
  CreatedAt = 'createdAt'
}

export enum BriefMediaTag {
  Attachment = 'attachment',
  CreationAttachment = 'creation_attachment',
  Final = 'final',
  Proof = 'proof',
  Quote = 'quote',
  Reference = 'reference',
  RejectedCreation = 'rejected_creation',
  RejectedQuote = 'rejected_quote'
}

export type BriefMediumSpecs = {
  __typename?: 'BriefMediumSpecs';
  formats?: Maybe<Array<Maybe<BriefFormatSpecs>>>;
  value?: Maybe<Scalars['String']>;
};

export type BriefModelSpecs = {
  __typename?: 'BriefModelSpecs';
  api?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type BriefOptions = BriefOptionsType & {
  __typename?: 'BriefOptions';
  budget?: Maybe<Scalars['Boolean']>;
  campaignDates?: Maybe<Scalars['Boolean']>;
  campaignLevel?: Maybe<Scalars['Boolean']>;
  campaignType?: Maybe<Scalars['Boolean']>;
  contextGoalsIssues?: Maybe<Scalars['Boolean']>;
  crm?: Maybe<Scalars['Boolean']>;
  customerJourney?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['Boolean']>;
  governance?: Maybe<Scalars['Boolean']>;
  groupedNotifications?: Maybe<Scalars['Boolean']>;
  internalReference?: Maybe<Scalars['Boolean']>;
  launchDates?: Maybe<Scalars['Boolean']>;
  lever?: Maybe<Scalars['Boolean']>;
  offer?: Maybe<Scalars['Boolean']>;
  quoteAmount?: Maybe<Scalars['Boolean']>;
  quoteComment?: Maybe<Scalars['Boolean']>;
  support?: Maybe<Scalars['Boolean']>;
  targeting?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['Boolean']>;
  validityDates?: Maybe<Scalars['Boolean']>;
  visualReference?: Maybe<Scalars['Boolean']>;
  wishDelivery?: Maybe<Scalars['Boolean']>;
  workflow?: Maybe<BriefWorkflow>;
  workType?: Maybe<Scalars['Boolean']>;
};

export type BriefOptionsInput = {
  activityType?: InputMaybe<Scalars['Boolean']>;
  briefType?: InputMaybe<Scalars['Boolean']>;
  budget?: InputMaybe<Scalars['Boolean']>;
  budgetType?: InputMaybe<Scalars['Boolean']>;
  campaignDates?: InputMaybe<Scalars['Boolean']>;
  campaignLevel?: InputMaybe<Scalars['Boolean']>;
  campaignType?: InputMaybe<Scalars['Boolean']>;
  communicationType?: InputMaybe<Scalars['Boolean']>;
  contextGoalsIssues?: InputMaybe<Scalars['Boolean']>;
  crm?: InputMaybe<Scalars['Boolean']>;
  customerJourney?: InputMaybe<Scalars['Boolean']>;
  delivery: Scalars['Boolean'];
  description?: InputMaybe<Scalars['Boolean']>;
  governance?: InputMaybe<Scalars['Boolean']>;
  groupedNotifications?: InputMaybe<Scalars['Boolean']>;
  internalReference: Scalars['Boolean'];
  launchDates?: InputMaybe<Scalars['Boolean']>;
  lever?: InputMaybe<Scalars['Boolean']>;
  modelType?: InputMaybe<Scalars['Boolean']>;
  offer?: InputMaybe<Scalars['Boolean']>;
  quoteAmount?: InputMaybe<Scalars['Boolean']>;
  quoteComment?: InputMaybe<Scalars['Boolean']>;
  support?: InputMaybe<Scalars['Boolean']>;
  targeting?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['Boolean'];
  validityDates?: InputMaybe<Scalars['Boolean']>;
  visualReference: Scalars['Boolean'];
  wishDelivery: Scalars['Boolean'];
  workflow: BriefWorkflow;
  workType?: InputMaybe<Scalars['Boolean']>;
};

export type BriefOptionsType = {
  budget?: Maybe<Scalars['Boolean']>;
  campaignDates?: Maybe<Scalars['Boolean']>;
  campaignLevel?: Maybe<Scalars['Boolean']>;
  campaignType?: Maybe<Scalars['Boolean']>;
  contextGoalsIssues?: Maybe<Scalars['Boolean']>;
  crm?: Maybe<Scalars['Boolean']>;
  customerJourney?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['Boolean']>;
  governance?: Maybe<Scalars['Boolean']>;
  groupedNotifications?: Maybe<Scalars['Boolean']>;
  internalReference?: Maybe<Scalars['Boolean']>;
  launchDates?: Maybe<Scalars['Boolean']>;
  lever?: Maybe<Scalars['Boolean']>;
  offer?: Maybe<Scalars['Boolean']>;
  quoteAmount?: Maybe<Scalars['Boolean']>;
  quoteComment?: Maybe<Scalars['Boolean']>;
  support?: Maybe<Scalars['Boolean']>;
  targeting?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['Boolean']>;
  validityDates?: Maybe<Scalars['Boolean']>;
  visualReference?: Maybe<Scalars['Boolean']>;
  wishDelivery?: Maybe<Scalars['Boolean']>;
  workflow?: Maybe<BriefWorkflow>;
  workType?: Maybe<Scalars['Boolean']>;
};

export type BriefQuoteOptions = {
  __typename?: 'BriefQuoteOptions';
  amount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
};

export enum BriefRole {
  Client = 'client',
  Provider = 'provider'
}

export type BriefsCountDocuments = {
  __typename?: 'BriefsCountDocuments';
  countArchived?: Maybe<Scalars['Int']>;
  countNotArchived?: Maybe<Scalars['Int']>;
};

export type BriefsFilter = {
  briefSpecClientIds?: InputMaybe<Array<Scalars['ID']>>;
  campaignId?: InputMaybe<Scalars['ID']>;
  contact?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  maxLeverCount?: InputMaybe<Scalars['Int']>;
  minLeverCount?: InputMaybe<Scalars['Int']>;
  requiredBriefSpecClientIds?: InputMaybe<Array<Scalars['ID']>>;
  salesPointGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  salesPointIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Array<BriefStatus>>;
};

export type BriefsForPlanningFilter = {
  briefSpecClientIds?: InputMaybe<Array<Scalars['ID']>>;
  salesPointGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  salesPointIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BriefShippingAddress = {
  __typename?: 'BriefShippingAddress';
  additionalAddress?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type BriefsPagination = {
  __typename?: 'BriefsPagination';
  briefs?: Maybe<Array<Maybe<BriefAllFields>>>;
  count?: Maybe<Scalars['Int']>;
};

export type BriefSpecClient = {
  __typename?: 'BriefSpecClient';
  children?: Maybe<Array<Maybe<BriefSpecClient>>>;
  clientId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['ID']>;
  providerUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['String']>;
};

export enum BriefSpecClientKey {
  CampaignColor = 'campaignColor',
  CampaignLevel = 'campaignLevel',
  Lever = 'lever',
  Support = 'support',
  WorkType = 'workType',
  WorkTypeIcon = 'workTypeIcon'
}

export enum BriefStatus {
  AwaitingBroadcast = 'awaiting_broadcast',
  AwaitingConception = 'awaiting_conception',
  AwaitingConceptionValidation = 'awaiting_conception_validation',
  AwaitingQuote = 'awaiting_quote',
  AwaitingQuoteValidation = 'awaiting_quote_validation',
  AwaitingRevision = 'awaiting_revision',
  AwaitingValidation = 'awaiting_validation',
  Broadcasting = 'broadcasting',
  Cancelled = 'cancelled',
  Done = 'done',
  Draft = 'draft',
  InDelivery = 'in_delivery',
  InProduction = 'in_production',
  Reporting = 'reporting'
}

export type BriefStatusFromTo = {
  __typename?: 'BriefStatusFromTo';
  from?: Maybe<BriefStatus>;
  to?: Maybe<BriefStatus>;
};

export type BriefTypeSpecs = {
  __typename?: 'BriefTypeSpecs';
  mediums?: Maybe<Array<Maybe<BriefMediumSpecs>>>;
  value?: Maybe<Scalars['String']>;
};

export enum BriefWorkflow {
  CreativeApproved = 'creative_approved',
  QuoteApproved = 'quote_approved',
  WorkflowDelivery = 'workflow_delivery',
  WorkflowEmilfrey = 'workflow_emilfrey'
}

export type BulkActionResult = {
  __typename?: 'BulkActionResult';
  partialSuccess?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BulkAddCartItemsReturnValue = {
  __typename?: 'BulkAddCartItemsReturnValue';
  availableProducts?: Maybe<Array<Maybe<Item>>>;
  cart?: Maybe<Cart>;
  unavailableProducts?: Maybe<Array<Maybe<Item>>>;
};

export type BulkUpdateMediaInput = {
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  replaceTags?: InputMaybe<Scalars['Boolean']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tips?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['Date']>;
  validTo?: InputMaybe<Scalars['Date']>;
};

export type BusinessManager = {
  __typename?: 'BusinessManager';
  customerId: Scalars['String'];
  facebookSystemUserId: Scalars['String'];
};

export type CallToAction = {
  __typename?: 'CallToAction';
  buttonName?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  redirectionUrl?: Maybe<Scalars['String']>;
  secondaryText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CallToActionInput = {
  buttonName?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  redirectionUrl?: InputMaybe<Scalars['String']>;
  secondaryText?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  categories?: Maybe<Array<Maybe<CampaignCategory>>>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  displayMode?: Maybe<CampaignDisplayModes>;
  document?: Maybe<Document>;
  enabled?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['Date']>;
  endDisplayDate?: Maybe<Scalars['Date']>;
  fileType?: Maybe<Scalars['String']>;
  hasPreorderDates?: Maybe<Scalars['Boolean']>;
  hasPreorderProducts?: Maybe<Scalars['Boolean']>;
  hasProducts?: Maybe<Scalars['Boolean']>;
  hideOnPlanning?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  isLocal?: Maybe<Scalars['Boolean']>;
  isNational?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isScheduled?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Scalars['String']>;
  postTemplates?: Maybe<Array<Maybe<PostTemplate>>>;
  preorderDaysRemaining?: Maybe<Scalars['Int']>;
  preorderEndDate?: Maybe<Scalars['Date']>;
  /** Établissements engagés / total. null pour un user local (donnée org-wide). */
  preorderEngagedSalespointsCount?: Maybe<Scalars['Int']>;
  preorderProductsCount?: Maybe<Scalars['Int']>;
  preorderReminderDays?: Maybe<Array<Scalars['Int']>>;
  preorderStartDate?: Maybe<Scalars['Date']>;
  preorderStatus?: Maybe<CampaignPreorderStatus>;
  preorderTotalSalespointsCount?: Maybe<Scalars['Int']>;
  productsAndCount?: Maybe<ProductsAndCount>;
  salespoint?: Maybe<SalesPoint>;
  salespointGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salespointId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  startDisplayDate?: Maybe<Scalars['Date']>;
  supports?: Maybe<Array<Maybe<Media>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  tempUrl?: Maybe<Scalars['String']>;
  type?: Maybe<CampaignType>;
  userHasWritePermission?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['ID']>;
  useSalespointGroups?: Maybe<Scalars['Boolean']>;
};


export type CampaignMediasArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CampaignPostTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CampaignPreorderStatusArgs = {
  salespointId?: InputMaybe<Scalars['ID']>;
};


export type CampaignProductsAndCountArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  preorderAvailable?: InputMaybe<Scalars['Boolean']>;
  showDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type CampaignActionDetailSubContent = {
  __typename?: 'CampaignActionDetailSubContent';
  actions?: Maybe<SubActions>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type CampaignCategoriesOrderInput = {
  categoryId: Scalars['ID'];
  order: Scalars['Int'];
};

export type CampaignCategory = {
  __typename?: 'CampaignCategory';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  campaignsIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  clientId?: Maybe<Scalars['String']>;
  displayCampaignsCategory?: Maybe<Scalars['Boolean']>;
  displayMode?: Maybe<CampaignCategoryDisplayModes>;
  enabled?: Maybe<Scalars['Boolean']>;
  endDisplayDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isVisible?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  salespointGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salespointGroupsIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  startDisplayDate?: Maybe<Scalars['Date']>;
  useSalespointGroups?: Maybe<Scalars['Boolean']>;
};

export enum CampaignCategoryDisplayModes {
  Always = 'always',
  Scheduled = 'scheduled'
}

export type CampaignCategoryInput = {
  campaignsIds: Array<InputMaybe<Scalars['ID']>>;
  displayCampaignsCategory: Scalars['Boolean'];
  displayMode: CampaignCategoryDisplayModes;
  enabled: Scalars['Boolean'];
  endDisplayDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startDisplayDate?: InputMaybe<Scalars['Date']>;
  useSalespointGroups: Scalars['Boolean'];
};

export type CampaignCategoryUpdateInput = {
  campaignsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  displayCampaignsCategory?: InputMaybe<Scalars['Boolean']>;
  displayMode: CampaignCategoryDisplayModes;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDisplayDate?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startDisplayDate?: InputMaybe<Scalars['Date']>;
  useSalespointGroups?: InputMaybe<Scalars['Boolean']>;
};

export type CampaignDetailActions = {
  __typename?: 'CampaignDetailActions';
  actions?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  subContent?: Maybe<Array<Maybe<CampaignActionDetailSubContent>>>;
  views?: Maybe<Scalars['Int']>;
};

export type CampaignDetailActionsPagination = {
  __typename?: 'CampaignDetailActionsPagination';
  campaignActionsDetail?: Maybe<Array<Maybe<CampaignDetailActions>>>;
  total?: Maybe<Scalars['Int']>;
};

export type CampaignDetails = {
  __typename?: 'CampaignDetails';
  campaignId?: Maybe<Scalars['ID']>;
  order?: Maybe<Scalars['Int']>;
};

export type CampaignDetailsInput = {
  campaignId?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
};

export enum CampaignDisplayModes {
  Always = 'always',
  Scheduled = 'scheduled',
  UntilEnd = 'untilEnd'
}

export type CampaignDownloadDetails = {
  __typename?: 'CampaignDownloadDetails';
  campaignName?: Maybe<Scalars['String']>;
  copies?: Maybe<Scalars['Int']>;
  downloads?: Maybe<Scalars['Int']>;
  fileName?: Maybe<Scalars['String']>;
};

export type CampaignDownloadDetailsPagination = {
  __typename?: 'CampaignDownloadDetailsPagination';
  campaignDownloadDetails?: Maybe<Array<Maybe<CampaignDownloadDetails>>>;
  count?: Maybe<Scalars['Int']>;
};

export type CampaignDownloadPerDay = {
  __typename?: 'CampaignDownloadPerDay';
  date?: Maybe<Scalars['Date']>;
  fileDownload?: Maybe<Scalars['Int']>;
  supportDownload?: Maybe<Scalars['Int']>;
};

export type CampaignInput = {
  categoriesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayMode?: InputMaybe<CampaignDisplayModes>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Date']>;
  endDisplayDate?: InputMaybe<Scalars['Date']>;
  hasPreorderDates?: InputMaybe<Scalars['Boolean']>;
  hasProducts?: InputMaybe<Scalars['Boolean']>;
  hideOnPlanning?: InputMaybe<Scalars['Boolean']>;
  isScheduled?: InputMaybe<Scalars['Boolean']>;
  medias?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  postTemplatesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  preorderEndDate?: InputMaybe<Scalars['Date']>;
  preorderReminderDays?: InputMaybe<Array<Scalars['Int']>>;
  preorderStartDate?: InputMaybe<Scalars['Date']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointId?: InputMaybe<Scalars['String']>;
  scope: CampaignScope;
  startDate?: InputMaybe<Scalars['Date']>;
  startDisplayDate?: InputMaybe<Scalars['Date']>;
  useSalespointGroups?: InputMaybe<Scalars['Boolean']>;
};

export type CampaignMetrics = {
  __typename?: 'CampaignMetrics';
  campaignDownloadDetails?: Maybe<CampaignDownloadDetailsPagination>;
  downloads?: Maybe<SimpleMetricReturn>;
  downloadsPerDay?: Maybe<Array<Maybe<CampaignDownloadPerDay>>>;
  pageViews?: Maybe<SimpleMetricReturn>;
  pageViewsPerDay?: Maybe<Array<Maybe<InfoPerDay>>>;
};


export type CampaignMetricsCampaignDownloadDetailsArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CampaignPagination = {
  __typename?: 'CampaignPagination';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  count?: Maybe<Scalars['Int']>;
};

export enum CampaignPreorderStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Pending = 'PENDING'
}

export type CampaignsByMonth = {
  __typename?: 'CampaignsByMonth';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export enum CampaignScope {
  Local = 'local',
  National = 'national'
}

export type CampaignSort = {
  criteria: CampaignSortCriteria;
  direction?: InputMaybe<Direction>;
};

export enum CampaignSortCriteria {
  CreatedAt = 'createdAt',
  Name = 'name',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt'
}

export type CampaignsPerPeriods = {
  __typename?: 'CampaignsPerPeriods';
  allCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  ended?: Maybe<Array<Maybe<Campaign>>>;
  homepageCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  ongoing?: Maybe<Array<Maybe<Campaign>>>;
  permanent?: Maybe<Array<Maybe<Campaign>>>;
  scheduled?: Maybe<Array<Maybe<Campaign>>>;
};

export type CampaignSupportCreationInput = {
  isProcessedByCloudinary?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  tempPath?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['Upload']>;
};

export type CampaignSupportUpdate = {
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  thumbnail?: InputMaybe<Scalars['Upload']>;
};

export type CampaignSupportUpdates = {
  deleteThumbnail?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  update: CampaignSupportUpdate;
};

export enum CampaignType {
  Default = 'DEFAULT',
  Marketing = 'MARKETING'
}

export type CanRegisterResult = {
  __typename?: 'CanRegisterResult';
  activity?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  loginViaSso?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['ID']>;
  roleName?: Maybe<Scalars['String']>;
  roleSlug?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export enum Carrier {
  Chronopost = 'chronopost',
  Dpd = 'dpd',
  Geodis = 'geodis',
  Gls = 'gls',
  Schenker = 'schenker',
  Tnt = 'tnt'
}

export type Cart = {
  __typename?: 'Cart';
  fees?: Maybe<Array<Maybe<Fees>>>;
  items?: Maybe<Array<Maybe<Item>>>;
  shippingFees?: Maybe<Array<Maybe<ProviderShippingFees>>>;
  total?: Maybe<Price>;
  totalWithFees?: Maybe<Price>;
  totalWithShippingFees?: Maybe<Price>;
  user: User;
  userId: Scalars['ID'];
  vouchers?: Maybe<Array<Maybe<Voucher>>>;
};

export type CartItemFilesInput = {
  files: Array<Scalars['Upload']>;
  productId: Scalars['ID'];
};

export type CartItemInput = {
  comment?: InputMaybe<Scalars['String']>;
  documentDownloadSettingsId?: InputMaybe<Scalars['ID']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  packInfo?: InputMaybe<PackInfoInput>;
  productId: Scalars['ID'];
  providerId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  selectedFixPrice?: InputMaybe<Scalars['Int']>;
  selectedInPack?: InputMaybe<Scalars['Boolean']>;
  subId?: InputMaybe<Scalars['ID']>;
  tempFolderDocumentId?: InputMaybe<Scalars['ID']>;
  type: CartType;
  variationByQuantity?: InputMaybe<Array<InputMaybe<QuantityVariationInput>>>;
};

export type CartItemOptionsInput = {
  options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  productId: Scalars['ID'];
  subId?: InputMaybe<Scalars['ID']>;
  type: CartType;
};

export type CartItemToDelete = {
  productId: Scalars['ID'];
  productPackId?: InputMaybe<Scalars['ID']>;
  subId?: InputMaybe<Scalars['ID']>;
};

export type CartProductsAvailabilityChange = {
  __typename?: 'CartProductsAvailabilityChange';
  item: Item;
  removed: Scalars['Boolean'];
  removedCount: Scalars['Int'];
};

export type CartProductsAvailabilityResult = {
  __typename?: 'CartProductsAvailabilityResult';
  cart: Cart;
  changes: Array<CartProductsAvailabilityChange>;
};

export enum CartType {
  Media = 'media',
  Pack = 'pack',
  Physical = 'physical'
}

export type CatalogPriceLevels = {
  __typename?: 'CatalogPriceLevels';
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type ChildProductCategory = {
  __typename?: 'ChildProductCategory';
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<Image>;
  parent: ParentProductCategory;
  parentId: Scalars['ID'];
  position: Scalars['Int'];
  products: Array<Product>;
  title: Scalars['String'];
};

export type ChildProductCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  parentId: Scalars['ID'];
  productIds: Array<Scalars['ID']>;
  title: Scalars['String'];
};

export type ChiliConfig = {
  __typename?: 'ChiliConfig';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  exportPreferences?: Maybe<Array<Maybe<ExportPreferences>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<User>;
  viewPreferencesId?: Maybe<Scalars['String']>;
  watermarkId?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['String']>;
};

export type ChiliConfigInput = {
  exportPreferences?: InputMaybe<Array<InputMaybe<ExportPreferencesInput>>>;
  viewPreferencesId?: InputMaybe<Scalars['String']>;
  watermarkId?: InputMaybe<Scalars['String']>;
  workspaceId?: InputMaybe<Scalars['String']>;
};

export type ChiliDetails = {
  __typename?: 'ChiliDetails';
  documentDownloadSettingsId?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentViewPrefsId?: Maybe<Scalars['String']>;
  documentWorkspaceId?: Maybe<Scalars['String']>;
  exportTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ChiliEditorInfo = {
  __typename?: 'ChiliEditorInfo';
  tempFolderDocumentId?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type ChoiceCustomFieldConfig = {
  __typename?: 'ChoiceCustomFieldConfig';
  displayType: ChoiceDisplayType;
  options: Array<Scalars['String']>;
};

export type ChoiceCustomFieldConfigInput = {
  displayType: ChoiceDisplayType;
  options: Array<Scalars['String']>;
};

export enum ChoiceDisplayType {
  DropDown = 'DROP_DOWN',
  Radio = 'RADIO'
}

export type Client = {
  __typename?: 'Client';
  apiKeys?: Maybe<Array<Maybe<ApiKey>>>;
  briefOptions?: Maybe<BriefOptionsType>;
  chiliPublisherId?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  defaultSsoId?: Maybe<Scalars['ID']>;
  directMarketingProvider?: Maybe<DirectMarketingProvider>;
  f?: Maybe<Array<Maybe<Features>>>;
  features?: Maybe<Array<Maybe<Feature>>>;
  homepageFeature?: Maybe<Features>;
  hyperSSOKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkedProviders?: Maybe<Array<Maybe<ProviderWithType>>>;
  mtargetBrand?: Maybe<Scalars['String']>;
  mtargetDomain?: Maybe<Scalars['String']>;
  mtargetSecret?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notIndexedSalesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
  partnerAuthBridges?: Maybe<Array<Maybe<PartnerAuthBridgeType>>>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  presenceManagement?: Maybe<PresenceManagement>;
  providerInfo?: Maybe<Provider>;
  salespoints?: Maybe<Array<Maybe<SalesPoint>>>;
  salespointsCount?: Maybe<Scalars['Int']>;
  saveChiliBySalespoint?: Maybe<Scalars['Boolean']>;
  shopOptions?: Maybe<ShopOptions>;
  socialConfig?: Maybe<SocialConfig>;
  socialOptions?: Maybe<SocialOptions>;
  usersCount?: Maybe<Scalars['Int']>;
};


export type ClientSalespointsCountArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type ClientInfo = {
  briefOptions?: InputMaybe<BriefOptionsInput>;
  chiliPublisherId?: InputMaybe<Scalars['String']>;
  defaultSsoId?: InputMaybe<Scalars['ID']>;
  directMarketingProvider?: InputMaybe<DirectMarketingProvider>;
  features: Array<FeatureInput>;
  /**
   * Slug is used to generate the clientId and has to match the regex /^[a-z0-9-]+$/
   * to be compatible with kubernetes ingress.
   */
  homepageFeature: Features;
  hyperSSOKey?: InputMaybe<Scalars['String']>;
  linkedProviders?: InputMaybe<Array<InputMaybe<ProviderTypeInput>>>;
  mtargetBrand?: InputMaybe<Scalars['String']>;
  mtargetDomain?: InputMaybe<Scalars['String']>;
  mtargetSecret?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notIndexedSalesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  partnerAuthBridges?: InputMaybe<Array<InputMaybe<PartnerAuthBridgeInput>>>;
  presenceManagement?: InputMaybe<PresenceManagementInfo>;
  saveChiliBySalespoint?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  socialConfig?: InputMaybe<SocialConfigInput>;
  socialOptions?: InputMaybe<SocialOptionsInput>;
};

export type ClientInfos = {
  __typename?: 'ClientInfos';
  clientId?: Maybe<Scalars['String']>;
  defaultSsoId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  providerInfo?: Maybe<Provider>;
};

export type ClientWithType = {
  __typename?: 'ClientWithType';
  clientId: Scalars['String'];
  providerType: ProviderType;
};

export type ClientWithTypeInput = {
  clientId: Scalars['String'];
  providerType: ProviderType;
};

export type CloudinaryUploadResult = {
  __typename?: 'CloudinaryUploadResult';
  aspectFormatRatio?: Maybe<Scalars['Float']>;
  bytes: Scalars['Int'];
  contentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  duration?: Maybe<Scalars['Float']>;
  filename?: Maybe<Scalars['String']>;
  format: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  images?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  publicId: Scalars['String'];
  resourceType: Scalars['String'];
  secureUrl: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type ColorCss = {
  __typename?: 'ColorCss';
  url?: Maybe<Scalars['String']>;
};

export type ColorsTheme = {
  __typename?: 'ColorsTheme';
  primaryHex?: Maybe<Scalars['String']>;
};

export type ConfirmInstantPurchaseOrder = {
  __typename?: 'ConfirmInstantPurchaseOrder';
  orderId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  toValidate?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type ConsumptionByRefInput = {
  productRef: Scalars['String'];
  quantity: Scalars['Int'];
};

export type ConsumptionInput = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type Contact = {
  __typename?: 'Contact';
  activity?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastname?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  contacts?: Maybe<Array<Maybe<Contact>>>;
  email?: Maybe<Scalars['String']>;
  facebookLink?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  foursquareLink?: Maybe<Scalars['String']>;
  instagramLink?: Maybe<Scalars['String']>;
  linkedinLink?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pinterestLink?: Maybe<Scalars['String']>;
  twitterLink?: Maybe<Scalars['String']>;
  vimeoLink?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  xingLink?: Maybe<Scalars['String']>;
  youtubeLink?: Maybe<Scalars['String']>;
};

export type ContactDetailsInput = {
  contacts?: InputMaybe<Array<InputMaybe<ContactInput>>>;
  email?: InputMaybe<Scalars['String']>;
  facebookLink?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  foursquareLink?: InputMaybe<Scalars['String']>;
  instagramLink?: InputMaybe<Scalars['String']>;
  linkedinLink?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pinterestLink?: InputMaybe<Scalars['String']>;
  twitterLink?: InputMaybe<Scalars['String']>;
  vimeoLink?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  xingLink?: InputMaybe<Scalars['String']>;
  youtubeLink?: InputMaybe<Scalars['String']>;
};

export type ContactInput = {
  activity: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export enum ConvertionType {
  Png = 'png'
}

export enum CountyCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xk = 'XK',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export enum CreatableEventType {
  Copy = 'COPY',
  Download = 'DOWNLOAD',
  Login = 'LOGIN',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderPassed = 'ORDER_PASSED',
  OrderRefused = 'ORDER_REFUSED',
  PageView = 'PAGE_VIEW',
  PostPlanned = 'POST_PLANNED',
  PostPublished = 'POST_PUBLISHED',
  PostTemplatePublished = 'POST_TEMPLATE_PUBLISHED',
  Upload = 'UPLOAD'
}

export type CreateCustomFieldDefinitionInput = {
  assetType: CustomFieldAssetType;
  choiceConfig?: InputMaybe<ChoiceCustomFieldConfigInput>;
  dateConfig?: InputMaybe<DateCustomFieldConfigInput>;
  description?: InputMaybe<Scalars['String']>;
  isDisplayedInExport?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  multipleChoiceConfig?: InputMaybe<MultipleChoiceCustomFieldConfigInput>;
  numberConfig?: InputMaybe<NumberCustomFieldConfigInput>;
  slug: Scalars['String'];
  textConfig?: InputMaybe<TextCustomFieldConfigInput>;
  type: CustomFieldType;
  visible: Scalars['Boolean'];
};

export type CreateRoleInput = {
  name: Scalars['String'];
  parentId: Scalars['ID'];
  permissionsSettings: Array<InputMaybe<PermissionInput>>;
  slug: Scalars['String'];
};

export type Credentials = {
  __typename?: 'Credentials';
  clientId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  jwToken?: Maybe<Scalars['String']>;
};

export enum CustomFieldAssetType {
  Salespoint = 'SALESPOINT'
}

export type CustomFieldDefinition = {
  __typename?: 'CustomFieldDefinition';
  assetType: CustomFieldAssetType;
  choiceConfig?: Maybe<ChoiceCustomFieldConfig>;
  clientId: Scalars['String'];
  dateConfig?: Maybe<DateCustomFieldConfig>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDisplayedInExport: Scalars['Boolean'];
  label: Scalars['String'];
  multipleChoiceConfig?: Maybe<MultipleChoiceCustomFieldConfig>;
  numberConfig?: Maybe<NumberCustomFieldConfig>;
  slug: Scalars['String'];
  textConfig?: Maybe<TextCustomFieldConfig>;
  type: CustomFieldType;
  updatedAt: Scalars['Date'];
  updatedBy: User;
  visible: Scalars['Boolean'];
};

export type CustomFieldInput = {
  choiceValue?: InputMaybe<Scalars['String']>;
  dateValue?: InputMaybe<Scalars['Date']>;
  definitionId: Scalars['String'];
  multipleChoiceValue?: InputMaybe<Array<Scalars['String']>>;
  numberValue?: InputMaybe<Scalars['Float']>;
  textValue?: InputMaybe<Scalars['String']>;
};

export enum CustomFieldType {
  Choice = 'CHOICE',
  Date = 'DATE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type CustomProductPerformance = {
  __typename?: 'CustomProductPerformance';
  downloads?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
};

export type CustomProductPerformancePagination = {
  __typename?: 'CustomProductPerformancePagination';
  count?: Maybe<Scalars['Int']>;
  customProductPerformance?: Maybe<Array<Maybe<CustomProductPerformance>>>;
};

export type CustomVisualsUpload = {
  __typename?: 'CustomVisualsUpload';
  filename?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type DateCustomFieldConfig = {
  __typename?: 'DateCustomFieldConfig';
  isDateTime: Scalars['Boolean'];
  timezone: Scalars['String'];
};

export type DateCustomFieldConfigInput = {
  isDateTime: Scalars['Boolean'];
  timezone: Scalars['String'];
};

export type DateRange = {
  end: Scalars['Date'];
  start: Scalars['Date'];
};

export type DateRangeOptional = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type DecodedJwtPayload = {
  __typename?: 'DecodedJwtPayload';
  header: HeaderPayload;
  payload: UserPayload;
  signature: Scalars['String'];
};

export type DefaultExtra = {
  __typename?: 'DefaultExtra';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DefaultLocationIds = {
  __typename?: 'DefaultLocationIds';
  billing?: Maybe<Scalars['ID']>;
  shipping?: Maybe<Scalars['ID']>;
};

export type DefaultLocationIdsInput = {
  billing?: InputMaybe<Scalars['ID']>;
  shipping?: InputMaybe<Scalars['ID']>;
};

export type DefaultLocations = {
  __typename?: 'DefaultLocations';
  billing?: Maybe<Location>;
  shipping?: Maybe<Location>;
};

export type DefaultPayload = {
  __typename?: 'DefaultPayload';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum Direction {
  Asc = 'asc',
  Desc = 'desc'
}

export enum DirectMarketingProvider {
  Heypongo = 'heypongo',
  Mtarget = 'mtarget'
}

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Document = {
  __typename?: 'Document';
  name?: Maybe<Scalars['String']>;
  publicUrl?: Maybe<Scalars['String']>;
  tempUrl?: Maybe<Scalars['String']>;
};

export type DocumentsExist = {
  __typename?: 'DocumentsExist';
  allExist?: Maybe<Scalars['Boolean']>;
  missingDocumentIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type DownloadDetails = {
  __typename?: 'DownloadDetails';
  downloads?: Maybe<Scalars['Int']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type DownloadDetailsPagination = {
  __typename?: 'DownloadDetailsPagination';
  count?: Maybe<Scalars['Int']>;
  downloadDetails?: Maybe<Array<Maybe<DownloadDetails>>>;
};

export type DownloadLibraryMediasResult = {
  __typename?: 'DownloadLibraryMediasResult';
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type DownloadMetrics = {
  __typename?: 'DownloadMetrics';
  copiedLinks?: Maybe<SimpleMetricReturn>;
  downloadDetails?: Maybe<DownloadDetailsPagination>;
  downloads?: Maybe<SimpleMetricReturn>;
  downloadsPerDay?: Maybe<Array<Maybe<DownloadsPerDay>>>;
};


export type DownloadMetricsDownloadDetailsArgs = {
  tableParams?: InputMaybe<TableParams>;
};

export type DownloadsPerDay = {
  __typename?: 'DownloadsPerDay';
  date?: Maybe<Scalars['Date']>;
  downloads?: Maybe<Scalars['Int']>;
};

export enum EmifreyCampaignLevelValues {
  CampagneLocale = 'campagne_locale'
}

export enum EmifreyLeverValues {
  Crm = 'crm',
  Display = 'display',
  Plv = 'plv',
  Prm = 'prm',
  Sea = 'sea',
  Seo = 'seo',
  Sma = 'sma'
}

export enum EmilfreyClients {
  Charlybriefemilfrey = 'charlybriefemilfrey',
  Emilfrey = 'emilfrey'
}

export enum ErrorCode {
  AddUserToProviderFailed = 'ADD_USER_TO_PROVIDER_FAILED',
  AnswerTemplateUploadFailed = 'ANSWER_TEMPLATE_UPLOAD_FAILED',
  BadUserInput = 'BAD_USER_INPUT',
  BlacklistUploadFailed = 'BLACKLIST_UPLOAD_FAILED',
  BriefActivityLogFailed = 'BRIEF_ACTIVITY_LOG_FAILED',
  BriefActivityNotificationFailed = 'BRIEF_ACTIVITY_NOTIFICATION_FAILED',
  BriefArchiveFailed = 'BRIEF_ARCHIVE_FAILED',
  BriefAssetUploadFailed = 'BRIEF_ASSET_UPLOAD_FAILED',
  BriefConceptionCreationFailed = 'BRIEF_CONCEPTION_CREATION_FAILED',
  BriefDuplicateMedia = 'BRIEF_DUPLICATE_MEDIA',
  BriefExcelNotFoundInZip = 'BRIEF_EXCEL_NOT_FOUND_IN_ZIP',
  BriefInvalidStatus = 'BRIEF_INVALID_STATUS',
  BriefInvalidSubmissionStage = 'BRIEF_INVALID_SUBMISSION_STAGE',
  BriefInvalidXlsxFormat = 'BRIEF_INVALID_XLSX_FORMAT',
  BriefInvalidZipFormat = 'BRIEF_INVALID_ZIP_FORMAT',
  BriefMediaNotFound = 'BRIEF_MEDIA_NOT_FOUND',
  BriefMultiLeverRestricted = 'BRIEF_MULTI_LEVER_RESTRICTED',
  BriefMultipleActivitiesLogFailed = 'BRIEF_MULTIPLE_ACTIVITIES_LOG_FAILED',
  BriefNotFound = 'BRIEF_NOT_FOUND',
  BriefNotFoundOrNoConception = 'BRIEF_NOT_FOUND_OR_NO_CONCEPTION',
  BriefNotProvider = 'BRIEF_NOT_PROVIDER',
  BriefProofhqInvalidStage = 'BRIEF_PROOFHQ_INVALID_STAGE',
  BriefProofhqNoConception = 'BRIEF_PROOFHQ_NO_CONCEPTION',
  BriefQuoteUpdateFailed = 'BRIEF_QUOTE_UPDATE_FAILED',
  BriefZipExtractionFailed = 'BRIEF_ZIP_EXTRACTION_FAILED',
  CartItemFileNotFound = 'CART_ITEM_FILE_NOT_FOUND',
  CartItemNotFound = 'CART_ITEM_NOT_FOUND',
  CartNotFound = 'CART_NOT_FOUND',
  CartQuantitiesInvalid = 'CART_QUANTITIES_INVALID',
  ChildProductCategoryNotFound = 'CHILD_PRODUCT_CATEGORY_NOT_FOUND',
  ChiliAuthFailed = 'CHILI_AUTH_FAILED',
  ChiliEditorLinkError = 'CHILI_EDITOR_LINK_ERROR',
  ChiliInvalidTaskResult = 'CHILI_INVALID_TASK_RESULT',
  ChiliMissingProductId = 'CHILI_MISSING_PRODUCT_ID',
  ChiliResourceError = 'CHILI_RESOURCE_ERROR',
  ChiliSearchFailed = 'CHILI_SEARCH_FAILED',
  DuplicatePermissions = 'DUPLICATE_PERMISSIONS',
  DuplicateSlug = 'DUPLICATE_SLUG',
  EnglishContentRequired = 'ENGLISH_CONTENT_REQUIRED',
  FakeDemoClientsMissing = 'FAKE_DEMO_CLIENTS_MISSING',
  FeatureNotEnabled = 'FEATURE_NOT_ENABLED',
  FileSizeOutOfLimit = 'FILE_SIZE_OUT_OF_LIMIT',
  FolderAlreadyExists = 'FOLDER_ALREADY_EXISTS',
  GcsUploadFailed = 'GCS_UPLOAD_FAILED',
  GraphqlOperationCreationFailed = 'GRAPHQL_OPERATION_CREATION_FAILED',
  GroupedBriefNotificationsFailed = 'GROUPED_BRIEF_NOTIFICATIONS_FAILED',
  HashtagAlreadyExists = 'HASHTAG_ALREADY_EXISTS',
  HashtagNotFound = 'HASHTAG_NOT_FOUND',
  ImportJobFailed = 'IMPORT_JOB_FAILED',
  ImportJobNotFound = 'IMPORT_JOB_NOT_FOUND',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidAbsoluteSlugs = 'INVALID_ABSOLUTE_SLUGS',
  InvalidBriefSpecClient = 'INVALID_BRIEF_SPEC_CLIENT',
  InvalidClientid = 'INVALID_CLIENTID',
  InvalidDateFormat = 'INVALID_DATE_FORMAT',
  InvalidEmailFormat = 'INVALID_EMAIL_FORMAT',
  InvalidExtension = 'INVALID_EXTENSION',
  InvalidFallback = 'INVALID_FALLBACK',
  InvalidGovernance = 'INVALID_GOVERNANCE',
  InvalidMethod = 'INVALID_METHOD',
  InvalidMtarget = 'INVALID_MTARGET',
  InvalidParentid = 'INVALID_PARENTID',
  InvalidRole = 'INVALID_ROLE',
  InvalidRoleUnauthorized = 'INVALID_ROLE_UNAUTHORIZED',
  InvalidSalespoint = 'INVALID_SALESPOINT',
  InvalidToken = 'INVALID_TOKEN',
  InvalidVoucher = 'INVALID_VOUCHER',
  LicorneResourceNotFound = 'LICORNE_RESOURCE_NOT_FOUND',
  LinkMetadataFetchFailed = 'LINK_METADATA_FETCH_FAILED',
  LocalNeedStore = 'LOCAL_NEED_STORE',
  MaximumOrderExceptionsConflict = 'MAXIMUM_ORDER_EXCEPTIONS_CONFLICT',
  MediaNotFound = 'MEDIA_NOT_FOUND',
  MissingRequiredParameters = 'MISSING_REQUIRED_PARAMETERS',
  NameNotUnique = 'NAME_NOT_UNIQUE',
  NewsNotFound = 'NEWS_NOT_FOUND',
  NoBriefProvider = 'NO_BRIEF_PROVIDER',
  NoCart = 'NO_CART',
  NoDirectMarketing = 'NO_DIRECT_MARKETING',
  NoLinkedSpLocal = 'NO_LINKED_SP_LOCAL',
  NoUserProvider = 'NO_USER_PROVIDER',
  OrderAddressesIncomplete = 'ORDER_ADDRESSES_INCOMPLETE',
  OrderAlreadyUpdated = 'ORDER_ALREADY_UPDATED',
  OrderArchiveUploadFail = 'ORDER_ARCHIVE_UPLOAD_FAIL',
  OrderInvalidStatusTransition = 'ORDER_INVALID_STATUS_TRANSITION',
  OrderNotFound = 'ORDER_NOT_FOUND',
  OrderNotProcessing = 'ORDER_NOT_PROCESSING',
  OrderSuperAdminForbidden = 'ORDER_SUPER_ADMIN_FORBIDDEN',
  OrderWrongProvider = 'ORDER_WRONG_PROVIDER',
  OrderWrongSalespoint = 'ORDER_WRONG_SALESPOINT',
  ParentCategoryNotFound = 'PARENT_CATEGORY_NOT_FOUND',
  ParentProductCategoryNotFound = 'PARENT_PRODUCT_CATEGORY_NOT_FOUND',
  PartnerAuthBridgeNotFound = 'PARTNER_AUTH_BRIDGE_NOT_FOUND',
  PaymentMethodNoshop = 'PAYMENT_METHOD_NOSHOP',
  PaymentMethodNotFound = 'PAYMENT_METHOD_NOT_FOUND',
  PaymentStatusUpdateFailed = 'PAYMENT_STATUS_UPDATE_FAILED',
  PermissionDenied = 'PERMISSION_DENIED',
  PmPhotosFetchFailed = 'PM_PHOTOS_FETCH_FAILED',
  PmProviderNotSupported = 'PM_PROVIDER_NOT_SUPPORTED',
  PmSyncFailed = 'PM_SYNC_FAILED',
  PositionIsGreaterThanAllowed = 'POSITION_IS_GREATER_THAN_ALLOWED',
  PositionShouldBePositive = 'POSITION_SHOULD_BE_POSITIVE',
  PresenceManagementExportFailed = 'PRESENCE_MANAGEMENT_EXPORT_FAILED',
  ProductCategoryNotFound = 'PRODUCT_CATEGORY_NOT_FOUND',
  ProductExportFailed = 'PRODUCT_EXPORT_FAILED',
  ProductNotFound = 'PRODUCT_NOT_FOUND',
  ProductsNotAvailable = 'PRODUCTS_NOT_AVAILABLE',
  ProofhqApiCallFailed = 'PROOFHQ_API_CALL_FAILED',
  ProofhqClientCreationFailed = 'PROOFHQ_CLIENT_CREATION_FAILED',
  ProofhqInvalidResponse = 'PROOFHQ_INVALID_RESPONSE',
  ProofhqUploadFailed = 'PROOFHQ_UPLOAD_FAILED',
  ProviderInvoiceNotFound = 'PROVIDER_INVOICE_NOT_FOUND',
  ProviderInvoiceSendFailed = 'PROVIDER_INVOICE_SEND_FAILED',
  ProviderNotFound = 'PROVIDER_NOT_FOUND',
  ProviderWrongClient = 'PROVIDER_WRONG_CLIENT',
  RecipientRequired = 'RECIPIENT_REQUIRED',
  RoleIssue = 'ROLE_ISSUE',
  SalespointDissociationDenied = 'SALESPOINT_DISSOCIATION_DENIED',
  SameMail = 'SAME_MAIL',
  SlugBadFormat = 'SLUG_BAD_FORMAT',
  SlugShouldBeUnique = 'SLUG_SHOULD_BE_UNIQUE',
  SsoFeatureMissing = 'SSO_FEATURE_MISSING',
  SsoMissingUser = 'SSO_MISSING_USER',
  SsoNotValidToken = 'SSO_NOT_VALID_TOKEN',
  SsoOnlyUser = 'SSO_ONLY_USER',
  StoreDisabled = 'STORE_DISABLED',
  StripeWebhookError = 'STRIPE_WEBHOOK_ERROR',
  SystemPaymentMethodAlreadyInherited = 'SYSTEM_PAYMENT_METHOD_ALREADY_INHERITED',
  SystemPaymentMethodCannotBeDeleted = 'SYSTEM_PAYMENT_METHOD_CANNOT_BE_DELETED',
  TagGroupNotFound = 'TAG_GROUP_NOT_FOUND',
  TagInvalidLabel = 'TAG_INVALID_LABEL',
  Unauthenticated = 'UNAUTHENTICATED',
  Unauthorized = 'UNAUTHORIZED',
  UpdateUserIdBriefClientSpecFailed = 'UPDATE_USER_ID_BRIEF_CLIENT_SPEC_FAILED',
  UserAlreadyExist = 'USER_ALREADY_EXIST',
  UserAlreadyInvited = 'USER_ALREADY_INVITED',
  UserAlreadyRegistered = 'USER_ALREADY_REGISTERED',
  UserCreationFailed = 'USER_CREATION_FAILED',
  UserDisabled = 'USER_DISABLED',
  UserDoesNotExist = 'USER_DOES_NOT_EXIST',
  UserIsRegistered = 'USER_IS_REGISTERED',
  UserLanguagePreferenceNotSet = 'USER_LANGUAGE_PREFERENCE_NOT_SET',
  UserNotExist = 'USER_NOT_EXIST',
  UserNotFound = 'USER_NOT_FOUND',
  UserNotMkpProvider = 'USER_NOT_MKP_PROVIDER',
  UserNotProvider = 'USER_NOT_PROVIDER',
  VoucherAlreadyUsed = 'VOUCHER_ALREADY_USED',
  VoucherNotCummulative = 'VOUCHER_NOT_CUMMULATIVE',
  WrongCredentials = 'WRONG_CREDENTIALS',
  WrongExportSlug = 'WRONG_EXPORT_SLUG',
  ZendeskUserNotFound = 'ZENDESK_USER_NOT_FOUND',
  ZiflowApiError = 'ZIFLOW_API_ERROR'
}

export enum EventDevice {
  App = 'APP',
  Web = 'WEB'
}

export enum EventModuleType {
  Campaign = 'CAMPAIGN',
  Library = 'LIBRARY'
}

export enum EventSubType {
  Campaign = 'CAMPAIGN',
  CampaignFile = 'CAMPAIGN_FILE',
  CampaignSupport = 'CAMPAIGN_SUPPORT',
  CustomProduct = 'CUSTOM_PRODUCT',
  Default = 'DEFAULT',
  Media = 'MEDIA',
  Product = 'PRODUCT',
  ProviderInvoice = 'PROVIDER_INVOICE'
}

export enum ExportEngagementType {
  Salespoint = 'salespoint',
  User = 'user'
}

export type ExportPreferences = {
  __typename?: 'ExportPreferences';
  exportId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export type ExportPreferencesInput = {
  exportId?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type ExportResult = {
  __typename?: 'ExportResult';
  json?: Maybe<Scalars['JSONObject']>;
  url?: Maybe<Scalars['String']>;
};

export type ExportSocialLinks = {
  __typename?: 'ExportSocialLinks';
  link: Scalars['String'];
  mediaLink: Scalars['String'];
};

export enum ExportSource {
  Provider = 'provider',
  User = 'user'
}

export enum ExportType {
  Csv = 'csv',
  Xls = 'xls',
  Xlsx = 'xlsx'
}

export enum ExportTypes {
  CampaignDetailActions = 'campaignDetailActions',
  CampaignDownloadDetails = 'campaignDownloadDetails',
  DownloadDetails = 'downloadDetails',
  DownloadedMedias = 'downloadedMedias',
  DownloadedMediasPerUsers = 'downloadedMediasPerUsers',
  PackDetails = 'packDetails',
  PlatformListMetricsBySalespoint = 'platformListMetricsBySalespoint',
  ProductDetails = 'productDetails',
  SalespointDetails = 'salespointDetails'
}

export type Fake = {
  __typename?: 'Fake';
  fake?: Maybe<Scalars['String']>;
};

export type Feature = {
  __typename?: 'Feature';
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Features>;
};

export type FeatureInput = {
  enabled: Scalars['Boolean'];
  name: Features;
};

export enum Features {
  Admin = 'admin',
  Briefs = 'briefs',
  BriefsAttachments = 'briefs_attachments',
  BriefsProofHq = 'briefs_proofHQ',
  BriefsZiflow = 'briefs_ziflow',
  Campaigns = 'campaigns',
  Culturecom = 'culturecom',
  DirectMarketing = 'direct_marketing',
  Governance = 'governance',
  Homepage = 'homepage',
  HyperspreadSso = 'hyperspread_sso',
  HyperspreadSsoDebugger = 'hyperspread_sso_debugger',
  KnowledgeBase = 'knowledge_base',
  Library = 'library',
  MobileApp = 'mobile_app',
  Notifications = 'notifications',
  Paidmedia = 'paidmedia',
  PresenceManagement = 'presence_management',
  PresenceManagementAlbums = 'presence_management_albums',
  Shop = 'shop',
  ShopAttributes = 'shop_attributes',
  ShopEsker = 'shop_esker',
  ShopMultiAddresses = 'shop_multi_addresses',
  ShopPacks = 'shop_packs',
  ShopPreorders = 'shop_preorders',
  ShopProviderInvoice = 'shop_provider_invoice',
  Social = 'social',
  SocialAds = 'social_ads',
  SocialAnswerTemplate = 'social_answer_template',
  SocialCrossPost = 'social_cross_post',
  SocialMessenger = 'social_messenger',
  SocialMsg = 'social_msg',
  SocialPub = 'social_pub',
  SocialStats = 'social_stats',
  Stats = 'stats'
}

export type Fees = {
  __typename?: 'Fees';
  discounts?: Maybe<Array<Maybe<Discount>>>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
};

export enum FieldBriefs {
  Actions = 'actions',
  CreatedAt = 'createdAt',
  Name = 'name',
  Reference = 'reference',
  SalesPoint = 'salesPoint',
  Status = 'status'
}

export enum FileImportType {
  Album = 'album',
  Avatar = 'avatar',
  Carousel = 'carousel',
  Cover = 'cover',
  Event = 'event',
  Gif = 'gif',
  Offer = 'offer',
  Photo = 'photo',
  Story = 'story',
  Thumbnail = 'thumbnail',
  Video = 'video'
}

export type FileInfo = {
  __typename?: 'FileInfo';
  filename?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FileInfoInput = {
  filename?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterPaidMedia = {
  keyword?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type Folder = {
  __typename?: 'Folder';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['ID']>;
  salespointsGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};

export type FolderInput = {
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name: Scalars['String'];
  parent?: InputMaybe<Scalars['ID']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  validFrom?: InputMaybe<Scalars['Date']>;
  validTo?: InputMaybe<Scalars['Date']>;
};

export type FolderSort = {
  criteria?: InputMaybe<SortFileOptions>;
  direction?: InputMaybe<Direction>;
};

export enum FolderSortCriteria {
  Name = 'name'
}

export type GetUploadUrlInput = {
  name: Scalars['String'];
  size: Scalars['Int'];
  type: Scalars['String'];
};

export type GetUploadUrlPayload = {
  __typename?: 'GetUploadUrlPayload';
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GoogleAccountsGroup = {
  __typename?: 'GoogleAccountsGroup';
  name?: Maybe<Scalars['String']>;
  networkReferer?: Maybe<Scalars['ID']>;
  type?: Maybe<GoogleAccountsGroupType>;
};

export enum GoogleAccountsGroupType {
  LocationGroup = 'LOCATION_GROUP',
  Personal = 'PERSONAL'
}

export type GoogleAccountsResponse = {
  __typename?: 'GoogleAccountsResponse';
  nextToken?: Maybe<Scalars['String']>;
  previousToken?: Maybe<Scalars['String']>;
  socialNetworkAccounts?: Maybe<Array<Maybe<AccountPage>>>;
};

export type GoogleAverageMetrics = {
  __typename?: 'GoogleAverageMetrics';
  AVERAGE?: Maybe<Scalars['Float']>;
  FIVE?: Maybe<Scalars['Int']>;
  FOUR?: Maybe<Scalars['Int']>;
  HAS_REPLY?: Maybe<Scalars['Int']>;
  ONE?: Maybe<Scalars['Int']>;
  THREE?: Maybe<Scalars['Int']>;
  TOTAL?: Maybe<Scalars['Int']>;
  TOTAL_PERIOD?: Maybe<Scalars['Int']>;
  TOTAL_PREV?: Maybe<Scalars['Int']>;
  TWO?: Maybe<Scalars['Int']>;
};

export type GoogleMetricsFields = {
  __typename?: 'GoogleMetricsFields';
  BUSINESS_BOOKINGS?: Maybe<Scalars['Int']>;
  BUSINESS_CONVERSATIONS?: Maybe<Scalars['Int']>;
  BUSINESS_DIRECTION_REQUESTS?: Maybe<Scalars['Int']>;
  BUSINESS_FOOD_MENU_CLICKS?: Maybe<Scalars['Int']>;
  BUSINESS_FOOD_ORDERS?: Maybe<Scalars['Int']>;
  BUSINESS_IMPRESSIONS_DESKTOP_MAPS?: Maybe<Scalars['Int']>;
  BUSINESS_IMPRESSIONS_DESKTOP_SEARCH?: Maybe<Scalars['Int']>;
  BUSINESS_IMPRESSIONS_MOBILE_MAPS?: Maybe<Scalars['Int']>;
  BUSINESS_IMPRESSIONS_MOBILE_SEARCH?: Maybe<Scalars['Int']>;
  CALL_CLICKS?: Maybe<Scalars['Int']>;
  CLICKS_PREV?: Maybe<Scalars['Int']>;
  GRAPH?: Maybe<Scalars['JSON']>;
  PM?: Maybe<PmMetrics>;
  REVIEWS?: Maybe<GoogleAverageMetrics>;
  SEARCH_PREV?: Maybe<Scalars['Int']>;
  WEBSITE_CLICKS?: Maybe<Scalars['Int']>;
};

export type GoogleMetricsFieldsInput = {
  BUSINESS_BOOKINGS?: InputMaybe<Scalars['Int']>;
  BUSINESS_CONVERSATIONS?: InputMaybe<Scalars['Int']>;
  BUSINESS_DIRECTION_REQUESTS?: InputMaybe<Scalars['Int']>;
  BUSINESS_FOOD_MENU_CLICKS?: InputMaybe<Scalars['Int']>;
  BUSINESS_FOOD_ORDERS?: InputMaybe<Scalars['Int']>;
  BUSINESS_IMPRESSIONS_DESKTOP_MAPS?: InputMaybe<Scalars['Int']>;
  BUSINESS_IMPRESSIONS_DESKTOP_SEARCH?: InputMaybe<Scalars['Int']>;
  BUSINESS_IMPRESSIONS_MOBILE_MAPS?: InputMaybe<Scalars['Int']>;
  BUSINESS_IMPRESSIONS_MOBILE_SEARCH?: InputMaybe<Scalars['Int']>;
  CALL_CLICKS?: InputMaybe<Scalars['Int']>;
  CLICKS_PREV?: InputMaybe<Scalars['Int']>;
  SEARCH_PREV?: InputMaybe<Scalars['Int']>;
  WEBSITE_CLICKS?: InputMaybe<Scalars['Int']>;
};

export type GooglePmMetrics = {
  __typename?: 'GooglePmMetrics';
  metrics?: Maybe<GoogleMetricsFields>;
};

export type GooglePmMetricsFilter = {
  endDate: Scalars['Date'];
  salespointId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['Date'];
};

export type GooglePmStatsInput = {
  clientId: Scalars['String'];
  date: Scalars['String'];
  metrics?: InputMaybe<GoogleMetricsFieldsInput>;
  salesPointId: Scalars['String'];
};

export type Governance = {
  __typename?: 'Governance';
  enabled?: Maybe<Scalars['Boolean']>;
  exceptions?: Maybe<Array<Maybe<GovernanceException>>>;
  id?: Maybe<Scalars['ID']>;
  localValidator?: Maybe<Scalars['Boolean']>;
  mode?: Maybe<GovernanceMode>;
  nationalValidator?: Maybe<Scalars['Boolean']>;
  type?: Maybe<GovernanceTypes>;
};

export type GovernanceException = {
  __typename?: 'GovernanceException';
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  localValidator?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nationalValidator?: Maybe<Scalars['Boolean']>;
  salesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
};

export type GovernanceExceptionInput = {
  enabled: Scalars['Boolean'];
  localValidator: Scalars['Boolean'];
  name: Scalars['String'];
  nationalValidator: Scalars['Boolean'];
  salesPointsIds: Array<Scalars['ID']>;
};

export type GovernanceInput = {
  enabled: Scalars['Boolean'];
  localValidator: Scalars['Boolean'];
  mode?: InputMaybe<GovernanceMode>;
  nationalValidator: Scalars['Boolean'];
};

export enum GovernanceMode {
  Global = 'global',
  Product = 'product'
}

export enum GovernanceTypes {
  Amplify = 'amplify',
  ConverseComment = 'converse_comment',
  ConverseRating = 'converse_rating',
  Order = 'order',
  Publish = 'publish'
}

export type HasGlobalDataResponse = {
  __typename?: 'HasGlobalDataResponse';
  facebook?: Maybe<Scalars['Boolean']>;
  google?: Maybe<Scalars['Boolean']>;
  instagram?: Maybe<Scalars['Boolean']>;
  linkedin?: Maybe<Scalars['Boolean']>;
};

export type Hashtags = {
  __typename?: 'Hashtags';
  clientId?: Maybe<Scalars['String']>;
  hashtags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HeaderPayload = {
  __typename?: 'HeaderPayload';
  alg: Scalars['String'];
  typ: Scalars['String'];
};

export type HelpBlock = {
  __typename?: 'HelpBlock';
  contact?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  phone1?: Maybe<Scalars['String']>;
  phone2?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type HelpBlockInput = {
  contact?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  phone1?: InputMaybe<Scalars['String']>;
  phone2?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type HelpBlockOrder = {
  id: Scalars['ID'];
  order: Scalars['Int'];
};

export type HierarchyDetail = {
  __typename?: 'HierarchyDetail';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  folderId: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<Scalars['ID']>;
  salespointsGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};

export type HomePageBasicSettings = {
  __typename?: 'HomePageBasicSettings';
  enabled?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type HomePageBasicSettingsInput = {
  enabled: Scalars['Boolean'];
  order: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type HomePageCallToAction = {
  __typename?: 'HomePageCallToAction';
  callToActions?: Maybe<Array<Maybe<CallToAction>>>;
  enabled?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
};

export type HomePageCallToActionInput = {
  callToActions?: InputMaybe<Array<InputMaybe<CallToActionInput>>>;
  enabled: Scalars['Boolean'];
  order: Scalars['Int'];
};

export type HomePageCampaignSettings = {
  __typename?: 'HomePageCampaignSettings';
  buttonLink?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  campaignIds?: Maybe<Array<Maybe<CampaignDetails>>>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  customCampaignsEnabled?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type HomePageCampaignSettingsInput = {
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  campaignIds?: InputMaybe<Array<InputMaybe<CampaignDetailsInput>>>;
  customCampaignsEnabled: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  order: Scalars['Int'];
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type HomePageSettings = {
  __typename?: 'HomePageSettings';
  callToAction?: Maybe<HomePageCallToAction>;
  campaign?: Maybe<HomePageCampaignSettings>;
  clientId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lang?: Maybe<AvailableLang>;
  library?: Maybe<HomePageBasicSettings>;
  planning?: Maybe<HomePageBasicSettings>;
  shop?: Maybe<HomePageBasicSettings>;
  slides?: Maybe<HomePageSlideSettings>;
};

export type HomePageSettingsInput = {
  callToAction: HomePageCallToActionInput;
  campaign: HomePageCampaignSettingsInput;
  lang: AvailableLang;
  library: HomePageBasicSettingsInput;
  planning: HomePageBasicSettingsInput;
  shop: HomePageBasicSettingsInput;
  slides: HomePageSlideSettingsInput;
};

export type HomePageSlideSettings = {
  __typename?: 'HomePageSlideSettings';
  enabled?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  sliderType?: Maybe<SliderType>;
  slidesDetails?: Maybe<Array<Maybe<SlidesDetails>>>;
};

export type HomePageSlideSettingsInput = {
  enabled: Scalars['Boolean'];
  order: Scalars['Int'];
  sliderType?: InputMaybe<SliderType>;
  slidesDetails?: InputMaybe<Array<InputMaybe<SlidesDetailsInput>>>;
};

export type HyperFile = {
  __typename?: 'HyperFile';
  bucketName: Scalars['String'];
  id: Scalars['ID'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export enum HyundaiClients {
  Charlybriefhyundai = 'charlybriefhyundai',
  Hypertest = 'hypertest',
  Hyundai = 'hyundai',
  Socialtest2 = 'socialtest2'
}

export enum HyundaiSalesforceClients {
  Hyundai = 'hyundai'
}

export type Image = {
  __typename?: 'Image';
  id: Scalars['ID'];
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  original?: Maybe<Scalars['String']>;
  originName?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type ImageDimensions = {
  __typename?: 'ImageDimensions';
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type ImageFormats = {
  __typename?: 'ImageFormats';
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type ImageInput = {
  file?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
};

export enum ImportAmplifyUsersBudgetError {
  BadDateFormat = 'BAD_DATE_FORMAT',
  BadFormat = 'BAD_FORMAT',
  DateMissing = 'DATE_MISSING',
  FieldIsRequired = 'FIELD_IS_REQUIRED',
  FileIsEmpty = 'FILE_IS_EMPTY',
  IncoherentDates = 'INCOHERENT_DATES',
  MissingBudgetLimit = 'MISSING_BUDGET_LIMIT',
  MissingHeader = 'MISSING_HEADER',
  NoValidUser = 'NO_VALID_USER',
  ShouldBeInteger = 'SHOULD_BE_INTEGER'
}

export type ImportAmplifyUsersBudgetErrors = {
  __typename?: 'ImportAmplifyUsersBudgetErrors';
  error?: Maybe<ImportAmplifyUsersBudgetError>;
  field?: Maybe<Scalars['String']>;
  line?: Maybe<Scalars['Int']>;
};

export type ImportAmplifyUsersBudgetResult = {
  __typename?: 'ImportAmplifyUsersBudgetResult';
  errors?: Maybe<Array<Maybe<ImportAmplifyUsersBudgetErrors>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum ImportFileForPostType {
  Album = 'album',
  Avatar = 'avatar',
  Carousel = 'carousel',
  Cover = 'cover',
  Event = 'event',
  Gif = 'gif',
  Offer = 'offer',
  Photo = 'photo',
  Profile = 'profile',
  Story = 'story',
  Thumbnail = 'thumbnail',
  Video = 'video'
}

export type ImportFileSpecifications = {
  __typename?: 'ImportFileSpecifications';
  allowedExtensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxDuration?: Maybe<Scalars['Int']>;
  maxFiles?: Maybe<Scalars['Int']>;
  maxFormat?: Maybe<Scalars['String']>;
  maxResolution?: Maybe<Scalars['String']>;
  maxSize?: Maybe<Scalars['String']>;
  minDuration?: Maybe<Scalars['Int']>;
  minFiles?: Maybe<Scalars['Int']>;
  minFormat?: Maybe<Scalars['String']>;
  minResolution?: Maybe<Scalars['String']>;
  minSize?: Maybe<Scalars['String']>;
};

export type ImportFileSpecificationsByType = {
  __typename?: 'ImportFileSpecificationsByType';
  specs?: Maybe<ImportFileSpecifications>;
  type?: Maybe<FileImportType>;
};

export type ImportJobError = {
  __typename?: 'ImportJobError';
  error?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<ImportJobFieldError>>>;
  ref?: Maybe<Scalars['String']>;
};

export type ImportJobFieldError = {
  __typename?: 'ImportJobFieldError';
  error?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
};

export enum ImportJobStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type ImportProductsJob = {
  __typename?: 'ImportProductsJob';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  importError?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['ID']>;
  successful?: Maybe<Array<Maybe<Scalars['String']>>>;
  updates?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ImportSalespointGroupsJob = {
  __typename?: 'ImportSalespointGroupsJob';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  importError?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['ID']>;
  successful?: Maybe<Array<Maybe<Scalars['String']>>>;
  updates?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ImportSalesPointJob = {
  __typename?: 'ImportSalesPointJob';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  creations?: Maybe<Array<Maybe<SalesPoint>>>;
  fails?: Maybe<Array<Maybe<ImportJobError>>>;
  id?: Maybe<Scalars['ID']>;
  importError?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  status?: Maybe<ImportJobStatus>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updates?: Maybe<Array<Maybe<SalesPoint>>>;
};

export type ImportUserAmplifyBudgetJob = {
  __typename?: 'ImportUserAmplifyBudgetJob';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  creations?: Maybe<Array<Maybe<UserAmplifyBudget>>>;
  fails?: Maybe<Array<Maybe<ImportJobError>>>;
  id?: Maybe<Scalars['ID']>;
  importError?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  status?: Maybe<ImportJobStatus>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updates?: Maybe<Array<Maybe<UserAmplifyBudget>>>;
};

export type ImportUserJob = {
  __typename?: 'ImportUserJob';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  creations?: Maybe<Array<Maybe<User>>>;
  fails?: Maybe<Array<Maybe<ImportJobError>>>;
  id?: Maybe<Scalars['ID']>;
  importError?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  status?: Maybe<ImportJobStatus>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updates?: Maybe<Array<Maybe<User>>>;
};

export type InfoPerDay = {
  __typename?: 'InfoPerDay';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
};

export type InputAmplifyCampaign = {
  advantagePlusOption: Scalars['Boolean'];
  callToAction?: InputMaybe<Scalars['Int']>;
  campaignName: Scalars['String'];
  connection: AmplifyCampaignConnectionTypes;
  customCatchmentAreaRadius?: InputMaybe<Scalars['Int']>;
  endAt: Scalars['Date'];
  link?: InputMaybe<Scalars['String']>;
  optimizationGoal: AmplifyCampaignGoalStrategy;
  organicTargeting?: InputMaybe<InputOrganicTargeting>;
  socialNetwork?: InputMaybe<Scalars['String']>;
  specialCategories?: InputMaybe<Array<InputMaybe<AmplifyCampaignSpecialCategory>>>;
  startAt: Scalars['Date'];
  target: AmplifyTargeting;
  totalBudget: Scalars['Float'];
  useDefaultCatchmentArea: Scalars['Boolean'];
};

export type InputBrief = {
  activityType?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  attribute?: InputMaybe<Scalars['String']>;
  briefSpecClient?: InputMaybe<Array<InputMaybe<InputBriefSpecClient>>>;
  briefType?: InputMaybe<Scalars['Boolean']>;
  budget?: InputMaybe<Scalars['Float']>;
  budgetType?: InputMaybe<Scalars['String']>;
  campaignEnd?: InputMaybe<Scalars['Date']>;
  campaignId?: InputMaybe<Scalars['ID']>;
  campaignStart?: InputMaybe<Scalars['Date']>;
  campaignType?: InputMaybe<Scalars['String']>;
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  comment?: InputMaybe<Scalars['String']>;
  communicationType?: InputMaybe<Scalars['String']>;
  contacts: Array<InputBriefContact>;
  contextGoalsIssues?: InputMaybe<Scalars['String']>;
  customerJourney?: InputMaybe<Scalars['String']>;
  deliveryDeadline?: InputMaybe<Scalars['Date']>;
  deliveryOption?: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  internalReference?: InputMaybe<Scalars['String']>;
  isCommentEnabled?: InputMaybe<Scalars['Boolean']>;
  isProduct?: InputMaybe<Scalars['Boolean']>;
  medium?: InputMaybe<Scalars['String']>;
  modelType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  offer?: InputMaybe<Scalars['String']>;
  other?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  referenceVisuals?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salesPointId: Scalars['ID'];
  shippingAddresses?: InputMaybe<Array<InputBriefShippingAddress>>;
  targeting?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  validEndDate?: InputMaybe<Scalars['Date']>;
  validStartDate?: InputMaybe<Scalars['Date']>;
};

export type InputBriefContact = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum InputBriefMediaTag {
  Attachment = 'attachment',
  Final = 'final',
  Quote = 'quote'
}

export type InputBriefQuoteOptions = {
  amount?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
};

export type InputBriefShippingAddress = {
  additionalAddress?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  quantity: Scalars['Int'];
};

export type InputBriefSpecClient = {
  id: Scalars['ID'];
  key: BriefSpecClientKey;
};

export type InputCarouselItem = {
  callToAction: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  position: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type InputCatalogPriceLevels = {
  price: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type InputChiliDetails = {
  documentDownloadSettingsId?: InputMaybe<Scalars['String']>;
  documentId: Scalars['String'];
  documentViewPrefsId?: InputMaybe<Scalars['String']>;
  documentWorkspaceId?: InputMaybe<Scalars['String']>;
  exportTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type InputDeleteOptionsAssets = {
  deleteImage?: InputMaybe<Scalars['Boolean']>;
};

export type InputDuplicateInfos = {
  baseHighQualityImageUrlOnDuplicate?: InputMaybe<Scalars['String']>;
  baseImageUrlOnDuplicate?: InputMaybe<Scalars['String']>;
  baseLowQualityImageUrlOnDuplicate?: InputMaybe<Scalars['String']>;
  duplicateProductId?: InputMaybe<Scalars['ID']>;
};

export type InputMediaDetails = {
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tips?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['Date']>;
  validTo?: InputMaybe<Scalars['Date']>;
};

export type InputMediaUrl = {
  filename: Scalars['String'];
  mimetype: Scalars['String'];
  url: Scalars['String'];
};

export type InputNotification = {
  id: Scalars['ID'];
  socialNetwork: SocialNetwork;
};

export type InputOrganicTargeting = {
  ageTargeting: Scalars['Boolean'];
  isGeoTarget?: InputMaybe<Scalars['Boolean']>;
  isGeoTargetOnlyGlobal?: InputMaybe<Scalars['Boolean']>;
  maxAgeTarget?: InputMaybe<Scalars['Int']>;
  minAgeTarget?: InputMaybe<Scalars['Int']>;
  sexOfTarget?: InputMaybe<Scalars['String']>;
  sexTargeting: Scalars['Boolean'];
  targetingCountries?: InputMaybe<Array<InputOrganicTargetingObject>>;
  targetingGeolocations?: InputMaybe<Array<InputOrganicTargetingObject>>;
  targetingInterests?: InputMaybe<Array<InputOrganicTargetingObject>>;
};

export type InputOrganicTargetingObject = {
  facebookKey: Scalars['String'];
  name: Scalars['String'];
};

export type InputProduct = {
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contextGoalsIssues?: InputMaybe<Scalars['String']>;
  crmSupports?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  deliveryDate?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledDate?: InputMaybe<Scalars['Date']>;
  documentDownloadSettingsId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  documentViewPrefsId?: InputMaybe<Scalars['String']>;
  documentWorkspaceId?: InputMaybe<Scalars['String']>;
  enabledDate?: InputMaybe<Scalars['Date']>;
  exportTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixPricesLevelsByQuantity?: InputMaybe<Array<InputCatalogPriceLevels>>;
  hasVariation?: InputMaybe<Scalars['Boolean']>;
  isBriefCrm?: InputMaybe<Scalars['Boolean']>;
  isCommentEnabled?: InputMaybe<Scalars['Boolean']>;
  isCustomizable: Scalars['Boolean'];
  isDownloadByEmail?: InputMaybe<Scalars['Boolean']>;
  isGovernanceEnabled?: InputMaybe<Scalars['Boolean']>;
  isHighlighted?: InputMaybe<Scalars['Boolean']>;
  isManyOptionsSelectable?: InputMaybe<Scalars['Boolean']>;
  isMaximumOrderEnabled?: InputMaybe<Scalars['Boolean']>;
  isMinimumOrderEnabled?: InputMaybe<Scalars['Boolean']>;
  isPack?: InputMaybe<Scalars['Boolean']>;
  isPaidMediaProduct?: InputMaybe<Scalars['Boolean']>;
  isProposeForDownload?: InputMaybe<Scalars['Boolean']>;
  isPurchaseOrder?: InputMaybe<Scalars['Boolean']>;
  isRoutingFileEnabled?: InputMaybe<Scalars['Boolean']>;
  isShowcase?: InputMaybe<Scalars['Boolean']>;
  isStockEnabled?: InputMaybe<Scalars['Boolean']>;
  maximumOrder?: InputMaybe<ProductMaximumOrderConfigInput>;
  maximumOrderExceptions?: InputMaybe<Array<ProductMaximumOrderExceptionInput>>;
  minimumOrder?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  numberOfExactOptions?: InputMaybe<Scalars['Int']>;
  other?: InputMaybe<Scalars['String']>;
  packagingUnit?: InputMaybe<Scalars['Int']>;
  paidMediaCampaignName?: InputMaybe<Scalars['String']>;
  preorderAvailable?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['Int']>;
  priceLevels?: InputMaybe<Array<InputCatalogPriceLevels>>;
  priceType?: InputMaybe<PriceTypes>;
  productOptions?: InputMaybe<Array<InputMaybe<InputProductOption>>>;
  productsInPack?: InputMaybe<Array<ProductPackId>>;
  providerId?: InputMaybe<Scalars['ID']>;
  ref: Scalars['String'];
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shouldHaveAtLeastOneOptionSelected?: InputMaybe<Scalars['Boolean']>;
  shouldHaveExactOptionsSelected?: InputMaybe<Scalars['Boolean']>;
  showcaseText?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['Int']>;
  stockLimitAlert?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  targeting?: InputMaybe<Scalars['String']>;
  technicalCharacteristics?: InputMaybe<Scalars['String']>;
  tips?: InputMaybe<Scalars['String']>;
  type: AllowedProductType;
  unitName?: InputMaybe<Scalars['String']>;
  useEnabledDates: Scalars['Boolean'];
  useLaunchDate?: InputMaybe<Scalars['Boolean']>;
  userCanAddFiles?: InputMaybe<Scalars['Boolean']>;
  userCanComment?: InputMaybe<Scalars['Boolean']>;
  userCanUpload?: InputMaybe<Scalars['Boolean']>;
  useSalespointGroups: Scalars['Boolean'];
  useValidDate?: InputMaybe<Scalars['Boolean']>;
  variation?: InputMaybe<Array<InputMaybe<ProductAttributeInput>>>;
  variationByQuantity?: InputMaybe<Array<InputMaybe<QuantityVariationInput>>>;
  watermarkPreview?: InputMaybe<Scalars['Boolean']>;
  weight?: InputMaybe<Scalars['Float']>;
  workTypeId?: InputMaybe<Scalars['ID']>;
};

export type InputProductOption = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  originalImage?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type InputSocialEvent = {
  callToAction?: InputMaybe<Scalars['Int']>;
  couponCode?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['Date']>;
  startAt?: InputMaybe<Scalars['Date']>;
  terms?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Item = {
  __typename?: 'Item';
  appliedDiscounts?: Maybe<Array<Maybe<Discount>>>;
  comment?: Maybe<Scalars['String']>;
  files: Array<ItemFile>;
  options?: Maybe<Array<Maybe<ProductOption>>>;
  packInfo?: Maybe<PackInfo>;
  product: Product;
  productId: Scalars['ID'];
  providerId?: Maybe<Scalars['ID']>;
  quantitiesPerLocation?: Maybe<Array<Maybe<QuantitiesPerLocation>>>;
  quantity: Scalars['Int'];
  salesPointIdChiliStorage?: Maybe<Scalars['String']>;
  selectedFixPrice?: Maybe<Scalars['Int']>;
  subId?: Maybe<Scalars['ID']>;
  totalPrice?: Maybe<Price>;
  totalPricePerLocations?: Maybe<Array<Maybe<PriceAndQuantityForLocation>>>;
  type?: Maybe<CartType>;
  unitPrice?: Maybe<Price>;
  variationByQuantity?: Maybe<Array<Maybe<QuantityVariation>>>;
};

export type ItemFile = {
  __typename?: 'ItemFile';
  bucketName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  originalName: Scalars['String'];
  url: Scalars['String'];
};

export type ItemQuantitiesPerLocationInput = {
  productId: Scalars['ID'];
  quantitiesPerLocation: Array<QuantitiesPerLocationInput>;
  subId?: InputMaybe<Scalars['ID']>;
};

export type ItemStatus = {
  __typename?: 'ItemStatus';
  count?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type ItemsToValidate = {
  __typename?: 'ItemsToValidate';
  amplify?: Maybe<ItemStatus>;
  converse_comment?: Maybe<ItemStatus>;
  converse_rating?: Maybe<ItemStatus>;
  order?: Maybe<ItemStatus>;
  publish?: Maybe<ItemStatus>;
};

export type JwtPayload = {
  __typename?: 'JwtPayload';
  token: Scalars['String'];
};

export enum LanguageSelectOption {
  Arabe = 'ARABE',
  Cantonais = 'CANTONAIS',
  Coreen = 'COREEN',
  Creole = 'CREOLE',
  Deutsch = 'DEUTSCH',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  Espanol = 'ESPANOL',
  Filipino = 'FILIPINO',
  Francais = 'FRANCAIS',
  Hebrew = 'HEBREW',
  Hindi = 'HINDI',
  Italiano = 'ITALIANO',
  Mandarin = 'MANDARIN',
  Polonais = 'POLONAIS',
  Portugais = 'PORTUGAIS',
  Roumain = 'ROUMAIN',
  Russe = 'RUSSE',
  Ukrainien = 'UKRAINIEN',
  Vietnamien = 'VIETNAMIEN'
}

export enum LibraryMediaType {
  CampaignSupport = 'campaignSupport',
  Customizable = 'customizable',
  File = 'file',
  Folder = 'folder'
}

export type LinkMetadata = {
  __typename?: 'LinkMetadata';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type LiteMedia = {
  __typename?: 'LiteMedia';
  details?: Maybe<MediaDetails>;
  enabled?: Maybe<Scalars['Boolean']>;
  fileType?: Maybe<UploadedFileType>;
  id: Scalars['ID'];
  images?: Maybe<ImageFormats>;
  name?: Maybe<Scalars['String']>;
  tempUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  type: LibraryMediaType;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};

export type LitePostTemplate = {
  __typename?: 'LitePostTemplate';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<PostTemplateTag>>>;
};

export type LitePostTemplateList = {
  __typename?: 'LitePostTemplateList';
  count?: Maybe<Scalars['Int']>;
  templates?: Maybe<Array<Maybe<LitePostTemplate>>>;
};

export type LocalizedNameInput = {
  lang?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  additionalAddress?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  locationCode?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

export type LocationInput = {
  additionalAddress?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  isDefaultFor?: InputMaybe<LocationType>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export enum LocationType {
  Billing = 'billing',
  Shipping = 'shipping'
}

export type LocationUpdate = {
  locationId: Scalars['String'];
  update: LocationInput;
};

export enum LoginMode {
  Password = 'password',
  Sso = 'sso'
}

export type MarketingActivationInput = {
  accountCodeSAP?: InputMaybe<Scalars['String']>;
  activityType: Scalars['String'];
  amount: Scalars['Float'];
  communicationType: Scalars['String'];
  endDate: Scalars['Date'];
  externalId: Scalars['String'];
  modelType: Scalars['String'];
  name: Scalars['String'];
  recommended?: InputMaybe<RecommendedValues>;
  startDate: Scalars['Date'];
  status?: InputMaybe<Scalars['Float']>;
};

export type MarketingActivationResult = {
  __typename?: 'MarketingActivationResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type MarketingActivationTargetType = {
  accountsCodeSAP: Array<InputMaybe<Scalars['String']>>;
  type: TargetTypes;
};

export type Media = {
  __typename?: 'Media';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  chiliDetails?: Maybe<ChiliDetails>;
  details?: Maybe<MediaDetails>;
  enabled?: Maybe<Scalars['Boolean']>;
  fileType?: Maybe<UploadedFileType>;
  id: Scalars['ID'];
  images?: Maybe<ImageFormats>;
  isDownloadByEmail?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  salespointsGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  tempUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  type: LibraryMediaType;
  url?: Maybe<Scalars['String']>;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};

export type MediaAndProductMetrics = {
  __typename?: 'MediaAndProductMetrics';
  copiedMediaLink?: Maybe<TagMetrics>;
  downloadedMedias?: Maybe<TagMetrics>;
  downloadedMediasPerUsers?: Maybe<TagMetrics>;
  enabledProducts?: Maybe<SimpleMetricReturn>;
  nbrActivatedMedias?: Maybe<SimpleMetricReturn>;
};

export type MediaDetails = {
  __typename?: 'MediaDetails';
  allTags?: Maybe<Array<Maybe<Tag>>>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  mimetype?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  tips?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaFilterGroup = {
  __typename?: 'MediaFilterGroup';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<MediaFilterOption>>>;
  type?: Maybe<MediaFilterType>;
};

export type MediaFilterInput = {
  optionID?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<MediaFilterType>;
};

export type MediaFilterOption = {
  __typename?: 'MediaFilterOption';
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export enum MediaFilterType {
  Extensions = 'extensions',
  FileType = 'fileType',
  FileTypes = 'fileTypes',
  MaxDuration = 'maxDuration',
  MaxFormat = 'maxFormat',
  MaxResolution = 'maxResolution',
  MaxSize = 'maxSize',
  MinDuration = 'minDuration',
  MinFormat = 'minFormat',
  MinResolution = 'minResolution',
  SocialNetworks = 'socialNetworks',
  Tag = 'tag'
}

export type MediasHighlighted = {
  __typename?: 'MediasHighlighted';
  medias?: Maybe<Array<Maybe<Media>>>;
  tag?: Maybe<Tag>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MediaSort = {
  criteria?: InputMaybe<SortFileOptions>;
  direction?: InputMaybe<Direction>;
};

export enum MediaSortCriteria {
  Name = 'name'
}

export type MediasPagination = {
  __typename?: 'MediasPagination';
  count?: Maybe<Scalars['Int']>;
  highlighted?: Maybe<Array<Maybe<MediasHighlighted>>>;
  medias?: Maybe<Array<Maybe<LiteMedia>>>;
};

export enum MediaType {
  Gif = 'gif',
  Image = 'image',
  Video = 'video'
}

export enum MediaTypeFilter {
  Customizable = 'customizable',
  File = 'file'
}

export type MentionItem = {
  __typename?: 'MentionItem';
  id: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type MentionPayload = {
  __typename?: 'MentionPayload';
  data?: Maybe<Array<Maybe<MentionItem>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Milestone = {
  __typename?: 'Milestone';
  end?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Date']>;
};

export type MultipleChoiceCustomFieldConfig = {
  __typename?: 'MultipleChoiceCustomFieldConfig';
  displayType: MultipleChoiceDisplayType;
  options: Array<Scalars['String']>;
};

export type MultipleChoiceCustomFieldConfigInput = {
  displayType: MultipleChoiceDisplayType;
  options: Array<Scalars['String']>;
};

export enum MultipleChoiceDisplayType {
  Checkbox = 'CHECKBOX',
  DropDown = 'DROP_DOWN'
}

export type Mutation = {
  __typename?: 'Mutation';
  addAmplifyAccounts?: Maybe<Array<Maybe<AccountPage>>>;
  addBriefComment?: Maybe<BriefComment>;
  addCartItemFiles?: Maybe<Cart>;
  addEditedProductToCart?: Maybe<AddEditedProductToCartResult>;
  addEditedProductToDraft?: Maybe<Scalars['Boolean']>;
  addFacebookAccount?: Maybe<Array<Maybe<AccountPage>>>;
  addGoogleAccounts?: Maybe<Array<Maybe<AccountPage>>>;
  addGovernanceException?: Maybe<GovernanceException>;
  addHashtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  addItemToCart?: Maybe<Cart>;
  addLibraryMedia?: Maybe<Array<Maybe<Media>>>;
  addLinkedinAccounts?: Maybe<Array<Maybe<AccountPage>>>;
  addMultipleItemsToCart?: Maybe<Cart>;
  addNews?: Maybe<News>;
  addOrderMessage?: Maybe<Order>;
  addPostTemplate?: Maybe<PostTemplate>;
  addProvider?: Maybe<Provider>;
  addSalesPointLocations?: Maybe<SalesPoint>;
  addSocialPost?: Maybe<AddSocialPostPayload>;
  addStaciExport?: Maybe<StaciExport>;
  addTwitterAccount?: Maybe<AccountPage>;
  archiveAllNotifications?: Maybe<DefaultPayload>;
  archiveBrief?: Maybe<Scalars['Boolean']>;
  archiveNotifications?: Maybe<DefaultPayload>;
  assignRole?: Maybe<Role>;
  assignVoucherToCart?: Maybe<Cart>;
  associateUsersToSalesPoint?: Maybe<Scalars['Boolean']>;
  associateUserToSalesPointGroups?: Maybe<Scalars['Boolean']>;
  associateUserToSalesPoints?: Maybe<Scalars['Boolean']>;
  bulkAddCartItems?: Maybe<BulkAddCartItemsReturnValue>;
  bulkRemoveCartItems?: Maybe<Cart>;
  cancelOrderByProvider?: Maybe<Order>;
  cancelPreorder?: Maybe<Preorder>;
  cancelProductsImportJob?: Maybe<Scalars['Boolean']>;
  cancelSalespointGroupsImportJob?: Maybe<Scalars['Boolean']>;
  cancelSalesPointsImportJob?: Maybe<Scalars['Boolean']>;
  cancelUserAmplifyBudgetImportJob?: Maybe<Scalars['Boolean']>;
  cancelUsersImportJob?: Maybe<Scalars['Boolean']>;
  changeEmail?: Maybe<Credentials>;
  changePassword?: Maybe<Credentials>;
  commitOrderPayment?: Maybe<Scalars['String']>;
  commitProductsImportJob?: Maybe<Scalars['Boolean']>;
  commitSalespointGroupsImportJob?: Maybe<Scalars['Boolean']>;
  commitSalesPointsImportJob?: Maybe<Scalars['Boolean']>;
  commitUserAmplifyBudgetImportJob?: Maybe<Scalars['Boolean']>;
  commitUsersImportJob?: Maybe<Scalars['Boolean']>;
  connectUserToFacebook?: Maybe<SocialLoginInfos>;
  connectUserToGoogle?: Maybe<SocialLoginInfos>;
  connectUserToLinkedin?: Maybe<SocialLoginInfos>;
  connectUserToTwitter?: Maybe<SocialLoginInfos>;
  consolidatePost: Scalars['Boolean'];
  createAmplifyCampaign?: Maybe<AmplifyCampaign>;
  createAnswerTemplate?: Maybe<AnswerTemplate>;
  createApiKey?: Maybe<ApiKey>;
  createBrief?: Maybe<Brief>;
  createCampaign?: Maybe<Campaign>;
  createCampaignCategory?: Maybe<CampaignCategory>;
  createChildProductCategory: ChildProductCategory;
  createClient?: Maybe<Client>;
  createCustomFieldDefinition: CustomFieldDefinition;
  createEvent: Scalars['Boolean'];
  createHelpBlock?: Maybe<HelpBlock>;
  createInstantPurchaseOrder?: Maybe<ConfirmInstantPurchaseOrder>;
  createJiraIssue?: Maybe<Scalars['String']>;
  createLibraryFolder?: Maybe<Folder>;
  createMarketingActivation?: Maybe<MarketingActivationResult>;
  createMultipleBriefs?: Maybe<Array<Maybe<Brief>>>;
  createOrderFromCart?: Maybe<OrderCreationResult>;
  createParentProductCategory: ParentProductCategory;
  createPaymentMethod?: Maybe<PaymentMethod>;
  createPdfThumbnail?: Maybe<Scalars['String']>;
  createPostTemplateTag?: Maybe<PostTemplateTag>;
  createPostTemplateTagGroup?: Maybe<PostTemplateTagGroup>;
  createProduct?: Maybe<Product>;
  createPromptBrief?: Maybe<PromptBriefResponse>;
  createRole?: Maybe<Role>;
  createSalesPoint?: Maybe<SalesPoint>;
  createSalespointGroup?: Maybe<SalespointsGroup>;
  createSecretKey?: Maybe<Scalars['Boolean']>;
  createSso?: Maybe<Sso>;
  createTag?: Maybe<Tag>;
  createTagGroup?: Maybe<TagGroup>;
  createUser?: Maybe<User>;
  createUserImmediately?: Maybe<User>;
  createVoucher?: Maybe<Voucher>;
  deleteAmplifyAccounts?: Maybe<BulkActionResult>;
  deleteAnswerTemplate?: Maybe<AnswerTemplate>;
  deleteBrief?: Maybe<Scalars['Boolean']>;
  deleteBriefMedia?: Maybe<Scalars['Boolean']>;
  deleteCampaign?: Maybe<Scalars['Boolean']>;
  deleteCampaignCategory?: Maybe<Scalars['Boolean']>;
  deleteCart?: Maybe<Scalars['Boolean']>;
  deleteCartItemFile?: Maybe<Cart>;
  deleteCustomVisual?: Maybe<Scalars['Boolean']>;
  deleteGovernanceException?: Maybe<Scalars['Boolean']>;
  deleteHashtag?: Maybe<Array<Maybe<Scalars['String']>>>;
  deleteHelpBlock?: Maybe<Scalars['Boolean']>;
  deleteLibraryFolder?: Maybe<Scalars['Boolean']>;
  deleteLibraryMedia?: Maybe<Scalars['Boolean']>;
  deleteLibraryMedias?: Maybe<Scalars['Boolean']>;
  deleteNews?: Maybe<Scalars['Boolean']>;
  deletePastSpecialOpeningHours?: Maybe<Scalars['Boolean']>;
  deletePaymentMethod?: Maybe<PaymentMethod>;
  deletePostTemplate?: Maybe<Scalars['Boolean']>;
  deletePostTemplateTag?: Maybe<Scalars['Boolean']>;
  deletePostTemplateTagGroup?: Maybe<Scalars['Boolean']>;
  deleteProduct?: Maybe<Scalars['Boolean']>;
  deleteProductCategory: Scalars['Boolean'];
  deleteProvider?: Maybe<Scalars['Boolean']>;
  deleteRole?: Maybe<Scalars['Boolean']>;
  deleteSalespointGroup?: Maybe<Scalars['Boolean']>;
  deleteSalesPointImages?: Maybe<Scalars['Boolean']>;
  deleteSalesPointLocations?: Maybe<Scalars['Boolean']>;
  deleteShippingFees?: Maybe<Scalars['Boolean']>;
  deleteSocialNetworkAccounts?: Maybe<BulkActionResult>;
  deleteSocialPost?: Maybe<Scalars['Boolean']>;
  deleteStaciExport?: Maybe<Scalars['Boolean']>;
  deleteTag?: Maybe<Tag>;
  deleteTagGroup?: Maybe<TagGroup>;
  deleteUser?: Maybe<User>;
  deleteVoucher?: Maybe<Scalars['Boolean']>;
  disconnectUserFromFacebook?: Maybe<Scalars['Boolean']>;
  disconnectUserFromGoogle?: Maybe<Scalars['Boolean']>;
  disconnectUserFromLinkedin?: Maybe<Scalars['Boolean']>;
  disconnectUserFromTwitter?: Maybe<Scalars['Boolean']>;
  dissociateUserFromSalesPointGroups?: Maybe<Scalars['Boolean']>;
  dissociateUserFromSalesPoints?: Maybe<Scalars['Boolean']>;
  dissociateUsersFromSalesPoint?: Maybe<Scalars['Boolean']>;
  downloadBlacklistFile?: Maybe<Scalars['String']>;
  downloadLibraryMedias?: Maybe<DownloadLibraryMediasResult>;
  downloadSalesPointImages?: Maybe<Scalars['String']>;
  duplicateCampaign?: Maybe<Campaign>;
  duplicateMedias?: Maybe<Array<Maybe<BriefMedia>>>;
  editPostTemplate?: Maybe<PostTemplate>;
  exportBriefs?: Maybe<Scalars['String']>;
  exportBriefSpecClients?: Maybe<Scalars['String']>;
  exportCampaignPreorders?: Maybe<Scalars['String']>;
  exportEngagementMetrics?: Maybe<Scalars['String']>;
  exportMetricsArray?: Maybe<Scalars['String']>;
  exportOrders?: Maybe<Scalars['String']>;
  exportPreorders?: Maybe<Scalars['String']>;
  exportPresenceManagement?: Maybe<Scalars['String']>;
  exportProducts?: Maybe<Scalars['String']>;
  exportSalespointGroups?: Maybe<Scalars['String']>;
  exportSalesPointsByFeatures?: Maybe<ExportResult>;
  exportStores?: Maybe<Scalars['String']>;
  exportUsers?: Maybe<Scalars['String']>;
  forceSuperAdminRole?: Maybe<Credentials>;
  generatePaidMediaCampaigns?: Maybe<Scalars['String']>;
  generatePdfDownloadLink?: Maybe<Scalars['String']>;
  generateProductDownloadLink?: Maybe<Scalars['String']>;
  getCustomVisualZip?: Maybe<Scalars['String']>;
  getMediaDownloadLink?: Maybe<Scalars['String']>;
  importAmplifyUsersBudget?: Maybe<ImportUserAmplifyBudgetJob>;
  importBriefTechnicalSpecifications?: Maybe<Scalars['Boolean']>;
  importProducts?: Maybe<ImportProductsJob>;
  importSalespointGroups?: Maybe<ImportSalespointGroupsJob>;
  importSalesPoints?: Maybe<ImportSalesPointJob>;
  importUsers?: Maybe<ImportUserJob>;
  insertGooglePmStats?: Maybe<Scalars['Boolean']>;
  inviteProvider?: Maybe<UserIdObj>;
  inviteUser?: Maybe<UserIdObj>;
  launchSocialCron?: Maybe<Scalars['String']>;
  linkAmplifyAccountToSalespoint?: Maybe<Scalars['Boolean']>;
  linkGlobalAmplifyAccount?: Maybe<Scalars['Boolean']>;
  linkGlobalSocialNetworkAccount?: Maybe<Scalars['Boolean']>;
  linkSocialNetworkAccountToSalespoint?: Maybe<Scalars['Boolean']>;
  login?: Maybe<Credentials>;
  loginHyperSSO?: Maybe<Credentials>;
  markAllErrorPostsAsDone: Scalars['Boolean'];
  markErrorPostsAsDone: Scalars['Boolean'];
  markNewsAsPresented?: Maybe<Scalars['Boolean']>;
  moveLibraryFolder?: Maybe<Scalars['Boolean']>;
  moveLibraryMedia?: Maybe<Scalars['Boolean']>;
  moveLibraryMedias?: Maybe<Scalars['Boolean']>;
  ovSyncR2SpsWithApigee?: Maybe<Scalars['Boolean']>;
  ovSyncR2SpsWithR1?: Maybe<Scalars['Boolean']>;
  ovSyncSPWithApigee?: Maybe<Array<Maybe<SalesPoint>>>;
  processCloudinaryEdit?: Maybe<CloudinaryUploadResult>;
  refreshFacebookAccounts?: Maybe<Scalars['Boolean']>;
  refreshOrdersArchives?: Maybe<Scalars['Boolean']>;
  removeVoucherFromCart?: Maybe<Cart>;
  replaceFileValidationOrders: Scalars['String'];
  replyToNotifications?: Maybe<BulkActionResult>;
  requestReset?: Maybe<Scalars['Boolean']>;
  resendUserInvitation?: Maybe<Scalars['Boolean']>;
  resendUserInvitations?: Maybe<ResendInvitationsResult>;
  resetCampaign: Scalars['Boolean'];
  resetEditedProduct?: Maybe<Scalars['Boolean']>;
  resetErrorPosts: Scalars['Boolean'];
  resetPassword?: Maybe<Credentials>;
  resetSalesPoint?: Maybe<ResetSalesPointPayload>;
  revokeApiKey?: Maybe<Scalars['Boolean']>;
  sendGroupedBriefNotifications?: Maybe<Scalars['Boolean']>;
  sendPreorderNotifications?: Maybe<Scalars['Boolean']>;
  sendSharedPurchaseOrderMail?: Maybe<Scalars['Boolean']>;
  setCampaignCategoriesOrder?: Maybe<Array<Maybe<CampaignCategory>>>;
  setDefaultStoreId?: Maybe<User>;
  setHelpBlockOrder?: Maybe<Array<Maybe<HelpBlock>>>;
  setProductCategoryEnabled?: Maybe<ProductCategory>;
  setProductCategoryPosition: ProductCategory;
  setShippingFees?: Maybe<ShippingFees>;
  setTrackingNumber?: Maybe<Order>;
  ssoGoogleLogin?: Maybe<Credentials>;
  staciExportOrders?: Maybe<StaciResult>;
  staciExportProducts?: Maybe<StaciResult>;
  staciImport?: Maybe<StaciImport>;
  staciImportOrdersStates?: Maybe<StaciResult>;
  staciImportStocks?: Maybe<StaciResult>;
  stopAmplifyAd?: Maybe<Scalars['Boolean']>;
  stopAmplifyCampaign?: Maybe<Scalars['Boolean']>;
  stopPosts: Scalars['Boolean'];
  submitBriefAttachments?: Maybe<Brief>;
  submitBriefConception?: Maybe<BriefMedia>;
  submitPreorder?: Maybe<Preorder>;
  switchOrganisation?: Maybe<Credentials>;
  synchroClientPmImages?: Maybe<Scalars['Boolean']>;
  syncVirtualUserAccounts?: Maybe<Scalars['Boolean']>;
  toggleAnswerTemplateStatus?: Maybe<Scalars['Boolean']>;
  toggleCampaignEnabled?: Maybe<Campaign>;
  toggleCustomFieldDefinitionVisibility: CustomFieldDefinition;
  toggleLikeNotifications?: Maybe<BulkActionResult>;
  toggleNotificationsVisibility?: Maybe<BulkActionResult>;
  toggleProductEnabled?: Maybe<Product>;
  transitionBriefsByDate?: Maybe<Scalars['Boolean']>;
  unlinkAmplifyAccountFromSalespoint?: Maybe<Scalars['Boolean']>;
  unlinkGlobalAmplifyAccount?: Maybe<Scalars['Boolean']>;
  unlinkGlobalSocialNetworkAccount?: Maybe<Scalars['Boolean']>;
  unlinkSocialNetworkAccountFromSalespoint?: Maybe<Scalars['Boolean']>;
  updateAmplifyCampaign?: Maybe<AmplifyCampaign>;
  updateAnswerTemplate?: Maybe<AnswerTemplate>;
  updateBrief?: Maybe<Brief>;
  updateBriefAttachmentsPageLastVisit?: Maybe<Scalars['Boolean']>;
  updateBriefStatus?: Maybe<Brief>;
  updateBusinessManagerToClient?: Maybe<BusinessManager>;
  updateCampaign?: Maybe<Scalars['Boolean']>;
  updateCampaignCategory?: Maybe<CampaignCategory>;
  updateCampaignSupport?: Maybe<Media>;
  updateCampaignSupports?: Maybe<Array<Maybe<Media>>>;
  updateCartItemComment?: Maybe<Cart>;
  updateCartItemOptions?: Maybe<Cart>;
  updateCartItemQuantity?: Maybe<Cart>;
  updateCartItemsQuantitiesPerLocation?: Maybe<Cart>;
  updateCartWithProductsAvailability: CartProductsAvailabilityResult;
  updateChildProductCategory: ChildProductCategory;
  updateChiliConfig?: Maybe<ChiliConfig>;
  updateClient?: Maybe<Client>;
  updateClientPmAttributes?: Maybe<Scalars['Boolean']>;
  updateClientPmServices?: Maybe<Scalars['Boolean']>;
  updateClientShopOptions?: Maybe<Client>;
  updateCloudinaryMedia?: Maybe<CloudinaryUploadResult>;
  updateColors?: Maybe<Scalars['String']>;
  updateCustomFieldDefinition: CustomFieldDefinition;
  updateGovernance?: Maybe<Governance>;
  updateGovernanceException?: Maybe<GovernanceException>;
  updateHelpBlock?: Maybe<HelpBlock>;
  updateHomePageSettings?: Maybe<HomePageSettings>;
  updateLastConnection?: Maybe<Scalars['Boolean']>;
  updateLibraryFolder?: Maybe<Folder>;
  updateLibraryMedia?: Maybe<Media>;
  updateLibraryMedias?: Maybe<Scalars['Boolean']>;
  updateMainAccount?: Maybe<Scalars['Boolean']>;
  updateMarketingActivation?: Maybe<MarketingActivationResult>;
  updateNews?: Maybe<News>;
  updateOrdersStatus?: Maybe<Scalars['Boolean']>;
  updateOrderStatus?: Maybe<Scalars['Boolean']>;
  updateParentProductCategory: ParentProductCategory;
  updatePaymentMethod?: Maybe<PaymentMethod>;
  updatePostTemplateTag?: Maybe<PostTemplateTag>;
  updatePostTemplateTagGroup?: Maybe<PostTemplateTagGroup>;
  updateProduct?: Maybe<Scalars['Boolean']>;
  updateProductStock?: Maybe<Scalars['Boolean']>;
  updateProvider?: Maybe<Provider>;
  updateProviderUserBriefSpecClients?: Maybe<Scalars['Boolean']>;
  updateRole?: Maybe<Role>;
  updateSalesPoint?: Maybe<SalesPoint>;
  updateSalespointGroup?: Maybe<Scalars['Boolean']>;
  updateSalesPointLocations?: Maybe<Array<Maybe<SalesPoint>>>;
  updateSocialPost?: Maybe<AddSocialPostPayload>;
  updateSso?: Maybe<Sso>;
  updateStaciExport?: Maybe<StaciExport>;
  updateTag?: Maybe<Tag>;
  updateTagGroup?: Maybe<TagGroup>;
  updateUser?: Maybe<User>;
  updateVoucher?: Maybe<Voucher>;
  uploadAnswerTemplates?: Maybe<Scalars['Boolean']>;
  uploadBlacklist?: Maybe<Scalars['Boolean']>;
  uploadBriefMedia?: Maybe<Array<Maybe<BriefMedia>>>;
  uploadCustomVisuals?: Maybe<Array<Maybe<CustomVisualsUpload>>>;
  uploadLogo?: Maybe<Scalars['Boolean']>;
  uploadMilestones?: Maybe<Scalars['Boolean']>;
  uploadProviderInvoice?: Maybe<UploadProviderInvoiceResponse>;
  uploadProviderLogo?: Maybe<Scalars['Boolean']>;
  uploadToCloudinary?: Maybe<CloudinaryUploadResult>;
  upsertPreorder?: Maybe<Preorder>;
  upsertUserAmplifyBudget?: Maybe<UserAmplifyBudget>;
  validateNotificationReplies?: Maybe<BulkActionResult>;
  validateOrder?: Maybe<Scalars['Boolean']>;
  validateOrders?: Maybe<Scalars['Boolean']>;
  validatePayment?: Maybe<PaymentInfo>;
  validateSocialPost?: Maybe<Scalars['Boolean']>;
  webhookConsolidate?: Maybe<Scalars['Boolean']>;
  webhookCreate?: Maybe<Scalars['Boolean']>;
};


export type MutationAddAmplifyAccountsArgs = {
  networkReferers: Array<Scalars['String']>;
  socialNetworkUser: Scalars['Int'];
};


export type MutationAddBriefCommentArgs = {
  briefId: Scalars['ID'];
  comment: Scalars['String'];
};


export type MutationAddCartItemFilesArgs = {
  existingFileIds?: InputMaybe<Array<Scalars['ID']>>;
  files?: InputMaybe<Array<Scalars['Upload']>>;
  packId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  subId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddEditedProductToCartArgs = {
  comment?: InputMaybe<Scalars['String']>;
  documentDownloadSettingsId: Scalars['ID'];
  existingSubId?: InputMaybe<Scalars['String']>;
  packId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedFixPrice?: InputMaybe<Scalars['Int']>;
  tempFolderDocumentId: Scalars['ID'];
  type?: InputMaybe<CartType>;
};


export type MutationAddEditedProductToDraftArgs = {
  existingSubId?: InputMaybe<Scalars['String']>;
  packId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  tempFolderDocumentId: Scalars['ID'];
};


export type MutationAddFacebookAccountArgs = {
  networkReferers?: InputMaybe<Array<Scalars['String']>>;
  socialNetworkUser: Scalars['Int'];
  systemUser?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};


export type MutationAddGoogleAccountsArgs = {
  networkReferers: Array<Scalars['String']>;
  socialNetworkUser: Scalars['Int'];
};


export type MutationAddGovernanceExceptionArgs = {
  data: GovernanceExceptionInput;
  governanceId: Scalars['ID'];
};


export type MutationAddHashtagArgs = {
  name: Scalars['String'];
};


export type MutationAddItemToCartArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  item?: InputMaybe<CartItemInput>;
};


export type MutationAddLibraryMediaArgs = {
  chiliDetails?: InputMaybe<InputChiliDetails>;
  details?: InputMaybe<InputMediaDetails>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  folderLocation?: InputMaybe<Scalars['ID']>;
  isDownloadByEmail?: InputMaybe<Scalars['Boolean']>;
  isFromEditFile?: InputMaybe<Scalars['Boolean']>;
  thumbnailFile?: InputMaybe<Scalars['Upload']>;
  type: LibraryMediaType;
};


export type MutationAddLinkedinAccountsArgs = {
  networkReferers: Array<Scalars['String']>;
  socialNetworkUser: Scalars['Int'];
};


export type MutationAddMultipleItemsToCartArgs = {
  items?: InputMaybe<Array<InputMaybe<CartItemInput>>>;
};


export type MutationAddNewsArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  news: NewsInput;
};


export type MutationAddOrderMessageArgs = {
  content: Scalars['String'];
  orderId: Scalars['ID'];
};


export type MutationAddPostTemplateArgs = {
  publishArgs: PostTemplateArgs;
};


export type MutationAddProviderArgs = {
  provider: ProviderInput;
};


export type MutationAddSalesPointLocationsArgs = {
  locations: Array<LocationInput>;
  salesPointId: Scalars['ID'];
};


export type MutationAddSocialPostArgs = {
  avatar?: InputMaybe<UploadOrGalleryMediaInput>;
  carouselItems?: InputMaybe<Array<InputCarouselItem>>;
  cover?: InputMaybe<UploadOrGalleryMediaInput>;
  dynamicLink?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<InputSocialEvent>;
  isFromReadyToPost?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  medias?: InputMaybe<Array<InputMaybe<UploadOrGalleryMediaInput>>>;
  publishArgs: PublishArgs;
  thumb?: InputMaybe<UploadOrGalleryMediaInput>;
};


export type MutationAddStaciExportArgs = {
  staciExport: StaciExportInput;
};


export type MutationAddTwitterAccountArgs = {
  oauthToken: Scalars['String'];
  oauthVerifier: Scalars['String'];
  redirectURL: Scalars['String'];
};


export type MutationArchiveAllNotificationsArgs = {
  filters: NotificationFilters;
};


export type MutationArchiveBriefArgs = {
  briefId: Scalars['ID'];
  toBeArchived: Scalars['Boolean'];
};


export type MutationArchiveNotificationsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationAssignRoleArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  roleId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAssignVoucherToCartArgs = {
  voucherCode: Scalars['String'];
};


export type MutationAssociateUsersToSalesPointArgs = {
  salesPoint: Scalars['ID'];
  users: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationAssociateUserToSalesPointGroupsArgs = {
  groupIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationAssociateUserToSalesPointsArgs = {
  absolute?: InputMaybe<Scalars['Boolean']>;
  salesPoints: Array<InputMaybe<Scalars['ID']>>;
  userId: Scalars['ID'];
};


export type MutationBulkAddCartItemsArgs = {
  items?: InputMaybe<Array<InputMaybe<CartItemInput>>>;
};


export type MutationBulkRemoveCartItemsArgs = {
  items?: InputMaybe<Array<InputMaybe<CartItemToDelete>>>;
};


export type MutationCancelOrderByProviderArgs = {
  orderId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationCancelPreorderArgs = {
  id: Scalars['ID'];
};


export type MutationCancelProductsImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCancelSalespointGroupsImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCancelSalesPointsImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCancelUserAmplifyBudgetImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCancelUsersImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationChangeEmailArgs = {
  id: Scalars['ID'];
  newEmail?: InputMaybe<Scalars['String']>;
};


export type MutationChangePasswordArgs = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationCommitOrderPaymentArgs = {
  orderIds: Array<Scalars['ID']>;
  stripePaymentMethod?: InputMaybe<StripePaymentMethod>;
};


export type MutationCommitProductsImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCommitSalespointGroupsImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCommitSalesPointsImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCommitUserAmplifyBudgetImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationCommitUsersImportJobArgs = {
  jobId: Scalars['ID'];
};


export type MutationConnectUserToFacebookArgs = {
  accountType: Scalars['String'];
  code: Scalars['String'];
  redirectURL: Scalars['String'];
};


export type MutationConnectUserToGoogleArgs = {
  accountType: Scalars['String'];
  code: Scalars['String'];
  redirectURL: Scalars['String'];
};


export type MutationConnectUserToLinkedinArgs = {
  accountType: Scalars['String'];
  code: Scalars['String'];
  redirectURL: Scalars['String'];
  state: Scalars['String'];
};


export type MutationConnectUserToTwitterArgs = {
  accountType: Scalars['String'];
  oauthToken: Scalars['String'];
  oauthVerifier: Scalars['String'];
  redirectURL: Scalars['String'];
};


export type MutationConsolidatePostArgs = {
  publishId: Scalars['ID'];
};


export type MutationCreateAmplifyCampaignArgs = {
  campaign: InputAmplifyCampaign;
  postCalendarId: Scalars['ID'];
};


export type MutationCreateAnswerTemplateArgs = {
  answerTemplate: AnswerTemplateInput;
};


export type MutationCreateBriefArgs = {
  brief: InputBrief;
  createDraft: Scalars['Boolean'];
};


export type MutationCreateCampaignArgs = {
  campaign: CampaignInput;
  campaignFile?: InputMaybe<Scalars['Upload']>;
  image?: InputMaybe<Scalars['Upload']>;
  supports?: InputMaybe<Array<InputMaybe<CampaignSupportCreationInput>>>;
  type?: InputMaybe<CampaignType>;
};


export type MutationCreateCampaignCategoryArgs = {
  category: CampaignCategoryInput;
  type?: InputMaybe<CampaignType>;
};


export type MutationCreateChildProductCategoryArgs = {
  input: ChildProductCategoryInput;
  newImage?: InputMaybe<Scalars['Upload']>;
};


export type MutationCreateClientArgs = {
  client: ClientInfo;
};


export type MutationCreateCustomFieldDefinitionArgs = {
  input: CreateCustomFieldDefinitionInput;
};


export type MutationCreateEventArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  extra?: InputMaybe<Scalars['String']>;
  moduleType?: InputMaybe<EventModuleType>;
  salespointIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  subType?: InputMaybe<EventSubType>;
  type: CreatableEventType;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateHelpBlockArgs = {
  create: HelpBlockInput;
  lang: AvailableLang;
};


export type MutationCreateInstantPurchaseOrderArgs = {
  productId: Scalars['ID'];
  productOptionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationCreateJiraIssueArgs = {
  currentUrl?: InputMaybe<Scalars['String']>;
  devlog?: InputMaybe<Scalars['String']>;
  sentryEnv?: InputMaybe<Scalars['String']>;
  sentryEventId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateLibraryFolderArgs = {
  folder: FolderInput;
};


export type MutationCreateMarketingActivationArgs = {
  activation: MarketingActivationInput;
  target: MarketingActivationTargetType;
  token: Scalars['String'];
};


export type MutationCreateMultipleBriefsArgs = {
  briefs: Array<InputBrief>;
  createDrafts: Scalars['Boolean'];
};


export type MutationCreateOrderFromCartArgs = {
  addresses?: InputMaybe<AddressesInput>;
  billingLocationId?: InputMaybe<Scalars['ID']>;
  eskerNumbers?: InputMaybe<Scalars['JSON']>;
  stripePaymentMethod?: InputMaybe<OrderPaymentMethodStripe>;
};


export type MutationCreateParentProductCategoryArgs = {
  input: ParentProductCategoryInput;
};


export type MutationCreatePaymentMethodArgs = {
  paymentMethod: PaymentMethodInput;
};


export type MutationCreatePdfThumbnailArgs = {
  file: Scalars['Upload'];
};


export type MutationCreatePostTemplateTagArgs = {
  tag: PostTemplateTagInput;
};


export type MutationCreatePostTemplateTagGroupArgs = {
  tagGroup: PostTemplateTagGroupInput;
};


export type MutationCreateProductArgs = {
  duplicateProductInfos?: InputMaybe<InputDuplicateInfos>;
  highQualityAsset?: InputMaybe<Scalars['Upload']>;
  images?: InputMaybe<Array<InputMaybe<ImageInput>>>;
  lowQualityAsset?: InputMaybe<Scalars['Upload']>;
  product: InputProduct;
  tempLowQualityAsset?: InputMaybe<TempFileInput>;
};


export type MutationCreatePromptBriefArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  textInput: Scalars['String'];
};


export type MutationCreateRoleArgs = {
  role: CreateRoleInput;
};


export type MutationCreateSalesPointArgs = {
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  salesPoint: SalesPointInput;
  socialConfig?: InputMaybe<SocialSalespointConfigInput>;
};


export type MutationCreateSalespointGroupArgs = {
  salespointGroup: SalespointGroupInput;
};


export type MutationCreateSecretKeyArgs = {
  secret: Scalars['String'];
};


export type MutationCreateSsoArgs = {
  sso: SsoInput;
};


export type MutationCreateTagArgs = {
  tag: TagInputCreation;
};


export type MutationCreateTagGroupArgs = {
  tagGroup: TagGroupInputCreation;
};


export type MutationCreateUserArgs = {
  user: UserInput;
};


export type MutationCreateUserImmediatelyArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  user: UserToCreateInput;
};


export type MutationCreateVoucherArgs = {
  voucher: VoucherInput;
};


export type MutationDeleteAmplifyAccountsArgs = {
  accountIds: Array<Scalars['ID']>;
};


export type MutationDeleteAnswerTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBriefArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBriefMediaArgs = {
  mediaIds: Array<Scalars['ID']>;
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCampaignCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCartItemFileArgs = {
  fileId: Scalars['ID'];
};


export type MutationDeleteCustomVisualArgs = {
  filenames: Array<InputMaybe<Scalars['String']>>;
  salesPointId: Scalars['ID'];
};


export type MutationDeleteGovernanceExceptionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteHashtagArgs = {
  name: Scalars['String'];
};


export type MutationDeleteHelpBlockArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLibraryFolderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLibraryMediaArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLibraryMediasArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDeleteNewsArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePastSpecialOpeningHoursArgs = {
  clientId?: InputMaybe<Scalars['String']>;
};


export type MutationDeletePaymentMethodArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePostTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePostTemplateTagArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePostTemplateTagGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProviderArgs = {
  providerId: Scalars['ID'];
};


export type MutationDeleteRoleArgs = {
  fallbackRoleId: Scalars['ID'];
  roleId: Scalars['ID'];
};


export type MutationDeleteSalespointGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSalesPointImagesArgs = {
  imageIds: Array<InputMaybe<Scalars['ID']>>;
  salesPointId: Scalars['ID'];
};


export type MutationDeleteSalesPointLocationsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationDeleteShippingFeesArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSocialNetworkAccountsArgs = {
  accountIds: Array<Scalars['ID']>;
  socialNetwork: SocialNetwork;
};


export type MutationDeleteSocialPostArgs = {
  publishId: Scalars['ID'];
};


export type MutationDeleteStaciExportArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTagGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
  providerId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteVoucherArgs = {
  id: Scalars['ID'];
};


export type MutationDisconnectUserFromFacebookArgs = {
  socialNetworkUser: Scalars['Int'];
};


export type MutationDisconnectUserFromGoogleArgs = {
  socialNetworkUser: Scalars['Int'];
};


export type MutationDisconnectUserFromLinkedinArgs = {
  socialNetworkUser: Scalars['Int'];
};


export type MutationDisconnectUserFromTwitterArgs = {
  socialNetworkUser: Scalars['Int'];
};


export type MutationDissociateUserFromSalesPointGroupsArgs = {
  groupIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationDissociateUserFromSalesPointsArgs = {
  salesPoints: Array<InputMaybe<Scalars['ID']>>;
  userId: Scalars['ID'];
};


export type MutationDissociateUsersFromSalesPointArgs = {
  salesPoint: Scalars['ID'];
  users: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationDownloadLibraryMediasArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationDownloadSalesPointImagesArgs = {
  salesPointId: Scalars['ID'];
};


export type MutationDuplicateCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type MutationDuplicateMediasArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationEditPostTemplateArgs = {
  publishArgs: PostTemplateArgs;
  templateId: Scalars['ID'];
};


export type MutationExportBriefsArgs = {
  filter?: InputMaybe<BriefsFilter>;
  format?: InputMaybe<BriefExportType>;
};


export type MutationExportBriefSpecClientsArgs = {
  clientId: Scalars['String'];
};


export type MutationExportCampaignPreordersArgs = {
  campaignId: Scalars['ID'];
  format?: InputMaybe<UploadFormat>;
};


export type MutationExportEngagementMetricsArgs = {
  filter?: InputMaybe<PlatformMetricsFilter>;
  groupBy: ExportEngagementType;
};


export type MutationExportMetricsArrayArgs = {
  dateRange?: InputMaybe<DateRange>;
  exportArgsJSON?: InputMaybe<Scalars['String']>;
  exportType: ExportTypes;
  format?: InputMaybe<UploadFormat>;
};


export type MutationExportOrdersArgs = {
  end: Scalars['Date'];
  filter?: InputMaybe<OrderFilter>;
  format?: InputMaybe<UploadFormat>;
  groupId?: InputMaybe<Scalars['ID']>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  start: Scalars['Date'];
  type: OrderExportType;
};


export type MutationExportPreordersArgs = {
  filter?: InputMaybe<PreorderFilter>;
  format?: InputMaybe<UploadFormat>;
  groupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationExportPresenceManagementArgs = {
  all: Scalars['Boolean'];
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};


export type MutationExportProductsArgs = {
  filters?: InputMaybe<Array<InputMaybe<ProductFilterInput>>>;
  format?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductSort>;
};


export type MutationExportSalespointGroupsArgs = {
  salesPointIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationExportSalesPointsByFeaturesArgs = {
  uploadFormat?: InputMaybe<UploadFormat>;
};


export type MutationExportStoresArgs = {
  filter?: InputMaybe<SalesPointFilter>;
  format?: InputMaybe<ExportType>;
};


export type MutationExportUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  format?: InputMaybe<ExportType>;
};


export type MutationForceSuperAdminRoleArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  roleSlug: Scalars['String'];
};


export type MutationGeneratePaidMediaCampaignsArgs = {
  file: Scalars['Upload'];
};


export type MutationGeneratePdfDownloadLinkArgs = {
  documentDownloadSettingsId?: InputMaybe<Scalars['String']>;
  documentId: Scalars['String'];
  documentViewPrefsId?: InputMaybe<Scalars['String']>;
  documentWorkspaceId?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateProductDownloadLinkArgs = {
  exportId?: InputMaybe<Scalars['String']>;
  isMedia?: InputMaybe<Scalars['Boolean']>;
  packId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  subId?: InputMaybe<Scalars['String']>;
};


export type MutationGetCustomVisualZipArgs = {
  assets: Array<InputMaybe<FileInfoInput>>;
  salesPointId: Scalars['ID'];
};


export type MutationGetMediaDownloadLinkArgs = {
  id: Scalars['ID'];
  singleUse?: Scalars['Boolean'];
};


export type MutationImportAmplifyUsersBudgetArgs = {
  file: Scalars['Upload'];
};


export type MutationImportBriefTechnicalSpecificationsArgs = {
  clientId: Scalars['String'];
  file: Scalars['Upload'];
};


export type MutationImportProductsArgs = {
  file: Scalars['Upload'];
};


export type MutationImportSalespointGroupsArgs = {
  csvFile: Scalars['Upload'];
};


export type MutationImportSalesPointsArgs = {
  file: Scalars['Upload'];
};


export type MutationImportUsersArgs = {
  file: Scalars['Upload'];
};


export type MutationInsertGooglePmStatsArgs = {
  stats: Array<GooglePmStatsInput>;
};


export type MutationInviteProviderArgs = {
  email: Scalars['String'];
  languagePreference?: InputMaybe<PlatformLanguageOption>;
  loginMode: LoginMode;
  providerId?: InputMaybe<Scalars['ID']>;
  roleId: Scalars['ID'];
  salesPointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationInviteUserArgs = {
  email: Scalars['String'];
  languagePreference?: InputMaybe<PlatformLanguageOption>;
  loginMode: LoginMode;
  roleId: Scalars['ID'];
  salespoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationLaunchSocialCronArgs = {
  path: Scalars['String'];
};


export type MutationLinkAmplifyAccountToSalespointArgs = {
  accountId: Scalars['ID'];
  salesPointId: Scalars['ID'];
};


export type MutationLinkGlobalAmplifyAccountArgs = {
  accountId: Scalars['ID'];
  label: Scalars['String'];
};


export type MutationLinkGlobalSocialNetworkAccountArgs = {
  accountId: Scalars['ID'];
  label: Scalars['String'];
  socialNetwork: SocialNetwork;
};


export type MutationLinkSocialNetworkAccountToSalespointArgs = {
  accountId: Scalars['ID'];
  salesPointId: Scalars['ID'];
  socialNetwork: SocialNetwork;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginHyperSsoArgs = {
  token: Scalars['String'];
};


export type MutationMarkAllErrorPostsAsDoneArgs = {
  publishId: Scalars['ID'];
};


export type MutationMarkErrorPostsAsDoneArgs = {
  postIds: Array<Scalars['ID']>;
  publishId: Scalars['ID'];
};


export type MutationMarkNewsAsPresentedArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationMoveLibraryFolderArgs = {
  id: Scalars['ID'];
  targetFolder?: InputMaybe<Scalars['ID']>;
};


export type MutationMoveLibraryMediaArgs = {
  id: Scalars['ID'];
  targetFolder?: InputMaybe<Scalars['ID']>;
};


export type MutationMoveLibraryMediasArgs = {
  ids: Array<Scalars['ID']>;
  targetFolder?: InputMaybe<Scalars['ID']>;
};


export type MutationOvSyncR2SpsWithApigeeArgs = {
  moveFileToArchives?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOvSyncR2SpsWithR1Args = {
  moveFileToArchives?: InputMaybe<Scalars['Boolean']>;
};


export type MutationOvSyncSpWithApigeeArgs = {
  addCurrentUser?: InputMaybe<Scalars['Boolean']>;
  affairCode: Scalars['String'];
};


export type MutationProcessCloudinaryEditArgs = {
  editedImageUrl: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
  originalPublicId?: InputMaybe<Scalars['String']>;
};


export type MutationRefreshFacebookAccountsArgs = {
  accountIds: Array<Scalars['ID']>;
};


export type MutationRefreshOrdersArchivesArgs = {
  ordersNumbers: Array<Scalars['String']>;
};


export type MutationRemoveVoucherFromCartArgs = {
  voucherId: Scalars['ID'];
};


export type MutationReplaceFileValidationOrdersArgs = {
  file: Scalars['Upload'];
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  subId?: InputMaybe<Scalars['ID']>;
};


export type MutationReplyToNotificationsArgs = {
  message: Scalars['String'];
  notificationsIds: Array<Scalars['ID']>;
  replyAll?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRequestResetArgs = {
  email: Scalars['String'];
};


export type MutationResendUserInvitationArgs = {
  providerId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationResendUserInvitationsArgs = {
  clientId: Scalars['ID'];
};


export type MutationResetCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationResetEditedProductArgs = {
  existingSubId?: InputMaybe<Scalars['ID']>;
  isMedia?: InputMaybe<Scalars['Boolean']>;
  packId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
};


export type MutationResetErrorPostsArgs = {
  publishId: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String'];
  token: Scalars['String'];
};


export type MutationResetSalesPointArgs = {
  args: ResetSalesPointArgs;
};


export type MutationRevokeApiKeyArgs = {
  apiKey: Scalars['String'];
};


export type MutationSendSharedPurchaseOrderMailArgs = {
  orderId: Scalars['ID'];
  sharedMail: Scalars['String'];
};


export type MutationSetCampaignCategoriesOrderArgs = {
  categoriesOrder: Array<CampaignCategoriesOrderInput>;
};


export type MutationSetDefaultStoreIdArgs = {
  defaultStoreId?: InputMaybe<Scalars['String']>;
};


export type MutationSetHelpBlockOrderArgs = {
  updates: Array<HelpBlockOrder>;
};


export type MutationSetProductCategoryEnabledArgs = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationSetProductCategoryPositionArgs = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};


export type MutationSetShippingFeesArgs = {
  shippingFees: ShippingFeesInput;
};


export type MutationSetTrackingNumberArgs = {
  carrierName: Carrier;
  orderId: Scalars['ID'];
  trackingNumber: Scalars['String'];
};


export type MutationSsoGoogleLoginArgs = {
  googleToken: Scalars['String'];
};


export type MutationStaciExportOrdersArgs = {
  fromDate?: InputMaybe<Scalars['Date']>;
  staciExportSlug: Scalars['String'];
  toDate?: InputMaybe<Scalars['Date']>;
};


export type MutationStaciExportProductsArgs = {
  fromDate?: InputMaybe<Scalars['Date']>;
  staciExportSlug: Scalars['String'];
  toDate?: InputMaybe<Scalars['Date']>;
};


export type MutationStaciImportArgs = {
  providerSlug: Scalars['String'];
  type: StaciImportType;
};


export type MutationStaciImportOrdersStatesArgs = {
  staciExportSlug: Scalars['String'];
};


export type MutationStaciImportStocksArgs = {
  staciExportSlug: Scalars['String'];
};


export type MutationStopAmplifyAdArgs = {
  adId: Scalars['ID'];
  campaignId: Scalars['ID'];
};


export type MutationStopAmplifyCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationStopPostsArgs = {
  publishId: Scalars['ID'];
};


export type MutationSubmitBriefAttachmentsArgs = {
  attachments: Array<InputMaybe<Scalars['ID']>>;
  briefId: Scalars['ID'];
  quoteOptions?: InputMaybe<InputBriefQuoteOptions>;
  sendNotificationMail?: InputMaybe<Scalars['Boolean']>;
  tag?: InputBriefMediaTag;
};


export type MutationSubmitBriefConceptionArgs = {
  api: BriefApi;
  briefId: Scalars['ID'];
  mediaId: Scalars['ID'];
};


export type MutationSubmitPreorderArgs = {
  id: Scalars['ID'];
};


export type MutationSwitchOrganisationArgs = {
  clientId: Scalars['String'];
};


export type MutationSynchroClientPmImagesArgs = {
  slugClient: Scalars['String'];
};


export type MutationSyncVirtualUserAccountsArgs = {
  clientId: Scalars['String'];
};


export type MutationToggleAnswerTemplateStatusArgs = {
  id: Scalars['ID'];
};


export type MutationToggleCampaignEnabledArgs = {
  id: Scalars['ID'];
};


export type MutationToggleCustomFieldDefinitionVisibilityArgs = {
  id: Scalars['ID'];
};


export type MutationToggleLikeNotificationsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationToggleNotificationsVisibilityArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<Array<InputMaybe<InputNotification>>>;
};


export type MutationToggleProductEnabledArgs = {
  id: Scalars['ID'];
};


export type MutationUnlinkAmplifyAccountFromSalespointArgs = {
  salesPointId: Scalars['ID'];
};


export type MutationUnlinkGlobalAmplifyAccountArgs = {
  label: Scalars['String'];
};


export type MutationUnlinkGlobalSocialNetworkAccountArgs = {
  label: Scalars['String'];
  socialNetwork: SocialNetwork;
};


export type MutationUnlinkSocialNetworkAccountFromSalespointArgs = {
  salesPointId: Scalars['ID'];
  socialNetwork: SocialNetwork;
};


export type MutationUpdateAmplifyCampaignArgs = {
  campaign: InputAmplifyCampaign;
  campaignId: Scalars['ID'];
};


export type MutationUpdateAnswerTemplateArgs = {
  id: Scalars['ID'];
  updates: AnswerTemplateUpdateInput;
};


export type MutationUpdateBriefArgs = {
  brief: InputBrief;
  editDraft: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationUpdateBriefStatusArgs = {
  briefId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  status: BriefStatus;
};


export type MutationUpdateBusinessManagerToClientArgs = {
  businessManagerId: Scalars['String'];
  clientId: Scalars['String'];
};


export type MutationUpdateCampaignArgs = {
  campaignFile?: InputMaybe<Scalars['Upload']>;
  deleteFile?: InputMaybe<Scalars['Boolean']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Upload']>;
  supports?: InputMaybe<Array<InputMaybe<CampaignSupportCreationInput>>>;
  updates: CampaignInput;
};


export type MutationUpdateCampaignCategoryArgs = {
  id: Scalars['ID'];
  updates: CampaignCategoryUpdateInput;
};


export type MutationUpdateCampaignSupportArgs = {
  deleteThumbnail?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  update?: InputMaybe<CampaignSupportUpdate>;
};


export type MutationUpdateCampaignSupportsArgs = {
  updates: Array<CampaignSupportUpdates>;
};


export type MutationUpdateCartItemCommentArgs = {
  comment?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
};


export type MutationUpdateCartItemOptionsArgs = {
  item: CartItemOptionsInput;
};


export type MutationUpdateCartItemQuantityArgs = {
  item?: InputMaybe<CartItemInput>;
};


export type MutationUpdateCartItemsQuantitiesPerLocationArgs = {
  items: Array<ItemQuantitiesPerLocationInput>;
};


export type MutationUpdateChildProductCategoryArgs = {
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  input: ChildProductCategoryInput;
  newImage?: InputMaybe<Scalars['Upload']>;
};


export type MutationUpdateChiliConfigArgs = {
  config: ChiliConfigInput;
};


export type MutationUpdateClientArgs = {
  client: ClientInfo;
  id: Scalars['ID'];
};


export type MutationUpdateClientPmAttributesArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateClientPmServicesArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateClientShopOptionsArgs = {
  shopOptions: ShopOptionsInput;
};


export type MutationUpdateCloudinaryMediaArgs = {
  newPublicId?: InputMaybe<Scalars['String']>;
  publicId: Scalars['String'];
  transformations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationUpdateColorsArgs = {
  primaryHex: Scalars['String'];
};


export type MutationUpdateCustomFieldDefinitionArgs = {
  id: Scalars['ID'];
  input: UpdateCustomFieldDefinitionInput;
};


export type MutationUpdateGovernanceArgs = {
  data: GovernanceInput;
  id: Scalars['ID'];
};


export type MutationUpdateGovernanceExceptionArgs = {
  data: GovernanceExceptionInput;
  id: Scalars['ID'];
};


export type MutationUpdateHelpBlockArgs = {
  id: Scalars['ID'];
  update: HelpBlockInput;
};


export type MutationUpdateHomePageSettingsArgs = {
  data: HomePageSettingsInput;
  id: Scalars['ID'];
};


export type MutationUpdateLibraryFolderArgs = {
  id: Scalars['ID'];
  updates: UpdateFolderInput;
};


export type MutationUpdateLibraryMediaArgs = {
  chiliDetails?: InputMaybe<UpdateChiliDetails>;
  deleteThumbnail?: InputMaybe<Scalars['Boolean']>;
  details?: InputMaybe<UpdateMediaDetails>;
  file?: InputMaybe<Scalars['Upload']>;
  folderLocation?: InputMaybe<Scalars['ID']>;
  isDownloadByEmail?: InputMaybe<Scalars['Boolean']>;
  mediaId: Scalars['ID'];
  thumbnailFile?: InputMaybe<Scalars['Upload']>;
  type?: InputMaybe<LibraryMediaType>;
};


export type MutationUpdateLibraryMediasArgs = {
  mediaIds: Array<Scalars['ID']>;
  updates: BulkUpdateMediaInput;
};


export type MutationUpdateMainAccountArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateMarketingActivationArgs = {
  activation: MarketingActivationInput;
  token: Scalars['String'];
};


export type MutationUpdateNewsArgs = {
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  newImage?: InputMaybe<Scalars['Upload']>;
  news: NewsInput;
};


export type MutationUpdateOrdersStatusArgs = {
  orderIds: Array<Scalars['ID']>;
  orderStatus: Status;
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrderStatusArgs = {
  orderId: Scalars['ID'];
  orderStatus: Status;
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateParentProductCategoryArgs = {
  id: Scalars['ID'];
  input: ParentProductCategoryInput;
};


export type MutationUpdatePaymentMethodArgs = {
  id: Scalars['ID'];
  paymentMethod: PaymentMethodInput;
};


export type MutationUpdatePostTemplateTagArgs = {
  id: Scalars['ID'];
  updates: PostTemplateTagInput;
};


export type MutationUpdatePostTemplateTagGroupArgs = {
  id: Scalars['ID'];
  updates: PostTemplateTagGroupInput;
};


export type MutationUpdateProductArgs = {
  deleteHighQualityAsset?: InputMaybe<Scalars['Boolean']>;
  deleteLowQualityAsset?: InputMaybe<Scalars['Boolean']>;
  deleteOptionsAssets?: InputMaybe<Array<InputMaybe<InputDeleteOptionsAssets>>>;
  highQualityAsset?: InputMaybe<Scalars['Upload']>;
  id?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Array<InputMaybe<ImageInput>>>;
  lowQualityAsset?: InputMaybe<Scalars['Upload']>;
  tempLowQualityAsset?: InputMaybe<TempFileInput>;
  updates: InputProduct;
};


export type MutationUpdateProductStockArgs = {
  productRef: Scalars['String'];
  stock: Scalars['Int'];
};


export type MutationUpdateProviderArgs = {
  providerId: Scalars['ID'];
  providerToUpdate?: InputMaybe<ProviderUpdateInput>;
};


export type MutationUpdateProviderUserBriefSpecClientsArgs = {
  key: Scalars['String'];
  specClientIds: Array<Scalars['ID']>;
  userId: Scalars['String'];
};


export type MutationUpdateRoleArgs = {
  role: UpdateRoleInput;
  roleId: Scalars['ID'];
};


export type MutationUpdateSalesPointArgs = {
  id: Scalars['ID'];
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  onlyStatus?: InputMaybe<Scalars['Boolean']>;
  salesPoint: SalesPointUpdateInput;
  socialConfig?: InputMaybe<SocialSalespointConfigInput>;
};


export type MutationUpdateSalespointGroupArgs = {
  id: Scalars['ID'];
  updates: SalespointGroupInput;
};


export type MutationUpdateSalesPointLocationsArgs = {
  updates: Array<LocationUpdate>;
};


export type MutationUpdateSocialPostArgs = {
  avatar?: InputMaybe<UploadOrGalleryMediaInput>;
  carouselItems?: InputMaybe<Array<InputCarouselItem>>;
  cover?: InputMaybe<UploadOrGalleryMediaInput>;
  dynamicLink?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<InputSocialEvent>;
  link?: InputMaybe<Scalars['String']>;
  medias?: InputMaybe<Array<InputMaybe<UploadOrGalleryMediaInput>>>;
  publishArgs: PublishArgs;
  publishId: Scalars['ID'];
  thumb?: InputMaybe<UploadOrGalleryMediaInput>;
  toValidate?: InputMaybe<PublishValidateVideo>;
};


export type MutationUpdateSsoArgs = {
  id: Scalars['ID'];
  sso: SsoInput;
};


export type MutationUpdateStaciExportArgs = {
  id: Scalars['ID'];
  staciExport: StaciExportInput;
};


export type MutationUpdateTagArgs = {
  id: Scalars['ID'];
  updates: TagInput;
};


export type MutationUpdateTagGroupArgs = {
  id: Scalars['ID'];
  updates: TagGroupInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  updates: UserUpdate;
};


export type MutationUpdateVoucherArgs = {
  id: Scalars['ID'];
  voucher: VoucherInput;
};


export type MutationUploadAnswerTemplatesArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadBlacklistArgs = {
  file?: InputMaybe<Scalars['Upload']>;
};


export type MutationUploadBriefMediaArgs = {
  files?: InputMaybe<Array<Scalars['Upload']>>;
  urls?: InputMaybe<Array<InputMediaUrl>>;
};


export type MutationUploadCustomVisualsArgs = {
  assets: Array<InputMaybe<Scalars['Upload']>>;
  salesPointId: Scalars['ID'];
};


export type MutationUploadLogoArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadMilestonesArgs = {
  file?: InputMaybe<Scalars['Upload']>;
};


export type MutationUploadProviderInvoiceArgs = {
  file: Scalars['Upload'];
  fileName: Scalars['String'];
  orderId: Scalars['String'];
};


export type MutationUploadProviderLogoArgs = {
  file: Scalars['Upload'];
  providerSlug: Scalars['String'];
};


export type MutationUploadToCloudinaryArgs = {
  file: Scalars['Upload'];
  folder?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['String']>;
  temporary?: InputMaybe<Scalars['Boolean']>;
  transformation?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertPreorderArgs = {
  input: PreorderInput;
};


export type MutationUpsertUserAmplifyBudgetArgs = {
  budgetIsLimited: Scalars['Boolean'];
  datesAreLimited: Scalars['Boolean'];
  endDate?: InputMaybe<Scalars['Date']>;
  granted?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  userId: Scalars['ID'];
};


export type MutationValidateNotificationRepliesArgs = {
  action?: InputMaybe<NotificationReplyStatus>;
  notificationId: Scalars['ID'];
  repliesIds: Array<Scalars['ID']>;
};


export type MutationValidateOrderArgs = {
  action: Scalars['String'];
  orderId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationValidateOrdersArgs = {
  action: Scalars['String'];
  orderIds: Array<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationValidatePaymentArgs = {
  balanceTransactionId: Scalars['ID'];
  chargeId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
  paymentIntentId: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationValidateSocialPostArgs = {
  action: ValidationActions;
  comment?: InputMaybe<Scalars['String']>;
  publishId: Scalars['ID'];
};


export type MutationWebhookConsolidateArgs = {
  id: Scalars['ID'];
};


export type MutationWebhookCreateArgs = {
  id: Scalars['ID'];
};

export type NbItemsToValidate = {
  __typename?: 'NbItemsToValidate';
  items?: Maybe<ItemsToValidate>;
  total?: Maybe<Scalars['Int']>;
};

export type News = {
  __typename?: 'News';
  contents: Array<NewsContent>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  recipient: NewsRecipient;
  releasedAt: Scalars['Date'];
};

export type NewsContent = {
  __typename?: 'NewsContent';
  cta: NewsContentCta;
  description: Scalars['String'];
  lang: AvailableLangs;
  title: Scalars['String'];
};

export type NewsContentCta = {
  __typename?: 'NewsContentCta';
  link: Scalars['String'];
  text: Scalars['String'];
};

export type NewsContentCtaInput = {
  link: Scalars['String'];
  text: Scalars['String'];
};

export type NewsContentInput = {
  cta: NewsContentCtaInput;
  description: Scalars['String'];
  lang: AvailableLangs;
  title: Scalars['String'];
};

export type NewsInput = {
  contents?: InputMaybe<Array<InputMaybe<NewsContentInput>>>;
  recipient?: InputMaybe<NewsRecipientInput>;
};

export type NewsRecipient = {
  __typename?: 'NewsRecipient';
  features: Array<Features>;
  roles: Array<NewsRecipientRoles>;
};

export type NewsRecipientInput = {
  features: Array<Features>;
  roles: Array<NewsRecipientRoles>;
};

export enum NewsRecipientRoles {
  Admin = 'admin',
  Local = 'local',
  National = 'national'
}

export type Notification = {
  __typename?: 'Notification';
  author?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  isAlert?: Maybe<Scalars['Boolean']>;
  isAnswered?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isLiked?: Maybe<Scalars['Boolean']>;
  isPendingApproval?: Maybe<Scalars['Boolean']>;
  isRead?: Maybe<Scalars['Boolean']>;
  isUpdated?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  notificationId?: Maybe<Scalars['ID']>;
  picture?: Maybe<Scalars['String']>;
  postId?: Maybe<Scalars['ID']>;
  rating?: Maybe<Scalars['Int']>;
  recommandation?: Maybe<Scalars['String']>;
  salesPointTargeted?: Maybe<SalesPoint>;
  socialNetwork?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
};

export type NotificationDetails = {
  __typename?: 'NotificationDetails';
  notification?: Maybe<Notification>;
  post?: Maybe<SocialMediaPost>;
  replies?: Maybe<Array<Maybe<NotificationReply>>>;
};

export type NotificationFilters = {
  alert?: InputMaybe<Scalars['Boolean']>;
  clusters?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  comment?: InputMaybe<Scalars['Boolean']>;
  direction?: InputMaybe<Direction>;
  endAt?: InputMaybe<Scalars['Date']>;
  globals?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<NotificationSortCriteria>;
  rating?: InputMaybe<Scalars['Boolean']>;
  read?: InputMaybe<Scalars['Boolean']>;
  salesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  socialNetwork: SocialNetwork;
  startAt?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['Boolean']>;
  target?: TargetType;
};

export type NotificationList = {
  __typename?: 'NotificationList';
  count?: Maybe<Scalars['Int']>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  pageInfos?: Maybe<PageInfos>;
  success?: Maybe<Scalars['Boolean']>;
};

export type NotificationReply = {
  __typename?: 'NotificationReply';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Date']>;
  type?: Maybe<Scalars['String']>;
  validationDate?: Maybe<Scalars['Date']>;
  validator?: Maybe<User>;
  validatorRole?: Maybe<ValidatorRole>;
};

export enum NotificationReplyStatus {
  All = 'all',
  AwaitingValidation = 'awaiting_validation',
  Rejected = 'rejected',
  Validate = 'validate'
}

export enum NotificationSortCriteria {
  Author = 'author',
  Date = 'date',
  Type = 'type'
}

export enum NotificationsTypes {
  All = 'all',
  Comment = 'comment',
  Post = 'post',
  Rating = 'rating',
  Review = 'review'
}

export type NumberCustomFieldConfig = {
  __typename?: 'NumberCustomFieldConfig';
  precision: Scalars['Int'];
};

export type NumberCustomFieldConfigInput = {
  precision: Scalars['Int'];
};

export enum OnboardingStatus {
  Done = 'done',
  NotStarted = 'not_started',
  Pending = 'pending'
}

export type Opening = {
  __typename?: 'Opening';
  day?: Maybe<Scalars['Int']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  sessions?: Maybe<Array<Maybe<Session>>>;
};

export type OpeningInput = {
  day?: InputMaybe<Scalars['Int']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  sessions?: InputMaybe<Array<InputMaybe<SessionInput>>>;
};

export type Order = {
  __typename?: 'Order';
  addresses: Addresses;
  affairCode?: Maybe<Scalars['String']>;
  author?: Maybe<User>;
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']>;
  date: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  eskerNumber?: Maybe<Scalars['String']>;
  fees?: Maybe<Array<Maybe<Fees>>>;
  governanceTrigger?: Maybe<GovernanceMode>;
  hasArchive?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isMultiProvider?: Maybe<Scalars['Boolean']>;
  isPurchaseOrder?: Maybe<Scalars['Boolean']>;
  isValidator?: Maybe<Scalars['Boolean']>;
  items: Array<Maybe<OrderItem>>;
  messages?: Maybe<Array<OrderMessage>>;
  orderNumber: Scalars['String'];
  paidMedia?: Maybe<PaidMediaCampaignLite>;
  parentOrderId?: Maybe<Scalars['ID']>;
  parentOrderNumber?: Maybe<Scalars['String']>;
  paymentDocumentUrl?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['ID']>;
  providerInvoice?: Maybe<ProviderInvoice>;
  purchaseOrderUrl?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  receipt?: Maybe<Scalars['String']>;
  roleValidator?: Maybe<RoleValidator>;
  salespoint?: Maybe<SalesPoint>;
  salespointId?: Maybe<Scalars['ID']>;
  shippingFees?: Maybe<Scalars['Int']>;
  sisterOrderCount?: Maybe<Scalars['Int']>;
  status: Status;
  supportsUrl?: Maybe<Scalars['String']>;
  total?: Maybe<Price>;
  totalProductsQuantity: Scalars['Int'];
  totalWithFees?: Maybe<Price>;
  totalWithShippingFees?: Maybe<Price>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingURL?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  validationDate?: Maybe<Scalars['Date']>;
  validator?: Maybe<User>;
  variationByQuantity?: Maybe<Array<Maybe<QuantityVariation>>>;
  vouchers?: Maybe<Array<Maybe<OrderVoucher>>>;
};

export type Order_ProductsPerformancePerOrder = {
  __typename?: 'Order_ProductsPerformancePerOrder';
  caHT?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  isCustomizable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  quantityOrdered?: Maybe<Scalars['Int']>;
  ref?: Maybe<Scalars['String']>;
};

export type Order_ProductsPerformancePerOrderPagination = {
  __typename?: 'Order_ProductsPerformancePerOrderPagination';
  count?: Maybe<Scalars['Int']>;
  productsPerformancePerOrder?: Maybe<Array<Maybe<Order_ProductsPerformancePerOrder>>>;
};

export type OrderCreationResult = {
  __typename?: 'OrderCreationResult';
  parentOrder?: Maybe<ParentOrder>;
  sessionUrl?: Maybe<Scalars['String']>;
};

export type OrderedCustomField = {
  __typename?: 'OrderedCustomField';
  choiceValue?: Maybe<Scalars['String']>;
  dateValue?: Maybe<Scalars['Date']>;
  definition: CustomFieldDefinition;
  multipleChoiceValue?: Maybe<Array<Scalars['String']>>;
  numberValue?: Maybe<Scalars['Float']>;
  textValue?: Maybe<Scalars['String']>;
};

export enum OrderExportType {
  BillingFormat = 'billing_format',
  Cmd = 'cmd'
}

export type OrderFilter = {
  dateRange?: InputMaybe<DateRange>;
  groupId?: InputMaybe<Scalars['ID']>;
  keyword?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  tab?: InputMaybe<Scalars['String']>;
  usersIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vouchers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type OrderImage = {
  __typename?: 'OrderImage';
  id?: Maybe<Scalars['ID']>;
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  original?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  appliedDiscounts?: Maybe<Array<Maybe<Discount>>>;
  comment?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
  files?: Maybe<Array<OrderItemFile>>;
  hasArchive: Scalars['Boolean'];
  options?: Maybe<Array<OrderItemOptions>>;
  packInfo?: Maybe<PackInfo>;
  product: OrderProduct;
  productId: Scalars['ID'];
  providerId?: Maybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  subId?: Maybe<Scalars['ID']>;
  supportsUrl?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Price>;
  type?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Price>;
  variationByQuantity?: Maybe<Array<Maybe<QuantityVariation>>>;
};

export type OrderItemFile = {
  __typename?: 'OrderItemFile';
  id: Scalars['ID'];
  name: Scalars['String'];
  originalName: Scalars['String'];
  url: Scalars['String'];
};

export type OrderItemOptions = {
  __typename?: 'OrderItemOptions';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<OrderImage>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

export type OrderMessage = {
  __typename?: 'OrderMessage';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isCancelledReason?: Maybe<Scalars['Boolean']>;
};

export enum OrderMetricOptions {
  AvgOrdersPerUser = 'avgOrdersPerUser',
  AvgTurnoverPerOrder = 'avgTurnoverPerOrder',
  Orders = 'orders',
  Turnover = 'turnover'
}

export type OrderMetrics = {
  __typename?: 'OrderMetrics';
  avgOrdersPerUser?: Maybe<SimpleMetricReturn>;
  avgTurnoverPerOrder?: Maybe<SimpleMetricReturn>;
  orders?: Maybe<SimpleMetricReturn>;
  productDetails?: Maybe<ProductDetailsPagination>;
  turnover?: Maybe<SimpleMetricReturn>;
  turnoverAndOrdersPerDay?: Maybe<Array<Maybe<TurnoverAndOrdersPerDay>>>;
};


export type OrderMetricsProductDetailsArgs = {
  additionalParams?: InputMaybe<OrderMetricsParams>;
};

export type OrderMetricsParams = {
  direction?: InputMaybe<Direction>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortCriteria>;
};

export type OrderPagination = {
  __typename?: 'OrderPagination';
  count: Scalars['Int'];
  orders?: Maybe<Array<Maybe<Order>>>;
  totalWithoutTaxes?: Maybe<Scalars['Float']>;
};

export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod';
  documentType?: Maybe<OrderPaymentMethodDocumentType>;
  type?: Maybe<OrderPaymentMethodType>;
};

export enum OrderPaymentMethodDocumentType {
  Invoice = 'INVOICE',
  PurchaseOrder = 'PURCHASE_ORDER'
}

export enum OrderPaymentMethodStripe {
  Card = 'card',
  SepaDebit = 'sepa_debit'
}

export enum OrderPaymentMethodType {
  Branch = 'BRANCH',
  Stripe = 'STRIPE'
}

export type OrderProduct = {
  __typename?: 'OrderProduct';
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  disabledDate?: Maybe<Scalars['Date']>;
  documentDownloadSettingsId?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentViewPrefsId?: Maybe<Scalars['String']>;
  documentWorkspaceId?: Maybe<Scalars['String']>;
  highQualityAsset?: Maybe<ProductAsset>;
  id: Scalars['ID'];
  images?: Maybe<Array<Maybe<OrderImage>>>;
  isCustomizable?: Maybe<Scalars['Boolean']>;
  isPaidMediaProduct?: Maybe<Scalars['Boolean']>;
  lowQualityAsset?: Maybe<ProductAsset>;
  name: Scalars['String'];
  packagingUnit?: Maybe<Scalars['Int']>;
  paidMediaCampaignName?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  priceType?: Maybe<PriceTypes>;
  providerId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<OrderTag>>>;
  tips?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OrderProductsCountParam = {
  productId: Scalars['ID'];
  startAt?: InputMaybe<Scalars['Date']>;
};

export type OrderProductsCountResult = {
  __typename?: 'OrderProductsCountResult';
  count: Scalars['Int'];
  productId: Scalars['ID'];
};

export type OrdersCountPerSalespoint = {
  __typename?: 'OrdersCountPerSalespoint';
  data?: Maybe<Array<Maybe<OrdersCountPerSalespointData>>>;
  total?: Maybe<Scalars['Int']>;
};

export type OrdersCountPerSalespointData = {
  __typename?: 'OrdersCountPerSalespointData';
  ordersCount?: Maybe<Scalars['Int']>;
  salespointId?: Maybe<Scalars['ID']>;
};

export enum OrderStatus {
  Canceled = 'canceled',
  Created = 'created',
  Outdated = 'outdated',
  Processing = 'processing',
  Refused = 'refused',
  ToValidate = 'to_validate',
  Validated = 'validated',
  WaitingValidation = 'waiting_validation'
}

export type OrderTag = {
  __typename?: 'OrderTag';
  backgroundColor?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  group?: Maybe<OrderTagGroup>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export type OrderTagGroup = {
  __typename?: 'OrderTagGroup';
  displayOnProduct?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type OrderTotal = {
  __typename?: 'OrderTotal';
  fees?: Maybe<Array<Maybe<Fees>>>;
  total?: Maybe<Price>;
  totalWithFees?: Maybe<Price>;
  totalWithShippingFees?: Maybe<Price>;
};

export type OrderVoucher = {
  __typename?: 'OrderVoucher';
  amount?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  cumulative?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  singleUse?: Maybe<Scalars['Boolean']>;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};

export type OrganicTargeting = {
  __typename?: 'OrganicTargeting';
  ageTargeting?: Maybe<Scalars['Boolean']>;
  cityKeysTarget?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxAgeTarget?: Maybe<Scalars['Int']>;
  minAgeTarget?: Maybe<Scalars['Int']>;
  sexOfTarget?: Maybe<Scalars['String']>;
  sexTargeting?: Maybe<Scalars['Boolean']>;
  targetingCountries?: Maybe<Array<Maybe<OrganicTargetingObject>>>;
  targetingGeolocations?: Maybe<Array<Maybe<OrganicTargetingObject>>>;
  targetingInterests?: Maybe<Array<Maybe<OrganicTargetingObject>>>;
};

export type OrganicTargetingObject = {
  __typename?: 'OrganicTargetingObject';
  facebookKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OtherTechnicalSpecificationsReturn = {
  __typename?: 'OtherTechnicalSpecificationsReturn';
  activities?: Maybe<Array<Maybe<BriefActivitiesSpecs>>>;
  specs?: Maybe<Array<Maybe<BriefBudgetTypeSpecs>>>;
};

export type OvInvoice = {
  __typename?: 'OvInvoice';
  date?: Maybe<Scalars['String']>;
  pdfExist?: Maybe<Scalars['Boolean']>;
  xlsExist?: Maybe<Scalars['Boolean']>;
};

export enum OvInvoicesFormat {
  Pdf = 'pdf',
  Xls = 'xls',
  Xlsx = 'xlsx'
}

export type OvInvoicesResult = {
  __typename?: 'OvInvoicesResult';
  months?: Maybe<Array<Maybe<OvInvoice>>>;
  yearCumuls?: Maybe<Array<Maybe<OvInvoice>>>;
};

export type PackDetail = {
  __typename?: 'PackDetail';
  name?: Maybe<Scalars['String']>;
  packId: Scalars['ID'];
  productsInPackCount?: Maybe<Scalars['Int']>;
  quantityOfProductOrdered?: Maybe<Scalars['Int']>;
  reference?: Maybe<Scalars['String']>;
  turnoverOfProductOrdered?: Maybe<Scalars['Float']>;
};

export type PackInfo = {
  __typename?: 'PackInfo';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  productsInPack?: Maybe<Array<Maybe<ProductInPack>>>;
  ref?: Maybe<Scalars['String']>;
};

export type PackInfoInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  productsInPack?: InputMaybe<Array<InputMaybe<ProductInPackInput>>>;
  ref?: InputMaybe<Scalars['String']>;
};

export type PackOrderDetails = {
  __typename?: 'PackOrderDetails';
  count?: Maybe<Scalars['Int']>;
  packDetails?: Maybe<Array<Maybe<PackDetail>>>;
};

export type PackOrderMetrics = {
  __typename?: 'PackOrderMetrics';
  packDetails?: Maybe<PackOrderDetails>;
};


export type PackOrderMetricsPackDetailsArgs = {
  additionalParams?: InputMaybe<OrderMetricsParams>;
};

export type PageInfos = {
  __typename?: 'PageInfos';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  totalPage?: Maybe<Scalars['Int']>;
  totalResult?: Maybe<Scalars['Int']>;
};

export type PaidMedia = {
  __typename?: 'PaidMedia';
  enabled?: Maybe<Scalars['Boolean']>;
  google?: Maybe<Scalars['Boolean']>;
  googleAccount?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['Boolean']>;
  metaAccount?: Maybe<Scalars['String']>;
};

export type PaidMediaCampaignBase = {
  campaignName: Scalars['String'];
  campaignType?: Maybe<Scalars['String']>;
  cost: Scalars['Float'];
  createdAt: Scalars['Date'];
  currency: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  interfaceSlug: Scalars['String'];
  networks?: Maybe<Array<Maybe<Scalars['String']>>>;
  orderId: Scalars['ID'];
  salesPoint?: Maybe<SalesPoint>;
  salesPointId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
  status: PaidMediaCampaignStatus;
};

export type PaidMediaCampaignDistribution = {
  __typename?: 'PaidMediaCampaignDistribution';
  engagement?: Maybe<Array<Maybe<PaidMediaCampaignDistributionTuple>>>;
  impressions?: Maybe<Array<Maybe<PaidMediaCampaignDistributionTuple>>>;
  reach?: Maybe<Array<Maybe<PaidMediaCampaignDistributionTuple>>>;
  spend?: Maybe<Array<Maybe<PaidMediaCampaignDistributionTuple>>>;
};

export type PaidMediaCampaignDistributionTuple = {
  __typename?: 'PaidMediaCampaignDistributionTuple';
  socialNetwork: Scalars['String'];
  value: Scalars['Float'];
};

export type PaidMediaCampaignInput = {
  campaignName: Scalars['String'];
  cost: Scalars['Float'];
  currency?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  interfaceSlug: Scalars['String'];
  networks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order: Scalars['ID'];
  providerSlug: Scalars['String'];
  salesPoint: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
};

export type PaidMediaCampaignLite = PaidMediaCampaignBase & {
  __typename?: 'PaidMediaCampaignLite';
  campaignName: Scalars['String'];
  campaignType?: Maybe<Scalars['String']>;
  cost: Scalars['Float'];
  createdAt: Scalars['Date'];
  currency: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  interfaceSlug: Scalars['String'];
  networks?: Maybe<Array<Maybe<Scalars['String']>>>;
  orderId: Scalars['ID'];
  salesPoint?: Maybe<SalesPoint>;
  salesPointId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
  status: PaidMediaCampaignStatus;
};

export type PaidMediaCampaignMetaDailyStat = {
  __typename?: 'PaidMediaCampaignMetaDailyStat';
  clicks?: Maybe<Scalars['Int']>;
  date: Scalars['Date'];
  engagement: Scalars['Int'];
  impressions: Scalars['Int'];
  reach: Scalars['Int'];
};

export type PaidMediaCampaignMetaDetail = PaidMediaCampaignBase & {
  __typename?: 'PaidMediaCampaignMetaDetail';
  avg_purchase?: Maybe<Scalars['Float']>;
  campaignName: Scalars['String'];
  campaignType?: Maybe<Scalars['String']>;
  clicks: Scalars['Int'];
  cost: Scalars['Float'];
  cpc: Scalars['Float'];
  cpm?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  currency: Scalars['String'];
  distribution?: Maybe<PaidMediaCampaignDistribution>;
  endDate?: Maybe<Scalars['Date']>;
  engagement: Scalars['Int'];
  id: Scalars['ID'];
  impressions: Scalars['Int'];
  interfaceSlug: Scalars['String'];
  margin?: Maybe<Scalars['Float']>;
  networks?: Maybe<Array<Maybe<Scalars['String']>>>;
  orderId: Scalars['ID'];
  purchase?: Maybe<Scalars['Int']>;
  reach: Scalars['Int'];
  salesPoint?: Maybe<SalesPoint>;
  salesPointId: Scalars['ID'];
  spend: Scalars['Float'];
  startDate?: Maybe<Scalars['Date']>;
  status: PaidMediaCampaignStatus;
  total_purchase: Scalars['Float'];
};

export enum PaidMediaCampaignStatus {
  Done = 'done',
  InProgress = 'in_progress',
  PendingCreation = 'pending_creation'
}

export type PaidMediaInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  google?: InputMaybe<Scalars['Boolean']>;
  googleAccount?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['Boolean']>;
  metaAccount?: InputMaybe<Scalars['String']>;
};

export type ParentOrder = {
  __typename?: 'ParentOrder';
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']>;
  date: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<OrderItem>>>;
  orderNumber: Scalars['String'];
  orders?: Maybe<Array<Maybe<Order>>>;
  ordersNeedValidation?: Maybe<Scalars['Boolean']>;
  ordersPartiallyNeedValidation?: Maybe<Scalars['Boolean']>;
  shippingFees?: Maybe<Scalars['Int']>;
  total: Price;
  totalProductsQuantity: Scalars['Int'];
  totalWithFees?: Maybe<Price>;
  totalWithShippingFees?: Maybe<Price>;
  userId: Scalars['ID'];
};

export type ParentProductCategory = {
  __typename?: 'ParentProductCategory';
  children: Array<ChildProductCategory>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  position: Scalars['Int'];
  salespointGroups: Array<SalespointsGroup>;
  title: Scalars['String'];
};

export type ParentProductCategoryInput = {
  enabled: Scalars['Boolean'];
  salespointGroupIds: Array<Scalars['ID']>;
  title: Scalars['String'];
};

export type PartnerAuthBridgeInput = {
  linkLabel: Scalars['String'];
  parameters?: InputMaybe<Scalars['JSON']>;
  partnerName: Scalars['String'];
};

export type PartnerAuthBridgeType = {
  __typename?: 'PartnerAuthBridgeType';
  linkLabel: Scalars['String'];
  parameters?: Maybe<Scalars['JSON']>;
  partnerName: Scalars['String'];
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  amount?: Maybe<Scalars['Int']>;
  chargeId?: Maybe<Scalars['ID']>;
  clientId?: Maybe<Scalars['String']>;
  currentStatus?: Maybe<PaymentStatusValue>;
  directChargeAccountId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  isMultiProvider?: Maybe<Scalars['Boolean']>;
  orderIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderNumber?: Maybe<Scalars['Int']>;
  parentOrderId?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['ID']>;
  paymentIntentId?: Maybe<Scalars['ID']>;
  status?: Maybe<Array<Maybe<PaymentStatus>>>;
  stripeFee?: Maybe<Scalars['Int']>;
  stripePaymentMethod?: Maybe<StripePaymentMethod>;
  stripeUrl?: Maybe<Scalars['String']>;
  toValidate?: Maybe<Scalars['Boolean']>;
  transfers?: Maybe<Array<Maybe<Transfer>>>;
  userId?: Maybe<Scalars['ID']>;
};

export type PaymentInfoInput = {
  amount: Scalars['Int'];
  orderIds: Array<Scalars['ID']>;
  orderNumber: Scalars['Int'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  cartText?: Maybe<Scalars['String']>;
  /** Document generated for a new order, can be null in case of unorderable payment method type (noshop) */
  documentType?: Maybe<PaymentMethodDocumentType>;
  id: Scalars['ID'];
  /** Is payment method is a system payment method, or inherited from a system payment method */
  isSystem: Scalars['Boolean'];
  /** Nullable for system payment methods (translated front) */
  name?: Maybe<Scalars['String']>;
  salesPointGroups?: Maybe<Array<SalespointsGroup>>;
  salesPointGroupsCount?: Maybe<Scalars['Int']>;
  type: PaymentMethodType;
};

export enum PaymentMethodDocumentType {
  Invoice = 'INVOICE',
  PurchaseOrder = 'PURCHASE_ORDER'
}

export type PaymentMethodInput = {
  cartText?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<PaymentMethodDocumentType>;
  name?: InputMaybe<Scalars['String']>;
  salesPointGroupIds: Array<Scalars['ID']>;
  type: PaymentMethodType;
};

export enum PaymentMethodType {
  Branch = 'BRANCH',
  Noshop = 'NOSHOP',
  Stripe = 'STRIPE'
}

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  date?: Maybe<Scalars['Date']>;
  value?: Maybe<PaymentStatusValue>;
};

export enum PaymentStatusValue {
  Canceled = 'canceled',
  Created = 'created',
  NotInitiated = 'not_initiated',
  PaymentFailed = 'payment_failed',
  Processing = 'processing',
  RequiresAction = 'requires_action',
  RequiresPaymentMethod = 'requires_payment_method',
  Succeeded = 'succeeded'
}

export enum Period {
  Futur = 'futur',
  Past = 'past',
  Present = 'present'
}

export type Permission = {
  __typename?: 'Permission';
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type PermissionInput = {
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Permissions = {
  __typename?: 'Permissions';
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PersistTemporaryFileInput = {
  from: Scalars['String'];
  to: PersistTemporaryFileToInput;
};

export type PersistTemporaryFileToInput = {
  bucket: Scalars['String'];
  path: Scalars['String'];
};

export type PlatformGraphElementMetrics = {
  __typename?: 'PlatformGraphElementMetrics';
  login?: Maybe<Array<Maybe<SimpleMetricReturn>>>;
  posts?: Maybe<Array<Maybe<SimpleMetricReturn>>>;
  postSources?: Maybe<Array<Maybe<SimpleMetricReturn>>>;
};

export type PlatformGraphMetrics = {
  __typename?: 'PlatformGraphMetrics';
  lineGraphMetrics?: Maybe<Array<Maybe<PlatformLineGraphMetric>>>;
  metrics?: Maybe<PlatformGraphElementMetrics>;
  total?: Maybe<PlatformGraphTotalMetrics>;
};

export type PlatformGraphTotalMetrics = {
  __typename?: 'PlatformGraphTotalMetrics';
  downloads?: Maybe<SimpleMetricReturn>;
  login?: Maybe<SimpleMetricReturn>;
  ordersPassed?: Maybe<SimpleMetricReturn>;
  postsPublished?: Maybe<SimpleMetricReturn>;
  turnover?: Maybe<SimpleMetricReturn>;
};

export enum PlatformLanguageOption {
  Ar = 'ar',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  He = 'he',
  It = 'it',
  Nl = 'nl'
}

export type PlatformLineGraphMetric = {
  __typename?: 'PlatformLineGraphMetric';
  date?: Maybe<Scalars['Date']>;
  downloads?: Maybe<Scalars['Int']>;
  login?: Maybe<Scalars['Int']>;
  ordersPassed?: Maybe<Scalars['Int']>;
  postsPublished?: Maybe<Scalars['Int']>;
  turnover?: Maybe<Scalars['Int']>;
};

export type PlatformListDeviceMetric = {
  __typename?: 'PlatformListDeviceMetric';
  app?: Maybe<Scalars['Int']>;
  web?: Maybe<Scalars['Int']>;
};

export type PlatformListLineMetricBySalesPoint = {
  __typename?: 'PlatformListLineMetricBySalesPoint';
  downloads?: Maybe<Scalars['Int']>;
  login?: Maybe<Scalars['Int']>;
  loginDevices?: Maybe<PlatformListDeviceMetric>;
  orders?: Maybe<Scalars['Int']>;
  paps?: Maybe<Scalars['Int']>;
  posts?: Maybe<PlatformListDeviceMetric>;
  salespoint?: Maybe<Scalars['String']>;
  totalUsers?: Maybe<Scalars['Int']>;
  usersCount?: Maybe<Scalars['Int']>;
};


export type PlatformListLineMetricBySalesPointTotalUsersArgs = {
  filter?: InputMaybe<PlatformMetricsFilter>;
};

export type PlatformListLineMetricByUser = {
  __typename?: 'PlatformListLineMetricByUser';
  downloads?: Maybe<Scalars['Int']>;
  login?: Maybe<Scalars['Int']>;
  loginDevices?: Maybe<PlatformListDeviceMetric>;
  orders?: Maybe<Scalars['Int']>;
  paps?: Maybe<Scalars['Int']>;
  plannifications?: Maybe<PlatformListPostMetric>;
  posts?: Maybe<PlatformListDeviceMetric>;
  salesPointsCount?: Maybe<Scalars['Int']>;
  user?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
};

export type PlatformListMetricsBySalespoint = {
  __typename?: 'PlatformListMetricsBySalespoint';
  metrics?: Maybe<Array<PlatformListLineMetricBySalesPoint>>;
  total?: Maybe<PlatformListTotalMetrics>;
  totalResult?: Maybe<Scalars['Int']>;
  userTotal?: Maybe<Scalars['Int']>;
};


export type PlatformListMetricsBySalespointUserTotalArgs = {
  filter?: InputMaybe<PlatformMetricsFilter>;
};

export type PlatformListMetricsByUser = {
  __typename?: 'PlatformListMetricsByUser';
  metrics?: Maybe<Array<Maybe<PlatformListLineMetricByUser>>>;
  total?: Maybe<PlatformListTotalMetrics>;
  totalResult?: Maybe<Scalars['Int']>;
};

export type PlatformListMetricsKeyword = {
  term: Scalars['String'];
  type: PlatformListMetricsKeywordType;
};

export enum PlatformListMetricsKeywordType {
  SalesPoint = 'salesPoint',
  User = 'user'
}

export type PlatformListMetricsSort = {
  criteria?: InputMaybe<PlatformListMetricsSortCriteria>;
  direction?: InputMaybe<PlatformListMetricsSortDirection>;
};

export enum PlatformListMetricsSortCriteria {
  Downloads = 'downloads',
  Login = 'login',
  Orders = 'orders',
  Paps = 'paps',
  PublishedPosts = 'publishedPosts',
  Salespoint = 'salespoint',
  User = 'user'
}

export enum PlatformListMetricsSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type PlatformListPostMetric = {
  __typename?: 'PlatformListPostMetric';
  immediate?: Maybe<Scalars['Int']>;
  planned?: Maybe<Scalars['Int']>;
};

export type PlatformListTotalMetrics = {
  __typename?: 'PlatformListTotalMetrics';
  downloads?: Maybe<Scalars['Int']>;
  login?: Maybe<Scalars['Int']>;
  loginDevices?: Maybe<PlatformListDeviceMetric>;
  orders?: Maybe<Scalars['Int']>;
  paps?: Maybe<Scalars['Int']>;
  plannifications?: Maybe<PlatformListPostMetric>;
  posts?: Maybe<PlatformListDeviceMetric>;
};

export type PlatformMetricsFilter = {
  dateRange: DateRange;
  keyword?: InputMaybe<PlatformListMetricsKeyword>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type PmMetrics = {
  __typename?: 'PmMetrics';
  need?: Maybe<Scalars['Int']>;
  no?: Maybe<Scalars['Int']>;
  no_sync?: Maybe<Scalars['Int']>;
  sync?: Maybe<Scalars['Int']>;
};

export type PmPhoto = {
  __typename?: 'PmPhoto';
  _id?: Maybe<Scalars['ID']>;
  bucketUrl?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  publicUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uberallUniquePhotoId?: Maybe<Scalars['Int']>;
};

export type PmPhotoInput = {
  _id?: InputMaybe<Scalars['ID']>;
  bucketUrl?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  fileName?: InputMaybe<Scalars['String']>;
  isNewImage?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  publicUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uberallUniquePhotoId?: InputMaybe<Scalars['Int']>;
};

export type PostCarouselItem = {
  __typename?: 'PostCarouselItem';
  callToAction?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  media?: Maybe<PublishMedia>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type PostErrors = {
  __typename?: 'PostErrors';
  count?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
};

export type PostMetrics = {
  __typename?: 'PostMetrics';
  anger?: Maybe<Scalars['Int']>;
  care?: Maybe<Scalars['Int']>;
  comments: Scalars['Int'];
  cpi?: Maybe<Scalars['Float']>;
  engagement: Scalars['Int'];
  engagementRate: Scalars['Float'];
  haha?: Maybe<Scalars['Int']>;
  insightAdInteraction?: Maybe<Scalars['Int']>;
  insightAdReach?: Maybe<Scalars['Float']>;
  insightAdSpent?: Maybe<Scalars['Float']>;
  insightPaid?: Maybe<Scalars['Int']>;
  insightUnpaid?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  linkClicks?: Maybe<Scalars['Int']>;
  love?: Maybe<Scalars['Int']>;
  reach: Scalars['Int'];
  shares: Scalars['Int'];
  sorry?: Maybe<Scalars['Int']>;
  totalReactions: Scalars['Int'];
  wow?: Maybe<Scalars['Int']>;
};

export enum PostStatus {
  All = 'all',
  Canceled = 'canceled',
  Done = 'done',
  Draft = 'draft',
  Error = 'error',
  InProgress = 'in_progress',
  Other = 'other',
  PendingPostAction = 'pending_post_action',
  PendingPostDate = 'pending_post_date',
  PendingValidation = 'pending_validation',
  Planned = 'planned',
  Posted = 'posted',
  PostedPlanned = 'posted_planned',
  PostedWithError = 'posted_with_error',
  Rejected = 'rejected',
  Stopped = 'stopped',
  Terminated = 'terminated',
  UploadInProgress = 'upload_in_progress'
}

export type PostTarget = {
  __typename?: 'PostTarget';
  clusters?: Maybe<Array<Maybe<Scalars['ID']>>>;
  globals?: Maybe<Array<Maybe<Scalars['String']>>>;
  onGlobals?: Maybe<Scalars['Boolean']>;
  onSalesPoints?: Maybe<Scalars['Boolean']>;
  salespointGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
  salesPointToExclude?: Maybe<Array<Maybe<SalesPoint>>>;
  targetToExclude?: Maybe<Array<Maybe<Scalars['ID']>>>;
  type?: Maybe<TargetType>;
};

export type PostTemplate = {
  __typename?: 'PostTemplate';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  displayStatus?: Maybe<PostTemplateDisplayStatus>;
  endDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  isScheduled?: Maybe<Scalars['Boolean']>;
  isUsable?: Maybe<Scalars['Boolean']>;
  licorneId?: Maybe<Scalars['ID']>;
  mongoId?: Maybe<Scalars['ID']>;
  multipleDescription?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  salespointsGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salespointsGroupsIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  socialNetworks?: Maybe<Array<Maybe<SocialNetwork>>>;
  startDate?: Maybe<Scalars['Date']>;
  tags?: Maybe<Array<Maybe<PostTemplateTag>>>;
  templateBodyData?: Maybe<PostTemplateBodyData>;
  type?: Maybe<PostType>;
  useSalespointsGroups?: Maybe<Scalars['Boolean']>;
};

export type PostTemplateArgs = {
  avatar?: InputMaybe<UploadOrGalleryMediaInput>;
  callToAction?: InputMaybe<Scalars['Int']>;
  campaigns?: InputMaybe<Array<Scalars['ID']>>;
  carouselItems?: InputMaybe<Array<InputCarouselItem>>;
  cover?: InputMaybe<UploadOrGalleryMediaInput>;
  description?: InputMaybe<Scalars['String']>;
  dynamicLink?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  event?: InputMaybe<InputSocialEvent>;
  htmlDescription?: InputMaybe<Scalars['String']>;
  isScheduled: Scalars['Boolean'];
  link?: InputMaybe<Scalars['String']>;
  medias?: InputMaybe<Array<InputMaybe<UploadOrGalleryMediaInput>>>;
  multipleDescription?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rawDescription?: InputMaybe<Scalars['String']>;
  salespointsGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  socialNetworks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  socialNetworksDescription?: InputMaybe<SocialNetworksDescriptionInput>;
  socialNetworksRawDescription?: InputMaybe<SocialNetworksDescriptionInput>;
  socialNetworkTarget?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  thumb?: InputMaybe<UploadOrGalleryMediaInput>;
  type: TemplatablePostType;
  useSalespointsGroups: Scalars['Boolean'];
};

export type PostTemplateBodyData = {
  __typename?: 'PostTemplateBodyData';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  authorRole?: Maybe<SocialAuthorRole>;
  avatar?: Maybe<PublishMedia>;
  callToAction?: Maybe<Scalars['Int']>;
  carouselItems?: Maybe<Array<PostCarouselItem>>;
  cover?: Maybe<PublishMedia>;
  description?: Maybe<Scalars['String']>;
  dynamicLink?: Maybe<Scalars['String']>;
  event?: Maybe<SocialEvent>;
  htmlDescription?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  medias?: Maybe<Array<Maybe<PublishMedia>>>;
  multipleDescription?: Maybe<Scalars['Boolean']>;
  preview?: Maybe<SocialMediaPostPreview>;
  rawDescription?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<SocialNetwork>>>;
  socialNetworksDescription?: Maybe<SocialNetworksDescriptionType>;
  socialNetworksRawDescription?: Maybe<SocialNetworksDescriptionType>;
  textDescription?: Maybe<Scalars['String']>;
  thumb?: Maybe<PublishMedia>;
  thumbMobile?: Maybe<Scalars['String']>;
  type?: Maybe<PostType>;
};

export enum PostTemplateDisplayStatus {
  Finished = 'finished',
  Permanent = 'permanent',
  Running = 'running',
  Scheduled = 'scheduled'
}

export type PostTemplateList = {
  __typename?: 'PostTemplateList';
  count?: Maybe<Scalars['Int']>;
  templates?: Maybe<Array<Maybe<PostTemplate>>>;
};

export type PostTemplateListFilters = {
  displayStatus?: InputMaybe<PostTemplateDisplayStatus>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  keyword?: InputMaybe<Scalars['String']>;
  salespointGroups?: InputMaybe<Array<Scalars['ID']>>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
  types?: InputMaybe<Array<InputMaybe<PostType>>>;
};

export type PostTemplateListSort = {
  criteria?: InputMaybe<PostTemplateListSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum PostTemplateListSortCriteria {
  CreatedAt = 'created_at',
  Name = 'name'
}

export type PostTemplateTag = {
  __typename?: 'PostTemplateTag';
  created_at?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  postTemplates?: Maybe<LitePostTemplateList>;
  tagGroup?: Maybe<PostTemplateTagGroup>;
  updated_at?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<User>;
};


export type PostTemplateTagPostTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PostTemplateTagGroup = {
  __typename?: 'PostTemplateTagGroup';
  created_at?: Maybe<Scalars['Date']>;
  displayOrder?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<PostTemplateTag>>>;
  updated_at?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<User>;
};

export type PostTemplateTagGroupInput = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type PostTemplateTagGroupPagination = {
  __typename?: 'PostTemplateTagGroupPagination';
  count?: Maybe<Scalars['Int']>;
  tagGroups?: Maybe<Array<Maybe<PostTemplateTagGroup>>>;
};

export type PostTemplateTagInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  postTemplates?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tagGroup?: InputMaybe<Scalars['ID']>;
};

export type PostTemplateTagPagination = {
  __typename?: 'PostTemplateTagPagination';
  count?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<PostTemplateTag>>>;
};

export type PostTemplateTagsFilters = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  templateListFilters?: InputMaybe<PostTemplateListFilters>;
};

export type PostTemplateTagsPagination = {
  __typename?: 'PostTemplateTagsPagination';
  count?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<PostTemplateTag>>>;
};

export type PostTemplateTagsSort = {
  criteria?: InputMaybe<PostTemplateTagsSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum PostTemplateTagsSortCriteria {
  CreatedAt = 'created_at',
  Name = 'name',
  UpdatedAt = 'updated_at'
}

export type PostTotalStatus = {
  __typename?: 'PostTotalStatus';
  error: Scalars['Int'];
  other: Scalars['Int'];
  posted: Scalars['Int'];
};

export type PostToValidateData = {
  authorFullName: Scalars['String'];
  createdAt: Scalars['Date'];
  salesPointId: Scalars['ID'];
  validatorType: ValidatorTypes;
};

export enum PostType {
  Album = 'album',
  Carousel = 'carousel',
  Event = 'event',
  Gif = 'gif',
  Link = 'link',
  Offer = 'offer',
  Photo = 'photo',
  Profile = 'profile',
  Status = 'status',
  Story = 'story',
  Video = 'video'
}

export type Preorder = {
  __typename?: 'Preorder';
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['ID'];
  clientId?: Maybe<Scalars['String']>;
  convertedOrderId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdById?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  items: Array<PreorderItem>;
  productsCount?: Maybe<Scalars['Int']>;
  providerName?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  salesPoint?: Maybe<SalesPoint>;
  salesPointId: Scalars['ID'];
  salesPointName?: Maybe<Scalars['String']>;
  status: PreorderStatus;
  statusUx?: Maybe<PreorderStatusUx>;
  submittedAt?: Maybe<Scalars['Date']>;
  totalWithoutTaxes?: Maybe<Scalars['Int']>;
  totalWithTaxes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export type PreorderFilter = {
  campaignIds?: InputMaybe<Array<Scalars['ID']>>;
  dateRange?: InputMaybe<DateRange>;
  keyword?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<PreorderStatus>>;
  statusesUx?: InputMaybe<Array<PreorderStatusUx>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PreorderInput = {
  campaignId: Scalars['ID'];
  items: Array<PreorderItemInput>;
  salesPointId: Scalars['ID'];
};

export type PreorderItem = {
  __typename?: 'PreorderItem';
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type PreorderItemInput = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type PreorderPagination = {
  __typename?: 'PreorderPagination';
  count: Scalars['Int'];
  preorders: Array<Preorder>;
  totalWithoutTaxes?: Maybe<Scalars['Float']>;
};

export enum PreorderSortField {
  Date = 'DATE',
  Ref = 'REF'
}

export enum PreorderStatus {
  Cancelled = 'cancelled',
  Converted = 'converted',
  Draft = 'draft',
  Submitted = 'submitted'
}

export enum PreorderStatusUx {
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS'
}

export type PresenceManagement = {
  __typename?: 'PresenceManagement';
  activeBrands?: Maybe<Scalars['Boolean']>;
  activeKeywords?: Maybe<Scalars['Boolean']>;
  activeServices?: Maybe<Scalars['Boolean']>;
  businessId?: Maybe<Scalars['String']>;
  businessIdentifier?: Maybe<Scalars['String']>;
  choiceUberall?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  isEverySalesPointsNotIndexed?: Maybe<Scalars['Boolean']>;
  privateKey?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  publicKey?: Maybe<Scalars['String']>;
};

export type PresenceManagementAttributes = {
  __typename?: 'PresenceManagementAttributes';
  displayName?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  optionsAttributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type PresenceManagementAttributesInput = {
  displayName?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  optionsAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type PresenceManagementInfo = {
  activeBrands?: InputMaybe<Scalars['Boolean']>;
  activeKeywords?: InputMaybe<Scalars['Boolean']>;
  activeServices?: InputMaybe<Scalars['Boolean']>;
  businessIdentifier?: InputMaybe<Scalars['String']>;
  choiceUberall?: InputMaybe<Scalars['String']>;
  isEverySalesPointsNotIndexed?: InputMaybe<Scalars['Boolean']>;
  privateKey?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<ProviderPresenceManagement>;
  publicKey?: InputMaybe<Scalars['String']>;
};

export type PresenceManagementSync = {
  __typename?: 'PresenceManagementSync';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<PresenceManagementSyncStatus>;
  statusCode?: Maybe<Scalars['String']>;
};

export enum PresenceManagementSyncStatus {
  NoSync = 'no_sync',
  SyncNeeded = 'sync_needed',
  Synced = 'synced'
}

export enum PreviewErrorCodes {
  NoThumbnail = 'NO_THUMBNAIL'
}

export type Price = {
  __typename?: 'Price';
  basePrice?: Maybe<PriceAmount>;
  discountedPrice?: Maybe<PriceAmount>;
};

export type PriceAmount = {
  __typename?: 'PriceAmount';
  taxAmount?: Maybe<Scalars['Int']>;
  taxPercent?: Maybe<Scalars['Int']>;
  withoutTaxes?: Maybe<Scalars['Float']>;
  withTaxes?: Maybe<Scalars['Float']>;
};


export type PriceAmountTaxAmountArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type PriceAmountWithoutTaxesArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type PriceAmountWithTaxesArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type PriceAndQuantityForLocation = {
  __typename?: 'PriceAndQuantityForLocation';
  basePrice?: Maybe<PriceAmount>;
  discountedPrice?: Maybe<PriceAmount>;
  locationId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type PriceByQuantity = {
  __typename?: 'PriceByQuantity';
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Int']>;
};

export type PricesByLocation = {
  basePrice: Scalars['Int'];
  locationId?: InputMaybe<Scalars['ID']>;
};

export enum PriceTypes {
  ByLevels = 'BY_LEVELS',
  ByQuantity = 'BY_QUANTITY',
  Simple = 'SIMPLE'
}

export type Product = {
  __typename?: 'Product';
  allTags?: Maybe<Array<Maybe<Tag>>>;
  availableQuantity?: Maybe<AvailableQuantity>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  catalogFixPricesLevelsByQuantity?: Maybe<Array<Maybe<CatalogPriceLevels>>>;
  catalogPrice?: Maybe<Scalars['Int']>;
  catalogPriceLevels?: Maybe<Array<Maybe<CatalogPriceLevels>>>;
  categories?: Maybe<Array<ChildProductCategory>>;
  clientId?: Maybe<Scalars['String']>;
  contextGoalsIssues?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  crmSupports?: Maybe<Array<Maybe<BriefSpecClient>>>;
  deliveryDate?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  disabledDate?: Maybe<Scalars['Date']>;
  discounts?: Maybe<Array<Maybe<Discount>>>;
  documentDownloadSettingsId?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentViewPrefsId?: Maybe<Scalars['String']>;
  documentWorkspaceId?: Maybe<Scalars['String']>;
  enabledDate?: Maybe<Scalars['Date']>;
  exportTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  fixPricesLevelsByQuantity?: Maybe<Array<Maybe<PriceByQuantity>>>;
  hasVariation?: Maybe<Scalars['Boolean']>;
  highQualityAsset?: Maybe<ProductAsset>;
  id: Scalars['ID'];
  images?: Maybe<Array<Maybe<Image>>>;
  isBriefCrm?: Maybe<Scalars['Boolean']>;
  isCommentEnabled?: Maybe<Scalars['Boolean']>;
  isCustomizable?: Maybe<Scalars['Boolean']>;
  isDownloadByEmail?: Maybe<Scalars['Boolean']>;
  isGovernanceEnabled?: Maybe<Scalars['Boolean']>;
  isHighlighted?: Maybe<Scalars['Boolean']>;
  isManyOptionsSelectable?: Maybe<Scalars['Boolean']>;
  isMaximumOrderEnabled?: Maybe<Scalars['Boolean']>;
  isMinimumOrderEnabled?: Maybe<Scalars['Boolean']>;
  isPack?: Maybe<Scalars['Boolean']>;
  isPaidMediaProduct?: Maybe<Scalars['Boolean']>;
  isProposeForDownload?: Maybe<Scalars['Boolean']>;
  isPurchaseOrder?: Maybe<Scalars['Boolean']>;
  isRoutingFileEnabled?: Maybe<Scalars['Boolean']>;
  isShowcase?: Maybe<Scalars['Boolean']>;
  isStockEnabled?: Maybe<Scalars['Boolean']>;
  lowQualityAsset?: Maybe<ProductAsset>;
  maximumOrder?: Maybe<ProductMaximumOrderConfig>;
  maximumOrderExceptions?: Maybe<Array<ProductMaximumOrderException>>;
  minimumOrder?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notifyOnStockLimit?: Maybe<Scalars['Boolean']>;
  numberOfExactOptions?: Maybe<Scalars['Int']>;
  other?: Maybe<Scalars['String']>;
  packagingUnit?: Maybe<Scalars['Int']>;
  packs?: Maybe<Array<Maybe<Product>>>;
  paidMediaCampaignName?: Maybe<Scalars['String']>;
  preorderAvailable?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Price>;
  priceType?: Maybe<PriceTypes>;
  productOptions?: Maybe<Array<Maybe<ProductOption>>>;
  productsInPack?: Maybe<Array<Maybe<ProductPack>>>;
  providerId?: Maybe<Scalars['ID']>;
  providerName?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  requiresOrderValidation?: Maybe<Scalars['Boolean']>;
  salespointGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  shouldHaveAtLeastOneOptionSelected?: Maybe<Scalars['Boolean']>;
  shouldHaveExactOptionsSelected?: Maybe<Scalars['Boolean']>;
  showcaseText?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  stockLimitAlert?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  targeting?: Maybe<Scalars['String']>;
  technicalCharacteristics?: Maybe<Scalars['String']>;
  tips?: Maybe<Scalars['String']>;
  type?: Maybe<AllowedProductType>;
  unitName?: Maybe<Scalars['String']>;
  useEnabledDates?: Maybe<Scalars['Boolean']>;
  useLaunchDate?: Maybe<Scalars['Boolean']>;
  userCanAddFiles?: Maybe<Scalars['Boolean']>;
  userCanComment?: Maybe<Scalars['Boolean']>;
  userCanUpload?: Maybe<Scalars['Boolean']>;
  useSalespointGroups?: Maybe<Scalars['Boolean']>;
  useValidDate?: Maybe<Scalars['Boolean']>;
  variation?: Maybe<Array<Maybe<ProductAttribute>>>;
  variationByQuantity?: Maybe<Array<Maybe<QuantityVariation>>>;
  watermarkPreview?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Float']>;
  workType?: Maybe<BriefSpecClient>;
};


export type ProductProductsInPackArgs = {
  showDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type ProductAsset = {
  __typename?: 'ProductAsset';
  id?: Maybe<Scalars['ID']>;
  mime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  fixed?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductAttributeInput = {
  fixed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductCategory = ChildProductCategory | ParentProductCategory;

export type ProductDetails = {
  __typename?: 'ProductDetails';
  downloads?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  orders?: Maybe<Scalars['Int']>;
  packsQuantity?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['ID']>;
  reference?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductDetailsPagination = {
  __typename?: 'ProductDetailsPagination';
  count?: Maybe<Scalars['Int']>;
  productDetails?: Maybe<Array<Maybe<ProductDetails>>>;
};

export type ProductFilter = {
  __typename?: 'ProductFilter';
  details?: Maybe<ProductFilterDetails>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ProductFilterType>;
};

export type ProductFilterDetails = {
  __typename?: 'ProductFilterDetails';
  options?: Maybe<Array<Maybe<ProductFilterOption>>>;
};

export type ProductFilterGroup = {
  __typename?: 'ProductFilterGroup';
  filters?: Maybe<Array<Maybe<ProductFilter>>>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ProductFilterInput = {
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  category?: InputMaybe<Scalars['ID']>;
  checkbox?: InputMaybe<Scalars['Boolean']>;
  createdAfter?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  keyword?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  providers?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  range?: InputMaybe<ProductFilterRangeValue>;
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Array<InputMaybe<AllowedProductType>>>;
};

export type ProductFilterOption = {
  __typename?: 'ProductFilterOption';
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ProductFilterRangeValue = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export enum ProductFilterType {
  Campaigns = 'campaigns',
  Categories = 'categories',
  Checkbox = 'checkbox',
  CreatedAfter = 'createdAfter',
  Keyword = 'keyword',
  Options = 'options',
  Range = 'range'
}

export type ProductInPack = {
  __typename?: 'ProductInPack';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
};

export type ProductInPackInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  ref?: InputMaybe<Scalars['String']>;
};

export type ProductMaximumOrderConfig = {
  __typename?: 'ProductMaximumOrderConfig';
  period: ProductMaximumOrderPeriod;
  quantity: Scalars['Int'];
};

export type ProductMaximumOrderConfigInput = {
  period: ProductMaximumOrderPeriod;
  quantity: Scalars['Int'];
};

export type ProductMaximumOrderException = {
  __typename?: 'ProductMaximumOrderException';
  period: ProductMaximumOrderPeriod;
  quantity: Scalars['Int'];
  salespointGroupsIds: Array<Scalars['ID']>;
  salespointsIds: Array<Scalars['ID']>;
};

export type ProductMaximumOrderExceptionInput = {
  period: ProductMaximumOrderPeriod;
  quantity: Scalars['Int'];
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ProductMaximumOrderPeriod {
  All = 'ALL',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type ProductMetrics = {
  __typename?: 'ProductMetrics';
  salespointCounts?: Maybe<SalespointCounts>;
  salespointDetails?: Maybe<SalespointDetailsPagination>;
};


export type ProductMetricsSalespointDetailsArgs = {
  tableParams?: InputMaybe<TableParams>;
};

export type ProductMetricsSalespointCountsOutput = {
  __typename?: 'productMetricsSalespointCountsOutput';
  salespointCounts?: Maybe<SalespointCounts>;
};

export type ProductMetricsSalespointDetailsOutput = {
  __typename?: 'productMetricsSalespointDetailsOutput';
  salespointDetails?: Maybe<SalespointDetailsPagination>;
};


export type ProductMetricsSalespointDetailsOutputSalespointDetailsArgs = {
  tableParams?: InputMaybe<TableParams>;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

export type ProductPack = {
  __typename?: 'ProductPack';
  position: Scalars['Int'];
  product: Product;
};

export type ProductPackId = {
  position: Scalars['Int'];
  product: Scalars['ID'];
};

export type ProductPagination = {
  __typename?: 'ProductPagination';
  count?: Maybe<Scalars['Int']>;
  highlightedCount?: Maybe<Scalars['Int']>;
  highlightedProducts?: Maybe<Array<Maybe<Product>>>;
  products?: Maybe<Array<Maybe<Product>>>;
};

export type ProductsAndCount = {
  __typename?: 'ProductsAndCount';
  count?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<Product>>>;
};

export type ProductSort = {
  criteria: ProductSortCriteria;
  direction?: InputMaybe<Direction>;
};

export enum ProductSortCriteria {
  CreatedAt = 'createdAt',
  Name = 'name',
  Price = 'price'
}

export type ProductsPerformancePerOrder = {
  __typename?: 'ProductsPerformancePerOrder';
  caHT?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  isCustomizable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  quantityOrdered?: Maybe<Scalars['Int']>;
  ref?: Maybe<Scalars['String']>;
};

export type ProductsPerformancePerOrderPagination = {
  __typename?: 'ProductsPerformancePerOrderPagination';
  count?: Maybe<Scalars['Int']>;
  productsPerformancePerOrder?: Maybe<Array<Maybe<ProductsPerformancePerOrder>>>;
};

export type ProfilePublishInput = {
  avatar?: InputMaybe<UploadOrGalleryMediaInput>;
  cover?: InputMaybe<UploadOrGalleryMediaInput>;
  publishArgs?: InputMaybe<PublishArgs>;
};

export type PromptBriefResponse = {
  __typename?: 'PromptBriefResponse';
  drafts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  finished?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  textResponse?: Maybe<Scalars['String']>;
};

export type Provider = {
  __typename?: 'Provider';
  additionalAddress?: Maybe<Scalars['String']>;
  additionalInfos?: Maybe<Array<Maybe<AdditionalInfo>>>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  doesBrief?: Maybe<Scalars['Boolean']>;
  doesMkp?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  legalMentions?: Maybe<Scalars['String']>;
  linkedClients?: Maybe<Array<Maybe<ClientWithType>>>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderMailEnabled?: Maybe<Scalars['Boolean']>;
  paidMedia?: Maybe<PaidMedia>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  sendTechnicalData?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  staciExportSlug?: Maybe<Scalars['String']>;
  stripePayment?: Maybe<Scalars['Boolean']>;
  userIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<User>>>;
  usersCount?: Maybe<Scalars['Int']>;
};

export type ProviderInput = {
  additionalAddress?: InputMaybe<Scalars['String']>;
  additionalInfos: Array<InputMaybe<AdditionalInfoInput>>;
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  legalMentions?: InputMaybe<Scalars['String']>;
  linkedClients: Array<InputMaybe<ClientWithTypeInput>>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderMailEnabled: Scalars['Boolean'];
  paidMedia?: InputMaybe<PaidMediaInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  sendTechnicalData?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  staciExportSlug?: InputMaybe<Scalars['String']>;
  stripePayment?: InputMaybe<Scalars['Boolean']>;
  userIds: Array<Scalars['ID']>;
};

export type ProviderInvoice = {
  __typename?: 'ProviderInvoice';
  created_at?: Maybe<Scalars['Date']>;
  filename?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export enum ProviderPresenceManagement {
  Evermaps = 'evermaps',
  Partoo = 'partoo',
  Uberall = 'uberall'
}

export type ProviderShippingFees = {
  __typename?: 'ProviderShippingFees';
  error?: Maybe<Scalars['Boolean']>;
  fees?: Maybe<Scalars['Int']>;
  locationId?: Maybe<Scalars['ID']>;
  providerId?: Maybe<Scalars['ID']>;
};

export type ProviderSimplified = {
  __typename?: 'ProviderSimplified';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export enum ProviderType {
  Brief = 'brief',
  Mkp = 'mkp'
}

export type ProviderTypeInput = {
  providerId: Scalars['ID'];
  providerType: ProviderType;
};

export type ProviderUpdateInput = {
  additionalInfos: Array<InputMaybe<AdditionalInfoInput>>;
  legalMentions?: InputMaybe<Scalars['String']>;
  linkedClients: Array<InputMaybe<ClientWithTypeInput>>;
  name: Scalars['String'];
  orderMailEnabled: Scalars['Boolean'];
  paidMedia?: InputMaybe<PaidMediaInput>;
  sendTechnicalData?: InputMaybe<Scalars['Boolean']>;
  staciExportSlug?: InputMaybe<Scalars['String']>;
  stripePayment?: InputMaybe<Scalars['Boolean']>;
  userIds: Array<InputMaybe<Scalars['ID']>>;
};

export type ProviderWithType = {
  __typename?: 'ProviderWithType';
  providerId: Scalars['ID'];
  providerType: ProviderType;
};

export type ProviderWithTypeInput = {
  providerId: Scalars['ID'];
  providerType: ProviderType;
};

export type PublishArgs = {
  callToAction?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  fromDuplicateId?: InputMaybe<Scalars['ID']>;
  htmlDescription?: InputMaybe<Scalars['String']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  organicTargeting?: InputMaybe<InputOrganicTargeting>;
  rawDescription?: InputMaybe<Scalars['String']>;
  scheduledAt?: InputMaybe<Scalars['String']>;
  socialNetworks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  socialNetworksDescription?: InputMaybe<SocialNetworksDescriptionInput>;
  socialNetworksRawDescription?: InputMaybe<SocialNetworksDescriptionInput>;
  socialNetworkTarget?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Target>;
  type: PostType;
};

export enum PublishAuthorRole {
  All = 'all',
  Local = 'local',
  National = 'national'
}

export type PublishList = {
  __typename?: 'PublishList';
  count?: Maybe<Scalars['Int']>;
  pageInfos?: Maybe<PageInfos>;
  posts?: Maybe<Array<Maybe<PublishListPost>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PublishListPost = {
  __typename?: 'PublishListPost';
  analyze?: Maybe<PostMetrics>;
  author?: Maybe<User>;
  authorRole?: Maybe<SocialAuthorRole>;
  avatar?: Maybe<PublishMedia>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  dynamicLink?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  groupErrors?: Maybe<Array<Maybe<PostErrors>>>;
  id: Scalars['ID'];
  isAmplifiable?: Maybe<Scalars['Boolean']>;
  isAmplified?: Maybe<Scalars['Boolean']>;
  isDeletable?: Maybe<Scalars['Boolean']>;
  isDuplicatable?: Maybe<Scalars['Boolean']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isPostCalendar?: Maybe<Scalars['Boolean']>;
  isTemplatable?: Maybe<Scalars['Boolean']>;
  levelEditable?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  postCalendarId?: Maybe<Scalars['ID']>;
  preview?: Maybe<SocialMediaPostPreview>;
  salesPointTargeted?: Maybe<SalesPoint>;
  scheduledAt?: Maybe<Scalars['Date']>;
  socialNetworkAccountUrl?: Maybe<Scalars['String']>;
  socialNetworkPostUrl?: Maybe<Scalars['String']>;
  socialNetworkTarget: SocialNetwork;
  status?: Maybe<PostStatus>;
  target?: Maybe<PublishListPostTarget>;
  textDescription?: Maybe<Scalars['String']>;
  thumbMobile?: Maybe<Scalars['String']>;
  totalPosts?: Maybe<Scalars['Int']>;
  totalStatus?: Maybe<PostTotalStatus>;
  type?: Maybe<PostType>;
  userCanValidatePost?: Maybe<Scalars['Boolean']>;
  userCanViewPostCalendarDetails?: Maybe<Scalars['Boolean']>;
  validationDate?: Maybe<Scalars['Date']>;
  validator?: Maybe<User>;
  validatorComment?: Maybe<Scalars['String']>;
  validatorRole?: Maybe<ValidatorRole>;
};

export type PublishListPostTarget = {
  __typename?: 'PublishListPostTarget';
  clusters?: Maybe<Array<Maybe<Scalars['ID']>>>;
  globals?: Maybe<Array<Maybe<Scalars['String']>>>;
  onGlobals?: Maybe<Scalars['Boolean']>;
  onSalesPoints?: Maybe<Scalars['Boolean']>;
  salesPoint?: Maybe<SalesPoint>;
  salesPointGroup?: Maybe<SalespointsGroup>;
  salespointGroups?: Maybe<Array<Maybe<Scalars['ID']>>>;
  salespointGroupsCount?: Maybe<Scalars['Int']>;
  salesPoints?: Maybe<Array<Maybe<Scalars['ID']>>>;
  salesPointsCount?: Maybe<Scalars['Int']>;
  salesPointsToExcludeCount?: Maybe<Scalars['Int']>;
  salesPointToExclude?: Maybe<SalesPoint>;
  targetToExclude?: Maybe<Array<Maybe<Scalars['ID']>>>;
  type?: Maybe<TargetType>;
};

export type PublishListPublishedBy = {
  __typename?: 'PublishListPublishedBy';
  hyperspread: Scalars['Boolean'];
  social_media: Scalars['Boolean'];
};

export type PublishListPublishedDate = {
  endAt?: InputMaybe<Scalars['Date']>;
  startAt?: InputMaybe<Scalars['Date']>;
};

export type PublishListPublishedFrom = {
  hyperspread: Scalars['Boolean'];
  social_media: Scalars['Boolean'];
};

export enum PublishListSort {
  Date = 'date',
  Engagement = 'engagement',
  EngagementRate = 'engagementRate',
  Reach = 'reach',
  Status = 'status'
}

export type PublishListSortArgs = {
  by?: InputMaybe<PublishListSort>;
  direction?: InputMaybe<Direction>;
};

export type PublishMedia = {
  __typename?: 'PublishMedia';
  extension?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  mimeType?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type PublishMediaInput = {
  mimeType?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};

export type PublishPayload = {
  __typename?: 'PublishPayload';
  data?: Maybe<SocialMediaPost>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PublishPostsPayload = {
  __typename?: 'PublishPostsPayload';
  data?: Maybe<Array<Maybe<SocialMediaPost>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PublishTotalStats = {
  __typename?: 'PublishTotalStats';
  engagement: Scalars['Int'];
  reach: Scalars['Int'];
  total: Scalars['Int'];
};

export type PublishValidateVideo = {
  action: ValidationActions;
  comment?: InputMaybe<Scalars['String']>;
};

export type QuantitiesPerLocation = {
  __typename?: 'QuantitiesPerLocation';
  locationId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type QuantitiesPerLocationInput = {
  locationId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
};

export type QuantityVariation = {
  __typename?: 'QuantityVariation';
  id: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  values?: Maybe<Scalars['JSON']>;
};

export type QuantityVariationInput = {
  quantity?: InputMaybe<Scalars['Int']>;
  values?: InputMaybe<Scalars['JSON']>;
};

export type Query = {
  __typename?: 'Query';
  allRoles?: Maybe<Array<Maybe<Role>>>;
  briefActivity?: Maybe<BriefActivityPagination>;
  briefById?: Maybe<BriefInterface>;
  briefCampaigns?: Maybe<CampaignPagination>;
  briefCampaignType?: Maybe<Array<Maybe<BriefCampaignType>>>;
  briefComments?: Maybe<BriefCommentsPagination>;
  briefContacts?: Maybe<BriefContactsPagination>;
  briefMedias?: Maybe<BriefMediaPagination>;
  briefOtherTechnicalSpecifications?: Maybe<OtherTechnicalSpecificationsReturn>;
  briefs?: Maybe<BriefsPagination>;
  briefSalesPoints?: Maybe<SalesPointPagination>;
  briefSalesPointsGroups?: Maybe<SalespointsGroupsPagination>;
  briefsCountDocuments?: Maybe<BriefsCountDocuments>;
  briefsForPlanning?: Maybe<Array<Maybe<BriefForPlanning>>>;
  briefSpecClients?: Maybe<Array<Maybe<BriefSpecClient>>>;
  briefTechnicalSpecifications?: Maybe<Array<Maybe<BriefTypeSpecs>>>;
  campaignById?: Maybe<Campaign>;
  campaignCategories?: Maybe<Array<Maybe<CampaignCategory>>>;
  campaignCategoryById?: Maybe<CampaignCategory>;
  campaignDetailActionMetrics?: Maybe<CampaignDetailActionsPagination>;
  campaignMetrics?: Maybe<CampaignMetrics>;
  campaigns?: Maybe<CampaignPagination>;
  campaignsByMonth?: Maybe<Array<Maybe<CampaignsByMonth>>>;
  campaignsPerPeriods?: Maybe<CampaignsPerPeriods>;
  campaignTags?: Maybe<Array<Maybe<Tag>>>;
  canRegister?: Maybe<CanRegisterResult>;
  canResetPassword?: Maybe<Scalars['Boolean']>;
  canUserOrder?: Maybe<Scalars['Boolean']>;
  cart?: Maybe<Cart>;
  checkCartProductsAvailability?: Maybe<Scalars['Boolean']>;
  checkJwtToken?: Maybe<Scalars['Boolean']>;
  checkUberallId: Scalars['Boolean'];
  childProductCategoriesByKeyword?: Maybe<Array<ChildProductCategory>>;
  clientHaveVouchers?: Maybe<Scalars['Boolean']>;
  clientsOfUser?: Maybe<Array<Maybe<ClientInfos>>>;
  createShortURL?: Maybe<ShortUrl>;
  downloadAnswerTemplatesFile?: Maybe<Scalars['String']>;
  downloadBlacklistFile?: Maybe<Scalars['String']>;
  downloadMetrics?: Maybe<DownloadMetrics>;
  downloadMilestonesFile?: Maybe<Scalars['String']>;
  exportAmplifyCampaign?: Maybe<Scalars['String']>;
  exportAmplifyCampaigns?: Maybe<Scalars['String']>;
  exportAmplifyUsersBudget?: Maybe<Scalars['String']>;
  exportNotificationsList: ExportSocialLinks;
  exportPostCalendarPosts: ExportSocialLinks;
  exportPublishList: ExportSocialLinks;
  exportSocialSalesPointStatsList: ExportSocialLinks;
  folderById?: Maybe<Folder>;
  folders?: Maybe<Array<Maybe<Folder>>>;
  getAccountsFromFacebook?: Maybe<AccountsResponse>;
  getAccountsFromLinkedin?: Maybe<AccountsResponse>;
  getAllClients?: Maybe<Array<Maybe<Client>>>;
  getAllHomePageSettings?: Maybe<Array<Maybe<HomePageSettings>>>;
  getAllSsoConfigs?: Maybe<Array<Maybe<Sso>>>;
  getAllUsers?: Maybe<Array<Maybe<User>>>;
  getAmplifyAccountFromSocialNetwork?: Maybe<AdAccountsResponse>;
  getAmplifyAccounts?: Maybe<AmplifyAccountPagination>;
  getAmplifyCampaignAds?: Maybe<AmplifyCampaignAdsList>;
  getAmplifyCampaignAvailableTargets?: Maybe<AmplifyCampaignAvailableTargets>;
  getAmplifyCampaignDetails?: Maybe<AmplifyCampaign>;
  getAmplifyCampaigns?: Maybe<AmplifyCampaignsList>;
  getAmplifyCampaignsTotalMetrics?: Maybe<AmplifyCampaignsTotalMetrics>;
  getAmplifyGlobalAccount?: Maybe<AccountPage>;
  getAnswerTemplate?: Maybe<AnswerTemplate>;
  getAnswerTemplates?: Maybe<AnswerTemplatePayload>;
  getAvailableGoogleAccounts?: Maybe<GoogleAccountsResponse>;
  getBase64PmWithBucketUrl?: Maybe<Scalars['String']>;
  getBlacklist?: Maybe<BlacklistPayload>;
  getChiliConfig?: Maybe<ChiliConfig>;
  getClientInfo?: Maybe<Client>;
  getColorsTheme?: Maybe<ColorsTheme>;
  getCountryList?: Maybe<TargetingPayload>;
  getCustomDynVar: Array<CustomFieldDefinition>;
  getCustomFieldDefinition: CustomFieldDefinition;
  getCustomFieldDefinitionsByAssetType: Array<CustomFieldDefinition>;
  getCustomVisualUrl?: Maybe<Array<Maybe<FileInfo>>>;
  getDefaultFeatures?: Maybe<Array<Maybe<Feature>>>;
  getDirectMarketingRedirection?: Maybe<Scalars['String']>;
  getFeatures?: Maybe<Array<Maybe<Features>>>;
  getGeolocList?: Maybe<TargetingPayload>;
  getGoogleAccountsGroups?: Maybe<Array<Maybe<GoogleAccountsGroup>>>;
  getHashtags?: Maybe<Array<Maybe<Scalars['String']>>>;
  getHelpBlockById?: Maybe<HelpBlock>;
  getHelpBlocksByLang?: Maybe<Array<Maybe<HelpBlock>>>;
  getHomePageSettings?: Maybe<HomePageSettings>;
  getImportFileSpecifications?: Maybe<ImportFileSpecifications>;
  getImportFileSpecificationsForAllSocialNetworks?: Maybe<Array<Maybe<SocialNetworkImportFileSpecifications>>>;
  getInitialOrderedCustomFieldsByAssetType: Array<OrderedCustomField>;
  getInterestList?: Maybe<TargetingPayload>;
  getJwtToken?: Maybe<JwtPayload>;
  getLatestEventExtraInfo?: Maybe<DefaultExtra>;
  getLinkMetadata?: Maybe<LinkMetadata>;
  getLitePostTemplatesList?: Maybe<LitePostTemplateList>;
  getMentionList?: Maybe<MentionPayload>;
  getMilestones?: Maybe<Array<Maybe<Milestone>>>;
  getNbItemsToValidate: NbItemsToValidate;
  getNbOrdersToValidate?: Maybe<Scalars['Int']>;
  getNewsById?: Maybe<News>;
  getNewsList?: Maybe<Array<Maybe<News>>>;
  getNotificationDetails?: Maybe<NotificationDetails>;
  getNotificationsList?: Maybe<NotificationList>;
  getOrderArchiveUrl: Scalars['String'];
  getOrderedProductPDFUrl?: Maybe<Scalars['String']>;
  getPaidMediaCampaign?: Maybe<PaidMediaCampaignLite>;
  getPaidMediaCampaignDailyInsight?: Maybe<Array<Maybe<PaidMediaCampaignMetaDailyStat>>>;
  getPaidMediaCampaignDetails?: Maybe<PaidMediaCampaignMetaDetail>;
  getPaidMediaCampaignList: Array<Maybe<PaidMediaCampaignLite>>;
  getPartnerAuthBridgeLink?: Maybe<AuthBridgeRouterLink>;
  getPartnerAuthBridgeList?: Maybe<Array<Maybe<BridgeRouterLinkList>>>;
  getPaymentDocumentUrl?: Maybe<Scalars['String']>;
  getPaymentMethodById?: Maybe<PaymentMethod>;
  getPmAttributesBySalesPoint?: Maybe<Scalars['JSON']>;
  getPmPhotosBySalesPoint?: Maybe<Scalars['JSON']>;
  getPostCalendarDetails?: Maybe<SocialMediaPost>;
  getPostCalendarPosts: PublishPostsPayload;
  getPostsWebhookList?: Maybe<Array<Maybe<WebhookList>>>;
  getPostTemplateDetails?: Maybe<PostTemplate>;
  getPostTemplateList?: Maybe<PostTemplateList>;
  getProductCategories?: Maybe<Array<ProductCategory>>;
  getProductCategoriesMenu?: Maybe<Array<ParentProductCategory>>;
  getProductCategory?: Maybe<ProductCategory>;
  getProofHqReviewerLink?: Maybe<Scalars['String']>;
  getProviderInvoiceUrl?: Maybe<Scalars['String']>;
  getPublishList?: Maybe<PublishList>;
  getPublishListForCalendar?: Maybe<Array<Maybe<SocialMediaPost>>>;
  getPublishTotalStats: PublishTotalStats;
  getSalespointLinkedSocialNetworkCount: SalesPointLinkedCountResult;
  getSalespointsByIds?: Maybe<Array<Maybe<SalesPoint>>>;
  getSalespointsIdsByGroupId?: Maybe<Array<Maybe<Scalars['ID']>>>;
  getSalespointsIdsByGroupIds?: Maybe<Array<Scalars['ID']>>;
  getSalesPointsTargetNetworkDetailByIds?: Maybe<SalesPointTargetNetworkDetail>;
  getShippingFees?: Maybe<ShippingFees>;
  getSocialCityStats: Array<AnalyzeSocialCityStats>;
  getSocialComparisonStats: AnalyzeComparisonStats;
  getSocialDemographicStats: AnalyzeSocialDemographicStats;
  getSocialGlobalDetails?: Maybe<SocialSalesPointDetails>;
  getSocialModerateCount?: Maybe<SocialModerateCount>;
  getSocialNetworkAccountBySalespointId?: Maybe<AccountPage>;
  getSocialNetworkAccounts?: Maybe<SocialNetworkAccounts>;
  getSocialNetworkGlobalAccount?: Maybe<AccountPage>;
  getSocialNetworkPostDetails?: Maybe<SocialMediaPost>;
  getSocialNetworkSSOLink?: Maybe<Scalars['String']>;
  getSocialNetworkUsers?: Maybe<Array<Maybe<SocialLoginInfos>>>;
  getSocialPerformanceStats: Array<AnalyzeMonthlyStats>;
  getSocialSalesPointDetails?: Maybe<SocialSalesPointDetails>;
  getSocialSalesPointStatsList: AnalyzeSalesPointStatsList;
  getSocialTotalGraphStats: AnalyzeTotalStats;
  getSocialTotalListStats: AnalyzeTotalStats;
  getSsoConfigById?: Maybe<Sso>;
  getStaciExportBySlug?: Maybe<StaciExport>;
  getStaciExports?: Maybe<Array<Maybe<StaciExport>>>;
  getStaciFlux?: Maybe<Array<Maybe<StaciResult>>>;
  getStateSaveChiliBySalespoint?: Maybe<Scalars['Boolean']>;
  getUploadUrls?: Maybe<Array<GetUploadUrlPayload>>;
  getUrlColorCss?: Maybe<ColorCss>;
  getUserAvailableSocialNetworks?: Maybe<Array<Maybe<SocialNetwork>>>;
  getUserInfoByApiKey?: Maybe<ApiKeyUserInfo>;
  getUserSalespointsGroups?: Maybe<Array<Maybe<UserSalesPointsGroup>>>;
  getUserSsoByEmail?: Maybe<SsoSecureInfo>;
  getUserUnpresentedNews?: Maybe<Array<Maybe<News>>>;
  googlePmMetrics?: Maybe<GooglePmMetrics>;
  governance?: Maybe<Governance>;
  governances?: Maybe<Array<Maybe<Governance>>>;
  hasGenerationPdfInProgress?: Maybe<Scalars['Boolean']>;
  hasGlobalAccount?: Maybe<Scalars['Boolean']>;
  hasGlobalAccountData?: Maybe<HasGlobalDataResponse>;
  hierarchyMedia?: Maybe<Array<Maybe<HierarchyDetail>>>;
  highlightedMedias?: Maybe<Array<Maybe<MediasHighlighted>>>;
  isGovernanceEnabled?: Maybe<Scalars['Boolean']>;
  languageSelectOptions?: Maybe<Array<Maybe<LanguageSelectOption>>>;
  me?: Maybe<User>;
  mediaAndProductMetrics?: Maybe<MediaAndProductMetrics>;
  mediaById?: Maybe<Media>;
  mediaFilterGroups?: Maybe<Array<Maybe<MediaFilterGroup>>>;
  medias?: Maybe<MediasPagination>;
  orderDetails?: Maybe<Order>;
  orderDetailsProvider?: Maybe<Order>;
  orderMetrics?: Maybe<OrderMetrics>;
  ordersByParentOrderId?: Maybe<Array<Maybe<Order>>>;
  ordersByProvider?: Maybe<OrderPagination>;
  ordersByUserId?: Maybe<OrderPagination>;
  ordersToValidate?: Maybe<OrderPagination>;
  ordersValidated?: Maybe<OrderPagination>;
  ovGetInvoicesByAffairCode?: Maybe<OvInvoicesResult>;
  ovGetInvoiceUrl?: Maybe<Scalars['String']>;
  packOrderMetrics?: Maybe<PackOrderMetrics>;
  parentOrderById?: Maybe<ParentOrder>;
  payments?: Maybe<Array<Maybe<PaymentInfo>>>;
  paymentSelectOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  platformGraphMetrics?: Maybe<PlatformGraphMetrics>;
  platformListMetricsBySalesPoint?: Maybe<PlatformListMetricsBySalespoint>;
  platformListMetricsByUser?: Maybe<PlatformListMetricsByUser>;
  postTemplateTagDetails?: Maybe<PostTemplateTag>;
  postTemplateTagFilters?: Maybe<Array<Maybe<TagFilter>>>;
  postTemplateTagGroupDetails?: Maybe<PostTemplateTagGroup>;
  postTemplateTagGroups?: Maybe<PostTemplateTagGroupPagination>;
  postTemplateTags?: Maybe<PostTemplateTagsPagination>;
  preorderForCampaign?: Maybe<Preorder>;
  preorders?: Maybe<PreorderPagination>;
  productById?: Maybe<Product>;
  productEditorUrl?: Maybe<ChiliEditorInfo>;
  productFilterGroups?: Maybe<Array<Maybe<ProductFilterGroup>>>;
  productMetrics?: Maybe<ProductMetrics>;
  productMetricsSalespointCounts?: Maybe<ProductMetricsSalespointCountsOutput>;
  productMetricsSalespointDetails?: Maybe<ProductMetricsSalespointDetailsOutput>;
  products?: Maybe<ProductPagination>;
  productsOfTypeExist?: Maybe<Scalars['Boolean']>;
  providerById?: Maybe<Provider>;
  providers?: Maybe<Array<Maybe<Provider>>>;
  providerSalespointsGroups?: Maybe<SalespointsGroupsPagination>;
  providersByClient?: Maybe<Array<Maybe<ProviderSimplified>>>;
  retrievePayments?: Maybe<Array<Maybe<PaymentInfo>>>;
  role?: Maybe<Role>;
  roles?: Maybe<Array<Maybe<Role>>>;
  rolesDetails?: Maybe<Array<Maybe<Role>>>;
  rolesUserCanPromoteTo?: Maybe<Array<Maybe<Role>>>;
  salesPointById?: Maybe<SalesPoint>;
  salespointGroupById?: Maybe<SalespointsGroup>;
  salesPoints?: Maybe<SalesPointPagination>;
  salesPointsByKeyword?: Maybe<SalesPointPagination>;
  salesPointsForGroups?: Maybe<SalesPointPagination>;
  salesPointsGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salesPointsGroupsByKeyword?: Maybe<SalespointsGroupsPagination>;
  salesPointsGroupsBySalesPointIds?: Maybe<SalespointsGroupsPagination>;
  shippingFeesGrid?: Maybe<ShippingFees>;
  shippingList?: Maybe<Array<Maybe<ShippingFees>>>;
  tagById?: Maybe<Tag>;
  tagGroupById?: Maybe<TagGroup>;
  tagGroups?: Maybe<TagGroupPagination>;
  tags?: Maybe<TagsPagination>;
  uberallGraphMetrics?: Maybe<UberallGraphMetrics>;
  userById?: Maybe<User>;
  userRole?: Maybe<Role>;
  users?: Maybe<UsersPagination>;
  voucherByCode?: Maybe<Voucher>;
};


export type QueryBriefActivityArgs = {
  briefId: Scalars['ID'];
  filter?: InputMaybe<BriefActivityFilter>;
  sort?: InputMaybe<BriefActivitySort>;
};


export type QueryBriefByIdArgs = {
  id: Scalars['ID'];
};


export type QueryBriefCampaignsArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBriefCommentsArgs = {
  briefId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BriefCommentsSort>;
};


export type QueryBriefContactsArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBriefMediasArgs = {
  briefId: Scalars['ID'];
  filters?: InputMaybe<BriefMediaFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BriefMediaSort>;
};


export type QueryBriefsArgs = {
  filter?: InputMaybe<BriefsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<SortField>;
};


export type QueryBriefSalesPointsArgs = {
  crm?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBriefSalesPointsGroupsArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryBriefsCountDocumentsArgs = {
  getArchived: Scalars['Boolean'];
};


export type QueryBriefsForPlanningArgs = {
  dateEnd: Scalars['Date'];
  dateStart: Scalars['Date'];
  filter?: InputMaybe<BriefsForPlanningFilter>;
};


export type QueryBriefSpecClientsArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  providerUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignByIdArgs = {
  id: Scalars['ID'];
};


export type QueryCampaignCategoriesArgs = {
  bypassVisibility?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointIds?: InputMaybe<Array<Scalars['ID']>>;
  types?: InputMaybe<Array<CampaignType>>;
};


export type QueryCampaignCategoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryCampaignDetailActionMetricsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  campaignType: CampaignType;
  dateRange: DateRange;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
  tableParams?: InputMaybe<TableParams>;
};


export type QueryCampaignMetricsArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  campaignType: CampaignType;
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCampaignsArgs = {
  bypassVisibility?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  dateRange?: InputMaybe<DateRangeOptional>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isFilteredOnEndDate?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointIds?: InputMaybe<Array<Scalars['ID']>>;
  scopes?: InputMaybe<Array<InputMaybe<CampaignScope>>>;
  sort?: InputMaybe<CampaignSort>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  types?: InputMaybe<Array<CampaignType>>;
};


export type QueryCampaignsByMonthArgs = {
  category?: InputMaybe<Scalars['ID']>;
  periods?: InputMaybe<Array<InputMaybe<Period>>>;
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  scopes?: InputMaybe<Array<InputMaybe<CampaignScope>>>;
  types?: InputMaybe<Array<CampaignType>>;
};


export type QueryCampaignsPerPeriodsArgs = {
  category?: InputMaybe<Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  keyword?: InputMaybe<Scalars['String']>;
  preorderStatuses?: InputMaybe<Array<CampaignPreorderStatus>>;
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointId?: InputMaybe<Scalars['ID']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']>>;
  scopes?: InputMaybe<Array<InputMaybe<CampaignScope>>>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  types: Array<CampaignType>;
};


export type QueryCampaignTagsArgs = {
  scopes?: InputMaybe<Array<InputMaybe<CampaignScope>>>;
  types: Array<CampaignType>;
};


export type QueryCanRegisterArgs = {
  token: Scalars['String'];
};


export type QueryCanResetPasswordArgs = {
  token: Scalars['String'];
};


export type QueryCartArgs = {
  types?: InputMaybe<Array<InputMaybe<CartType>>>;
};


export type QueryCheckJwtTokenArgs = {
  token: Scalars['String'];
};


export type QueryCheckUberallIdArgs = {
  uberallIdentifier: Scalars['String'];
};


export type QueryChildProductCategoriesByKeywordArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryClientsOfUserArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryCreateShortUrlArgs = {
  url: Scalars['String'];
};


export type QueryDownloadMetricsArgs = {
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
  tableParams?: InputMaybe<TableParams>;
};


export type QueryExportAmplifyCampaignArgs = {
  campaignId: Scalars['ID'];
  sort?: InputMaybe<AmplifyAdsListSortArgs>;
};


export type QueryExportAmplifyCampaignsArgs = {
  endAt?: InputMaybe<Scalars['Date']>;
  globals?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postCalendarId?: InputMaybe<Scalars['ID']>;
  salesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  socialNetwork?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<AmplifyCampaignsListSortArgs>;
  startAt?: InputMaybe<Scalars['Date']>;
  target: TargetType;
};


export type QueryExportNotificationsListArgs = {
  filters: NotificationFilters;
};


export type QueryExportPostCalendarPostsArgs = {
  publishId: Scalars['ID'];
};


export type QueryExportPublishListArgs = {
  args: SearchPublishListArgs;
  sort?: InputMaybe<PublishListSortArgs>;
};


export type QueryExportSocialSalesPointStatsListArgs = {
  args: AnalyzeSalesPointStatsListQueryArgs;
  direction?: InputMaybe<Direction>;
  orderBy?: InputMaybe<AnalyzeSalesPointStatsListQueryOrderBy>;
};


export type QueryFolderByIdArgs = {
  id: Scalars['ID'];
};


export type QueryFoldersArgs = {
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Scalars['ID']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sort?: InputMaybe<FolderSort>;
};


export type QueryGetAccountsFromFacebookArgs = {
  nextToken?: InputMaybe<Scalars['String']>;
  previousToken?: InputMaybe<Scalars['String']>;
  socialNetworkUser: Scalars['Int'];
};


export type QueryGetAccountsFromLinkedinArgs = {
  socialNetworkUser: Scalars['Int'];
};


export type QueryGetAllUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAmplifyAccountFromSocialNetworkArgs = {
  nextToken?: InputMaybe<Scalars['String']>;
  previousToken?: InputMaybe<Scalars['String']>;
  socialNetworkUser: Scalars['Int'];
};


export type QueryGetAmplifyAccountsArgs = {
  isLinked?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  socialNetworkUser?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAmplifyCampaignAdsArgs = {
  campaignId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AmplifyAdsListSortArgs>;
};


export type QueryGetAmplifyCampaignAvailableTargetsArgs = {
  postCalendarId: Scalars['ID'];
};


export type QueryGetAmplifyCampaignDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryGetAmplifyCampaignsArgs = {
  endAt?: InputMaybe<Scalars['Date']>;
  globals?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  postCalendarId?: InputMaybe<Scalars['ID']>;
  salesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  socialNetwork?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<AmplifyCampaignsListSortArgs>;
  startAt?: InputMaybe<Scalars['Date']>;
  target: TargetType;
};


export type QueryGetAmplifyCampaignsTotalMetricsArgs = {
  endAt?: InputMaybe<Scalars['Date']>;
  globals?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postCalendarId?: InputMaybe<Scalars['ID']>;
  salesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  socialNetwork?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['Date']>;
  target?: InputMaybe<TargetType>;
};


export type QueryGetAmplifyGlobalAccountArgs = {
  label: Scalars['String'];
};


export type QueryGetAnswerTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryGetAnswerTemplatesArgs = {
  params: AnswerTemplateListInputParams;
};


export type QueryGetAvailableGoogleAccountsArgs = {
  groupId: Scalars['ID'];
  keyword?: InputMaybe<Scalars['String']>;
  socialNetworkUser: Scalars['Int'];
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetBase64PmWithBucketUrlArgs = {
  url: Scalars['String'];
};


export type QueryGetClientInfoArgs = {
  id: Scalars['ID'];
};


export type QueryGetCountryListArgs = {
  query: Scalars['String'];
};


export type QueryGetCustomDynVarArgs = {
  clientId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCustomFieldDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryGetCustomFieldDefinitionsByAssetTypeArgs = {
  assetType: CustomFieldAssetType;
};


export type QueryGetCustomVisualUrlArgs = {
  salesPointId: Scalars['ID'];
};


export type QueryGetGeolocListArgs = {
  query: Scalars['String'];
};


export type QueryGetGoogleAccountsGroupsArgs = {
  socialNetworkUser: Scalars['Int'];
};


export type QueryGetHelpBlockByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetHelpBlocksByLangArgs = {
  lang: AvailableLang;
};


export type QueryGetImportFileSpecificationsArgs = {
  socialNetwork: SocialNetwork;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
  type: ImportFileForPostType;
};


export type QueryGetInitialOrderedCustomFieldsByAssetTypeArgs = {
  assetType: CustomFieldAssetType;
};


export type QueryGetInterestListArgs = {
  query: Scalars['String'];
};


export type QueryGetJwtTokenArgs = {
  email: Scalars['String'];
  iat?: InputMaybe<Scalars['Int']>;
};


export type QueryGetLatestEventExtraInfoArgs = {
  id: Scalars['ID'];
};


export type QueryGetLinkMetadataArgs = {
  link: Scalars['String'];
};


export type QueryGetLitePostTemplatesListArgs = {
  filters?: InputMaybe<PostTemplateListFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PostTemplateListSort>;
};


export type QueryGetMentionListArgs = {
  query: Scalars['String'];
};


export type QueryGetMilestonesArgs = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};


export type QueryGetNewsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetNotificationDetailsArgs = {
  id: Scalars['ID'];
  status: NotificationReplyStatus;
};


export type QueryGetNotificationsListArgs = {
  filters: NotificationFilters;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  toValidate?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetOrderArchiveUrlArgs = {
  orderId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  subId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetOrderedProductPdfUrlArgs = {
  preview?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['ID'];
  subId: Scalars['ID'];
};


export type QueryGetPaidMediaCampaignArgs = {
  clientId: Scalars['String'];
  orderId: Scalars['ID'];
};


export type QueryGetPaidMediaCampaignDailyInsightArgs = {
  networks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paidMediaCampaignId: Scalars['ID'];
};


export type QueryGetPaidMediaCampaignDetailsArgs = {
  networks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paidMediaCampaignId: Scalars['ID'];
};


export type QueryGetPaidMediaCampaignListArgs = {
  filters?: InputMaybe<FilterPaidMedia>;
  salesPointsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryGetPartnerAuthBridgeLinkArgs = {
  email: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryGetPaymentDocumentUrlArgs = {
  forceGeneration?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
};


export type QueryGetPaymentMethodByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetPmAttributesBySalesPointArgs = {
  id: Scalars['ID'];
};


export type QueryGetPmPhotosBySalesPointArgs = {
  id: Scalars['ID'];
};


export type QueryGetPostCalendarDetailsArgs = {
  publishId: Scalars['ID'];
};


export type QueryGetPostCalendarPostsArgs = {
  publishId: Scalars['ID'];
  sort?: InputMaybe<PublishListSortArgs>;
};


export type QueryGetPostTemplateDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryGetPostTemplateListArgs = {
  filters?: InputMaybe<PostTemplateListFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PostTemplateListSort>;
};


export type QueryGetProductCategoriesArgs = {
  parentId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetProductCategoriesMenuArgs = {
  bypassSelectedSalespoint?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetProductCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryGetProofHqReviewerLinkArgs = {
  briefId: Scalars['ID'];
};


export type QueryGetProviderInvoiceUrlArgs = {
  orderId: Scalars['ID'];
  path: Scalars['String'];
};


export type QueryGetPublishListArgs = {
  args: SearchPublishListArgs;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PublishListSortArgs>;
};


export type QueryGetPublishListForCalendarArgs = {
  args: SearchPublishListArgs;
  sort?: InputMaybe<PublishListSortArgs>;
};


export type QueryGetPublishTotalStatsArgs = {
  args: SearchPublishListArgs;
};


export type QueryGetSalespointLinkedSocialNetworkCountArgs = {
  salespointGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointIds?: InputMaybe<Array<Scalars['ID']>>;
  socialNetwork: SocialNetwork;
};


export type QueryGetSalespointsByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryGetSalespointsIdsByGroupIdArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetSalespointsIdsByGroupIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  socialNetwork?: InputMaybe<Scalars['String']>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
};


export type QueryGetSalesPointsTargetNetworkDetailByIdsArgs = {
  salespointGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointIds?: InputMaybe<Array<Scalars['ID']>>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
};


export type QueryGetShippingFeesArgs = {
  id: Scalars['ID'];
};


export type QueryGetSocialCityStatsArgs = {
  args: AnalyzeQueryArgs;
};


export type QueryGetSocialComparisonStatsArgs = {
  args: AnalyzeQueryArgs;
};


export type QueryGetSocialDemographicStatsArgs = {
  args: AnalyzeQueryArgs;
};


export type QueryGetSocialGlobalDetailsArgs = {
  label: Scalars['String'];
};


export type QueryGetSocialModerateCountArgs = {
  salesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryGetSocialNetworkAccountBySalespointIdArgs = {
  salesPointId: Scalars['ID'];
  socialNetwork: SocialNetwork;
};


export type QueryGetSocialNetworkAccountsArgs = {
  isLinked?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  socialNetwork: SocialNetwork;
  socialNetworkUser?: InputMaybe<Scalars['Int']>;
};


export type QueryGetSocialNetworkGlobalAccountArgs = {
  label: Scalars['String'];
  socialNetwork: SocialNetwork;
};


export type QueryGetSocialNetworkPostDetailsArgs = {
  publishId: Scalars['ID'];
};


export type QueryGetSocialNetworkSsoLinkArgs = {
  redirectURL: Scalars['String'];
  socialNetwork: SocialNetwork;
};


export type QueryGetSocialNetworkUsersArgs = {
  socialNetwork: SocialNetwork;
};


export type QueryGetSocialPerformanceStatsArgs = {
  args: AnalyzeQueryArgs;
};


export type QueryGetSocialSalesPointDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryGetSocialSalesPointStatsListArgs = {
  args: AnalyzeSalesPointStatsListQueryArgs;
  direction?: InputMaybe<Direction>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AnalyzeSalesPointStatsListQueryOrderBy>;
};


export type QueryGetSocialTotalGraphStatsArgs = {
  args: AnalyzeQueryArgs;
};


export type QueryGetSocialTotalListStatsArgs = {
  args: AnalyzeQueryArgs;
};


export type QueryGetSsoConfigByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetStaciExportBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryGetStaciFluxArgs = {
  exportSlug?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  success?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<StaciFluxType>;
};


export type QueryGetUploadUrlsArgs = {
  inputs: Array<GetUploadUrlInput>;
};


export type QueryGetUserInfoByApiKeyArgs = {
  apiKey: Scalars['String'];
};


export type QueryGetUserSsoByEmailArgs = {
  email: Scalars['String'];
};


export type QueryGooglePmMetricsArgs = {
  filter?: InputMaybe<GooglePmMetricsFilter>;
};


export type QueryGovernanceArgs = {
  type: GovernanceTypes;
};


export type QueryHasGlobalAccountArgs = {
  label: Scalars['String'];
  socialNetwork?: InputMaybe<SocialNetwork>;
};


export type QueryHasGlobalAccountDataArgs = {
  label: Scalars['String'];
};


export type QueryHierarchyMediaArgs = {
  id: Scalars['ID'];
};


export type QueryHighlightedMediasArgs = {
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
  excludeDisabledForAdmin?: InputMaybe<Scalars['Boolean']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryIsGovernanceEnabledArgs = {
  type: GovernanceTypes;
};


export type QueryMediaAndProductMetricsArgs = {
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryMediaByIdArgs = {
  id: Scalars['ID'];
};


export type QueryMediaFilterGroupsArgs = {
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<InputMaybe<MediaFilterInput>>>;
  folderId?: InputMaybe<Scalars['ID']>;
  types?: InputMaybe<Array<InputMaybe<MediaTypeFilter>>>;
};


export type QueryMediasArgs = {
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
  campaignId?: InputMaybe<Scalars['ID']>;
  excludeDisabledForAdmin?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<InputMaybe<MediaFilterInput>>>;
  folderId?: InputMaybe<Scalars['ID']>;
  includeHighlighted?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  searchInSubfolders?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<MediaSort>;
  types?: InputMaybe<Array<InputMaybe<MediaTypeFilter>>>;
};


export type QueryOrderDetailsArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderDetailsProviderArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderMetricsArgs = {
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryOrdersByParentOrderIdArgs = {
  parentOrderId: Scalars['ID'];
};


export type QueryOrdersByProviderArgs = {
  filter?: InputMaybe<OrderFilter>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  mergeOrders?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  salespointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sort?: InputMaybe<Direction>;
};


export type QueryOrdersByUserIdArgs = {
  filter?: InputMaybe<OrderFilter>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  mergeOrders?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  salespointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sort?: InputMaybe<Direction>;
};


export type QueryOrdersToValidateArgs = {
  filter?: InputMaybe<OrderFilter>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  mergeOrders?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  salespointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sort?: InputMaybe<Direction>;
};


export type QueryOrdersValidatedArgs = {
  filter?: InputMaybe<OrderFilter>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  mergeOrders?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  salespointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sort?: InputMaybe<Direction>;
};


export type QueryOvGetInvoicesByAffairCodeArgs = {
  affairCode: Scalars['String'];
};


export type QueryOvGetInvoiceUrlArgs = {
  affairCode: Scalars['String'];
  date: Scalars['String'];
  format: OvInvoicesFormat;
};


export type QueryPackOrderMetricsArgs = {
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryParentOrderByIdArgs = {
  parentOrderId: Scalars['ID'];
};


export type QueryPlatformGraphMetricsArgs = {
  filter?: InputMaybe<PlatformMetricsFilter>;
};


export type QueryPlatformListMetricsBySalesPointArgs = {
  filter?: InputMaybe<PlatformMetricsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PlatformListMetricsSort>;
};


export type QueryPlatformListMetricsByUserArgs = {
  filter?: InputMaybe<PlatformMetricsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PlatformListMetricsSort>;
};


export type QueryPostTemplateTagDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryPostTemplateTagFiltersArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  postTemplateListFilters?: InputMaybe<PostTemplateListFilters>;
};


export type QueryPostTemplateTagGroupDetailsArgs = {
  id: Scalars['ID'];
};


export type QueryPostTemplateTagGroupsArgs = {
  filter?: InputMaybe<PostTemplateTagsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PostTemplateTagsSort>;
};


export type QueryPostTemplateTagsArgs = {
  filter?: InputMaybe<PostTemplateTagsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PostTemplateTagsSort>;
};


export type QueryPreorderForCampaignArgs = {
  campaignId: Scalars['ID'];
  salesPointId: Scalars['ID'];
};


export type QueryPreordersArgs = {
  filter?: InputMaybe<PreorderFilter>;
  groupsIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Direction>;
  sortBy?: InputMaybe<PreorderSortField>;
};


export type QueryProductByIdArgs = {
  id: Scalars['ID'];
  isQueryFromUpdateProductAdmin?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductEditorUrlArgs = {
  isMedia?: InputMaybe<Scalars['Boolean']>;
  packId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  subId?: InputMaybe<Scalars['String']>;
};


export type QueryProductFilterGroupsArgs = {
  filters?: InputMaybe<Array<InputMaybe<ProductFilterInput>>>;
};


export type QueryProductMetricsArgs = {
  productId: Scalars['ID'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
  tableParams?: InputMaybe<TableParams>;
};


export type QueryProductMetricsSalespointCountsArgs = {
  productId: Scalars['ID'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryProductMetricsSalespointDetailsArgs = {
  productId: Scalars['ID'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']>>;
  tableParams?: InputMaybe<TableParams>;
};


export type QueryProductsArgs = {
  category?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Array<InputMaybe<ProductFilterInput>>>;
  fromPack?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  preorderAvailable?: InputMaybe<Scalars['Boolean']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']>>;
  separateHighlights?: InputMaybe<Scalars['Boolean']>;
  showDisabled?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<ProductSort>;
};


export type QueryProductsOfTypeExistArgs = {
  type: AllowedProductType;
};


export type QueryProviderByIdArgs = {
  providerId: Scalars['ID'];
};


export type QueryProviderSalespointsGroupsArgs = {
  idProvider?: InputMaybe<Scalars['ID']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryProvidersByClientArgs = {
  providerType?: InputMaybe<ProviderType>;
};


export type QueryRetrievePaymentsArgs = {
  orderIds: Array<Scalars['ID']>;
};


export type QueryRoleArgs = {
  roleId: Scalars['ID'];
};


export type QueryRolesDetailsArgs = {
  forkable?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySalesPointByIdArgs = {
  id: Scalars['ID'];
};


export type QuerySalespointGroupByIdArgs = {
  id: Scalars['ID'];
};


export type QuerySalesPointsArgs = {
  filter?: InputMaybe<SalesPointFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SalesPointSort>;
};


export type QuerySalesPointsByKeywordArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
  type?: InputMaybe<SocialLinkType>;
};


export type QuerySalesPointsForGroupsArgs = {
  filter?: InputMaybe<SalesPointFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SalesPointSort>;
};


export type QuerySalesPointsGroupsArgs = {
  filter?: InputMaybe<SalesPointFilter>;
};


export type QuerySalesPointsGroupsByKeywordArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
  includeEmptyGroup?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
  type?: InputMaybe<SocialLinkType>;
};


export type QuerySalesPointsGroupsBySalesPointIdsArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  salesPointIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryShippingListArgs = {
  keyword?: InputMaybe<Scalars['String']>;
};


export type QueryTagByIdArgs = {
  id: Scalars['ID'];
};


export type QueryTagGroupByIdArgs = {
  id: Scalars['ID'];
};


export type QueryTagGroupsArgs = {
  filter?: InputMaybe<TagsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TagGroupsSort>;
};


export type QueryTagsArgs = {
  filter?: InputMaybe<TagsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TagsSort>;
};


export type QueryUberallGraphMetricsArgs = {
  filter?: InputMaybe<UberallMetricsFilter>;
};


export type QueryUserByIdArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<UserSort>;
};


export type QueryVoucherByCodeArgs = {
  code: Scalars['String'];
};

export enum RecommendedValues {
  Non = 'Non',
  Oui = 'Oui'
}

export type ResendInvitationFailure = {
  __typename?: 'ResendInvitationFailure';
  error: Scalars['String'];
  userId: Scalars['ID'];
};

export type ResendInvitationsResult = {
  __typename?: 'ResendInvitationsResult';
  failed: Scalars['Int'];
  failures: Array<ResendInvitationFailure>;
  sent: Scalars['Int'];
  total: Scalars['Int'];
};

export type ResetSalesPointArgs = {
  id: Scalars['ID'];
  socialNetworks: Array<SocialNetwork>;
};

export type ResetSalesPointPayload = {
  __typename?: 'ResetSalesPointPayload';
  success: Scalars['Boolean'];
};

export type Role = {
  __typename?: 'Role';
  absoluteSlug?: Maybe<Scalars['String']>;
  canEdit?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isForkable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<Role>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  permissionsSettings?: Maybe<Array<Maybe<Permission>>>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userCount?: Maybe<Scalars['Int']>;
};

export enum RolesValidator {
  Local = 'local',
  National = 'national'
}

export enum RoleValidator {
  Local = 'local',
  National = 'national'
}

export type SalesPoint = {
  __typename?: 'SalesPoint';
  affairCode?: Maybe<Scalars['String']>;
  catchmentArea?: Maybe<SalesPointCatchmentArea>;
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  commercialZoneName?: Maybe<Scalars['String']>;
  contactDetails?: Maybe<ContactDetails>;
  defaultLocationIds?: Maybe<DefaultLocationIds>;
  defaultLocations?: Maybe<DefaultLocations>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Maybe<Image>>>;
  isAmplifyConnectionOptionAvailable?: Maybe<Scalars['Boolean']>;
  isSalesPointNotIndexed?: Maybe<Scalars['Boolean']>;
  isValidCatchmentForCategory?: Maybe<Scalars['Boolean']>;
  languageOptions?: Maybe<Array<Maybe<LanguageSelectOption>>>;
  /** @deprecated use 'publicLocation' */
  location?: Maybe<Location>;
  locations?: Maybe<Array<Maybe<Location>>>;
  longDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Array<Maybe<Opening>>>;
  orderedCustomFields: Array<OrderedCustomField>;
  ovRegionalDirectorate?: Maybe<Scalars['String']>;
  parentAffairCode?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  phone?: Maybe<Scalars['String']>;
  pmPhotos?: Maybe<Array<Maybe<PmPhoto>>>;
  presenceManagementAttributes?: Maybe<Array<Maybe<PresenceManagementAttributes>>>;
  presenceManagementBrands?: Maybe<Array<Maybe<Scalars['String']>>>;
  presenceManagementIdentifier?: Maybe<Scalars['String']>;
  presenceManagementKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  presenceManagementServices?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  presenceManagementSync?: Maybe<PresenceManagementSync>;
  publicLocation?: Maybe<Location>;
  publicName?: Maybe<Scalars['String']>;
  RCS?: Maybe<Scalars['String']>;
  salespointGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  secondaryName?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  siretCode?: Maybe<Scalars['String']>;
  social?: Maybe<SalesPointSocial>;
  socialDetails?: Maybe<SocialSalesPointDetails>;
  specialOpeningHours?: Maybe<Array<Maybe<SpecialOpeningHours>>>;
  tvaCode?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type SalesPointCatchmentArea = {
  __typename?: 'SalesPointCatchmentArea';
  postalCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  radius?: Maybe<Scalars['Int']>;
  type?: Maybe<SalesPointCatchmentAreaType>;
};

export type SalesPointCatchmentAreaInput = {
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
  radius?: InputMaybe<Scalars['Int']>;
  type: SalesPointCatchmentAreaType;
};

export enum SalesPointCatchmentAreaType {
  PostalCodes = 'postalCodes',
  Radius = 'radius',
  Region = 'region'
}

export type SalespointCounts = {
  __typename?: 'SalespointCounts';
  actions?: Maybe<Scalars['Int']>;
  downloads?: Maybe<Scalars['Int']>;
  orders?: Maybe<Scalars['Int']>;
  totalSalespoints?: Maybe<Scalars['Int']>;
};

export type SalespointDetails = {
  __typename?: 'SalespointDetails';
  actions?: Maybe<Scalars['Int']>;
  downloads?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  orders?: Maybe<Scalars['Int']>;
};

export type SalespointDetailsPagination = {
  __typename?: 'SalespointDetailsPagination';
  count?: Maybe<Scalars['Int']>;
  salespointDetails?: Maybe<Array<Maybe<SalespointDetails>>>;
};

export type SalesPointFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  keyword?: InputMaybe<Scalars['String']>;
  onlyFromUser?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<SalesPointState>;
  updatedAt?: InputMaybe<DateRange>;
};

export type SalespointGroupInput = {
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  medias?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SalesPointGroupsByPaymentMethodId = {
  __typename?: 'SalesPointGroupsByPaymentMethodId';
  paymentMethodId?: Maybe<Scalars['ID']>;
  salesPointGroups?: Maybe<Array<SalespointsGroup>>;
};

export type SalesPointInput = {
  affairCode?: InputMaybe<Scalars['String']>;
  catchmentArea?: InputMaybe<SalesPointCatchmentAreaInput>;
  code?: InputMaybe<Scalars['String']>;
  commercialZoneName?: InputMaybe<Scalars['String']>;
  contactDetails?: InputMaybe<ContactDetailsInput>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  fax?: InputMaybe<Scalars['String']>;
  languageOptions?: InputMaybe<Array<InputMaybe<LanguageSelectOption>>>;
  longDescription?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  openingHours?: InputMaybe<Array<InputMaybe<OpeningInput>>>;
  paymentOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phone?: InputMaybe<Scalars['String']>;
  pmPhotos?: InputMaybe<Array<InputMaybe<PmPhotoInput>>>;
  presenceManagementAttributes?: InputMaybe<Array<InputMaybe<PresenceManagementAttributesInput>>>;
  presenceManagementBrands?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  presenceManagementIdentifier?: InputMaybe<Scalars['String']>;
  presenceManagementKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  presenceManagementServices?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  publicLocation: LocationInput;
  publicName?: InputMaybe<Scalars['String']>;
  RCS?: InputMaybe<Scalars['String']>;
  secondaryName?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  siretCode?: InputMaybe<Scalars['String']>;
  specialOpeningHours?: InputMaybe<Array<InputMaybe<SpecialOpeningHoursInput>>>;
  tvaCode?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SalesPointLicorne = {
  __typename?: 'SalesPointLicorne';
  customerId?: Maybe<Scalars['String']>;
  facebookAccount?: Maybe<AccountPage>;
  googleAccount?: Maybe<AccountPage>;
  id: Scalars['ID'];
  instagramAccount?: Maybe<AccountPage>;
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  linkedinAccount?: Maybe<AccountPage>;
  twitterAccount?: Maybe<AccountPage>;
};

export type SalesPointLinkedAdAccountsInput = {
  facebook?: InputMaybe<Scalars['Boolean']>;
  google?: InputMaybe<Scalars['Boolean']>;
  instagram?: InputMaybe<Scalars['Boolean']>;
  linkedin?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['Boolean']>;
};

export type SalesPointLinkedCountResult = {
  __typename?: 'SalesPointLinkedCountResult';
  linked: Scalars['Int'];
  notLinked: Scalars['Int'];
};

export type SalesPointLinkedPagesInput = {
  facebook?: InputMaybe<Scalars['String']>;
  google?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['Boolean']>;
  linkedin?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

export type SalesPointPagination = {
  __typename?: 'SalesPointPagination';
  count?: Maybe<Scalars['Int']>;
  disabledSalesPointsCount?: Maybe<Scalars['Int']>;
  enabledSalesPointsCount?: Maybe<Scalars['Int']>;
  salesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
};

export type SalesPointPostsCount = {
  __typename?: 'SalesPointPostsCount';
  posts: Scalars['Int'];
  salesPoint: Scalars['String'];
};

export type SalespointsGroup = {
  __typename?: 'SalespointsGroup';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  client: Client;
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  medias?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['ID']>;
  products?: Maybe<Array<Maybe<Product>>>;
  salespointIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  salespoints?: Maybe<Array<Maybe<SalesPoint>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<User>;
};

export type SalespointsGroupsPagination = {
  __typename?: 'SalespointsGroupsPagination';
  count?: Maybe<Scalars['Int']>;
  salesPointsGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
};

export type SalesPointSocial = {
  __typename?: 'SalesPointSocial';
  linkedAdAccounts?: Maybe<SalesPointSocialLinkedPages>;
  linkedPages?: Maybe<SalesPointSocialLinkedPages>;
  location?: Maybe<SalesPointSocialLocation>;
};

export type SalesPointSocialLinkedPages = {
  __typename?: 'SalesPointSocialLinkedPages';
  facebook?: Maybe<Scalars['Boolean']>;
  google?: Maybe<Scalars['Boolean']>;
  instagram?: Maybe<Scalars['Boolean']>;
  linkedin?: Maybe<Scalars['Boolean']>;
  twitter?: Maybe<Scalars['Boolean']>;
};

export type SalesPointSocialLinkedPagesInput = {
  accountId: Scalars['ID'];
  socialNetwork: SocialNetwork;
};

export type SalesPointSocialLocation = {
  __typename?: 'SalesPointSocialLocation';
  facebook?: Maybe<SocialLocation>;
};

export type SalesPointSort = {
  criteria?: InputMaybe<SalesPointSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum SalesPointSortCriteria {
  Address = 'address',
  City = 'city',
  Enabled = 'enabled',
  Name = 'name'
}

export enum SalesPointState {
  All = 'all',
  Disabled = 'disabled',
  Enabled = 'enabled'
}

export type SalesPointTargetNetworkDetail = {
  __typename?: 'SalesPointTargetNetworkDetail';
  facebook?: Maybe<Scalars['Int']>;
  google?: Maybe<Scalars['Int']>;
  instagram?: Maybe<Scalars['Int']>;
  linkedin?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type SalesPointUpdateInput = {
  affairCode?: InputMaybe<Scalars['String']>;
  catchmentArea?: InputMaybe<SalesPointCatchmentAreaInput>;
  code?: InputMaybe<Scalars['String']>;
  commercialZoneName?: InputMaybe<Scalars['String']>;
  contactDetails?: InputMaybe<ContactDetailsInput>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  defaultLocationIds?: InputMaybe<DefaultLocationIdsInput>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  fax?: InputMaybe<Scalars['String']>;
  languageOptions?: InputMaybe<Array<InputMaybe<LanguageSelectOption>>>;
  longDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Array<InputMaybe<OpeningInput>>>;
  paymentOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phone?: InputMaybe<Scalars['String']>;
  pmPhotos?: InputMaybe<Array<InputMaybe<PmPhotoInput>>>;
  presenceManagementAttributes?: InputMaybe<Array<InputMaybe<PresenceManagementAttributesInput>>>;
  presenceManagementBrands?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  presenceManagementIdentifier?: InputMaybe<Scalars['String']>;
  presenceManagementKeywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  presenceManagementServices?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  publicLocation?: InputMaybe<LocationInput>;
  publicName?: InputMaybe<Scalars['String']>;
  RCS?: InputMaybe<Scalars['String']>;
  secondaryName?: InputMaybe<Scalars['String']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  siretCode?: InputMaybe<Scalars['String']>;
  specialOpeningHours?: InputMaybe<Array<InputMaybe<SpecialOpeningHoursInput>>>;
  tvaCode?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum SearchPostStatus {
  Draft = 'draft',
  Moderation = 'moderation',
  Planned = 'planned',
  Posted = 'posted',
  PostedPlanned = 'posted_planned'
}

export type SearchPublishListArgs = {
  accurateTargeting?: InputMaybe<Scalars['Boolean']>;
  clusters?: InputMaybe<Array<Scalars['ID']>>;
  globals?: InputMaybe<Array<Scalars['String']>>;
  groupPublications: Scalars['Boolean'];
  publishedBy: PublishAuthorRole;
  publishedDate: PublishListPublishedDate;
  publishedFrom: PublishListPublishedFrom;
  salesPoints?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  socialNetwork: SocialNetwork;
  status: SearchPostStatus;
  target: TargetType;
};

export type Session = {
  __typename?: 'Session';
  end?: Maybe<Scalars['String']>;
  isAllDay?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type SessionInput = {
  end?: InputMaybe<Scalars['String']>;
  isAllDay?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};

export type SetSalesPointsLinkedAdAccountsInput = {
  id: Scalars['ID'];
  linkedAdAccounts: SalesPointLinkedAdAccountsInput;
};

export type SetSalesPointsLinkedPagesInput = {
  id: Scalars['ID'];
  linkedPages: SalesPointLinkedPagesInput;
};

export type ShippingFees = {
  __typename?: 'ShippingFees';
  enabled?: Maybe<Scalars['Boolean']>;
  freeShipping?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  isAllSalesPoints?: Maybe<Scalars['Boolean']>;
  maxWeight?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  salespointGroupsIds?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salesPointsIds?: Maybe<Array<Maybe<SalesPoint>>>;
  shippingFeesGridPerWeight?: Maybe<Array<Maybe<ShippingFeesPerWeight>>>;
};

export type ShippingFeesByProviders = {
  __typename?: 'ShippingFeesByProviders';
  id: Scalars['ID'];
  shippingFees?: Maybe<ShippingFees>;
};

export type ShippingFeesInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  freeShipping?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isAllSalesPoints?: InputMaybe<Scalars['Boolean']>;
  maxWeight?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salesPointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shippingFeesGridPerWeight: Array<InputMaybe<ShippingFeesPerWeightInput>>;
};

export type ShippingFeesPerWeight = {
  __typename?: 'ShippingFeesPerWeight';
  fees?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ShippingFeesPerWeightInput = {
  fees?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ShopCategoriesOptions = {
  __typename?: 'ShopCategoriesOptions';
  enabled?: Maybe<Scalars['Boolean']>;
  showAllProductsLinkEnabled?: Maybe<Scalars['Boolean']>;
};

export type ShopCategoriesOptionsInput = {
  enabled: Scalars['Boolean'];
  showAllProductsLinkEnabled: Scalars['Boolean'];
};

export type ShopOptions = {
  __typename?: 'ShopOptions';
  billingAddress?: Maybe<BillingAddress>;
  categories?: Maybe<ShopCategoriesOptions>;
  defaultPaymentMethodId?: Maybe<Scalars['ID']>;
  displayStockAlert?: Maybe<Scalars['Boolean']>;
  displayTaxes?: Maybe<Scalars['Boolean']>;
  isShippingFeesEnabled?: Maybe<Scalars['Boolean']>;
  stockAlertRecipients?: Maybe<Array<Maybe<User>>>;
};

export type ShopOptionsInput = {
  billingAddress?: InputMaybe<BillingAddressInput>;
  categories?: InputMaybe<ShopCategoriesOptionsInput>;
  defaultPaymentMethodId?: InputMaybe<Scalars['ID']>;
  displayStockAlert?: InputMaybe<Scalars['Boolean']>;
  displayTaxes?: InputMaybe<Scalars['Boolean']>;
  isShippingFeesEnabled?: InputMaybe<Scalars['Boolean']>;
  stockAlertRecipients?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ShortUrl = {
  __typename?: 'shortUrl';
  created_at?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  long_url?: Maybe<Scalars['String']>;
};

export type SimpleMetricReturn = {
  __typename?: 'SimpleMetricReturn';
  count?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  variationPercentage?: Maybe<Scalars['Float']>;
};

export type SlideImage = {
  __typename?: 'SlideImage';
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  original?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export enum SliderType {
  Classic = 'classic',
  Full = 'full'
}

export type SlidesDetails = {
  __typename?: 'SlidesDetails';
  buttonDisplay?: Maybe<Scalars['Boolean']>;
  buttonText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<SlideImage>;
  order?: Maybe<Scalars['Int']>;
  redirectionLink?: Maybe<Scalars['String']>;
  secondaryText?: Maybe<Scalars['String']>;
  textColor?: Maybe<TextColor>;
  title?: Maybe<Scalars['String']>;
};

export type SlidesDetailsInput = {
  buttonDisplay?: InputMaybe<Scalars['Boolean']>;
  buttonText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['Upload']>;
  order: Scalars['Int'];
  redirectionLink?: InputMaybe<Scalars['String']>;
  secondaryText?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<TextColor>;
  title?: InputMaybe<Scalars['String']>;
};

export enum SocialAuthorRole {
  Local = 'local',
  National = 'national'
}

export type SocialConfig = {
  __typename?: 'SocialConfig';
  businessManagerId?: Maybe<Scalars['String']>;
  facebookSystemUserId?: Maybe<Scalars['String']>;
};

export type SocialConfigInput = {
  businessManagerId?: InputMaybe<Scalars['String']>;
  facebookSystemUserId?: InputMaybe<Scalars['String']>;
};

export type SocialEvent = {
  __typename?: 'SocialEvent';
  callToAction?: Maybe<Scalars['Int']>;
  couponCode?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['Date']>;
  startAt?: Maybe<Scalars['Date']>;
  terms?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum SocialLinkType {
  Ad = 'ad',
  Page = 'page'
}

export type SocialLocation = {
  __typename?: 'SocialLocation';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  facebookCityKey?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type SocialLoginInfos = {
  __typename?: 'SocialLoginInfos';
  accountType?: Maybe<Scalars['String']>;
  connected?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isSystemUser?: Maybe<Scalars['Boolean']>;
  isTokenValid?: Maybe<Scalars['Boolean']>;
  mainAccount?: Maybe<Scalars['Boolean']>;
  socialNetwork?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type SocialMediaPost = {
  __typename?: 'SocialMediaPost';
  adCount?: Maybe<Scalars['Int']>;
  amplifyAvailableTargets?: Maybe<AmplifyCampaignAvailableTargets>;
  analyze?: Maybe<PostMetrics>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  authorRole?: Maybe<SocialAuthorRole>;
  avatar?: Maybe<PublishMedia>;
  caller?: Maybe<Scalars['Int']>;
  callToAction?: Maybe<Scalars['Int']>;
  carouselItems?: Maybe<Array<PostCarouselItem>>;
  cover?: Maybe<PublishMedia>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  dynamicLink?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorStatus?: Maybe<Scalars['String']>;
  event?: Maybe<SocialEvent>;
  htmlDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAmplifiable?: Maybe<Scalars['Boolean']>;
  isAmplified?: Maybe<Scalars['Boolean']>;
  isDeletable?: Maybe<Scalars['Boolean']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  isDuplicatable?: Maybe<Scalars['Boolean']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isPostCalendar?: Maybe<Scalars['Boolean']>;
  isTemplatable?: Maybe<Scalars['Boolean']>;
  levelEditable?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  medias?: Maybe<Array<Maybe<PublishMedia>>>;
  organicTargeting?: Maybe<OrganicTargeting>;
  postCalendarId?: Maybe<Scalars['ID']>;
  preview?: Maybe<SocialMediaPostPreview>;
  rawDescription?: Maybe<Scalars['String']>;
  salesPointTargeted?: Maybe<SalesPoint>;
  scheduledAt?: Maybe<Scalars['Date']>;
  socialNetworkAccountUrl?: Maybe<Scalars['String']>;
  socialNetworkPage?: Maybe<AccountPage>;
  socialNetworkPostId?: Maybe<Scalars['ID']>;
  socialNetworkPostUrl?: Maybe<Scalars['String']>;
  socialNetworks?: Maybe<Array<Maybe<Scalars['String']>>>;
  socialNetworksDescription?: Maybe<SocialNetworksDescriptionType>;
  socialNetworksRawDescription?: Maybe<SocialNetworksDescriptionType>;
  socialNetworkTarget: SocialNetwork;
  status?: Maybe<PostStatus>;
  target?: Maybe<PostTarget>;
  textDescription?: Maybe<Scalars['String']>;
  thumb?: Maybe<PublishMedia>;
  thumbMobile?: Maybe<Scalars['String']>;
  totalPosts?: Maybe<Scalars['Int']>;
  totalStatus?: Maybe<PostTotalStatus>;
  type?: Maybe<PostType>;
  userCanValidatePost?: Maybe<Scalars['Boolean']>;
  userCanViewPostCalendarDetails?: Maybe<Scalars['Boolean']>;
  validationDate?: Maybe<Scalars['Date']>;
  validator?: Maybe<User>;
  validatorComment?: Maybe<Scalars['String']>;
  validatorId?: Maybe<Scalars['ID']>;
  validatorRole?: Maybe<Scalars['String']>;
};

export type SocialMediaPostPreview = {
  __typename?: 'SocialMediaPostPreview';
  caption?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  dates?: Maybe<StartAndEndDates>;
  error?: Maybe<PreviewErrorCodes>;
  promoCode?: Maybe<Scalars['String']>;
  targettedNetworks?: Maybe<Array<Maybe<SocialNetwork>>>;
  type?: Maybe<SocialMediaPostPreviewType>;
  videoThumbnail?: Maybe<Scalars['String']>;
};

export enum SocialMediaPostPreviewType {
  Event = 'event',
  Image = 'image',
  Promotion = 'promotion',
  Text = 'text',
  Video = 'video'
}

export type SocialModerateCount = {
  __typename?: 'SocialModerateCount';
  data?: Maybe<SocialModerateObject>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SocialModerateObject = {
  __typename?: 'SocialModerateObject';
  amplify?: Maybe<Scalars['Int']>;
  posts?: Maybe<Scalars['Int']>;
  replies?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export enum SocialNetwork {
  All = 'all',
  CrossPost = 'cross_post',
  Facebook = 'facebook',
  Google = 'google',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  ReadyToPost = 'ready_to_post',
  Twitter = 'twitter'
}

export type SocialNetworkAccounts = {
  __typename?: 'SocialNetworkAccounts';
  count?: Maybe<Scalars['Int']>;
  pageInfos?: Maybe<PageInfos>;
  socialNetworkAccounts?: Maybe<Array<Maybe<AccountPage>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SocialNetworkImportFileSpecifications = {
  __typename?: 'SocialNetworkImportFileSpecifications';
  socialNetwork?: Maybe<SocialNetwork>;
  socialNetworks?: Maybe<Array<Maybe<SocialNetwork>>>;
  types?: Maybe<Array<Maybe<ImportFileSpecificationsByType>>>;
};

export type SocialNetworksDescriptionInput = {
  facebook?: InputMaybe<Scalars['String']>;
  google?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

export type SocialNetworksDescriptionType = {
  __typename?: 'SocialNetworksDescriptionType';
  facebook?: Maybe<Scalars['String']>;
  google?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

export type SocialOptions = {
  __typename?: 'SocialOptions';
  cronActivated?: Maybe<Scalars['Boolean']>;
  linkedinFeature?: Maybe<Scalars['Boolean']>;
};

export type SocialOptionsInput = {
  cronActivated: Scalars['Boolean'];
  linkedinFeature: Scalars['Boolean'];
};

export type SocialSalespointConfigInput = {
  adAccountsToLink?: InputMaybe<Array<InputMaybe<SalesPointSocialLinkedPagesInput>>>;
  adAccountsToUnlink?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
  pagesToLink?: InputMaybe<Array<InputMaybe<SalesPointSocialLinkedPagesInput>>>;
  pagesToUnlink?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
};

export type SocialSalesPointDetails = {
  __typename?: 'SocialSalesPointDetails';
  customerId?: Maybe<Scalars['String']>;
  facebookAccount?: Maybe<AccountPage>;
  facebookAdAccount?: Maybe<AccountPage>;
  googleAccount?: Maybe<AccountPage>;
  id?: Maybe<Scalars['ID']>;
  instagramAccount?: Maybe<AccountPage>;
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  linkedinAccount?: Maybe<AccountPage>;
  twitterAccount?: Maybe<AccountPage>;
};

export type SocialSalespointsInput = {
  enabled: Scalars['Boolean'];
  facebookUrl: Scalars['String'];
  salesPointId: Scalars['ID'];
  salesPointName?: InputMaybe<Scalars['String']>;
};

export enum SortCriteria {
  Actions = 'actions',
  Downloads = 'downloads',
  Name = 'name',
  Orders = 'orders',
  PacksQuantity = 'packsQuantity',
  Posts = 'posts',
  ProductsInPackCount = 'productsInPackCount',
  QuantityOfProductOrdered = 'quantityOfProductOrdered',
  Reference = 'reference',
  Sessions = 'sessions',
  Turnover = 'turnover',
  TurnoverOfProductOrdered = 'turnoverOfProductOrdered',
  Views = 'views'
}

export type SortField = {
  field: FieldBriefs;
  typeOfSort?: InputMaybe<Scalars['Int']>;
};

export enum SortFileOptions {
  CreationDate = 'creationDate',
  LastUpdate = 'lastUpdate',
  Name = 'name',
  Size = 'size',
  Type = 'type'
}

export type SortInput = {
  criteria?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
};

export type SpecialOpeningHours = {
  __typename?: 'SpecialOpeningHours';
  from?: Maybe<Scalars['Date']>;
  hoursFrom?: Maybe<Scalars['String']>;
  hoursTo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['Date']>;
};

export type SpecialOpeningHoursInput = {
  from?: InputMaybe<Scalars['Date']>;
  hoursFrom?: InputMaybe<Scalars['String']>;
  hoursTo?: InputMaybe<Scalars['String']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['Date']>;
};

export type Sso = {
  __typename?: 'Sso';
  config?: Maybe<Array<Maybe<SsoConfig>>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  ssoProvider?: Maybe<Scalars['String']>;
};

export type SsoConfig = {
  __typename?: 'SsoConfig';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SsoInput = {
  config: Array<SsoInputConfig>;
  name: Scalars['String'];
  ssoProvider: Scalars['String'];
};

export type SsoInputConfig = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type SsoSecureInfo = {
  __typename?: 'SsoSecureInfo';
  id: Scalars['ID'];
  provider: Scalars['String'];
};

export type StaciExport = {
  __typename?: 'StaciExport';
  accountCode?: Maybe<Scalars['String']>;
  committingCode?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  ftpFolder?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  operationCode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  testing?: Maybe<Scalars['Boolean']>;
};

export type StaciExportInput = {
  accountCode?: InputMaybe<Scalars['String']>;
  committingCode: Scalars['String'];
  fileName?: InputMaybe<Scalars['String']>;
  ftpFolder: Scalars['String'];
  operationCode?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  testing: Scalars['Boolean'];
};

export enum StaciFluxType {
  OrdersOut = 'orders_out',
  OrdersStatesIn = 'orders_states_in',
  StocksIn = 'stocks_in'
}

export type StaciImport = {
  __typename?: 'StaciImport';
  fluxId?: Maybe<Scalars['ID']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum StaciImportType {
  Expeditions = 'expeditions',
  Stock = 'stock'
}

export type StaciResult = {
  __typename?: 'StaciResult';
  created_at?: Maybe<Scalars['Date']>;
  error?: Maybe<Scalars['String']>;
  exportSlug?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  fluxId?: Maybe<Scalars['ID']>;
  success?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type StartAndEndDates = {
  __typename?: 'StartAndEndDates';
  end?: Maybe<Scalars['Date']>;
  start?: Maybe<Scalars['Date']>;
};

export enum Status {
  Cancelled = 'cancelled',
  Created = 'created',
  Outdated = 'outdated',
  Processing = 'processing',
  Refused = 'refused',
  ToValidate = 'to_validate',
  Validated = 'validated',
  WaitingValidation = 'waiting_validation'
}

export type StripeConfig = {
  __typename?: 'StripeConfig';
  accountId?: Maybe<Scalars['ID']>;
  onboardingStatus?: Maybe<OnboardingStatus>;
  onboardLink?: Maybe<Scalars['String']>;
};

export enum StripePaymentMethod {
  Card = 'card',
  None = 'none',
  SepaDebit = 'sepa_debit'
}

export type SubActions = {
  __typename?: 'SubActions';
  copies?: Maybe<Scalars['Int']>;
  downloads?: Maybe<Scalars['Int']>;
  orders?: Maybe<Scalars['Int']>;
  posts?: Maybe<Scalars['Int']>;
};

export type TableParams = {
  direction?: InputMaybe<Direction>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortCriteria>;
};

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Maybe<CountyCode>>>;
  createdAt?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  library?: Maybe<TagLibraryInfos>;
  name?: Maybe<Scalars['String']>;
  salespointGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
  shop?: Maybe<TagShopInfos>;
  tagGroup?: Maybe<TagGroup>;
  types?: Maybe<Array<Maybe<TagType>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<User>;
  useSalespoints?: Maybe<Scalars['Boolean']>;
};

export type TagFilter = {
  __typename?: 'TagFilter';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<TagFilterOption>>>;
};

export type TagFilterOption = {
  __typename?: 'TagFilterOption';
  countMatchingTemplates?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type TagGroup = {
  __typename?: 'TagGroup';
  createdAt?: Maybe<Scalars['Date']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  library?: Maybe<TagGroupLibraryInfo>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  salespointGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
  shop?: Maybe<TagGroupShopInfo>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  types?: Maybe<Array<Maybe<TagType>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<User>;
  useSalespoints?: Maybe<Scalars['Boolean']>;
};

export type TagGroupInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  library?: InputMaybe<TagGroupLibraryInfoInput>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salesPointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shop?: InputMaybe<TagGroupShopInfoInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  types?: InputMaybe<Array<InputMaybe<TagType>>>;
  useSalespoints?: InputMaybe<Scalars['Boolean']>;
};

export type TagGroupInputCreation = {
  enabled: Scalars['Boolean'];
  library?: InputMaybe<TagGroupLibraryInfoInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salesPointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shop?: InputMaybe<TagGroupShopInfoInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  types: Array<TagType>;
  useSalespoints: Scalars['Boolean'];
};

export type TagGroupLibraryInfo = {
  __typename?: 'TagGroupLibraryInfo';
  highlightOrder?: Maybe<Scalars['Int']>;
  isHighlighted?: Maybe<Scalars['Boolean']>;
  mediaIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type TagGroupLibraryInfoInput = {
  highlightOrder?: InputMaybe<Scalars['Int']>;
  isHighlighted?: InputMaybe<Scalars['Boolean']>;
};

export type TagGroupPagination = {
  __typename?: 'TagGroupPagination';
  count?: Maybe<Scalars['Int']>;
  tagGroups?: Maybe<Array<TagGroup>>;
};

export type TagGroupShopInfo = {
  __typename?: 'TagGroupShopInfo';
  displayOnProducts?: Maybe<Scalars['Boolean']>;
  productIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type TagGroupShopInfoInput = {
  displayOnProducts?: InputMaybe<Scalars['Boolean']>;
};

export type TagGroupsSort = {
  criteria?: InputMaybe<TagGroupsSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum TagGroupsSortCriteria {
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type TagInput = {
  color?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<InputMaybe<CountyCode>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  library?: InputMaybe<TagLibraryInfosInput>;
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salesPointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shop?: InputMaybe<TagShopInfosInput>;
  tagGroupId?: InputMaybe<Scalars['ID']>;
  types?: InputMaybe<Array<InputMaybe<TagType>>>;
  useSalespoints?: InputMaybe<Scalars['Boolean']>;
};

export type TagInputCreation = {
  color?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<InputMaybe<CountyCode>>>;
  enabled: Scalars['Boolean'];
  label: Scalars['String'];
  library?: InputMaybe<TagLibraryInfosInput>;
  salespointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salesPointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shop?: InputMaybe<TagShopInfosInput>;
  tagGroupId?: InputMaybe<Scalars['ID']>;
  types: Array<TagType>;
  useSalespoints: Scalars['Boolean'];
};

export type TagLibraryInfos = {
  __typename?: 'TagLibraryInfos';
  highlightOrder?: Maybe<Scalars['Int']>;
  isHighlighted?: Maybe<Scalars['Boolean']>;
  medias?: Maybe<Array<Maybe<Media>>>;
};

export type TagLibraryInfosInput = {
  highlightOrder?: InputMaybe<Scalars['Int']>;
  isHighlighted?: InputMaybe<Scalars['Boolean']>;
  medias: Array<InputMaybe<Scalars['ID']>>;
};

export type TagMetrics = {
  __typename?: 'TagMetrics';
  count?: Maybe<Scalars['Int']>;
  payloads?: Maybe<Array<Maybe<TagPayload>>>;
  variationPercentage?: Maybe<Scalars['Float']>;
};

export type TagPayload = {
  __typename?: 'TagPayload';
  extraData?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nbrEvent?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type TagsFilters = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<TagType>>;
};

export type TagShopInfos = {
  __typename?: 'TagShopInfos';
  displayOnProducts?: Maybe<Scalars['Boolean']>;
  products?: Maybe<Array<Maybe<Product>>>;
};

export type TagShopInfosInput = {
  displayOnProducts?: InputMaybe<Scalars['Boolean']>;
  products: Array<InputMaybe<Scalars['ID']>>;
};

export type TagsPagination = {
  __typename?: 'TagsPagination';
  count?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type TagsSort = {
  criteria?: InputMaybe<TagsSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum TagsSortCriteria {
  CreatedAt = 'createdAt',
  Highlighted = 'highlighted',
  Label = 'label',
  UpdatedAt = 'updatedAt'
}

export enum TagType {
  Library = 'library',
  Shop = 'shop'
}

export type Target = {
  clusters?: InputMaybe<Array<Scalars['ID']>>;
  globals?: InputMaybe<Array<Scalars['String']>>;
  onGlobals?: InputMaybe<Scalars['Boolean']>;
  onSalesPoints?: InputMaybe<Scalars['Boolean']>;
  salesPoints?: InputMaybe<Array<Scalars['ID']>>;
  type: TargetType;
};

export type TargetingItem = {
  __typename?: 'TargetingItem';
  facebookKey: Scalars['String'];
  name: Scalars['String'];
};

export type TargetingPayload = {
  __typename?: 'TargetingPayload';
  data?: Maybe<Array<Maybe<TargetingItem>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum TargetType {
  All = 'all',
  AllSalesPoints = 'all_sales_points',
  AllTarget = 'all_target',
  Cluster = 'cluster',
  Global = 'global',
  NoTarget = 'no_target',
  SalesPoint = 'sales_point'
}

export enum TargetTypes {
  All = 'all',
  Salespoints = 'salespoints'
}

export type TempFileInput = {
  name: Scalars['String'];
  tempPath: Scalars['String'];
};

export enum TemplatablePostType {
  Album = 'album',
  Carousel = 'carousel',
  Event = 'event',
  Gif = 'gif',
  Link = 'link',
  Offer = 'offer',
  Photo = 'photo',
  Profile = 'profile',
  Status = 'status',
  Story = 'story',
  Video = 'video'
}

export enum TextColor {
  Dark = 'dark',
  Light = 'light'
}

export type TextCustomFieldConfig = {
  __typename?: 'TextCustomFieldConfig';
  dynVar: Scalars['Boolean'];
  paragraph: Scalars['Boolean'];
};

export type TextCustomFieldConfigInput = {
  dynVar: Scalars['Boolean'];
  paragraph: Scalars['Boolean'];
};

export type TotalPostsCount = {
  __typename?: 'TotalPostsCount';
  total: Scalars['Int'];
};

export type Transfer = {
  __typename?: 'Transfer';
  amount?: Maybe<Scalars['Int']>;
  orderNumber?: Maybe<Scalars['ID']>;
  providerId?: Maybe<Scalars['ID']>;
  stripeAccountId?: Maybe<Scalars['ID']>;
  stripeFee?: Maybe<Scalars['Int']>;
  stripeUrl?: Maybe<Scalars['String']>;
  transferId?: Maybe<Scalars['ID']>;
  transferOriginId?: Maybe<Scalars['ID']>;
  userEmail?: Maybe<Scalars['String']>;
};

export type TurnoverAndOrdersPerDay = {
  __typename?: 'TurnoverAndOrdersPerDay';
  date?: Maybe<Scalars['Date']>;
  orders?: Maybe<Scalars['Int']>;
  turnover?: Maybe<Scalars['Int']>;
};

export type TurnoverPerSalespoint = {
  __typename?: 'TurnoverPerSalespoint';
  data?: Maybe<Array<Maybe<TurnoverPerSalespointData>>>;
  total?: Maybe<Scalars['Int']>;
};

export type TurnoverPerSalespointData = {
  __typename?: 'TurnoverPerSalespointData';
  salespointId?: Maybe<Scalars['ID']>;
  turnover?: Maybe<Scalars['Int']>;
};

export enum TypePhotosPresenceManagementPartoo {
  Logo = 'LOGO',
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum TypePhotosPresenceManagementUberall {
  AppleLandscape = 'APPLE_LANDSCAPE',
  AtWork = 'AT_WORK',
  CommonArea = 'COMMON_AREA',
  DoctorComPortrait = 'DOCTOR_COM_PORTRAIT',
  Exterior = 'EXTERIOR',
  FacebookLandscape = 'FACEBOOK_LANDSCAPE',
  FoodAndDrink = 'FOOD_AND_DRINK',
  Interior = 'INTERIOR',
  Landscape = 'LANDSCAPE',
  Logo = 'LOGO',
  Main = 'MAIN',
  Menu = 'MENU',
  Photo = 'PHOTO',
  Product = 'PRODUCT',
  Rooms = 'ROOMS',
  SquaredLogo = 'SQUARED_LOGO',
  StorefinderCover = 'STOREFINDER_COVER',
  StorefinderLogo = 'STOREFINDER_LOGO',
  Teams = 'TEAMS'
}

export type TypesLabel = {
  __typename?: 'TypesLabel';
  activityTypeLabel?: Maybe<Scalars['String']>;
  budgetTypeLabel?: Maybe<Scalars['String']>;
  communicationTypeLabel?: Maybe<Scalars['String']>;
  modelTypeLabel?: Maybe<Scalars['String']>;
};

export type UberallBusinessInfo = {
  __typename?: 'UberallBusinessInfo';
  businessId: Scalars['String'];
  isEverySalesPointsNotIndexed?: Maybe<Scalars['Boolean']>;
  privateKey?: Maybe<Scalars['String']>;
};

export type UberallGraphClicksMetrics = {
  __typename?: 'UberallGraphClicksMetrics';
  driving_direction?: Maybe<Array<InfoPerDay>>;
  phone?: Maybe<Array<InfoPerDay>>;
  website?: Maybe<Array<InfoPerDay>>;
};

export type UberallGraphMetrics = {
  __typename?: 'UberallGraphMetrics';
  metrics?: Maybe<UberallGraphMetricsFields>;
  total?: Maybe<UberallGraphTotalMetrics>;
};

export type UberallGraphMetricsFields = {
  __typename?: 'UberallGraphMetricsFields';
  clicks?: Maybe<UberallGraphClicksMetrics>;
  search?: Maybe<UberallGraphSearchMetrics>;
  views?: Maybe<UberallGraphViewsMetrics>;
};

export type UberallGraphSearchMetrics = {
  __typename?: 'UberallGraphSearchMetrics';
  direct?: Maybe<Scalars['Int']>;
  indirect?: Maybe<Scalars['Int']>;
};

export type UberallGraphTotalMetrics = {
  __typename?: 'UberallGraphTotalMetrics';
  clicks?: Maybe<SimpleMetricReturn>;
  search?: Maybe<SimpleMetricReturn>;
  views?: Maybe<SimpleMetricReturn>;
};

export type UberallGraphViewsMetrics = {
  __typename?: 'UberallGraphViewsMetrics';
  maps?: Maybe<Array<InfoPerDay>>;
  search?: Maybe<Array<InfoPerDay>>;
};

export type UberallListMetric = {
  __typename?: 'UberallListMetric';
  metrics?: Maybe<UberallListMetricLine>;
  salespoint: Scalars['String'];
};

export type UberallListMetricLine = {
  __typename?: 'UberallListMetricLine';
  clicks?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['Int']>;
  views?: Maybe<Scalars['Int']>;
};

export type UberallListMetricsType = {
  __typename?: 'UberallListMetricsType';
  metrics?: Maybe<Array<Maybe<UberallListMetric>>>;
};

export type UberallMetricsFilter = {
  dateRange: DateRange;
  salespointId?: InputMaybe<Scalars['ID']>;
  type: UberallMetricTypes;
};

export enum UberallMetricTypes {
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

export type UpdateChiliDetails = {
  documentDownloadSettingsId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  documentViewPrefsId?: InputMaybe<Scalars['String']>;
  documentWorkspaceId?: InputMaybe<Scalars['String']>;
  exportTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateCustomFieldDefinitionInput = {
  choiceConfig?: InputMaybe<ChoiceCustomFieldConfigInput>;
  dateConfig?: InputMaybe<DateCustomFieldConfigInput>;
  description: Scalars['String'];
  isDisplayedInExport?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
  multipleChoiceConfig?: InputMaybe<MultipleChoiceCustomFieldConfigInput>;
  numberConfig?: InputMaybe<NumberCustomFieldConfigInput>;
  slug: Scalars['String'];
  textConfig?: InputMaybe<TextCustomFieldConfigInput>;
  visible: Scalars['Boolean'];
};

export type UpdateFolderInput = {
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  validFrom?: InputMaybe<Scalars['Date']>;
  validTo?: InputMaybe<Scalars['Date']>;
};

export type UpdateMediaDetails = {
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tips?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['Date']>;
  validTo?: InputMaybe<Scalars['Date']>;
};

export type UpdateRoleInput = {
  name: Scalars['String'];
  permissionsSettings: Array<InputMaybe<PermissionInput>>;
  slug: Scalars['String'];
};

export type UploadCustomizableItemPdfInput = {
  productId: Scalars['ID'];
  subId: Scalars['ID'];
};

export enum UploadedFileType {
  All = 'all',
  Audio = 'audio',
  Document = 'document',
  Image = 'image',
  Other = 'other',
  Video = 'video'
}

export enum UploadFormat {
  Cson = 'cson',
  Csv = 'csv',
  Hjson = 'hjson',
  Ini = 'ini',
  Json = 'json',
  Json5 = 'json5',
  Toml = 'toml',
  Xls = 'xls',
  Xlsx = 'xlsx',
  Yaml = 'yaml'
}

export type UploadOrGalleryMediaInput = {
  fileToUpload?: InputMaybe<Scalars['Upload']>;
  media?: InputMaybe<PublishMediaInput>;
  position: Scalars['Int'];
};

export type UploadProviderInvoiceResponse = {
  __typename?: 'UploadProviderInvoiceResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UrlByPage = {
  __typename?: 'UrlByPage';
  page?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  activity?: Maybe<Scalars['String']>;
  amplifyBudget?: Maybe<UserAmplifyBudget>;
  canEdit?: Maybe<Scalars['Boolean']>;
  cart?: Maybe<Cart>;
  client: Client;
  clientId?: Maybe<Scalars['String']>;
  clients?: Maybe<Array<Maybe<Client>>>;
  createdAt?: Maybe<Scalars['Date']>;
  defaultStoreId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstname?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  hasGovernanceApplied?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  languagePreference?: Maybe<PlatformLanguageOption>;
  lastActivityDay?: Maybe<Scalars['Date']>;
  lastname?: Maybe<Scalars['String']>;
  loginViaSso?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  orders?: Maybe<OrderPagination>;
  phone?: Maybe<Scalars['String']>;
  providerBriefClientId?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['ID']>;
  providerInfo?: Maybe<Provider>;
  registered?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Role>;
  salesPointGroups?: Maybe<Array<Maybe<SalespointsGroup>>>;
  salesPoints?: Maybe<Array<Maybe<SalesPoint>>>;
  selectedSalesPoint?: Maybe<SalesPoint>;
  selectedSalesPointId?: Maybe<Scalars['ID']>;
};


export type UserCartArgs = {
  types?: InputMaybe<Array<InputMaybe<CartType>>>;
};


export type UserHasGovernanceAppliedArgs = {
  type: GovernanceTypes;
};


export type UserOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Direction>;
};


export type UserSalesPointsArgs = {
  socialNetwork?: InputMaybe<Scalars['String']>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>>>;
};

export type UserAmplifyBudget = {
  __typename?: 'UserAmplifyBudget';
  budgetIsLimited?: Maybe<Scalars['Boolean']>;
  datesAreLimited?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['Date']>;
  granted?: Maybe<Scalars['Int']>;
  leftToSpend?: Maybe<Scalars['Float']>;
  spent?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['Date']>;
  userId?: Maybe<Scalars['ID']>;
};

export type UserFilter = {
  absoluteRoleSlug?: InputMaybe<Scalars['String']>;
  absoluteRoleSlugs?: InputMaybe<Array<Scalars['String']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  requiredPermissions?: InputMaybe<Array<Scalars['String']>>;
  roleId?: InputMaybe<Scalars['ID']>;
};

export type UserIdObj = {
  __typename?: 'UserIdObj';
  id?: Maybe<Scalars['ID']>;
};

export type UserInput = {
  activity: Scalars['String'];
  defaultStoreId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  languagePreference?: InputMaybe<PlatformLanguageOption>;
  lastname: Scalars['String'];
  mobilePhone?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

export type UserMailInfo = {
  languagePreference?: InputMaybe<PlatformLanguageOption>;
  providerId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  clientId: Scalars['String'];
  email: Scalars['String'];
  iat: Scalars['Float'];
};

export type UserSalesPointCount = {
  __typename?: 'UserSalesPointCount';
  salespointCount?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['ID']>;
};

export type UserSalesPointsGroup = {
  __typename?: 'UserSalesPointsGroup';
  enabled?: Maybe<Scalars['Boolean']>;
  groupId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  salespointsCount?: Maybe<Scalars['Int']>;
};

export type UsersMail = {
  email: Scalars['String'];
  languagePreference: Scalars['String'];
};

export type UserSort = {
  criteria?: InputMaybe<UserSortCriteria>;
  direction?: InputMaybe<Direction>;
};

export enum UserSortCriteria {
  Name = 'name',
  Role = 'role'
}

export type UsersPagination = {
  __typename?: 'UsersPagination';
  count?: Maybe<Scalars['Int']>;
  providerId?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type UserSsoInput = {
  activity: Scalars['String'];
  defaultStoreId?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  mobilePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UserToCreateInput = {
  activity: Scalars['String'];
  defaultStoreId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  languagePreference?: InputMaybe<PlatformLanguageOption>;
  lastname: Scalars['String'];
  loginMode: LoginMode;
  mobilePhone?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['ID']>;
  roleId: Scalars['ID'];
  salesPointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salespoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UserUpdate = {
  activity?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  firstname?: InputMaybe<Scalars['String']>;
  languagePreference?: InputMaybe<PlatformLanguageOption>;
  lastname?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export enum ValidationActions {
  Rejected = 'rejected',
  Validate = 'validate'
}

export type ValidationPayload = {
  __typename?: 'ValidationPayload';
  mode?: Maybe<GovernanceMode>;
  salesPointId?: Maybe<Scalars['ID']>;
  validatorRole?: Maybe<RolesValidator>;
};

export enum ValidatorRole {
  Local = 'local',
  National = 'national'
}

export enum ValidatorTypes {
  Local = 'local',
  National = 'national'
}

export type Voucher = {
  __typename?: 'Voucher';
  amount?: Maybe<Scalars['Int']>;
  clientId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  cumulative?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  singleUse?: Maybe<Scalars['Boolean']>;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};

export type VoucherInput = {
  amount: Scalars['Int'];
  code: Scalars['String'];
  cumulative: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  singleUse: Scalars['Boolean'];
  validFrom: Scalars['Date'];
  validTo: Scalars['Date'];
};

export type WebhookData = {
  __typename?: 'WebhookData';
  author?: Maybe<Scalars['String']>;
  authorId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  postAt?: Maybe<Scalars['String']>;
  socialNetworkAccountId?: Maybe<Scalars['String']>;
  socialNetworkNotificationId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type WebhookList = {
  __typename?: 'WebhookList';
  facebookPage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  postCalendarId?: Maybe<Scalars['ID']>;
  socialNetworkPostId?: Maybe<Scalars['ID']>;
  webhookData?: Maybe<WebhookData>;
};

export type CreateAnswerTemplateMutationVariables = Exact<{
  answerTemplate: AnswerTemplateInput;
}>;


export type CreateAnswerTemplateMutation = { __typename?: 'Mutation', createAnswerTemplate?: { __typename?: 'AnswerTemplate', id?: string | null, clientId?: string | null, name?: string | null, message?: string | null, rating?: Array<AnswerTemplateRating | null> | null, enabled?: boolean | null, language?: AvailableLanguages | null, types?: Array<NotificationsTypes | null> | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type ToggleAnswerTemplateStatusMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToggleAnswerTemplateStatusMutation = { __typename?: 'Mutation', toggleAnswerTemplateStatus?: boolean | null };

export type UpdateAnswerTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: AnswerTemplateUpdateInput;
}>;


export type UpdateAnswerTemplateMutation = { __typename?: 'Mutation', updateAnswerTemplate?: { __typename?: 'AnswerTemplate', name?: string | null, message?: string | null, rating?: Array<AnswerTemplateRating | null> | null, enabled?: boolean | null, language?: AvailableLanguages | null, types?: Array<NotificationsTypes | null> | null } | null };

export type GetAnswerTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAnswerTemplateQuery = { __typename?: 'Query', getAnswerTemplate?: { __typename?: 'AnswerTemplate', id?: string | null, clientId?: string | null, name?: string | null, message?: string | null, rating?: Array<AnswerTemplateRating | null> | null, enabled?: boolean | null, language?: AvailableLanguages | null, types?: Array<NotificationsTypes | null> | null, createdAt?: any | null, updatedAt?: any | null } | null };

export type GetAnswerTemplatesQueryVariables = Exact<{
  params: AnswerTemplateListInputParams;
}>;


export type GetAnswerTemplatesQuery = { __typename?: 'Query', getAnswerTemplates?: { __typename?: 'AnswerTemplatePayload', count?: number | null, answerTemplates?: Array<{ __typename?: 'AnswerTemplate', id?: string | null, clientId?: string | null, name?: string | null, message?: string | null, rating?: Array<AnswerTemplateRating | null> | null, enabled?: boolean | null, language?: AvailableLanguages | null, types?: Array<NotificationsTypes | null> | null, createdAt?: any | null, updatedAt?: any | null } | null> | null } | null };

export type CreateCustomFieldDefinitionMutationVariables = Exact<{
  input: CreateCustomFieldDefinitionInput;
}>;


export type CreateCustomFieldDefinitionMutation = { __typename?: 'Mutation', createCustomFieldDefinition: { __typename?: 'CustomFieldDefinition', id: string } };

export type UpdateCustomFieldMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateCustomFieldDefinitionInput;
}>;


export type UpdateCustomFieldMutation = { __typename?: 'Mutation', updateCustomFieldDefinition: { __typename?: 'CustomFieldDefinition', id: string, assetType: CustomFieldAssetType, type: CustomFieldType, clientId: string, slug: string, label: string, visible: boolean, description?: string | null, updatedAt: any, isDisplayedInExport: boolean, updatedBy: { __typename?: 'User', fullName?: string | null }, textConfig?: { __typename?: 'TextCustomFieldConfig', paragraph: boolean, dynVar: boolean } | null, numberConfig?: { __typename?: 'NumberCustomFieldConfig', precision: number } | null, choiceConfig?: { __typename?: 'ChoiceCustomFieldConfig', displayType: ChoiceDisplayType, options: Array<string> } | null, multipleChoiceConfig?: { __typename?: 'MultipleChoiceCustomFieldConfig', displayType: MultipleChoiceDisplayType, options: Array<string> } | null, dateConfig?: { __typename?: 'DateCustomFieldConfig', isDateTime: boolean, timezone: string } | null } };

export type GetCustomFieldDefinitionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCustomFieldDefinitionQuery = { __typename?: 'Query', getCustomFieldDefinition: { __typename?: 'CustomFieldDefinition', id: string, assetType: CustomFieldAssetType, type: CustomFieldType, clientId: string, slug: string, label: string, visible: boolean, description?: string | null, isDisplayedInExport: boolean, updatedAt: any, updatedBy: { __typename?: 'User', fullName?: string | null }, textConfig?: { __typename?: 'TextCustomFieldConfig', paragraph: boolean, dynVar: boolean } | null, numberConfig?: { __typename?: 'NumberCustomFieldConfig', precision: number } | null, choiceConfig?: { __typename?: 'ChoiceCustomFieldConfig', displayType: ChoiceDisplayType, options: Array<string> } | null, multipleChoiceConfig?: { __typename?: 'MultipleChoiceCustomFieldConfig', displayType: MultipleChoiceDisplayType, options: Array<string> } | null, dateConfig?: { __typename?: 'DateCustomFieldConfig', isDateTime: boolean, timezone: string } | null } };

export type ToggleCustomFieldDefinitionVisibilityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToggleCustomFieldDefinitionVisibilityMutation = { __typename?: 'Mutation', toggleCustomFieldDefinitionVisibility: { __typename?: 'CustomFieldDefinition', id: string, updatedAt: any, visible: boolean } };

export type GetCustomFieldDefinitionsByAssetTypeQueryVariables = Exact<{
  assetType: CustomFieldAssetType;
}>;


export type GetCustomFieldDefinitionsByAssetTypeQuery = { __typename?: 'Query', getCustomFieldDefinitionsByAssetType: Array<{ __typename?: 'CustomFieldDefinition', id: string, label: string, slug: string, type: CustomFieldType, updatedAt: any, visible: boolean }> };

export type GetInitialOrderedCustomFieldsByAssetTypeQueryVariables = Exact<{
  assetType: CustomFieldAssetType;
}>;


export type GetInitialOrderedCustomFieldsByAssetTypeQuery = { __typename?: 'Query', getInitialOrderedCustomFieldsByAssetType: Array<{ __typename?: 'OrderedCustomField', textValue?: string | null, numberValue?: number | null, choiceValue?: string | null, multipleChoiceValue?: Array<string> | null, dateValue?: any | null, definition: { __typename?: 'CustomFieldDefinition', id: string, type: CustomFieldType, label: string, description?: string | null, textConfig?: { __typename?: 'TextCustomFieldConfig', paragraph: boolean, dynVar: boolean } | null, numberConfig?: { __typename?: 'NumberCustomFieldConfig', precision: number } | null, choiceConfig?: { __typename?: 'ChoiceCustomFieldConfig', displayType: ChoiceDisplayType, options: Array<string> } | null, multipleChoiceConfig?: { __typename?: 'MultipleChoiceCustomFieldConfig', displayType: MultipleChoiceDisplayType, options: Array<string> } | null, dateConfig?: { __typename?: 'DateCustomFieldConfig', isDateTime: boolean, timezone: string } | null } }> };

export type OrderedCustomFieldFragmentFragment = { __typename?: 'OrderedCustomField', textValue?: string | null, numberValue?: number | null, choiceValue?: string | null, multipleChoiceValue?: Array<string> | null, dateValue?: any | null, definition: { __typename?: 'CustomFieldDefinition', id: string, type: CustomFieldType, label: string, description?: string | null, textConfig?: { __typename?: 'TextCustomFieldConfig', paragraph: boolean, dynVar: boolean } | null, numberConfig?: { __typename?: 'NumberCustomFieldConfig', precision: number } | null, choiceConfig?: { __typename?: 'ChoiceCustomFieldConfig', displayType: ChoiceDisplayType, options: Array<string> } | null, multipleChoiceConfig?: { __typename?: 'MultipleChoiceCustomFieldConfig', displayType: MultipleChoiceDisplayType, options: Array<string> } | null, dateConfig?: { __typename?: 'DateCustomFieldConfig', isDateTime: boolean, timezone: string } | null } };

export type CreatePdfThumbnailMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type CreatePdfThumbnailMutation = { __typename?: 'Mutation', createPdfThumbnail?: string | null };

export type FeaturesSelect_GetFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesSelect_GetFeaturesQuery = { __typename?: 'Query', getFeatures?: Array<Features | null> | null };

export type SwitchOrganisationMutationVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type SwitchOrganisationMutation = { __typename?: 'Mutation', switchOrganisation?: { __typename?: 'Credentials', jwToken?: string | null, clientId?: string | null } | null };

export type SpAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpAddressesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, selectedSalesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, code?: string | null, defaultLocations?: { __typename?: 'DefaultLocations', shipping?: { __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null, billing?: { __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null } | null, publicLocation?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null, locations?: Array<{ __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null> | null } | null } | null };

export type AddOrderMessageMutationVariables = Exact<{
  orderId: Scalars['ID'];
  content: Scalars['String'];
}>;


export type AddOrderMessageMutation = { __typename?: 'Mutation', addOrderMessage?: { __typename?: 'Order', messages?: Array<{ __typename?: 'OrderMessage', id: string, content?: string | null, createdAt?: any | null, isCancelledReason?: boolean | null }> | null } | null };

export type AdminProductCategoriesList_SetProductCategoryEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type AdminProductCategoriesList_SetProductCategoryEnabledMutation = { __typename?: 'Mutation', setProductCategoryEnabled?: { __typename?: 'ChildProductCategory', id: string, enabled: boolean } | { __typename?: 'ParentProductCategory', id: string, enabled: boolean } | null };

export type SetProductCategoryPositionMutationVariables = Exact<{
  id: Scalars['ID'];
  position: Scalars['Int'];
}>;


export type SetProductCategoryPositionMutation = { __typename?: 'Mutation', setProductCategoryPosition: { __typename?: 'ChildProductCategory', id: string, position: number } | { __typename?: 'ParentProductCategory', id: string, position: number } };

export type GetStockAlertSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStockAlertSettingQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, shopOptions?: { __typename?: 'ShopOptions', displayStockAlert?: boolean | null } | null } } | null };

export type SmartSelectCampaignsQueryVariables = Exact<{
  types?: InputMaybe<Array<CampaignType> | CampaignType>;
  keyword?: InputMaybe<Scalars['String']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SmartSelectCampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignPagination', campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null } | null };

export type SmartSelectCampaignCategoriesQueryVariables = Exact<{
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  types?: InputMaybe<Array<CampaignType> | CampaignType>;
}>;


export type SmartSelectCampaignCategoriesQuery = { __typename?: 'Query', campaignCategories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null } | null> | null };

export type SmartSelectMediasQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SmartSelectMediasQuery = { __typename?: 'Query', medias?: { __typename?: 'MediasPagination', medias?: Array<{ __typename?: 'LiteMedia', id: string, name?: string | null } | null> | null } | null };

export type SmartSelectPostTemplatesQueryVariables = Exact<{
  filters?: InputMaybe<PostTemplateListFilters>;
  sort?: InputMaybe<PostTemplateListSort>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SmartSelectPostTemplatesQuery = { __typename?: 'Query', getPostTemplateList?: { __typename?: 'PostTemplateList', templates?: Array<{ __typename?: 'PostTemplate', id?: string | null, mongoId?: string | null, name?: string | null } | null> | null } | null };

export type SmartSelectProductsQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SmartSelectProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPagination', products?: Array<{ __typename?: 'Product', id: string, name?: string | null } | null> | null } | null };

export type SmartSelectSalesPointsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SalesPointFilter>;
}>;


export type SmartSelectSalesPointsQuery = { __typename?: 'Query', salesPoints?: { __typename?: 'SalesPointPagination', salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, client?: { __typename?: 'Client', name?: string | null } | null } | null> | null } | null };

export type SmartSelectSalespointGroupsQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SmartSelectSalespointGroupsQuery = { __typename?: 'Query', salesPointsGroupsBySalesPointIds?: { __typename?: 'SalespointsGroupsPagination', salesPointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null } | null };

export type SmartSelectTagGroupsQueryVariables = Exact<{
  filter?: InputMaybe<TagsFilters>;
}>;


export type SmartSelectTagGroupsQuery = { __typename?: 'Query', tagGroups?: { __typename?: 'TagGroupPagination', tagGroups?: Array<{ __typename?: 'TagGroup', id?: string | null, name?: string | null }> | null } | null };

export type SmartSelectTagsQueryVariables = Exact<{
  filter?: InputMaybe<TagsFilters>;
}>;


export type SmartSelectTagsQuery = { __typename?: 'Query', tags?: { __typename?: 'TagsPagination', tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null };

export type HasGlobalAccountQueryVariables = Exact<{
  socialNetwork?: InputMaybe<SocialNetwork>;
}>;


export type HasGlobalAccountQuery = { __typename?: 'Query', hasGlobalAccount?: boolean | null };

export type HasGlobalAccountDataQueryVariables = Exact<{ [key: string]: never; }>;


export type HasGlobalAccountDataQuery = { __typename?: 'Query', hasGlobalAccountData?: { __typename?: 'HasGlobalDataResponse', facebook?: boolean | null, linkedin?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null };

export type NewsModal_GetUserUnpresentedNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsModal_GetUserUnpresentedNewsQuery = { __typename?: 'Query', getUserUnpresentedNews?: Array<{ __typename?: 'News', id: string, imageUrl?: string | null, recipient: { __typename?: 'NewsRecipient', roles: Array<NewsRecipientRoles> }, contents: Array<{ __typename?: 'NewsContent', lang: AvailableLangs, title: string, description: string, cta: { __typename?: 'NewsContentCta', link: string, text: string } }> } | null> | null };

export type NewsModal_MarkNewsAsPresentedMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type NewsModal_MarkNewsAsPresentedMutation = { __typename?: 'Mutation', markNewsAsPresented?: boolean | null };

export type TotalNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalNotificationsQuery = { __typename?: 'Query', getNbItemsToValidate: { __typename?: 'NbItemsToValidate', total?: number | null } };

export type GetNbItemsToValidateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNbItemsToValidateQuery = { __typename?: 'Query', getNbItemsToValidate: { __typename?: 'NbItemsToValidate', total?: number | null, items?: { __typename?: 'ItemsToValidate', order?: { __typename?: 'ItemStatus', enabled?: boolean | null, count?: number | null } | null, converse_comment?: { __typename?: 'ItemStatus', enabled?: boolean | null, count?: number | null } | null, converse_rating?: { __typename?: 'ItemStatus', enabled?: boolean | null, count?: number | null } | null, publish?: { __typename?: 'ItemStatus', enabled?: boolean | null, count?: number | null } | null, amplify?: { __typename?: 'ItemStatus', enabled?: boolean | null, count?: number | null } | null } | null } };

export type AddEditedProductToCartMutationVariables = Exact<{
  productId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CartType>;
  tempFolderDocumentId: Scalars['ID'];
  documentDownloadSettingsId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  packId?: InputMaybe<Scalars['ID']>;
  existingSubId?: InputMaybe<Scalars['String']>;
  selectedFixPrice?: InputMaybe<Scalars['Int']>;
}>;


export type AddEditedProductToCartMutation = { __typename?: 'Mutation', addEditedProductToCart?: { __typename?: 'AddEditedProductToCartResult', success: boolean, subId?: string | null } | null };

export type AddEditedProductToDraftMutationVariables = Exact<{
  productId: Scalars['ID'];
  tempFolderDocumentId: Scalars['ID'];
  packId?: InputMaybe<Scalars['ID']>;
  existingSubId?: InputMaybe<Scalars['String']>;
}>;


export type AddEditedProductToDraftMutation = { __typename?: 'Mutation', addEditedProductToDraft?: boolean | null };

export type AddItemToCartMutationVariables = Exact<{
  item?: InputMaybe<CartItemInput>;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;


export type AddItemToCartMutation = { __typename?: 'Mutation', addItemToCart?: { __typename?: 'Cart', userId: string, user: { __typename?: 'User', id: string }, items?: Array<{ __typename?: 'Item', productId: string, type?: CartType | null, quantity: number, subId?: string | null, providerId?: string | null, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null } | null> | null } | null };

export type AddLibraryMediaMutationVariables = Exact<{
  thumbnailFile?: InputMaybe<Scalars['Upload']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>>;
  type: LibraryMediaType;
  chiliDetails?: InputMaybe<InputChiliDetails>;
  details?: InputMaybe<InputMediaDetails>;
  folderLocation?: InputMaybe<Scalars['ID']>;
  isFromEditFile?: InputMaybe<Scalars['Boolean']>;
  isDownloadByEmail?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddLibraryMediaMutation = { __typename?: 'Mutation', addLibraryMedia?: Array<{ __typename?: 'Media', id: string, type: LibraryMediaType, name?: string | null, fileType?: UploadedFileType | null, isDownloadByEmail?: boolean | null, validFrom?: any | null, validTo?: any | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null } | null> | null };

export type AddPostTemplateMutationVariables = Exact<{
  publishArgs: PostTemplateArgs;
}>;


export type AddPostTemplateMutation = { __typename?: 'Mutation', addPostTemplate?: { __typename?: 'PostTemplate', id?: string | null, name?: string | null, type?: PostType | null, socialNetworks?: Array<SocialNetwork | null> | null, useSalespointsGroups?: boolean | null, salespointsGroupsIds?: Array<string | null> | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, displayStatus?: PostTemplateDisplayStatus | null } | null };

export type AddSalesPointLocationsMutationVariables = Exact<{
  salesPointId: Scalars['ID'];
  locations: Array<LocationInput> | LocationInput;
}>;


export type AddSalesPointLocationsMutation = { __typename?: 'Mutation', addSalesPointLocations?: { __typename?: 'SalesPoint', id?: string | null, locations?: Array<{ __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null } | null> | null } | null };

export type AddSocialPostMutationVariables = Exact<{
  publishArgs: PublishArgs;
  link?: InputMaybe<Scalars['String']>;
  dynamicLink?: InputMaybe<Scalars['String']>;
  medias?: InputMaybe<Array<InputMaybe<UploadOrGalleryMediaInput>> | InputMaybe<UploadOrGalleryMediaInput>>;
  thumb?: InputMaybe<UploadOrGalleryMediaInput>;
  cover?: InputMaybe<UploadOrGalleryMediaInput>;
  avatar?: InputMaybe<UploadOrGalleryMediaInput>;
  carouselItems?: InputMaybe<Array<InputCarouselItem> | InputCarouselItem>;
  event?: InputMaybe<InputSocialEvent>;
  isFromReadyToPost?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddSocialPostMutation = { __typename?: 'Mutation', addSocialPost?: { __typename?: 'AddSocialPostPayload', validationRequiredCount?: number | null, post?: { __typename?: 'SocialMediaPost', id: string, type?: PostType | null, description?: string | null, rawDescription?: string | null, htmlDescription?: string | null, scheduledAt?: any | null, validationDate?: any | null, validatorRole?: string | null, socialNetworkTarget: SocialNetwork, isDraft?: boolean | null, status?: PostStatus | null, target?: { __typename?: 'PostTarget', type?: TargetType | null, globals?: Array<string | null> | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, targetToExclude?: Array<string | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null, salespoints?: Array<{ __typename?: 'SalesPoint', social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null } | null } | null> | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null } | null } | null> | null } | null } | null } | null };

export type AssignRoleMutationVariables = Exact<{
  userId: Scalars['ID'];
  roleId: Scalars['ID'];
}>;


export type AssignRoleMutation = { __typename?: 'Mutation', assignRole?: { __typename?: 'Role', id?: string | null, name?: string | null } | null };

export type AssignVoucherToCartMutationVariables = Exact<{
  voucherCode: Scalars['String'];
}>;


export type AssignVoucherToCartMutation = { __typename?: 'Mutation', assignVoucherToCart?: { __typename?: 'Cart', userId: string } | null };

export type AssociateUserToSalesPointsMutationVariables = Exact<{
  userId: Scalars['ID'];
  salesPoints: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type AssociateUserToSalesPointsMutation = { __typename?: 'Mutation', associateUserToSalesPoints?: boolean | null };

export type AssociateUsersToSalesPointMutationVariables = Exact<{
  users: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  salesPoint: Scalars['ID'];
}>;


export type AssociateUsersToSalesPointMutation = { __typename?: 'Mutation', associateUsersToSalesPoint?: boolean | null };

export type BulkAddCartItemsMutationVariables = Exact<{
  items?: InputMaybe<Array<InputMaybe<CartItemInput>> | InputMaybe<CartItemInput>>;
}>;


export type BulkAddCartItemsMutation = { __typename?: 'Mutation', bulkAddCartItems?: { __typename?: 'BulkAddCartItemsReturnValue', availableProducts?: Array<{ __typename?: 'Item', productId: string, quantity: number } | null> | null, unavailableProducts?: Array<{ __typename?: 'Item', productId: string, quantity: number } | null> | null } | null };

export type CancelPreorderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelPreorderMutation = { __typename?: 'Mutation', cancelPreorder?: { __typename?: 'Preorder', id: string, status: PreorderStatus } | null };

export type CancelSalesPointsImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CancelSalesPointsImportJobMutation = { __typename?: 'Mutation', cancelSalesPointsImportJob?: boolean | null };

export type CancelUserAmplifyBudgetImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CancelUserAmplifyBudgetImportJobMutation = { __typename?: 'Mutation', cancelUserAmplifyBudgetImportJob?: boolean | null };

export type CancelUsersImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CancelUsersImportJobMutation = { __typename?: 'Mutation', cancelUsersImportJob?: boolean | null };

export type ChangePasswordMutationVariables = Exact<{
  email: Scalars['String'];
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'Credentials', jwToken?: string | null } | null };

export type CommitSalesPointsImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CommitSalesPointsImportJobMutation = { __typename?: 'Mutation', commitSalesPointsImportJob?: boolean | null };

export type CommitUserAmplifyBudgetImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CommitUserAmplifyBudgetImportJobMutation = { __typename?: 'Mutation', commitUserAmplifyBudgetImportJob?: boolean | null };

export type CommitUsersImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CommitUsersImportJobMutation = { __typename?: 'Mutation', commitUsersImportJob?: boolean | null };

export type CreateAmplifyCampaignMutationVariables = Exact<{
  campaign: InputAmplifyCampaign;
  postCalendarId: Scalars['ID'];
}>;


export type CreateAmplifyCampaignMutation = { __typename?: 'Mutation', createAmplifyCampaign?: { __typename?: 'AmplifyCampaign', id?: string | null } | null };

export type CreateEventMutationVariables = Exact<{
  type: CreatableEventType;
  subType?: InputMaybe<EventSubType>;
  moduleType?: InputMaybe<EventModuleType>;
  extra?: InputMaybe<Scalars['String']>;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: boolean };

export type CreateInstantPurchaseOrderMutationVariables = Exact<{
  productId: Scalars['ID'];
  productOptionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CreateInstantPurchaseOrderMutation = { __typename?: 'Mutation', createInstantPurchaseOrder?: { __typename?: 'ConfirmInstantPurchaseOrder', status?: number | null, orderId?: string | null, url?: string | null, toValidate?: boolean | null } | null };

export type CreateLibraryFolderMutationVariables = Exact<{
  folder: FolderInput;
}>;


export type CreateLibraryFolderMutation = { __typename?: 'Mutation', createLibraryFolder?: { __typename?: 'Folder', id?: string | null, name?: string | null, parent?: string | null, validFrom?: any | null, validTo?: any | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null } | null };

export type CreateOrderFromCartMutationVariables = Exact<{
  billingLocationId?: InputMaybe<Scalars['ID']>;
  stripePaymentMethod?: InputMaybe<OrderPaymentMethodStripe>;
  addresses?: InputMaybe<AddressesInput>;
  eskerNumbers?: InputMaybe<Scalars['JSON']>;
}>;


export type CreateOrderFromCartMutation = { __typename?: 'Mutation', createOrderFromCart?: { __typename?: 'OrderCreationResult', sessionUrl?: string | null, parentOrder?: { __typename?: 'ParentOrder', id: string, ordersNeedValidation?: boolean | null, ordersPartiallyNeedValidation?: boolean | null, orders?: Array<{ __typename?: 'Order', id: string } | null> | null, totalWithFees?: { __typename?: 'Price', discountedPrice?: { __typename?: 'PriceAmount', withTaxes?: number | null } | null } | null } | null } | null };

export type CreateRoleMutationVariables = Exact<{
  role: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole?: { __typename?: 'Role', id?: string | null } | null };

export type CreateSalesPointMutationVariables = Exact<{
  salesPoint: SalesPointInput;
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>>;
  socialConfig?: InputMaybe<SocialSalespointConfigInput>;
}>;


export type CreateSalesPointMutation = { __typename?: 'Mutation', createSalesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, email?: string | null, code?: string | null, affairCode?: string | null, tvaCode?: string | null, enabled?: boolean | null, RCS?: string | null, secondaryName?: string | null, siretCode?: string | null, phone?: string | null, fax?: string | null, contactDetails?: { __typename?: 'ContactDetails', phoneNumber?: string | null, email?: string | null, website?: string | null, twitterLink?: string | null, facebookLink?: string | null, pinterestLink?: string | null, instagramLink?: string | null, youtubeLink?: string | null, linkedinLink?: string | null, foursquareLink?: string | null, vimeoLink?: string | null, xingLink?: string | null, contacts?: Array<{ __typename?: 'Contact', id?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, activity?: string | null, email?: string | null } | null> | null } | null, location?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null, images?: Array<{ __typename?: 'Image', thumbnail?: string | null, large?: string | null, small?: string | null, medium?: string | null, original?: string | null } | null> | null, openingHours?: Array<{ __typename?: 'Opening', day?: number | null, isOpen?: boolean | null, sessions?: Array<{ __typename?: 'Session', start?: string | null, end?: string | null, isAllDay?: boolean | null } | null> | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, lastname?: string | null, firstname?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null } | null> | null, specialOpeningHours?: Array<{ __typename?: 'SpecialOpeningHours', id?: string | null, from?: any | null, to?: any | null, isOpen?: boolean | null, hoursFrom?: string | null, hoursTo?: string | null } | null> | null } | null };

export type CreateTagMutationVariables = Exact<{
  tag: TagInputCreation;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag?: { __typename?: 'Tag', id: string, label?: string | null } | null };

export type CreateTagGroupMutationVariables = Exact<{
  tagGroup: TagGroupInputCreation;
}>;


export type CreateTagGroupMutation = { __typename?: 'Mutation', createTagGroup?: { __typename?: 'TagGroup', id?: string | null, name?: string | null } | null };

export type CreateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phone?: string | null, mobilePhone?: string | null, activity?: string | null, email?: string | null } | null };

export type CreateUserImmediatelyMutationVariables = Exact<{
  user: UserToCreateInput;
}>;


export type CreateUserImmediatelyMutation = { __typename?: 'Mutation', createUserImmediately?: { __typename?: 'User', id: string } | null };

export type DeleteAnswerTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAnswerTemplateMutation = { __typename?: 'Mutation', deleteAnswerTemplate?: { __typename?: 'AnswerTemplate', id?: string | null } | null };

export type DeleteCustomVisualMutationVariables = Exact<{
  salesPointId: Scalars['ID'];
  filenames: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type DeleteCustomVisualMutation = { __typename?: 'Mutation', deleteCustomVisual?: boolean | null };

export type DeleteLibraryFolderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLibraryFolderMutation = { __typename?: 'Mutation', deleteLibraryFolder?: boolean | null };

export type DeleteLibraryMediaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLibraryMediaMutation = { __typename?: 'Mutation', deleteLibraryMedia?: boolean | null };

export type DeleteLibraryMediasMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteLibraryMediasMutation = { __typename?: 'Mutation', deleteLibraryMedias?: boolean | null };

export type DeleteNewsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNewsMutation = { __typename?: 'Mutation', deleteNews?: boolean | null };

export type AdminProductCategoriesForm_DeleteProductCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminProductCategoriesForm_DeleteProductCategoryMutation = { __typename?: 'Mutation', deleteProductCategory: boolean };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['ID'];
  fallbackRoleId: Scalars['ID'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole?: boolean | null };

export type DeleteSalesPointImagesMutationVariables = Exact<{
  imageIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  salesPointId: Scalars['ID'];
}>;


export type DeleteSalesPointImagesMutation = { __typename?: 'Mutation', deleteSalesPointImages?: boolean | null };

export type DeleteSalesPointLocationsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteSalesPointLocationsMutation = { __typename?: 'Mutation', deleteSalesPointLocations?: boolean | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag?: { __typename?: 'Tag', id: string, label?: string | null, tagGroup?: { __typename?: 'TagGroup', id?: string | null, name?: string | null } | null } | null };

export type DeleteTagGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTagGroupMutation = { __typename?: 'Mutation', deleteTagGroup?: { __typename?: 'TagGroup', id?: string | null } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID'];
  providerId?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'User', id: string } | null };

export type DissociateUserFromSalesPointsMutationVariables = Exact<{
  userId: Scalars['ID'];
  salesPoints: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type DissociateUserFromSalesPointsMutation = { __typename?: 'Mutation', dissociateUserFromSalesPoints?: boolean | null };

export type DissociateUsersFromSalesPointMutationVariables = Exact<{
  users: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  salesPoint: Scalars['ID'];
}>;


export type DissociateUsersFromSalesPointMutation = { __typename?: 'Mutation', dissociateUsersFromSalesPoint?: boolean | null };

export type DownloadSalesPointImagesMutationVariables = Exact<{
  salesPointId: Scalars['ID'];
}>;


export type DownloadSalesPointImagesMutation = { __typename?: 'Mutation', downloadSalesPointImages?: string | null };

export type EditPostTemplateMutationVariables = Exact<{
  publishArgs: PostTemplateArgs;
  templateId: Scalars['ID'];
}>;


export type EditPostTemplateMutation = { __typename?: 'Mutation', editPostTemplate?: { __typename?: 'PostTemplate', id?: string | null, name?: string | null, type?: PostType | null, socialNetworks?: Array<SocialNetwork | null> | null, useSalespointsGroups?: boolean | null, salespointsGroupsIds?: Array<string | null> | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, displayStatus?: PostTemplateDisplayStatus | null } | null };

export type EmptyCartMutationVariables = Exact<{ [key: string]: never; }>;


export type EmptyCartMutation = { __typename?: 'Mutation', deleteCart?: boolean | null };

export type ExportCampaignPreordersMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  format?: InputMaybe<UploadFormat>;
}>;


export type ExportCampaignPreordersMutation = { __typename?: 'Mutation', exportCampaignPreorders?: string | null };

export type ExportOrdersMutationVariables = Exact<{
  filter?: InputMaybe<OrderFilter>;
  salespointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  start: Scalars['Date'];
  end: Scalars['Date'];
  groupId?: InputMaybe<Scalars['ID']>;
  format?: InputMaybe<UploadFormat>;
  type: OrderExportType;
}>;


export type ExportOrdersMutation = { __typename?: 'Mutation', exportOrders?: string | null };

export type ExportPreordersMutationVariables = Exact<{
  filter?: InputMaybe<PreorderFilter>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  groupsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  format?: InputMaybe<UploadFormat>;
}>;


export type ExportPreordersMutation = { __typename?: 'Mutation', exportPreorders?: string | null };

export type ExportPresenceManagementMutationVariables = Exact<{
  start?: InputMaybe<Scalars['Date']>;
  end?: InputMaybe<Scalars['Date']>;
  all: Scalars['Boolean'];
}>;


export type ExportPresenceManagementMutation = { __typename?: 'Mutation', exportPresenceManagement?: string | null };

export type ExportStoresMutationVariables = Exact<{
  filter?: InputMaybe<SalesPointFilter>;
  format?: InputMaybe<ExportType>;
}>;


export type ExportStoresMutation = { __typename?: 'Mutation', exportStores?: string | null };

export type ExportUsersMutationVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
}>;


export type ExportUsersMutation = { __typename?: 'Mutation', exportUsers?: string | null };

export type ForceSuperAdminRoleMutationVariables = Exact<{
  roleSlug: Scalars['String'];
  clientId?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
}>;


export type ForceSuperAdminRoleMutation = { __typename?: 'Mutation', forceSuperAdminRole?: { __typename?: 'Credentials', jwToken?: string | null, clientId?: string | null } | null };

export type GenerateProductDownloadLinkMutationVariables = Exact<{
  productId: Scalars['ID'];
  isMedia?: InputMaybe<Scalars['Boolean']>;
  exportId?: InputMaybe<Scalars['String']>;
  packId?: InputMaybe<Scalars['ID']>;
  subId?: InputMaybe<Scalars['String']>;
}>;


export type GenerateProductDownloadLinkMutation = { __typename?: 'Mutation', generateProductDownloadLink?: string | null };

export type GetCustomVisualZipMutationVariables = Exact<{
  assets: Array<InputMaybe<FileInfoInput>> | InputMaybe<FileInfoInput>;
  salesPointId: Scalars['ID'];
}>;


export type GetCustomVisualZipMutation = { __typename?: 'Mutation', getCustomVisualZip?: string | null };

export type GetMediaDownloadLinkMutationVariables = Exact<{
  id: Scalars['ID'];
  singleUse: Scalars['Boolean'];
}>;


export type GetMediaDownloadLinkMutation = { __typename?: 'Mutation', getMediaDownloadLink?: string | null };

export type GetPaymentDocumentUrlQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type GetPaymentDocumentUrlQuery = { __typename?: 'Query', getPaymentDocumentUrl?: string | null };

export type ImportSalesPointsJobMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ImportSalesPointsJobMutation = { __typename?: 'Mutation', importSalesPoints?: { __typename?: 'ImportSalesPointJob', id?: string | null, importError?: string | null, creations?: Array<{ __typename?: 'SalesPoint', code?: string | null, name?: string | null } | null> | null, updates?: Array<{ __typename?: 'SalesPoint', code?: string | null, name?: string | null } | null> | null, fails?: Array<{ __typename?: 'ImportJobError', ref?: string | null, error?: string | null, fields?: Array<{ __typename?: 'ImportJobFieldError', field?: string | null, error?: string | null } | null> | null } | null> | null } | null };

export type ImportUsersMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ImportUsersMutation = { __typename?: 'Mutation', importUsers?: { __typename?: 'ImportUserJob', id?: string | null, importError?: string | null, creations?: Array<{ __typename?: 'User', email?: string | null } | null> | null, updates?: Array<{ __typename?: 'User', email?: string | null } | null> | null, fails?: Array<{ __typename?: 'ImportJobError', ref?: string | null, error?: string | null, fields?: Array<{ __typename?: 'ImportJobFieldError', field?: string | null } | null> | null } | null> | null } | null };

export type InviteProviderMutationVariables = Exact<{
  email: Scalars['String'];
  providerId?: InputMaybe<Scalars['ID']>;
  languagePreference?: InputMaybe<PlatformLanguageOption>;
  roleId: Scalars['ID'];
  loginMode: LoginMode;
  salesPointGroupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type InviteProviderMutation = { __typename?: 'Mutation', inviteProvider?: { __typename?: 'UserIdObj', id?: string | null } | null };

export type InviteUserMutationVariables = Exact<{
  email: Scalars['String'];
  roleId: Scalars['ID'];
  salespoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  languagePreference?: InputMaybe<PlatformLanguageOption>;
  loginMode: LoginMode;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser?: { __typename?: 'UserIdObj', id?: string | null } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'Credentials', jwToken?: string | null, clientId?: string | null } | null };

export type LoginHyperSsoMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type LoginHyperSsoMutation = { __typename?: 'Mutation', loginHyperSSO?: { __typename?: 'Credentials', jwToken?: string | null, clientId?: string | null } | null };

export type MoveLibraryFolderMutationVariables = Exact<{
  id: Scalars['ID'];
  targetFolder?: InputMaybe<Scalars['ID']>;
}>;


export type MoveLibraryFolderMutation = { __typename?: 'Mutation', moveLibraryFolder?: boolean | null };

export type MoveLibraryMediaMutationVariables = Exact<{
  id: Scalars['ID'];
  targetFolder?: InputMaybe<Scalars['ID']>;
}>;


export type MoveLibraryMediaMutation = { __typename?: 'Mutation', moveLibraryMedia?: boolean | null };

export type PostFragmentFragment = { __typename?: 'SocialMediaPost', id: string, type?: PostType | null, description?: string | null, rawDescription?: string | null, htmlDescription?: string | null, scheduledAt?: any | null, validationDate?: any | null, validatorRole?: string | null, socialNetworkTarget: SocialNetwork, isDraft?: boolean | null, status?: PostStatus | null, target?: { __typename?: 'PostTarget', type?: TargetType | null, globals?: Array<string | null> | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, targetToExclude?: Array<string | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null, salespoints?: Array<{ __typename?: 'SalesPoint', social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null } | null } | null> | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null } | null } | null> | null } | null };

export type ProcessCloudinaryEditMutationVariables = Exact<{
  editedImageUrl: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
  originalPublicId?: InputMaybe<Scalars['String']>;
}>;


export type ProcessCloudinaryEditMutation = { __typename?: 'Mutation', processCloudinaryEdit?: { __typename?: 'CloudinaryUploadResult', publicId: string, secureUrl: string, url: string, width?: number | null, height?: number | null, format: string, resourceType: string, bytes: number, createdAt: string, path?: string | null, filename?: string | null } | null };

export type BulkRemoveCartItemsMutationVariables = Exact<{
  items?: InputMaybe<Array<InputMaybe<CartItemToDelete>> | InputMaybe<CartItemToDelete>>;
}>;


export type BulkRemoveCartItemsMutation = { __typename?: 'Mutation', bulkRemoveCartItems?: { __typename?: 'Cart', userId: string, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, user: { __typename?: 'User', id: string }, items?: Array<{ __typename?: 'Item', productId: string, quantity: number, type?: CartType | null, product: { __typename?: 'Product', id: string } } | null> | null } | null };

export type RequestResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestResetMutation = { __typename?: 'Mutation', requestReset?: boolean | null };

export type ResendUserInvitationMutationVariables = Exact<{
  userId: Scalars['ID'];
  providerId?: InputMaybe<Scalars['ID']>;
}>;


export type ResendUserInvitationMutation = { __typename?: 'Mutation', resendUserInvitation?: boolean | null };

export type ResendUserInvitationsMutationVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type ResendUserInvitationsMutation = { __typename?: 'Mutation', resendUserInvitations?: { __typename?: 'ResendInvitationsResult', total: number, sent: number, failed: number, failures: Array<{ __typename?: 'ResendInvitationFailure', userId: string, error: string }> } | null };

export type ResetEditedProductMutationVariables = Exact<{
  productId: Scalars['ID'];
  isMedia?: InputMaybe<Scalars['Boolean']>;
  packId?: InputMaybe<Scalars['ID']>;
  existingSubId?: InputMaybe<Scalars['ID']>;
}>;


export type ResetEditedProductMutation = { __typename?: 'Mutation', resetEditedProduct?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'Credentials', jwToken?: string | null } | null };

export type SetDefaultStoreIdMutationVariables = Exact<{
  storeId?: InputMaybe<Scalars['String']>;
}>;


export type SetDefaultStoreIdMutation = { __typename?: 'Mutation', setDefaultStoreId?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, defaultStoreId?: string | null } | null };

export type SetTrackingNumberMutationVariables = Exact<{
  orderId: Scalars['ID'];
  trackingNumber: Scalars['String'];
  carrierName: Carrier;
}>;


export type SetTrackingNumberMutation = { __typename?: 'Mutation', setTrackingNumber?: { __typename?: 'Order', id: string, orderNumber: string, trackingNumber?: string | null, trackingURL?: string | null, userId: string, status: Status, receipt?: string | null, totalProductsQuantity: number, date: any, items: Array<{ __typename?: 'OrderItem', productId: string, subId?: string | null, quantity: number, product: { __typename?: 'OrderProduct', id: string, name: string, ref?: string | null, description?: string | null, isCustomizable?: boolean | null, images?: Array<{ __typename?: 'OrderImage', small?: string | null } | null> | null, tags?: Array<{ __typename?: 'OrderTag', id?: string | null, label?: string | null, color?: string | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null } } | null>, addresses: { __typename?: 'Addresses', shipping?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null, billing?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null }, vouchers?: Array<{ __typename?: 'OrderVoucher', name?: string | null, amount?: number | null } | null> | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null } | null, totalWithFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null, withTaxes?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null };

export type SsoGoogleLoginMutationVariables = Exact<{
  googleToken: Scalars['String'];
}>;


export type SsoGoogleLoginMutation = { __typename?: 'Mutation', ssoGoogleLogin?: { __typename?: 'Credentials', jwToken?: string | null, clientId?: string | null } | null };

export type StopAmplifyAdMutationVariables = Exact<{
  campaignId: Scalars['ID'];
  adId: Scalars['ID'];
}>;


export type StopAmplifyAdMutation = { __typename?: 'Mutation', stopAmplifyAd?: boolean | null };

export type StopAmplifyCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StopAmplifyCampaignMutation = { __typename?: 'Mutation', stopAmplifyCampaign?: boolean | null };

export type SubmitPreorderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmitPreorderMutation = { __typename?: 'Mutation', submitPreorder?: { __typename?: 'Preorder', id: string, status: PreorderStatus, ref?: string | null, submittedAt?: any | null } | null };

export type UpdateAmplifyCampaignMutationVariables = Exact<{
  campaign: InputAmplifyCampaign;
  campaignId: Scalars['ID'];
}>;


export type UpdateAmplifyCampaignMutation = { __typename?: 'Mutation', updateAmplifyCampaign?: { __typename?: 'AmplifyCampaign', id?: string | null } | null };

export type UpdateCampaignSupportsMutationVariables = Exact<{
  updates: Array<CampaignSupportUpdates> | CampaignSupportUpdates;
}>;


export type UpdateCampaignSupportsMutation = { __typename?: 'Mutation', updateCampaignSupports?: Array<{ __typename?: 'Media', id: string, name?: string | null, order?: number | null, url?: string | null, thumbnail?: string | null, fileType?: UploadedFileType | null } | null> | null };

export type UpdateCartItemCommentMutationVariables = Exact<{
  productId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCartItemCommentMutation = { __typename?: 'Mutation', updateCartItemComment?: { __typename?: 'Cart', items?: Array<{ __typename?: 'Item', comment?: string | null } | null> | null } | null };

export type UpdateCartItemOptionsMutationVariables = Exact<{
  item: CartItemOptionsInput;
}>;


export type UpdateCartItemOptionsMutation = { __typename?: 'Mutation', updateCartItemOptions?: { __typename?: 'Cart', userId: string } | null };

export type UpdateCartItemQuantityMutationVariables = Exact<{
  item?: InputMaybe<CartItemInput>;
}>;


export type UpdateCartItemQuantityMutation = { __typename?: 'Mutation', updateCartItemQuantity?: { __typename?: 'Cart', userId: string, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, user: { __typename?: 'User', id: string }, items?: Array<{ __typename?: 'Item', productId: string, type?: CartType | null, quantity: number, subId?: string | null, packInfo?: { __typename?: 'PackInfo', id?: string | null, name?: string | null, ref?: string | null, productsInPack?: Array<{ __typename?: 'ProductInPack', id?: string | null, name?: string | null, ref?: string | null } | null> | null } | null, unitPrice?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null, totalPrice?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null } | null> | null } | null };

export type UpdateCartItemsQuantitiesPerLocationMutationVariables = Exact<{
  items: Array<ItemQuantitiesPerLocationInput> | ItemQuantitiesPerLocationInput;
}>;


export type UpdateCartItemsQuantitiesPerLocationMutation = { __typename?: 'Mutation', updateCartItemsQuantitiesPerLocation?: { __typename?: 'Cart', userId: string, items?: Array<{ __typename?: 'Item', subId?: string | null, quantity: number, productId: string, quantitiesPerLocation?: Array<{ __typename?: 'QuantitiesPerLocation', locationId?: string | null, quantity?: number | null } | null> | null } | null> | null } | null };

export type UpdateCloudinaryMediaMutationVariables = Exact<{
  publicId: Scalars['String'];
  transformations?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  newPublicId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCloudinaryMediaMutation = { __typename?: 'Mutation', updateCloudinaryMedia?: { __typename?: 'CloudinaryUploadResult', publicId: string, secureUrl: string, url: string, width?: number | null, height?: number | null, format: string, resourceType: string, bytes: number, createdAt: string, updatedAt?: string | null } | null };

export type UpdateHomePageSettingsMutationVariables = Exact<{
  id: Scalars['ID'];
  data: HomePageSettingsInput;
}>;


export type UpdateHomePageSettingsMutation = { __typename?: 'Mutation', updateHomePageSettings?: { __typename?: 'HomePageSettings', id?: string | null, lang?: AvailableLang | null, slides?: { __typename?: 'HomePageSlideSettings', enabled?: boolean | null, slidesDetails?: Array<{ __typename?: 'SlidesDetails', id?: string | null, title?: string | null, buttonText?: string | null, redirectionLink?: string | null, order?: number | null, image?: { __typename?: 'SlideImage', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null } | null> | null } | null, campaign?: { __typename?: 'HomePageCampaignSettings', enabled?: boolean | null, title?: string | null, text?: string | null, buttonText?: string | null, buttonLink?: string | null, customCampaignsEnabled?: boolean | null, order?: number | null, campaignIds?: Array<{ __typename?: 'CampaignDetails', campaignId?: string | null, order?: number | null } | null> | null } | null, callToAction?: { __typename?: 'HomePageCallToAction', enabled?: boolean | null, order?: number | null, callToActions?: Array<{ __typename?: 'CallToAction', order?: number | null, title?: string | null, secondaryText?: string | null, buttonName?: string | null, redirectionUrl?: string | null } | null> | null } | null, shop?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null, library?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null, planning?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null } | null };

export type UpdateLastConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateLastConnectionMutation = { __typename?: 'Mutation', updateLastConnection?: boolean | null };

export type UpdateLibraryFolderMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: UpdateFolderInput;
}>;


export type UpdateLibraryFolderMutation = { __typename?: 'Mutation', updateLibraryFolder?: { __typename?: 'Folder', id?: string | null, name?: string | null, parent?: string | null, validFrom?: any | null, validTo?: any | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null } | null };

export type UpdateLibraryMediaMutationVariables = Exact<{
  mediaId: Scalars['ID'];
  type?: InputMaybe<LibraryMediaType>;
  file?: InputMaybe<Scalars['Upload']>;
  chiliDetails?: InputMaybe<UpdateChiliDetails>;
  details?: InputMaybe<UpdateMediaDetails>;
  folderLocation?: InputMaybe<Scalars['ID']>;
  thumbnailFile?: InputMaybe<Scalars['Upload']>;
  deleteThumbnail?: InputMaybe<Scalars['Boolean']>;
  isDownloadByEmail?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateLibraryMediaMutation = { __typename?: 'Mutation', updateLibraryMedia?: { __typename?: 'Media', id: string, name?: string | null, isDownloadByEmail?: boolean | null, validTo?: any | null, validFrom?: any | null, fileType?: UploadedFileType | null, thumbnail?: string | null, images?: { __typename?: 'ImageFormats', small?: string | null, thumbnail?: string | null, large?: string | null } | null } | null };

export type UpdateLibraryMediasMutationVariables = Exact<{
  mediaIds: Array<Scalars['ID']> | Scalars['ID'];
  updates: BulkUpdateMediaInput;
}>;


export type UpdateLibraryMediasMutation = { __typename?: 'Mutation', updateLibraryMedias?: boolean | null };

export type UpdateOrderStatusMutationVariables = Exact<{
  orderId: Scalars['ID'];
  orderStatus: Status;
  reason?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrderStatusMutation = { __typename?: 'Mutation', updateOrderStatus?: boolean | null };

export type UpdateProviderUserBriefSpecClientsMutationVariables = Exact<{
  specClientIds: Array<Scalars['ID']> | Scalars['ID'];
  userId: Scalars['String'];
  key: Scalars['String'];
}>;


export type UpdateProviderUserBriefSpecClientsMutation = { __typename?: 'Mutation', updateProviderUserBriefSpecClients?: boolean | null };

export type UpdateRoleMutationVariables = Exact<{
  roleId: Scalars['ID'];
  role: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'Role', id?: string | null } | null };

export type UpdateSalesPointMutationVariables = Exact<{
  id: Scalars['ID'];
  salesPoint: SalesPointUpdateInput;
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>>;
  socialConfig?: InputMaybe<SocialSalespointConfigInput>;
  onlyStatus?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateSalesPointMutation = { __typename?: 'Mutation', updateSalesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, email?: string | null, code?: string | null, affairCode?: string | null, tvaCode?: string | null, enabled?: boolean | null, RCS?: string | null, secondaryName?: string | null, siretCode?: string | null, phone?: string | null, fax?: string | null, shortDescription?: string | null, longDescription?: string | null, languageOptions?: Array<LanguageSelectOption | null> | null, paymentOptions?: Array<string | null> | null, contactDetails?: { __typename?: 'ContactDetails', phoneNumber?: string | null, email?: string | null, website?: string | null, twitterLink?: string | null, facebookLink?: string | null, pinterestLink?: string | null, instagramLink?: string | null, youtubeLink?: string | null, linkedinLink?: string | null, foursquareLink?: string | null, vimeoLink?: string | null, xingLink?: string | null, contacts?: Array<{ __typename?: 'Contact', id?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, activity?: string | null, email?: string | null } | null> | null } | null, location?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null, images?: Array<{ __typename?: 'Image', thumbnail?: string | null, large?: string | null, small?: string | null, medium?: string | null, original?: string | null } | null> | null, openingHours?: Array<{ __typename?: 'Opening', day?: number | null, isOpen?: boolean | null, sessions?: Array<{ __typename?: 'Session', start?: string | null, end?: string | null, isAllDay?: boolean | null } | null> | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, lastname?: string | null, firstname?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null } | null> | null, specialOpeningHours?: Array<{ __typename?: 'SpecialOpeningHours', id?: string | null, from?: any | null, to?: any | null, isOpen?: boolean | null, hoursFrom?: string | null, hoursTo?: string | null } | null> | null } | null };

export type UpdateSalesPointLocationsMutationVariables = Exact<{
  updates: Array<LocationUpdate> | LocationUpdate;
}>;


export type UpdateSalesPointLocationsMutation = { __typename?: 'Mutation', updateSalesPointLocations?: Array<{ __typename?: 'SalesPoint', id?: string | null } | null> | null };

export type UpdateSocialPostMutationVariables = Exact<{
  publishArgs: PublishArgs;
  link?: InputMaybe<Scalars['String']>;
  dynamicLink?: InputMaybe<Scalars['String']>;
  toValidate?: InputMaybe<PublishValidateVideo>;
  medias?: InputMaybe<Array<InputMaybe<UploadOrGalleryMediaInput>> | InputMaybe<UploadOrGalleryMediaInput>>;
  thumb?: InputMaybe<UploadOrGalleryMediaInput>;
  cover?: InputMaybe<UploadOrGalleryMediaInput>;
  avatar?: InputMaybe<UploadOrGalleryMediaInput>;
  carouselItems?: InputMaybe<Array<InputCarouselItem> | InputCarouselItem>;
  event?: InputMaybe<InputSocialEvent>;
  publishId: Scalars['ID'];
}>;


export type UpdateSocialPostMutation = { __typename?: 'Mutation', updateSocialPost?: { __typename?: 'AddSocialPostPayload', validationRequiredCount?: number | null, post?: { __typename?: 'SocialMediaPost', id: string, type?: PostType | null, description?: string | null, rawDescription?: string | null, htmlDescription?: string | null, scheduledAt?: any | null, validationDate?: any | null, validatorRole?: string | null, socialNetworkTarget: SocialNetwork, isDraft?: boolean | null, status?: PostStatus | null, target?: { __typename?: 'PostTarget', type?: TargetType | null, globals?: Array<string | null> | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, targetToExclude?: Array<string | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null, salespoints?: Array<{ __typename?: 'SalesPoint', social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null } | null } | null> | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null } | null } | null> | null } | null } | null } | null };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['ID'];
  tag: TagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag?: { __typename?: 'Tag', id: string, label?: string | null, types?: Array<TagType | null> | null, enabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, tagGroup?: { __typename?: 'TagGroup', id?: string | null, name?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null } | null };

export type UpdateTagGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: TagGroupInput;
}>;


export type UpdateTagGroupMutation = { __typename?: 'Mutation', updateTagGroup?: { __typename?: 'TagGroup', id?: string | null, name?: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: UserUpdate;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phone?: string | null, mobilePhone?: string | null, activity?: string | null, email?: string | null, enabled?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, enabled?: boolean | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null } | null } | null> | null } | null };

export type UploadCustomVisualsMutationVariables = Exact<{
  salesPointId: Scalars['ID'];
  assets: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
}>;


export type UploadCustomVisualsMutation = { __typename?: 'Mutation', uploadCustomVisuals?: Array<{ __typename?: 'CustomVisualsUpload', url?: string | null, filename?: string | null } | null> | null };

export type UploadProviderInvoiceMutationVariables = Exact<{
  orderId: Scalars['String'];
  fileName: Scalars['String'];
  file: Scalars['Upload'];
}>;


export type UploadProviderInvoiceMutation = { __typename?: 'Mutation', uploadProviderInvoice?: { __typename?: 'UploadProviderInvoiceResponse', success: boolean, message?: string | null } | null };

export type UploadToCloudinaryMutationVariables = Exact<{
  file: Scalars['Upload'];
  folder?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['String']>;
  transformation?: InputMaybe<Scalars['String']>;
  temporary?: InputMaybe<Scalars['Boolean']>;
}>;


export type UploadToCloudinaryMutation = { __typename?: 'Mutation', uploadToCloudinary?: { __typename?: 'CloudinaryUploadResult', publicId: string, secureUrl: string, url: string, width?: number | null, height?: number | null, format: string, resourceType: string, bytes: number, createdAt: string } | null };

export type UpsertPreorderMutationVariables = Exact<{
  input: PreorderInput;
}>;


export type UpsertPreorderMutation = { __typename?: 'Mutation', upsertPreorder?: { __typename?: 'Preorder', id: string, status: PreorderStatus, ref?: string | null, items: Array<{ __typename?: 'PreorderItem', productId: string, quantity: number }> } | null };

export type ValidateSocialPostMutationVariables = Exact<{
  publishId: Scalars['ID'];
  action: ValidationActions;
  comment?: InputMaybe<Scalars['String']>;
}>;


export type ValidateSocialPostMutation = { __typename?: 'Mutation', validateSocialPost?: boolean | null };

export type GetTagsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TagsSort>;
}>;


export type GetTagsQuery = { __typename?: 'Query', tags?: { __typename?: 'TagsPagination', tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, types?: Array<TagType | null> | null, enabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, tagGroup?: { __typename?: 'TagGroup', id?: string | null, name?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null } | null> | null } | null };

export type AllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRolesQuery = { __typename?: 'Query', allRoles?: Array<{ __typename?: 'Role', id?: string | null, name?: string | null, slug?: string | null, absoluteSlug?: string | null, deletedAt?: string | null } | null> | null };

export type AmplifyGetCountryListQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type AmplifyGetCountryListQuery = { __typename?: 'Query', getCountryList?: { __typename?: 'TargetingPayload', data?: Array<{ __typename?: 'TargetingItem', facebookKey: string, name: string } | null> | null } | null };

export type AmplifyGetGeolocListQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type AmplifyGetGeolocListQuery = { __typename?: 'Query', getGeolocList?: { __typename?: 'TargetingPayload', data?: Array<{ __typename?: 'TargetingItem', facebookKey: string, name: string } | null> | null } | null };

export type AmplifyGetInterestListQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type AmplifyGetInterestListQuery = { __typename?: 'Query', getInterestList?: { __typename?: 'TargetingPayload', data?: Array<{ __typename?: 'TargetingItem', facebookKey: string, name: string } | null> | null } | null };

export type AdCampaignForm_GetPostCalendarDetailsQueryVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type AdCampaignForm_GetPostCalendarDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, name?: string | null } } | null, getPostCalendarDetails?: { __typename?: 'SocialMediaPost', id: string, authorRole?: SocialAuthorRole | null, scheduledAt?: any | null, type?: PostType | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, videoThumbnail?: string | null, caption?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null, amplifyAvailableTargets?: { __typename?: 'AmplifyCampaignAvailableTargets', onGlobals?: boolean | null, isGlobalConnectionOptionAvailable?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, isAmplifyConnectionOptionAvailable?: boolean | null } | null> | null } | null } | null };

export type BriefSpecClientsQueryVariables = Exact<{
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  providerUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type BriefSpecClientsQuery = { __typename?: 'Query', briefSpecClients?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, clientId?: string | null, key?: string | null, value?: string | null, label?: string | null, parentId?: string | null, providerUserIds?: Array<string | null> | null, children?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, clientId?: string | null, key?: string | null, value?: string | null, label?: string | null, parentId?: string | null, providerUserIds?: Array<string | null> | null } | null> | null } | null> | null };

export type CampaignByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  salespointId?: InputMaybe<Scalars['ID']>;
}>;


export type CampaignByIdQuery = { __typename?: 'Query', campaignById?: { __typename?: 'Campaign', id: string, name?: string | null, enabled?: boolean | null, description?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, displayMode?: CampaignDisplayModes | null, startDisplayDate?: any | null, endDisplayDate?: any | null, hasPreorderDates?: boolean | null, preorderStartDate?: any | null, preorderEndDate?: any | null, preorderReminderDays?: Array<number> | null, hasPreorderProducts?: boolean | null, preorderProductsCount?: number | null, preorderEngagedSalespointsCount?: number | null, preorderTotalSalespointsCount?: number | null, preorderDaysRemaining?: number | null, preorderStatus?: CampaignPreorderStatus | null, color?: string | null, isLocal?: boolean | null, type?: CampaignType | null, userId?: string | null, userHasWritePermission?: boolean | null, isNew?: boolean | null, useSalespointGroups?: boolean | null, tempUrl?: string | null, hasProducts?: boolean | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, document?: { __typename?: 'Document', name?: string | null, publicUrl?: string | null } | null, supports?: Array<{ __typename?: 'Media', id: string, name?: string | null, order?: number | null, url?: string | null, thumbnail?: string | null, fileType?: UploadedFileType | null, type: LibraryMediaType } | null> | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, medias?: Array<{ __typename?: 'Media', id: string, name?: string | null, fileType?: UploadedFileType | null, tempUrl?: string | null, thumbnail?: string | null, type: LibraryMediaType, images?: { __typename?: 'ImageFormats', thumbnail?: string | null, small?: string | null, medium?: string | null, large?: string | null } | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, mimetype?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, tagGroup?: { __typename?: 'TagGroup', id?: string | null } | null } | null> | null } | null } | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, productsAndCount?: { __typename?: 'ProductsAndCount', count?: number | null, products?: Array<{ __typename?: 'Product', isPack?: boolean | null, id: string, name?: string | null, priceType?: PriceTypes | null, description?: string | null, isCustomizable?: boolean | null, tips?: string | null, type?: AllowedProductType | null, ref?: string | null, shouldHaveAtLeastOneOptionSelected?: boolean | null, isShowcase?: boolean | null, isBriefCrm?: boolean | null, showcaseText?: string | null, images?: Array<{ __typename?: 'Image', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null> | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, fixPricesLevelsByQuantity?: Array<{ __typename?: 'PriceByQuantity', quantity?: number | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null } | null } | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null, lowQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, productOptions?: Array<{ __typename?: 'ProductOption', id: string, price?: number | null } | null> | null } | null> | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null } | null> | null, postTemplates?: Array<{ __typename?: 'PostTemplate', id?: string | null, name?: string | null, mongoId?: string | null, salespointsGroupsIds?: Array<string | null> | null } | null> | null } | null };

export type CampaignDetailActionMetricsQueryVariables = Exact<{
  dateRange: DateRange;
  campaignType: CampaignType;
  campaignId?: InputMaybe<Scalars['ID']>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  tableParams?: InputMaybe<TableParams>;
}>;


export type CampaignDetailActionMetricsQuery = { __typename?: 'Query', campaignDetailActionMetrics?: { __typename?: 'CampaignDetailActionsPagination', total?: number | null, campaignActionsDetail?: Array<{ __typename?: 'CampaignDetailActions', id?: string | null, actions?: number | null, views?: number | null, name?: string | null, subContent?: Array<{ __typename?: 'CampaignActionDetailSubContent', id?: string | null, name?: string | null, actions?: { __typename?: 'SubActions', downloads?: number | null, orders?: number | null, copies?: number | null, posts?: number | null } | null } | null> | null } | null> | null } | null };

export type CampaignFragmentFragment = { __typename?: 'Campaign', id: string, name?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, description?: string | null, hideOnPlanning?: boolean | null, isNew?: boolean | null, isLocal?: boolean | null, hasProducts?: boolean | null, userHasWritePermission?: boolean | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', id: string } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, displayCampaignsCategory?: boolean | null } | null> | null };

export type CampaignInfoQueryVariables = Exact<{
  id: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CampaignInfoQuery = { __typename?: 'Query', campaignById?: { __typename?: 'Campaign', id: string, enabled?: boolean | null, name?: string | null, hideOnPlanning?: boolean | null, description?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, displayMode?: CampaignDisplayModes | null, startDisplayDate?: any | null, endDisplayDate?: any | null, color?: string | null, useSalespointGroups?: boolean | null, salespointId?: string | null, isNew?: boolean | null, tempUrl?: string | null, hasProducts?: boolean | null, isNational?: boolean | null, supports?: Array<{ __typename?: 'Media', id: string, name?: string | null, order?: number | null, url?: string | null, thumbnail?: string | null, fileType?: UploadedFileType | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, document?: { __typename?: 'Document', name?: string | null, tempUrl?: string | null } | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, medias?: Array<{ __typename?: 'Media', id: string, name?: string | null } | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, productsAndCount?: { __typename?: 'ProductsAndCount', count?: number | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null } | null> | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | null };

export type CampaignPreorderProductsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type CampaignPreorderProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPagination', count?: number | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null, ref?: string | null, preorderAvailable?: boolean | null, packagingUnit?: number | null, isStockEnabled?: boolean | null, stock?: number | null, isMinimumOrderEnabled?: boolean | null, minimumOrder?: number | null, isMaximumOrderEnabled?: boolean | null, priceType?: PriceTypes | null, catalogPrice?: number | null, maximumOrder?: { __typename?: 'ProductMaximumOrderConfig', period: ProductMaximumOrderPeriod, quantity: number } | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, catalogFixPricesLevelsByQuantity?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, fixPricesLevelsByQuantity?: Array<{ __typename?: 'PriceByQuantity', quantity?: number | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null> | null, images?: Array<{ __typename?: 'Image', id: string, original?: string | null, thumbnail?: string | null, small?: string | null } | null> | null, availableQuantity?: { __typename?: 'AvailableQuantity', min: number, max: number } | null } | null> | null } | null };

export type CampaignsQueryQueryVariables = Exact<{
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  category?: InputMaybe<Scalars['ID']>;
  dateRange?: InputMaybe<DateRangeOptional>;
  types?: InputMaybe<Array<CampaignType> | CampaignType>;
  scopes?: InputMaybe<Array<InputMaybe<CampaignScope>> | InputMaybe<CampaignScope>>;
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  keyword?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CampaignsQueryQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignPagination', campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, enabled?: boolean | null, description?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, displayMode?: CampaignDisplayModes | null, startDisplayDate?: any | null, endDisplayDate?: any | null, hideOnPlanning?: boolean | null, isLocal?: boolean | null, isVisible?: boolean | null, color?: string | null, isNew?: boolean | null, hasProducts?: boolean | null, hasPreorderProducts?: boolean | null, preorderEndDate?: any | null, preorderDaysRemaining?: number | null, createdAt?: any | null, userHasWritePermission?: boolean | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, image?: { __typename?: 'Image', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, medias?: Array<{ __typename?: 'Media', id: string } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', clientId?: string | null, id: string, name?: string | null, displayCampaignsCategory?: boolean | null } | null> | null } | null> | null } | null };

export type CampaignsForPreorderFilterQueryVariables = Exact<{
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CampaignsForPreorderFilterQuery = { __typename?: 'Query', campaignsPerPeriods?: { __typename?: 'CampaignsPerPeriods', allCampaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, hasPreorderProducts?: boolean | null } | null> | null } | null };

export type CampaignsPerPeriodsQueryVariables = Exact<{
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  category?: InputMaybe<Scalars['ID']>;
  types: Array<CampaignType> | CampaignType;
  scopes?: InputMaybe<Array<InputMaybe<CampaignScope>> | InputMaybe<CampaignScope>>;
  tagIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  keyword?: InputMaybe<Scalars['String']>;
  preorderStatuses?: InputMaybe<Array<CampaignPreorderStatus> | CampaignPreorderStatus>;
  salespointId?: InputMaybe<Scalars['ID']>;
}>;


export type CampaignsPerPeriodsQuery = { __typename?: 'Query', campaignsPerPeriods?: { __typename?: 'CampaignsPerPeriods', allCampaigns?: Array<{ __typename?: 'Campaign', hasPreorderProducts?: boolean | null, preorderEndDate?: any | null, preorderDaysRemaining?: number | null, preorderStatus?: CampaignPreorderStatus | null, id: string, name?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, description?: string | null, hideOnPlanning?: boolean | null, isNew?: boolean | null, isLocal?: boolean | null, hasProducts?: boolean | null, userHasWritePermission?: boolean | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', id: string } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, displayCampaignsCategory?: boolean | null } | null> | null } | null> | null, ongoing?: Array<{ __typename?: 'Campaign', hasPreorderProducts?: boolean | null, preorderEndDate?: any | null, preorderDaysRemaining?: number | null, preorderStatus?: CampaignPreorderStatus | null, id: string, name?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, description?: string | null, hideOnPlanning?: boolean | null, isNew?: boolean | null, isLocal?: boolean | null, hasProducts?: boolean | null, userHasWritePermission?: boolean | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', id: string } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, displayCampaignsCategory?: boolean | null } | null> | null } | null> | null, scheduled?: Array<{ __typename?: 'Campaign', hasPreorderProducts?: boolean | null, preorderEndDate?: any | null, preorderDaysRemaining?: number | null, preorderStatus?: CampaignPreorderStatus | null, id: string, name?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, description?: string | null, hideOnPlanning?: boolean | null, isNew?: boolean | null, isLocal?: boolean | null, hasProducts?: boolean | null, userHasWritePermission?: boolean | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', id: string } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, displayCampaignsCategory?: boolean | null } | null> | null } | null> | null, permanent?: Array<{ __typename?: 'Campaign', hasPreorderProducts?: boolean | null, preorderEndDate?: any | null, preorderDaysRemaining?: number | null, preorderStatus?: CampaignPreorderStatus | null, id: string, name?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, description?: string | null, hideOnPlanning?: boolean | null, isNew?: boolean | null, isLocal?: boolean | null, hasProducts?: boolean | null, userHasWritePermission?: boolean | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', id: string } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, displayCampaignsCategory?: boolean | null } | null> | null } | null> | null, ended?: Array<{ __typename?: 'Campaign', hasPreorderProducts?: boolean | null, preorderEndDate?: any | null, preorderDaysRemaining?: number | null, preorderStatus?: CampaignPreorderStatus | null, id: string, name?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, description?: string | null, hideOnPlanning?: boolean | null, isNew?: boolean | null, isLocal?: boolean | null, hasProducts?: boolean | null, userHasWritePermission?: boolean | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', id: string } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, displayCampaignsCategory?: boolean | null } | null> | null } | null> | null } | null };

export type CanRegisterQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CanRegisterQuery = { __typename?: 'Query', canRegister?: { __typename?: 'CanRegisterResult', email?: string | null, userId?: string | null, error?: string | null, loginViaSso?: boolean | null, firstname?: string | null, lastname?: string | null, phone?: string | null, mobilePhone?: string | null, activity?: string | null, roleId?: string | null, roleSlug?: string | null, roleName?: string | null } | null };

export type CanResetPasswordQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CanResetPasswordQuery = { __typename?: 'Query', canResetPassword?: boolean | null };

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', userId: string, shippingFees?: Array<{ __typename?: 'ProviderShippingFees', fees?: number | null, providerId?: string | null, error?: boolean | null } | null> | null, totalWithShippingFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, items?: Array<{ __typename?: 'Item', subId?: string | null, comment?: string | null, productId: string, providerId?: string | null, type?: CartType | null, quantity: number, selectedFixPrice?: number | null, packInfo?: { __typename?: 'PackInfo', id?: string | null, name?: string | null, ref?: string | null, productsInPack?: Array<{ __typename?: 'ProductInPack', id?: string | null, name?: string | null, ref?: string | null } | null> | null } | null, files: Array<{ __typename?: 'ItemFile', id: string, url: string, originalName: string }>, options?: Array<{ __typename?: 'ProductOption', id: string, name?: string | null, price?: number | null, description?: string | null, image?: { __typename?: 'Image', id: string, small?: string | null } | null } | null> | null, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null, unitPrice?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, totalPrice?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, totalPricePerLocations?: Array<{ __typename?: 'PriceAndQuantityForLocation', locationId?: string | null, quantity?: number | null, basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null> | null, product: { __typename?: 'Product', id: string, providerId?: string | null, name?: string | null, description?: string | null, isMaximumOrderEnabled?: boolean | null, providerName?: string | null, isMinimumOrderEnabled?: boolean | null, minimumOrder?: number | null, catalogPrice?: number | null, priceType?: PriceTypes | null, isStockEnabled?: boolean | null, stock?: number | null, packagingUnit?: number | null, isCustomizable?: boolean | null, type?: AllowedProductType | null, isManyOptionsSelectable?: boolean | null, shouldHaveAtLeastOneOptionSelected?: boolean | null, shouldHaveExactOptionsSelected?: boolean | null, numberOfExactOptions?: number | null, isCommentEnabled?: boolean | null, userCanAddFiles?: boolean | null, isRoutingFileEnabled?: boolean | null, userCanComment?: boolean | null, userCanUpload?: boolean | null, maximumOrder?: { __typename?: 'ProductMaximumOrderConfig', quantity: number, period: ProductMaximumOrderPeriod } | null, availableQuantity?: { __typename?: 'AvailableQuantity', min: number, max: number } | null, catalogFixPricesLevelsByQuantity?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, fixPricesLevelsByQuantity?: Array<{ __typename?: 'PriceByQuantity', quantity?: number | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null> | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, images?: Array<{ __typename?: 'Image', thumbnail?: string | null, large?: string | null, small?: string | null, medium?: string | null, original?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, productOptions?: Array<{ __typename?: 'ProductOption', id: string } | null> | null }, quantitiesPerLocation?: Array<{ __typename?: 'QuantitiesPerLocation', locationId?: string | null, quantity?: number | null } | null> | null } | null> | null, vouchers?: Array<{ __typename?: 'Voucher', name?: string | null, amount?: number | null } | null> | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null };

export type CheckCartProductsAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckCartProductsAvailabilityQuery = { __typename?: 'Query', checkCartProductsAvailability?: boolean | null };

export type ClientBriefOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientBriefOptionsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, providerBriefClientId?: string | null, client: { __typename?: 'Client', briefOptions?: { __typename?: 'BriefHyundaiOptions', type?: boolean | null, internalReference?: boolean | null, visualReference?: boolean | null, delivery?: boolean | null, wishDelivery?: boolean | null, budget?: boolean | null, budgetType?: boolean | null, activityType?: boolean | null, modelType?: boolean | null, communicationType?: boolean | null, briefType?: boolean | null, workflow?: BriefWorkflow | null, contextGoalsIssues?: boolean | null, description?: boolean | null, targeting?: boolean | null, offer?: boolean | null, customerJourney?: boolean | null, campaignDates?: boolean | null, launchDates?: boolean | null, validityDates?: boolean | null, campaignType?: boolean | null, lever?: boolean | null, support?: boolean | null, workType?: boolean | null, campaignLevel?: boolean | null } | { __typename?: 'BriefOptions', type?: boolean | null, internalReference?: boolean | null, visualReference?: boolean | null, delivery?: boolean | null, wishDelivery?: boolean | null, budget?: boolean | null, workflow?: BriefWorkflow | null, contextGoalsIssues?: boolean | null, description?: boolean | null, targeting?: boolean | null, offer?: boolean | null, customerJourney?: boolean | null, campaignDates?: boolean | null, launchDates?: boolean | null, validityDates?: boolean | null, campaignType?: boolean | null, lever?: boolean | null, support?: boolean | null, workType?: boolean | null, campaignLevel?: boolean | null, governance?: boolean | null, groupedNotifications?: boolean | null } | null } } | null };

export type ClientNameQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientNameQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, name?: string | null } } | null };

export type ClientSsoQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientSsoQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, defaultSsoId?: string | null } } | null };

export type ClientsOfUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientsOfUserQuery = { __typename?: 'Query', clientsOfUser?: Array<{ __typename?: 'ClientInfos', name?: string | null, clientId?: string | null, providerInfo?: { __typename?: 'Provider', id: string, name: string, slug: string } | null } | null> | null };

export type CombinedAmplifyCampaignsListQueryQueryVariables = Exact<{
  postCalendarId?: InputMaybe<Scalars['ID']>;
  target: TargetType;
  salesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  globals?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  startAt?: InputMaybe<Scalars['Date']>;
  endAt?: InputMaybe<Scalars['Date']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  socialNetwork?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<AmplifyCampaignsListSortArgs>;
}>;


export type CombinedAmplifyCampaignsListQueryQuery = { __typename?: 'Query', getAmplifyCampaignsTotalMetrics?: { __typename?: 'AmplifyCampaignsTotalMetrics', campaignsCount?: number | null, spentBudget?: number | null, spentReach?: number | null, spentInteractions?: number | null } | null, getAmplifyCampaigns?: { __typename?: 'AmplifyCampaignsList', count?: number | null, campaigns?: Array<{ __typename?: 'AmplifyCampaign', id?: string | null, name?: string | null, socialNetwork?: string | null, authorRole?: SocialAuthorRole | null, status?: AmplifyAdCampaignStatus | null, adsCount?: number | null, totalBudget?: number | null, perPostBudget?: number | null, spentBudget?: number | null, callToAction?: number | null, spentReach?: number | null, spentInteraction?: number | null, cpi?: number | null, connection?: AmplifyCampaignConnectionTypes | null, isDefaultChalandiseZone?: boolean | null, startAt?: any | null, endAt?: any | null, optimizationGoal?: AmplifyCampaignGoalStrategy | null, specialCategories?: Array<AmplifyCampaignSpecialCategory | null> | null, target?: { __typename?: 'AmplifyCampaignTargeting', type?: TargetType | null, onGlobals?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', name?: string | null } | null> | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, post?: { __typename?: 'SocialMediaPost', id: string, type?: PostType | null, socialNetworkTarget: SocialNetwork, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, videoThumbnail?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null, target?: { __typename?: 'PostTarget', type?: TargetType | null } | null } | null, totalStatus?: { __typename?: 'AmplifyCampaignTotalStatus', done?: number | null, error?: number | null, terminated?: number | null } | null } | null> | null } | null };

export type CreateShortUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type CreateShortUrlQuery = { __typename?: 'Query', createShortURL?: { __typename?: 'shortUrl', link?: string | null } | null };

export type DeleteShippingFeesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteShippingFeesMutation = { __typename?: 'Mutation', deleteShippingFees?: boolean | null };

export type ExportAmplifyCampaignQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  sort?: InputMaybe<AmplifyAdsListSortArgs>;
}>;


export type ExportAmplifyCampaignQuery = { __typename?: 'Query', exportAmplifyCampaign?: string | null };

export type ExportAmplifyCampaignsQueryVariables = Exact<{
  postCalendarId?: InputMaybe<Scalars['ID']>;
  target: TargetType;
  salesPoints?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  globals?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  socialNetwork?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['Date']>;
  endAt?: InputMaybe<Scalars['Date']>;
  sort?: InputMaybe<AmplifyCampaignsListSortArgs>;
}>;


export type ExportAmplifyCampaignsQuery = { __typename?: 'Query', exportAmplifyCampaigns?: string | null };

export type FolderByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FolderByIdQuery = { __typename?: 'Query', folderById?: { __typename?: 'Folder', id?: string | null, name?: string | null, parent?: string | null, validFrom?: any | null, validTo?: any | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null } | null };

export type FoldersQueryVariables = Exact<{
  sort?: InputMaybe<FolderSort>;
  folderId?: InputMaybe<Scalars['ID']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
}>;


export type FoldersQuery = { __typename?: 'Query', folders?: Array<{ __typename?: 'Folder', id?: string | null, name?: string | null, parent?: string | null, enabled?: boolean | null, validFrom?: any | null, validTo?: any | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null } | null> | null };

export type FoldersForNavigationQueryVariables = Exact<{
  sort?: InputMaybe<FolderSort>;
  folderId?: InputMaybe<Scalars['ID']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
}>;


export type FoldersForNavigationQuery = { __typename?: 'Query', folders?: Array<{ __typename?: 'Folder', id?: string | null, name?: string | null, parent?: string | null, enabled?: boolean | null, validFrom?: any | null, validTo?: any | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null } | null> | null };

export type GetAllClientsIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientsIdsQuery = { __typename?: 'Query', getAllClients?: Array<{ __typename?: 'Client', clientId?: string | null, name?: string | null } | null> | null };

export type GetAllUsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllUsersQuery = { __typename?: 'Query', getAllUsers?: Array<{ __typename?: 'User', id: string, firstname?: string | null, fullName?: string | null, lastname?: string | null, mobilePhone?: string | null, email?: string | null, enabled?: boolean | null, activity?: string | null, canEdit?: boolean | null, registered?: boolean | null, lastActivityDay?: any | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null, absoluteSlug?: string | null } | null } | null> | null };

export type GetAmplifyAccountsQueryVariables = Exact<{
  socialNetworkUser?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  isLinked?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
}>;


export type GetAmplifyAccountsQuery = { __typename?: 'Query', getAmplifyAccounts?: { __typename?: 'AmplifyAccountPagination', count?: number | null, accounts?: Array<{ __typename?: 'AmplifyAccount', id?: string | null, name?: string | null, isLinked?: boolean | null, isActive?: boolean | null } | null> | null } | null };

export type GetAmplifyCampaignAdsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AmplifyAdsListSortArgs>;
}>;


export type GetAmplifyCampaignAdsQuery = { __typename?: 'Query', getAmplifyCampaignAds?: { __typename?: 'AmplifyCampaignAdsList', count?: number | null, ads?: Array<{ __typename?: 'AmplifyCampaignAd', id?: string | null, status?: AmplifyAdCampaignStatus | null, stoppedDate?: any | null, totalBudget?: number | null, spentBudget?: number | null, spentReach?: number | null, spentInteraction?: number | null, cpi?: number | null, errorMessage?: string | null, target?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetBase64PmWithBucketUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type GetBase64PmWithBucketUrlQuery = { __typename?: 'Query', getBase64PmWithBucketUrl?: string | null };

export type GetBasicUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBasicUserInfoQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, selectedSalesPointId?: string | null, languagePreference?: PlatformLanguageOption | null, selectedSalesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, role?: { __typename?: 'Role', id?: string | null, permissions?: Array<string | null> | null, name?: string | null } | null } | null };

export type GetBriefClientFeaturesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBriefClientFeaturesQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, client?: { __typename?: 'Client', f?: Array<Features | null> | null } | null } | { __typename?: 'BriefHyundai', id?: string | null, client?: { __typename?: 'Client', f?: Array<Features | null> | null } | null } | null };

export type GetBriefConceptionUrlStateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBriefConceptionUrlStateQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, conception?: Array<{ __typename?: 'BriefMedia', id?: string | null, url?: string | null } | null> | null } | { __typename?: 'BriefHyundai', id?: string | null, conception?: Array<{ __typename?: 'BriefMedia', id?: string | null, url?: string | null } | null> | null } | null };

export type AdCampaignForm_GetCampaignDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdCampaignForm_GetCampaignDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, name?: string | null } } | null, getAmplifyCampaignDetails?: { __typename?: 'AmplifyCampaign', id?: string | null, name?: string | null, adsCount?: number | null, totalBudget?: number | null, perPostBudget?: number | null, spentBudget?: number | null, spentReach?: number | null, spentInteraction?: number | null, cpi?: number | null, optimizationGoal?: AmplifyCampaignGoalStrategy | null, specialCategories?: Array<AmplifyCampaignSpecialCategory | null> | null, connection?: AmplifyCampaignConnectionTypes | null, isDefaultChalandiseZone?: boolean | null, advantagePlusOption: boolean, geoRadius?: number | null, startAt?: any | null, endAt?: any | null, sexTargeting?: boolean | null, ageTargeting?: boolean | null, sexOfTarget?: string | null, minAgeTarget?: number | null, maxAgeTarget?: number | null, target?: { __typename?: 'AmplifyCampaignTargeting', type?: TargetType | null, onGlobals?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null, targetingInterests?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, targetingCountries?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, targetingGeolocations?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, post?: { __typename?: 'SocialMediaPost', id: string, authorRole?: SocialAuthorRole | null, scheduledAt?: any | null, type?: PostType | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, videoThumbnail?: string | null, caption?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null, amplifyAvailableTargets?: { __typename?: 'AmplifyCampaignAvailableTargets', onGlobals?: boolean | null, isGlobalConnectionOptionAvailable?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, isAmplifyConnectionOptionAvailable?: boolean | null } | null> | null } | null } | null } | null };

export type GetDefaultChiliIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultChiliIdsQuery = { __typename?: 'Query', getChiliConfig?: { __typename?: 'ChiliConfig', clientId?: string | null, workspaceId?: string | null, watermarkId?: string | null, viewPreferencesId?: string | null, updatedAt?: any | null, exportPreferences?: Array<{ __typename?: 'ExportPreferences', id?: string | null, exportId?: string | null, label?: string | null } | null> | null, updatedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null };

export type ClientFeatureQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientFeatureQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, f?: Array<Features | null> | null } } | null };

export type TargetingStep_GetCountryListQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type TargetingStep_GetCountryListQuery = { __typename?: 'Query', getCountryList?: { __typename?: 'TargetingPayload', data?: Array<{ __typename?: 'TargetingItem', facebookKey: string, name: string } | null> | null } | null };

export type GetCustomDynVarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomDynVarQuery = { __typename?: 'Query', getCustomDynVar: Array<{ __typename?: 'CustomFieldDefinition', slug: string, description?: string | null, label: string }> };

export type GetCustomVisualUrlQueryVariables = Exact<{
  salesPointId: Scalars['ID'];
}>;


export type GetCustomVisualUrlQuery = { __typename?: 'Query', getCustomVisualUrl?: Array<{ __typename?: 'FileInfo', url?: string | null, filename?: string | null } | null> | null };

export type GetOrderedProductPdfUrlQueryVariables = Exact<{
  productId: Scalars['ID'];
  subId: Scalars['ID'];
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOrderedProductPdfUrlQuery = { __typename?: 'Query', getOrderedProductPDFUrl?: string | null };

export type GroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupsQuery = { __typename?: 'Query', salesPointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null };

export type GetHashtagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHashtagsQuery = { __typename?: 'Query', getHashtags?: Array<string | null> | null };

export type GetImportFileSpecificationsQueryVariables = Exact<{
  socialNetwork: SocialNetwork;
  type: ImportFileForPostType;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>> | InputMaybe<SocialNetwork>>;
}>;


export type GetImportFileSpecificationsQuery = { __typename?: 'Query', getImportFileSpecifications?: { __typename?: 'ImportFileSpecifications', allowedExtensions?: Array<string | null> | null, minSize?: string | null, maxSize?: string | null, minFormat?: string | null, maxFormat?: string | null, minResolution?: string | null, maxResolution?: string | null, minFiles?: number | null, maxFiles?: number | null, minDuration?: number | null, maxDuration?: number | null } | null };

export type GetImportFileSpecificationsForAllSocialNetworksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImportFileSpecificationsForAllSocialNetworksQuery = { __typename?: 'Query', getImportFileSpecificationsForAllSocialNetworks?: Array<{ __typename?: 'SocialNetworkImportFileSpecifications', socialNetwork?: SocialNetwork | null, types?: Array<{ __typename?: 'ImportFileSpecificationsByType', type?: FileImportType | null, specs?: { __typename?: 'ImportFileSpecifications', allowedExtensions?: Array<string | null> | null, minSize?: string | null, maxSize?: string | null, minFormat?: string | null, maxFormat?: string | null, minResolution?: string | null, maxResolution?: string | null, minFiles?: number | null, maxFiles?: number | null } | null } | null> | null } | null> | null };

export type TargetingStep_GetInterestListQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type TargetingStep_GetInterestListQuery = { __typename?: 'Query', getInterestList?: { __typename?: 'TargetingPayload', data?: Array<{ __typename?: 'TargetingItem', facebookKey: string, name: string } | null> | null } | null };

export type GetLinkMetadataQueryVariables = Exact<{
  link: Scalars['String'];
}>;


export type GetLinkMetadataQuery = { __typename?: 'Query', getLinkMetadata?: { __typename?: 'LinkMetadata', source?: string | null, title?: string | null, description?: string | null, image?: string | null } | null };

export type GetMentionListQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type GetMentionListQuery = { __typename?: 'Query', getMentionList?: { __typename?: 'MentionPayload', data?: Array<{ __typename?: 'MentionItem', id: string, name: string, url: string } | null> | null } | null };

export type GetOrderArchiveUrlQueryVariables = Exact<{
  orderId: Scalars['ID'];
  productId?: InputMaybe<Scalars['ID']>;
  subId?: InputMaybe<Scalars['ID']>;
}>;


export type GetOrderArchiveUrlQuery = { __typename?: 'Query', getOrderArchiveUrl: string };

export type GetPmPhotosBySalesPointIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPmPhotosBySalesPointIdQuery = { __typename?: 'Query', getPmPhotosBySalesPoint?: any | null };

export type GetPostCalendarDetailsQueryVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type GetPostCalendarDetailsQuery = { __typename?: 'Query', getPostCalendarDetails?: { __typename?: 'SocialMediaPost', link?: string | null, dynamicLink?: string | null, id: string, type?: PostType | null, description?: string | null, rawDescription?: string | null, htmlDescription?: string | null, scheduledAt?: any | null, validationDate?: any | null, validatorRole?: string | null, socialNetworkTarget: SocialNetwork, isDraft?: boolean | null, status?: PostStatus | null, cover?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, avatar?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, medias?: Array<{ __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null> | null, thumb?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, carouselItems?: Array<{ __typename?: 'PostCarouselItem', position?: number | null, link?: string | null, title?: string | null, description?: string | null, callToAction?: number | null, media?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null }> | null, event?: { __typename?: 'SocialEvent', title?: string | null, startAt?: any | null, endAt?: any | null, callToAction?: number | null, terms?: string | null, couponCode?: string | null } | null, organicTargeting?: { __typename?: 'OrganicTargeting', sexTargeting?: boolean | null, sexOfTarget?: string | null, ageTargeting?: boolean | null, minAgeTarget?: number | null, maxAgeTarget?: number | null, targetingInterests?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, targetingCountries?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, targetingGeolocations?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null } | null, target?: { __typename?: 'PostTarget', type?: TargetType | null, globals?: Array<string | null> | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, targetToExclude?: Array<string | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null, salespoints?: Array<{ __typename?: 'SalesPoint', social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null } | null } | null> | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null } | null } | null } | null> | null } | null } | null };

export type GetProviderInvoiceUrlQueryVariables = Exact<{
  orderId: Scalars['ID'];
  path: Scalars['String'];
}>;


export type GetProviderInvoiceUrlQuery = { __typename?: 'Query', getProviderInvoiceUrl?: string | null };

export type GetSalesPointsByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>> | InputMaybe<SocialNetwork>>;
  type?: InputMaybe<SocialLinkType>;
}>;


export type GetSalesPointsByKeywordQuery = { __typename?: 'Query', salesPointsByKeyword?: { __typename?: 'SalesPointPagination', count?: number | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, google?: boolean | null, instagram?: boolean | null, twitter?: boolean | null } | null } | null } | null> | null } | null };

export type GetSalesPointsGroupsByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  socialNetwork?: InputMaybe<SocialNetwork>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>> | InputMaybe<SocialNetwork>>;
  type?: InputMaybe<SocialLinkType>;
}>;


export type GetSalesPointsGroupsByKeywordQuery = { __typename?: 'Query', salesPointsGroupsByKeyword?: { __typename?: 'SalespointsGroupsPagination', count?: number | null, salesPointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null } | null };

export type GetSalesPointsTargetNetworkDetailByIdsQueryVariables = Exact<{
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>> | InputMaybe<SocialNetwork>>;
}>;


export type GetSalesPointsTargetNetworkDetailByIdsQuery = { __typename?: 'Query', getSalesPointsTargetNetworkDetailByIds?: { __typename?: 'SalesPointTargetNetworkDetail', total?: number | null, facebook?: number | null, google?: number | null, instagram?: number | null, linkedin?: number | null } | null };

export type GetSalespointLinkedSocialNetworkCountQueryVariables = Exact<{
  socialNetwork: SocialNetwork;
  salespointGroupIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetSalespointLinkedSocialNetworkCountQuery = { __typename?: 'Query', getSalespointLinkedSocialNetworkCount: { __typename?: 'SalesPointLinkedCountResult', linked: number, notLinked: number } };

export type GetShippingFeeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetShippingFeeQuery = { __typename?: 'Query', getShippingFees?: { __typename?: 'ShippingFees', enabled?: boolean | null, name?: string | null, maxWeight?: number | null, freeShipping?: number | null, isAllSalesPoints?: boolean | null, id?: string | null, shippingFeesGridPerWeight?: Array<{ __typename?: 'ShippingFeesPerWeight', fees?: number | null, weight?: number | null } | null> | null, salesPointsIds?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null, salespointGroupsIds?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null } | null };

export type GetSocialNetworkAccountsQueryVariables = Exact<{
  socialNetwork: SocialNetwork;
  socialNetworkUser?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  isLinked?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
}>;


export type GetSocialNetworkAccountsQuery = { __typename?: 'Query', getSocialNetworkAccounts?: { __typename?: 'SocialNetworkAccounts', count?: number | null, socialNetworkAccounts?: Array<{ __typename?: 'AccountPage', id?: string | null, name?: string | null, isLinked?: boolean | null, url?: string | null, haveInstagramAccount?: boolean | null } | null> | null } | null };

export type GetSocialNetworkUsersQueryVariables = Exact<{
  socialNetwork: SocialNetwork;
}>;


export type GetSocialNetworkUsersQuery = { __typename?: 'Query', getSocialNetworkUsers?: Array<{ __typename?: 'SocialLoginInfos', id?: number | null, username?: string | null, isTokenValid?: boolean | null, connected?: boolean | null, accountType?: string | null, socialNetwork?: string | null, mainAccount?: boolean | null, isSystemUser?: boolean | null } | null> | null };

export type GetStateSaveChiliBySalespointQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStateSaveChiliBySalespointQuery = { __typename?: 'Query', getStateSaveChiliBySalespoint?: boolean | null };

export type GetTagsMediasQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TagsSort>;
  filter?: InputMaybe<TagsFilters>;
}>;


export type GetTagsMediasQuery = { __typename?: 'Query', tags?: { __typename?: 'TagsPagination', count?: number | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, enabled?: boolean | null, tagGroup?: { __typename?: 'TagGroup', id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetUrlColorCssQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUrlColorCssQuery = { __typename?: 'Query', getUrlColorCss?: { __typename?: 'ColorCss', url?: string | null } | null };

export type GetUserAvailableSocialNetworksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAvailableSocialNetworksQuery = { __typename?: 'Query', getUserAvailableSocialNetworks?: Array<SocialNetwork | null> | null };

export type HierarchyMediaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HierarchyMediaQuery = { __typename?: 'Query', hierarchyMedia?: Array<{ __typename?: 'HierarchyDetail', name: string, folderId: string } | null> | null };

export type HomePageAllSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageAllSettingsQuery = { __typename?: 'Query', getAllHomePageSettings?: Array<{ __typename?: 'HomePageSettings', id?: string | null, lang?: AvailableLang | null, slides?: { __typename?: 'HomePageSlideSettings', enabled?: boolean | null, order?: number | null, sliderType?: SliderType | null, slidesDetails?: Array<{ __typename?: 'SlidesDetails', id?: string | null, title?: string | null, secondaryText?: string | null, textColor?: TextColor | null, buttonDisplay?: boolean | null, buttonText?: string | null, redirectionLink?: string | null, order?: number | null, image?: { __typename?: 'SlideImage', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null } | null> | null } | null, campaign?: { __typename?: 'HomePageCampaignSettings', enabled?: boolean | null, title?: string | null, text?: string | null, buttonText?: string | null, buttonLink?: string | null, customCampaignsEnabled?: boolean | null, order?: number | null, campaignIds?: Array<{ __typename?: 'CampaignDetails', campaignId?: string | null, order?: number | null } | null> | null } | null, callToAction?: { __typename?: 'HomePageCallToAction', enabled?: boolean | null, order?: number | null, callToActions?: Array<{ __typename?: 'CallToAction', order?: number | null, title?: string | null, secondaryText?: string | null, buttonName?: string | null, redirectionUrl?: string | null } | null> | null } | null, shop?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null, library?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null, planning?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null } | null> | null };

export type HomePageSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageSettingsQuery = { __typename?: 'Query', getHomePageSettings?: { __typename?: 'HomePageSettings', id?: string | null, lang?: AvailableLang | null, slides?: { __typename?: 'HomePageSlideSettings', enabled?: boolean | null, order?: number | null, sliderType?: SliderType | null, slidesDetails?: Array<{ __typename?: 'SlidesDetails', id?: string | null, title?: string | null, secondaryText?: string | null, textColor?: TextColor | null, buttonDisplay?: boolean | null, buttonText?: string | null, redirectionLink?: string | null, order?: number | null, image?: { __typename?: 'SlideImage', original?: string | null } | null } | null> | null } | null, campaign?: { __typename?: 'HomePageCampaignSettings', enabled?: boolean | null, title?: string | null, text?: string | null, buttonText?: string | null, buttonLink?: string | null, customCampaignsEnabled?: boolean | null, order?: number | null, campaignIds?: Array<{ __typename?: 'CampaignDetails', campaignId?: string | null, order?: number | null } | null> | null } | null, callToAction?: { __typename?: 'HomePageCallToAction', enabled?: boolean | null, order?: number | null, callToActions?: Array<{ __typename?: 'CallToAction', order?: number | null, title?: string | null, secondaryText?: string | null, buttonName?: string | null, redirectionUrl?: string | null } | null> | null } | null, shop?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null, library?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null, planning?: { __typename?: 'HomePageBasicSettings', enabled?: boolean | null, order?: number | null, title?: string | null } | null } | null };

export type HomepageCampaignsQueryVariables = Exact<{
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  types: Array<CampaignType> | CampaignType;
}>;


export type HomepageCampaignsQuery = { __typename?: 'Query', campaignsPerPeriods?: { __typename?: 'CampaignsPerPeriods', homepageCampaigns?: Array<{ __typename?: 'Campaign', hasPreorderProducts?: boolean | null, preorderEndDate?: any | null, preorderDaysRemaining?: number | null, id: string, name?: string | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, description?: string | null, hideOnPlanning?: boolean | null, isNew?: boolean | null, isLocal?: boolean | null, hasProducts?: boolean | null, userHasWritePermission?: boolean | null, image?: { __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', id: string } | null> | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, displayCampaignsCategory?: boolean | null } | null> | null } | null> | null } | null };

export type LanguageSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguageSelectOptionsQuery = { __typename?: 'Query', languageSelectOptions?: Array<LanguageSelectOption | null> | null };

export type GetPostCalendarDetails_And_Client_NameQueryVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type GetPostCalendarDetails_And_Client_NameQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, name?: string | null } } | null, getPostCalendarDetails?: { __typename?: 'SocialMediaPost', id: string, levelEditable?: number | null, type?: PostType | null, description?: string | null, rawDescription?: string | null, htmlDescription?: string | null, caller?: number | null, scheduledAt?: any | null, validationDate?: any | null, validatorRole?: string | null, socialNetworkTarget: SocialNetwork, isDraft?: boolean | null, status?: PostStatus | null, callToAction?: number | null, link?: string | null, dynamicLink?: string | null, socialNetworksDescription?: { __typename?: 'SocialNetworksDescriptionType', facebook?: string | null, instagram?: string | null, linkedin?: string | null, google?: string | null, twitter?: string | null } | null, socialNetworksRawDescription?: { __typename?: 'SocialNetworksDescriptionType', facebook?: string | null, instagram?: string | null, linkedin?: string | null, google?: string | null, twitter?: string | null } | null, target?: { __typename?: 'PostTarget', type?: TargetType | null, globals?: Array<string | null> | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, targetToExclude?: Array<string | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null, cover?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, avatar?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, medias?: Array<{ __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null, size?: number | null, width?: number | null, height?: number | null, extension?: string | null } | null> | null, thumb?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, carouselItems?: Array<{ __typename?: 'PostCarouselItem', position?: number | null, link?: string | null, title?: string | null, description?: string | null, callToAction?: number | null, media?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null }> | null, event?: { __typename?: 'SocialEvent', title?: string | null, startAt?: any | null, endAt?: any | null, callToAction?: number | null, terms?: string | null, couponCode?: string | null } | null, organicTargeting?: { __typename?: 'OrganicTargeting', sexTargeting?: boolean | null, sexOfTarget?: string | null, ageTargeting?: boolean | null, minAgeTarget?: number | null, maxAgeTarget?: number | null, cityKeysTarget?: Array<string | null> | null, targetingInterests?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, targetingCountries?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, targetingGeolocations?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null } | null } | null };

export type MediaByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MediaByIdQuery = { __typename?: 'Query', mediaById?: { __typename?: 'Media', id: string, type: LibraryMediaType, name?: string | null, fileType?: UploadedFileType | null, thumbnail?: string | null, validFrom?: any | null, validTo?: any | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, size?: number | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null, images?: { __typename?: 'ImageFormats', thumbnail?: string | null, large?: string | null } | null } | null };

export type MediaByIdChiliQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MediaByIdChiliQuery = { __typename?: 'Query', mediaById?: { __typename?: 'Media', id: string, type: LibraryMediaType, name?: string | null, fileType?: UploadedFileType | null, thumbnail?: string | null, isDownloadByEmail?: boolean | null, validFrom?: any | null, validTo?: any | null, chiliDetails?: { __typename?: 'ChiliDetails', documentId?: string | null, documentDownloadSettingsId?: string | null, documentWorkspaceId?: string | null, documentViewPrefsId?: string | null, exportTypeIds?: Array<string | null> | null } | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, size?: number | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null, images?: { __typename?: 'ImageFormats', thumbnail?: string | null } | null } | null };

export type MediaFilterGroupsQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<MediaFilterInput>> | InputMaybe<MediaFilterInput>>;
  folderId?: InputMaybe<Scalars['ID']>;
  types?: InputMaybe<Array<InputMaybe<MediaTypeFilter>> | InputMaybe<MediaTypeFilter>>;
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
}>;


export type MediaFilterGroupsQuery = { __typename?: 'Query', mediaFilterGroups?: Array<{ __typename?: 'MediaFilterGroup', id?: string | null, name?: string | null, type?: MediaFilterType | null, options?: Array<{ __typename?: 'MediaFilterOption', id?: string | null, name?: string | null, count?: number | null } | null> | null } | null> | null };

export type MediasQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MediaSort>;
  folderId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Array<InputMaybe<MediaFilterInput>> | InputMaybe<MediaFilterInput>>;
  keyword?: InputMaybe<Scalars['String']>;
  searchInSubfolders?: InputMaybe<Scalars['Boolean']>;
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignId?: InputMaybe<Scalars['ID']>;
  includeHighlighted?: InputMaybe<Scalars['Boolean']>;
  excludeDisabledForAdmin?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<InputMaybe<MediaTypeFilter>> | InputMaybe<MediaTypeFilter>>;
}>;


export type MediasQuery = { __typename?: 'Query', medias?: { __typename?: 'MediasPagination', count?: number | null, highlighted?: Array<{ __typename?: 'MediasHighlighted', tag?: { __typename?: 'Tag', id: string, label?: string | null, enabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, library?: { __typename?: 'TagLibraryInfos', isHighlighted?: boolean | null, highlightOrder?: number | null } | null } | null, medias?: Array<{ __typename?: 'Media', id: string, name?: string | null, type: LibraryMediaType, fileType?: UploadedFileType | null, thumbnail?: string | null, tempUrl?: string | null, enabled?: boolean | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, size?: number | null, mimetype?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null, images?: { __typename?: 'ImageFormats', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null } | null } | null> | null } | null> | null, medias?: Array<{ __typename?: 'LiteMedia', id: string, name?: string | null, type: LibraryMediaType, fileType?: UploadedFileType | null, thumbnail?: string | null, tempUrl?: string | null, enabled?: boolean | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, size?: number | null, mimetype?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null, images?: { __typename?: 'ImageFormats', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null } | null } | null> | null } | null };

export type Medias_For_Upload_ModalQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MediaSort>;
  folderId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Array<InputMaybe<MediaFilterInput>> | InputMaybe<MediaFilterInput>>;
  keyword?: InputMaybe<Scalars['String']>;
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignId?: InputMaybe<Scalars['ID']>;
  includeHighlighted?: InputMaybe<Scalars['Boolean']>;
  excludeDisabledForAdmin?: InputMaybe<Scalars['Boolean']>;
}>;


export type Medias_For_Upload_ModalQuery = { __typename?: 'Query', medias?: { __typename?: 'MediasPagination', count?: number | null, medias?: Array<{ __typename?: 'LiteMedia', id: string, name?: string | null, fileType?: UploadedFileType | null, tempUrl?: string | null, thumbnail?: string | null, details?: { __typename?: 'MediaDetails', size?: number | null, mimetype?: string | null, extension?: string | null, width?: number | null, height?: number | null } | null, images?: { __typename?: 'ImageFormats', medium?: string | null } | null } | null> | null } | null };

export type OrderDetailsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderDetailsQuery = { __typename?: 'Query', orderDetails?: { __typename?: 'Order', id: string, orderNumber: string, trackingNumber?: string | null, trackingURL?: string | null, userId: string, status: Status, receipt?: string | null, totalProductsQuantity: number, date: any, items: Array<{ __typename?: 'OrderItem', productId: string, subId?: string | null, quantity: number, packInfo?: { __typename?: 'PackInfo', id?: string | null, name?: string | null, ref?: string | null, productsInPack?: Array<{ __typename?: 'ProductInPack', id?: string | null, name?: string | null, ref?: string | null } | null> | null } | null, product: { __typename?: 'OrderProduct', id: string, name: string, ref?: string | null, description?: string | null, isCustomizable?: boolean | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, images?: Array<{ __typename?: 'OrderImage', small?: string | null } | null> | null, tags?: Array<{ __typename?: 'OrderTag', id?: string | null, label?: string | null, color?: string | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null }, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null } | null>, addresses: { __typename?: 'Addresses', shipping?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null, billing?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null }, vouchers?: Array<{ __typename?: 'OrderVoucher', name?: string | null, amount?: number | null } | null> | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null } | null, totalWithFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null, withTaxes?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null };

export type OrderDetailsWithModerationQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderDetailsWithModerationQuery = { __typename?: 'Query', orderDetails?: { __typename?: 'Order', id: string, affairCode?: string | null, parentOrderId?: string | null, sisterOrderCount?: number | null, orderNumber: string, trackingNumber?: string | null, trackingURL?: string | null, userId: string, status: Status, receipt?: string | null, totalProductsQuantity: number, date: any, validationDate?: any | null, roleValidator?: RoleValidator | null, reason?: string | null, isPurchaseOrder?: boolean | null, shippingFees?: number | null, isValidator?: boolean | null, hasArchive?: boolean | null, paymentInfo?: { __typename?: 'PaymentInfo', currentStatus?: PaymentStatusValue | null, stripePaymentMethod?: StripePaymentMethod | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null, email?: string | null } | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, client?: { __typename?: 'Client', id: string, shopOptions?: { __typename?: 'ShopOptions', isShippingFeesEnabled?: boolean | null, displayTaxes?: boolean | null, billingAddress?: { __typename?: 'BillingAddress', address?: string | null, additionalAddress?: string | null, company?: string | null, city?: string | null, country?: string | null, postalCode?: string | null } | null } | null } | null, paymentMethod?: { __typename?: 'OrderPaymentMethod', type?: OrderPaymentMethodType | null, documentType?: OrderPaymentMethodDocumentType | null } | null, messages?: Array<{ __typename?: 'OrderMessage', id: string, content?: string | null, createdAt?: any | null, isCancelledReason?: boolean | null }> | null, validator?: { __typename?: 'User', id: string, fullName?: string | null } | null, items: Array<{ __typename?: 'OrderItem', hasArchive: boolean, productId: string, subId?: string | null, comment?: string | null, quantity: number, files?: Array<{ __typename?: 'OrderItemFile', id: string, originalName: string, url: string }> | null, options?: Array<{ __typename?: 'OrderItemOptions', id: string, name?: string | null, price?: number | null }> | null, unitPrice?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, totalPrice?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, product: { __typename?: 'OrderProduct', id: string, name: string, ref?: string | null, description?: string | null, isCustomizable?: boolean | null, packagingUnit?: number | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, images?: Array<{ __typename?: 'OrderImage', thumbnail?: string | null } | null> | null, tags?: Array<{ __typename?: 'OrderTag', id?: string | null, label?: string | null, color?: string | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null }, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null } | null>, addresses: { __typename?: 'Addresses', shipping?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, salespoint?: { __typename?: 'SalesPoint', name?: string | null } | null } | null, billing?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null }, vouchers?: Array<{ __typename?: 'OrderVoucher', name?: string | null, amount?: number | null } | null> | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null } | null, totalWithFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null, withTaxes?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, totalWithShippingFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null };

export type OrdersByUserIdQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Direction>;
  filter?: InputMaybe<OrderFilter>;
  salespointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  groupsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type OrdersByUserIdQuery = { __typename?: 'Query', ordersByUserId?: { __typename?: 'OrderPagination', count: number, totalWithoutTaxes?: number | null, orders?: Array<{ __typename?: 'Order', id: string, isValidator?: boolean | null, orderNumber: string, trackingNumber?: string | null, trackingURL?: string | null, userId: string, status: Status, receipt?: string | null, totalProductsQuantity: number, date: any, isPurchaseOrder?: boolean | null, paymentMethod?: { __typename?: 'OrderPaymentMethod', type?: OrderPaymentMethodType | null, documentType?: OrderPaymentMethodDocumentType | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', currentStatus?: PaymentStatusValue | null, stripePaymentMethod?: StripePaymentMethod | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, items: Array<{ __typename?: 'OrderItem', productId: string, subId?: string | null, providerId?: string | null, quantity: number, packInfo?: { __typename?: 'PackInfo', id?: string | null, name?: string | null, ref?: string | null, productsInPack?: Array<{ __typename?: 'ProductInPack', id?: string | null, name?: string | null, ref?: string | null } | null> | null } | null, product: { __typename?: 'OrderProduct', id: string, name: string, ref?: string | null, description?: string | null, isCustomizable?: boolean | null, type?: string | null, images?: Array<{ __typename?: 'OrderImage', small?: string | null } | null> | null, tags?: Array<{ __typename?: 'OrderTag', id?: string | null, label?: string | null, color?: string | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null }, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null } | null>, addresses: { __typename?: 'Addresses', shipping?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null, billing?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null }, vouchers?: Array<{ __typename?: 'OrderVoucher', name?: string | null, amount?: number | null } | null> | null, provider?: { __typename?: 'Provider', name: string } | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, totalWithFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null, withTaxes?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, totalWithShippingFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null } | null, providerInvoice?: { __typename?: 'ProviderInvoice', path?: string | null } | null } | null> | null } | null };

export type ParentOrderByIdQueryVariables = Exact<{
  parentOrderId: Scalars['ID'];
}>;


export type ParentOrderByIdQuery = { __typename?: 'Query', parentOrderById?: { __typename?: 'ParentOrder', orderNumber: string } | null };

export type PaymentSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentSelectOptionsQuery = { __typename?: 'Query', paymentSelectOptions?: Array<string | null> | null };

export type PreorderForCampaignQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  salesPointId: Scalars['ID'];
}>;


export type PreorderForCampaignQuery = { __typename?: 'Query', preorderForCampaign?: { __typename?: 'Preorder', id: string, status: PreorderStatus, ref?: string | null, submittedAt?: any | null, items: Array<{ __typename?: 'PreorderItem', productId: string, quantity: number }> } | null };

export type PreordersByUserIdQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Direction>;
  sortBy?: InputMaybe<PreorderSortField>;
  filter?: InputMaybe<PreorderFilter>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  groupsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PreordersByUserIdQuery = { __typename?: 'Query', preorders?: { __typename?: 'PreorderPagination', count: number, totalWithoutTaxes?: number | null, preorders: Array<{ __typename?: 'Preorder', id: string, ref?: string | null, status: PreorderStatus, statusUx?: PreorderStatusUx | null, submittedAt?: any | null, createdAt?: any | null, salesPointId: string, salesPointName?: string | null, providerName?: string | null, productsCount?: number | null, totalWithoutTaxes?: number | null, totalWithTaxes?: number | null, items: Array<{ __typename?: 'PreorderItem', productId: string, quantity: number }>, user?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null, preorderEndDate?: any | null } | null }> } | null };

export type ProductByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  isQueryFromUpdateProductAdmin?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProductByIdQuery = { __typename?: 'Query', productById?: { __typename?: 'Product', id: string, name?: string | null, providerId?: string | null, isBriefCrm?: boolean | null, other?: string | null, isShowcase?: boolean | null, showcaseText?: string | null, userCanComment?: boolean | null, userCanUpload?: boolean | null, userCanAddFiles?: boolean | null, isRoutingFileEnabled?: boolean | null, packagingUnit?: number | null, isStockEnabled?: boolean | null, stock?: number | null, isMinimumOrderEnabled?: boolean | null, minimumOrder?: number | null, isMaximumOrderEnabled?: boolean | null, isGovernanceEnabled?: boolean | null, requiresOrderValidation?: boolean | null, priceType?: PriceTypes | null, ref?: string | null, description?: string | null, isCustomizable?: boolean | null, tips?: string | null, technicalCharacteristics?: string | null, type?: AllowedProductType | null, isPurchaseOrder?: boolean | null, isCommentEnabled?: boolean | null, documentId?: string | null, documentDownloadSettingsId?: string | null, documentWorkspaceId?: string | null, documentViewPrefsId?: string | null, exportTypeIds?: Array<string | null> | null, watermarkPreview?: boolean | null, useSalespointGroups?: boolean | null, useEnabledDates?: boolean | null, useLaunchDate?: boolean | null, useValidDate?: boolean | null, deliveryDate?: number | null, enabledDate?: any | null, disabledDate?: any | null, disabled?: boolean | null, isProposeForDownload?: boolean | null, isManyOptionsSelectable?: boolean | null, shouldHaveAtLeastOneOptionSelected?: boolean | null, shouldHaveExactOptionsSelected?: boolean | null, numberOfExactOptions?: number | null, paidMediaCampaignName?: string | null, isPaidMediaProduct?: boolean | null, hasVariation?: boolean | null, isDownloadByEmail?: boolean | null, contextGoalsIssues?: string | null, targeting?: string | null, isPack?: boolean | null, preorderAvailable?: boolean | null, crmSupports?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, value?: string | null, label?: string | null } | null> | null, workType?: { __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, value?: string | null, label?: string | null } | null, availableQuantity?: { __typename?: 'AvailableQuantity', max: number, min: number } | null, maximumOrder?: { __typename?: 'ProductMaximumOrderConfig', quantity: number, period: ProductMaximumOrderPeriod } | null, maximumOrderExceptions?: Array<{ __typename?: 'ProductMaximumOrderException', salespointGroupsIds: Array<string>, salespointsIds: Array<string>, quantity: number, period: ProductMaximumOrderPeriod }> | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, catalogFixPricesLevelsByQuantity?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, fixPricesLevelsByQuantity?: Array<{ __typename?: 'PriceByQuantity', quantity?: number | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null> | null, images?: Array<{ __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, small?: string | null, medium?: string | null, original?: string | null, originName?: string | null, mime?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, productOptions?: Array<{ __typename?: 'ProductOption', id: string, name?: string | null, price?: number | null, description?: string | null, position?: number | null, image?: { __typename?: 'Image', thumbnail?: string | null, large?: string | null, small?: string | null, medium?: string | null, original?: string | null } | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null, lowQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null, id?: string | null, mime?: string | null } | null, variation?: Array<{ __typename?: 'ProductAttribute', name?: string | null, slug?: string | null, fixed?: boolean | null, values?: Array<string | null> | null } | null> | null, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null, productsInPack?: Array<{ __typename?: 'ProductPack', position: number, product: { __typename?: 'Product', id: string, providerId?: string | null, name?: string | null, isBriefCrm?: boolean | null, isShowcase?: boolean | null, showcaseText?: string | null, userCanComment?: boolean | null, userCanUpload?: boolean | null, isRoutingFileEnabled?: boolean | null, packagingUnit?: number | null, isStockEnabled?: boolean | null, stock?: number | null, isMinimumOrderEnabled?: boolean | null, minimumOrder?: number | null, isMaximumOrderEnabled?: boolean | null, catalogPrice?: number | null, priceType?: PriceTypes | null, ref?: string | null, isCustomizable?: boolean | null, isPurchaseOrder?: boolean | null, isCommentEnabled?: boolean | null, documentId?: string | null, documentDownloadSettingsId?: string | null, documentWorkspaceId?: string | null, documentViewPrefsId?: string | null, exportTypeIds?: Array<string | null> | null, watermarkPreview?: boolean | null, hasVariation?: boolean | null, availableQuantity?: { __typename?: 'AvailableQuantity', max: number, min: number } | null, maximumOrder?: { __typename?: 'ProductMaximumOrderConfig', quantity: number, period: ProductMaximumOrderPeriod } | null, maximumOrderExceptions?: Array<{ __typename?: 'ProductMaximumOrderException', salespointGroupsIds: Array<string>, salespointsIds: Array<string>, quantity: number, period: ProductMaximumOrderPeriod }> | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, catalogFixPricesLevelsByQuantity?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, fixPricesLevelsByQuantity?: Array<{ __typename?: 'PriceByQuantity', quantity?: number | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null> | null, images?: Array<{ __typename?: 'Image', id: string, original?: string | null, originName?: string | null } | null> | null, variation?: Array<{ __typename?: 'ProductAttribute', name?: string | null, slug?: string | null, fixed?: boolean | null, values?: Array<string | null> | null } | null> | null, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null } } | null> | null } | null };

export type ProductFilterGroupsQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<ProductFilterInput>> | InputMaybe<ProductFilterInput>>;
}>;


export type ProductFilterGroupsQuery = { __typename?: 'Query', productFilterGroups?: Array<{ __typename?: 'ProductFilterGroup', name?: string | null, id?: string | null, filters?: Array<{ __typename?: 'ProductFilter', id?: string | null, name?: string | null, type?: ProductFilterType | null, details?: { __typename?: 'ProductFilterDetails', options?: Array<{ __typename?: 'ProductFilterOption', id?: string | null, name?: string | null, count?: number | null } | null> | null } | null } | null> | null } | null> | null };

export type ProductsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<ProductFilterInput>> | InputMaybe<ProductFilterInput>>;
  sort?: InputMaybe<ProductSort>;
  keyword?: InputMaybe<Scalars['String']>;
  separateHighlights?: InputMaybe<Scalars['Boolean']>;
  preorderAvailable?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPagination', count?: number | null, highlightedCount?: number | null, products?: Array<{ __typename?: 'Product', clientId?: string | null, id: string, name?: string | null, isHighlighted?: boolean | null, isBriefCrm?: boolean | null, isShowcase?: boolean | null, showcaseText?: string | null, priceType?: PriceTypes | null, description?: string | null, isCustomizable?: boolean | null, tips?: string | null, type?: AllowedProductType | null, ref?: string | null, shouldHaveAtLeastOneOptionSelected?: boolean | null, shouldHaveExactOptionsSelected?: boolean | null, numberOfExactOptions?: number | null, stock?: number | null, isStockEnabled?: boolean | null, packagingUnit?: number | null, isPack?: boolean | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, fixPricesLevelsByQuantity?: Array<{ __typename?: 'PriceByQuantity', quantity?: number | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null, lowQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null, images?: Array<{ __typename?: 'Image', thumbnail?: string | null, large?: string | null, small?: string | null, medium?: string | null, original?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, productOptions?: Array<{ __typename?: 'ProductOption', id: string, price?: number | null } | null> | null, productsInPack?: Array<{ __typename?: 'ProductPack', position: number, product: { __typename?: 'Product', id: string, name?: string | null, priceType?: PriceTypes | null, catalogPrice?: number | null, images?: Array<{ __typename?: 'Image', id: string, original?: string | null, originName?: string | null } | null> | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', price?: number | null, quantity?: number | null } | null> | null, catalogFixPricesLevelsByQuantity?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null } } | null> | null } | null> | null, highlightedProducts?: Array<{ __typename?: 'Product', id: string, name?: string | null, type?: AllowedProductType | null, isShowcase?: boolean | null, isBriefCrm?: boolean | null, showcaseText?: string | null, priceType?: PriceTypes | null, description?: string | null, isHighlighted?: boolean | null, useEnabledDates?: boolean | null, useLaunchDate?: boolean | null, useValidDate?: boolean | null, deliveryDate?: number | null, enabledDate?: any | null, disabledDate?: any | null, shouldHaveAtLeastOneOptionSelected?: boolean | null, shouldHaveExactOptionsSelected?: boolean | null, numberOfExactOptions?: number | null, packagingUnit?: number | null, isCustomizable?: boolean | null, isPack?: boolean | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null, fixPricesLevelsByQuantity?: Array<{ __typename?: 'PriceByQuantity', quantity?: number | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null, lowQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null, images?: Array<{ __typename?: 'Image', medium?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, productOptions?: Array<{ __typename?: 'ProductOption', id: string, price?: number | null } | null> | null, productsInPack?: Array<{ __typename?: 'ProductPack', position: number, product: { __typename?: 'Product', id: string, name?: string | null, priceType?: PriceTypes | null, catalogPrice?: number | null, images?: Array<{ __typename?: 'Image', id: string, original?: string | null, originName?: string | null } | null> | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', price?: number | null } | null> | null, catalogFixPricesLevelsByQuantity?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null } } | null> | null } | null> | null } | null };

export type ProductsOfTypeExistQueryVariables = Exact<{
  type: AllowedProductType;
}>;


export type ProductsOfTypeExistQuery = { __typename?: 'Query', productsOfTypeExist?: boolean | null };

export type ProviderTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderTypeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, providerInfo?: { __typename?: 'Provider', id: string, linkedClients?: Array<{ __typename?: 'ClientWithType', providerType: ProviderType } | null> | null } | null } | null };

export type ProviderUserInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProviderUserInfoQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phone?: string | null, mobilePhone?: string | null, activity?: string | null, enabled?: boolean | null, email?: string | null, languagePreference?: PlatformLanguageOption | null, registered?: boolean | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null, slug?: string | null } | null, salesPointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null, client: { __typename?: 'Client', name?: string | null } } | null> | null } | null };

export type RoleQueryVariables = Exact<{
  roleId: Scalars['ID'];
}>;


export type RoleQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id?: string | null, name?: string | null, slug?: string | null, canEdit?: boolean | null, isForkable?: boolean | null, permissionsSettings?: Array<{ __typename?: 'Permission', name?: string | null, enabled?: boolean | null } | null> | null, parent?: { __typename?: 'Role', id?: string | null, slug?: string | null, permissionsSettings?: Array<{ __typename?: 'Permission', name?: string | null, enabled?: boolean | null } | null> | null } | null } | null };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', roles?: Array<{ __typename?: 'Role', id?: string | null, name?: string | null, slug?: string | null, absoluteSlug?: string | null } | null> | null };

export type RolesDetailsQueryVariables = Exact<{
  forkable?: InputMaybe<Scalars['Boolean']>;
}>;


export type RolesDetailsQuery = { __typename?: 'Query', rolesDetails?: Array<{ __typename?: 'Role', id?: string | null, name?: string | null, slug?: string | null, userCount?: number | null, updatedAt?: string | null, isForkable?: boolean | null } | null> | null };

export type RolesUserCanPromoteToQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesUserCanPromoteToQuery = { __typename?: 'Query', rolesUserCanPromoteTo?: Array<{ __typename?: 'Role', id?: string | null, name?: string | null, slug?: string | null, absoluteSlug?: string | null } | null> | null };

export type SalesPointsListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SalesPointFilter>;
  sort?: InputMaybe<SalesPointSort>;
}>;


export type SalesPointsListQuery = { __typename?: 'Query', salesPoints?: { __typename?: 'SalesPointPagination', count?: number | null, enabledSalesPointsCount?: number | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, enabled?: boolean | null, location?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null, social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, instagram?: boolean | null, google?: boolean | null, twitter?: boolean | null } | null } | null } | null> | null } | null };

export type ShippingListQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type ShippingListQuery = { __typename?: 'Query', shippingList?: Array<{ __typename?: 'ShippingFees', id?: string | null, isAllSalesPoints?: boolean | null, name?: string | null, maxWeight?: number | null, freeShipping?: number | null, enabled?: boolean | null, shippingFeesGridPerWeight?: Array<{ __typename?: 'ShippingFeesPerWeight', fees?: number | null, weight?: number | null } | null> | null, salespointGroupsIds?: Array<{ __typename?: 'SalespointsGroup', name?: string | null, id: string } | null> | null, salesPointsIds?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null> | null };

export type SimpleCartQueryVariables = Exact<{ [key: string]: never; }>;


export type SimpleCartQuery = { __typename?: 'Query', cart?: { __typename?: 'Cart', userId: string, items?: Array<{ __typename?: 'Item', subId?: string | null, quantity: number, productId: string, quantitiesPerLocation?: Array<{ __typename?: 'QuantitiesPerLocation', locationId?: string | null, quantity?: number | null } | null> | null } | null> | null } | null };

export type TagByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TagByIdQuery = { __typename?: 'Query', tagById?: { __typename?: 'Tag', id: string, types?: Array<TagType | null> | null, label?: string | null, color?: string | null, enabled?: boolean | null, countries?: Array<CountyCode | null> | null, useSalespoints?: boolean | null, createdAt?: any | null, updatedAt?: any | null, tagGroup?: { __typename?: 'TagGroup', id?: string | null } | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null, shop?: { __typename?: 'TagShopInfos', displayOnProducts?: boolean | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null } | null> | null } | null, library?: { __typename?: 'TagLibraryInfos', isHighlighted?: boolean | null, highlightOrder?: number | null, medias?: Array<{ __typename?: 'Media', id: string, name?: string | null } | null> | null } | null, updatedBy?: { __typename?: 'User', fullName?: string | null } | null } | null };

export type TagGroupByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TagGroupByIdQuery = { __typename?: 'Query', tagGroupById?: { __typename?: 'TagGroup', id?: string | null, name?: string | null, order?: number | null, enabled?: boolean | null, useSalespoints?: boolean | null, createdAt?: any | null, updatedAt?: any | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null } | null> | null, updatedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', tags?: { __typename?: 'TagsPagination', tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null };

export type TagsWithDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsWithDetailsQuery = { __typename?: 'Query', tags?: { __typename?: 'TagsPagination', tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null, enabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, tagGroup?: { __typename?: 'TagGroup', id?: string | null, name?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null, shop?: { __typename?: 'TagShopInfos', products?: Array<{ __typename?: 'Product', id: string } | null> | null } | null } | null> | null } | null };

export type UserByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phone?: string | null, mobilePhone?: string | null, activity?: string | null, canEdit?: boolean | null, enabled?: boolean | null, email?: string | null, languagePreference?: PlatformLanguageOption | null, defaultStoreId?: string | null, registered?: boolean | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null, slug?: string | null } | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, enabled?: boolean | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null } | null } | null> | null } | null };

export type UserDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, activity?: string | null, email?: string | null, phone?: string | null, mobilePhone?: string | null, clientId?: string | null, selectedSalesPointId?: string | null, languagePreference?: PlatformLanguageOption | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, email?: string | null, code?: string | null, tvaCode?: string | null, enabled?: boolean | null, RCS?: string | null, secondaryName?: string | null, siretCode?: string | null, phone?: string | null, affairCode?: string | null, longDescription?: string | null, shortDescription?: string | null, paymentOptions?: Array<string | null> | null, languageOptions?: Array<LanguageSelectOption | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null, contactDetails?: { __typename?: 'ContactDetails', phoneNumber?: string | null, email?: string | null, website?: string | null, twitterLink?: string | null, facebookLink?: string | null, pinterestLink?: string | null, instagramLink?: string | null, youtubeLink?: string | null, linkedinLink?: string | null, foursquareLink?: string | null, vimeoLink?: string | null, xingLink?: string | null, contacts?: Array<{ __typename?: 'Contact', id?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, activity?: string | null, email?: string | null } | null> | null } | null, location?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null, images?: Array<{ __typename?: 'Image', thumbnail?: string | null, large?: string | null, small?: string | null, medium?: string | null, original?: string | null } | null> | null, openingHours?: Array<{ __typename?: 'Opening', day?: number | null, isOpen?: boolean | null, sessions?: Array<{ __typename?: 'Session', start?: string | null, end?: string | null, isAllDay?: boolean | null } | null> | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, lastname?: string | null, firstname?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null } | null> | null, specialOpeningHours?: Array<{ __typename?: 'SpecialOpeningHours', id?: string | null, from?: any | null, to?: any | null, isOpen?: boolean | null, hoursFrom?: string | null, hoursTo?: string | null } | null> | null } | null> | null, role?: { __typename?: 'Role', id?: string | null, permissions?: Array<string | null> | null, name?: string | null, slug?: string | null } | null } | null };

export type UserDetailsSalespointQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailsSalespointQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, fullName?: string | null, selectedSalesPointId?: string | null, phone?: string | null, mobilePhone?: string | null, role?: { __typename?: 'Role', id?: string | null, permissions?: Array<string | null> | null } | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, code?: string | null, name?: string | null, location?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null } | null> | null } | null };

export type UserDetailEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailEmailQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, clientId?: string | null } | null };

export type UserFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFeaturesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, role?: { __typename?: 'Role', id?: string | null, permissions?: Array<string | null> | null, slug?: string | null } | null, client: { __typename?: 'Client', id: string, f?: Array<Features | null> | null, clientId?: string | null } } | null };

export type UserInfoForContentQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoForContentQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phone?: string | null, mobilePhone?: string | null, activity?: string | null, canEdit?: boolean | null, enabled?: boolean | null, email?: string | null, languagePreference?: PlatformLanguageOption | null, defaultStoreId?: string | null, registered?: boolean | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null, slug?: string | null } | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, enabled?: boolean | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null } | null } | null> | null } | null };

export type UserMailQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMailQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, client: { __typename?: 'Client', id: string, homepageFeature?: Features | null }, role?: { __typename?: 'Role', id?: string | null, slug?: string | null } | null } | null };

export type UserPersonalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPersonalInfoQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, activity?: string | null, mobilePhone?: string | null, phone?: string | null, email?: string | null, languagePreference?: PlatformLanguageOption | null, loginViaSso?: boolean | null } | null };

export type UserRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRoleQuery = { __typename?: 'Query', userRole?: { __typename?: 'Role', id?: string | null, permissions?: Array<string | null> | null, name?: string | null, slug?: string | null, absoluteSlug?: string | null } | null };

export type UserSelectedSalesPointQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSelectedSalesPointQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, selectedSalesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, email?: string | null, affairCode?: string | null, code?: string | null, tvaCode?: string | null, enabled?: boolean | null, RCS?: string | null, secondaryName?: string | null, siretCode?: string | null, phone?: string | null, fax?: string | null, shortDescription?: string | null, longDescription?: string | null, paymentOptions?: Array<string | null> | null, languageOptions?: Array<LanguageSelectOption | null> | null, contactDetails?: { __typename?: 'ContactDetails', phoneNumber?: string | null, email?: string | null, website?: string | null, twitterLink?: string | null, facebookLink?: string | null, pinterestLink?: string | null, instagramLink?: string | null, youtubeLink?: string | null, linkedinLink?: string | null, foursquareLink?: string | null, vimeoLink?: string | null, xingLink?: string | null, contacts?: Array<{ __typename?: 'Contact', id?: string | null, firstname?: string | null, lastname?: string | null, phone?: string | null, activity?: string | null, email?: string | null } | null> | null } | null, location?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null, longitude?: number | null, latitude?: number | null } | null, images?: Array<{ __typename?: 'Image', id: string, thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null> | null, openingHours?: Array<{ __typename?: 'Opening', day?: number | null, isOpen?: boolean | null, sessions?: Array<{ __typename?: 'Session', start?: string | null, end?: string | null, isAllDay?: boolean | null } | null> | null } | null> | null, users?: Array<{ __typename?: 'User', id: string, lastname?: string | null, firstname?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null } | null> | null, specialOpeningHours?: Array<{ __typename?: 'SpecialOpeningHours', id?: string | null, from?: any | null, to?: any | null, isOpen?: boolean | null, hoursFrom?: string | null, hoursTo?: string | null } | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null } | null } | null };

export type UserSelectedSalesPointCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSelectedSalesPointCustomFieldsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, selectedSalesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, orderedCustomFields: Array<{ __typename?: 'OrderedCustomField', textValue?: string | null, definition: { __typename?: 'CustomFieldDefinition', id: string, assetType: CustomFieldAssetType, clientId: string, type: CustomFieldType, slug: string, label: string, visible: boolean, description?: string | null, updatedAt: any } }> } | null } | null };

export type UserSelectedSalesPointLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSelectedSalesPointLocationsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, selectedSalesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, code?: string | null, publicLocation?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, additionalAddress?: string | null, city?: string | null, country?: string | null, locationCode?: string | null } | null, locations?: Array<{ __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, additionalAddress?: string | null, city?: string | null, country?: string | null, locationCode?: string | null } | null> | null } | null } | null };

export type UserSocialDetailsQueryVariables = Exact<{
  socialNetwork: Scalars['String'];
  socialNetworks?: InputMaybe<Array<InputMaybe<SocialNetwork>> | InputMaybe<SocialNetwork>>;
}>;


export type UserSocialDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, social?: { __typename?: 'SalesPointSocial', linkedPages?: { __typename?: 'SalesPointSocialLinkedPages', facebook?: boolean | null, instagram?: boolean | null, twitter?: boolean | null, google?: boolean | null, linkedin?: boolean | null } | null } | null } | null> | null, role?: { __typename?: 'Role', id?: string | null, permissions?: Array<string | null> | null } | null } | null };

export type UsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserFilter>;
  sort?: InputMaybe<UserSort>;
}>;


export type UsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersPagination', count?: number | null, providerId?: string | null, users?: Array<{ __typename?: 'User', id: string, firstname?: string | null, fullName?: string | null, lastname?: string | null, mobilePhone?: string | null, email?: string | null, enabled?: boolean | null, activity?: string | null, canEdit?: boolean | null, registered?: boolean | null, lastActivityDay?: any | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null, absoluteSlug?: string | null } | null } | null> | null } | null };

export type GetAllClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientsQuery = { __typename?: 'Query', getAllClients?: Array<{ __typename?: 'Client', id: string, name?: string | null, clientId?: string | null } | null> | null };

export type ExportAmplifyUsersBudgetQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportAmplifyUsersBudgetQuery = { __typename?: 'Query', exportAmplifyUsersBudget?: string | null };

export type ImportAmplifyUsersBudgetMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ImportAmplifyUsersBudgetMutation = { __typename?: 'Mutation', importAmplifyUsersBudget?: { __typename?: 'ImportUserAmplifyBudgetJob', id?: string | null, importError?: string | null, creations?: Array<{ __typename?: 'UserAmplifyBudget', spent?: number | null, granted?: number | null, budgetIsLimited?: boolean | null, datesAreLimited?: boolean | null, startDate?: any | null, endDate?: any | null } | null> | null, updates?: Array<{ __typename?: 'UserAmplifyBudget', spent?: number | null, granted?: number | null, budgetIsLimited?: boolean | null, datesAreLimited?: boolean | null, startDate?: any | null, endDate?: any | null } | null> | null, fails?: Array<{ __typename?: 'ImportJobError', ref?: string | null, error?: string | null, fields?: Array<{ __typename?: 'ImportJobFieldError', field?: string | null, error?: string | null } | null> | null } | null> | null } | null };

export type UsersBudgetListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<UserFilter>;
  sort?: InputMaybe<UserSort>;
  socialNetwork?: InputMaybe<Scalars['String']>;
}>;


export type UsersBudgetListQuery = { __typename?: 'Query', users?: { __typename?: 'UsersPagination', count?: number | null, users?: Array<{ __typename?: 'User', id: string, fullName?: string | null, email?: string | null, enabled?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null, permissions?: Array<string | null> | null } | null, amplifyBudget?: { __typename?: 'UserAmplifyBudget', budgetIsLimited?: boolean | null, granted?: number | null, leftToSpend?: number | null, datesAreLimited?: boolean | null, startDate?: any | null, endDate?: any | null } | null } | null> | null } | null };

export type UpsertUserAmplifyBudgetMutationVariables = Exact<{
  userId: Scalars['ID'];
  budgetIsLimited: Scalars['Boolean'];
  granted?: InputMaybe<Scalars['Int']>;
  datesAreLimited: Scalars['Boolean'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpsertUserAmplifyBudgetMutation = { __typename?: 'Mutation', upsertUserAmplifyBudget?: { __typename?: 'UserAmplifyBudget', userId?: string | null, budgetIsLimited?: boolean | null, granted?: number | null, leftToSpend?: number | null, datesAreLimited?: boolean | null, startDate?: any | null, endDate?: any | null } | null };

export type CreateApiKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey?: { __typename?: 'ApiKey', apiKey?: string | null } | null };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', apiKeys?: Array<{ __typename?: 'ApiKey', apiKey?: string | null, user?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null> | null } } | null };

export type RevokeApiKeyMutationVariables = Exact<{
  apiKey: Scalars['String'];
}>;


export type RevokeApiKeyMutation = { __typename?: 'Mutation', revokeApiKey?: boolean | null };

export type DownloadBlacklistFileQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadBlacklistFileQuery = { __typename?: 'Query', downloadBlacklistFile?: string | null };

export type UploadBlacklistMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadBlacklistMutation = { __typename?: 'Mutation', uploadBlacklist?: boolean | null };

export type CreateCampaignCategoryMutationVariables = Exact<{
  category: CampaignCategoryInput;
  type?: InputMaybe<CampaignType>;
}>;


export type CreateCampaignCategoryMutation = { __typename?: 'Mutation', createCampaignCategory?: { __typename?: 'CampaignCategory', id: string, name?: string | null, enabled?: boolean | null, displayMode?: CampaignCategoryDisplayModes | null, startDisplayDate?: any | null, endDisplayDate?: any | null, useSalespointGroups?: boolean | null, isVisible?: boolean | null, order?: number | null, clientId?: string | null, displayCampaignsCategory?: boolean | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null } | null };

export type DeleteCampaignCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCampaignCategoryMutation = { __typename?: 'Mutation', deleteCampaignCategory?: boolean | null };

export type CampaignCategoriesQueryVariables = Exact<{
  bypassVisibility?: InputMaybe<Scalars['Boolean']>;
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  keyword?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<CampaignType> | CampaignType>;
}>;


export type CampaignCategoriesQuery = { __typename?: 'Query', campaignCategories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, enabled?: boolean | null, isVisible?: boolean | null, displayMode?: CampaignCategoryDisplayModes | null, startDisplayDate?: any | null, endDisplayDate?: any | null, useSalespointGroups?: boolean | null, order?: number | null, clientId?: string | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null } | null> | null };

export type SetCampaignCategoriesOrderMutationVariables = Exact<{
  categoriesOrder: Array<CampaignCategoriesOrderInput> | CampaignCategoriesOrderInput;
}>;


export type SetCampaignCategoriesOrderMutation = { __typename?: 'Mutation', setCampaignCategoriesOrder?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null, enabled?: boolean | null, displayMode?: CampaignCategoryDisplayModes | null, startDisplayDate?: any | null, isVisible?: boolean | null, endDisplayDate?: any | null, useSalespointGroups?: boolean | null, order?: number | null, clientId?: string | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null } | null> | null };

export type UpdateCampaignCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: CampaignCategoryUpdateInput;
}>;


export type UpdateCampaignCategoryMutation = { __typename?: 'Mutation', updateCampaignCategory?: { __typename?: 'CampaignCategory', id: string, name?: string | null, enabled?: boolean | null, displayMode?: CampaignCategoryDisplayModes | null, startDisplayDate?: any | null, isVisible?: boolean | null, endDisplayDate?: any | null, useSalespointGroups?: boolean | null, order?: number | null, clientId?: string | null, displayCampaignsCategory?: boolean | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null } | null };

export type CampaignsQueryVariables = Exact<{
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  bypassVisibility?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CampaignSort>;
  types?: InputMaybe<Array<CampaignType> | CampaignType>;
}>;


export type CampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignPagination', campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, enabled?: boolean | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, displayMode?: CampaignDisplayModes | null, startDisplayDate?: any | null, endDisplayDate?: any | null, categories?: Array<{ __typename?: 'CampaignCategory', id: string, name?: string | null } | null> | null } | null> | null } | null };

export type CreateCampaignMutationVariables = Exact<{
  campaign: CampaignInput;
  campaignFile?: InputMaybe<Scalars['Upload']>;
  supports?: InputMaybe<Array<InputMaybe<CampaignSupportCreationInput>> | InputMaybe<CampaignSupportCreationInput>>;
  image?: InputMaybe<Scalars['Upload']>;
  type?: InputMaybe<CampaignType>;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign?: { __typename?: 'Campaign', id: string, name?: string | null, description?: string | null, startDate?: any | null, color?: string | null, endDate?: any | null, isNew?: boolean | null, hasProducts?: boolean | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null, color?: string | null } | null> | null, image?: { __typename?: 'Image', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null, original?: string | null } | null } | null };

export type DeleteCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCampaignMutation = { __typename?: 'Mutation', deleteCampaign?: boolean | null };

export type ToggleCampaignEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToggleCampaignEnabledMutation = { __typename?: 'Mutation', toggleCampaignEnabled?: { __typename?: 'Campaign', id: string, enabled?: boolean | null } | null };

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: CampaignInput;
  supports?: InputMaybe<Array<InputMaybe<CampaignSupportCreationInput>> | InputMaybe<CampaignSupportCreationInput>>;
  campaignFile?: InputMaybe<Scalars['Upload']>;
  deleteFile?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['Upload']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign?: boolean | null };

export type UpdateChiliConfigMutationVariables = Exact<{
  config: ChiliConfigInput;
}>;


export type UpdateChiliConfigMutation = { __typename?: 'Mutation', updateChiliConfig?: { __typename?: 'ChiliConfig', clientId?: string | null } | null };

export type AddHashtagMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type AddHashtagMutation = { __typename?: 'Mutation', addHashtag?: Array<string | null> | null };

export type DeleteHashtagMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type DeleteHashtagMutation = { __typename?: 'Mutation', deleteHashtag?: Array<string | null> | null };

export type HashtagsQueryVariables = Exact<{ [key: string]: never; }>;


export type HashtagsQuery = { __typename?: 'Query', getHashtags?: Array<string | null> | null };

export type CreateHelpBlockMutationVariables = Exact<{
  lang: AvailableLang;
  create: HelpBlockInput;
}>;


export type CreateHelpBlockMutation = { __typename?: 'Mutation', createHelpBlock?: { __typename?: 'HelpBlock', id?: string | null, title?: string | null, order?: number | null } | null };

export type DeleteHelpBlockMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteHelpBlockMutation = { __typename?: 'Mutation', deleteHelpBlock?: boolean | null };

export type GetHelpBlocksByLangQueryVariables = Exact<{
  lang: AvailableLang;
}>;


export type GetHelpBlocksByLangQuery = { __typename?: 'Query', getHelpBlocksByLang?: Array<{ __typename?: 'HelpBlock', id?: string | null, title?: string | null, order?: number | null } | null> | null };

export type SetHelpBlockOrderMutationVariables = Exact<{
  updates: Array<HelpBlockOrder> | HelpBlockOrder;
}>;


export type SetHelpBlockOrderMutation = { __typename?: 'Mutation', setHelpBlockOrder?: Array<{ __typename?: 'HelpBlock', id?: string | null, title?: string | null, order?: number | null } | null> | null };

export type UpdateHelpBlockMutationVariables = Exact<{
  id: Scalars['ID'];
  update: HelpBlockInput;
}>;


export type UpdateHelpBlockMutation = { __typename?: 'Mutation', updateHelpBlock?: { __typename?: 'HelpBlock', id?: string | null, title?: string | null, order?: number | null } | null };

export type UpdateColorsMutationVariables = Exact<{
  primaryHex: Scalars['String'];
}>;


export type UpdateColorsMutation = { __typename?: 'Mutation', updateColors?: string | null };

export type UploadLogoMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadLogoMutation = { __typename?: 'Mutation', uploadLogo?: boolean | null };

export type DownloadMilestonesFileQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadMilestonesFileQuery = { __typename?: 'Query', downloadMilestonesFile?: string | null };

export type UploadMilestonesMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadMilestonesMutation = { __typename?: 'Mutation', uploadMilestones?: boolean | null };

export type AddModerationExceptionMutationVariables = Exact<{
  governanceId: Scalars['ID'];
  data: GovernanceExceptionInput;
}>;


export type AddModerationExceptionMutation = { __typename?: 'Mutation', addGovernanceException?: { __typename?: 'GovernanceException', id?: string | null, name?: string | null, enabled?: boolean | null, nationalValidator?: boolean | null, localValidator?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null };

export type GetModerationQueryVariables = Exact<{
  type: GovernanceTypes;
}>;


export type GetModerationQuery = { __typename?: 'Query', governance?: { __typename?: 'Governance', id?: string | null, type?: GovernanceTypes | null, enabled?: boolean | null, mode?: GovernanceMode | null, nationalValidator?: boolean | null, localValidator?: boolean | null, exceptions?: Array<{ __typename?: 'GovernanceException', id?: string | null, name?: string | null, enabled?: boolean | null, nationalValidator?: boolean | null, localValidator?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export type DeleteModerationExceptionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteModerationExceptionMutation = { __typename?: 'Mutation', deleteGovernanceException?: boolean | null };

export type UpdateModerationMutationVariables = Exact<{
  id: Scalars['ID'];
  data: GovernanceInput;
}>;


export type UpdateModerationMutation = { __typename?: 'Mutation', updateGovernance?: { __typename?: 'Governance', id?: string | null, type?: GovernanceTypes | null, enabled?: boolean | null, mode?: GovernanceMode | null, nationalValidator?: boolean | null, localValidator?: boolean | null, exceptions?: Array<{ __typename?: 'GovernanceException', id?: string | null, name?: string | null, enabled?: boolean | null, nationalValidator?: boolean | null, localValidator?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export type UpdateModerationExceptionMutationVariables = Exact<{
  id: Scalars['ID'];
  data: GovernanceExceptionInput;
}>;


export type UpdateModerationExceptionMutation = { __typename?: 'Mutation', updateGovernanceException?: { __typename?: 'GovernanceException', id?: string | null, name?: string | null, enabled?: boolean | null, nationalValidator?: boolean | null, localValidator?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null };

export type CreatePostTemplateTagMutationVariables = Exact<{
  tag: PostTemplateTagInput;
}>;


export type CreatePostTemplateTagMutation = { __typename?: 'Mutation', createPostTemplateTag?: { __typename?: 'PostTemplateTag', id: string } | null };

export type CreatePostTemplateTagGroupMutationVariables = Exact<{
  tagGroup: PostTemplateTagGroupInput;
}>;


export type CreatePostTemplateTagGroupMutation = { __typename?: 'Mutation', createPostTemplateTagGroup?: { __typename?: 'PostTemplateTagGroup', id: string } | null };

export type DeletePostTemplateTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePostTemplateTagMutation = { __typename?: 'Mutation', deletePostTemplateTag?: boolean | null };

export type DeletePostTemplateTagGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePostTemplateTagGroupMutation = { __typename?: 'Mutation', deletePostTemplateTagGroup?: boolean | null };

export type PostTemplateTagGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type PostTemplateTagGroupsQuery = { __typename?: 'Query', postTemplateTagGroups?: { __typename?: 'PostTemplateTagGroupPagination', tagGroups?: Array<{ __typename?: 'PostTemplateTagGroup', id: string, name?: string | null, created_at?: any | null, updated_at?: any | null, enabled?: boolean | null } | null> | null } | null };

export type PostTemplateTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type PostTemplateTagsQuery = { __typename?: 'Query', postTemplateTags?: { __typename?: 'PostTemplateTagsPagination', tags?: Array<{ __typename?: 'PostTemplateTag', id: string, name?: string | null, created_at?: any | null, updated_at?: any | null, enabled?: boolean | null, tagGroup?: { __typename?: 'PostTemplateTagGroup', name?: string | null } | null } | null> | null } | null };

export type UpdatePostTemplateTagMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: PostTemplateTagInput;
}>;


export type UpdatePostTemplateTagMutation = { __typename?: 'Mutation', updatePostTemplateTag?: { __typename?: 'PostTemplateTag', id: string } | null };

export type UpdatePostTemplateTagGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: PostTemplateTagGroupInput;
}>;


export type UpdatePostTemplateTagGroupMutation = { __typename?: 'Mutation', updatePostTemplateTagGroup?: { __typename?: 'PostTemplateTagGroup', id: string } | null };

export type AdminProductCategoriesScreen_GetParentProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminProductCategoriesScreen_GetParentProductCategoriesQuery = { __typename?: 'Query', getProductCategories?: Array<{ __typename?: 'ChildProductCategory' } | { __typename?: 'ParentProductCategory', id: string, title: string, enabled: boolean, position: number }> | null };

export type AdminProductCategoriesForm_CreateChildProductCategoryMutationVariables = Exact<{
  input: ChildProductCategoryInput;
  newImage?: InputMaybe<Scalars['Upload']>;
}>;


export type AdminProductCategoriesForm_CreateChildProductCategoryMutation = { __typename?: 'Mutation', createChildProductCategory: { __typename?: 'ChildProductCategory', id: string, parentId: string } };

export type AdminProductCategoriesForm_CreateParentProductCategoryMutationVariables = Exact<{
  input: ParentProductCategoryInput;
}>;


export type AdminProductCategoriesForm_CreateParentProductCategoryMutation = { __typename?: 'Mutation', createParentProductCategory: { __typename?: 'ParentProductCategory', id: string, title: string, enabled: boolean } };

export type AdminProductCategoriesForm_GetChildProductCategoriesQueryVariables = Exact<{
  parentId: Scalars['ID'];
}>;


export type AdminProductCategoriesForm_GetChildProductCategoriesQuery = { __typename?: 'Query', getProductCategories?: Array<{ __typename?: 'ChildProductCategory', id: string, title: string, enabled: boolean, position: number } | { __typename?: 'ParentProductCategory' }> | null };

export type UpdateChildProductCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ChildProductCategoryInput;
  newImage?: InputMaybe<Scalars['Upload']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateChildProductCategoryMutation = { __typename?: 'Mutation', updateChildProductCategory: { __typename?: 'ChildProductCategory', id: string, title: string, description?: string | null, enabled: boolean, image?: { __typename?: 'Image', id: string, original?: string | null } | null, products: Array<{ __typename?: 'Product', id: string, name?: string | null }> } };

export type AdminProductCategoriesForm_UpdateParentProductCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ParentProductCategoryInput;
}>;


export type AdminProductCategoriesForm_UpdateParentProductCategoryMutation = { __typename?: 'Mutation', updateParentProductCategory: { __typename?: 'ParentProductCategory', id: string, title: string, enabled: boolean, salespointGroups: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null }> } };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct?: boolean | null };

export type ProductsAvailableInPackQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type ProductsAvailableInPackQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPagination', count?: number | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null, priceType?: PriceTypes | null, catalogPrice?: number | null, images?: Array<{ __typename?: 'Image', id: string, original?: string | null, originName?: string | null } | null> | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, catalogPriceLevels?: Array<{ __typename?: 'CatalogPriceLevels', price?: number | null } | null> | null, catalogFixPricesLevelsByQuantity?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null } | null> | null } | null };

export type ChildProductCategoriesByKeywordQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type ChildProductCategoriesByKeywordQuery = { __typename?: 'Query', childProductCategoriesByKeyword?: Array<{ __typename?: 'ChildProductCategory', id: string, title: string, enabled: boolean, parentId: string }> | null };

export type CreateProductMutationVariables = Exact<{
  product: InputProduct;
  lowQualityAsset?: InputMaybe<Scalars['Upload']>;
  tempLowQualityAsset?: InputMaybe<TempFileInput>;
  highQualityAsset?: InputMaybe<Scalars['Upload']>;
  images?: InputMaybe<Array<InputMaybe<ImageInput>> | InputMaybe<ImageInput>>;
  duplicateProductInfos?: InputMaybe<InputDuplicateInfos>;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct?: { __typename?: 'Product', id: string, name?: string | null, isCustomizable?: boolean | null, type?: AllowedProductType | null, catalogPrice?: number | null, ref?: string | null, description?: string | null, tips?: string | null, disabled?: boolean | null, stock?: number | null, isStockEnabled?: boolean | null, price?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null } | null };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: InputProduct;
  lowQualityAsset?: InputMaybe<Scalars['Upload']>;
  tempLowQualityAsset?: InputMaybe<TempFileInput>;
  deleteLowQualityAsset?: InputMaybe<Scalars['Boolean']>;
  highQualityAsset?: InputMaybe<Scalars['Upload']>;
  deleteHighQualityAsset?: InputMaybe<Scalars['Boolean']>;
  images?: InputMaybe<Array<InputMaybe<ImageInput>> | InputMaybe<ImageInput>>;
  deleteOptionsAssets?: InputMaybe<Array<InputMaybe<InputDeleteOptionsAssets>> | InputMaybe<InputDeleteOptionsAssets>>;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: boolean | null };

export type GetProductsQueryVariables = Exact<{
  filters?: InputMaybe<Array<InputMaybe<ProductFilterInput>> | InputMaybe<ProductFilterInput>>;
}>;


export type GetProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPagination', products?: Array<{ __typename?: 'Product', id: string, name?: string | null, isCustomizable?: boolean | null, ref?: string | null, disabled?: boolean | null, catalogPrice?: number | null, priceType?: PriceTypes | null, stock?: number | null, isStockEnabled?: boolean | null, packagingUnit?: number | null, isShowcase?: boolean | null, isBriefCrm?: boolean | null, isPack?: boolean | null, catalogFixPricesLevelsByQuantity?: Array<{ __typename?: 'CatalogPriceLevels', quantity?: number | null, price?: number | null } | null> | null } | null> | null } | null };

export type CancelProductsImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CancelProductsImportJobMutation = { __typename?: 'Mutation', cancelProductsImportJob?: boolean | null };

export type CommitProductsImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CommitProductsImportJobMutation = { __typename?: 'Mutation', commitProductsImportJob?: boolean | null };

export type ExportProductsMutationVariables = Exact<{
  sort?: InputMaybe<ProductSort>;
  format?: InputMaybe<Scalars['String']>;
}>;


export type ExportProductsMutation = { __typename?: 'Mutation', exportProducts?: string | null };

export type ImportProductsMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ImportProductsMutation = { __typename?: 'Mutation', importProducts?: { __typename?: 'ImportProductsJob', jobId?: string | null, updates?: Array<string | null> | null, successful?: Array<string | null> | null, errors?: Array<string | null> | null, importError?: string | null } | null };

export type ToggleProductEnabledMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToggleProductEnabledMutation = { __typename?: 'Mutation', toggleProductEnabled?: { __typename?: 'Product', id: string, disabled?: boolean | null } | null };

export type CancelSalespointGroupsImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type CancelSalespointGroupsImportJobMutation = { __typename?: 'Mutation', cancelSalespointGroupsImportJob?: boolean | null };

export type SalesPointsGroups_CommitSalespointGroupsImportJobMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type SalesPointsGroups_CommitSalespointGroupsImportJobMutation = { __typename?: 'Mutation', commitSalespointGroupsImportJob?: boolean | null };

export type CreateSalespointGroupMutationVariables = Exact<{
  salespointGroup: SalespointGroupInput;
}>;


export type CreateSalespointGroupMutation = { __typename?: 'Mutation', createSalespointGroup?: { __typename?: 'SalespointsGroup', id: string, name?: string | null, paymentMethodId?: string | null, enabled?: boolean | null, updatedAt?: any | null, salespoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null } | null> | null, medias?: Array<{ __typename?: 'Media', id: string, name?: string | null } | null> | null, updatedBy?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null };

export type DeleteSalespointGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSalespointGroupMutation = { __typename?: 'Mutation', deleteSalespointGroup?: boolean | null };

export type SalesPointsGroups_ExportSalespointGroupsMutationVariables = Exact<{ [key: string]: never; }>;


export type SalesPointsGroups_ExportSalespointGroupsMutation = { __typename?: 'Mutation', exportSalespointGroups?: string | null };

export type SalesPointsGroupsInfo_GetClientPaymentSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesPointsGroupsInfo_GetClientPaymentSettingsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: PaymentMethodType, name?: string | null, isSystem: boolean }> | null } } | null };

export type GetUserSalespointsGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSalespointsGroupsQuery = { __typename?: 'Query', getUserSalespointsGroups?: Array<{ __typename?: 'UserSalesPointsGroup', groupId?: string | null, name?: string | null, salespointsCount?: number | null, enabled?: boolean | null } | null> | null };

export type SalesPointsGroups_ImportSalespointGroupsMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type SalesPointsGroups_ImportSalespointGroupsMutation = { __typename?: 'Mutation', importSalespointGroups?: { __typename?: 'ImportSalespointGroupsJob', jobId?: string | null, successful?: Array<string | null> | null, updates?: Array<string | null> | null, errors?: Array<string | null> | null, importError?: string | null } | null };

export type SalesPointsGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesPointsGroupsQuery = { __typename?: 'Query', salesPointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null, enabled?: boolean | null, salespoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null> | null };

export type UpdateSalespointGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  updates: SalespointGroupInput;
}>;


export type UpdateSalespointGroupMutation = { __typename?: 'Mutation', updateSalespointGroup?: boolean | null };

export type ShopGeneralCategories_GetClientShopCategoriesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopGeneralCategories_GetClientShopCategoriesOptionsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, shopOptions?: { __typename?: 'ShopOptions', categories?: { __typename?: 'ShopCategoriesOptions', enabled?: boolean | null, showAllProductsLinkEnabled?: boolean | null } | null } | null } } | null };

export type ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationVariables = Exact<{
  shopOptions: ShopOptionsInput;
}>;


export type ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation = { __typename?: 'Mutation', updateClientShopOptions?: { __typename?: 'Client', id: string, shopOptions?: { __typename?: 'ShopOptions', categories?: { __typename?: 'ShopCategoriesOptions', enabled?: boolean | null, showAllProductsLinkEnabled?: boolean | null } | null } | null } | null };

export type ShopGeneralAddPayment_CreatePaymentMethodMutationVariables = Exact<{
  paymentMethod: PaymentMethodInput;
}>;


export type ShopGeneralAddPayment_CreatePaymentMethodMutation = { __typename?: 'Mutation', createPaymentMethod?: { __typename?: 'PaymentMethod', id: string, type: PaymentMethodType, isSystem: boolean, name?: string | null, salesPointGroupsCount?: number | null } | null };

export type ShopGeneralPayment_DeletePaymentMethodMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShopGeneralPayment_DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod?: { __typename?: 'PaymentMethod', id: string, name?: string | null } | null };

export type ShopGeneralFormPayment_GetPaymentMethodByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShopGeneralFormPayment_GetPaymentMethodByIdQuery = { __typename?: 'Query', getPaymentMethodById?: { __typename?: 'PaymentMethod', id: string, isSystem: boolean, type: PaymentMethodType, documentType?: PaymentMethodDocumentType | null, name?: string | null, cartText?: string | null, salesPointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null }> | null } | null };

export type ShopGeneralAddPayment_SalesPointsGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopGeneralAddPayment_SalesPointsGroupsQuery = { __typename?: 'Query', salesPointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null };

export type ShopGeneralFormPayment_UpdatePaymentMethodMutationVariables = Exact<{
  id: Scalars['ID'];
  paymentMethod: PaymentMethodInput;
}>;


export type ShopGeneralFormPayment_UpdatePaymentMethodMutation = { __typename?: 'Mutation', updatePaymentMethod?: { __typename?: 'PaymentMethod', id: string, isSystem: boolean, type: PaymentMethodType, documentType?: PaymentMethodDocumentType | null, name?: string | null, cartText?: string | null, salesPointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string }> | null } | null };

export type ShopGeneralPayment_GetClientPaymentSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopGeneralPayment_GetClientPaymentSettingsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, type: PaymentMethodType, isSystem: boolean, name?: string | null, salesPointGroupsCount?: number | null }> | null, shopOptions?: { __typename?: 'ShopOptions', displayTaxes?: boolean | null, defaultPaymentMethodId?: string | null, billingAddress?: { __typename?: 'BillingAddress', address?: string | null, additionalAddress?: string | null, company?: string | null, city?: string | null, country?: string | null, postalCode?: string | null } | null } | null } } | null };

export type ShopGeneralPayment_UpdateClientShopOptionsMutationVariables = Exact<{
  shopOptions: ShopOptionsInput;
}>;


export type ShopGeneralPayment_UpdateClientShopOptionsMutation = { __typename?: 'Mutation', updateClientShopOptions?: { __typename?: 'Client', id: string, shopOptions?: { __typename?: 'ShopOptions', defaultPaymentMethodId?: string | null, displayTaxes?: boolean | null, displayStockAlert?: boolean | null, stockAlertRecipients?: Array<{ __typename?: 'User', id: string, fullName?: string | null } | null> | null, billingAddress?: { __typename?: 'BillingAddress', address?: string | null, additionalAddress?: string | null, city?: string | null, country?: string | null, postalCode?: string | null } | null } | null } | null };

export type ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, shopOptions?: { __typename?: 'ShopOptions', isShippingFeesEnabled?: boolean | null } | null } } | null };

export type ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationVariables = Exact<{
  shopOptions: ShopOptionsInput;
}>;


export type ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation = { __typename?: 'Mutation', updateClientShopOptions?: { __typename?: 'Client', id: string, shopOptions?: { __typename?: 'ShopOptions', isShippingFeesEnabled?: boolean | null } | null } | null };

export type ShopGetClientStocksSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopGetClientStocksSettingsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, client: { __typename?: 'Client', id: string, shopOptions?: { __typename?: 'ShopOptions', displayTaxes?: boolean | null, defaultPaymentMethodId?: string | null, displayStockAlert?: boolean | null, stockAlertRecipients?: Array<{ __typename?: 'User', id: string, fullName?: string | null } | null> | null } | null } } | null };

export type ShopGetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
}>;


export type ShopGetUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersPagination', users?: Array<{ __typename?: 'User', id: string, fullName?: string | null } | null> | null } | null };

export type AddAmplifyAccountsMutationVariables = Exact<{
  networkReferers: Array<Scalars['String']> | Scalars['String'];
  socialNetworkUser: Scalars['Int'];
}>;


export type AddAmplifyAccountsMutation = { __typename?: 'Mutation', addAmplifyAccounts?: Array<{ __typename?: 'AccountPage', id?: string | null } | null> | null };

export type DisconnectUserFromFacebookMutationVariables = Exact<{
  socialNetworkUser: Scalars['Int'];
}>;


export type DisconnectUserFromFacebookMutation = { __typename?: 'Mutation', disconnectUserFromFacebook?: boolean | null };

export type GetAccountsFromFacebookQueryVariables = Exact<{
  socialNetworkUser: Scalars['Int'];
  previousToken?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetAccountsFromFacebookQuery = { __typename?: 'Query', getAccountsFromFacebook?: { __typename?: 'AccountsResponse', nextToken?: string | null, previousToken?: string | null, accounts?: Array<{ __typename?: 'AccountPage', id?: string | null, name?: string | null, alreadyRecord?: boolean | null } | null> | null } | null };

export type GetAmplifyAccountFromSocialNetworkQueryVariables = Exact<{
  socialNetworkUser: Scalars['Int'];
  previousToken?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetAmplifyAccountFromSocialNetworkQuery = { __typename?: 'Query', getAmplifyAccountFromSocialNetwork?: { __typename?: 'AdAccountsResponse', nextToken?: string | null, previousToken?: string | null, adAccounts?: Array<{ __typename?: 'AmplifyAccount', id?: string | null, name?: string | null } | null> | null } | null };

export type UpdateMainAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateMainAccountMutation = { __typename?: 'Mutation', updateMainAccount?: boolean | null };

export type AddGoogleAccountsMutationVariables = Exact<{
  networkReferers: Array<Scalars['String']> | Scalars['String'];
  socialNetworkUser: Scalars['Int'];
}>;


export type AddGoogleAccountsMutation = { __typename?: 'Mutation', addGoogleAccounts?: Array<{ __typename?: 'AccountPage', id?: string | null } | null> | null };

export type DisconnectUserFromGoogleMutationVariables = Exact<{
  socialNetworkUser: Scalars['Int'];
}>;


export type DisconnectUserFromGoogleMutation = { __typename?: 'Mutation', disconnectUserFromGoogle?: boolean | null };

export type GetAvailableGoogleAccountsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  socialNetworkUser: Scalars['Int'];
  token?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type GetAvailableGoogleAccountsQuery = { __typename?: 'Query', getAvailableGoogleAccounts?: { __typename?: 'GoogleAccountsResponse', nextToken?: string | null, previousToken?: string | null, socialNetworkAccounts?: Array<{ __typename?: 'AccountPage', id?: string | null, name?: string | null, alreadyRecord?: boolean | null, networkReferer?: string | null } | null> | null } | null };

export type GetGoogleAccountsGroupsQueryVariables = Exact<{
  socialNetworkUser: Scalars['Int'];
}>;


export type GetGoogleAccountsGroupsQuery = { __typename?: 'Query', getGoogleAccountsGroups?: Array<{ __typename?: 'GoogleAccountsGroup', networkReferer?: string | null, name?: string | null, type?: GoogleAccountsGroupType | null } | null> | null };

export type AddLinkedinAccountsMutationVariables = Exact<{
  networkReferers: Array<Scalars['String']> | Scalars['String'];
  socialNetworkUser: Scalars['Int'];
}>;


export type AddLinkedinAccountsMutation = { __typename?: 'Mutation', addLinkedinAccounts?: Array<{ __typename?: 'AccountPage', id?: string | null } | null> | null };

export type DisconnectUserFromLinkedinMutationVariables = Exact<{
  socialNetworkUser: Scalars['Int'];
}>;


export type DisconnectUserFromLinkedinMutation = { __typename?: 'Mutation', disconnectUserFromLinkedin?: boolean | null };

export type GetAccountsFromLinkedinQueryVariables = Exact<{
  socialNetworkUser: Scalars['Int'];
}>;


export type GetAccountsFromLinkedinQuery = { __typename?: 'Query', getAccountsFromLinkedin?: { __typename?: 'AccountsResponse', accounts?: Array<{ __typename?: 'AccountPage', id?: string | null, name?: string | null, alreadyRecord?: boolean | null } | null> | null } | null };

export type AddFacebookAccountMutationVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  networkReferers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  socialNetworkUser: Scalars['Int'];
  systemUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddFacebookAccountMutation = { __typename?: 'Mutation', addFacebookAccount?: Array<{ __typename?: 'AccountPage', id?: string | null } | null> | null };

export type RefreshFacebookAccountsMutationVariables = Exact<{
  accountIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RefreshFacebookAccountsMutation = { __typename?: 'Mutation', refreshFacebookAccounts?: boolean | null };

export type DeleteAmplifyAccountsMutationVariables = Exact<{
  accountIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteAmplifyAccountsMutation = { __typename?: 'Mutation', deleteAmplifyAccounts?: { __typename?: 'BulkActionResult', success?: boolean | null, partialSuccess?: boolean | null } | null };

export type DeleteSocialNetworkAccountsMutationVariables = Exact<{
  accountIds: Array<Scalars['ID']> | Scalars['ID'];
  socialNetwork: SocialNetwork;
}>;


export type DeleteSocialNetworkAccountsMutation = { __typename?: 'Mutation', deleteSocialNetworkAccounts?: { __typename?: 'BulkActionResult', success?: boolean | null, partialSuccess?: boolean | null } | null };

export type GetSocialNetworkSsoLinkQueryVariables = Exact<{
  socialNetwork: SocialNetwork;
  redirectURL: Scalars['String'];
}>;


export type GetSocialNetworkSsoLinkQuery = { __typename?: 'Query', getSocialNetworkSSOLink?: string | null };

export type GetAmplifyGlobalAccountQueryVariables = Exact<{
  label: Scalars['String'];
}>;


export type GetAmplifyGlobalAccountQuery = { __typename?: 'Query', getAmplifyGlobalAccount?: { __typename?: 'AccountPage', id?: string | null, name?: string | null, isActive?: boolean | null, isLinked?: boolean | null, networkReferer?: string | null, url?: string | null } | null };

export type GetInstagramUrlQueryVariables = Exact<{
  label: Scalars['String'];
}>;


export type GetInstagramUrlQuery = { __typename?: 'Query', getSocialNetworkGlobalAccount?: { __typename?: 'AccountPage', url?: string | null } | null };

export type GetSocialNetworkGlobalAccountQueryVariables = Exact<{
  socialNetwork: SocialNetwork;
  label: Scalars['String'];
}>;


export type GetSocialNetworkGlobalAccountQuery = { __typename?: 'Query', getSocialNetworkGlobalAccount?: { __typename?: 'AccountPage', id?: string | null, name?: string | null, isActive?: boolean | null, isLinked?: boolean | null, networkReferer?: string | null, url?: string | null, haveInstagramAccount?: boolean | null } | null };

export type LinkGlobalAmplifyAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
  label: Scalars['String'];
}>;


export type LinkGlobalAmplifyAccountMutation = { __typename?: 'Mutation', linkGlobalAmplifyAccount?: boolean | null };

export type LinkGlobalSocialNetworkAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
  label: Scalars['String'];
  socialNetwork: SocialNetwork;
}>;


export type LinkGlobalSocialNetworkAccountMutation = { __typename?: 'Mutation', linkGlobalSocialNetworkAccount?: boolean | null };

export type UnlinkGlobalAmplifyAccountMutationVariables = Exact<{
  label: Scalars['String'];
}>;


export type UnlinkGlobalAmplifyAccountMutation = { __typename?: 'Mutation', unlinkGlobalAmplifyAccount?: boolean | null };

export type UnlinkGlobalSocialNetworkAccountMutationVariables = Exact<{
  label: Scalars['String'];
  socialNetwork: SocialNetwork;
}>;


export type UnlinkGlobalSocialNetworkAccountMutation = { __typename?: 'Mutation', unlinkGlobalSocialNetworkAccount?: boolean | null };

export type AddTwitterAccountMutationVariables = Exact<{
  redirectURL: Scalars['String'];
  oauthToken: Scalars['String'];
  oauthVerifier: Scalars['String'];
}>;


export type AddTwitterAccountMutation = { __typename?: 'Mutation', addTwitterAccount?: { __typename?: 'AccountPage', id?: string | null } | null };

export type ConnectUserToFacebookMutationVariables = Exact<{
  code: Scalars['String'];
  accountType: Scalars['String'];
  redirectURL: Scalars['String'];
}>;


export type ConnectUserToFacebookMutation = { __typename?: 'Mutation', connectUserToFacebook?: { __typename?: 'SocialLoginInfos', username?: string | null, isTokenValid?: boolean | null, connected?: boolean | null, accountType?: string | null, id?: number | null, socialNetwork?: string | null } | null };

export type ConnectUserToGoogleMutationVariables = Exact<{
  code: Scalars['String'];
  accountType: Scalars['String'];
  redirectURL: Scalars['String'];
}>;


export type ConnectUserToGoogleMutation = { __typename?: 'Mutation', connectUserToGoogle?: { __typename?: 'SocialLoginInfos', username?: string | null, isTokenValid?: boolean | null, connected?: boolean | null, accountType?: string | null, id?: number | null, socialNetwork?: string | null } | null };

export type ConnectUserToLinkedinMutationVariables = Exact<{
  code: Scalars['String'];
  accountType: Scalars['String'];
  redirectURL: Scalars['String'];
  state: Scalars['String'];
}>;


export type ConnectUserToLinkedinMutation = { __typename?: 'Mutation', connectUserToLinkedin?: { __typename?: 'SocialLoginInfos', username?: string | null, isTokenValid?: boolean | null, connected?: boolean | null, accountType?: string | null, id?: number | null, socialNetwork?: string | null } | null };

export type GetJwtTokenQueryVariables = Exact<{
  email: Scalars['String'];
  iat?: InputMaybe<Scalars['Int']>;
}>;


export type GetJwtTokenQuery = { __typename?: 'Query', getJwtToken?: { __typename?: 'JwtPayload', token: string } | null };

export type AssociateUserToSalesPointGroupsMutationVariables = Exact<{
  groupIds: Array<Scalars['ID']> | Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type AssociateUserToSalesPointGroupsMutation = { __typename?: 'Mutation', associateUserToSalesPointGroups?: boolean | null };

export type DissociateUserFromSalesPointGroupsMutationVariables = Exact<{
  groupIds: Array<Scalars['ID']> | Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type DissociateUserFromSalesPointGroupsMutation = { __typename?: 'Mutation', dissociateUserFromSalesPointGroups?: boolean | null };

export type ProviderSalespointsGroupsQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  idProvider?: InputMaybe<Scalars['ID']>;
}>;


export type ProviderSalespointsGroupsQuery = { __typename?: 'Query', providerSalespointsGroups?: { __typename?: 'SalespointsGroupsPagination', count?: number | null, salesPointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null, client: { __typename?: 'Client', name?: string | null } } | null> | null } | null };

export type ArchiveBriefMutationVariables = Exact<{
  briefId: Scalars['ID'];
  toBeArchived: Scalars['Boolean'];
}>;


export type ArchiveBriefMutation = { __typename?: 'Mutation', archiveBrief?: boolean | null };

export type BriefsCountDocumentsQueryVariables = Exact<{
  getArchived: Scalars['Boolean'];
}>;


export type BriefsCountDocumentsQuery = { __typename?: 'Query', briefsCountDocuments?: { __typename?: 'BriefsCountDocuments', countArchived?: number | null, countNotArchived?: number | null } | null };

export type CreateBriefCommentMutationVariables = Exact<{
  id: Scalars['ID'];
  comment: Scalars['String'];
}>;


export type CreateBriefCommentMutation = { __typename?: 'Mutation', addBriefComment?: { __typename?: 'BriefComment', id?: string | null } | null };

export type CreateMultipleBriefsMutationVariables = Exact<{
  briefs: Array<InputBrief> | InputBrief;
  createDrafts: Scalars['Boolean'];
}>;


export type CreateMultipleBriefsMutation = { __typename?: 'Mutation', createMultipleBriefs?: Array<{ __typename?: 'Brief', id?: string | null } | null> | null };

export type TransitionBriefsByDateMutationVariables = Exact<{ [key: string]: never; }>;


export type TransitionBriefsByDateMutation = { __typename?: 'Mutation', transitionBriefsByDate?: boolean | null };

export type SendGroupedBriefNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type SendGroupedBriefNotificationsMutation = { __typename?: 'Mutation', sendGroupedBriefNotifications?: boolean | null };

export type DeleteBriefMediaMutationVariables = Exact<{
  mediaIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteBriefMediaMutation = { __typename?: 'Mutation', deleteBriefMedia?: boolean | null };

export type ExportBriefsMutationVariables = Exact<{
  format?: InputMaybe<BriefExportType>;
  filter?: InputMaybe<BriefsFilter>;
}>;


export type ExportBriefsMutation = { __typename?: 'Mutation', exportBriefs?: string | null };

export type AvailableAdressesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AvailableAdressesQuery = { __typename?: 'Query', salesPointById?: { __typename?: 'SalesPoint', id?: string | null, defaultLocations?: { __typename?: 'DefaultLocations', shipping?: { __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null } | null, publicLocation?: { __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null, locations?: Array<{ __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null> | null } | null };

export type AvailableBriefCampaignsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CampaignSort>;
}>;


export type AvailableBriefCampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignPagination', count?: number | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, startDate?: any | null, endDate?: any | null, enabled?: boolean | null } | null> | null } | null };

export type GetBriefActivityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBriefActivityQuery = { __typename?: 'Query', briefActivity?: { __typename?: 'BriefActivityPagination', count?: number | null, activity?: Array<{ __typename?: 'BriefActivity', id?: string | null, action?: BriefAction | null, createdAt?: any | null, comment?: { __typename?: 'BriefComment', id?: string | null, message?: string | null } | null, author?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, content?: { __typename?: 'BriefActivityContent', status?: { __typename?: 'BriefStatusFromTo', from?: BriefStatus | null, to?: BriefStatus | null } | null } | null } | null> | null } | null };

export type BriefAttachmentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BriefAttachmentsQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, attachments?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, mimetype?: string | null, thumbnail?: string | null, createdAt?: any | null, tag?: BriefMediaTag | null, url?: string | null, createdBy?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null } | null> | null, quoteOptions?: { __typename?: 'BriefQuoteOptions', amount?: number | null, comment?: string | null } | null } | { __typename?: 'BriefHyundai', id?: string | null, attachments?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, mimetype?: string | null, thumbnail?: string | null, createdAt?: any | null, tag?: BriefMediaTag | null, url?: string | null, createdBy?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null } | null> | null, quoteOptions?: { __typename?: 'BriefQuoteOptions', amount?: number | null, comment?: string | null } | null } | null };

export type GetBriefQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBriefQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, isArchived?: boolean | null, isProduct?: boolean | null, isCommentEnabled?: boolean | null, comment?: string | null, attribute?: string | null, productAttribute?: any | null, format?: string | null, description?: string | null, createdAt?: any | null, deliveryDeadline?: any | null, deliveryOption?: boolean | null, internalReference?: string | null, medium?: string | null, name?: string | null, type?: string | null, status?: BriefStatus | null, campaignId?: string | null, campaignStart?: any | null, campaignEnd?: any | null, validStartDate?: any | null, validEndDate?: any | null, productId?: string | null, deliveryDate?: number | null, useLaunchDate?: boolean | null, useValidDate?: boolean | null, contextGoalsIssues?: string | null, targeting?: string | null, offer?: string | null, customerJourney?: string | null, campaignType?: string | null, other?: string | null, budget?: number | null, attachments?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, thumbnail?: string | null, url?: string | null, tag?: BriefMediaTag | null } | null> | null, quoteOptions?: { __typename?: 'BriefQuoteOptions', amount?: number | null, comment?: string | null } | null, client?: { __typename?: 'Client', id: string, clientId?: string | null, briefOptions?: { __typename?: 'BriefHyundaiOptions', type?: boolean | null, internalReference?: boolean | null, visualReference?: boolean | null, delivery?: boolean | null, wishDelivery?: boolean | null, budget?: boolean | null, budgetType?: boolean | null, activityType?: boolean | null, modelType?: boolean | null, communicationType?: boolean | null, briefType?: boolean | null, workflow?: BriefWorkflow | null, governance?: boolean | null, quoteComment?: boolean | null, quoteAmount?: boolean | null, contextGoalsIssues?: boolean | null, description?: boolean | null, targeting?: boolean | null, offer?: boolean | null, customerJourney?: boolean | null, campaignDates?: boolean | null, launchDates?: boolean | null, validityDates?: boolean | null, campaignType?: boolean | null, lever?: boolean | null, support?: boolean | null, workType?: boolean | null, campaignLevel?: boolean | null } | { __typename?: 'BriefOptions', type?: boolean | null, internalReference?: boolean | null, visualReference?: boolean | null, delivery?: boolean | null, wishDelivery?: boolean | null, budget?: boolean | null, workflow?: BriefWorkflow | null, governance?: boolean | null, quoteComment?: boolean | null, quoteAmount?: boolean | null, contextGoalsIssues?: boolean | null, description?: boolean | null, targeting?: boolean | null, offer?: boolean | null, customerJourney?: boolean | null, campaignDates?: boolean | null, launchDates?: boolean | null, validityDates?: boolean | null, campaignType?: boolean | null, lever?: boolean | null, support?: boolean | null, workType?: boolean | null, campaignLevel?: boolean | null } | null } | null, author?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: { __typename?: 'Role', id?: string | null, absoluteSlug?: string | null } | null } | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, contacts?: Array<{ __typename?: 'BriefContact', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null> | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null } | null, shippingAddresses?: Array<{ __typename?: 'BriefShippingAddress', name?: string | null, address?: string | null, additionalAddress?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, quantity?: number | null } | null> | null, referenceVisuals?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, url?: string | null, mimetype?: string | null, thumbnail?: string | null } | null> | null, briefSpecClient?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, value?: string | null, label?: string | null, parentId?: string | null, children?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, value?: string | null, label?: string | null, parentId?: string | null } | null> | null } | null> | null } | { __typename?: 'BriefHyundai', budgetType?: string | null, modelType?: string | null, activityType?: string | null, briefType?: boolean | null, communicationType?: string | null, id?: string | null, isArchived?: boolean | null, isProduct?: boolean | null, isCommentEnabled?: boolean | null, comment?: string | null, attribute?: string | null, productAttribute?: any | null, format?: string | null, description?: string | null, createdAt?: any | null, deliveryDeadline?: any | null, deliveryOption?: boolean | null, internalReference?: string | null, medium?: string | null, name?: string | null, type?: string | null, status?: BriefStatus | null, campaignId?: string | null, campaignStart?: any | null, campaignEnd?: any | null, validStartDate?: any | null, validEndDate?: any | null, productId?: string | null, deliveryDate?: number | null, useLaunchDate?: boolean | null, useValidDate?: boolean | null, contextGoalsIssues?: string | null, targeting?: string | null, offer?: string | null, customerJourney?: string | null, campaignType?: string | null, other?: string | null, budget?: number | null, typesLabel?: { __typename?: 'TypesLabel', activityTypeLabel?: string | null, communicationTypeLabel?: string | null, modelTypeLabel?: string | null, budgetTypeLabel?: string | null } | null, attachments?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, thumbnail?: string | null, url?: string | null, tag?: BriefMediaTag | null } | null> | null, quoteOptions?: { __typename?: 'BriefQuoteOptions', amount?: number | null, comment?: string | null } | null, client?: { __typename?: 'Client', id: string, clientId?: string | null, briefOptions?: { __typename?: 'BriefHyundaiOptions', type?: boolean | null, internalReference?: boolean | null, visualReference?: boolean | null, delivery?: boolean | null, wishDelivery?: boolean | null, budget?: boolean | null, budgetType?: boolean | null, activityType?: boolean | null, modelType?: boolean | null, communicationType?: boolean | null, briefType?: boolean | null, workflow?: BriefWorkflow | null, governance?: boolean | null, quoteComment?: boolean | null, quoteAmount?: boolean | null, contextGoalsIssues?: boolean | null, description?: boolean | null, targeting?: boolean | null, offer?: boolean | null, customerJourney?: boolean | null, campaignDates?: boolean | null, launchDates?: boolean | null, validityDates?: boolean | null, campaignType?: boolean | null, lever?: boolean | null, support?: boolean | null, workType?: boolean | null, campaignLevel?: boolean | null } | { __typename?: 'BriefOptions', type?: boolean | null, internalReference?: boolean | null, visualReference?: boolean | null, delivery?: boolean | null, wishDelivery?: boolean | null, budget?: boolean | null, workflow?: BriefWorkflow | null, governance?: boolean | null, quoteComment?: boolean | null, quoteAmount?: boolean | null, contextGoalsIssues?: boolean | null, description?: boolean | null, targeting?: boolean | null, offer?: boolean | null, customerJourney?: boolean | null, campaignDates?: boolean | null, launchDates?: boolean | null, validityDates?: boolean | null, campaignType?: boolean | null, lever?: boolean | null, support?: boolean | null, workType?: boolean | null, campaignLevel?: boolean | null } | null } | null, author?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, role?: { __typename?: 'Role', id?: string | null, absoluteSlug?: string | null } | null } | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, contacts?: Array<{ __typename?: 'BriefContact', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null> | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null } | null, shippingAddresses?: Array<{ __typename?: 'BriefShippingAddress', name?: string | null, address?: string | null, additionalAddress?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, quantity?: number | null } | null> | null, referenceVisuals?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, url?: string | null, mimetype?: string | null, thumbnail?: string | null } | null> | null, briefSpecClient?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, value?: string | null, label?: string | null, parentId?: string | null, children?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, value?: string | null, label?: string | null, parentId?: string | null } | null> | null } | null> | null } | null };

export type BriefCommentsQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type BriefCommentsQuery = { __typename?: 'Query', briefComments?: { __typename?: 'BriefCommentsPagination', comments?: Array<{ __typename?: 'BriefComment', id?: string | null, message?: string | null, createdAt?: any | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, activity?: { __typename?: 'BriefActivity', id?: string | null, action?: BriefAction | null, content?: { __typename?: 'BriefActivityContent', status?: { __typename?: 'BriefStatusFromTo', to?: BriefStatus | null } | null } | null } | null } | null> | null } | null };

export type BriefCommentsCountQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type BriefCommentsCountQuery = { __typename?: 'Query', briefComments?: { __typename?: 'BriefCommentsPagination', count?: number | null } | null };

export type GetBriefConceptionLinkQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBriefConceptionLinkQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, status?: BriefStatus | null, name?: string | null, createdAt?: any | null, reference?: string | null, awaitingNewConception?: boolean | null, author?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, conception?: Array<{ __typename?: 'BriefMedia', id?: string | null, api?: BriefApi | null, url?: string | null } | null> | null } | { __typename?: 'BriefHyundai', id?: string | null, status?: BriefStatus | null, name?: string | null, createdAt?: any | null, reference?: string | null, awaitingNewConception?: boolean | null, author?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, conception?: Array<{ __typename?: 'BriefMedia', id?: string | null, api?: BriefApi | null, url?: string | null } | null> | null } | null };

export type BriefHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BriefHistoryQuery = { __typename?: 'Query', briefActivity?: { __typename?: 'BriefActivityPagination', activity?: Array<{ __typename?: 'BriefActivity', id?: string | null, action?: BriefAction | null, createdAt?: any | null, author?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, content?: { __typename?: 'BriefActivityContent', decision?: BriefConceptionDecision | null, updatedFields?: Array<string | null> | null, status?: { __typename?: 'BriefStatusFromTo', from?: BriefStatus | null, to?: BriefStatus | null } | null, file?: { __typename?: 'BriefMedia', id?: string | null, filename?: string | null, url?: string | null } | null } | null, comment?: { __typename?: 'BriefComment', message?: string | null } | null } | null> | null } | null };

export type BriefOverviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BriefOverviewQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, isArchived?: boolean | null, isProduct?: boolean | null, createdAt?: any | null, name?: string | null, briefNumber?: number | null, status?: BriefStatus | null, validStartDate?: any | null, validEndDate?: any | null, author?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, shippingAddresses?: Array<{ __typename?: 'BriefShippingAddress', postalCode?: string | null } | null> | null, conception?: Array<{ __typename?: 'BriefMedia', api?: BriefApi | null } | null> | null, client?: { __typename?: 'Client', f?: Array<Features | null> | null } | null } | { __typename?: 'BriefHyundai', id?: string | null, isArchived?: boolean | null, isProduct?: boolean | null, createdAt?: any | null, name?: string | null, briefNumber?: number | null, status?: BriefStatus | null, validStartDate?: any | null, validEndDate?: any | null, author?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, shippingAddresses?: Array<{ __typename?: 'BriefShippingAddress', postalCode?: string | null } | null> | null, conception?: Array<{ __typename?: 'BriefMedia', api?: BriefApi | null } | null> | null, client?: { __typename?: 'Client', f?: Array<Features | null> | null } | null } | null };

export type BriefReferenceVisualsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BriefReferenceVisualsQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, referenceVisuals?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, mimetype?: string | null, thumbnail?: string | null, url?: string | null } | null> | null } | { __typename?: 'BriefHyundai', id?: string | null, referenceVisuals?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, mimetype?: string | null, thumbnail?: string | null, url?: string | null } | null> | null } | null };

export type BriefSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BriefSummaryQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, createdAt?: any | null, medium?: string | null, format?: string | null, description?: string | null, internalReference?: string | null, name?: string | null, type?: string | null, campaignId?: string | null, deliveryDeadline?: any | null, deliveryOption?: boolean | null, status?: BriefStatus | null, contacts?: Array<{ __typename?: 'BriefContact', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null> | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | { __typename?: 'BriefHyundai', id?: string | null, createdAt?: any | null, medium?: string | null, format?: string | null, description?: string | null, internalReference?: string | null, name?: string | null, type?: string | null, campaignId?: string | null, deliveryDeadline?: any | null, deliveryOption?: boolean | null, status?: BriefStatus | null, contacts?: Array<{ __typename?: 'BriefContact', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null> | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | null };

export type BriefSpecificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type BriefSpecificationsQuery = { __typename?: 'Query', briefTechnicalSpecifications?: Array<{ __typename?: 'BriefTypeSpecs', value?: string | null, mediums?: Array<{ __typename?: 'BriefMediumSpecs', value?: string | null, formats?: Array<{ __typename?: 'BriefFormatSpecs', value?: string | null, defaultDescription?: string | null } | null> | null } | null> | null } | null> | null, briefOtherTechnicalSpecifications?: { __typename?: 'OtherTechnicalSpecificationsReturn', activities?: Array<{ __typename?: 'BriefActivitiesSpecs', api?: string | null, value?: string | null } | null> | null, specs?: Array<{ __typename?: 'BriefBudgetTypeSpecs', api?: string | null, value?: string | null, models?: Array<{ __typename?: 'BriefModelSpecs', api?: string | null, value?: string | null } | null> | null, communications?: Array<{ __typename?: 'BriefCommunicationSpecs', api?: string | null, value?: string | null } | null> | null } | null> | null } | null, briefCampaignType?: Array<{ __typename?: 'BriefCampaignType', label?: string | null, value?: string | null } | null> | null };

export type BriefDeliveryOptionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BriefDeliveryOptionQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', deliveryOption?: boolean | null } | { __typename?: 'BriefHyundai', deliveryOption?: boolean | null } | null };

export type GetBriefsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<BriefsFilter>;
  sortField?: InputMaybe<SortField>;
}>;


export type GetBriefsQuery = { __typename?: 'Query', briefs?: { __typename?: 'BriefsPagination', count?: number | null, briefs?: Array<{ __typename?: 'BriefAllFields', id?: string | null, name?: string | null, briefNumber?: number | null, description?: string | null, internalReference?: string | null, status?: BriefStatus | null, createdAt?: any | null, isArchived?: boolean | null, isProduct?: boolean | null, author?: { __typename?: 'User', firstname?: string | null, lastname?: string | null } | null, attachments?: Array<{ __typename?: 'BriefMedia', id?: string | null } | null> | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, briefSpecClient?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, label?: string | null } | null> | null } | null> | null } | null };

export type CampaignSummaryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CampaignSummaryQuery = { __typename?: 'Query', campaignById?: { __typename?: 'Campaign', id: string, name?: string | null } | null };

export type GetCampaignsQueryVariables = Exact<{
  salespointGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  types?: InputMaybe<Array<CampaignType> | CampaignType>;
  sort?: InputMaybe<CampaignSort>;
  keyword?: InputMaybe<Scalars['String']>;
  isFilteredOnEndDate?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignPagination', campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, startDate?: any | null, endDate?: any | null, enabled?: boolean | null } | null> | null } | null };

export type GetInformationsToCreateBriefQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SalesPointFilter>;
  types?: InputMaybe<Array<CampaignType> | CampaignType>;
}>;


export type GetInformationsToCreateBriefQuery = { __typename?: 'Query', salesPoints?: { __typename?: 'SalesPointPagination', count?: number | null, enabledSalesPointsCount?: number | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, enabled?: boolean | null } | null> | null } | null, campaigns?: { __typename?: 'CampaignPagination', count?: number | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, name?: string | null } | null> | null } | null, me?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null, phone?: string | null, email?: string | null, defaultStoreId?: string | null, selectedSalesPointId?: string | null, selectedSalesPoint?: { __typename?: 'SalesPoint', salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null, defaultLocations?: { __typename?: 'DefaultLocations', shipping?: { __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null } | null, publicLocation?: { __typename?: 'Location', address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null, locations?: Array<{ __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null> | null } | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null } | null> | null } | null, briefTechnicalSpecifications?: Array<{ __typename?: 'BriefTypeSpecs', value?: string | null, mediums?: Array<{ __typename?: 'BriefMediumSpecs', value?: string | null, formats?: Array<{ __typename?: 'BriefFormatSpecs', value?: string | null, defaultDescription?: string | null } | null> | null } | null> | null } | null> | null };

export type GetLatestEventQueryVariables = Exact<{
  briefId: Scalars['ID'];
  filter?: InputMaybe<BriefActivityFilter>;
  sort?: InputMaybe<BriefActivitySort>;
}>;


export type GetLatestEventQuery = { __typename?: 'Query', briefActivity?: { __typename?: 'BriefActivityPagination', activity?: Array<{ __typename?: 'BriefActivity', id?: string | null, createdAt?: any | null, content?: { __typename?: 'BriefActivityContent', status?: { __typename?: 'BriefStatusFromTo', to?: BriefStatus | null, from?: BriefStatus | null } | null } | null } | null> | null } | null };

export type GetRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, selectedSalesPoint?: { __typename?: 'SalesPoint', salespointGroups?: Array<{ __typename?: 'SalespointsGroup', name?: string | null, id: string } | null> | null } | null, role?: { __typename?: 'Role', id?: string | null, slug?: string | null, absoluteSlug?: string | null } | null } | null };

export type MySalespointGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySalespointGroupsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, selectedSalesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null } | null } | null };

export type GetProofHqReviewerLinkQueryVariables = Exact<{
  briefId: Scalars['ID'];
}>;


export type GetProofHqReviewerLinkQuery = { __typename?: 'Query', getProofHqReviewerLink?: string | null };

export type GetSalespointInfoByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSalespointInfoByIdQuery = { __typename?: 'Query', salesPointById?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, email?: string | null, phone?: string | null, contactDetails?: { __typename?: 'ContactDetails', website?: string | null } | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string } | null> | null, defaultLocations?: { __typename?: 'DefaultLocations', shipping?: { __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null } | null, publicLocation?: { __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null, locations?: Array<{ __typename?: 'Location', id?: string | null, name?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, additionalAddress?: string | null } | null> | null } | null };

export type BriefShippingAddressesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BriefShippingAddressesQuery = { __typename?: 'Query', briefById?: { __typename?: 'Brief', id?: string | null, shippingAddresses?: Array<{ __typename?: 'BriefShippingAddress', name?: string | null, address?: string | null, additionalAddress?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, quantity?: number | null } | null> | null } | { __typename?: 'BriefHyundai', id?: string | null, shippingAddresses?: Array<{ __typename?: 'BriefShippingAddress', name?: string | null, address?: string | null, additionalAddress?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, quantity?: number | null } | null> | null } | null };

export type SalesPointsOptionsByKeywordQueryVariables = Exact<{
  keyword: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type SalesPointsOptionsByKeywordQuery = { __typename?: 'Query', salesPointsByKeyword?: { __typename?: 'SalesPointPagination', enabledSalesPointsCount?: number | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null };

export type SubmitBriefAttachmentsMutationVariables = Exact<{
  id: Scalars['ID'];
  attachments: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  tag: InputBriefMediaTag;
  sendNotificationMail?: InputMaybe<Scalars['Boolean']>;
  quoteOptions?: InputMaybe<InputBriefQuoteOptions>;
}>;


export type SubmitBriefAttachmentsMutation = { __typename?: 'Mutation', submitBriefAttachments?: { __typename?: 'Brief', id?: string | null, status?: BriefStatus | null } | null };

export type SubmitBriefConceptionMutationVariables = Exact<{
  briefId: Scalars['ID'];
  mediaId: Scalars['ID'];
  api: BriefApi;
}>;


export type SubmitBriefConceptionMutation = { __typename?: 'Mutation', submitBriefConception?: { __typename?: 'BriefMedia', id?: string | null } | null };

export type UpdateBriefMutationVariables = Exact<{
  id: Scalars['ID'];
  brief: InputBrief;
  editDraft: Scalars['Boolean'];
}>;


export type UpdateBriefMutation = { __typename?: 'Mutation', updateBrief?: { __typename?: 'Brief', id?: string | null } | null };

export type UpdateBriefStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: BriefStatus;
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBriefStatusMutation = { __typename?: 'Mutation', updateBriefStatus?: { __typename?: 'Brief', id?: string | null } | null };

export type UploadBriefMediaMutationVariables = Exact<{
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
  urls?: InputMaybe<Array<InputMediaUrl> | InputMediaUrl>;
}>;


export type UploadBriefMediaMutation = { __typename?: 'Mutation', uploadBriefMedia?: Array<{ __typename?: 'BriefMedia', id?: string | null, filename?: string | null, url?: string | null, mimetype?: string | null, thumbnail?: string | null } | null> | null };

export type BriefsForPlanningQueryVariables = Exact<{
  dateStart: Scalars['Date'];
  dateEnd: Scalars['Date'];
  filter?: InputMaybe<BriefsForPlanningFilter>;
}>;


export type BriefsForPlanningQuery = { __typename?: 'Query', briefsForPlanning?: Array<{ __typename?: 'BriefForPlanning', id?: string | null, name?: string | null, status?: BriefStatus | null, validStartDate?: any | null, validEndDate?: any | null, salesPointId?: string | null, briefSpecClient?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, value?: string | null, label?: string | null, parentId?: string | null, children?: Array<{ __typename?: 'BriefSpecClient', id?: string | null, key?: string | null, value?: string | null, label?: string | null } | null> | null } | null> | null } | null> | null };

export type GetBriefsCountQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<BriefsFilter>;
}>;


export type GetBriefsCountQuery = { __typename?: 'Query', briefs?: { __typename?: 'BriefsPagination', count?: number | null } | null };

export type GetMediaByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMediaByIdQuery = { __typename?: 'Query', mediaById?: { __typename?: 'Media', id: string, fileType?: UploadedFileType | null, name?: string | null, url?: string | null, thumbnail?: string | null, type: LibraryMediaType, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, size?: number | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null, images?: { __typename?: 'ImageFormats', large?: string | null } | null } | null };

export type UpdateCartWithProductsAvailabilityMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateCartWithProductsAvailabilityMutation = { __typename?: 'Mutation', updateCartWithProductsAvailability: { __typename?: 'CartProductsAvailabilityResult', changes: Array<{ __typename?: 'CartProductsAvailabilityChange', removed: boolean, removedCount: number, item: { __typename?: 'Item', product: { __typename?: 'Product', name?: string | null } } }>, cart: { __typename?: 'Cart', userId: string, items?: Array<{ __typename?: 'Item', productId: string, quantity: number, totalPrice?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null } | null } | null, product: { __typename?: 'Product', id: string, stock?: number | null, isStockEnabled?: boolean | null }, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null } | null> | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null } } };

export type DownloadLibraryMediasMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DownloadLibraryMediasMutation = { __typename?: 'Mutation', downloadLibraryMedias?: { __typename?: 'DownloadLibraryMediasResult', url: string, filename: string } | null };

export type GetFolderFiltersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetFolderFiltersQuery = { __typename?: 'Query', folderById?: { __typename?: 'Folder', validFrom?: any | null, validTo?: any | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null } | null };

export type HighlightedMediasQueryVariables = Exact<{
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  excludeDisabledForAdmin?: InputMaybe<Scalars['Boolean']>;
}>;


export type HighlightedMediasQuery = { __typename?: 'Query', highlightedMedias?: Array<{ __typename?: 'MediasHighlighted', totalCount?: number | null, tag?: { __typename?: 'Tag', id: string, label?: string | null, enabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, library?: { __typename?: 'TagLibraryInfos', isHighlighted?: boolean | null, highlightOrder?: number | null } | null } | null, medias?: Array<{ __typename?: 'Media', id: string, name?: string | null, type: LibraryMediaType, fileType?: UploadedFileType | null, thumbnail?: string | null, tempUrl?: string | null, enabled?: boolean | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, size?: number | null, mimetype?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null, images?: { __typename?: 'ImageFormats', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null } | null } | null> | null } | null> | null };

export type InfiniteMediasQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MediaSort>;
  folderId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<Array<InputMaybe<MediaFilterInput>> | InputMaybe<MediaFilterInput>>;
  keyword?: InputMaybe<Scalars['String']>;
  searchInSubfolders?: InputMaybe<Scalars['Boolean']>;
  bypassSalespointsGroups?: InputMaybe<Scalars['Boolean']>;
  salespointsGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignId?: InputMaybe<Scalars['ID']>;
  includeHighlighted?: InputMaybe<Scalars['Boolean']>;
  excludeDisabledForAdmin?: InputMaybe<Scalars['Boolean']>;
  types?: InputMaybe<Array<InputMaybe<MediaTypeFilter>> | InputMaybe<MediaTypeFilter>>;
}>;


export type InfiniteMediasQuery = { __typename?: 'Query', medias?: { __typename?: 'MediasPagination', count?: number | null, medias?: Array<{ __typename?: 'LiteMedia', id: string, name?: string | null, type: LibraryMediaType, fileType?: UploadedFileType | null, thumbnail?: string | null, tempUrl?: string | null, enabled?: boolean | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, size?: number | null, mimetype?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null, images?: { __typename?: 'ImageFormats', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null } | null } | null> | null, highlighted?: Array<{ __typename?: 'MediasHighlighted', tag?: { __typename?: 'Tag', id: string, label?: string | null, enabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, library?: { __typename?: 'TagLibraryInfos', isHighlighted?: boolean | null, highlightOrder?: number | null } | null } | null, medias?: Array<{ __typename?: 'Media', id: string, name?: string | null, type: LibraryMediaType, fileType?: UploadedFileType | null, thumbnail?: string | null, tempUrl?: string | null, enabled?: boolean | null, details?: { __typename?: 'MediaDetails', description?: string | null, tips?: string | null, size?: number | null, mimetype?: string | null, tags?: Array<{ __typename?: 'Tag', id: string, label?: string | null } | null> | null } | null, images?: { __typename?: 'ImageFormats', thumbnail?: string | null, large?: string | null, medium?: string | null, small?: string | null } | null } | null> | null } | null> | null } | null };

export type MoveLibraryMediasMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  targetFolder?: InputMaybe<Scalars['ID']>;
}>;


export type MoveLibraryMediasMutation = { __typename?: 'Mutation', moveLibraryMedias?: boolean | null };

export type CommitOrderPaymentMutationVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  stripePaymentMethod?: InputMaybe<StripePaymentMethod>;
}>;


export type CommitOrderPaymentMutation = { __typename?: 'Mutation', commitOrderPayment?: string | null };

export type GetOrdersToValidateQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderFilter>;
  sort?: InputMaybe<Direction>;
}>;


export type GetOrdersToValidateQuery = { __typename?: 'Query', ordersToValidate?: { __typename?: 'OrderPagination', count: number, orders?: Array<{ __typename?: 'Order', id: string, isValidator?: boolean | null, orderNumber: string, trackingNumber?: string | null, trackingURL?: string | null, userId: string, status: Status, receipt?: string | null, totalProductsQuantity: number, date: any, isPurchaseOrder?: boolean | null, paymentMethod?: { __typename?: 'OrderPaymentMethod', type?: OrderPaymentMethodType | null, documentType?: OrderPaymentMethodDocumentType | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', currentStatus?: PaymentStatusValue | null, stripePaymentMethod?: StripePaymentMethod | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, items: Array<{ __typename?: 'OrderItem', productId: string, subId?: string | null, quantity: number, product: { __typename?: 'OrderProduct', id: string, name: string, ref?: string | null, description?: string | null, isCustomizable?: boolean | null, type?: string | null, images?: Array<{ __typename?: 'OrderImage', small?: string | null } | null> | null, tags?: Array<{ __typename?: 'OrderTag', id?: string | null, label?: string | null, color?: string | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null }, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null } | null>, addresses: { __typename?: 'Addresses', shipping?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null, billing?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null }, vouchers?: Array<{ __typename?: 'OrderVoucher', name?: string | null, amount?: number | null } | null> | null, provider?: { __typename?: 'Provider', name: string } | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, totalWithFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null, withTaxes?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, totalWithShippingFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null } | null } | null> | null } | null };

export type GetOrdersValidatedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<OrderFilter>;
  sort?: InputMaybe<Direction>;
}>;


export type GetOrdersValidatedQuery = { __typename?: 'Query', ordersValidated?: { __typename?: 'OrderPagination', count: number, orders?: Array<{ __typename?: 'Order', id: string, orderNumber: string, status: Status, date: any, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null } | null } | null, totalWithShippingFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null } | null } | null, salespoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, provider?: { __typename?: 'Provider', name: string } | null, author?: { __typename?: 'User', email?: string | null, fullName?: string | null } | null, items: Array<{ __typename?: 'OrderItem', productId: string, quantity: number } | null> } | null> | null } | null };

export type ValidateOrdersMutationVariables = Exact<{
  ordersIds: Array<Scalars['ID']> | Scalars['ID'];
  action: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type ValidateOrdersMutation = { __typename?: 'Mutation', validateOrders?: boolean | null };

export type AddMultipleItemsToCartMutationVariables = Exact<{
  items?: InputMaybe<Array<InputMaybe<CartItemInput>> | InputMaybe<CartItemInput>>;
}>;


export type AddMultipleItemsToCartMutation = { __typename?: 'Mutation', addMultipleItemsToCart?: { __typename?: 'Cart', items?: Array<{ __typename?: 'Item', productId: string, providerId?: string | null, subId?: string | null, packInfo?: { __typename?: 'PackInfo', id?: string | null, name?: string | null, ref?: string | null, productsInPack?: Array<{ __typename?: 'ProductInPack', id?: string | null, name?: string | null, ref?: string | null } | null> | null } | null, files: Array<{ __typename?: 'ItemFile', id: string, originalName: string }> } | null> | null } | null };

export type ProductInfo_AddCartItemFilesMutationVariables = Exact<{
  productId: Scalars['ID'];
  packId?: InputMaybe<Scalars['ID']>;
  subId?: InputMaybe<Scalars['ID']>;
  files?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
  existingFileIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ProductInfo_AddCartItemFilesMutation = { __typename?: 'Mutation', addCartItemFiles?: { __typename?: 'Cart', userId: string, items?: Array<{ __typename?: 'Item', productId: string, files: Array<{ __typename?: 'ItemFile', id: string, originalName: string }> } | null> | null } | null };

export type ProductInfo_DeleteCartItemFileMutationVariables = Exact<{
  fileId: Scalars['ID'];
}>;


export type ProductInfo_DeleteCartItemFileMutation = { __typename?: 'Mutation', deleteCartItemFile?: { __typename?: 'Cart', userId: string, items?: Array<{ __typename?: 'Item', productId: string, files: Array<{ __typename?: 'ItemFile', id: string, originalName: string }> } | null> | null } | null };

export type CancelOrderByProviderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type CancelOrderByProviderMutation = { __typename?: 'Mutation', cancelOrderByProvider?: { __typename?: 'Order', id: string, status: Status, reason?: string | null, messages?: Array<{ __typename?: 'OrderMessage', content?: string | null, isCancelledReason?: boolean | null }> | null } | null };

export type GetPaidMediaCampaignQueryVariables = Exact<{
  orderId: Scalars['ID'];
  clientId: Scalars['String'];
}>;


export type GetPaidMediaCampaignQuery = { __typename?: 'Query', getPaidMediaCampaign?: { __typename?: 'PaidMediaCampaignLite', id: string } | null };

export type ReplaceFileProductMutationVariables = Exact<{
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  file: Scalars['Upload'];
  subId?: InputMaybe<Scalars['ID']>;
}>;


export type ReplaceFileProductMutation = { __typename?: 'Mutation', replaceFileValidationOrders: string };

export type OrderDetails_OrderDetailsProviderQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderDetails_OrderDetailsProviderQuery = { __typename?: 'Query', orderDetailsProvider?: { __typename?: 'Order', id: string, orderNumber: string, trackingNumber?: string | null, trackingURL?: string | null, userId: string, eskerNumber?: string | null, status: Status, receipt?: string | null, totalProductsQuantity: number, date: any, shippingFees?: number | null, hasArchive?: boolean | null, client?: { __typename?: 'Client', id: string, clientId?: string | null, shopOptions?: { __typename?: 'ShopOptions', isShippingFeesEnabled?: boolean | null, displayTaxes?: boolean | null } | null } | null, paymentMethod?: { __typename?: 'OrderPaymentMethod', type?: OrderPaymentMethodType | null, documentType?: OrderPaymentMethodDocumentType | null } | null, messages?: Array<{ __typename?: 'OrderMessage', id: string, content?: string | null, createdAt?: any | null, isCancelledReason?: boolean | null }> | null, author?: { __typename?: 'User', email?: string | null } | null, validator?: { __typename?: 'User', email?: string | null } | null, items: Array<{ __typename?: 'OrderItem', hasArchive: boolean, comment?: string | null, productId: string, subId?: string | null, quantity: number, options?: Array<{ __typename?: 'OrderItemOptions', name?: string | null }> | null, product: { __typename?: 'OrderProduct', id: string, name: string, ref?: string | null, description?: string | null, isCustomizable?: boolean | null, isPaidMediaProduct?: boolean | null, packagingUnit?: number | null, images?: Array<{ __typename?: 'OrderImage', small?: string | null } | null> | null, tags?: Array<{ __typename?: 'OrderTag', id?: string | null, label?: string | null, color?: string | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null }, variationByQuantity?: Array<{ __typename?: 'QuantityVariation', quantity?: number | null, values?: any | null } | null> | null } | null>, addresses: { __typename?: 'Addresses', shipping?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null, billing?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null }, vouchers?: Array<{ __typename?: 'OrderVoucher', name?: string | null, amount?: number | null } | null> | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null } | null, totalWithFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null, withTaxes?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, totalWithShippingFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withTaxes?: number | null, withoutTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', isMultiProvider?: boolean | null, currentStatus?: PaymentStatusValue | null, paymentIntentId?: string | null, stripePaymentMethod?: StripePaymentMethod | null, stripeUrl?: string | null, stripeFee?: number | null, status?: Array<{ __typename?: 'PaymentStatus', date?: any | null, value?: PaymentStatusValue | null } | null> | null, transfers?: Array<{ __typename?: 'Transfer', stripeUrl?: string | null, transferOriginId?: string | null, orderNumber?: string | null } | null> | null } | null, providerInvoice?: { __typename?: 'ProviderInvoice', filename?: string | null, path?: string | null, created_at?: any | null } | null } | null };

export type OrdersByProviderQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Direction>;
  filter?: InputMaybe<OrderFilter>;
}>;


export type OrdersByProviderQuery = { __typename?: 'Query', ordersByProvider?: { __typename?: 'OrderPagination', count: number, orders?: Array<{ __typename?: 'Order', id: string, orderNumber: string, trackingNumber?: string | null, trackingURL?: string | null, userId: string, status: Status, receipt?: string | null, totalProductsQuantity: number, date: any, paymentMethod?: { __typename?: 'OrderPaymentMethod', type?: OrderPaymentMethodType | null } | null, items: Array<{ __typename?: 'OrderItem', productId: string, subId?: string | null, quantity: number, product: { __typename?: 'OrderProduct', id: string, name: string, ref?: string | null, description?: string | null, isCustomizable?: boolean | null, images?: Array<{ __typename?: 'OrderImage', small?: string | null } | null> | null, tags?: Array<{ __typename?: 'OrderTag', id?: string | null, label?: string | null, color?: string | null } | null> | null, highQualityAsset?: { __typename?: 'ProductAsset', url?: string | null, name?: string | null } | null } } | null>, addresses: { __typename?: 'Addresses', shipping?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null, billing?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null, company?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null } | null }, vouchers?: Array<{ __typename?: 'OrderVoucher', name?: string | null, amount?: number | null } | null> | null, total?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, totalWithShippingFees?: { __typename?: 'Price', basePrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, taxPercent?: number | null, taxAmount?: number | null, withTaxes?: number | null } | null, discountedPrice?: { __typename?: 'PriceAmount', withoutTaxes?: number | null, withTaxes?: number | null, taxAmount?: number | null, taxPercent?: number | null } | null } | null, paymentInfo?: { __typename?: 'PaymentInfo', isMultiProvider?: boolean | null, currentStatus?: PaymentStatusValue | null, paymentIntentId?: string | null, stripePaymentMethod?: StripePaymentMethod | null, stripeUrl?: string | null, stripeFee?: number | null, status?: Array<{ __typename?: 'PaymentStatus', date?: any | null, value?: PaymentStatusValue | null } | null> | null, transfers?: Array<{ __typename?: 'Transfer', stripeUrl?: string | null, transferOriginId?: string | null, orderNumber?: string | null } | null> | null } | null, providerInvoice?: { __typename?: 'ProviderInvoice', filename?: string | null, path?: string | null, created_at?: any | null } | null } | null> | null } | null };

export type ArchiveAllNotificationsMutationVariables = Exact<{
  filters: NotificationFilters;
}>;


export type ArchiveAllNotificationsMutation = { __typename?: 'Mutation', archiveAllNotifications?: { __typename?: 'DefaultPayload', success?: boolean | null } | null };

export type ArchiveNotificationsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type ArchiveNotificationsMutation = { __typename?: 'Mutation', archiveNotifications?: { __typename?: 'DefaultPayload', success?: boolean | null } | null };

export type ExportNotificationsListQueryVariables = Exact<{
  filters: NotificationFilters;
}>;


export type ExportNotificationsListQuery = { __typename?: 'Query', exportNotificationsList: { __typename?: 'ExportSocialLinks', mediaLink: string } };

export type GetNotificationDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  status: NotificationReplyStatus;
}>;


export type GetNotificationDetailsQuery = { __typename?: 'Query', getNotificationDetails?: { __typename?: 'NotificationDetails', replies?: Array<{ __typename?: 'NotificationReply', id?: string | null, message?: string | null, type?: string | null, createdAt?: any | null, status?: any | null, validationDate?: any | null, validatorRole?: ValidatorRole | null, validator?: { __typename?: 'User', id: string, fullName?: string | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null } | null> | null, notification?: { __typename?: 'Notification', id?: string | null, isRead?: boolean | null, isAnswered?: boolean | null, isLiked?: boolean | null, isHidden?: boolean | null, isUpdated?: boolean | null, rating?: number | null, recommandation?: string | null, picture?: string | null, video?: string | null, postId?: string | null, createdAt?: any | null, type?: string | null, message?: string | null, url?: string | null, notificationId?: string | null, author?: string | null, socialNetwork?: string | null, isPendingApproval?: boolean | null, salesPointTargeted?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | null, post?: { __typename?: 'SocialMediaPost', id: string, socialNetworkPostId?: string | null, description?: string | null, textDescription?: string | null, createdAt?: any | null, authorRole?: SocialAuthorRole | null, type?: PostType | null, status?: PostStatus | null, socialNetworkTarget: SocialNetwork, link?: string | null, authorId?: string | null, isDraft?: boolean | null, isDeletable?: boolean | null, isDuplicatable?: boolean | null, isEditable?: boolean | null, isAmplified?: boolean | null, socialNetworkPostUrl?: string | null, author?: { __typename?: 'User', id: string, firstname?: string | null, lastname?: string | null } | null, totalStatus?: { __typename?: 'PostTotalStatus', posted: number, error: number, other: number } | null, target?: { __typename?: 'PostTarget', type?: TargetType | null } | null, analyze?: { __typename?: 'PostMetrics', engagementRate: number, totalReactions: number, shares: number, comments: number, engagement: number, reach: number, insightPaid?: number | null, insightUnpaid?: number | null, likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null } | null, medias?: Array<{ __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null> | null, thumb?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, avatar?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, cover?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, carouselItems?: Array<{ __typename?: 'PostCarouselItem', media?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null }> | null, salesPointTargeted?: { __typename?: 'SalesPoint', name?: string | null } | null } | null } | null };

export type GetNotificationsListQueryVariables = Exact<{
  filters: NotificationFilters;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  toValidate?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetNotificationsListQuery = { __typename?: 'Query', getNotificationsList?: { __typename?: 'NotificationList', count?: number | null, notifications?: Array<{ __typename?: 'Notification', id?: string | null, type?: string | null, socialNetwork?: string | null, author?: string | null, isRead?: boolean | null, isAnswered?: boolean | null, isLiked?: boolean | null, isHidden?: boolean | null, isAlert?: boolean | null, isUpdated?: boolean | null, rating?: number | null, recommandation?: string | null, picture?: string | null, video?: string | null, postId?: string | null, createdAt?: any | null, message?: string | null, url?: string | null, notificationId?: string | null, isPendingApproval?: boolean | null, salesPointTargeted?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null, publicName?: string | null, secondaryName?: string | null } | null } | null> | null } | null };

export type UserStoreCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserStoreCodesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null };

export type ReplyToNotificationsMutationVariables = Exact<{
  notificationsIds: Array<Scalars['ID']> | Scalars['ID'];
  message: Scalars['String'];
  replyAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type ReplyToNotificationsMutation = { __typename?: 'Mutation', replyToNotifications?: { __typename?: 'BulkActionResult', success?: boolean | null, partialSuccess?: boolean | null } | null };

export type ToggleLikeNotificationsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type ToggleLikeNotificationsMutation = { __typename?: 'Mutation', toggleLikeNotifications?: { __typename?: 'BulkActionResult', success?: boolean | null, partialSuccess?: boolean | null } | null };

export type ToggleNotificationsVisibilityMutationVariables = Exact<{
  notifications?: InputMaybe<Array<InputMaybe<InputNotification>> | InputMaybe<InputNotification>>;
  hide?: InputMaybe<Scalars['Boolean']>;
}>;


export type ToggleNotificationsVisibilityMutation = { __typename?: 'Mutation', toggleNotificationsVisibility?: { __typename?: 'BulkActionResult', success?: boolean | null, partialSuccess?: boolean | null } | null };

export type ValidateNotificationRepliesMutationVariables = Exact<{
  notificationId: Scalars['ID'];
  repliesIds: Array<Scalars['ID']> | Scalars['ID'];
  action: NotificationReplyStatus;
}>;


export type ValidateNotificationRepliesMutation = { __typename?: 'Mutation', validateNotificationReplies?: { __typename?: 'BulkActionResult', success?: boolean | null, partialSuccess?: boolean | null } | null };

export type DeletePostTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePostTemplateMutation = { __typename?: 'Mutation', deletePostTemplate?: boolean | null };

export type GetPostTemplateDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPostTemplateDetailsQuery = { __typename?: 'Query', getPostTemplateDetails?: { __typename?: 'PostTemplate', id?: string | null, name?: string | null, displayStatus?: PostTemplateDisplayStatus | null, type?: PostType | null, socialNetworks?: Array<SocialNetwork | null> | null, useSalespointsGroups?: boolean | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, isUsable?: boolean | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', name?: string | null } | null> | null, tags?: Array<{ __typename?: 'PostTemplateTag', id: string, name?: string | null } | null> | null, templateBodyData?: { __typename?: 'PostTemplateBodyData', textDescription?: string | null, authorRole?: SocialAuthorRole | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, videoThumbnail?: string | null, content?: string | null, caption?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null } | null } | null };

export type GetPostTemplateListQueryVariables = Exact<{
  filters?: InputMaybe<PostTemplateListFilters>;
  sort?: InputMaybe<PostTemplateListSort>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPostTemplateListQuery = { __typename?: 'Query', getPostTemplateList?: { __typename?: 'PostTemplateList', count?: number | null, templates?: Array<{ __typename?: 'PostTemplate', mongoId?: string | null, id?: string | null, name?: string | null, type?: PostType | null, socialNetworks?: Array<SocialNetwork | null> | null, displayStatus?: PostTemplateDisplayStatus | null, useSalespointsGroups?: boolean | null, isScheduled?: boolean | null, startDate?: any | null, endDate?: any | null, salespointsGroups?: Array<{ __typename?: 'SalespointsGroup', name?: string | null, salespoints?: Array<{ __typename?: 'SalesPoint', name?: string | null } | null> | null } | null> | null, templateBodyData?: { __typename?: 'PostTemplateBodyData', textDescription?: string | null, htmlDescription?: string | null, authorRole?: SocialAuthorRole | null, socialNetworksDescription?: { __typename?: 'SocialNetworksDescriptionType', facebook?: string | null, instagram?: string | null, google?: string | null, linkedin?: string | null, twitter?: string | null } | null, socialNetworksRawDescription?: { __typename?: 'SocialNetworksDescriptionType', facebook?: string | null, instagram?: string | null, google?: string | null, linkedin?: string | null, twitter?: string | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, videoThumbnail?: string | null, content?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null } | null } | null> | null } | null };

export type PostTemplateTagFiltersQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
  postTemplateListFilters?: InputMaybe<PostTemplateListFilters>;
}>;


export type PostTemplateTagFiltersQuery = { __typename?: 'Query', postTemplateTagFilters?: Array<{ __typename?: 'TagFilter', id?: string | null, name?: string | null, tags?: Array<{ __typename?: 'TagFilterOption', id?: string | null, name?: string | null, countMatchingTemplates?: number | null } | null> | null } | null> | null };

export type PostDetailsPublishFragment = { __typename?: 'SocialMediaPost', socialNetworkPostId?: string | null, status?: PostStatus | null, totalPosts?: number | null, authorRole?: SocialAuthorRole | null, validatorComment?: string | null, validationDate?: any | null, validatorRole?: string | null, scheduledAt?: any | null, adCount?: number | null, isAmplifiable?: boolean | null, userCanValidatePost?: boolean | null, userCanViewPostCalendarDetails?: boolean | null, isEditable?: boolean | null, isDeletable?: boolean | null, isTemplatable?: boolean | null, isDuplicatable?: boolean | null, type?: PostType | null, description?: string | null, textDescription?: string | null, htmlDescription?: string | null, link?: string | null, callToAction?: number | null, socialNetworkTarget: SocialNetwork, rawDescription?: string | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, validator?: { __typename?: 'User', id: string, fullName?: string | null } | null, organicTargeting?: { __typename?: 'OrganicTargeting', sexTargeting?: boolean | null, sexOfTarget?: string | null, ageTargeting?: boolean | null, minAgeTarget?: number | null, maxAgeTarget?: number | null, targetingInterests?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null, targetingCountries?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null, targetingGeolocations?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null } | null, target?: { __typename?: 'PostTarget', type?: TargetType | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, targetToExclude?: Array<string | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null, salesPointToExclude?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null, analyze?: { __typename?: 'PostMetrics', reach: number, engagement: number, comments: number, shares: number, totalReactions: number, insightAdReach?: number | null, insightAdInteraction?: number | null, insightAdSpent?: number | null, likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null } | null, thumb?: { __typename?: 'PublishMedia', path?: string | null } | null, medias?: Array<{ __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null> | null, cover?: { __typename?: 'PublishMedia', path?: string | null } | null, carouselItems?: Array<{ __typename?: 'PostCarouselItem', link?: string | null, title?: string | null, description?: string | null, callToAction?: number | null, media?: { __typename?: 'PublishMedia', path?: string | null } | null }> | null, avatar?: { __typename?: 'PublishMedia', path?: string | null } | null, event?: { __typename?: 'SocialEvent', title?: string | null, startAt?: any | null, endAt?: any | null, callToAction?: number | null, terms?: string | null, couponCode?: string | null } | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, caption?: string | null, videoThumbnail?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null };

export type PostPreviewPublishFragment = { __typename?: 'SocialMediaPost', type?: PostType | null, description?: string | null, textDescription?: string | null, htmlDescription?: string | null, link?: string | null, callToAction?: number | null, socialNetworkTarget: SocialNetwork, rawDescription?: string | null, thumb?: { __typename?: 'PublishMedia', path?: string | null } | null, medias?: Array<{ __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null> | null, cover?: { __typename?: 'PublishMedia', path?: string | null } | null, carouselItems?: Array<{ __typename?: 'PostCarouselItem', link?: string | null, title?: string | null, description?: string | null, callToAction?: number | null, media?: { __typename?: 'PublishMedia', path?: string | null } | null }> | null, avatar?: { __typename?: 'PublishMedia', path?: string | null } | null, event?: { __typename?: 'SocialEvent', title?: string | null, startAt?: any | null, endAt?: any | null, callToAction?: number | null, terms?: string | null, couponCode?: string | null } | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, caption?: string | null, videoThumbnail?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null };

export type PostDetails_GetPostCalendarDetailsQueryVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type PostDetails_GetPostCalendarDetailsQuery = { __typename?: 'Query', getPostCalendarDetails?: { __typename?: 'SocialMediaPost', id: string, socialNetworkPostId?: string | null, status?: PostStatus | null, totalPosts?: number | null, authorRole?: SocialAuthorRole | null, validatorComment?: string | null, validationDate?: any | null, validatorRole?: string | null, scheduledAt?: any | null, adCount?: number | null, isAmplifiable?: boolean | null, userCanValidatePost?: boolean | null, userCanViewPostCalendarDetails?: boolean | null, isEditable?: boolean | null, isDeletable?: boolean | null, isTemplatable?: boolean | null, isDuplicatable?: boolean | null, type?: PostType | null, description?: string | null, textDescription?: string | null, htmlDescription?: string | null, link?: string | null, callToAction?: number | null, socialNetworkTarget: SocialNetwork, rawDescription?: string | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, validator?: { __typename?: 'User', id: string, fullName?: string | null } | null, organicTargeting?: { __typename?: 'OrganicTargeting', sexTargeting?: boolean | null, sexOfTarget?: string | null, ageTargeting?: boolean | null, minAgeTarget?: number | null, maxAgeTarget?: number | null, targetingInterests?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null, targetingCountries?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null, targetingGeolocations?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null } | null, target?: { __typename?: 'PostTarget', type?: TargetType | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, targetToExclude?: Array<string | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null, salesPointToExclude?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null, analyze?: { __typename?: 'PostMetrics', reach: number, engagement: number, comments: number, shares: number, totalReactions: number, insightAdReach?: number | null, insightAdInteraction?: number | null, insightAdSpent?: number | null, likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null } | null, thumb?: { __typename?: 'PublishMedia', path?: string | null } | null, medias?: Array<{ __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null> | null, cover?: { __typename?: 'PublishMedia', path?: string | null } | null, carouselItems?: Array<{ __typename?: 'PostCarouselItem', link?: string | null, title?: string | null, description?: string | null, callToAction?: number | null, media?: { __typename?: 'PublishMedia', path?: string | null } | null }> | null, avatar?: { __typename?: 'PublishMedia', path?: string | null } | null, event?: { __typename?: 'SocialEvent', title?: string | null, startAt?: any | null, endAt?: any | null, callToAction?: number | null, terms?: string | null, couponCode?: string | null } | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, caption?: string | null, videoThumbnail?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null } | null };

export type PostDetails_GetSocialNetworkPostDetailsQueryVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type PostDetails_GetSocialNetworkPostDetailsQuery = { __typename?: 'Query', getSocialNetworkPostDetails?: { __typename?: 'SocialMediaPost', id: string, socialNetworkPostUrl?: string | null, postCalendarId?: string | null, socialNetworkPostId?: string | null, status?: PostStatus | null, totalPosts?: number | null, authorRole?: SocialAuthorRole | null, validatorComment?: string | null, validationDate?: any | null, validatorRole?: string | null, scheduledAt?: any | null, adCount?: number | null, isAmplifiable?: boolean | null, userCanValidatePost?: boolean | null, userCanViewPostCalendarDetails?: boolean | null, isEditable?: boolean | null, isDeletable?: boolean | null, isTemplatable?: boolean | null, isDuplicatable?: boolean | null, type?: PostType | null, description?: string | null, textDescription?: string | null, htmlDescription?: string | null, link?: string | null, callToAction?: number | null, socialNetworkTarget: SocialNetwork, rawDescription?: string | null, salesPointTargeted?: { __typename?: 'SalesPoint', name?: string | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, validator?: { __typename?: 'User', id: string, fullName?: string | null } | null, organicTargeting?: { __typename?: 'OrganicTargeting', sexTargeting?: boolean | null, sexOfTarget?: string | null, ageTargeting?: boolean | null, minAgeTarget?: number | null, maxAgeTarget?: number | null, targetingInterests?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null, targetingCountries?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null, targetingGeolocations?: Array<{ __typename?: 'OrganicTargetingObject', name?: string | null } | null> | null } | null, target?: { __typename?: 'PostTarget', type?: TargetType | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, targetToExclude?: Array<string | null> | null, salespointGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null, salesPointToExclude?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null, analyze?: { __typename?: 'PostMetrics', reach: number, engagement: number, comments: number, shares: number, totalReactions: number, insightAdReach?: number | null, insightAdInteraction?: number | null, insightAdSpent?: number | null, likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null } | null, thumb?: { __typename?: 'PublishMedia', path?: string | null } | null, medias?: Array<{ __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null> | null, cover?: { __typename?: 'PublishMedia', path?: string | null } | null, carouselItems?: Array<{ __typename?: 'PostCarouselItem', link?: string | null, title?: string | null, description?: string | null, callToAction?: number | null, media?: { __typename?: 'PublishMedia', path?: string | null } | null }> | null, avatar?: { __typename?: 'PublishMedia', path?: string | null } | null, event?: { __typename?: 'SocialEvent', title?: string | null, startAt?: any | null, endAt?: any | null, callToAction?: number | null, terms?: string | null, couponCode?: string | null } | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, caption?: string | null, videoThumbnail?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null } | null };

export type PostReactionDetailsPublishAnalyzeFragment = { __typename?: 'PostMetrics', likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null };

export type PostStatusDetailsPublishTotalStatusFragment = { __typename?: 'PostTotalStatus', posted: number, error: number, other: number };

export type PostsListItemPostFragment = { __typename?: 'PublishListPost', id: string, postCalendarId?: string | null, type?: PostType | null, scheduledAt?: any | null, createdAt?: any | null, status?: PostStatus | null, totalPosts?: number | null, authorRole?: SocialAuthorRole | null, validationDate?: any | null, validatorRole?: ValidatorRole | null, validatorComment?: string | null, textDescription?: string | null, description?: string | null, link?: string | null, socialNetworkPostUrl?: string | null, socialNetworkTarget: SocialNetwork, isAmplified?: boolean | null, isAmplifiable?: boolean | null, userCanValidatePost?: boolean | null, userCanViewPostCalendarDetails?: boolean | null, isEditable?: boolean | null, isDeletable?: boolean | null, isDuplicatable?: boolean | null, isTemplatable?: boolean | null, levelEditable?: number | null, errorMessage?: string | null, avatar?: { __typename?: 'PublishMedia', mimeType?: string | null, extension?: string | null, path?: string | null } | null, validator?: { __typename?: 'User', id: string, fullName?: string | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, salesPointTargeted?: { __typename?: 'SalesPoint', name?: string | null } | null, target?: { __typename?: 'PublishListPostTarget', type?: TargetType | null, salespointGroupsCount?: number | null, salesPointsCount?: number | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, salesPointsToExcludeCount?: number | null, salesPointGroup?: { __typename?: 'SalespointsGroup', id: string, name?: string | null } | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, salesPointToExclude?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | null, analyze?: { __typename?: 'PostMetrics', engagementRate: number, totalReactions: number, shares: number, comments: number, engagement: number, reach: number, insightPaid?: number | null, insightUnpaid?: number | null, likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null } | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, videoThumbnail?: string | null, caption?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null, totalStatus?: { __typename?: 'PostTotalStatus', posted: number, error: number, other: number } | null, groupErrors?: Array<{ __typename?: 'PostErrors', count?: number | null, error?: string | null } | null> | null };

export type GetPublishTotalStatsQueryVariables = Exact<{
  args: SearchPublishListArgs;
}>;


export type GetPublishTotalStatsQuery = { __typename?: 'Query', getPublishTotalStats: { __typename?: 'PublishTotalStats', total: number, reach: number, engagement: number } };

export type ExportPublishListQueryVariables = Exact<{
  args: SearchPublishListArgs;
  sort?: InputMaybe<PublishListSortArgs>;
}>;


export type ExportPublishListQuery = { __typename?: 'Query', exportPublishList: { __typename?: 'ExportSocialLinks', mediaLink: string } };

export type GetMilestonesQueryVariables = Exact<{
  start: Scalars['Date'];
  end: Scalars['Date'];
}>;


export type GetMilestonesQuery = { __typename?: 'Query', getMilestones?: Array<{ __typename?: 'Milestone', start?: any | null, end?: any | null, name?: string | null } | null> | null };

export type GetPublishListForCalendarQueryVariables = Exact<{
  args: SearchPublishListArgs;
  sort: PublishListSortArgs;
}>;


export type GetPublishListForCalendarQuery = { __typename?: 'Query', getPublishListForCalendar?: Array<{ __typename?: 'SocialMediaPost', id: string, postCalendarId?: string | null, socialNetworkTarget: SocialNetwork, textDescription?: string | null, scheduledAt?: any | null, status?: PostStatus | null } | null> | null };

export type GetPublishListQueryVariables = Exact<{
  args: SearchPublishListArgs;
  sort: PublishListSortArgs;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPublishListQuery = { __typename?: 'Query', getPublishList?: { __typename?: 'PublishList', count?: number | null, posts?: Array<{ __typename?: 'PublishListPost', id: string, postCalendarId?: string | null, type?: PostType | null, scheduledAt?: any | null, createdAt?: any | null, status?: PostStatus | null, totalPosts?: number | null, authorRole?: SocialAuthorRole | null, validationDate?: any | null, validatorRole?: ValidatorRole | null, validatorComment?: string | null, textDescription?: string | null, description?: string | null, link?: string | null, socialNetworkPostUrl?: string | null, socialNetworkTarget: SocialNetwork, isAmplified?: boolean | null, isAmplifiable?: boolean | null, userCanValidatePost?: boolean | null, userCanViewPostCalendarDetails?: boolean | null, isEditable?: boolean | null, isDeletable?: boolean | null, isDuplicatable?: boolean | null, isTemplatable?: boolean | null, levelEditable?: number | null, errorMessage?: string | null, avatar?: { __typename?: 'PublishMedia', mimeType?: string | null, extension?: string | null, path?: string | null } | null, validator?: { __typename?: 'User', id: string, fullName?: string | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, salesPointTargeted?: { __typename?: 'SalesPoint', name?: string | null } | null, target?: { __typename?: 'PublishListPostTarget', type?: TargetType | null, salespointGroupsCount?: number | null, salesPointsCount?: number | null, onSalesPoints?: boolean | null, onGlobals?: boolean | null, salesPointsToExcludeCount?: number | null, salesPointGroup?: { __typename?: 'SalespointsGroup', id: string, name?: string | null } | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, salesPointToExclude?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | null, analyze?: { __typename?: 'PostMetrics', engagementRate: number, totalReactions: number, shares: number, comments: number, engagement: number, reach: number, insightPaid?: number | null, insightUnpaid?: number | null, likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null } | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, videoThumbnail?: string | null, caption?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null, totalStatus?: { __typename?: 'PostTotalStatus', posted: number, error: number, other: number } | null, groupErrors?: Array<{ __typename?: 'PostErrors', count?: number | null, error?: string | null } | null> | null } | null> | null } | null };

export type DeleteSocialPostMutationVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type DeleteSocialPostMutation = { __typename?: 'Mutation', deleteSocialPost?: boolean | null };

export type ExportPostCalendarPostsQueryVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type ExportPostCalendarPostsQuery = { __typename?: 'Query', exportPostCalendarPosts: { __typename?: 'ExportSocialLinks', mediaLink: string } };

export type PostsDetailsListItemPublishFragment = { __typename?: 'SocialMediaPost', status?: PostStatus | null, socialNetworkTarget: SocialNetwork, scheduledAt?: any | null, type?: PostType | null, socialNetworkPostUrl?: string | null, analyze?: { __typename?: 'PostMetrics', totalReactions: number, comments: number, shares: number, engagement: number, engagementRate: number, reach: number, insightUnpaid?: number | null, insightPaid?: number | null, likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null } | null, salesPointTargeted?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null };

export type GetPostCalendarPostsQueryVariables = Exact<{
  publishId: Scalars['ID'];
  sort?: InputMaybe<PublishListSortArgs>;
}>;


export type GetPostCalendarPostsQuery = { __typename?: 'Query', getPostCalendarPosts: { __typename?: 'PublishPostsPayload', success?: boolean | null, data?: Array<{ __typename?: 'SocialMediaPost', id: string, errorMessage?: string | null, status?: PostStatus | null, socialNetworkTarget: SocialNetwork, scheduledAt?: any | null, type?: PostType | null, socialNetworkPostUrl?: string | null, analyze?: { __typename?: 'PostMetrics', totalReactions: number, comments: number, shares: number, engagement: number, engagementRate: number, reach: number, insightUnpaid?: number | null, insightPaid?: number | null, likes?: number | null, love?: number | null, care?: number | null, haha?: number | null, wow?: number | null, sorry?: number | null, anger?: number | null } | null, salesPointTargeted?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | null> | null } };

export type GetSocialTotalGraphStatsQueryVariables = Exact<{
  args: AnalyzeQueryArgs;
}>;


export type GetSocialTotalGraphStatsQuery = { __typename?: 'Query', getSocialTotalGraphStats: { __typename?: 'AnalyzeTotalStats', fansAdded?: number | null, reach: number, engagement: number } };

export type GetSocialCityStatsQueryVariables = Exact<{
  args: AnalyzeQueryArgs;
}>;


export type GetSocialCityStatsQuery = { __typename?: 'Query', getSocialCityStats: Array<{ __typename?: 'AnalyzeSocialCityStats', name: string, fans: number, popularityPercent: number }> };

export type GetSocialComparisonStatsQueryVariables = Exact<{
  args: AnalyzeQueryArgs;
}>;


export type GetSocialComparisonStatsQuery = { __typename?: 'Query', getSocialComparisonStats: { __typename?: 'AnalyzeComparisonStats', fans: { __typename?: 'AnalyzeComparisonStat', national: number, salesPoint: number }, reach: { __typename?: 'AnalyzeComparisonStat', national: number, salesPoint: number }, engagement: { __typename?: 'AnalyzeComparisonStat', national: number, salesPoint: number } } };

export type GetSocialPerformanceStatsQueryVariables = Exact<{
  args: AnalyzeQueryArgs;
}>;


export type GetSocialPerformanceStatsQuery = { __typename?: 'Query', getSocialPerformanceStats: Array<{ __typename?: 'AnalyzeMonthlyStats', date: any, stats: { __typename?: 'AnalyzeTotalStats', fans: number, reach: number, engagement: number } }> };

export type GetSocialDemographicStatsQueryVariables = Exact<{
  args: AnalyzeQueryArgs;
}>;


export type GetSocialDemographicStatsQuery = { __typename?: 'Query', getSocialDemographicStats: { __typename?: 'AnalyzeSocialDemographicStats', gender: Array<{ __typename?: 'AnalyzeStat', key: string, total: number }>, age: Array<{ __typename?: 'AnalyzeStat', key: string, total: number }>, locale: Array<{ __typename?: 'AnalyzeStat', key: string, total: number }> } };

export type ExportSocialSalesPointStatsListQueryVariables = Exact<{
  args: AnalyzeSalesPointStatsListQueryArgs;
  orderBy?: InputMaybe<AnalyzeSalesPointStatsListQueryOrderBy>;
  direction?: InputMaybe<Direction>;
}>;


export type ExportSocialSalesPointStatsListQuery = { __typename?: 'Query', exportSocialSalesPointStatsList: { __typename?: 'ExportSocialLinks', mediaLink: string } };

export type QueryQueryVariables = Exact<{
  args: AnalyzeSalesPointStatsListQueryArgs;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AnalyzeSalesPointStatsListQueryOrderBy>;
  direction?: InputMaybe<Direction>;
}>;


export type QueryQuery = { __typename?: 'Query', getSocialSalesPointStatsList: { __typename?: 'AnalyzeSalesPointStatsList', success: boolean, pageInfos: { __typename?: 'PageInfos', page?: number | null, totalResult?: number | null, totalPage?: number | null }, data: Array<{ __typename?: 'AnalyzeSalesPointStatsListData', id: string, url: string, fans: number, fansLost: number, fansAdded: number, engagement: number, reach: number, posts: number, followers: number, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null }> } };

export type GetSocialTotalListStatsQueryVariables = Exact<{
  args: AnalyzeQueryArgs;
}>;


export type GetSocialTotalListStatsQuery = { __typename?: 'Query', getSocialTotalListStats: { __typename?: 'AnalyzeTotalStats', fans: number, fansLost?: number | null, fansAdded?: number | null, reach: number, engagement: number, posts?: number | null, followers: number } };

export type CampaignMetricsQueryVariables = Exact<{
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignId?: InputMaybe<Scalars['ID']>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  campaignType: CampaignType;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
}>;


export type CampaignMetricsQuery = { __typename?: 'Query', campaignMetrics?: { __typename?: 'CampaignMetrics', pageViews?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, pageViewsPerDay?: Array<{ __typename?: 'InfoPerDay', date?: any | null, count?: number | null } | null> | null, downloadsPerDay?: Array<{ __typename?: 'CampaignDownloadPerDay', date?: any | null, fileDownload?: number | null, supportDownload?: number | null } | null> | null, campaignDownloadDetails?: { __typename?: 'CampaignDownloadDetailsPagination', count?: number | null, campaignDownloadDetails?: Array<{ __typename?: 'CampaignDownloadDetails', fileName?: string | null, campaignName?: string | null, downloads?: number | null, copies?: number | null } | null> | null } | null, downloads?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null } | null };

export type KpiAndGraphQueryQueryVariables = Exact<{
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  tableParams?: InputMaybe<TableParams>;
}>;


export type KpiAndGraphQueryQuery = { __typename?: 'Query', downloadMetrics?: { __typename?: 'DownloadMetrics', downloads?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, copiedLinks?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, downloadsPerDay?: Array<{ __typename?: 'DownloadsPerDay', date?: any | null, downloads?: number | null } | null> | null } | null };

export type DownloadTableQueryQueryVariables = Exact<{
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  tableParams?: InputMaybe<TableParams>;
}>;


export type DownloadTableQueryQuery = { __typename?: 'Query', downloadMetrics?: { __typename?: 'DownloadMetrics', downloadDetails?: { __typename?: 'DownloadDetailsPagination', count?: number | null, downloadDetails?: Array<{ __typename?: 'DownloadDetails', id?: string | null, name?: string | null, format?: string | null, downloads?: number | null } | null> | null } | null } | null };

export type MongoDbMetricsQueryVariables = Exact<{
  filter?: InputMaybe<PlatformMetricsFilter>;
}>;


export type MongoDbMetricsQuery = { __typename?: 'Query', platformGraphMetrics?: { __typename?: 'PlatformGraphMetrics', total?: { __typename?: 'PlatformGraphTotalMetrics', login?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, downloads?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, postsPublished?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, ordersPassed?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, turnover?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null } | null, metrics?: { __typename?: 'PlatformGraphElementMetrics', login?: Array<{ __typename?: 'SimpleMetricReturn', type?: string | null, count?: number | null, variationPercentage?: number | null } | null> | null, posts?: Array<{ __typename?: 'SimpleMetricReturn', type?: string | null, count?: number | null, variationPercentage?: number | null } | null> | null, postSources?: Array<{ __typename?: 'SimpleMetricReturn', type?: string | null, count?: number | null, variationPercentage?: number | null } | null> | null } | null, lineGraphMetrics?: Array<{ __typename?: 'PlatformLineGraphMetric', date?: any | null, login?: number | null, downloads?: number | null, postsPublished?: number | null, ordersPassed?: number | null, turnover?: number | null } | null> | null } | null };

export type ExportEngagementMetricsMutationVariables = Exact<{
  filter?: InputMaybe<PlatformMetricsFilter>;
  groupBy: ExportEngagementType;
}>;


export type ExportEngagementMetricsMutation = { __typename?: 'Mutation', exportEngagementMetrics?: string | null };

export type PlatformListMetricsBySalespointQueryVariables = Exact<{
  filter?: InputMaybe<PlatformMetricsFilter>;
  sort?: InputMaybe<PlatformListMetricsSort>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PlatformListMetricsBySalespointQuery = { __typename?: 'Query', platformListMetricsBySalesPoint?: { __typename?: 'PlatformListMetricsBySalespoint', userTotal?: number | null, totalResult?: number | null, total?: { __typename?: 'PlatformListTotalMetrics', login?: number | null, paps?: number | null, downloads?: number | null, orders?: number | null, loginDevices?: { __typename?: 'PlatformListDeviceMetric', web?: number | null, app?: number | null } | null, posts?: { __typename?: 'PlatformListDeviceMetric', web?: number | null, app?: number | null } | null, plannifications?: { __typename?: 'PlatformListPostMetric', planned?: number | null, immediate?: number | null } | null } | null, metrics?: Array<{ __typename?: 'PlatformListLineMetricBySalesPoint', usersCount?: number | null, salespoint?: string | null, login?: number | null, paps?: number | null, downloads?: number | null, orders?: number | null, loginDevices?: { __typename?: 'PlatformListDeviceMetric', web?: number | null, app?: number | null } | null, posts?: { __typename?: 'PlatformListDeviceMetric', web?: number | null, app?: number | null } | null }> | null } | null };

export type PlatformListMetricsByUserQueryVariables = Exact<{
  filter?: InputMaybe<PlatformMetricsFilter>;
  sort?: InputMaybe<PlatformListMetricsSort>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PlatformListMetricsByUserQuery = { __typename?: 'Query', platformListMetricsByUser?: { __typename?: 'PlatformListMetricsByUser', totalResult?: number | null, total?: { __typename?: 'PlatformListTotalMetrics', login?: number | null, paps?: number | null, downloads?: number | null, orders?: number | null, loginDevices?: { __typename?: 'PlatformListDeviceMetric', web?: number | null, app?: number | null } | null, posts?: { __typename?: 'PlatformListDeviceMetric', web?: number | null, app?: number | null } | null, plannifications?: { __typename?: 'PlatformListPostMetric', planned?: number | null, immediate?: number | null } | null } | null, metrics?: Array<{ __typename?: 'PlatformListLineMetricByUser', user?: string | null, userRole?: string | null, salesPointsCount?: number | null, login?: number | null, paps?: number | null, downloads?: number | null, orders?: number | null, plannifications?: { __typename?: 'PlatformListPostMetric', planned?: number | null, immediate?: number | null } | null, loginDevices?: { __typename?: 'PlatformListDeviceMetric', web?: number | null, app?: number | null } | null, posts?: { __typename?: 'PlatformListDeviceMetric', web?: number | null, app?: number | null } | null } | null> | null } | null };

export type GetSalesPointsGroupsQueryVariables = Exact<{
  filter?: InputMaybe<SalesPointFilter>;
}>;


export type GetSalesPointsGroupsQuery = { __typename?: 'Query', salesPointsGroups?: Array<{ __typename?: 'SalespointsGroup', id: string, name?: string | null } | null> | null };

export type SalesPointsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SalesPointFilter>;
  sort?: InputMaybe<SalesPointSort>;
}>;


export type SalesPointsQuery = { __typename?: 'Query', salesPoints?: { __typename?: 'SalesPointPagination', count?: number | null, enabledSalesPointsCount?: number | null, salesPoints?: Array<{ __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null> | null } | null };

export type MediaAndProductMetricsQueryVariables = Exact<{
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type MediaAndProductMetricsQuery = { __typename?: 'Query', mediaAndProductMetrics?: { __typename?: 'MediaAndProductMetrics', downloadedMedias?: { __typename?: 'TagMetrics', variationPercentage?: number | null, count?: number | null, payloads?: Array<{ __typename?: 'TagPayload', itemId?: string | null, name?: string | null, type?: string | null, nbrEvent?: number | null } | null> | null } | null, copiedMediaLink?: { __typename?: 'TagMetrics', count?: number | null, variationPercentage?: number | null } | null, nbrActivatedMedias?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null } | null };

export type CampaignQueryVariables = Exact<{
  paidMediaCampaignId: Scalars['ID'];
  networks?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CampaignQuery = { __typename?: 'Query', getPaidMediaCampaignDetails?: { __typename?: 'PaidMediaCampaignMetaDetail', id: string, campaignName: string, campaignType?: string | null, startDate?: any | null, endDate?: any | null, currency: string, networks?: Array<string | null> | null, status: PaidMediaCampaignStatus, cost: number, spend: number, impressions: number, reach: number, engagement: number, clicks: number, cpc: number, cpm?: number | null, purchase?: number | null, total_purchase: number, avg_purchase?: number | null, margin?: number | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null, distribution?: { __typename?: 'PaidMediaCampaignDistribution', spend?: Array<{ __typename?: 'PaidMediaCampaignDistributionTuple', socialNetwork: string, value: number } | null> | null, impressions?: Array<{ __typename?: 'PaidMediaCampaignDistributionTuple', socialNetwork: string, value: number } | null> | null, reach?: Array<{ __typename?: 'PaidMediaCampaignDistributionTuple', socialNetwork: string, value: number } | null> | null, engagement?: Array<{ __typename?: 'PaidMediaCampaignDistributionTuple', socialNetwork: string, value: number } | null> | null } | null } | null };

export type CampaignsListQueryVariables = Exact<{
  salesPointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filters?: InputMaybe<FilterPaidMedia>;
}>;


export type CampaignsListQuery = { __typename?: 'Query', getPaidMediaCampaignList: Array<{ __typename?: 'PaidMediaCampaignLite', id: string, salesPointId: string, orderId: string, campaignName: string, campaignType?: string | null, startDate?: any | null, endDate?: any | null, interfaceSlug: string, cost: number, currency: string, status: PaidMediaCampaignStatus, networks?: Array<string | null> | null, salesPoint?: { __typename?: 'SalesPoint', id?: string | null, name?: string | null } | null } | null> };

export type DailyStatsQueryVariables = Exact<{
  paidMediaCampaignId: Scalars['ID'];
  networks?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type DailyStatsQuery = { __typename?: 'Query', getPaidMediaCampaignDailyInsight?: Array<{ __typename?: 'PaidMediaCampaignMetaDailyStat', date: any, impressions: number, reach: number, engagement: number, clicks?: number | null } | null> | null };

export type GooglePmhMetricsQueryVariables = Exact<{
  filter?: InputMaybe<GooglePmMetricsFilter>;
}>;


export type GooglePmhMetricsQuery = { __typename?: 'Query', googlePmMetrics?: { __typename?: 'GooglePmMetrics', metrics?: { __typename?: 'GoogleMetricsFields', WEBSITE_CLICKS?: number | null, BUSINESS_BOOKINGS?: number | null, BUSINESS_FOOD_ORDERS?: number | null, BUSINESS_FOOD_MENU_CLICKS?: number | null, BUSINESS_IMPRESSIONS_DESKTOP_SEARCH?: number | null, BUSINESS_IMPRESSIONS_DESKTOP_MAPS?: number | null, BUSINESS_IMPRESSIONS_MOBILE_MAPS?: number | null, BUSINESS_IMPRESSIONS_MOBILE_SEARCH?: number | null, BUSINESS_CONVERSATIONS?: number | null, BUSINESS_DIRECTION_REQUESTS?: number | null, CALL_CLICKS?: number | null, CLICKS_PREV?: number | null, SEARCH_PREV?: number | null, GRAPH?: any | null, REVIEWS?: { __typename?: 'GoogleAverageMetrics', AVERAGE?: number | null, ONE?: number | null, TWO?: number | null, THREE?: number | null, FOUR?: number | null, FIVE?: number | null, HAS_REPLY?: number | null, TOTAL?: number | null, TOTAL_PERIOD?: number | null, TOTAL_PREV?: number | null } | null, PM?: { __typename?: 'PmMetrics', sync?: number | null, need?: number | null, no_sync?: number | null, no?: number | null } | null } | null } | null };

export type UberallGraphMetricsQueryVariables = Exact<{
  filter?: InputMaybe<UberallMetricsFilter>;
}>;


export type UberallGraphMetricsQuery = { __typename?: 'Query', uberallGraphMetrics?: { __typename?: 'UberallGraphMetrics', total?: { __typename?: 'UberallGraphTotalMetrics', search?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, views?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, clicks?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null } | null, metrics?: { __typename?: 'UberallGraphMetricsFields', search?: { __typename?: 'UberallGraphSearchMetrics', direct?: number | null, indirect?: number | null } | null, views?: { __typename?: 'UberallGraphViewsMetrics', maps?: Array<{ __typename?: 'InfoPerDay', date?: any | null, count?: number | null }> | null, search?: Array<{ __typename?: 'InfoPerDay', date?: any | null, count?: number | null }> | null } | null, clicks?: { __typename?: 'UberallGraphClicksMetrics', website?: Array<{ __typename?: 'InfoPerDay', date?: any | null, count?: number | null }> | null, driving_direction?: Array<{ __typename?: 'InfoPerDay', date?: any | null, count?: number | null }> | null, phone?: Array<{ __typename?: 'InfoPerDay', date?: any | null, count?: number | null }> | null } | null } | null } | null };

export type ProductMetricsQueryVariables = Exact<{
  productId: Scalars['ID'];
}>;


export type ProductMetricsQuery = { __typename?: 'Query', productMetrics?: { __typename?: 'ProductMetrics', salespointCounts?: { __typename?: 'SalespointCounts', downloads?: number | null, orders?: number | null, actions?: number | null, totalSalespoints?: number | null } | null } | null };

export type ProductMetricsSalespointCountsQueryVariables = Exact<{
  productId: Scalars['ID'];
}>;


export type ProductMetricsSalespointCountsQuery = { __typename?: 'Query', productMetricsSalespointCounts?: { __typename?: 'productMetricsSalespointCountsOutput', salespointCounts?: { __typename?: 'SalespointCounts', downloads?: number | null, orders?: number | null, actions?: number | null, totalSalespoints?: number | null } | null } | null };

export type ProductMetricsSalespointDetailsQueryVariables = Exact<{
  productId: Scalars['ID'];
  tableParams?: InputMaybe<TableParams>;
}>;


export type ProductMetricsSalespointDetailsQuery = { __typename?: 'Query', productMetricsSalespointDetails?: { __typename?: 'productMetricsSalespointDetailsOutput', salespointDetails?: { __typename?: 'SalespointDetailsPagination', count?: number | null, salespointDetails?: Array<{ __typename?: 'SalespointDetails', name?: string | null, downloads?: number | null, orders?: number | null, actions?: number | null } | null> | null } | null } | null };

export type TableMetricsQueryVariables = Exact<{
  productId: Scalars['ID'];
  tableParams?: InputMaybe<TableParams>;
}>;


export type TableMetricsQuery = { __typename?: 'Query', productMetrics?: { __typename?: 'ProductMetrics', salespointDetails?: { __typename?: 'SalespointDetailsPagination', count?: number | null, salespointDetails?: Array<{ __typename?: 'SalespointDetails', name?: string | null, downloads?: number | null, orders?: number | null, actions?: number | null } | null> | null } | null } | null };

export type MarketPlaceMetricsQueryVariables = Exact<{
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  additionalParams?: InputMaybe<OrderMetricsParams>;
}>;


export type MarketPlaceMetricsQuery = { __typename?: 'Query', orderMetrics?: { __typename?: 'OrderMetrics', orders?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, turnover?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, avgTurnoverPerOrder?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, avgOrdersPerUser?: { __typename?: 'SimpleMetricReturn', count?: number | null, variationPercentage?: number | null } | null, turnoverAndOrdersPerDay?: Array<{ __typename?: 'TurnoverAndOrdersPerDay', date?: any | null, turnover?: number | null, orders?: number | null } | null> | null, productDetails?: { __typename?: 'ProductDetailsPagination', count?: number | null, productDetails?: Array<{ __typename?: 'ProductDetails', productId?: string | null, name?: string | null, reference?: string | null, type?: string | null, downloads?: number | null, orders?: number | null, packsQuantity?: number | null } | null> | null } | null } | null };

export type PackOrderMetricsQueryVariables = Exact<{
  dateRange: DateRange;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  salespointsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salespointGroupsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  additionalParams?: InputMaybe<OrderMetricsParams>;
}>;


export type PackOrderMetricsQuery = { __typename?: 'Query', packOrderMetrics?: { __typename?: 'PackOrderMetrics', packDetails?: { __typename?: 'PackOrderDetails', count?: number | null, packDetails?: Array<{ __typename?: 'PackDetail', packId: string, name?: string | null, reference?: string | null, productsInPackCount?: number | null, quantityOfProductOrdered?: number | null, turnoverOfProductOrdered?: number | null } | null> | null } | null } | null };

export type ExportMetricsArrayMutationVariables = Exact<{
  dateRange?: InputMaybe<DateRange>;
  exportType: ExportTypes;
  exportArgsJSON?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<UploadFormat>;
}>;


export type ExportMetricsArrayMutation = { __typename?: 'Mutation', exportMetricsArray?: string | null };

export type DownloadAnswerTemplatesFileQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadAnswerTemplatesFileQuery = { __typename?: 'Query', downloadAnswerTemplatesFile?: string | null };

export type UploadAnswerTemplatesMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadAnswerTemplatesMutation = { __typename?: 'Mutation', uploadAnswerTemplates?: boolean | null };

export type ConsolidatePostMutationVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type ConsolidatePostMutation = { __typename?: 'Mutation', consolidatePost: boolean };

export type GetAmplifyCampaignDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAmplifyCampaignDetailsQuery = { __typename?: 'Query', getAmplifyCampaignDetails?: { __typename?: 'AmplifyCampaign', id?: string | null, name?: string | null, authorRole?: SocialAuthorRole | null, geoRadius?: number | null, status?: AmplifyAdCampaignStatus | null, adsCount?: number | null, totalBudget?: number | null, perPostBudget?: number | null, spentBudget?: number | null, spentReach?: number | null, spentInteraction?: number | null, cpi?: number | null, connection?: AmplifyCampaignConnectionTypes | null, isDefaultChalandiseZone?: boolean | null, startAt?: any | null, endAt?: any | null, sexOfTarget?: string | null, minAgeTarget?: number | null, maxAgeTarget?: number | null, optimizationGoal?: AmplifyCampaignGoalStrategy | null, target?: { __typename?: 'AmplifyCampaignTargeting', type?: TargetType | null, onGlobals?: boolean | null, salesPoints?: Array<{ __typename?: 'SalesPoint', name?: string | null } | null> | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, post?: { __typename?: 'SocialMediaPost', id: string, type?: PostType | null, socialNetworkTarget: SocialNetwork, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, videoThumbnail?: string | null, caption?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null, target?: { __typename?: 'PostTarget', type?: TargetType | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null, role?: { __typename?: 'Role', id?: string | null, name?: string | null } | null } | null } | null, totalStatus?: { __typename?: 'AmplifyCampaignTotalStatus', done?: number | null, error?: number | null, terminated?: number | null } | null, targetingInterests?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, targetingCountries?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null, targetingGeolocations?: Array<{ __typename?: 'OrganicTargetingObject', facebookKey?: string | null, name?: string | null } | null> | null } | null };

export type GetPostCalendarDetailsForAdminQueryVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type GetPostCalendarDetailsForAdminQuery = { __typename?: 'Query', getPostCalendarDetails?: { __typename?: 'SocialMediaPost', id: string, createdAt?: any | null, scheduledAt?: any | null, type?: PostType | null, totalPosts?: number | null, authorRole?: SocialAuthorRole | null, socialNetworkTarget: SocialNetwork, socialNetworkAccountUrl?: string | null, socialNetworkPostUrl?: string | null, status?: PostStatus | null, description?: string | null, textDescription?: string | null, htmlDescription?: string | null, link?: string | null, callToAction?: number | null, rawDescription?: string | null, target?: { __typename?: 'PostTarget', type?: TargetType | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, avatar?: { __typename?: 'PublishMedia', path?: string | null } | null, medias?: Array<{ __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null> | null, thumb?: { __typename?: 'PublishMedia', path?: string | null, mimeType?: string | null } | null, event?: { __typename?: 'SocialEvent', title?: string | null, startAt?: any | null, endAt?: any | null, callToAction?: number | null, terms?: string | null, couponCode?: string | null } | null, cover?: { __typename?: 'PublishMedia', path?: string | null } | null, carouselItems?: Array<{ __typename?: 'PostCarouselItem', link?: string | null, title?: string | null, description?: string | null, callToAction?: number | null, media?: { __typename?: 'PublishMedia', path?: string | null } | null }> | null, preview?: { __typename?: 'SocialMediaPostPreview', type?: SocialMediaPostPreviewType | null, content?: string | null, caption?: string | null, videoThumbnail?: string | null, targettedNetworks?: Array<SocialNetwork | null> | null, promoCode?: string | null, dates?: { __typename?: 'StartAndEndDates', start?: any | null, end?: any | null } | null } | null } | null };

export type GetPostCalendarPostsForAdminQueryVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type GetPostCalendarPostsForAdminQuery = { __typename?: 'Query', getPostCalendarPosts: { __typename?: 'PublishPostsPayload', success?: boolean | null, data?: Array<{ __typename?: 'SocialMediaPost', id: string, socialNetworkTarget: SocialNetwork, status?: PostStatus | null, errorStatus?: string | null, errorMessage?: string | null, socialNetworkAccountUrl?: string | null, socialNetworkPostUrl?: string | null, socialNetworkPage?: { __typename?: 'AccountPage', id?: string | null, url?: string | null, name?: string | null } | null, salesPointTargeted?: { __typename?: 'SalesPoint', name?: string | null, id?: string | null } | null } | null> | null } };

export type MarkAllErrorPostsAsDoneMutationVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type MarkAllErrorPostsAsDoneMutation = { __typename?: 'Mutation', markAllErrorPostsAsDone: boolean };

export type MarkErrorPostsAsDoneMutationVariables = Exact<{
  publishId: Scalars['ID'];
  postIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkErrorPostsAsDoneMutation = { __typename?: 'Mutation', markErrorPostsAsDone: boolean };

export type ResetCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResetCampaignMutation = { __typename?: 'Mutation', resetCampaign: boolean };

export type ResetErrorPostsMutationVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type ResetErrorPostsMutation = { __typename?: 'Mutation', resetErrorPosts: boolean };

export type StopPostsMutationVariables = Exact<{
  publishId: Scalars['ID'];
}>;


export type StopPostsMutation = { __typename?: 'Mutation', stopPosts: boolean };

export type DeletePastSpecialOpeningHoursMutationVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']>;
}>;


export type DeletePastSpecialOpeningHoursMutation = { __typename?: 'Mutation', deletePastSpecialOpeningHours?: boolean | null };

export type ResetSalesPointMutationVariables = Exact<{
  args: ResetSalesPointArgs;
}>;


export type ResetSalesPointMutation = { __typename?: 'Mutation', resetSalesPoint?: { __typename?: 'ResetSalesPointPayload', success: boolean } | null };

export type AddNewsMutationVariables = Exact<{
  news: NewsInput;
  image?: InputMaybe<Scalars['Upload']>;
}>;


export type AddNewsMutation = { __typename?: 'Mutation', addNews?: { __typename?: 'News', id: string } | null };

export type UpdateNewsMutationVariables = Exact<{
  id: Scalars['ID'];
  news: NewsInput;
  newImage?: InputMaybe<Scalars['Upload']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateNewsMutation = { __typename?: 'Mutation', updateNews?: { __typename?: 'News', id: string, contents: Array<{ __typename?: 'NewsContent', lang: AvailableLangs, title: string }> } | null };

export type NewsListScreen_GetNewsListQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsListScreen_GetNewsListQuery = { __typename?: 'Query', getNewsList?: Array<{ __typename?: 'News', id: string, contents: Array<{ __typename?: 'NewsContent', lang: AvailableLangs, title: string }> } | null> | null };

export type GetAllClientsOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClientsOrganizationQuery = { __typename?: 'Query', getAllClients?: Array<{ __typename?: 'Client', id: string, name?: string | null, clientId?: string | null } | null> | null };

export type CreateOrganizationMutationVariables = Exact<{
  client: ClientInfo;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createClient?: { __typename?: 'Client', id: string, name?: string | null, clientId?: string | null, features?: Array<{ __typename?: 'Feature', name?: Features | null, enabled?: boolean | null } | null> | null } | null };

export type ExportBriefSpecClientsMutationVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type ExportBriefSpecClientsMutation = { __typename?: 'Mutation', exportBriefSpecClients?: string | null };

export type ImportBriefTechnicalSpecificationsMutationVariables = Exact<{
  file: Scalars['Upload'];
  clientId: Scalars['String'];
}>;


export type ImportBriefTechnicalSpecificationsMutation = { __typename?: 'Mutation', importBriefTechnicalSpecifications?: boolean | null };

export type SyncVirtualUserAccountsMutationVariables = Exact<{
  clientId: Scalars['String'];
}>;


export type SyncVirtualUserAccountsMutation = { __typename?: 'Mutation', syncVirtualUserAccounts?: boolean | null };

export type SynchroClientPmImagesMutationVariables = Exact<{
  slugClient: Scalars['String'];
}>;


export type SynchroClientPmImagesMutation = { __typename?: 'Mutation', synchroClientPmImages?: boolean | null };

export type UpdateClientPmServicesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateClientPmServicesMutation = { __typename?: 'Mutation', updateClientPmServices?: boolean | null };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
  client: ClientInfo;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateClient?: { __typename?: 'Client', id: string, name?: string | null, clientId?: string | null, homepageFeature?: Features | null, features?: Array<{ __typename?: 'Feature', name?: Features | null, enabled?: boolean | null } | null> | null, socialOptions?: { __typename?: 'SocialOptions', cronActivated?: boolean | null } | null } | null };

export type UpdateClientPmAttributesMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateClientPmAttributesMutation = { __typename?: 'Mutation', updateClientPmAttributes?: boolean | null };

export type GeneratePaidMediaCampaignsMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type GeneratePaidMediaCampaignsMutation = { __typename?: 'Mutation', generatePaidMediaCampaigns?: string | null };

export type ProviderListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderListQuery = { __typename?: 'Query', providers?: Array<{ __typename?: 'Provider', id: string, name: string, slug: string, usersCount?: number | null, enabled?: boolean | null } | null> | null };

export type AddProviderMutationVariables = Exact<{
  provider: ProviderInput;
}>;


export type AddProviderMutation = { __typename?: 'Mutation', addProvider?: { __typename?: 'Provider', id: string } | null };

export type UpdateProviderMutationVariables = Exact<{
  providerId: Scalars['ID'];
  providerToUpdate: ProviderUpdateInput;
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider?: { __typename?: 'Provider', id: string } | null };

export type LaunchSocialCronMutationVariables = Exact<{
  path: Scalars['String'];
}>;


export type LaunchSocialCronMutation = { __typename?: 'Mutation', launchSocialCron?: string | null };

export type WebhookConsolidateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WebhookConsolidateMutation = { __typename?: 'Mutation', webhookConsolidate?: boolean | null };

export type WebhookCreateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WebhookCreateMutation = { __typename?: 'Mutation', webhookCreate?: boolean | null };

export type GetPostsWebhookListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPostsWebhookListQuery = { __typename?: 'Query', getPostsWebhookList?: Array<{ __typename?: 'WebhookList', id?: string | null, socialNetworkPostId?: string | null, postCalendarId?: string | null, facebookPage?: string | null, webhookData?: { __typename?: 'WebhookData', author?: string | null, authorId?: string | null, message?: string | null, url?: string | null, postAt?: string | null, socialNetworkNotificationId?: string | null, socialNetworkAccountId?: string | null } | null } | null> | null };

export const OrderedCustomFieldFragmentFragmentDoc = gql`
    fragment OrderedCustomFieldFragment on OrderedCustomField {
  definition {
    id
    type
    label
    description
    textConfig {
      paragraph
      dynVar
    }
    numberConfig {
      precision
    }
    choiceConfig {
      displayType
      options
    }
    multipleChoiceConfig {
      displayType
      options
    }
    dateConfig {
      isDateTime
      timezone
    }
  }
  textValue
  numberValue
  choiceValue
  multipleChoiceValue
  dateValue
}
    `;
export const PostFragmentFragmentDoc = gql`
    fragment PostFragment on SocialMediaPost {
  id
  type
  description
  rawDescription
  htmlDescription
  scheduledAt
  validationDate
  validatorRole
  socialNetworkTarget
  isDraft
  status
  target {
    type
    globals
    onSalesPoints
    onGlobals
    targetToExclude
    salespointGroups {
      id
      name
      salespoints {
        social {
          linkedPages {
            facebook
            google
            instagram
          }
        }
      }
    }
    salesPoints {
      id
      name
      social {
        linkedPages {
          facebook
          google
          instagram
        }
      }
    }
  }
}
    `;
export const CampaignFragmentFragmentDoc = gql`
    fragment CampaignFragment on Campaign {
  id
  name
  isScheduled
  startDate
  endDate
  description
  hideOnPlanning
  isNew
  isLocal
  image {
    id
    thumbnail
    large
    medium
    small
    original
  }
  tags {
    id
    label
    color
  }
  hasProducts
  medias {
    id
  }
  salespoint {
    id
    name
  }
  userHasWritePermission
  categories {
    id
    name
    displayCampaignsCategory
  }
}
    `;
export const PostReactionDetailsPublishAnalyzeFragmentDoc = gql`
    fragment PostReactionDetailsPublishAnalyze on PostMetrics {
  likes
  love
  care
  haha
  wow
  sorry
  anger
}
    `;
export const PostPreviewPublishFragmentDoc = gql`
    fragment PostPreviewPublish on SocialMediaPost {
  type
  description
  textDescription
  htmlDescription
  link
  callToAction
  thumb {
    path
  }
  medias {
    path
    mimeType
  }
  cover {
    path
  }
  carouselItems {
    media {
      path
    }
    link
    title
    description
    callToAction
  }
  avatar {
    path
  }
  socialNetworkTarget
  rawDescription
  event {
    title
    startAt
    endAt
    callToAction
    terms
    couponCode
  }
  preview {
    type
    content
    caption
    videoThumbnail
    targettedNetworks
    dates {
      start
      end
    }
    promoCode
  }
}
    `;
export const PostDetailsPublishFragmentDoc = gql`
    fragment PostDetailsPublish on SocialMediaPost {
  socialNetworkPostId
  status
  totalPosts
  authorRole
  author {
    id
    fullName
  }
  validator {
    id
    fullName
  }
  validatorComment
  validationDate
  validatorRole
  scheduledAt
  adCount
  organicTargeting {
    sexTargeting
    sexOfTarget
    ageTargeting
    minAgeTarget
    maxAgeTarget
    targetingInterests {
      name
    }
    targetingCountries {
      name
    }
    targetingGeolocations {
      name
    }
  }
  target {
    type
    salespointGroups {
      id
      name
    }
    salesPoints {
      id
      name
    }
    onSalesPoints
    onGlobals
    targetToExclude
    salesPointToExclude {
      id
      name
    }
  }
  analyze {
    reach
    engagement
    comments
    shares
    totalReactions
    insightAdReach
    insightAdInteraction
    insightAdSpent
    ...PostReactionDetailsPublishAnalyze
  }
  isAmplifiable
  userCanValidatePost
  userCanViewPostCalendarDetails
  isEditable
  isDeletable
  isTemplatable
  isDuplicatable
  ...PostPreviewPublish
}
    ${PostReactionDetailsPublishAnalyzeFragmentDoc}
${PostPreviewPublishFragmentDoc}`;
export const PostStatusDetailsPublishTotalStatusFragmentDoc = gql`
    fragment PostStatusDetailsPublishTotalStatus on PostTotalStatus {
  posted
  error
  other
}
    `;
export const PostsListItemPostFragmentDoc = gql`
    fragment PostsListItemPost on PublishListPost {
  id
  postCalendarId
  type
  scheduledAt
  createdAt
  status
  totalPosts
  authorRole
  avatar {
    mimeType
    extension
    path
  }
  validator {
    id
    fullName
  }
  validationDate
  validatorRole
  authorRole
  validatorComment
  author {
    id
    fullName
  }
  textDescription
  description
  link
  salesPointTargeted {
    name
  }
  target {
    type
    salespointGroupsCount
    salesPointsCount
    salesPointGroup {
      id
      name
    }
    salesPoint {
      id
      name
    }
    onSalesPoints
    onGlobals
    salesPointsToExcludeCount
    salesPointToExclude {
      id
      name
    }
  }
  analyze {
    engagementRate
    totalReactions
    shares
    comments
    engagement
    reach
    insightPaid
    insightUnpaid
    ...PostReactionDetailsPublishAnalyze
  }
  socialNetworkPostUrl
  socialNetworkTarget
  preview {
    type
    content
    videoThumbnail
    caption
    targettedNetworks
    dates {
      start
      end
    }
    promoCode
  }
  totalStatus {
    ...PostStatusDetailsPublishTotalStatus
  }
  isAmplified
  isAmplifiable
  userCanValidatePost
  userCanViewPostCalendarDetails
  isEditable
  isDeletable
  isDuplicatable
  isTemplatable
  levelEditable
  errorMessage
  groupErrors {
    count
    error
  }
}
    ${PostReactionDetailsPublishAnalyzeFragmentDoc}
${PostStatusDetailsPublishTotalStatusFragmentDoc}`;
export const PostsDetailsListItemPublishFragmentDoc = gql`
    fragment PostsDetailsListItemPublish on SocialMediaPost {
  status
  socialNetworkTarget
  scheduledAt
  type
  socialNetworkPostUrl
  analyze {
    totalReactions
    comments
    shares
    engagement
    engagementRate
    reach
    insightUnpaid
    insightPaid
    ...PostReactionDetailsPublishAnalyze
  }
  salesPointTargeted {
    id
    name
  }
}
    ${PostReactionDetailsPublishAnalyzeFragmentDoc}`;
export const CreateAnswerTemplateDocument = gql`
    mutation CreateAnswerTemplate($answerTemplate: AnswerTemplateInput!) {
  createAnswerTemplate(answerTemplate: $answerTemplate) {
    id
    clientId
    name
    message
    rating
    enabled
    language
    types
    createdAt
    updatedAt
  }
}
    `;
export type CreateAnswerTemplateMutationFn = Apollo.MutationFunction<CreateAnswerTemplateMutation, CreateAnswerTemplateMutationVariables>;

/**
 * __useCreateAnswerTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAnswerTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerTemplateMutation, { data, loading, error }] = useCreateAnswerTemplateMutation({
 *   variables: {
 *      answerTemplate: // value for 'answerTemplate'
 *   },
 * });
 */
export function useCreateAnswerTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnswerTemplateMutation, CreateAnswerTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnswerTemplateMutation, CreateAnswerTemplateMutationVariables>(CreateAnswerTemplateDocument, options);
      }
export type CreateAnswerTemplateMutationHookResult = ReturnType<typeof useCreateAnswerTemplateMutation>;
export type CreateAnswerTemplateMutationResult = Apollo.MutationResult<CreateAnswerTemplateMutation>;
export type CreateAnswerTemplateMutationOptions = Apollo.BaseMutationOptions<CreateAnswerTemplateMutation, CreateAnswerTemplateMutationVariables>;
export const ToggleAnswerTemplateStatusDocument = gql`
    mutation toggleAnswerTemplateStatus($id: ID!) {
  toggleAnswerTemplateStatus(id: $id)
}
    `;
export type ToggleAnswerTemplateStatusMutationFn = Apollo.MutationFunction<ToggleAnswerTemplateStatusMutation, ToggleAnswerTemplateStatusMutationVariables>;

/**
 * __useToggleAnswerTemplateStatusMutation__
 *
 * To run a mutation, you first call `useToggleAnswerTemplateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAnswerTemplateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAnswerTemplateStatusMutation, { data, loading, error }] = useToggleAnswerTemplateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleAnswerTemplateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAnswerTemplateStatusMutation, ToggleAnswerTemplateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleAnswerTemplateStatusMutation, ToggleAnswerTemplateStatusMutationVariables>(ToggleAnswerTemplateStatusDocument, options);
      }
export type ToggleAnswerTemplateStatusMutationHookResult = ReturnType<typeof useToggleAnswerTemplateStatusMutation>;
export type ToggleAnswerTemplateStatusMutationResult = Apollo.MutationResult<ToggleAnswerTemplateStatusMutation>;
export type ToggleAnswerTemplateStatusMutationOptions = Apollo.BaseMutationOptions<ToggleAnswerTemplateStatusMutation, ToggleAnswerTemplateStatusMutationVariables>;
export const UpdateAnswerTemplateDocument = gql`
    mutation updateAnswerTemplate($id: ID!, $updates: AnswerTemplateUpdateInput!) {
  updateAnswerTemplate(id: $id, updates: $updates) {
    name
    message
    rating
    enabled
    language
    types
  }
}
    `;
export type UpdateAnswerTemplateMutationFn = Apollo.MutationFunction<UpdateAnswerTemplateMutation, UpdateAnswerTemplateMutationVariables>;

/**
 * __useUpdateAnswerTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerTemplateMutation, { data, loading, error }] = useUpdateAnswerTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAnswerTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnswerTemplateMutation, UpdateAnswerTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnswerTemplateMutation, UpdateAnswerTemplateMutationVariables>(UpdateAnswerTemplateDocument, options);
      }
export type UpdateAnswerTemplateMutationHookResult = ReturnType<typeof useUpdateAnswerTemplateMutation>;
export type UpdateAnswerTemplateMutationResult = Apollo.MutationResult<UpdateAnswerTemplateMutation>;
export type UpdateAnswerTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateAnswerTemplateMutation, UpdateAnswerTemplateMutationVariables>;
export const GetAnswerTemplateDocument = gql`
    query getAnswerTemplate($id: ID!) {
  getAnswerTemplate(id: $id) {
    id
    clientId
    name
    message
    rating
    enabled
    language
    types
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAnswerTemplateQuery__
 *
 * To run a query within a React component, call `useGetAnswerTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswerTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswerTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnswerTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetAnswerTemplateQuery, GetAnswerTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswerTemplateQuery, GetAnswerTemplateQueryVariables>(GetAnswerTemplateDocument, options);
      }
export function useGetAnswerTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswerTemplateQuery, GetAnswerTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswerTemplateQuery, GetAnswerTemplateQueryVariables>(GetAnswerTemplateDocument, options);
        }
export type GetAnswerTemplateQueryHookResult = ReturnType<typeof useGetAnswerTemplateQuery>;
export type GetAnswerTemplateLazyQueryHookResult = ReturnType<typeof useGetAnswerTemplateLazyQuery>;
export type GetAnswerTemplateQueryResult = Apollo.QueryResult<GetAnswerTemplateQuery, GetAnswerTemplateQueryVariables>;
export const GetAnswerTemplatesDocument = gql`
    query getAnswerTemplates($params: AnswerTemplateListInputParams!) {
  getAnswerTemplates(params: $params) {
    count
    answerTemplates {
      id
      clientId
      name
      message
      rating
      enabled
      language
      types
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetAnswerTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAnswerTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswerTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswerTemplatesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetAnswerTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetAnswerTemplatesQuery, GetAnswerTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswerTemplatesQuery, GetAnswerTemplatesQueryVariables>(GetAnswerTemplatesDocument, options);
      }
export function useGetAnswerTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswerTemplatesQuery, GetAnswerTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswerTemplatesQuery, GetAnswerTemplatesQueryVariables>(GetAnswerTemplatesDocument, options);
        }
export type GetAnswerTemplatesQueryHookResult = ReturnType<typeof useGetAnswerTemplatesQuery>;
export type GetAnswerTemplatesLazyQueryHookResult = ReturnType<typeof useGetAnswerTemplatesLazyQuery>;
export type GetAnswerTemplatesQueryResult = Apollo.QueryResult<GetAnswerTemplatesQuery, GetAnswerTemplatesQueryVariables>;
export const CreateCustomFieldDefinitionDocument = gql`
    mutation createCustomFieldDefinition($input: CreateCustomFieldDefinitionInput!) {
  createCustomFieldDefinition(input: $input) {
    id
  }
}
    `;
export type CreateCustomFieldDefinitionMutationFn = Apollo.MutationFunction<CreateCustomFieldDefinitionMutation, CreateCustomFieldDefinitionMutationVariables>;

/**
 * __useCreateCustomFieldDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateCustomFieldDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFieldDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFieldDefinitionMutation, { data, loading, error }] = useCreateCustomFieldDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomFieldDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomFieldDefinitionMutation, CreateCustomFieldDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomFieldDefinitionMutation, CreateCustomFieldDefinitionMutationVariables>(CreateCustomFieldDefinitionDocument, options);
      }
export type CreateCustomFieldDefinitionMutationHookResult = ReturnType<typeof useCreateCustomFieldDefinitionMutation>;
export type CreateCustomFieldDefinitionMutationResult = Apollo.MutationResult<CreateCustomFieldDefinitionMutation>;
export type CreateCustomFieldDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateCustomFieldDefinitionMutation, CreateCustomFieldDefinitionMutationVariables>;
export const UpdateCustomFieldDocument = gql`
    mutation updateCustomField($id: ID!, $input: UpdateCustomFieldDefinitionInput!) {
  updateCustomFieldDefinition(id: $id, input: $input) {
    id
    assetType
    type
    clientId
    slug
    label
    visible
    description
    updatedAt
    isDisplayedInExport
    updatedBy {
      fullName
    }
    textConfig {
      paragraph
      dynVar
    }
    numberConfig {
      precision
    }
    choiceConfig {
      displayType
      options
    }
    multipleChoiceConfig {
      displayType
      options
    }
    dateConfig {
      isDateTime
      timezone
    }
  }
}
    `;
export type UpdateCustomFieldMutationFn = Apollo.MutationFunction<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>;

/**
 * __useUpdateCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFieldMutation, { data, loading, error }] = useUpdateCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>(UpdateCustomFieldDocument, options);
      }
export type UpdateCustomFieldMutationHookResult = ReturnType<typeof useUpdateCustomFieldMutation>;
export type UpdateCustomFieldMutationResult = Apollo.MutationResult<UpdateCustomFieldMutation>;
export type UpdateCustomFieldMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>;
export const GetCustomFieldDefinitionDocument = gql`
    query getCustomFieldDefinition($id: ID!) {
  getCustomFieldDefinition(id: $id) {
    id
    assetType
    type
    clientId
    slug
    label
    visible
    description
    isDisplayedInExport
    updatedAt
    updatedBy {
      fullName
    }
    textConfig {
      paragraph
      dynVar
    }
    numberConfig {
      precision
    }
    choiceConfig {
      displayType
      options
    }
    multipleChoiceConfig {
      displayType
      options
    }
    dateConfig {
      isDateTime
      timezone
    }
  }
}
    `;

/**
 * __useGetCustomFieldDefinitionQuery__
 *
 * To run a query within a React component, call `useGetCustomFieldDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFieldDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFieldDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomFieldDefinitionQuery(baseOptions: Apollo.QueryHookOptions<GetCustomFieldDefinitionQuery, GetCustomFieldDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFieldDefinitionQuery, GetCustomFieldDefinitionQueryVariables>(GetCustomFieldDefinitionDocument, options);
      }
export function useGetCustomFieldDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFieldDefinitionQuery, GetCustomFieldDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFieldDefinitionQuery, GetCustomFieldDefinitionQueryVariables>(GetCustomFieldDefinitionDocument, options);
        }
export type GetCustomFieldDefinitionQueryHookResult = ReturnType<typeof useGetCustomFieldDefinitionQuery>;
export type GetCustomFieldDefinitionLazyQueryHookResult = ReturnType<typeof useGetCustomFieldDefinitionLazyQuery>;
export type GetCustomFieldDefinitionQueryResult = Apollo.QueryResult<GetCustomFieldDefinitionQuery, GetCustomFieldDefinitionQueryVariables>;
export const ToggleCustomFieldDefinitionVisibilityDocument = gql`
    mutation toggleCustomFieldDefinitionVisibility($id: ID!) {
  toggleCustomFieldDefinitionVisibility(id: $id) {
    id
    updatedAt
    visible
  }
}
    `;
export type ToggleCustomFieldDefinitionVisibilityMutationFn = Apollo.MutationFunction<ToggleCustomFieldDefinitionVisibilityMutation, ToggleCustomFieldDefinitionVisibilityMutationVariables>;

/**
 * __useToggleCustomFieldDefinitionVisibilityMutation__
 *
 * To run a mutation, you first call `useToggleCustomFieldDefinitionVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCustomFieldDefinitionVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCustomFieldDefinitionVisibilityMutation, { data, loading, error }] = useToggleCustomFieldDefinitionVisibilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCustomFieldDefinitionVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCustomFieldDefinitionVisibilityMutation, ToggleCustomFieldDefinitionVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCustomFieldDefinitionVisibilityMutation, ToggleCustomFieldDefinitionVisibilityMutationVariables>(ToggleCustomFieldDefinitionVisibilityDocument, options);
      }
export type ToggleCustomFieldDefinitionVisibilityMutationHookResult = ReturnType<typeof useToggleCustomFieldDefinitionVisibilityMutation>;
export type ToggleCustomFieldDefinitionVisibilityMutationResult = Apollo.MutationResult<ToggleCustomFieldDefinitionVisibilityMutation>;
export type ToggleCustomFieldDefinitionVisibilityMutationOptions = Apollo.BaseMutationOptions<ToggleCustomFieldDefinitionVisibilityMutation, ToggleCustomFieldDefinitionVisibilityMutationVariables>;
export const GetCustomFieldDefinitionsByAssetTypeDocument = gql`
    query getCustomFieldDefinitionsByAssetType($assetType: CustomFieldAssetType!) {
  getCustomFieldDefinitionsByAssetType(assetType: $assetType) {
    id
    label
    slug
    type
    updatedAt
    visible
  }
}
    `;

/**
 * __useGetCustomFieldDefinitionsByAssetTypeQuery__
 *
 * To run a query within a React component, call `useGetCustomFieldDefinitionsByAssetTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFieldDefinitionsByAssetTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFieldDefinitionsByAssetTypeQuery({
 *   variables: {
 *      assetType: // value for 'assetType'
 *   },
 * });
 */
export function useGetCustomFieldDefinitionsByAssetTypeQuery(baseOptions: Apollo.QueryHookOptions<GetCustomFieldDefinitionsByAssetTypeQuery, GetCustomFieldDefinitionsByAssetTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFieldDefinitionsByAssetTypeQuery, GetCustomFieldDefinitionsByAssetTypeQueryVariables>(GetCustomFieldDefinitionsByAssetTypeDocument, options);
      }
export function useGetCustomFieldDefinitionsByAssetTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFieldDefinitionsByAssetTypeQuery, GetCustomFieldDefinitionsByAssetTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFieldDefinitionsByAssetTypeQuery, GetCustomFieldDefinitionsByAssetTypeQueryVariables>(GetCustomFieldDefinitionsByAssetTypeDocument, options);
        }
export type GetCustomFieldDefinitionsByAssetTypeQueryHookResult = ReturnType<typeof useGetCustomFieldDefinitionsByAssetTypeQuery>;
export type GetCustomFieldDefinitionsByAssetTypeLazyQueryHookResult = ReturnType<typeof useGetCustomFieldDefinitionsByAssetTypeLazyQuery>;
export type GetCustomFieldDefinitionsByAssetTypeQueryResult = Apollo.QueryResult<GetCustomFieldDefinitionsByAssetTypeQuery, GetCustomFieldDefinitionsByAssetTypeQueryVariables>;
export const GetInitialOrderedCustomFieldsByAssetTypeDocument = gql`
    query getInitialOrderedCustomFieldsByAssetType($assetType: CustomFieldAssetType!) {
  getInitialOrderedCustomFieldsByAssetType(assetType: $assetType) {
    ...OrderedCustomFieldFragment
  }
}
    ${OrderedCustomFieldFragmentFragmentDoc}`;

/**
 * __useGetInitialOrderedCustomFieldsByAssetTypeQuery__
 *
 * To run a query within a React component, call `useGetInitialOrderedCustomFieldsByAssetTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialOrderedCustomFieldsByAssetTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialOrderedCustomFieldsByAssetTypeQuery({
 *   variables: {
 *      assetType: // value for 'assetType'
 *   },
 * });
 */
export function useGetInitialOrderedCustomFieldsByAssetTypeQuery(baseOptions: Apollo.QueryHookOptions<GetInitialOrderedCustomFieldsByAssetTypeQuery, GetInitialOrderedCustomFieldsByAssetTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialOrderedCustomFieldsByAssetTypeQuery, GetInitialOrderedCustomFieldsByAssetTypeQueryVariables>(GetInitialOrderedCustomFieldsByAssetTypeDocument, options);
      }
export function useGetInitialOrderedCustomFieldsByAssetTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialOrderedCustomFieldsByAssetTypeQuery, GetInitialOrderedCustomFieldsByAssetTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialOrderedCustomFieldsByAssetTypeQuery, GetInitialOrderedCustomFieldsByAssetTypeQueryVariables>(GetInitialOrderedCustomFieldsByAssetTypeDocument, options);
        }
export type GetInitialOrderedCustomFieldsByAssetTypeQueryHookResult = ReturnType<typeof useGetInitialOrderedCustomFieldsByAssetTypeQuery>;
export type GetInitialOrderedCustomFieldsByAssetTypeLazyQueryHookResult = ReturnType<typeof useGetInitialOrderedCustomFieldsByAssetTypeLazyQuery>;
export type GetInitialOrderedCustomFieldsByAssetTypeQueryResult = Apollo.QueryResult<GetInitialOrderedCustomFieldsByAssetTypeQuery, GetInitialOrderedCustomFieldsByAssetTypeQueryVariables>;
export const CreatePdfThumbnailDocument = gql`
    mutation createPdfThumbnail($file: Upload!) {
  createPdfThumbnail(file: $file)
}
    `;
export type CreatePdfThumbnailMutationFn = Apollo.MutationFunction<CreatePdfThumbnailMutation, CreatePdfThumbnailMutationVariables>;

/**
 * __useCreatePdfThumbnailMutation__
 *
 * To run a mutation, you first call `useCreatePdfThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePdfThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPdfThumbnailMutation, { data, loading, error }] = useCreatePdfThumbnailMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreatePdfThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<CreatePdfThumbnailMutation, CreatePdfThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePdfThumbnailMutation, CreatePdfThumbnailMutationVariables>(CreatePdfThumbnailDocument, options);
      }
export type CreatePdfThumbnailMutationHookResult = ReturnType<typeof useCreatePdfThumbnailMutation>;
export type CreatePdfThumbnailMutationResult = Apollo.MutationResult<CreatePdfThumbnailMutation>;
export type CreatePdfThumbnailMutationOptions = Apollo.BaseMutationOptions<CreatePdfThumbnailMutation, CreatePdfThumbnailMutationVariables>;
export const FeaturesSelect_GetFeaturesDocument = gql`
    query FeaturesSelect_getFeatures {
  getFeatures
}
    `;

/**
 * __useFeaturesSelect_GetFeaturesQuery__
 *
 * To run a query within a React component, call `useFeaturesSelect_GetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesSelect_GetFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesSelect_GetFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturesSelect_GetFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<FeaturesSelect_GetFeaturesQuery, FeaturesSelect_GetFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesSelect_GetFeaturesQuery, FeaturesSelect_GetFeaturesQueryVariables>(FeaturesSelect_GetFeaturesDocument, options);
      }
export function useFeaturesSelect_GetFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesSelect_GetFeaturesQuery, FeaturesSelect_GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesSelect_GetFeaturesQuery, FeaturesSelect_GetFeaturesQueryVariables>(FeaturesSelect_GetFeaturesDocument, options);
        }
export type FeaturesSelect_GetFeaturesQueryHookResult = ReturnType<typeof useFeaturesSelect_GetFeaturesQuery>;
export type FeaturesSelect_GetFeaturesLazyQueryHookResult = ReturnType<typeof useFeaturesSelect_GetFeaturesLazyQuery>;
export type FeaturesSelect_GetFeaturesQueryResult = Apollo.QueryResult<FeaturesSelect_GetFeaturesQuery, FeaturesSelect_GetFeaturesQueryVariables>;
export const SwitchOrganisationDocument = gql`
    mutation switchOrganisation($clientId: String!) {
  switchOrganisation(clientId: $clientId) {
    jwToken
    clientId
  }
}
    `;
export type SwitchOrganisationMutationFn = Apollo.MutationFunction<SwitchOrganisationMutation, SwitchOrganisationMutationVariables>;

/**
 * __useSwitchOrganisationMutation__
 *
 * To run a mutation, you first call `useSwitchOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchOrganisationMutation, { data, loading, error }] = useSwitchOrganisationMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSwitchOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<SwitchOrganisationMutation, SwitchOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchOrganisationMutation, SwitchOrganisationMutationVariables>(SwitchOrganisationDocument, options);
      }
export type SwitchOrganisationMutationHookResult = ReturnType<typeof useSwitchOrganisationMutation>;
export type SwitchOrganisationMutationResult = Apollo.MutationResult<SwitchOrganisationMutation>;
export type SwitchOrganisationMutationOptions = Apollo.BaseMutationOptions<SwitchOrganisationMutation, SwitchOrganisationMutationVariables>;
export const SpAddressesDocument = gql`
    query spAddresses {
  me {
    id
    firstname
    lastname
    selectedSalesPoint {
      id
      name
      code
      defaultLocations {
        shipping {
          id
          name
          address
          postalCode
          city
          country
          additionalAddress
          longitude
          latitude
        }
        billing {
          id
          name
          address
          postalCode
          city
          country
          additionalAddress
          longitude
          latitude
        }
      }
      publicLocation {
        address
        postalCode
        city
        country
        additionalAddress
        longitude
        latitude
      }
      locations {
        id
        name
        address
        postalCode
        city
        country
        additionalAddress
        longitude
        latitude
      }
    }
  }
}
    `;

/**
 * __useSpAddressesQuery__
 *
 * To run a query within a React component, call `useSpAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpAddressesQuery(baseOptions?: Apollo.QueryHookOptions<SpAddressesQuery, SpAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpAddressesQuery, SpAddressesQueryVariables>(SpAddressesDocument, options);
      }
export function useSpAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpAddressesQuery, SpAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpAddressesQuery, SpAddressesQueryVariables>(SpAddressesDocument, options);
        }
export type SpAddressesQueryHookResult = ReturnType<typeof useSpAddressesQuery>;
export type SpAddressesLazyQueryHookResult = ReturnType<typeof useSpAddressesLazyQuery>;
export type SpAddressesQueryResult = Apollo.QueryResult<SpAddressesQuery, SpAddressesQueryVariables>;
export const AddOrderMessageDocument = gql`
    mutation addOrderMessage($orderId: ID!, $content: String!) {
  addOrderMessage(orderId: $orderId, content: $content) {
    messages {
      id
      content
      createdAt
      isCancelledReason
    }
  }
}
    `;
export type AddOrderMessageMutationFn = Apollo.MutationFunction<AddOrderMessageMutation, AddOrderMessageMutationVariables>;

/**
 * __useAddOrderMessageMutation__
 *
 * To run a mutation, you first call `useAddOrderMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderMessageMutation, { data, loading, error }] = useAddOrderMessageMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useAddOrderMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderMessageMutation, AddOrderMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderMessageMutation, AddOrderMessageMutationVariables>(AddOrderMessageDocument, options);
      }
export type AddOrderMessageMutationHookResult = ReturnType<typeof useAddOrderMessageMutation>;
export type AddOrderMessageMutationResult = Apollo.MutationResult<AddOrderMessageMutation>;
export type AddOrderMessageMutationOptions = Apollo.BaseMutationOptions<AddOrderMessageMutation, AddOrderMessageMutationVariables>;
export const AdminProductCategoriesList_SetProductCategoryEnabledDocument = gql`
    mutation AdminProductCategoriesList_setProductCategoryEnabled($id: ID!, $enabled: Boolean!) {
  setProductCategoryEnabled(id: $id, enabled: $enabled) {
    ... on ChildProductCategory {
      id
      enabled
    }
    ... on ParentProductCategory {
      id
      enabled
    }
  }
}
    `;
export type AdminProductCategoriesList_SetProductCategoryEnabledMutationFn = Apollo.MutationFunction<AdminProductCategoriesList_SetProductCategoryEnabledMutation, AdminProductCategoriesList_SetProductCategoryEnabledMutationVariables>;

/**
 * __useAdminProductCategoriesList_SetProductCategoryEnabledMutation__
 *
 * To run a mutation, you first call `useAdminProductCategoriesList_SetProductCategoryEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminProductCategoriesList_SetProductCategoryEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminProductCategoriesListSetProductCategoryEnabledMutation, { data, loading, error }] = useAdminProductCategoriesList_SetProductCategoryEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useAdminProductCategoriesList_SetProductCategoryEnabledMutation(baseOptions?: Apollo.MutationHookOptions<AdminProductCategoriesList_SetProductCategoryEnabledMutation, AdminProductCategoriesList_SetProductCategoryEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminProductCategoriesList_SetProductCategoryEnabledMutation, AdminProductCategoriesList_SetProductCategoryEnabledMutationVariables>(AdminProductCategoriesList_SetProductCategoryEnabledDocument, options);
      }
export type AdminProductCategoriesList_SetProductCategoryEnabledMutationHookResult = ReturnType<typeof useAdminProductCategoriesList_SetProductCategoryEnabledMutation>;
export type AdminProductCategoriesList_SetProductCategoryEnabledMutationResult = Apollo.MutationResult<AdminProductCategoriesList_SetProductCategoryEnabledMutation>;
export type AdminProductCategoriesList_SetProductCategoryEnabledMutationOptions = Apollo.BaseMutationOptions<AdminProductCategoriesList_SetProductCategoryEnabledMutation, AdminProductCategoriesList_SetProductCategoryEnabledMutationVariables>;
export const SetProductCategoryPositionDocument = gql`
    mutation setProductCategoryPosition($id: ID!, $position: Int!) {
  setProductCategoryPosition(id: $id, position: $position) {
    ... on ChildProductCategory {
      id
      position
    }
    ... on ParentProductCategory {
      id
      position
    }
  }
}
    `;
export type SetProductCategoryPositionMutationFn = Apollo.MutationFunction<SetProductCategoryPositionMutation, SetProductCategoryPositionMutationVariables>;

/**
 * __useSetProductCategoryPositionMutation__
 *
 * To run a mutation, you first call `useSetProductCategoryPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProductCategoryPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProductCategoryPositionMutation, { data, loading, error }] = useSetProductCategoryPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useSetProductCategoryPositionMutation(baseOptions?: Apollo.MutationHookOptions<SetProductCategoryPositionMutation, SetProductCategoryPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProductCategoryPositionMutation, SetProductCategoryPositionMutationVariables>(SetProductCategoryPositionDocument, options);
      }
export type SetProductCategoryPositionMutationHookResult = ReturnType<typeof useSetProductCategoryPositionMutation>;
export type SetProductCategoryPositionMutationResult = Apollo.MutationResult<SetProductCategoryPositionMutation>;
export type SetProductCategoryPositionMutationOptions = Apollo.BaseMutationOptions<SetProductCategoryPositionMutation, SetProductCategoryPositionMutationVariables>;
export const GetStockAlertSettingDocument = gql`
    query GetStockAlertSetting {
  me {
    id
    client {
      id
      shopOptions {
        displayStockAlert
      }
    }
  }
}
    `;

/**
 * __useGetStockAlertSettingQuery__
 *
 * To run a query within a React component, call `useGetStockAlertSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockAlertSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockAlertSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStockAlertSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetStockAlertSettingQuery, GetStockAlertSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStockAlertSettingQuery, GetStockAlertSettingQueryVariables>(GetStockAlertSettingDocument, options);
      }
export function useGetStockAlertSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStockAlertSettingQuery, GetStockAlertSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStockAlertSettingQuery, GetStockAlertSettingQueryVariables>(GetStockAlertSettingDocument, options);
        }
export type GetStockAlertSettingQueryHookResult = ReturnType<typeof useGetStockAlertSettingQuery>;
export type GetStockAlertSettingLazyQueryHookResult = ReturnType<typeof useGetStockAlertSettingLazyQuery>;
export type GetStockAlertSettingQueryResult = Apollo.QueryResult<GetStockAlertSettingQuery, GetStockAlertSettingQueryVariables>;
export const SmartSelectCampaignsDocument = gql`
    query smartSelectCampaigns($types: [CampaignType!], $keyword: String, $salespointIds: [ID!]) {
  campaigns(bypassVisibility: true, limit: 300, offset: 0, types: $types, keyword: $keyword, salespointIds: $salespointIds) {
    campaigns {
      id
      name
    }
  }
}
    `;

/**
 * __useSmartSelectCampaignsQuery__
 *
 * To run a query within a React component, call `useSmartSelectCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectCampaignsQuery({
 *   variables: {
 *      types: // value for 'types'
 *      keyword: // value for 'keyword'
 *      salespointIds: // value for 'salespointIds'
 *   },
 * });
 */
export function useSmartSelectCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectCampaignsQuery, SmartSelectCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectCampaignsQuery, SmartSelectCampaignsQueryVariables>(SmartSelectCampaignsDocument, options);
      }
export function useSmartSelectCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectCampaignsQuery, SmartSelectCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectCampaignsQuery, SmartSelectCampaignsQueryVariables>(SmartSelectCampaignsDocument, options);
        }
export type SmartSelectCampaignsQueryHookResult = ReturnType<typeof useSmartSelectCampaignsQuery>;
export type SmartSelectCampaignsLazyQueryHookResult = ReturnType<typeof useSmartSelectCampaignsLazyQuery>;
export type SmartSelectCampaignsQueryResult = Apollo.QueryResult<SmartSelectCampaignsQuery, SmartSelectCampaignsQueryVariables>;
export const SmartSelectCampaignCategoriesDocument = gql`
    query smartSelectCampaignCategories($salespointIds: [ID!], $types: [CampaignType!]) {
  campaignCategories(bypassVisibility: true, types: $types, salespointIds: $salespointIds) {
    id
    name
  }
}
    `;

/**
 * __useSmartSelectCampaignCategoriesQuery__
 *
 * To run a query within a React component, call `useSmartSelectCampaignCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectCampaignCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectCampaignCategoriesQuery({
 *   variables: {
 *      salespointIds: // value for 'salespointIds'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useSmartSelectCampaignCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectCampaignCategoriesQuery, SmartSelectCampaignCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectCampaignCategoriesQuery, SmartSelectCampaignCategoriesQueryVariables>(SmartSelectCampaignCategoriesDocument, options);
      }
export function useSmartSelectCampaignCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectCampaignCategoriesQuery, SmartSelectCampaignCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectCampaignCategoriesQuery, SmartSelectCampaignCategoriesQueryVariables>(SmartSelectCampaignCategoriesDocument, options);
        }
export type SmartSelectCampaignCategoriesQueryHookResult = ReturnType<typeof useSmartSelectCampaignCategoriesQuery>;
export type SmartSelectCampaignCategoriesLazyQueryHookResult = ReturnType<typeof useSmartSelectCampaignCategoriesLazyQuery>;
export type SmartSelectCampaignCategoriesQueryResult = Apollo.QueryResult<SmartSelectCampaignCategoriesQuery, SmartSelectCampaignCategoriesQueryVariables>;
export const SmartSelectMediasDocument = gql`
    query smartSelectMedias($keyword: String, $salespointIds: [ID!], $limit: Int = 5000) {
  medias(offset: 0, limit: $limit, types: [file, customizable], keyword: $keyword, salespointIds: $salespointIds, sort: {criteria: name, direction: asc}) {
    medias {
      id
      name
    }
  }
}
    `;

/**
 * __useSmartSelectMediasQuery__
 *
 * To run a query within a React component, call `useSmartSelectMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectMediasQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      salespointIds: // value for 'salespointIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSmartSelectMediasQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectMediasQuery, SmartSelectMediasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectMediasQuery, SmartSelectMediasQueryVariables>(SmartSelectMediasDocument, options);
      }
export function useSmartSelectMediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectMediasQuery, SmartSelectMediasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectMediasQuery, SmartSelectMediasQueryVariables>(SmartSelectMediasDocument, options);
        }
export type SmartSelectMediasQueryHookResult = ReturnType<typeof useSmartSelectMediasQuery>;
export type SmartSelectMediasLazyQueryHookResult = ReturnType<typeof useSmartSelectMediasLazyQuery>;
export type SmartSelectMediasQueryResult = Apollo.QueryResult<SmartSelectMediasQuery, SmartSelectMediasQueryVariables>;
export const SmartSelectPostTemplatesDocument = gql`
    query smartSelectPostTemplates($filters: PostTemplateListFilters, $sort: PostTemplateListSort, $offset: Int, $limit: Int) {
  getPostTemplateList(filters: $filters, sort: $sort, offset: $offset, limit: $limit) {
    templates {
      id
      mongoId
      name
    }
  }
}
    `;

/**
 * __useSmartSelectPostTemplatesQuery__
 *
 * To run a query within a React component, call `useSmartSelectPostTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectPostTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectPostTemplatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSmartSelectPostTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectPostTemplatesQuery, SmartSelectPostTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectPostTemplatesQuery, SmartSelectPostTemplatesQueryVariables>(SmartSelectPostTemplatesDocument, options);
      }
export function useSmartSelectPostTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectPostTemplatesQuery, SmartSelectPostTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectPostTemplatesQuery, SmartSelectPostTemplatesQueryVariables>(SmartSelectPostTemplatesDocument, options);
        }
export type SmartSelectPostTemplatesQueryHookResult = ReturnType<typeof useSmartSelectPostTemplatesQuery>;
export type SmartSelectPostTemplatesLazyQueryHookResult = ReturnType<typeof useSmartSelectPostTemplatesLazyQuery>;
export type SmartSelectPostTemplatesQueryResult = Apollo.QueryResult<SmartSelectPostTemplatesQuery, SmartSelectPostTemplatesQueryVariables>;
export const SmartSelectProductsDocument = gql`
    query smartSelectProducts($keyword: String, $salespointIds: [ID!], $limit: Int = 5000) {
  products(offset: 0, limit: $limit, showDisabled: true, separateHighlights: false, keyword: $keyword, salespointIds: $salespointIds, sort: {criteria: name, direction: asc}) {
    products {
      id
      name
    }
  }
}
    `;

/**
 * __useSmartSelectProductsQuery__
 *
 * To run a query within a React component, call `useSmartSelectProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectProductsQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      salespointIds: // value for 'salespointIds'
 *   },
 * });
 */
export function useSmartSelectProductsQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectProductsQuery, SmartSelectProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectProductsQuery, SmartSelectProductsQueryVariables>(SmartSelectProductsDocument, options);
      }
export function useSmartSelectProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectProductsQuery, SmartSelectProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectProductsQuery, SmartSelectProductsQueryVariables>(SmartSelectProductsDocument, options);
        }
export type SmartSelectProductsQueryHookResult = ReturnType<typeof useSmartSelectProductsQuery>;
export type SmartSelectProductsLazyQueryHookResult = ReturnType<typeof useSmartSelectProductsLazyQuery>;
export type SmartSelectProductsQueryResult = Apollo.QueryResult<SmartSelectProductsQuery, SmartSelectProductsQueryVariables>;
export const SmartSelectSalesPointsDocument = gql`
    query smartSelectSalesPoints($offset: Int, $limit: Int, $filter: SalesPointFilter) {
  salesPoints(offset: $offset, limit: $limit, filter: $filter) {
    salesPoints {
      id
      name
      client {
        name
      }
    }
  }
}
    `;

/**
 * __useSmartSelectSalesPointsQuery__
 *
 * To run a query within a React component, call `useSmartSelectSalesPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectSalesPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectSalesPointsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSmartSelectSalesPointsQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectSalesPointsQuery, SmartSelectSalesPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectSalesPointsQuery, SmartSelectSalesPointsQueryVariables>(SmartSelectSalesPointsDocument, options);
      }
export function useSmartSelectSalesPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectSalesPointsQuery, SmartSelectSalesPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectSalesPointsQuery, SmartSelectSalesPointsQueryVariables>(SmartSelectSalesPointsDocument, options);
        }
export type SmartSelectSalesPointsQueryHookResult = ReturnType<typeof useSmartSelectSalesPointsQuery>;
export type SmartSelectSalesPointsLazyQueryHookResult = ReturnType<typeof useSmartSelectSalesPointsLazyQuery>;
export type SmartSelectSalesPointsQueryResult = Apollo.QueryResult<SmartSelectSalesPointsQuery, SmartSelectSalesPointsQueryVariables>;
export const SmartSelectSalespointGroupsDocument = gql`
    query smartSelectSalespointGroups($keyword: String, $salespointIds: [ID!]) {
  salesPointsGroupsBySalesPointIds(offset: 0, limit: 300, keyword: $keyword, salesPointIds: $salespointIds) {
    salesPointsGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useSmartSelectSalespointGroupsQuery__
 *
 * To run a query within a React component, call `useSmartSelectSalespointGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectSalespointGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectSalespointGroupsQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      salespointIds: // value for 'salespointIds'
 *   },
 * });
 */
export function useSmartSelectSalespointGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectSalespointGroupsQuery, SmartSelectSalespointGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectSalespointGroupsQuery, SmartSelectSalespointGroupsQueryVariables>(SmartSelectSalespointGroupsDocument, options);
      }
export function useSmartSelectSalespointGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectSalespointGroupsQuery, SmartSelectSalespointGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectSalespointGroupsQuery, SmartSelectSalespointGroupsQueryVariables>(SmartSelectSalespointGroupsDocument, options);
        }
export type SmartSelectSalespointGroupsQueryHookResult = ReturnType<typeof useSmartSelectSalespointGroupsQuery>;
export type SmartSelectSalespointGroupsLazyQueryHookResult = ReturnType<typeof useSmartSelectSalespointGroupsLazyQuery>;
export type SmartSelectSalespointGroupsQueryResult = Apollo.QueryResult<SmartSelectSalespointGroupsQuery, SmartSelectSalespointGroupsQueryVariables>;
export const SmartSelectTagGroupsDocument = gql`
    query smartSelectTagGroups($filter: TagsFilters) {
  tagGroups(offset: 0, limit: 50, filter: $filter) {
    tagGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useSmartSelectTagGroupsQuery__
 *
 * To run a query within a React component, call `useSmartSelectTagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectTagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectTagGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSmartSelectTagGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectTagGroupsQuery, SmartSelectTagGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectTagGroupsQuery, SmartSelectTagGroupsQueryVariables>(SmartSelectTagGroupsDocument, options);
      }
export function useSmartSelectTagGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectTagGroupsQuery, SmartSelectTagGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectTagGroupsQuery, SmartSelectTagGroupsQueryVariables>(SmartSelectTagGroupsDocument, options);
        }
export type SmartSelectTagGroupsQueryHookResult = ReturnType<typeof useSmartSelectTagGroupsQuery>;
export type SmartSelectTagGroupsLazyQueryHookResult = ReturnType<typeof useSmartSelectTagGroupsLazyQuery>;
export type SmartSelectTagGroupsQueryResult = Apollo.QueryResult<SmartSelectTagGroupsQuery, SmartSelectTagGroupsQueryVariables>;
export const SmartSelectTagsDocument = gql`
    query smartSelectTags($filter: TagsFilters) {
  tags(offset: 0, limit: 50, filter: $filter) {
    tags {
      id
      label
    }
  }
}
    `;

/**
 * __useSmartSelectTagsQuery__
 *
 * To run a query within a React component, call `useSmartSelectTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartSelectTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartSelectTagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSmartSelectTagsQuery(baseOptions?: Apollo.QueryHookOptions<SmartSelectTagsQuery, SmartSelectTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartSelectTagsQuery, SmartSelectTagsQueryVariables>(SmartSelectTagsDocument, options);
      }
export function useSmartSelectTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartSelectTagsQuery, SmartSelectTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartSelectTagsQuery, SmartSelectTagsQueryVariables>(SmartSelectTagsDocument, options);
        }
export type SmartSelectTagsQueryHookResult = ReturnType<typeof useSmartSelectTagsQuery>;
export type SmartSelectTagsLazyQueryHookResult = ReturnType<typeof useSmartSelectTagsLazyQuery>;
export type SmartSelectTagsQueryResult = Apollo.QueryResult<SmartSelectTagsQuery, SmartSelectTagsQueryVariables>;
export const HasGlobalAccountDocument = gql`
    query hasGlobalAccount($socialNetwork: SocialNetwork) {
  hasGlobalAccount(label: "national", socialNetwork: $socialNetwork)
}
    `;

/**
 * __useHasGlobalAccountQuery__
 *
 * To run a query within a React component, call `useHasGlobalAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasGlobalAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasGlobalAccountQuery({
 *   variables: {
 *      socialNetwork: // value for 'socialNetwork'
 *   },
 * });
 */
export function useHasGlobalAccountQuery(baseOptions?: Apollo.QueryHookOptions<HasGlobalAccountQuery, HasGlobalAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasGlobalAccountQuery, HasGlobalAccountQueryVariables>(HasGlobalAccountDocument, options);
      }
export function useHasGlobalAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasGlobalAccountQuery, HasGlobalAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasGlobalAccountQuery, HasGlobalAccountQueryVariables>(HasGlobalAccountDocument, options);
        }
export type HasGlobalAccountQueryHookResult = ReturnType<typeof useHasGlobalAccountQuery>;
export type HasGlobalAccountLazyQueryHookResult = ReturnType<typeof useHasGlobalAccountLazyQuery>;
export type HasGlobalAccountQueryResult = Apollo.QueryResult<HasGlobalAccountQuery, HasGlobalAccountQueryVariables>;
export const HasGlobalAccountDataDocument = gql`
    query hasGlobalAccountData {
  hasGlobalAccountData(label: "national") {
    facebook
    linkedin
    google
    instagram
  }
}
    `;

/**
 * __useHasGlobalAccountDataQuery__
 *
 * To run a query within a React component, call `useHasGlobalAccountDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasGlobalAccountDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasGlobalAccountDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasGlobalAccountDataQuery(baseOptions?: Apollo.QueryHookOptions<HasGlobalAccountDataQuery, HasGlobalAccountDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasGlobalAccountDataQuery, HasGlobalAccountDataQueryVariables>(HasGlobalAccountDataDocument, options);
      }
export function useHasGlobalAccountDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasGlobalAccountDataQuery, HasGlobalAccountDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasGlobalAccountDataQuery, HasGlobalAccountDataQueryVariables>(HasGlobalAccountDataDocument, options);
        }
export type HasGlobalAccountDataQueryHookResult = ReturnType<typeof useHasGlobalAccountDataQuery>;
export type HasGlobalAccountDataLazyQueryHookResult = ReturnType<typeof useHasGlobalAccountDataLazyQuery>;
export type HasGlobalAccountDataQueryResult = Apollo.QueryResult<HasGlobalAccountDataQuery, HasGlobalAccountDataQueryVariables>;
export const NewsModal_GetUserUnpresentedNewsDocument = gql`
    query NewsModal_getUserUnpresentedNews {
  getUserUnpresentedNews {
    id
    imageUrl
    recipient {
      roles
    }
    contents {
      lang
      title
      description
      cta {
        link
        text
      }
    }
  }
}
    `;

/**
 * __useNewsModal_GetUserUnpresentedNewsQuery__
 *
 * To run a query within a React component, call `useNewsModal_GetUserUnpresentedNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsModal_GetUserUnpresentedNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsModal_GetUserUnpresentedNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewsModal_GetUserUnpresentedNewsQuery(baseOptions?: Apollo.QueryHookOptions<NewsModal_GetUserUnpresentedNewsQuery, NewsModal_GetUserUnpresentedNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsModal_GetUserUnpresentedNewsQuery, NewsModal_GetUserUnpresentedNewsQueryVariables>(NewsModal_GetUserUnpresentedNewsDocument, options);
      }
export function useNewsModal_GetUserUnpresentedNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsModal_GetUserUnpresentedNewsQuery, NewsModal_GetUserUnpresentedNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsModal_GetUserUnpresentedNewsQuery, NewsModal_GetUserUnpresentedNewsQueryVariables>(NewsModal_GetUserUnpresentedNewsDocument, options);
        }
export type NewsModal_GetUserUnpresentedNewsQueryHookResult = ReturnType<typeof useNewsModal_GetUserUnpresentedNewsQuery>;
export type NewsModal_GetUserUnpresentedNewsLazyQueryHookResult = ReturnType<typeof useNewsModal_GetUserUnpresentedNewsLazyQuery>;
export type NewsModal_GetUserUnpresentedNewsQueryResult = Apollo.QueryResult<NewsModal_GetUserUnpresentedNewsQuery, NewsModal_GetUserUnpresentedNewsQueryVariables>;
export const NewsModal_MarkNewsAsPresentedDocument = gql`
    mutation NewsModal_markNewsAsPresented($ids: [ID!]!) {
  markNewsAsPresented(ids: $ids)
}
    `;
export type NewsModal_MarkNewsAsPresentedMutationFn = Apollo.MutationFunction<NewsModal_MarkNewsAsPresentedMutation, NewsModal_MarkNewsAsPresentedMutationVariables>;

/**
 * __useNewsModal_MarkNewsAsPresentedMutation__
 *
 * To run a mutation, you first call `useNewsModal_MarkNewsAsPresentedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsModal_MarkNewsAsPresentedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsModalMarkNewsAsPresentedMutation, { data, loading, error }] = useNewsModal_MarkNewsAsPresentedMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useNewsModal_MarkNewsAsPresentedMutation(baseOptions?: Apollo.MutationHookOptions<NewsModal_MarkNewsAsPresentedMutation, NewsModal_MarkNewsAsPresentedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewsModal_MarkNewsAsPresentedMutation, NewsModal_MarkNewsAsPresentedMutationVariables>(NewsModal_MarkNewsAsPresentedDocument, options);
      }
export type NewsModal_MarkNewsAsPresentedMutationHookResult = ReturnType<typeof useNewsModal_MarkNewsAsPresentedMutation>;
export type NewsModal_MarkNewsAsPresentedMutationResult = Apollo.MutationResult<NewsModal_MarkNewsAsPresentedMutation>;
export type NewsModal_MarkNewsAsPresentedMutationOptions = Apollo.BaseMutationOptions<NewsModal_MarkNewsAsPresentedMutation, NewsModal_MarkNewsAsPresentedMutationVariables>;
export const TotalNotificationsDocument = gql`
    query totalNotifications {
  getNbItemsToValidate {
    total
  }
}
    `;

/**
 * __useTotalNotificationsQuery__
 *
 * To run a query within a React component, call `useTotalNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTotalNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<TotalNotificationsQuery, TotalNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalNotificationsQuery, TotalNotificationsQueryVariables>(TotalNotificationsDocument, options);
      }
export function useTotalNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalNotificationsQuery, TotalNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalNotificationsQuery, TotalNotificationsQueryVariables>(TotalNotificationsDocument, options);
        }
export type TotalNotificationsQueryHookResult = ReturnType<typeof useTotalNotificationsQuery>;
export type TotalNotificationsLazyQueryHookResult = ReturnType<typeof useTotalNotificationsLazyQuery>;
export type TotalNotificationsQueryResult = Apollo.QueryResult<TotalNotificationsQuery, TotalNotificationsQueryVariables>;
export const GetNbItemsToValidateDocument = gql`
    query getNbItemsToValidate {
  getNbItemsToValidate {
    total
    items {
      order {
        enabled
        count
      }
      converse_comment {
        enabled
        count
      }
      converse_rating {
        enabled
        count
      }
      publish {
        enabled
        count
      }
      amplify {
        enabled
        count
      }
    }
  }
}
    `;

/**
 * __useGetNbItemsToValidateQuery__
 *
 * To run a query within a React component, call `useGetNbItemsToValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNbItemsToValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNbItemsToValidateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNbItemsToValidateQuery(baseOptions?: Apollo.QueryHookOptions<GetNbItemsToValidateQuery, GetNbItemsToValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNbItemsToValidateQuery, GetNbItemsToValidateQueryVariables>(GetNbItemsToValidateDocument, options);
      }
export function useGetNbItemsToValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNbItemsToValidateQuery, GetNbItemsToValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNbItemsToValidateQuery, GetNbItemsToValidateQueryVariables>(GetNbItemsToValidateDocument, options);
        }
export type GetNbItemsToValidateQueryHookResult = ReturnType<typeof useGetNbItemsToValidateQuery>;
export type GetNbItemsToValidateLazyQueryHookResult = ReturnType<typeof useGetNbItemsToValidateLazyQuery>;
export type GetNbItemsToValidateQueryResult = Apollo.QueryResult<GetNbItemsToValidateQuery, GetNbItemsToValidateQueryVariables>;
export const AddEditedProductToCartDocument = gql`
    mutation addEditedProductToCart($productId: ID!, $quantity: Int, $type: CartType, $tempFolderDocumentId: ID!, $documentDownloadSettingsId: ID!, $comment: String, $packId: ID, $existingSubId: String, $selectedFixPrice: Int) {
  addEditedProductToCart(productId: $productId, quantity: $quantity, type: $type, tempFolderDocumentId: $tempFolderDocumentId, documentDownloadSettingsId: $documentDownloadSettingsId, comment: $comment, packId: $packId, existingSubId: $existingSubId, selectedFixPrice: $selectedFixPrice) {
    success
    subId
  }
}
    `;
export type AddEditedProductToCartMutationFn = Apollo.MutationFunction<AddEditedProductToCartMutation, AddEditedProductToCartMutationVariables>;

/**
 * __useAddEditedProductToCartMutation__
 *
 * To run a mutation, you first call `useAddEditedProductToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditedProductToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditedProductToCartMutation, { data, loading, error }] = useAddEditedProductToCartMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      quantity: // value for 'quantity'
 *      type: // value for 'type'
 *      tempFolderDocumentId: // value for 'tempFolderDocumentId'
 *      documentDownloadSettingsId: // value for 'documentDownloadSettingsId'
 *      comment: // value for 'comment'
 *      packId: // value for 'packId'
 *      existingSubId: // value for 'existingSubId'
 *      selectedFixPrice: // value for 'selectedFixPrice'
 *   },
 * });
 */
export function useAddEditedProductToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddEditedProductToCartMutation, AddEditedProductToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditedProductToCartMutation, AddEditedProductToCartMutationVariables>(AddEditedProductToCartDocument, options);
      }
export type AddEditedProductToCartMutationHookResult = ReturnType<typeof useAddEditedProductToCartMutation>;
export type AddEditedProductToCartMutationResult = Apollo.MutationResult<AddEditedProductToCartMutation>;
export type AddEditedProductToCartMutationOptions = Apollo.BaseMutationOptions<AddEditedProductToCartMutation, AddEditedProductToCartMutationVariables>;
export const AddEditedProductToDraftDocument = gql`
    mutation addEditedProductToDraft($productId: ID!, $tempFolderDocumentId: ID!, $packId: ID, $existingSubId: String) {
  addEditedProductToDraft(productId: $productId, tempFolderDocumentId: $tempFolderDocumentId, packId: $packId, existingSubId: $existingSubId)
}
    `;
export type AddEditedProductToDraftMutationFn = Apollo.MutationFunction<AddEditedProductToDraftMutation, AddEditedProductToDraftMutationVariables>;

/**
 * __useAddEditedProductToDraftMutation__
 *
 * To run a mutation, you first call `useAddEditedProductToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditedProductToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditedProductToDraftMutation, { data, loading, error }] = useAddEditedProductToDraftMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      tempFolderDocumentId: // value for 'tempFolderDocumentId'
 *      packId: // value for 'packId'
 *      existingSubId: // value for 'existingSubId'
 *   },
 * });
 */
export function useAddEditedProductToDraftMutation(baseOptions?: Apollo.MutationHookOptions<AddEditedProductToDraftMutation, AddEditedProductToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditedProductToDraftMutation, AddEditedProductToDraftMutationVariables>(AddEditedProductToDraftDocument, options);
      }
export type AddEditedProductToDraftMutationHookResult = ReturnType<typeof useAddEditedProductToDraftMutation>;
export type AddEditedProductToDraftMutationResult = Apollo.MutationResult<AddEditedProductToDraftMutation>;
export type AddEditedProductToDraftMutationOptions = Apollo.BaseMutationOptions<AddEditedProductToDraftMutation, AddEditedProductToDraftMutationVariables>;
export const AddItemToCartDocument = gql`
    mutation addItemToCart($item: CartItemInput, $files: [Upload!]) {
  addItemToCart(item: $item, files: $files) {
    userId
    user {
      id
    }
    items {
      productId
      type
      quantity
      subId
      providerId
      variationByQuantity {
        quantity
        values
      }
    }
  }
}
    `;
export type AddItemToCartMutationFn = Apollo.MutationFunction<AddItemToCartMutation, AddItemToCartMutationVariables>;

/**
 * __useAddItemToCartMutation__
 *
 * To run a mutation, you first call `useAddItemToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToCartMutation, { data, loading, error }] = useAddItemToCartMutation({
 *   variables: {
 *      item: // value for 'item'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddItemToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddItemToCartMutation, AddItemToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemToCartMutation, AddItemToCartMutationVariables>(AddItemToCartDocument, options);
      }
export type AddItemToCartMutationHookResult = ReturnType<typeof useAddItemToCartMutation>;
export type AddItemToCartMutationResult = Apollo.MutationResult<AddItemToCartMutation>;
export type AddItemToCartMutationOptions = Apollo.BaseMutationOptions<AddItemToCartMutation, AddItemToCartMutationVariables>;
export const AddLibraryMediaDocument = gql`
    mutation addLibraryMedia($thumbnailFile: Upload, $files: [Upload], $type: LibraryMediaType!, $chiliDetails: InputChiliDetails, $details: InputMediaDetails, $folderLocation: ID, $isFromEditFile: Boolean = false, $isDownloadByEmail: Boolean) {
  addLibraryMedia(thumbnailFile: $thumbnailFile, files: $files, type: $type, chiliDetails: $chiliDetails, details: $details, folderLocation: $folderLocation, isFromEditFile: $isFromEditFile, isDownloadByEmail: $isDownloadByEmail) {
    id
    type
    name
    fileType
    isDownloadByEmail
    details {
      description
      tips
      tags {
        id
        label
      }
    }
    validFrom
    validTo
  }
}
    `;
export type AddLibraryMediaMutationFn = Apollo.MutationFunction<AddLibraryMediaMutation, AddLibraryMediaMutationVariables>;

/**
 * __useAddLibraryMediaMutation__
 *
 * To run a mutation, you first call `useAddLibraryMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLibraryMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLibraryMediaMutation, { data, loading, error }] = useAddLibraryMediaMutation({
 *   variables: {
 *      thumbnailFile: // value for 'thumbnailFile'
 *      files: // value for 'files'
 *      type: // value for 'type'
 *      chiliDetails: // value for 'chiliDetails'
 *      details: // value for 'details'
 *      folderLocation: // value for 'folderLocation'
 *      isFromEditFile: // value for 'isFromEditFile'
 *      isDownloadByEmail: // value for 'isDownloadByEmail'
 *   },
 * });
 */
export function useAddLibraryMediaMutation(baseOptions?: Apollo.MutationHookOptions<AddLibraryMediaMutation, AddLibraryMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLibraryMediaMutation, AddLibraryMediaMutationVariables>(AddLibraryMediaDocument, options);
      }
export type AddLibraryMediaMutationHookResult = ReturnType<typeof useAddLibraryMediaMutation>;
export type AddLibraryMediaMutationResult = Apollo.MutationResult<AddLibraryMediaMutation>;
export type AddLibraryMediaMutationOptions = Apollo.BaseMutationOptions<AddLibraryMediaMutation, AddLibraryMediaMutationVariables>;
export const AddPostTemplateDocument = gql`
    mutation addPostTemplate($publishArgs: PostTemplateArgs!) {
  addPostTemplate(publishArgs: $publishArgs) {
    id
    name
    type
    socialNetworks
    useSalespointsGroups
    salespointsGroupsIds
    isScheduled
    startDate
    endDate
    displayStatus
  }
}
    `;
export type AddPostTemplateMutationFn = Apollo.MutationFunction<AddPostTemplateMutation, AddPostTemplateMutationVariables>;

/**
 * __useAddPostTemplateMutation__
 *
 * To run a mutation, you first call `useAddPostTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostTemplateMutation, { data, loading, error }] = useAddPostTemplateMutation({
 *   variables: {
 *      publishArgs: // value for 'publishArgs'
 *   },
 * });
 */
export function useAddPostTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddPostTemplateMutation, AddPostTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPostTemplateMutation, AddPostTemplateMutationVariables>(AddPostTemplateDocument, options);
      }
export type AddPostTemplateMutationHookResult = ReturnType<typeof useAddPostTemplateMutation>;
export type AddPostTemplateMutationResult = Apollo.MutationResult<AddPostTemplateMutation>;
export type AddPostTemplateMutationOptions = Apollo.BaseMutationOptions<AddPostTemplateMutation, AddPostTemplateMutationVariables>;
export const AddSalesPointLocationsDocument = gql`
    mutation addSalesPointLocations($salesPointId: ID!, $locations: [LocationInput!]!) {
  addSalesPointLocations(salesPointId: $salesPointId, locations: $locations) {
    id
    locations {
      id
      name
      address
    }
  }
}
    `;
export type AddSalesPointLocationsMutationFn = Apollo.MutationFunction<AddSalesPointLocationsMutation, AddSalesPointLocationsMutationVariables>;

/**
 * __useAddSalesPointLocationsMutation__
 *
 * To run a mutation, you first call `useAddSalesPointLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSalesPointLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSalesPointLocationsMutation, { data, loading, error }] = useAddSalesPointLocationsMutation({
 *   variables: {
 *      salesPointId: // value for 'salesPointId'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useAddSalesPointLocationsMutation(baseOptions?: Apollo.MutationHookOptions<AddSalesPointLocationsMutation, AddSalesPointLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSalesPointLocationsMutation, AddSalesPointLocationsMutationVariables>(AddSalesPointLocationsDocument, options);
      }
export type AddSalesPointLocationsMutationHookResult = ReturnType<typeof useAddSalesPointLocationsMutation>;
export type AddSalesPointLocationsMutationResult = Apollo.MutationResult<AddSalesPointLocationsMutation>;
export type AddSalesPointLocationsMutationOptions = Apollo.BaseMutationOptions<AddSalesPointLocationsMutation, AddSalesPointLocationsMutationVariables>;
export const AddSocialPostDocument = gql`
    mutation addSocialPost($publishArgs: PublishArgs!, $link: String, $dynamicLink: String, $medias: [UploadOrGalleryMediaInput], $thumb: UploadOrGalleryMediaInput, $cover: UploadOrGalleryMediaInput, $avatar: UploadOrGalleryMediaInput, $carouselItems: [InputCarouselItem!], $event: InputSocialEvent, $isFromReadyToPost: Boolean) {
  addSocialPost(publishArgs: $publishArgs, link: $link, dynamicLink: $dynamicLink, medias: $medias, thumb: $thumb, cover: $cover, avatar: $avatar, carouselItems: $carouselItems, event: $event, isFromReadyToPost: $isFromReadyToPost) {
    validationRequiredCount
    post {
      ...PostFragment
    }
  }
}
    ${PostFragmentFragmentDoc}`;
export type AddSocialPostMutationFn = Apollo.MutationFunction<AddSocialPostMutation, AddSocialPostMutationVariables>;

/**
 * __useAddSocialPostMutation__
 *
 * To run a mutation, you first call `useAddSocialPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSocialPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSocialPostMutation, { data, loading, error }] = useAddSocialPostMutation({
 *   variables: {
 *      publishArgs: // value for 'publishArgs'
 *      link: // value for 'link'
 *      dynamicLink: // value for 'dynamicLink'
 *      medias: // value for 'medias'
 *      thumb: // value for 'thumb'
 *      cover: // value for 'cover'
 *      avatar: // value for 'avatar'
 *      carouselItems: // value for 'carouselItems'
 *      event: // value for 'event'
 *      isFromReadyToPost: // value for 'isFromReadyToPost'
 *   },
 * });
 */
export function useAddSocialPostMutation(baseOptions?: Apollo.MutationHookOptions<AddSocialPostMutation, AddSocialPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSocialPostMutation, AddSocialPostMutationVariables>(AddSocialPostDocument, options);
      }
export type AddSocialPostMutationHookResult = ReturnType<typeof useAddSocialPostMutation>;
export type AddSocialPostMutationResult = Apollo.MutationResult<AddSocialPostMutation>;
export type AddSocialPostMutationOptions = Apollo.BaseMutationOptions<AddSocialPostMutation, AddSocialPostMutationVariables>;
export const AssignRoleDocument = gql`
    mutation assignRole($userId: ID!, $roleId: ID!) {
  assignRole(userId: $userId, roleId: $roleId) {
    id
    name
  }
}
    `;
export type AssignRoleMutationFn = Apollo.MutationFunction<AssignRoleMutation, AssignRoleMutationVariables>;

/**
 * __useAssignRoleMutation__
 *
 * To run a mutation, you first call `useAssignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleMutation, { data, loading, error }] = useAssignRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAssignRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignRoleMutation, AssignRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRoleMutation, AssignRoleMutationVariables>(AssignRoleDocument, options);
      }
export type AssignRoleMutationHookResult = ReturnType<typeof useAssignRoleMutation>;
export type AssignRoleMutationResult = Apollo.MutationResult<AssignRoleMutation>;
export type AssignRoleMutationOptions = Apollo.BaseMutationOptions<AssignRoleMutation, AssignRoleMutationVariables>;
export const AssignVoucherToCartDocument = gql`
    mutation assignVoucherToCart($voucherCode: String!) {
  assignVoucherToCart(voucherCode: $voucherCode) {
    userId
  }
}
    `;
export type AssignVoucherToCartMutationFn = Apollo.MutationFunction<AssignVoucherToCartMutation, AssignVoucherToCartMutationVariables>;

/**
 * __useAssignVoucherToCartMutation__
 *
 * To run a mutation, you first call `useAssignVoucherToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignVoucherToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignVoucherToCartMutation, { data, loading, error }] = useAssignVoucherToCartMutation({
 *   variables: {
 *      voucherCode: // value for 'voucherCode'
 *   },
 * });
 */
export function useAssignVoucherToCartMutation(baseOptions?: Apollo.MutationHookOptions<AssignVoucherToCartMutation, AssignVoucherToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignVoucherToCartMutation, AssignVoucherToCartMutationVariables>(AssignVoucherToCartDocument, options);
      }
export type AssignVoucherToCartMutationHookResult = ReturnType<typeof useAssignVoucherToCartMutation>;
export type AssignVoucherToCartMutationResult = Apollo.MutationResult<AssignVoucherToCartMutation>;
export type AssignVoucherToCartMutationOptions = Apollo.BaseMutationOptions<AssignVoucherToCartMutation, AssignVoucherToCartMutationVariables>;
export const AssociateUserToSalesPointsDocument = gql`
    mutation associateUserToSalesPoints($userId: ID!, $salesPoints: [ID]!) {
  associateUserToSalesPoints(userId: $userId, salesPoints: $salesPoints)
}
    `;
export type AssociateUserToSalesPointsMutationFn = Apollo.MutationFunction<AssociateUserToSalesPointsMutation, AssociateUserToSalesPointsMutationVariables>;

/**
 * __useAssociateUserToSalesPointsMutation__
 *
 * To run a mutation, you first call `useAssociateUserToSalesPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateUserToSalesPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateUserToSalesPointsMutation, { data, loading, error }] = useAssociateUserToSalesPointsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      salesPoints: // value for 'salesPoints'
 *   },
 * });
 */
export function useAssociateUserToSalesPointsMutation(baseOptions?: Apollo.MutationHookOptions<AssociateUserToSalesPointsMutation, AssociateUserToSalesPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateUserToSalesPointsMutation, AssociateUserToSalesPointsMutationVariables>(AssociateUserToSalesPointsDocument, options);
      }
export type AssociateUserToSalesPointsMutationHookResult = ReturnType<typeof useAssociateUserToSalesPointsMutation>;
export type AssociateUserToSalesPointsMutationResult = Apollo.MutationResult<AssociateUserToSalesPointsMutation>;
export type AssociateUserToSalesPointsMutationOptions = Apollo.BaseMutationOptions<AssociateUserToSalesPointsMutation, AssociateUserToSalesPointsMutationVariables>;
export const AssociateUsersToSalesPointDocument = gql`
    mutation associateUsersToSalesPoint($users: [ID]!, $salesPoint: ID!) {
  associateUsersToSalesPoint(users: $users, salesPoint: $salesPoint)
}
    `;
export type AssociateUsersToSalesPointMutationFn = Apollo.MutationFunction<AssociateUsersToSalesPointMutation, AssociateUsersToSalesPointMutationVariables>;

/**
 * __useAssociateUsersToSalesPointMutation__
 *
 * To run a mutation, you first call `useAssociateUsersToSalesPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateUsersToSalesPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateUsersToSalesPointMutation, { data, loading, error }] = useAssociateUsersToSalesPointMutation({
 *   variables: {
 *      users: // value for 'users'
 *      salesPoint: // value for 'salesPoint'
 *   },
 * });
 */
export function useAssociateUsersToSalesPointMutation(baseOptions?: Apollo.MutationHookOptions<AssociateUsersToSalesPointMutation, AssociateUsersToSalesPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateUsersToSalesPointMutation, AssociateUsersToSalesPointMutationVariables>(AssociateUsersToSalesPointDocument, options);
      }
export type AssociateUsersToSalesPointMutationHookResult = ReturnType<typeof useAssociateUsersToSalesPointMutation>;
export type AssociateUsersToSalesPointMutationResult = Apollo.MutationResult<AssociateUsersToSalesPointMutation>;
export type AssociateUsersToSalesPointMutationOptions = Apollo.BaseMutationOptions<AssociateUsersToSalesPointMutation, AssociateUsersToSalesPointMutationVariables>;
export const BulkAddCartItemsDocument = gql`
    mutation bulkAddCartItems($items: [CartItemInput]) {
  bulkAddCartItems(items: $items) {
    availableProducts {
      productId
      quantity
    }
    unavailableProducts {
      productId
      quantity
    }
  }
}
    `;
export type BulkAddCartItemsMutationFn = Apollo.MutationFunction<BulkAddCartItemsMutation, BulkAddCartItemsMutationVariables>;

/**
 * __useBulkAddCartItemsMutation__
 *
 * To run a mutation, you first call `useBulkAddCartItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddCartItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddCartItemsMutation, { data, loading, error }] = useBulkAddCartItemsMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useBulkAddCartItemsMutation(baseOptions?: Apollo.MutationHookOptions<BulkAddCartItemsMutation, BulkAddCartItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAddCartItemsMutation, BulkAddCartItemsMutationVariables>(BulkAddCartItemsDocument, options);
      }
export type BulkAddCartItemsMutationHookResult = ReturnType<typeof useBulkAddCartItemsMutation>;
export type BulkAddCartItemsMutationResult = Apollo.MutationResult<BulkAddCartItemsMutation>;
export type BulkAddCartItemsMutationOptions = Apollo.BaseMutationOptions<BulkAddCartItemsMutation, BulkAddCartItemsMutationVariables>;
export const CancelPreorderDocument = gql`
    mutation cancelPreorder($id: ID!) {
  cancelPreorder(id: $id) {
    id
    status
  }
}
    `;
export type CancelPreorderMutationFn = Apollo.MutationFunction<CancelPreorderMutation, CancelPreorderMutationVariables>;

/**
 * __useCancelPreorderMutation__
 *
 * To run a mutation, you first call `useCancelPreorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPreorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPreorderMutation, { data, loading, error }] = useCancelPreorderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPreorderMutation(baseOptions?: Apollo.MutationHookOptions<CancelPreorderMutation, CancelPreorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPreorderMutation, CancelPreorderMutationVariables>(CancelPreorderDocument, options);
      }
export type CancelPreorderMutationHookResult = ReturnType<typeof useCancelPreorderMutation>;
export type CancelPreorderMutationResult = Apollo.MutationResult<CancelPreorderMutation>;
export type CancelPreorderMutationOptions = Apollo.BaseMutationOptions<CancelPreorderMutation, CancelPreorderMutationVariables>;
export const CancelSalesPointsImportJobDocument = gql`
    mutation cancelSalesPointsImportJob($jobId: ID!) {
  cancelSalesPointsImportJob(jobId: $jobId)
}
    `;
export type CancelSalesPointsImportJobMutationFn = Apollo.MutationFunction<CancelSalesPointsImportJobMutation, CancelSalesPointsImportJobMutationVariables>;

/**
 * __useCancelSalesPointsImportJobMutation__
 *
 * To run a mutation, you first call `useCancelSalesPointsImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSalesPointsImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSalesPointsImportJobMutation, { data, loading, error }] = useCancelSalesPointsImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelSalesPointsImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelSalesPointsImportJobMutation, CancelSalesPointsImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSalesPointsImportJobMutation, CancelSalesPointsImportJobMutationVariables>(CancelSalesPointsImportJobDocument, options);
      }
export type CancelSalesPointsImportJobMutationHookResult = ReturnType<typeof useCancelSalesPointsImportJobMutation>;
export type CancelSalesPointsImportJobMutationResult = Apollo.MutationResult<CancelSalesPointsImportJobMutation>;
export type CancelSalesPointsImportJobMutationOptions = Apollo.BaseMutationOptions<CancelSalesPointsImportJobMutation, CancelSalesPointsImportJobMutationVariables>;
export const CancelUserAmplifyBudgetImportJobDocument = gql`
    mutation cancelUserAmplifyBudgetImportJob($jobId: ID!) {
  cancelUserAmplifyBudgetImportJob(jobId: $jobId)
}
    `;
export type CancelUserAmplifyBudgetImportJobMutationFn = Apollo.MutationFunction<CancelUserAmplifyBudgetImportJobMutation, CancelUserAmplifyBudgetImportJobMutationVariables>;

/**
 * __useCancelUserAmplifyBudgetImportJobMutation__
 *
 * To run a mutation, you first call `useCancelUserAmplifyBudgetImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUserAmplifyBudgetImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUserAmplifyBudgetImportJobMutation, { data, loading, error }] = useCancelUserAmplifyBudgetImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelUserAmplifyBudgetImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelUserAmplifyBudgetImportJobMutation, CancelUserAmplifyBudgetImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelUserAmplifyBudgetImportJobMutation, CancelUserAmplifyBudgetImportJobMutationVariables>(CancelUserAmplifyBudgetImportJobDocument, options);
      }
export type CancelUserAmplifyBudgetImportJobMutationHookResult = ReturnType<typeof useCancelUserAmplifyBudgetImportJobMutation>;
export type CancelUserAmplifyBudgetImportJobMutationResult = Apollo.MutationResult<CancelUserAmplifyBudgetImportJobMutation>;
export type CancelUserAmplifyBudgetImportJobMutationOptions = Apollo.BaseMutationOptions<CancelUserAmplifyBudgetImportJobMutation, CancelUserAmplifyBudgetImportJobMutationVariables>;
export const CancelUsersImportJobDocument = gql`
    mutation cancelUsersImportJob($jobId: ID!) {
  cancelUsersImportJob(jobId: $jobId)
}
    `;
export type CancelUsersImportJobMutationFn = Apollo.MutationFunction<CancelUsersImportJobMutation, CancelUsersImportJobMutationVariables>;

/**
 * __useCancelUsersImportJobMutation__
 *
 * To run a mutation, you first call `useCancelUsersImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUsersImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUsersImportJobMutation, { data, loading, error }] = useCancelUsersImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelUsersImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelUsersImportJobMutation, CancelUsersImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelUsersImportJobMutation, CancelUsersImportJobMutationVariables>(CancelUsersImportJobDocument, options);
      }
export type CancelUsersImportJobMutationHookResult = ReturnType<typeof useCancelUsersImportJobMutation>;
export type CancelUsersImportJobMutationResult = Apollo.MutationResult<CancelUsersImportJobMutation>;
export type CancelUsersImportJobMutationOptions = Apollo.BaseMutationOptions<CancelUsersImportJobMutation, CancelUsersImportJobMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($email: String!, $oldPassword: String!, $newPassword: String!) {
  changePassword(email: $email, oldPassword: $oldPassword, newPassword: $newPassword) {
    jwToken
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CommitSalesPointsImportJobDocument = gql`
    mutation commitSalesPointsImportJob($jobId: ID!) {
  commitSalesPointsImportJob(jobId: $jobId)
}
    `;
export type CommitSalesPointsImportJobMutationFn = Apollo.MutationFunction<CommitSalesPointsImportJobMutation, CommitSalesPointsImportJobMutationVariables>;

/**
 * __useCommitSalesPointsImportJobMutation__
 *
 * To run a mutation, you first call `useCommitSalesPointsImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitSalesPointsImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitSalesPointsImportJobMutation, { data, loading, error }] = useCommitSalesPointsImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCommitSalesPointsImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CommitSalesPointsImportJobMutation, CommitSalesPointsImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitSalesPointsImportJobMutation, CommitSalesPointsImportJobMutationVariables>(CommitSalesPointsImportJobDocument, options);
      }
export type CommitSalesPointsImportJobMutationHookResult = ReturnType<typeof useCommitSalesPointsImportJobMutation>;
export type CommitSalesPointsImportJobMutationResult = Apollo.MutationResult<CommitSalesPointsImportJobMutation>;
export type CommitSalesPointsImportJobMutationOptions = Apollo.BaseMutationOptions<CommitSalesPointsImportJobMutation, CommitSalesPointsImportJobMutationVariables>;
export const CommitUserAmplifyBudgetImportJobDocument = gql`
    mutation commitUserAmplifyBudgetImportJob($jobId: ID!) {
  commitUserAmplifyBudgetImportJob(jobId: $jobId)
}
    `;
export type CommitUserAmplifyBudgetImportJobMutationFn = Apollo.MutationFunction<CommitUserAmplifyBudgetImportJobMutation, CommitUserAmplifyBudgetImportJobMutationVariables>;

/**
 * __useCommitUserAmplifyBudgetImportJobMutation__
 *
 * To run a mutation, you first call `useCommitUserAmplifyBudgetImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitUserAmplifyBudgetImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitUserAmplifyBudgetImportJobMutation, { data, loading, error }] = useCommitUserAmplifyBudgetImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCommitUserAmplifyBudgetImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CommitUserAmplifyBudgetImportJobMutation, CommitUserAmplifyBudgetImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitUserAmplifyBudgetImportJobMutation, CommitUserAmplifyBudgetImportJobMutationVariables>(CommitUserAmplifyBudgetImportJobDocument, options);
      }
export type CommitUserAmplifyBudgetImportJobMutationHookResult = ReturnType<typeof useCommitUserAmplifyBudgetImportJobMutation>;
export type CommitUserAmplifyBudgetImportJobMutationResult = Apollo.MutationResult<CommitUserAmplifyBudgetImportJobMutation>;
export type CommitUserAmplifyBudgetImportJobMutationOptions = Apollo.BaseMutationOptions<CommitUserAmplifyBudgetImportJobMutation, CommitUserAmplifyBudgetImportJobMutationVariables>;
export const CommitUsersImportJobDocument = gql`
    mutation commitUsersImportJob($jobId: ID!) {
  commitUsersImportJob(jobId: $jobId)
}
    `;
export type CommitUsersImportJobMutationFn = Apollo.MutationFunction<CommitUsersImportJobMutation, CommitUsersImportJobMutationVariables>;

/**
 * __useCommitUsersImportJobMutation__
 *
 * To run a mutation, you first call `useCommitUsersImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitUsersImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitUsersImportJobMutation, { data, loading, error }] = useCommitUsersImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCommitUsersImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CommitUsersImportJobMutation, CommitUsersImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitUsersImportJobMutation, CommitUsersImportJobMutationVariables>(CommitUsersImportJobDocument, options);
      }
export type CommitUsersImportJobMutationHookResult = ReturnType<typeof useCommitUsersImportJobMutation>;
export type CommitUsersImportJobMutationResult = Apollo.MutationResult<CommitUsersImportJobMutation>;
export type CommitUsersImportJobMutationOptions = Apollo.BaseMutationOptions<CommitUsersImportJobMutation, CommitUsersImportJobMutationVariables>;
export const CreateAmplifyCampaignDocument = gql`
    mutation createAmplifyCampaign($campaign: InputAmplifyCampaign!, $postCalendarId: ID!) {
  createAmplifyCampaign(campaign: $campaign, postCalendarId: $postCalendarId) {
    id
  }
}
    `;
export type CreateAmplifyCampaignMutationFn = Apollo.MutationFunction<CreateAmplifyCampaignMutation, CreateAmplifyCampaignMutationVariables>;

/**
 * __useCreateAmplifyCampaignMutation__
 *
 * To run a mutation, you first call `useCreateAmplifyCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAmplifyCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAmplifyCampaignMutation, { data, loading, error }] = useCreateAmplifyCampaignMutation({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      postCalendarId: // value for 'postCalendarId'
 *   },
 * });
 */
export function useCreateAmplifyCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateAmplifyCampaignMutation, CreateAmplifyCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAmplifyCampaignMutation, CreateAmplifyCampaignMutationVariables>(CreateAmplifyCampaignDocument, options);
      }
export type CreateAmplifyCampaignMutationHookResult = ReturnType<typeof useCreateAmplifyCampaignMutation>;
export type CreateAmplifyCampaignMutationResult = Apollo.MutationResult<CreateAmplifyCampaignMutation>;
export type CreateAmplifyCampaignMutationOptions = Apollo.BaseMutationOptions<CreateAmplifyCampaignMutation, CreateAmplifyCampaignMutationVariables>;
export const CreateEventDocument = gql`
    mutation createEvent($type: CreatableEventType!, $subType: EventSubType, $moduleType: EventModuleType, $extra: String) {
  createEvent(type: $type, subType: $subType, extra: $extra, moduleType: $moduleType)
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      type: // value for 'type'
 *      subType: // value for 'subType'
 *      moduleType: // value for 'moduleType'
 *      extra: // value for 'extra'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateInstantPurchaseOrderDocument = gql`
    mutation createInstantPurchaseOrder($productId: ID!, $productOptionIds: [ID]) {
  createInstantPurchaseOrder(productId: $productId, productOptionIds: $productOptionIds) {
    status
    orderId
    url
    toValidate
  }
}
    `;
export type CreateInstantPurchaseOrderMutationFn = Apollo.MutationFunction<CreateInstantPurchaseOrderMutation, CreateInstantPurchaseOrderMutationVariables>;

/**
 * __useCreateInstantPurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCreateInstantPurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstantPurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstantPurchaseOrderMutation, { data, loading, error }] = useCreateInstantPurchaseOrderMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      productOptionIds: // value for 'productOptionIds'
 *   },
 * });
 */
export function useCreateInstantPurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateInstantPurchaseOrderMutation, CreateInstantPurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInstantPurchaseOrderMutation, CreateInstantPurchaseOrderMutationVariables>(CreateInstantPurchaseOrderDocument, options);
      }
export type CreateInstantPurchaseOrderMutationHookResult = ReturnType<typeof useCreateInstantPurchaseOrderMutation>;
export type CreateInstantPurchaseOrderMutationResult = Apollo.MutationResult<CreateInstantPurchaseOrderMutation>;
export type CreateInstantPurchaseOrderMutationOptions = Apollo.BaseMutationOptions<CreateInstantPurchaseOrderMutation, CreateInstantPurchaseOrderMutationVariables>;
export const CreateLibraryFolderDocument = gql`
    mutation createLibraryFolder($folder: FolderInput!) {
  createLibraryFolder(folder: $folder) {
    id
    name
    parent
    salespointsGroups {
      id
    }
    validFrom
    validTo
  }
}
    `;
export type CreateLibraryFolderMutationFn = Apollo.MutationFunction<CreateLibraryFolderMutation, CreateLibraryFolderMutationVariables>;

/**
 * __useCreateLibraryFolderMutation__
 *
 * To run a mutation, you first call `useCreateLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLibraryFolderMutation, { data, loading, error }] = useCreateLibraryFolderMutation({
 *   variables: {
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useCreateLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateLibraryFolderMutation, CreateLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLibraryFolderMutation, CreateLibraryFolderMutationVariables>(CreateLibraryFolderDocument, options);
      }
export type CreateLibraryFolderMutationHookResult = ReturnType<typeof useCreateLibraryFolderMutation>;
export type CreateLibraryFolderMutationResult = Apollo.MutationResult<CreateLibraryFolderMutation>;
export type CreateLibraryFolderMutationOptions = Apollo.BaseMutationOptions<CreateLibraryFolderMutation, CreateLibraryFolderMutationVariables>;
export const CreateOrderFromCartDocument = gql`
    mutation createOrderFromCart($billingLocationId: ID, $stripePaymentMethod: OrderPaymentMethodStripe, $addresses: AddressesInput, $eskerNumbers: JSON) {
  createOrderFromCart(billingLocationId: $billingLocationId, stripePaymentMethod: $stripePaymentMethod, addresses: $addresses, eskerNumbers: $eskerNumbers) {
    sessionUrl
    parentOrder {
      id
      ordersNeedValidation
      ordersPartiallyNeedValidation
      orders {
        id
      }
      totalWithFees {
        discountedPrice {
          withTaxes
        }
      }
    }
  }
}
    `;
export type CreateOrderFromCartMutationFn = Apollo.MutationFunction<CreateOrderFromCartMutation, CreateOrderFromCartMutationVariables>;

/**
 * __useCreateOrderFromCartMutation__
 *
 * To run a mutation, you first call `useCreateOrderFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderFromCartMutation, { data, loading, error }] = useCreateOrderFromCartMutation({
 *   variables: {
 *      billingLocationId: // value for 'billingLocationId'
 *      stripePaymentMethod: // value for 'stripePaymentMethod'
 *      addresses: // value for 'addresses'
 *      eskerNumbers: // value for 'eskerNumbers'
 *   },
 * });
 */
export function useCreateOrderFromCartMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderFromCartMutation, CreateOrderFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderFromCartMutation, CreateOrderFromCartMutationVariables>(CreateOrderFromCartDocument, options);
      }
export type CreateOrderFromCartMutationHookResult = ReturnType<typeof useCreateOrderFromCartMutation>;
export type CreateOrderFromCartMutationResult = Apollo.MutationResult<CreateOrderFromCartMutation>;
export type CreateOrderFromCartMutationOptions = Apollo.BaseMutationOptions<CreateOrderFromCartMutation, CreateOrderFromCartMutationVariables>;
export const CreateRoleDocument = gql`
    mutation createRole($role: CreateRoleInput!) {
  createRole(role: $role) {
    id
  }
}
    `;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const CreateSalesPointDocument = gql`
    mutation createSalesPoint($salesPoint: SalesPointInput!, $images: [Upload], $socialConfig: SocialSalespointConfigInput) {
  createSalesPoint(salesPoint: $salesPoint, images: $images, socialConfig: $socialConfig) {
    id
    name
    email
    code
    affairCode
    tvaCode
    enabled
    RCS
    secondaryName
    siretCode
    phone
    fax
    contactDetails {
      phoneNumber
      email
      website
      twitterLink
      facebookLink
      pinterestLink
      instagramLink
      youtubeLink
      linkedinLink
      foursquareLink
      vimeoLink
      xingLink
      contacts {
        id
        firstname
        lastname
        phone
        activity
        email
      }
    }
    location {
      address
      postalCode
      city
      country
      additionalAddress
      longitude
      latitude
    }
    images {
      thumbnail
      large
      small
      medium
      original
    }
    openingHours {
      day
      isOpen
      sessions {
        start
        end
        isAllDay
      }
    }
    users {
      id
      lastname
      firstname
      phone
      mobilePhone
      email
    }
    specialOpeningHours {
      id
      from
      to
      isOpen
      hoursFrom
      hoursTo
    }
  }
}
    `;
export type CreateSalesPointMutationFn = Apollo.MutationFunction<CreateSalesPointMutation, CreateSalesPointMutationVariables>;

/**
 * __useCreateSalesPointMutation__
 *
 * To run a mutation, you first call `useCreateSalesPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesPointMutation, { data, loading, error }] = useCreateSalesPointMutation({
 *   variables: {
 *      salesPoint: // value for 'salesPoint'
 *      images: // value for 'images'
 *      socialConfig: // value for 'socialConfig'
 *   },
 * });
 */
export function useCreateSalesPointMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalesPointMutation, CreateSalesPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalesPointMutation, CreateSalesPointMutationVariables>(CreateSalesPointDocument, options);
      }
export type CreateSalesPointMutationHookResult = ReturnType<typeof useCreateSalesPointMutation>;
export type CreateSalesPointMutationResult = Apollo.MutationResult<CreateSalesPointMutation>;
export type CreateSalesPointMutationOptions = Apollo.BaseMutationOptions<CreateSalesPointMutation, CreateSalesPointMutationVariables>;
export const CreateTagDocument = gql`
    mutation createTag($tag: TagInputCreation!) {
  createTag(tag: $tag) {
    id
    label
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const CreateTagGroupDocument = gql`
    mutation createTagGroup($tagGroup: TagGroupInputCreation!) {
  createTagGroup(tagGroup: $tagGroup) {
    id
    name
  }
}
    `;
export type CreateTagGroupMutationFn = Apollo.MutationFunction<CreateTagGroupMutation, CreateTagGroupMutationVariables>;

/**
 * __useCreateTagGroupMutation__
 *
 * To run a mutation, you first call `useCreateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagGroupMutation, { data, loading, error }] = useCreateTagGroupMutation({
 *   variables: {
 *      tagGroup: // value for 'tagGroup'
 *   },
 * });
 */
export function useCreateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagGroupMutation, CreateTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagGroupMutation, CreateTagGroupMutationVariables>(CreateTagGroupDocument, options);
      }
export type CreateTagGroupMutationHookResult = ReturnType<typeof useCreateTagGroupMutation>;
export type CreateTagGroupMutationResult = Apollo.MutationResult<CreateTagGroupMutation>;
export type CreateTagGroupMutationOptions = Apollo.BaseMutationOptions<CreateTagGroupMutation, CreateTagGroupMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($user: UserInput!) {
  createUser(user: $user) {
    id
    firstname
    lastname
    phone
    mobilePhone
    activity
    email
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateUserImmediatelyDocument = gql`
    mutation createUserImmediately($user: UserToCreateInput!) {
  createUserImmediately(user: $user) {
    id
  }
}
    `;
export type CreateUserImmediatelyMutationFn = Apollo.MutationFunction<CreateUserImmediatelyMutation, CreateUserImmediatelyMutationVariables>;

/**
 * __useCreateUserImmediatelyMutation__
 *
 * To run a mutation, you first call `useCreateUserImmediatelyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserImmediatelyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserImmediatelyMutation, { data, loading, error }] = useCreateUserImmediatelyMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserImmediatelyMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserImmediatelyMutation, CreateUserImmediatelyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserImmediatelyMutation, CreateUserImmediatelyMutationVariables>(CreateUserImmediatelyDocument, options);
      }
export type CreateUserImmediatelyMutationHookResult = ReturnType<typeof useCreateUserImmediatelyMutation>;
export type CreateUserImmediatelyMutationResult = Apollo.MutationResult<CreateUserImmediatelyMutation>;
export type CreateUserImmediatelyMutationOptions = Apollo.BaseMutationOptions<CreateUserImmediatelyMutation, CreateUserImmediatelyMutationVariables>;
export const DeleteAnswerTemplateDocument = gql`
    mutation deleteAnswerTemplate($id: ID!) {
  deleteAnswerTemplate(id: $id) {
    id
  }
}
    `;
export type DeleteAnswerTemplateMutationFn = Apollo.MutationFunction<DeleteAnswerTemplateMutation, DeleteAnswerTemplateMutationVariables>;

/**
 * __useDeleteAnswerTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteAnswerTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswerTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswerTemplateMutation, { data, loading, error }] = useDeleteAnswerTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnswerTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnswerTemplateMutation, DeleteAnswerTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnswerTemplateMutation, DeleteAnswerTemplateMutationVariables>(DeleteAnswerTemplateDocument, options);
      }
export type DeleteAnswerTemplateMutationHookResult = ReturnType<typeof useDeleteAnswerTemplateMutation>;
export type DeleteAnswerTemplateMutationResult = Apollo.MutationResult<DeleteAnswerTemplateMutation>;
export type DeleteAnswerTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteAnswerTemplateMutation, DeleteAnswerTemplateMutationVariables>;
export const DeleteCustomVisualDocument = gql`
    mutation deleteCustomVisual($salesPointId: ID!, $filenames: [String]!) {
  deleteCustomVisual(salesPointId: $salesPointId, filenames: $filenames)
}
    `;
export type DeleteCustomVisualMutationFn = Apollo.MutationFunction<DeleteCustomVisualMutation, DeleteCustomVisualMutationVariables>;

/**
 * __useDeleteCustomVisualMutation__
 *
 * To run a mutation, you first call `useDeleteCustomVisualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomVisualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomVisualMutation, { data, loading, error }] = useDeleteCustomVisualMutation({
 *   variables: {
 *      salesPointId: // value for 'salesPointId'
 *      filenames: // value for 'filenames'
 *   },
 * });
 */
export function useDeleteCustomVisualMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomVisualMutation, DeleteCustomVisualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomVisualMutation, DeleteCustomVisualMutationVariables>(DeleteCustomVisualDocument, options);
      }
export type DeleteCustomVisualMutationHookResult = ReturnType<typeof useDeleteCustomVisualMutation>;
export type DeleteCustomVisualMutationResult = Apollo.MutationResult<DeleteCustomVisualMutation>;
export type DeleteCustomVisualMutationOptions = Apollo.BaseMutationOptions<DeleteCustomVisualMutation, DeleteCustomVisualMutationVariables>;
export const DeleteLibraryFolderDocument = gql`
    mutation deleteLibraryFolder($id: ID!) {
  deleteLibraryFolder(id: $id)
}
    `;
export type DeleteLibraryFolderMutationFn = Apollo.MutationFunction<DeleteLibraryFolderMutation, DeleteLibraryFolderMutationVariables>;

/**
 * __useDeleteLibraryFolderMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryFolderMutation, { data, loading, error }] = useDeleteLibraryFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryFolderMutation, DeleteLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryFolderMutation, DeleteLibraryFolderMutationVariables>(DeleteLibraryFolderDocument, options);
      }
export type DeleteLibraryFolderMutationHookResult = ReturnType<typeof useDeleteLibraryFolderMutation>;
export type DeleteLibraryFolderMutationResult = Apollo.MutationResult<DeleteLibraryFolderMutation>;
export type DeleteLibraryFolderMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryFolderMutation, DeleteLibraryFolderMutationVariables>;
export const DeleteLibraryMediaDocument = gql`
    mutation deleteLibraryMedia($id: ID!) {
  deleteLibraryMedia(id: $id)
}
    `;
export type DeleteLibraryMediaMutationFn = Apollo.MutationFunction<DeleteLibraryMediaMutation, DeleteLibraryMediaMutationVariables>;

/**
 * __useDeleteLibraryMediaMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryMediaMutation, { data, loading, error }] = useDeleteLibraryMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLibraryMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryMediaMutation, DeleteLibraryMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryMediaMutation, DeleteLibraryMediaMutationVariables>(DeleteLibraryMediaDocument, options);
      }
export type DeleteLibraryMediaMutationHookResult = ReturnType<typeof useDeleteLibraryMediaMutation>;
export type DeleteLibraryMediaMutationResult = Apollo.MutationResult<DeleteLibraryMediaMutation>;
export type DeleteLibraryMediaMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryMediaMutation, DeleteLibraryMediaMutationVariables>;
export const DeleteLibraryMediasDocument = gql`
    mutation deleteLibraryMedias($ids: [ID!]!) {
  deleteLibraryMedias(ids: $ids)
}
    `;
export type DeleteLibraryMediasMutationFn = Apollo.MutationFunction<DeleteLibraryMediasMutation, DeleteLibraryMediasMutationVariables>;

/**
 * __useDeleteLibraryMediasMutation__
 *
 * To run a mutation, you first call `useDeleteLibraryMediasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLibraryMediasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLibraryMediasMutation, { data, loading, error }] = useDeleteLibraryMediasMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteLibraryMediasMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLibraryMediasMutation, DeleteLibraryMediasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLibraryMediasMutation, DeleteLibraryMediasMutationVariables>(DeleteLibraryMediasDocument, options);
      }
export type DeleteLibraryMediasMutationHookResult = ReturnType<typeof useDeleteLibraryMediasMutation>;
export type DeleteLibraryMediasMutationResult = Apollo.MutationResult<DeleteLibraryMediasMutation>;
export type DeleteLibraryMediasMutationOptions = Apollo.BaseMutationOptions<DeleteLibraryMediasMutation, DeleteLibraryMediasMutationVariables>;
export const DeleteNewsDocument = gql`
    mutation deleteNews($id: ID!) {
  deleteNews(id: $id)
}
    `;
export type DeleteNewsMutationFn = Apollo.MutationFunction<DeleteNewsMutation, DeleteNewsMutationVariables>;

/**
 * __useDeleteNewsMutation__
 *
 * To run a mutation, you first call `useDeleteNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNewsMutation, { data, loading, error }] = useDeleteNewsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNewsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNewsMutation, DeleteNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNewsMutation, DeleteNewsMutationVariables>(DeleteNewsDocument, options);
      }
export type DeleteNewsMutationHookResult = ReturnType<typeof useDeleteNewsMutation>;
export type DeleteNewsMutationResult = Apollo.MutationResult<DeleteNewsMutation>;
export type DeleteNewsMutationOptions = Apollo.BaseMutationOptions<DeleteNewsMutation, DeleteNewsMutationVariables>;
export const AdminProductCategoriesForm_DeleteProductCategoryDocument = gql`
    mutation AdminProductCategoriesForm_deleteProductCategory($id: ID!) {
  deleteProductCategory(id: $id)
}
    `;
export type AdminProductCategoriesForm_DeleteProductCategoryMutationFn = Apollo.MutationFunction<AdminProductCategoriesForm_DeleteProductCategoryMutation, AdminProductCategoriesForm_DeleteProductCategoryMutationVariables>;

/**
 * __useAdminProductCategoriesForm_DeleteProductCategoryMutation__
 *
 * To run a mutation, you first call `useAdminProductCategoriesForm_DeleteProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminProductCategoriesForm_DeleteProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminProductCategoriesFormDeleteProductCategoryMutation, { data, loading, error }] = useAdminProductCategoriesForm_DeleteProductCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminProductCategoriesForm_DeleteProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminProductCategoriesForm_DeleteProductCategoryMutation, AdminProductCategoriesForm_DeleteProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminProductCategoriesForm_DeleteProductCategoryMutation, AdminProductCategoriesForm_DeleteProductCategoryMutationVariables>(AdminProductCategoriesForm_DeleteProductCategoryDocument, options);
      }
export type AdminProductCategoriesForm_DeleteProductCategoryMutationHookResult = ReturnType<typeof useAdminProductCategoriesForm_DeleteProductCategoryMutation>;
export type AdminProductCategoriesForm_DeleteProductCategoryMutationResult = Apollo.MutationResult<AdminProductCategoriesForm_DeleteProductCategoryMutation>;
export type AdminProductCategoriesForm_DeleteProductCategoryMutationOptions = Apollo.BaseMutationOptions<AdminProductCategoriesForm_DeleteProductCategoryMutation, AdminProductCategoriesForm_DeleteProductCategoryMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($roleId: ID!, $fallbackRoleId: ID!) {
  deleteRole(roleId: $roleId, fallbackRoleId: $fallbackRoleId)
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      fallbackRoleId: // value for 'fallbackRoleId'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const DeleteSalesPointImagesDocument = gql`
    mutation deleteSalesPointImages($imageIds: [ID]!, $salesPointId: ID!) {
  deleteSalesPointImages(imageIds: $imageIds, salesPointId: $salesPointId)
}
    `;
export type DeleteSalesPointImagesMutationFn = Apollo.MutationFunction<DeleteSalesPointImagesMutation, DeleteSalesPointImagesMutationVariables>;

/**
 * __useDeleteSalesPointImagesMutation__
 *
 * To run a mutation, you first call `useDeleteSalesPointImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesPointImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesPointImagesMutation, { data, loading, error }] = useDeleteSalesPointImagesMutation({
 *   variables: {
 *      imageIds: // value for 'imageIds'
 *      salesPointId: // value for 'salesPointId'
 *   },
 * });
 */
export function useDeleteSalesPointImagesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesPointImagesMutation, DeleteSalesPointImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesPointImagesMutation, DeleteSalesPointImagesMutationVariables>(DeleteSalesPointImagesDocument, options);
      }
export type DeleteSalesPointImagesMutationHookResult = ReturnType<typeof useDeleteSalesPointImagesMutation>;
export type DeleteSalesPointImagesMutationResult = Apollo.MutationResult<DeleteSalesPointImagesMutation>;
export type DeleteSalesPointImagesMutationOptions = Apollo.BaseMutationOptions<DeleteSalesPointImagesMutation, DeleteSalesPointImagesMutationVariables>;
export const DeleteSalesPointLocationsDocument = gql`
    mutation deleteSalesPointLocations($ids: [String!]!) {
  deleteSalesPointLocations(ids: $ids)
}
    `;
export type DeleteSalesPointLocationsMutationFn = Apollo.MutationFunction<DeleteSalesPointLocationsMutation, DeleteSalesPointLocationsMutationVariables>;

/**
 * __useDeleteSalesPointLocationsMutation__
 *
 * To run a mutation, you first call `useDeleteSalesPointLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalesPointLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalesPointLocationsMutation, { data, loading, error }] = useDeleteSalesPointLocationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteSalesPointLocationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalesPointLocationsMutation, DeleteSalesPointLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalesPointLocationsMutation, DeleteSalesPointLocationsMutationVariables>(DeleteSalesPointLocationsDocument, options);
      }
export type DeleteSalesPointLocationsMutationHookResult = ReturnType<typeof useDeleteSalesPointLocationsMutation>;
export type DeleteSalesPointLocationsMutationResult = Apollo.MutationResult<DeleteSalesPointLocationsMutation>;
export type DeleteSalesPointLocationsMutationOptions = Apollo.BaseMutationOptions<DeleteSalesPointLocationsMutation, DeleteSalesPointLocationsMutationVariables>;
export const DeleteTagDocument = gql`
    mutation deleteTag($id: ID!) {
  deleteTag(id: $id) {
    id
    label
    tagGroup {
      id
      name
    }
  }
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const DeleteTagGroupDocument = gql`
    mutation deleteTagGroup($id: ID!) {
  deleteTagGroup(id: $id) {
    id
  }
}
    `;
export type DeleteTagGroupMutationFn = Apollo.MutationFunction<DeleteTagGroupMutation, DeleteTagGroupMutationVariables>;

/**
 * __useDeleteTagGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagGroupMutation, { data, loading, error }] = useDeleteTagGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagGroupMutation, DeleteTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagGroupMutation, DeleteTagGroupMutationVariables>(DeleteTagGroupDocument, options);
      }
export type DeleteTagGroupMutationHookResult = ReturnType<typeof useDeleteTagGroupMutation>;
export type DeleteTagGroupMutationResult = Apollo.MutationResult<DeleteTagGroupMutation>;
export type DeleteTagGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTagGroupMutation, DeleteTagGroupMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: ID!, $providerId: ID) {
  deleteUser(id: $id, providerId: $providerId) {
    id
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const DissociateUserFromSalesPointsDocument = gql`
    mutation dissociateUserFromSalesPoints($userId: ID!, $salesPoints: [ID]!) {
  dissociateUserFromSalesPoints(userId: $userId, salesPoints: $salesPoints)
}
    `;
export type DissociateUserFromSalesPointsMutationFn = Apollo.MutationFunction<DissociateUserFromSalesPointsMutation, DissociateUserFromSalesPointsMutationVariables>;

/**
 * __useDissociateUserFromSalesPointsMutation__
 *
 * To run a mutation, you first call `useDissociateUserFromSalesPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDissociateUserFromSalesPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dissociateUserFromSalesPointsMutation, { data, loading, error }] = useDissociateUserFromSalesPointsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      salesPoints: // value for 'salesPoints'
 *   },
 * });
 */
export function useDissociateUserFromSalesPointsMutation(baseOptions?: Apollo.MutationHookOptions<DissociateUserFromSalesPointsMutation, DissociateUserFromSalesPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DissociateUserFromSalesPointsMutation, DissociateUserFromSalesPointsMutationVariables>(DissociateUserFromSalesPointsDocument, options);
      }
export type DissociateUserFromSalesPointsMutationHookResult = ReturnType<typeof useDissociateUserFromSalesPointsMutation>;
export type DissociateUserFromSalesPointsMutationResult = Apollo.MutationResult<DissociateUserFromSalesPointsMutation>;
export type DissociateUserFromSalesPointsMutationOptions = Apollo.BaseMutationOptions<DissociateUserFromSalesPointsMutation, DissociateUserFromSalesPointsMutationVariables>;
export const DissociateUsersFromSalesPointDocument = gql`
    mutation dissociateUsersFromSalesPoint($users: [ID]!, $salesPoint: ID!) {
  dissociateUsersFromSalesPoint(users: $users, salesPoint: $salesPoint)
}
    `;
export type DissociateUsersFromSalesPointMutationFn = Apollo.MutationFunction<DissociateUsersFromSalesPointMutation, DissociateUsersFromSalesPointMutationVariables>;

/**
 * __useDissociateUsersFromSalesPointMutation__
 *
 * To run a mutation, you first call `useDissociateUsersFromSalesPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDissociateUsersFromSalesPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dissociateUsersFromSalesPointMutation, { data, loading, error }] = useDissociateUsersFromSalesPointMutation({
 *   variables: {
 *      users: // value for 'users'
 *      salesPoint: // value for 'salesPoint'
 *   },
 * });
 */
export function useDissociateUsersFromSalesPointMutation(baseOptions?: Apollo.MutationHookOptions<DissociateUsersFromSalesPointMutation, DissociateUsersFromSalesPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DissociateUsersFromSalesPointMutation, DissociateUsersFromSalesPointMutationVariables>(DissociateUsersFromSalesPointDocument, options);
      }
export type DissociateUsersFromSalesPointMutationHookResult = ReturnType<typeof useDissociateUsersFromSalesPointMutation>;
export type DissociateUsersFromSalesPointMutationResult = Apollo.MutationResult<DissociateUsersFromSalesPointMutation>;
export type DissociateUsersFromSalesPointMutationOptions = Apollo.BaseMutationOptions<DissociateUsersFromSalesPointMutation, DissociateUsersFromSalesPointMutationVariables>;
export const DownloadSalesPointImagesDocument = gql`
    mutation downloadSalesPointImages($salesPointId: ID!) {
  downloadSalesPointImages(salesPointId: $salesPointId)
}
    `;
export type DownloadSalesPointImagesMutationFn = Apollo.MutationFunction<DownloadSalesPointImagesMutation, DownloadSalesPointImagesMutationVariables>;

/**
 * __useDownloadSalesPointImagesMutation__
 *
 * To run a mutation, you first call `useDownloadSalesPointImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadSalesPointImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadSalesPointImagesMutation, { data, loading, error }] = useDownloadSalesPointImagesMutation({
 *   variables: {
 *      salesPointId: // value for 'salesPointId'
 *   },
 * });
 */
export function useDownloadSalesPointImagesMutation(baseOptions?: Apollo.MutationHookOptions<DownloadSalesPointImagesMutation, DownloadSalesPointImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadSalesPointImagesMutation, DownloadSalesPointImagesMutationVariables>(DownloadSalesPointImagesDocument, options);
      }
export type DownloadSalesPointImagesMutationHookResult = ReturnType<typeof useDownloadSalesPointImagesMutation>;
export type DownloadSalesPointImagesMutationResult = Apollo.MutationResult<DownloadSalesPointImagesMutation>;
export type DownloadSalesPointImagesMutationOptions = Apollo.BaseMutationOptions<DownloadSalesPointImagesMutation, DownloadSalesPointImagesMutationVariables>;
export const EditPostTemplateDocument = gql`
    mutation editPostTemplate($publishArgs: PostTemplateArgs!, $templateId: ID!) {
  editPostTemplate(publishArgs: $publishArgs, templateId: $templateId) {
    id
    name
    type
    socialNetworks
    useSalespointsGroups
    salespointsGroupsIds
    isScheduled
    startDate
    endDate
    displayStatus
  }
}
    `;
export type EditPostTemplateMutationFn = Apollo.MutationFunction<EditPostTemplateMutation, EditPostTemplateMutationVariables>;

/**
 * __useEditPostTemplateMutation__
 *
 * To run a mutation, you first call `useEditPostTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPostTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPostTemplateMutation, { data, loading, error }] = useEditPostTemplateMutation({
 *   variables: {
 *      publishArgs: // value for 'publishArgs'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useEditPostTemplateMutation(baseOptions?: Apollo.MutationHookOptions<EditPostTemplateMutation, EditPostTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPostTemplateMutation, EditPostTemplateMutationVariables>(EditPostTemplateDocument, options);
      }
export type EditPostTemplateMutationHookResult = ReturnType<typeof useEditPostTemplateMutation>;
export type EditPostTemplateMutationResult = Apollo.MutationResult<EditPostTemplateMutation>;
export type EditPostTemplateMutationOptions = Apollo.BaseMutationOptions<EditPostTemplateMutation, EditPostTemplateMutationVariables>;
export const EmptyCartDocument = gql`
    mutation emptyCart {
  deleteCart
}
    `;
export type EmptyCartMutationFn = Apollo.MutationFunction<EmptyCartMutation, EmptyCartMutationVariables>;

/**
 * __useEmptyCartMutation__
 *
 * To run a mutation, you first call `useEmptyCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmptyCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emptyCartMutation, { data, loading, error }] = useEmptyCartMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmptyCartMutation(baseOptions?: Apollo.MutationHookOptions<EmptyCartMutation, EmptyCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmptyCartMutation, EmptyCartMutationVariables>(EmptyCartDocument, options);
      }
export type EmptyCartMutationHookResult = ReturnType<typeof useEmptyCartMutation>;
export type EmptyCartMutationResult = Apollo.MutationResult<EmptyCartMutation>;
export type EmptyCartMutationOptions = Apollo.BaseMutationOptions<EmptyCartMutation, EmptyCartMutationVariables>;
export const ExportCampaignPreordersDocument = gql`
    mutation exportCampaignPreorders($campaignId: ID!, $format: UploadFormat) {
  exportCampaignPreorders(campaignId: $campaignId, format: $format)
}
    `;
export type ExportCampaignPreordersMutationFn = Apollo.MutationFunction<ExportCampaignPreordersMutation, ExportCampaignPreordersMutationVariables>;

/**
 * __useExportCampaignPreordersMutation__
 *
 * To run a mutation, you first call `useExportCampaignPreordersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCampaignPreordersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCampaignPreordersMutation, { data, loading, error }] = useExportCampaignPreordersMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportCampaignPreordersMutation(baseOptions?: Apollo.MutationHookOptions<ExportCampaignPreordersMutation, ExportCampaignPreordersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCampaignPreordersMutation, ExportCampaignPreordersMutationVariables>(ExportCampaignPreordersDocument, options);
      }
export type ExportCampaignPreordersMutationHookResult = ReturnType<typeof useExportCampaignPreordersMutation>;
export type ExportCampaignPreordersMutationResult = Apollo.MutationResult<ExportCampaignPreordersMutation>;
export type ExportCampaignPreordersMutationOptions = Apollo.BaseMutationOptions<ExportCampaignPreordersMutation, ExportCampaignPreordersMutationVariables>;
export const ExportOrdersDocument = gql`
    mutation exportOrders($filter: OrderFilter, $salespointsIds: [ID], $groupsIds: [ID], $start: Date!, $end: Date!, $groupId: ID, $format: UploadFormat, $type: OrderExportType!) {
  exportOrders(filter: $filter, salespointsIds: $salespointsIds, groupsIds: $groupsIds, start: $start, end: $end, groupId: $groupId, format: $format, type: $type)
}
    `;
export type ExportOrdersMutationFn = Apollo.MutationFunction<ExportOrdersMutation, ExportOrdersMutationVariables>;

/**
 * __useExportOrdersMutation__
 *
 * To run a mutation, you first call `useExportOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportOrdersMutation, { data, loading, error }] = useExportOrdersMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      salespointsIds: // value for 'salespointsIds'
 *      groupsIds: // value for 'groupsIds'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      groupId: // value for 'groupId'
 *      format: // value for 'format'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useExportOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ExportOrdersMutation, ExportOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportOrdersMutation, ExportOrdersMutationVariables>(ExportOrdersDocument, options);
      }
export type ExportOrdersMutationHookResult = ReturnType<typeof useExportOrdersMutation>;
export type ExportOrdersMutationResult = Apollo.MutationResult<ExportOrdersMutation>;
export type ExportOrdersMutationOptions = Apollo.BaseMutationOptions<ExportOrdersMutation, ExportOrdersMutationVariables>;
export const ExportPreordersDocument = gql`
    mutation exportPreorders($filter: PreorderFilter, $salespointsIds: [ID!], $groupsIds: [ID!], $format: UploadFormat) {
  exportPreorders(filter: $filter, salespointsIds: $salespointsIds, groupsIds: $groupsIds, format: $format)
}
    `;
export type ExportPreordersMutationFn = Apollo.MutationFunction<ExportPreordersMutation, ExportPreordersMutationVariables>;

/**
 * __useExportPreordersMutation__
 *
 * To run a mutation, you first call `useExportPreordersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPreordersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPreordersMutation, { data, loading, error }] = useExportPreordersMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      salespointsIds: // value for 'salespointsIds'
 *      groupsIds: // value for 'groupsIds'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportPreordersMutation(baseOptions?: Apollo.MutationHookOptions<ExportPreordersMutation, ExportPreordersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPreordersMutation, ExportPreordersMutationVariables>(ExportPreordersDocument, options);
      }
export type ExportPreordersMutationHookResult = ReturnType<typeof useExportPreordersMutation>;
export type ExportPreordersMutationResult = Apollo.MutationResult<ExportPreordersMutation>;
export type ExportPreordersMutationOptions = Apollo.BaseMutationOptions<ExportPreordersMutation, ExportPreordersMutationVariables>;
export const ExportPresenceManagementDocument = gql`
    mutation exportPresenceManagement($start: Date, $end: Date, $all: Boolean!) {
  exportPresenceManagement(start: $start, end: $end, all: $all)
}
    `;
export type ExportPresenceManagementMutationFn = Apollo.MutationFunction<ExportPresenceManagementMutation, ExportPresenceManagementMutationVariables>;

/**
 * __useExportPresenceManagementMutation__
 *
 * To run a mutation, you first call `useExportPresenceManagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPresenceManagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPresenceManagementMutation, { data, loading, error }] = useExportPresenceManagementMutation({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useExportPresenceManagementMutation(baseOptions?: Apollo.MutationHookOptions<ExportPresenceManagementMutation, ExportPresenceManagementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPresenceManagementMutation, ExportPresenceManagementMutationVariables>(ExportPresenceManagementDocument, options);
      }
export type ExportPresenceManagementMutationHookResult = ReturnType<typeof useExportPresenceManagementMutation>;
export type ExportPresenceManagementMutationResult = Apollo.MutationResult<ExportPresenceManagementMutation>;
export type ExportPresenceManagementMutationOptions = Apollo.BaseMutationOptions<ExportPresenceManagementMutation, ExportPresenceManagementMutationVariables>;
export const ExportStoresDocument = gql`
    mutation exportStores($filter: SalesPointFilter, $format: ExportType) {
  exportStores(filter: $filter, format: $format)
}
    `;
export type ExportStoresMutationFn = Apollo.MutationFunction<ExportStoresMutation, ExportStoresMutationVariables>;

/**
 * __useExportStoresMutation__
 *
 * To run a mutation, you first call `useExportStoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportStoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportStoresMutation, { data, loading, error }] = useExportStoresMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportStoresMutation(baseOptions?: Apollo.MutationHookOptions<ExportStoresMutation, ExportStoresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportStoresMutation, ExportStoresMutationVariables>(ExportStoresDocument, options);
      }
export type ExportStoresMutationHookResult = ReturnType<typeof useExportStoresMutation>;
export type ExportStoresMutationResult = Apollo.MutationResult<ExportStoresMutation>;
export type ExportStoresMutationOptions = Apollo.BaseMutationOptions<ExportStoresMutation, ExportStoresMutationVariables>;
export const ExportUsersDocument = gql`
    mutation exportUsers($filter: UserFilter) {
  exportUsers(filter: $filter)
}
    `;
export type ExportUsersMutationFn = Apollo.MutationFunction<ExportUsersMutation, ExportUsersMutationVariables>;

/**
 * __useExportUsersMutation__
 *
 * To run a mutation, you first call `useExportUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUsersMutation, { data, loading, error }] = useExportUsersMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportUsersMutation(baseOptions?: Apollo.MutationHookOptions<ExportUsersMutation, ExportUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportUsersMutation, ExportUsersMutationVariables>(ExportUsersDocument, options);
      }
export type ExportUsersMutationHookResult = ReturnType<typeof useExportUsersMutation>;
export type ExportUsersMutationResult = Apollo.MutationResult<ExportUsersMutation>;
export type ExportUsersMutationOptions = Apollo.BaseMutationOptions<ExportUsersMutation, ExportUsersMutationVariables>;
export const ForceSuperAdminRoleDocument = gql`
    mutation forceSuperAdminRole($roleSlug: String!, $clientId: String, $providerId: String) {
  forceSuperAdminRole(roleSlug: $roleSlug, clientId: $clientId, providerId: $providerId) {
    jwToken
    clientId
  }
}
    `;
export type ForceSuperAdminRoleMutationFn = Apollo.MutationFunction<ForceSuperAdminRoleMutation, ForceSuperAdminRoleMutationVariables>;

/**
 * __useForceSuperAdminRoleMutation__
 *
 * To run a mutation, you first call `useForceSuperAdminRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceSuperAdminRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceSuperAdminRoleMutation, { data, loading, error }] = useForceSuperAdminRoleMutation({
 *   variables: {
 *      roleSlug: // value for 'roleSlug'
 *      clientId: // value for 'clientId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useForceSuperAdminRoleMutation(baseOptions?: Apollo.MutationHookOptions<ForceSuperAdminRoleMutation, ForceSuperAdminRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceSuperAdminRoleMutation, ForceSuperAdminRoleMutationVariables>(ForceSuperAdminRoleDocument, options);
      }
export type ForceSuperAdminRoleMutationHookResult = ReturnType<typeof useForceSuperAdminRoleMutation>;
export type ForceSuperAdminRoleMutationResult = Apollo.MutationResult<ForceSuperAdminRoleMutation>;
export type ForceSuperAdminRoleMutationOptions = Apollo.BaseMutationOptions<ForceSuperAdminRoleMutation, ForceSuperAdminRoleMutationVariables>;
export const GenerateProductDownloadLinkDocument = gql`
    mutation generateProductDownloadLink($productId: ID!, $isMedia: Boolean, $exportId: String, $packId: ID, $subId: String) {
  generateProductDownloadLink(productId: $productId, isMedia: $isMedia, exportId: $exportId, packId: $packId, subId: $subId)
}
    `;
export type GenerateProductDownloadLinkMutationFn = Apollo.MutationFunction<GenerateProductDownloadLinkMutation, GenerateProductDownloadLinkMutationVariables>;

/**
 * __useGenerateProductDownloadLinkMutation__
 *
 * To run a mutation, you first call `useGenerateProductDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProductDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProductDownloadLinkMutation, { data, loading, error }] = useGenerateProductDownloadLinkMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      isMedia: // value for 'isMedia'
 *      exportId: // value for 'exportId'
 *      packId: // value for 'packId'
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useGenerateProductDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProductDownloadLinkMutation, GenerateProductDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProductDownloadLinkMutation, GenerateProductDownloadLinkMutationVariables>(GenerateProductDownloadLinkDocument, options);
      }
export type GenerateProductDownloadLinkMutationHookResult = ReturnType<typeof useGenerateProductDownloadLinkMutation>;
export type GenerateProductDownloadLinkMutationResult = Apollo.MutationResult<GenerateProductDownloadLinkMutation>;
export type GenerateProductDownloadLinkMutationOptions = Apollo.BaseMutationOptions<GenerateProductDownloadLinkMutation, GenerateProductDownloadLinkMutationVariables>;
export const GetCustomVisualZipDocument = gql`
    mutation getCustomVisualZip($assets: [FileInfoInput]!, $salesPointId: ID!) {
  getCustomVisualZip(assets: $assets, salesPointId: $salesPointId)
}
    `;
export type GetCustomVisualZipMutationFn = Apollo.MutationFunction<GetCustomVisualZipMutation, GetCustomVisualZipMutationVariables>;

/**
 * __useGetCustomVisualZipMutation__
 *
 * To run a mutation, you first call `useGetCustomVisualZipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCustomVisualZipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCustomVisualZipMutation, { data, loading, error }] = useGetCustomVisualZipMutation({
 *   variables: {
 *      assets: // value for 'assets'
 *      salesPointId: // value for 'salesPointId'
 *   },
 * });
 */
export function useGetCustomVisualZipMutation(baseOptions?: Apollo.MutationHookOptions<GetCustomVisualZipMutation, GetCustomVisualZipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCustomVisualZipMutation, GetCustomVisualZipMutationVariables>(GetCustomVisualZipDocument, options);
      }
export type GetCustomVisualZipMutationHookResult = ReturnType<typeof useGetCustomVisualZipMutation>;
export type GetCustomVisualZipMutationResult = Apollo.MutationResult<GetCustomVisualZipMutation>;
export type GetCustomVisualZipMutationOptions = Apollo.BaseMutationOptions<GetCustomVisualZipMutation, GetCustomVisualZipMutationVariables>;
export const GetMediaDownloadLinkDocument = gql`
    mutation getMediaDownloadLink($id: ID!, $singleUse: Boolean!) {
  getMediaDownloadLink(id: $id, singleUse: $singleUse)
}
    `;
export type GetMediaDownloadLinkMutationFn = Apollo.MutationFunction<GetMediaDownloadLinkMutation, GetMediaDownloadLinkMutationVariables>;

/**
 * __useGetMediaDownloadLinkMutation__
 *
 * To run a mutation, you first call `useGetMediaDownloadLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMediaDownloadLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMediaDownloadLinkMutation, { data, loading, error }] = useGetMediaDownloadLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      singleUse: // value for 'singleUse'
 *   },
 * });
 */
export function useGetMediaDownloadLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetMediaDownloadLinkMutation, GetMediaDownloadLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetMediaDownloadLinkMutation, GetMediaDownloadLinkMutationVariables>(GetMediaDownloadLinkDocument, options);
      }
export type GetMediaDownloadLinkMutationHookResult = ReturnType<typeof useGetMediaDownloadLinkMutation>;
export type GetMediaDownloadLinkMutationResult = Apollo.MutationResult<GetMediaDownloadLinkMutation>;
export type GetMediaDownloadLinkMutationOptions = Apollo.BaseMutationOptions<GetMediaDownloadLinkMutation, GetMediaDownloadLinkMutationVariables>;
export const GetPaymentDocumentUrlDocument = gql`
    query getPaymentDocumentUrl($orderId: ID!) {
  getPaymentDocumentUrl(orderId: $orderId)
}
    `;

/**
 * __useGetPaymentDocumentUrlQuery__
 *
 * To run a query within a React component, call `useGetPaymentDocumentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentDocumentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentDocumentUrlQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetPaymentDocumentUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentDocumentUrlQuery, GetPaymentDocumentUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentDocumentUrlQuery, GetPaymentDocumentUrlQueryVariables>(GetPaymentDocumentUrlDocument, options);
      }
export function useGetPaymentDocumentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentDocumentUrlQuery, GetPaymentDocumentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentDocumentUrlQuery, GetPaymentDocumentUrlQueryVariables>(GetPaymentDocumentUrlDocument, options);
        }
export type GetPaymentDocumentUrlQueryHookResult = ReturnType<typeof useGetPaymentDocumentUrlQuery>;
export type GetPaymentDocumentUrlLazyQueryHookResult = ReturnType<typeof useGetPaymentDocumentUrlLazyQuery>;
export type GetPaymentDocumentUrlQueryResult = Apollo.QueryResult<GetPaymentDocumentUrlQuery, GetPaymentDocumentUrlQueryVariables>;
export const ImportSalesPointsJobDocument = gql`
    mutation importSalesPointsJob($file: Upload!) {
  importSalesPoints(file: $file) {
    id
    creations {
      code
      name
    }
    updates {
      code
      name
    }
    fails {
      ref
      error
      fields {
        field
        error
      }
    }
    importError
  }
}
    `;
export type ImportSalesPointsJobMutationFn = Apollo.MutationFunction<ImportSalesPointsJobMutation, ImportSalesPointsJobMutationVariables>;

/**
 * __useImportSalesPointsJobMutation__
 *
 * To run a mutation, you first call `useImportSalesPointsJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportSalesPointsJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importSalesPointsJobMutation, { data, loading, error }] = useImportSalesPointsJobMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportSalesPointsJobMutation(baseOptions?: Apollo.MutationHookOptions<ImportSalesPointsJobMutation, ImportSalesPointsJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportSalesPointsJobMutation, ImportSalesPointsJobMutationVariables>(ImportSalesPointsJobDocument, options);
      }
export type ImportSalesPointsJobMutationHookResult = ReturnType<typeof useImportSalesPointsJobMutation>;
export type ImportSalesPointsJobMutationResult = Apollo.MutationResult<ImportSalesPointsJobMutation>;
export type ImportSalesPointsJobMutationOptions = Apollo.BaseMutationOptions<ImportSalesPointsJobMutation, ImportSalesPointsJobMutationVariables>;
export const ImportUsersDocument = gql`
    mutation importUsers($file: Upload!) {
  importUsers(file: $file) {
    id
    creations {
      email
    }
    updates {
      email
    }
    fails {
      ref
      error
      fields {
        field
      }
    }
    importError
  }
}
    `;
export type ImportUsersMutationFn = Apollo.MutationFunction<ImportUsersMutation, ImportUsersMutationVariables>;

/**
 * __useImportUsersMutation__
 *
 * To run a mutation, you first call `useImportUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importUsersMutation, { data, loading, error }] = useImportUsersMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportUsersMutation(baseOptions?: Apollo.MutationHookOptions<ImportUsersMutation, ImportUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportUsersMutation, ImportUsersMutationVariables>(ImportUsersDocument, options);
      }
export type ImportUsersMutationHookResult = ReturnType<typeof useImportUsersMutation>;
export type ImportUsersMutationResult = Apollo.MutationResult<ImportUsersMutation>;
export type ImportUsersMutationOptions = Apollo.BaseMutationOptions<ImportUsersMutation, ImportUsersMutationVariables>;
export const InviteProviderDocument = gql`
    mutation inviteProvider($email: String!, $providerId: ID, $languagePreference: PlatformLanguageOption, $roleId: ID!, $loginMode: LoginMode!, $salesPointGroupsIds: [ID]) {
  inviteProvider(email: $email, providerId: $providerId, languagePreference: $languagePreference, roleId: $roleId, loginMode: $loginMode, salesPointGroupsIds: $salesPointGroupsIds) {
    id
  }
}
    `;
export type InviteProviderMutationFn = Apollo.MutationFunction<InviteProviderMutation, InviteProviderMutationVariables>;

/**
 * __useInviteProviderMutation__
 *
 * To run a mutation, you first call `useInviteProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteProviderMutation, { data, loading, error }] = useInviteProviderMutation({
 *   variables: {
 *      email: // value for 'email'
 *      providerId: // value for 'providerId'
 *      languagePreference: // value for 'languagePreference'
 *      roleId: // value for 'roleId'
 *      loginMode: // value for 'loginMode'
 *      salesPointGroupsIds: // value for 'salesPointGroupsIds'
 *   },
 * });
 */
export function useInviteProviderMutation(baseOptions?: Apollo.MutationHookOptions<InviteProviderMutation, InviteProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteProviderMutation, InviteProviderMutationVariables>(InviteProviderDocument, options);
      }
export type InviteProviderMutationHookResult = ReturnType<typeof useInviteProviderMutation>;
export type InviteProviderMutationResult = Apollo.MutationResult<InviteProviderMutation>;
export type InviteProviderMutationOptions = Apollo.BaseMutationOptions<InviteProviderMutation, InviteProviderMutationVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($email: String!, $roleId: ID!, $salespoints: [ID], $languagePreference: PlatformLanguageOption, $loginMode: LoginMode!) {
  inviteUser(email: $email, roleId: $roleId, salespoints: $salespoints, languagePreference: $languagePreference, loginMode: $loginMode) {
    id
  }
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      roleId: // value for 'roleId'
 *      salespoints: // value for 'salespoints'
 *      languagePreference: // value for 'languagePreference'
 *      loginMode: // value for 'loginMode'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    jwToken
    clientId
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginHyperSsoDocument = gql`
    mutation loginHyperSSO($token: String!) {
  loginHyperSSO(token: $token) {
    jwToken
    clientId
  }
}
    `;
export type LoginHyperSsoMutationFn = Apollo.MutationFunction<LoginHyperSsoMutation, LoginHyperSsoMutationVariables>;

/**
 * __useLoginHyperSsoMutation__
 *
 * To run a mutation, you first call `useLoginHyperSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginHyperSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginHyperSsoMutation, { data, loading, error }] = useLoginHyperSsoMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginHyperSsoMutation(baseOptions?: Apollo.MutationHookOptions<LoginHyperSsoMutation, LoginHyperSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginHyperSsoMutation, LoginHyperSsoMutationVariables>(LoginHyperSsoDocument, options);
      }
export type LoginHyperSsoMutationHookResult = ReturnType<typeof useLoginHyperSsoMutation>;
export type LoginHyperSsoMutationResult = Apollo.MutationResult<LoginHyperSsoMutation>;
export type LoginHyperSsoMutationOptions = Apollo.BaseMutationOptions<LoginHyperSsoMutation, LoginHyperSsoMutationVariables>;
export const MoveLibraryFolderDocument = gql`
    mutation moveLibraryFolder($id: ID!, $targetFolder: ID) {
  moveLibraryFolder(id: $id, targetFolder: $targetFolder)
}
    `;
export type MoveLibraryFolderMutationFn = Apollo.MutationFunction<MoveLibraryFolderMutation, MoveLibraryFolderMutationVariables>;

/**
 * __useMoveLibraryFolderMutation__
 *
 * To run a mutation, you first call `useMoveLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLibraryFolderMutation, { data, loading, error }] = useMoveLibraryFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      targetFolder: // value for 'targetFolder'
 *   },
 * });
 */
export function useMoveLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<MoveLibraryFolderMutation, MoveLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveLibraryFolderMutation, MoveLibraryFolderMutationVariables>(MoveLibraryFolderDocument, options);
      }
export type MoveLibraryFolderMutationHookResult = ReturnType<typeof useMoveLibraryFolderMutation>;
export type MoveLibraryFolderMutationResult = Apollo.MutationResult<MoveLibraryFolderMutation>;
export type MoveLibraryFolderMutationOptions = Apollo.BaseMutationOptions<MoveLibraryFolderMutation, MoveLibraryFolderMutationVariables>;
export const MoveLibraryMediaDocument = gql`
    mutation moveLibraryMedia($id: ID!, $targetFolder: ID) {
  moveLibraryMedia(id: $id, targetFolder: $targetFolder)
}
    `;
export type MoveLibraryMediaMutationFn = Apollo.MutationFunction<MoveLibraryMediaMutation, MoveLibraryMediaMutationVariables>;

/**
 * __useMoveLibraryMediaMutation__
 *
 * To run a mutation, you first call `useMoveLibraryMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLibraryMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLibraryMediaMutation, { data, loading, error }] = useMoveLibraryMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      targetFolder: // value for 'targetFolder'
 *   },
 * });
 */
export function useMoveLibraryMediaMutation(baseOptions?: Apollo.MutationHookOptions<MoveLibraryMediaMutation, MoveLibraryMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveLibraryMediaMutation, MoveLibraryMediaMutationVariables>(MoveLibraryMediaDocument, options);
      }
export type MoveLibraryMediaMutationHookResult = ReturnType<typeof useMoveLibraryMediaMutation>;
export type MoveLibraryMediaMutationResult = Apollo.MutationResult<MoveLibraryMediaMutation>;
export type MoveLibraryMediaMutationOptions = Apollo.BaseMutationOptions<MoveLibraryMediaMutation, MoveLibraryMediaMutationVariables>;
export const ProcessCloudinaryEditDocument = gql`
    mutation processCloudinaryEdit($editedImageUrl: String!, $filename: String, $originalPublicId: String) {
  processCloudinaryEdit(editedImageUrl: $editedImageUrl, filename: $filename, originalPublicId: $originalPublicId) {
    publicId
    secureUrl
    url
    width
    height
    format
    resourceType
    bytes
    createdAt
    path
    filename
  }
}
    `;
export type ProcessCloudinaryEditMutationFn = Apollo.MutationFunction<ProcessCloudinaryEditMutation, ProcessCloudinaryEditMutationVariables>;

/**
 * __useProcessCloudinaryEditMutation__
 *
 * To run a mutation, you first call `useProcessCloudinaryEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessCloudinaryEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processCloudinaryEditMutation, { data, loading, error }] = useProcessCloudinaryEditMutation({
 *   variables: {
 *      editedImageUrl: // value for 'editedImageUrl'
 *      filename: // value for 'filename'
 *      originalPublicId: // value for 'originalPublicId'
 *   },
 * });
 */
export function useProcessCloudinaryEditMutation(baseOptions?: Apollo.MutationHookOptions<ProcessCloudinaryEditMutation, ProcessCloudinaryEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessCloudinaryEditMutation, ProcessCloudinaryEditMutationVariables>(ProcessCloudinaryEditDocument, options);
      }
export type ProcessCloudinaryEditMutationHookResult = ReturnType<typeof useProcessCloudinaryEditMutation>;
export type ProcessCloudinaryEditMutationResult = Apollo.MutationResult<ProcessCloudinaryEditMutation>;
export type ProcessCloudinaryEditMutationOptions = Apollo.BaseMutationOptions<ProcessCloudinaryEditMutation, ProcessCloudinaryEditMutationVariables>;
export const BulkRemoveCartItemsDocument = gql`
    mutation bulkRemoveCartItems($items: [CartItemToDelete]) {
  bulkRemoveCartItems(items: $items) {
    userId
    total {
      basePrice {
        withTaxes
        withoutTaxes
        taxAmount
        taxPercent
      }
    }
    user {
      id
    }
    items {
      product {
        id
      }
      productId
      quantity
      type
    }
  }
}
    `;
export type BulkRemoveCartItemsMutationFn = Apollo.MutationFunction<BulkRemoveCartItemsMutation, BulkRemoveCartItemsMutationVariables>;

/**
 * __useBulkRemoveCartItemsMutation__
 *
 * To run a mutation, you first call `useBulkRemoveCartItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveCartItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveCartItemsMutation, { data, loading, error }] = useBulkRemoveCartItemsMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useBulkRemoveCartItemsMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveCartItemsMutation, BulkRemoveCartItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveCartItemsMutation, BulkRemoveCartItemsMutationVariables>(BulkRemoveCartItemsDocument, options);
      }
export type BulkRemoveCartItemsMutationHookResult = ReturnType<typeof useBulkRemoveCartItemsMutation>;
export type BulkRemoveCartItemsMutationResult = Apollo.MutationResult<BulkRemoveCartItemsMutation>;
export type BulkRemoveCartItemsMutationOptions = Apollo.BaseMutationOptions<BulkRemoveCartItemsMutation, BulkRemoveCartItemsMutationVariables>;
export const RequestResetDocument = gql`
    mutation requestReset($email: String!) {
  requestReset(email: $email)
}
    `;
export type RequestResetMutationFn = Apollo.MutationFunction<RequestResetMutation, RequestResetMutationVariables>;

/**
 * __useRequestResetMutation__
 *
 * To run a mutation, you first call `useRequestResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetMutation, { data, loading, error }] = useRequestResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetMutation, RequestResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetMutation, RequestResetMutationVariables>(RequestResetDocument, options);
      }
export type RequestResetMutationHookResult = ReturnType<typeof useRequestResetMutation>;
export type RequestResetMutationResult = Apollo.MutationResult<RequestResetMutation>;
export type RequestResetMutationOptions = Apollo.BaseMutationOptions<RequestResetMutation, RequestResetMutationVariables>;
export const ResendUserInvitationDocument = gql`
    mutation resendUserInvitation($userId: ID!, $providerId: ID) {
  resendUserInvitation(userId: $userId, providerId: $providerId)
}
    `;
export type ResendUserInvitationMutationFn = Apollo.MutationFunction<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;

/**
 * __useResendUserInvitationMutation__
 *
 * To run a mutation, you first call `useResendUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInvitationMutation, { data, loading, error }] = useResendUserInvitationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useResendUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>(ResendUserInvitationDocument, options);
      }
export type ResendUserInvitationMutationHookResult = ReturnType<typeof useResendUserInvitationMutation>;
export type ResendUserInvitationMutationResult = Apollo.MutationResult<ResendUserInvitationMutation>;
export type ResendUserInvitationMutationOptions = Apollo.BaseMutationOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;
export const ResendUserInvitationsDocument = gql`
    mutation resendUserInvitations($clientId: ID!) {
  resendUserInvitations(clientId: $clientId) {
    total
    sent
    failed
    failures {
      userId
      error
    }
  }
}
    `;
export type ResendUserInvitationsMutationFn = Apollo.MutationFunction<ResendUserInvitationsMutation, ResendUserInvitationsMutationVariables>;

/**
 * __useResendUserInvitationsMutation__
 *
 * To run a mutation, you first call `useResendUserInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInvitationsMutation, { data, loading, error }] = useResendUserInvitationsMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useResendUserInvitationsMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserInvitationsMutation, ResendUserInvitationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserInvitationsMutation, ResendUserInvitationsMutationVariables>(ResendUserInvitationsDocument, options);
      }
export type ResendUserInvitationsMutationHookResult = ReturnType<typeof useResendUserInvitationsMutation>;
export type ResendUserInvitationsMutationResult = Apollo.MutationResult<ResendUserInvitationsMutation>;
export type ResendUserInvitationsMutationOptions = Apollo.BaseMutationOptions<ResendUserInvitationsMutation, ResendUserInvitationsMutationVariables>;
export const ResetEditedProductDocument = gql`
    mutation resetEditedProduct($productId: ID!, $isMedia: Boolean = false, $packId: ID, $existingSubId: ID) {
  resetEditedProduct(productId: $productId, isMedia: $isMedia, packId: $packId, existingSubId: $existingSubId)
}
    `;
export type ResetEditedProductMutationFn = Apollo.MutationFunction<ResetEditedProductMutation, ResetEditedProductMutationVariables>;

/**
 * __useResetEditedProductMutation__
 *
 * To run a mutation, you first call `useResetEditedProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEditedProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEditedProductMutation, { data, loading, error }] = useResetEditedProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      isMedia: // value for 'isMedia'
 *      packId: // value for 'packId'
 *      existingSubId: // value for 'existingSubId'
 *   },
 * });
 */
export function useResetEditedProductMutation(baseOptions?: Apollo.MutationHookOptions<ResetEditedProductMutation, ResetEditedProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetEditedProductMutation, ResetEditedProductMutationVariables>(ResetEditedProductDocument, options);
      }
export type ResetEditedProductMutationHookResult = ReturnType<typeof useResetEditedProductMutation>;
export type ResetEditedProductMutationResult = Apollo.MutationResult<ResetEditedProductMutation>;
export type ResetEditedProductMutationOptions = Apollo.BaseMutationOptions<ResetEditedProductMutation, ResetEditedProductMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $newPassword: String!) {
  resetPassword(token: $token, newPassword: $newPassword) {
    jwToken
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SetDefaultStoreIdDocument = gql`
    mutation setDefaultStoreId($storeId: String) {
  setDefaultStoreId(defaultStoreId: $storeId) {
    id
    firstname
    lastname
    defaultStoreId
  }
}
    `;
export type SetDefaultStoreIdMutationFn = Apollo.MutationFunction<SetDefaultStoreIdMutation, SetDefaultStoreIdMutationVariables>;

/**
 * __useSetDefaultStoreIdMutation__
 *
 * To run a mutation, you first call `useSetDefaultStoreIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultStoreIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultStoreIdMutation, { data, loading, error }] = useSetDefaultStoreIdMutation({
 *   variables: {
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useSetDefaultStoreIdMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultStoreIdMutation, SetDefaultStoreIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultStoreIdMutation, SetDefaultStoreIdMutationVariables>(SetDefaultStoreIdDocument, options);
      }
export type SetDefaultStoreIdMutationHookResult = ReturnType<typeof useSetDefaultStoreIdMutation>;
export type SetDefaultStoreIdMutationResult = Apollo.MutationResult<SetDefaultStoreIdMutation>;
export type SetDefaultStoreIdMutationOptions = Apollo.BaseMutationOptions<SetDefaultStoreIdMutation, SetDefaultStoreIdMutationVariables>;
export const SetTrackingNumberDocument = gql`
    mutation setTrackingNumber($orderId: ID!, $trackingNumber: String!, $carrierName: Carrier!) {
  setTrackingNumber(orderId: $orderId, trackingNumber: $trackingNumber, carrierName: $carrierName) {
    id
    orderNumber
    trackingNumber
    trackingURL
    userId
    status
    receipt
    totalProductsQuantity
    date
    items {
      productId
      subId
      product {
        id
        name
        ref
        description
        isCustomizable
        images {
          small
        }
        tags {
          id
          label
          color
        }
        highQualityAsset {
          url
          name
        }
      }
      quantity
    }
    addresses {
      shipping {
        firstname
        lastname
        company
        phone
        address
        postalCode
        city
        country
      }
      billing {
        firstname
        lastname
        company
        phone
        address
        postalCode
        city
        country
      }
    }
    vouchers {
      name
      amount
    }
    total {
      basePrice {
        withoutTaxes
        withTaxes
        taxPercent
        taxAmount
      }
    }
    totalWithFees {
      basePrice {
        withoutTaxes
        taxPercent
        taxAmount
        withTaxes
      }
      discountedPrice {
        withoutTaxes
        withTaxes
        taxAmount
        taxPercent
      }
    }
  }
}
    `;
export type SetTrackingNumberMutationFn = Apollo.MutationFunction<SetTrackingNumberMutation, SetTrackingNumberMutationVariables>;

/**
 * __useSetTrackingNumberMutation__
 *
 * To run a mutation, you first call `useSetTrackingNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTrackingNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTrackingNumberMutation, { data, loading, error }] = useSetTrackingNumberMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      trackingNumber: // value for 'trackingNumber'
 *      carrierName: // value for 'carrierName'
 *   },
 * });
 */
export function useSetTrackingNumberMutation(baseOptions?: Apollo.MutationHookOptions<SetTrackingNumberMutation, SetTrackingNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTrackingNumberMutation, SetTrackingNumberMutationVariables>(SetTrackingNumberDocument, options);
      }
export type SetTrackingNumberMutationHookResult = ReturnType<typeof useSetTrackingNumberMutation>;
export type SetTrackingNumberMutationResult = Apollo.MutationResult<SetTrackingNumberMutation>;
export type SetTrackingNumberMutationOptions = Apollo.BaseMutationOptions<SetTrackingNumberMutation, SetTrackingNumberMutationVariables>;
export const SsoGoogleLoginDocument = gql`
    mutation ssoGoogleLogin($googleToken: String!) {
  ssoGoogleLogin(googleToken: $googleToken) {
    jwToken
    clientId
  }
}
    `;
export type SsoGoogleLoginMutationFn = Apollo.MutationFunction<SsoGoogleLoginMutation, SsoGoogleLoginMutationVariables>;

/**
 * __useSsoGoogleLoginMutation__
 *
 * To run a mutation, you first call `useSsoGoogleLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoGoogleLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoGoogleLoginMutation, { data, loading, error }] = useSsoGoogleLoginMutation({
 *   variables: {
 *      googleToken: // value for 'googleToken'
 *   },
 * });
 */
export function useSsoGoogleLoginMutation(baseOptions?: Apollo.MutationHookOptions<SsoGoogleLoginMutation, SsoGoogleLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SsoGoogleLoginMutation, SsoGoogleLoginMutationVariables>(SsoGoogleLoginDocument, options);
      }
export type SsoGoogleLoginMutationHookResult = ReturnType<typeof useSsoGoogleLoginMutation>;
export type SsoGoogleLoginMutationResult = Apollo.MutationResult<SsoGoogleLoginMutation>;
export type SsoGoogleLoginMutationOptions = Apollo.BaseMutationOptions<SsoGoogleLoginMutation, SsoGoogleLoginMutationVariables>;
export const StopAmplifyAdDocument = gql`
    mutation stopAmplifyAd($campaignId: ID!, $adId: ID!) {
  stopAmplifyAd(campaignId: $campaignId, adId: $adId)
}
    `;
export type StopAmplifyAdMutationFn = Apollo.MutationFunction<StopAmplifyAdMutation, StopAmplifyAdMutationVariables>;

/**
 * __useStopAmplifyAdMutation__
 *
 * To run a mutation, you first call `useStopAmplifyAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopAmplifyAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopAmplifyAdMutation, { data, loading, error }] = useStopAmplifyAdMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      adId: // value for 'adId'
 *   },
 * });
 */
export function useStopAmplifyAdMutation(baseOptions?: Apollo.MutationHookOptions<StopAmplifyAdMutation, StopAmplifyAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopAmplifyAdMutation, StopAmplifyAdMutationVariables>(StopAmplifyAdDocument, options);
      }
export type StopAmplifyAdMutationHookResult = ReturnType<typeof useStopAmplifyAdMutation>;
export type StopAmplifyAdMutationResult = Apollo.MutationResult<StopAmplifyAdMutation>;
export type StopAmplifyAdMutationOptions = Apollo.BaseMutationOptions<StopAmplifyAdMutation, StopAmplifyAdMutationVariables>;
export const StopAmplifyCampaignDocument = gql`
    mutation stopAmplifyCampaign($id: ID!) {
  stopAmplifyCampaign(id: $id)
}
    `;
export type StopAmplifyCampaignMutationFn = Apollo.MutationFunction<StopAmplifyCampaignMutation, StopAmplifyCampaignMutationVariables>;

/**
 * __useStopAmplifyCampaignMutation__
 *
 * To run a mutation, you first call `useStopAmplifyCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopAmplifyCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopAmplifyCampaignMutation, { data, loading, error }] = useStopAmplifyCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopAmplifyCampaignMutation(baseOptions?: Apollo.MutationHookOptions<StopAmplifyCampaignMutation, StopAmplifyCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopAmplifyCampaignMutation, StopAmplifyCampaignMutationVariables>(StopAmplifyCampaignDocument, options);
      }
export type StopAmplifyCampaignMutationHookResult = ReturnType<typeof useStopAmplifyCampaignMutation>;
export type StopAmplifyCampaignMutationResult = Apollo.MutationResult<StopAmplifyCampaignMutation>;
export type StopAmplifyCampaignMutationOptions = Apollo.BaseMutationOptions<StopAmplifyCampaignMutation, StopAmplifyCampaignMutationVariables>;
export const SubmitPreorderDocument = gql`
    mutation submitPreorder($id: ID!) {
  submitPreorder(id: $id) {
    id
    status
    ref
    submittedAt
  }
}
    `;
export type SubmitPreorderMutationFn = Apollo.MutationFunction<SubmitPreorderMutation, SubmitPreorderMutationVariables>;

/**
 * __useSubmitPreorderMutation__
 *
 * To run a mutation, you first call `useSubmitPreorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPreorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPreorderMutation, { data, loading, error }] = useSubmitPreorderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitPreorderMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPreorderMutation, SubmitPreorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPreorderMutation, SubmitPreorderMutationVariables>(SubmitPreorderDocument, options);
      }
export type SubmitPreorderMutationHookResult = ReturnType<typeof useSubmitPreorderMutation>;
export type SubmitPreorderMutationResult = Apollo.MutationResult<SubmitPreorderMutation>;
export type SubmitPreorderMutationOptions = Apollo.BaseMutationOptions<SubmitPreorderMutation, SubmitPreorderMutationVariables>;
export const UpdateAmplifyCampaignDocument = gql`
    mutation updateAmplifyCampaign($campaign: InputAmplifyCampaign!, $campaignId: ID!) {
  updateAmplifyCampaign(campaign: $campaign, campaignId: $campaignId) {
    id
  }
}
    `;
export type UpdateAmplifyCampaignMutationFn = Apollo.MutationFunction<UpdateAmplifyCampaignMutation, UpdateAmplifyCampaignMutationVariables>;

/**
 * __useUpdateAmplifyCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateAmplifyCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmplifyCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmplifyCampaignMutation, { data, loading, error }] = useUpdateAmplifyCampaignMutation({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUpdateAmplifyCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmplifyCampaignMutation, UpdateAmplifyCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAmplifyCampaignMutation, UpdateAmplifyCampaignMutationVariables>(UpdateAmplifyCampaignDocument, options);
      }
export type UpdateAmplifyCampaignMutationHookResult = ReturnType<typeof useUpdateAmplifyCampaignMutation>;
export type UpdateAmplifyCampaignMutationResult = Apollo.MutationResult<UpdateAmplifyCampaignMutation>;
export type UpdateAmplifyCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateAmplifyCampaignMutation, UpdateAmplifyCampaignMutationVariables>;
export const UpdateCampaignSupportsDocument = gql`
    mutation updateCampaignSupports($updates: [CampaignSupportUpdates!]!) {
  updateCampaignSupports(updates: $updates) {
    id
    name
    order
    url
    thumbnail
    fileType
  }
}
    `;
export type UpdateCampaignSupportsMutationFn = Apollo.MutationFunction<UpdateCampaignSupportsMutation, UpdateCampaignSupportsMutationVariables>;

/**
 * __useUpdateCampaignSupportsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignSupportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignSupportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignSupportsMutation, { data, loading, error }] = useUpdateCampaignSupportsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCampaignSupportsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignSupportsMutation, UpdateCampaignSupportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignSupportsMutation, UpdateCampaignSupportsMutationVariables>(UpdateCampaignSupportsDocument, options);
      }
export type UpdateCampaignSupportsMutationHookResult = ReturnType<typeof useUpdateCampaignSupportsMutation>;
export type UpdateCampaignSupportsMutationResult = Apollo.MutationResult<UpdateCampaignSupportsMutation>;
export type UpdateCampaignSupportsMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignSupportsMutation, UpdateCampaignSupportsMutationVariables>;
export const UpdateCartItemCommentDocument = gql`
    mutation updateCartItemComment($productId: ID!, $comment: String) {
  updateCartItemComment(productId: $productId, comment: $comment) {
    items {
      comment
    }
  }
}
    `;
export type UpdateCartItemCommentMutationFn = Apollo.MutationFunction<UpdateCartItemCommentMutation, UpdateCartItemCommentMutationVariables>;

/**
 * __useUpdateCartItemCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemCommentMutation, { data, loading, error }] = useUpdateCartItemCommentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateCartItemCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemCommentMutation, UpdateCartItemCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartItemCommentMutation, UpdateCartItemCommentMutationVariables>(UpdateCartItemCommentDocument, options);
      }
export type UpdateCartItemCommentMutationHookResult = ReturnType<typeof useUpdateCartItemCommentMutation>;
export type UpdateCartItemCommentMutationResult = Apollo.MutationResult<UpdateCartItemCommentMutation>;
export type UpdateCartItemCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemCommentMutation, UpdateCartItemCommentMutationVariables>;
export const UpdateCartItemOptionsDocument = gql`
    mutation updateCartItemOptions($item: CartItemOptionsInput!) {
  updateCartItemOptions(item: $item) {
    userId
  }
}
    `;
export type UpdateCartItemOptionsMutationFn = Apollo.MutationFunction<UpdateCartItemOptionsMutation, UpdateCartItemOptionsMutationVariables>;

/**
 * __useUpdateCartItemOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemOptionsMutation, { data, loading, error }] = useUpdateCartItemOptionsMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useUpdateCartItemOptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemOptionsMutation, UpdateCartItemOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartItemOptionsMutation, UpdateCartItemOptionsMutationVariables>(UpdateCartItemOptionsDocument, options);
      }
export type UpdateCartItemOptionsMutationHookResult = ReturnType<typeof useUpdateCartItemOptionsMutation>;
export type UpdateCartItemOptionsMutationResult = Apollo.MutationResult<UpdateCartItemOptionsMutation>;
export type UpdateCartItemOptionsMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemOptionsMutation, UpdateCartItemOptionsMutationVariables>;
export const UpdateCartItemQuantityDocument = gql`
    mutation updateCartItemQuantity($item: CartItemInput) {
  updateCartItemQuantity(item: $item) {
    userId
    total {
      basePrice {
        withTaxes
        withoutTaxes
        taxAmount
        taxPercent
      }
    }
    user {
      id
    }
    items {
      productId
      type
      quantity
      subId
      packInfo {
        id
        name
        ref
        productsInPack {
          id
          name
          ref
        }
      }
      unitPrice {
        basePrice {
          withoutTaxes
        }
      }
      variationByQuantity {
        quantity
        values
      }
      totalPrice {
        basePrice {
          withoutTaxes
        }
      }
    }
  }
}
    `;
export type UpdateCartItemQuantityMutationFn = Apollo.MutationFunction<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>;

/**
 * __useUpdateCartItemQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemQuantityMutation, { data, loading, error }] = useUpdateCartItemQuantityMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useUpdateCartItemQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>(UpdateCartItemQuantityDocument, options);
      }
export type UpdateCartItemQuantityMutationHookResult = ReturnType<typeof useUpdateCartItemQuantityMutation>;
export type UpdateCartItemQuantityMutationResult = Apollo.MutationResult<UpdateCartItemQuantityMutation>;
export type UpdateCartItemQuantityMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>;
export const UpdateCartItemsQuantitiesPerLocationDocument = gql`
    mutation updateCartItemsQuantitiesPerLocation($items: [ItemQuantitiesPerLocationInput!]!) {
  updateCartItemsQuantitiesPerLocation(items: $items) {
    userId
    items {
      subId
      quantity
      productId
      quantitiesPerLocation {
        locationId
        quantity
      }
    }
  }
}
    `;
export type UpdateCartItemsQuantitiesPerLocationMutationFn = Apollo.MutationFunction<UpdateCartItemsQuantitiesPerLocationMutation, UpdateCartItemsQuantitiesPerLocationMutationVariables>;

/**
 * __useUpdateCartItemsQuantitiesPerLocationMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemsQuantitiesPerLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemsQuantitiesPerLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemsQuantitiesPerLocationMutation, { data, loading, error }] = useUpdateCartItemsQuantitiesPerLocationMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdateCartItemsQuantitiesPerLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemsQuantitiesPerLocationMutation, UpdateCartItemsQuantitiesPerLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartItemsQuantitiesPerLocationMutation, UpdateCartItemsQuantitiesPerLocationMutationVariables>(UpdateCartItemsQuantitiesPerLocationDocument, options);
      }
export type UpdateCartItemsQuantitiesPerLocationMutationHookResult = ReturnType<typeof useUpdateCartItemsQuantitiesPerLocationMutation>;
export type UpdateCartItemsQuantitiesPerLocationMutationResult = Apollo.MutationResult<UpdateCartItemsQuantitiesPerLocationMutation>;
export type UpdateCartItemsQuantitiesPerLocationMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemsQuantitiesPerLocationMutation, UpdateCartItemsQuantitiesPerLocationMutationVariables>;
export const UpdateCloudinaryMediaDocument = gql`
    mutation updateCloudinaryMedia($publicId: String!, $transformations: [String], $newPublicId: String) {
  updateCloudinaryMedia(publicId: $publicId, transformations: $transformations, newPublicId: $newPublicId) {
    publicId
    secureUrl
    url
    width
    height
    format
    resourceType
    bytes
    createdAt
    updatedAt
  }
}
    `;
export type UpdateCloudinaryMediaMutationFn = Apollo.MutationFunction<UpdateCloudinaryMediaMutation, UpdateCloudinaryMediaMutationVariables>;

/**
 * __useUpdateCloudinaryMediaMutation__
 *
 * To run a mutation, you first call `useUpdateCloudinaryMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCloudinaryMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCloudinaryMediaMutation, { data, loading, error }] = useUpdateCloudinaryMediaMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      transformations: // value for 'transformations'
 *      newPublicId: // value for 'newPublicId'
 *   },
 * });
 */
export function useUpdateCloudinaryMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCloudinaryMediaMutation, UpdateCloudinaryMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCloudinaryMediaMutation, UpdateCloudinaryMediaMutationVariables>(UpdateCloudinaryMediaDocument, options);
      }
export type UpdateCloudinaryMediaMutationHookResult = ReturnType<typeof useUpdateCloudinaryMediaMutation>;
export type UpdateCloudinaryMediaMutationResult = Apollo.MutationResult<UpdateCloudinaryMediaMutation>;
export type UpdateCloudinaryMediaMutationOptions = Apollo.BaseMutationOptions<UpdateCloudinaryMediaMutation, UpdateCloudinaryMediaMutationVariables>;
export const UpdateHomePageSettingsDocument = gql`
    mutation updateHomePageSettings($id: ID!, $data: HomePageSettingsInput!) {
  updateHomePageSettings(id: $id, data: $data) {
    id
    lang
    slides {
      enabled
      slidesDetails {
        id
        title
        buttonText
        redirectionLink
        order
        image {
          thumbnail
          large
          medium
          small
          original
        }
      }
    }
    campaign {
      enabled
      title
      text
      buttonText
      buttonLink
      customCampaignsEnabled
      campaignIds {
        campaignId
        order
      }
      order
    }
    callToAction {
      enabled
      order
      callToActions {
        order
        title
        secondaryText
        buttonName
        redirectionUrl
      }
    }
    shop {
      enabled
      order
      title
    }
    library {
      enabled
      order
      title
    }
    planning {
      enabled
      order
      title
    }
  }
}
    `;
export type UpdateHomePageSettingsMutationFn = Apollo.MutationFunction<UpdateHomePageSettingsMutation, UpdateHomePageSettingsMutationVariables>;

/**
 * __useUpdateHomePageSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateHomePageSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHomePageSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHomePageSettingsMutation, { data, loading, error }] = useUpdateHomePageSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateHomePageSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHomePageSettingsMutation, UpdateHomePageSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHomePageSettingsMutation, UpdateHomePageSettingsMutationVariables>(UpdateHomePageSettingsDocument, options);
      }
export type UpdateHomePageSettingsMutationHookResult = ReturnType<typeof useUpdateHomePageSettingsMutation>;
export type UpdateHomePageSettingsMutationResult = Apollo.MutationResult<UpdateHomePageSettingsMutation>;
export type UpdateHomePageSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateHomePageSettingsMutation, UpdateHomePageSettingsMutationVariables>;
export const UpdateLastConnectionDocument = gql`
    mutation updateLastConnection {
  updateLastConnection
}
    `;
export type UpdateLastConnectionMutationFn = Apollo.MutationFunction<UpdateLastConnectionMutation, UpdateLastConnectionMutationVariables>;

/**
 * __useUpdateLastConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateLastConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastConnectionMutation, { data, loading, error }] = useUpdateLastConnectionMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateLastConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastConnectionMutation, UpdateLastConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastConnectionMutation, UpdateLastConnectionMutationVariables>(UpdateLastConnectionDocument, options);
      }
export type UpdateLastConnectionMutationHookResult = ReturnType<typeof useUpdateLastConnectionMutation>;
export type UpdateLastConnectionMutationResult = Apollo.MutationResult<UpdateLastConnectionMutation>;
export type UpdateLastConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateLastConnectionMutation, UpdateLastConnectionMutationVariables>;
export const UpdateLibraryFolderDocument = gql`
    mutation updateLibraryFolder($id: ID!, $updates: UpdateFolderInput!) {
  updateLibraryFolder(id: $id, updates: $updates) {
    id
    name
    parent
    salespointsGroups {
      id
    }
    validFrom
    validTo
  }
}
    `;
export type UpdateLibraryFolderMutationFn = Apollo.MutationFunction<UpdateLibraryFolderMutation, UpdateLibraryFolderMutationVariables>;

/**
 * __useUpdateLibraryFolderMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryFolderMutation, { data, loading, error }] = useUpdateLibraryFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateLibraryFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryFolderMutation, UpdateLibraryFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLibraryFolderMutation, UpdateLibraryFolderMutationVariables>(UpdateLibraryFolderDocument, options);
      }
export type UpdateLibraryFolderMutationHookResult = ReturnType<typeof useUpdateLibraryFolderMutation>;
export type UpdateLibraryFolderMutationResult = Apollo.MutationResult<UpdateLibraryFolderMutation>;
export type UpdateLibraryFolderMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryFolderMutation, UpdateLibraryFolderMutationVariables>;
export const UpdateLibraryMediaDocument = gql`
    mutation updateLibraryMedia($mediaId: ID!, $type: LibraryMediaType, $file: Upload, $chiliDetails: UpdateChiliDetails, $details: UpdateMediaDetails, $folderLocation: ID, $thumbnailFile: Upload, $deleteThumbnail: Boolean, $isDownloadByEmail: Boolean) {
  updateLibraryMedia(mediaId: $mediaId, type: $type, file: $file, chiliDetails: $chiliDetails, details: $details, folderLocation: $folderLocation, thumbnailFile: $thumbnailFile, deleteThumbnail: $deleteThumbnail, isDownloadByEmail: $isDownloadByEmail) {
    id
    name
    isDownloadByEmail
    validTo
    validFrom
    images {
      small
      thumbnail
      large
    }
    fileType
    thumbnail
  }
}
    `;
export type UpdateLibraryMediaMutationFn = Apollo.MutationFunction<UpdateLibraryMediaMutation, UpdateLibraryMediaMutationVariables>;

/**
 * __useUpdateLibraryMediaMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryMediaMutation, { data, loading, error }] = useUpdateLibraryMediaMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *      type: // value for 'type'
 *      file: // value for 'file'
 *      chiliDetails: // value for 'chiliDetails'
 *      details: // value for 'details'
 *      folderLocation: // value for 'folderLocation'
 *      thumbnailFile: // value for 'thumbnailFile'
 *      deleteThumbnail: // value for 'deleteThumbnail'
 *      isDownloadByEmail: // value for 'isDownloadByEmail'
 *   },
 * });
 */
export function useUpdateLibraryMediaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryMediaMutation, UpdateLibraryMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLibraryMediaMutation, UpdateLibraryMediaMutationVariables>(UpdateLibraryMediaDocument, options);
      }
export type UpdateLibraryMediaMutationHookResult = ReturnType<typeof useUpdateLibraryMediaMutation>;
export type UpdateLibraryMediaMutationResult = Apollo.MutationResult<UpdateLibraryMediaMutation>;
export type UpdateLibraryMediaMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryMediaMutation, UpdateLibraryMediaMutationVariables>;
export const UpdateLibraryMediasDocument = gql`
    mutation updateLibraryMedias($mediaIds: [ID!]!, $updates: BulkUpdateMediaInput!) {
  updateLibraryMedias(mediaIds: $mediaIds, updates: $updates)
}
    `;
export type UpdateLibraryMediasMutationFn = Apollo.MutationFunction<UpdateLibraryMediasMutation, UpdateLibraryMediasMutationVariables>;

/**
 * __useUpdateLibraryMediasMutation__
 *
 * To run a mutation, you first call `useUpdateLibraryMediasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLibraryMediasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLibraryMediasMutation, { data, loading, error }] = useUpdateLibraryMediasMutation({
 *   variables: {
 *      mediaIds: // value for 'mediaIds'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateLibraryMediasMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLibraryMediasMutation, UpdateLibraryMediasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLibraryMediasMutation, UpdateLibraryMediasMutationVariables>(UpdateLibraryMediasDocument, options);
      }
export type UpdateLibraryMediasMutationHookResult = ReturnType<typeof useUpdateLibraryMediasMutation>;
export type UpdateLibraryMediasMutationResult = Apollo.MutationResult<UpdateLibraryMediasMutation>;
export type UpdateLibraryMediasMutationOptions = Apollo.BaseMutationOptions<UpdateLibraryMediasMutation, UpdateLibraryMediasMutationVariables>;
export const UpdateOrderStatusDocument = gql`
    mutation updateOrderStatus($orderId: ID!, $orderStatus: Status!, $reason: String) {
  updateOrderStatus(orderId: $orderId, orderStatus: $orderStatus, reason: $reason)
}
    `;
export type UpdateOrderStatusMutationFn = Apollo.MutationFunction<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;

/**
 * __useUpdateOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStatusMutation, { data, loading, error }] = useUpdateOrderStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      orderStatus: // value for 'orderStatus'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>(UpdateOrderStatusDocument, options);
      }
export type UpdateOrderStatusMutationHookResult = ReturnType<typeof useUpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationResult = Apollo.MutationResult<UpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;
export const UpdateProviderUserBriefSpecClientsDocument = gql`
    mutation updateProviderUserBriefSpecClients($specClientIds: [ID!]!, $userId: String!, $key: String!) {
  updateProviderUserBriefSpecClients(specClientIds: $specClientIds, userId: $userId, key: $key)
}
    `;
export type UpdateProviderUserBriefSpecClientsMutationFn = Apollo.MutationFunction<UpdateProviderUserBriefSpecClientsMutation, UpdateProviderUserBriefSpecClientsMutationVariables>;

/**
 * __useUpdateProviderUserBriefSpecClientsMutation__
 *
 * To run a mutation, you first call `useUpdateProviderUserBriefSpecClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderUserBriefSpecClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderUserBriefSpecClientsMutation, { data, loading, error }] = useUpdateProviderUserBriefSpecClientsMutation({
 *   variables: {
 *      specClientIds: // value for 'specClientIds'
 *      userId: // value for 'userId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useUpdateProviderUserBriefSpecClientsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderUserBriefSpecClientsMutation, UpdateProviderUserBriefSpecClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderUserBriefSpecClientsMutation, UpdateProviderUserBriefSpecClientsMutationVariables>(UpdateProviderUserBriefSpecClientsDocument, options);
      }
export type UpdateProviderUserBriefSpecClientsMutationHookResult = ReturnType<typeof useUpdateProviderUserBriefSpecClientsMutation>;
export type UpdateProviderUserBriefSpecClientsMutationResult = Apollo.MutationResult<UpdateProviderUserBriefSpecClientsMutation>;
export type UpdateProviderUserBriefSpecClientsMutationOptions = Apollo.BaseMutationOptions<UpdateProviderUserBriefSpecClientsMutation, UpdateProviderUserBriefSpecClientsMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation updateRole($roleId: ID!, $role: UpdateRoleInput!) {
  updateRole(roleId: $roleId, role: $role) {
    id
  }
}
    `;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const UpdateSalesPointDocument = gql`
    mutation updateSalesPoint($id: ID!, $salesPoint: SalesPointUpdateInput!, $images: [Upload], $socialConfig: SocialSalespointConfigInput, $onlyStatus: Boolean) {
  updateSalesPoint(id: $id, salesPoint: $salesPoint, images: $images, socialConfig: $socialConfig, onlyStatus: $onlyStatus) {
    id
    name
    email
    code
    affairCode
    tvaCode
    enabled
    RCS
    secondaryName
    siretCode
    phone
    fax
    shortDescription
    longDescription
    languageOptions
    paymentOptions
    contactDetails {
      phoneNumber
      email
      website
      twitterLink
      facebookLink
      pinterestLink
      instagramLink
      youtubeLink
      linkedinLink
      foursquareLink
      vimeoLink
      xingLink
      contacts {
        id
        firstname
        lastname
        phone
        activity
        email
      }
    }
    location {
      address
      postalCode
      city
      country
      additionalAddress
      longitude
      latitude
    }
    images {
      thumbnail
      large
      small
      medium
      original
    }
    openingHours {
      day
      isOpen
      sessions {
        start
        end
        isAllDay
      }
    }
    users {
      id
      lastname
      firstname
      phone
      mobilePhone
      email
    }
    specialOpeningHours {
      id
      from
      to
      isOpen
      hoursFrom
      hoursTo
    }
  }
}
    `;
export type UpdateSalesPointMutationFn = Apollo.MutationFunction<UpdateSalesPointMutation, UpdateSalesPointMutationVariables>;

/**
 * __useUpdateSalesPointMutation__
 *
 * To run a mutation, you first call `useUpdateSalesPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesPointMutation, { data, loading, error }] = useUpdateSalesPointMutation({
 *   variables: {
 *      id: // value for 'id'
 *      salesPoint: // value for 'salesPoint'
 *      images: // value for 'images'
 *      socialConfig: // value for 'socialConfig'
 *      onlyStatus: // value for 'onlyStatus'
 *   },
 * });
 */
export function useUpdateSalesPointMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesPointMutation, UpdateSalesPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesPointMutation, UpdateSalesPointMutationVariables>(UpdateSalesPointDocument, options);
      }
export type UpdateSalesPointMutationHookResult = ReturnType<typeof useUpdateSalesPointMutation>;
export type UpdateSalesPointMutationResult = Apollo.MutationResult<UpdateSalesPointMutation>;
export type UpdateSalesPointMutationOptions = Apollo.BaseMutationOptions<UpdateSalesPointMutation, UpdateSalesPointMutationVariables>;
export const UpdateSalesPointLocationsDocument = gql`
    mutation updateSalesPointLocations($updates: [LocationUpdate!]!) {
  updateSalesPointLocations(updates: $updates) {
    id
  }
}
    `;
export type UpdateSalesPointLocationsMutationFn = Apollo.MutationFunction<UpdateSalesPointLocationsMutation, UpdateSalesPointLocationsMutationVariables>;

/**
 * __useUpdateSalesPointLocationsMutation__
 *
 * To run a mutation, you first call `useUpdateSalesPointLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesPointLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesPointLocationsMutation, { data, loading, error }] = useUpdateSalesPointLocationsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateSalesPointLocationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesPointLocationsMutation, UpdateSalesPointLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesPointLocationsMutation, UpdateSalesPointLocationsMutationVariables>(UpdateSalesPointLocationsDocument, options);
      }
export type UpdateSalesPointLocationsMutationHookResult = ReturnType<typeof useUpdateSalesPointLocationsMutation>;
export type UpdateSalesPointLocationsMutationResult = Apollo.MutationResult<UpdateSalesPointLocationsMutation>;
export type UpdateSalesPointLocationsMutationOptions = Apollo.BaseMutationOptions<UpdateSalesPointLocationsMutation, UpdateSalesPointLocationsMutationVariables>;
export const UpdateSocialPostDocument = gql`
    mutation updateSocialPost($publishArgs: PublishArgs!, $link: String, $dynamicLink: String, $toValidate: PublishValidateVideo, $medias: [UploadOrGalleryMediaInput], $thumb: UploadOrGalleryMediaInput, $cover: UploadOrGalleryMediaInput, $avatar: UploadOrGalleryMediaInput, $carouselItems: [InputCarouselItem!], $event: InputSocialEvent, $publishId: ID!) {
  updateSocialPost(publishArgs: $publishArgs, link: $link, dynamicLink: $dynamicLink, medias: $medias, thumb: $thumb, cover: $cover, avatar: $avatar, carouselItems: $carouselItems, event: $event, toValidate: $toValidate, publishId: $publishId) {
    validationRequiredCount
    post {
      ...PostFragment
    }
  }
}
    ${PostFragmentFragmentDoc}`;
export type UpdateSocialPostMutationFn = Apollo.MutationFunction<UpdateSocialPostMutation, UpdateSocialPostMutationVariables>;

/**
 * __useUpdateSocialPostMutation__
 *
 * To run a mutation, you first call `useUpdateSocialPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialPostMutation, { data, loading, error }] = useUpdateSocialPostMutation({
 *   variables: {
 *      publishArgs: // value for 'publishArgs'
 *      link: // value for 'link'
 *      dynamicLink: // value for 'dynamicLink'
 *      toValidate: // value for 'toValidate'
 *      medias: // value for 'medias'
 *      thumb: // value for 'thumb'
 *      cover: // value for 'cover'
 *      avatar: // value for 'avatar'
 *      carouselItems: // value for 'carouselItems'
 *      event: // value for 'event'
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useUpdateSocialPostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialPostMutation, UpdateSocialPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialPostMutation, UpdateSocialPostMutationVariables>(UpdateSocialPostDocument, options);
      }
export type UpdateSocialPostMutationHookResult = ReturnType<typeof useUpdateSocialPostMutation>;
export type UpdateSocialPostMutationResult = Apollo.MutationResult<UpdateSocialPostMutation>;
export type UpdateSocialPostMutationOptions = Apollo.BaseMutationOptions<UpdateSocialPostMutation, UpdateSocialPostMutationVariables>;
export const UpdateTagDocument = gql`
    mutation updateTag($id: ID!, $tag: TagInput!) {
  updateTag(id: $id, updates: $tag) {
    id
    label
    types
    tagGroup {
      id
      name
      tags {
        id
        label
      }
    }
    enabled
    createdAt
    updatedAt
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const UpdateTagGroupDocument = gql`
    mutation updateTagGroup($id: ID!, $updates: TagGroupInput!) {
  updateTagGroup(id: $id, updates: $updates) {
    id
    name
  }
}
    `;
export type UpdateTagGroupMutationFn = Apollo.MutationFunction<UpdateTagGroupMutation, UpdateTagGroupMutationVariables>;

/**
 * __useUpdateTagGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagGroupMutation, { data, loading, error }] = useUpdateTagGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagGroupMutation, UpdateTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagGroupMutation, UpdateTagGroupMutationVariables>(UpdateTagGroupDocument, options);
      }
export type UpdateTagGroupMutationHookResult = ReturnType<typeof useUpdateTagGroupMutation>;
export type UpdateTagGroupMutationResult = Apollo.MutationResult<UpdateTagGroupMutation>;
export type UpdateTagGroupMutationOptions = Apollo.BaseMutationOptions<UpdateTagGroupMutation, UpdateTagGroupMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $updates: UserUpdate!) {
  updateUser(id: $id, updates: $updates) {
    id
    firstname
    lastname
    phone
    mobilePhone
    activity
    email
    enabled
    salesPoints {
      id
      name
      location {
        address
        city
      }
      enabled
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UploadCustomVisualsDocument = gql`
    mutation uploadCustomVisuals($salesPointId: ID!, $assets: [Upload]!) {
  uploadCustomVisuals(salesPointId: $salesPointId, assets: $assets) {
    url
    filename
  }
}
    `;
export type UploadCustomVisualsMutationFn = Apollo.MutationFunction<UploadCustomVisualsMutation, UploadCustomVisualsMutationVariables>;

/**
 * __useUploadCustomVisualsMutation__
 *
 * To run a mutation, you first call `useUploadCustomVisualsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomVisualsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomVisualsMutation, { data, loading, error }] = useUploadCustomVisualsMutation({
 *   variables: {
 *      salesPointId: // value for 'salesPointId'
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useUploadCustomVisualsMutation(baseOptions?: Apollo.MutationHookOptions<UploadCustomVisualsMutation, UploadCustomVisualsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCustomVisualsMutation, UploadCustomVisualsMutationVariables>(UploadCustomVisualsDocument, options);
      }
export type UploadCustomVisualsMutationHookResult = ReturnType<typeof useUploadCustomVisualsMutation>;
export type UploadCustomVisualsMutationResult = Apollo.MutationResult<UploadCustomVisualsMutation>;
export type UploadCustomVisualsMutationOptions = Apollo.BaseMutationOptions<UploadCustomVisualsMutation, UploadCustomVisualsMutationVariables>;
export const UploadProviderInvoiceDocument = gql`
    mutation UploadProviderInvoice($orderId: String!, $fileName: String!, $file: Upload!) {
  uploadProviderInvoice(orderId: $orderId, fileName: $fileName, file: $file) {
    success
    message
  }
}
    `;
export type UploadProviderInvoiceMutationFn = Apollo.MutationFunction<UploadProviderInvoiceMutation, UploadProviderInvoiceMutationVariables>;

/**
 * __useUploadProviderInvoiceMutation__
 *
 * To run a mutation, you first call `useUploadProviderInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProviderInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProviderInvoiceMutation, { data, loading, error }] = useUploadProviderInvoiceMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      fileName: // value for 'fileName'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadProviderInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UploadProviderInvoiceMutation, UploadProviderInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProviderInvoiceMutation, UploadProviderInvoiceMutationVariables>(UploadProviderInvoiceDocument, options);
      }
export type UploadProviderInvoiceMutationHookResult = ReturnType<typeof useUploadProviderInvoiceMutation>;
export type UploadProviderInvoiceMutationResult = Apollo.MutationResult<UploadProviderInvoiceMutation>;
export type UploadProviderInvoiceMutationOptions = Apollo.BaseMutationOptions<UploadProviderInvoiceMutation, UploadProviderInvoiceMutationVariables>;
export const UploadToCloudinaryDocument = gql`
    mutation uploadToCloudinary($file: Upload!, $folder: String, $publicId: String, $transformation: String, $temporary: Boolean) {
  uploadToCloudinary(file: $file, folder: $folder, publicId: $publicId, transformation: $transformation, temporary: $temporary) {
    publicId
    secureUrl
    url
    width
    height
    format
    resourceType
    bytes
    createdAt
  }
}
    `;
export type UploadToCloudinaryMutationFn = Apollo.MutationFunction<UploadToCloudinaryMutation, UploadToCloudinaryMutationVariables>;

/**
 * __useUploadToCloudinaryMutation__
 *
 * To run a mutation, you first call `useUploadToCloudinaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadToCloudinaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadToCloudinaryMutation, { data, loading, error }] = useUploadToCloudinaryMutation({
 *   variables: {
 *      file: // value for 'file'
 *      folder: // value for 'folder'
 *      publicId: // value for 'publicId'
 *      transformation: // value for 'transformation'
 *      temporary: // value for 'temporary'
 *   },
 * });
 */
export function useUploadToCloudinaryMutation(baseOptions?: Apollo.MutationHookOptions<UploadToCloudinaryMutation, UploadToCloudinaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadToCloudinaryMutation, UploadToCloudinaryMutationVariables>(UploadToCloudinaryDocument, options);
      }
export type UploadToCloudinaryMutationHookResult = ReturnType<typeof useUploadToCloudinaryMutation>;
export type UploadToCloudinaryMutationResult = Apollo.MutationResult<UploadToCloudinaryMutation>;
export type UploadToCloudinaryMutationOptions = Apollo.BaseMutationOptions<UploadToCloudinaryMutation, UploadToCloudinaryMutationVariables>;
export const UpsertPreorderDocument = gql`
    mutation upsertPreorder($input: PreorderInput!) {
  upsertPreorder(input: $input) {
    id
    status
    ref
    items {
      productId
      quantity
    }
  }
}
    `;
export type UpsertPreorderMutationFn = Apollo.MutationFunction<UpsertPreorderMutation, UpsertPreorderMutationVariables>;

/**
 * __useUpsertPreorderMutation__
 *
 * To run a mutation, you first call `useUpsertPreorderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPreorderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPreorderMutation, { data, loading, error }] = useUpsertPreorderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPreorderMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPreorderMutation, UpsertPreorderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPreorderMutation, UpsertPreorderMutationVariables>(UpsertPreorderDocument, options);
      }
export type UpsertPreorderMutationHookResult = ReturnType<typeof useUpsertPreorderMutation>;
export type UpsertPreorderMutationResult = Apollo.MutationResult<UpsertPreorderMutation>;
export type UpsertPreorderMutationOptions = Apollo.BaseMutationOptions<UpsertPreorderMutation, UpsertPreorderMutationVariables>;
export const ValidateSocialPostDocument = gql`
    mutation validateSocialPost($publishId: ID!, $action: ValidationActions!, $comment: String) {
  validateSocialPost(publishId: $publishId, action: $action, comment: $comment)
}
    `;
export type ValidateSocialPostMutationFn = Apollo.MutationFunction<ValidateSocialPostMutation, ValidateSocialPostMutationVariables>;

/**
 * __useValidateSocialPostMutation__
 *
 * To run a mutation, you first call `useValidateSocialPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSocialPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSocialPostMutation, { data, loading, error }] = useValidateSocialPostMutation({
 *   variables: {
 *      publishId: // value for 'publishId'
 *      action: // value for 'action'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useValidateSocialPostMutation(baseOptions?: Apollo.MutationHookOptions<ValidateSocialPostMutation, ValidateSocialPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateSocialPostMutation, ValidateSocialPostMutationVariables>(ValidateSocialPostDocument, options);
      }
export type ValidateSocialPostMutationHookResult = ReturnType<typeof useValidateSocialPostMutation>;
export type ValidateSocialPostMutationResult = Apollo.MutationResult<ValidateSocialPostMutation>;
export type ValidateSocialPostMutationOptions = Apollo.BaseMutationOptions<ValidateSocialPostMutation, ValidateSocialPostMutationVariables>;
export const GetTagsDocument = gql`
    query getTags($limit: Int, $sort: TagsSort) {
  tags(limit: $limit, sort: $sort) {
    tags {
      id
      label
      types
      tagGroup {
        id
        name
        tags {
          id
          label
        }
      }
      enabled
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const AllRolesDocument = gql`
    query allRoles {
  allRoles {
    id
    name
    slug
    absoluteSlug
    deletedAt
  }
}
    `;

/**
 * __useAllRolesQuery__
 *
 * To run a query within a React component, call `useAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
      }
export function useAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
export type AllRolesQueryHookResult = ReturnType<typeof useAllRolesQuery>;
export type AllRolesLazyQueryHookResult = ReturnType<typeof useAllRolesLazyQuery>;
export type AllRolesQueryResult = Apollo.QueryResult<AllRolesQuery, AllRolesQueryVariables>;
export const AmplifyGetCountryListDocument = gql`
    query amplifyGetCountryList($query: String!) {
  getCountryList(query: $query) {
    data {
      facebookKey
      name
    }
  }
}
    `;

/**
 * __useAmplifyGetCountryListQuery__
 *
 * To run a query within a React component, call `useAmplifyGetCountryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmplifyGetCountryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmplifyGetCountryListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAmplifyGetCountryListQuery(baseOptions: Apollo.QueryHookOptions<AmplifyGetCountryListQuery, AmplifyGetCountryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmplifyGetCountryListQuery, AmplifyGetCountryListQueryVariables>(AmplifyGetCountryListDocument, options);
      }
export function useAmplifyGetCountryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmplifyGetCountryListQuery, AmplifyGetCountryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmplifyGetCountryListQuery, AmplifyGetCountryListQueryVariables>(AmplifyGetCountryListDocument, options);
        }
export type AmplifyGetCountryListQueryHookResult = ReturnType<typeof useAmplifyGetCountryListQuery>;
export type AmplifyGetCountryListLazyQueryHookResult = ReturnType<typeof useAmplifyGetCountryListLazyQuery>;
export type AmplifyGetCountryListQueryResult = Apollo.QueryResult<AmplifyGetCountryListQuery, AmplifyGetCountryListQueryVariables>;
export const AmplifyGetGeolocListDocument = gql`
    query amplifyGetGeolocList($query: String!) {
  getGeolocList(query: $query) {
    data {
      facebookKey
      name
    }
  }
}
    `;

/**
 * __useAmplifyGetGeolocListQuery__
 *
 * To run a query within a React component, call `useAmplifyGetGeolocListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmplifyGetGeolocListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmplifyGetGeolocListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAmplifyGetGeolocListQuery(baseOptions: Apollo.QueryHookOptions<AmplifyGetGeolocListQuery, AmplifyGetGeolocListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmplifyGetGeolocListQuery, AmplifyGetGeolocListQueryVariables>(AmplifyGetGeolocListDocument, options);
      }
export function useAmplifyGetGeolocListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmplifyGetGeolocListQuery, AmplifyGetGeolocListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmplifyGetGeolocListQuery, AmplifyGetGeolocListQueryVariables>(AmplifyGetGeolocListDocument, options);
        }
export type AmplifyGetGeolocListQueryHookResult = ReturnType<typeof useAmplifyGetGeolocListQuery>;
export type AmplifyGetGeolocListLazyQueryHookResult = ReturnType<typeof useAmplifyGetGeolocListLazyQuery>;
export type AmplifyGetGeolocListQueryResult = Apollo.QueryResult<AmplifyGetGeolocListQuery, AmplifyGetGeolocListQueryVariables>;
export const AmplifyGetInterestListDocument = gql`
    query amplifyGetInterestList($query: String!) {
  getInterestList(query: $query) {
    data {
      facebookKey
      name
    }
  }
}
    `;

/**
 * __useAmplifyGetInterestListQuery__
 *
 * To run a query within a React component, call `useAmplifyGetInterestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmplifyGetInterestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmplifyGetInterestListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAmplifyGetInterestListQuery(baseOptions: Apollo.QueryHookOptions<AmplifyGetInterestListQuery, AmplifyGetInterestListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmplifyGetInterestListQuery, AmplifyGetInterestListQueryVariables>(AmplifyGetInterestListDocument, options);
      }
export function useAmplifyGetInterestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmplifyGetInterestListQuery, AmplifyGetInterestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmplifyGetInterestListQuery, AmplifyGetInterestListQueryVariables>(AmplifyGetInterestListDocument, options);
        }
export type AmplifyGetInterestListQueryHookResult = ReturnType<typeof useAmplifyGetInterestListQuery>;
export type AmplifyGetInterestListLazyQueryHookResult = ReturnType<typeof useAmplifyGetInterestListLazyQuery>;
export type AmplifyGetInterestListQueryResult = Apollo.QueryResult<AmplifyGetInterestListQuery, AmplifyGetInterestListQueryVariables>;
export const AdCampaignForm_GetPostCalendarDetailsDocument = gql`
    query AdCampaignForm_getPostCalendarDetails($publishId: ID!) {
  me {
    id
    client {
      id
      name
    }
  }
  getPostCalendarDetails(publishId: $publishId) {
    id
    authorRole
    scheduledAt
    type
    preview {
      type
      content
      videoThumbnail
      caption
      targettedNetworks
      dates {
        start
        end
      }
    }
    amplifyAvailableTargets {
      salesPoints {
        id
        name
        isAmplifyConnectionOptionAvailable
      }
      onGlobals
      isGlobalConnectionOptionAvailable
    }
  }
}
    `;

/**
 * __useAdCampaignForm_GetPostCalendarDetailsQuery__
 *
 * To run a query within a React component, call `useAdCampaignForm_GetPostCalendarDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdCampaignForm_GetPostCalendarDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdCampaignForm_GetPostCalendarDetailsQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useAdCampaignForm_GetPostCalendarDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdCampaignForm_GetPostCalendarDetailsQuery, AdCampaignForm_GetPostCalendarDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdCampaignForm_GetPostCalendarDetailsQuery, AdCampaignForm_GetPostCalendarDetailsQueryVariables>(AdCampaignForm_GetPostCalendarDetailsDocument, options);
      }
export function useAdCampaignForm_GetPostCalendarDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdCampaignForm_GetPostCalendarDetailsQuery, AdCampaignForm_GetPostCalendarDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdCampaignForm_GetPostCalendarDetailsQuery, AdCampaignForm_GetPostCalendarDetailsQueryVariables>(AdCampaignForm_GetPostCalendarDetailsDocument, options);
        }
export type AdCampaignForm_GetPostCalendarDetailsQueryHookResult = ReturnType<typeof useAdCampaignForm_GetPostCalendarDetailsQuery>;
export type AdCampaignForm_GetPostCalendarDetailsLazyQueryHookResult = ReturnType<typeof useAdCampaignForm_GetPostCalendarDetailsLazyQuery>;
export type AdCampaignForm_GetPostCalendarDetailsQueryResult = Apollo.QueryResult<AdCampaignForm_GetPostCalendarDetailsQuery, AdCampaignForm_GetPostCalendarDetailsQueryVariables>;
export const BriefSpecClientsDocument = gql`
    query briefSpecClients($key: String, $value: String, $clientId: String, $isDeleted: Boolean, $providerUserIds: [String]) {
  briefSpecClients(key: $key, value: $value, clientId: $clientId, isDeleted: $isDeleted, providerUserIds: $providerUserIds) {
    id
    clientId
    key
    value
    label
    parentId
    providerUserIds
    children {
      id
      clientId
      key
      value
      label
      parentId
      providerUserIds
    }
  }
}
    `;

/**
 * __useBriefSpecClientsQuery__
 *
 * To run a query within a React component, call `useBriefSpecClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefSpecClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefSpecClientsQuery({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *      clientId: // value for 'clientId'
 *      isDeleted: // value for 'isDeleted'
 *      providerUserIds: // value for 'providerUserIds'
 *   },
 * });
 */
export function useBriefSpecClientsQuery(baseOptions?: Apollo.QueryHookOptions<BriefSpecClientsQuery, BriefSpecClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefSpecClientsQuery, BriefSpecClientsQueryVariables>(BriefSpecClientsDocument, options);
      }
export function useBriefSpecClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefSpecClientsQuery, BriefSpecClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefSpecClientsQuery, BriefSpecClientsQueryVariables>(BriefSpecClientsDocument, options);
        }
export type BriefSpecClientsQueryHookResult = ReturnType<typeof useBriefSpecClientsQuery>;
export type BriefSpecClientsLazyQueryHookResult = ReturnType<typeof useBriefSpecClientsLazyQuery>;
export type BriefSpecClientsQueryResult = Apollo.QueryResult<BriefSpecClientsQuery, BriefSpecClientsQueryVariables>;
export const CampaignByIdDocument = gql`
    query campaignById($id: ID!, $salespointId: ID) {
  campaignById(id: $id) {
    id
    name
    enabled
    description
    isScheduled
    startDate
    endDate
    displayMode
    startDisplayDate
    endDisplayDate
    hasPreorderDates
    preorderStartDate
    preorderEndDate
    preorderReminderDays
    hasPreorderProducts
    preorderProductsCount
    preorderEngagedSalespointsCount
    preorderTotalSalespointsCount
    preorderDaysRemaining
    preorderStatus(salespointId: $salespointId)
    color
    isLocal
    type
    userId
    userHasWritePermission
    tags {
      id
      label
      color
    }
    document {
      name
      publicUrl
    }
    supports {
      id
      name
      order
      url
      thumbnail
      fileType
      type
    }
    isNew
    image {
      id
      thumbnail
      large
      medium
      small
      original
    }
    medias {
      id
      name
      fileType
      tempUrl
      thumbnail
      type
      images {
        thumbnail
        small
        medium
        large
      }
      salespointsGroups {
        id
        name
      }
      campaigns {
        id
        name
      }
      details {
        description
        tips
        mimetype
        tags {
          id
          label
          tagGroup {
            id
          }
        }
      }
    }
    useSalespointGroups
    salespointGroups {
      id
      name
    }
    tempUrl
    hasProducts
    productsAndCount(preorderAvailable: false) {
      products {
        isPack
        id
        name
        images {
          thumbnail
          large
          medium
          small
          original
        }
        price {
          basePrice {
            withTaxes
            withoutTaxes
            taxAmount
            taxPercent
          }
        }
        priceType
        catalogPriceLevels {
          quantity
          price
        }
        fixPricesLevelsByQuantity {
          quantity
          price {
            basePrice {
              withTaxes
              withoutTaxes
            }
          }
        }
        description
        isCustomizable
        highQualityAsset {
          url
          name
        }
        lowQualityAsset {
          url
          name
        }
        tags {
          id
          label
          color
        }
        tips
        type
        description
        ref
        isCustomizable
        tips
        productOptions {
          id
          price
        }
        shouldHaveAtLeastOneOptionSelected
        isShowcase
        isBriefCrm
        showcaseText
      }
      count
    }
    categories {
      id
      name
    }
    postTemplates {
      id
      name
      mongoId
      salespointsGroupsIds
    }
  }
}
    `;

/**
 * __useCampaignByIdQuery__
 *
 * To run a query within a React component, call `useCampaignByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      salespointId: // value for 'salespointId'
 *   },
 * });
 */
export function useCampaignByIdQuery(baseOptions: Apollo.QueryHookOptions<CampaignByIdQuery, CampaignByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignByIdQuery, CampaignByIdQueryVariables>(CampaignByIdDocument, options);
      }
export function useCampaignByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignByIdQuery, CampaignByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignByIdQuery, CampaignByIdQueryVariables>(CampaignByIdDocument, options);
        }
export type CampaignByIdQueryHookResult = ReturnType<typeof useCampaignByIdQuery>;
export type CampaignByIdLazyQueryHookResult = ReturnType<typeof useCampaignByIdLazyQuery>;
export type CampaignByIdQueryResult = Apollo.QueryResult<CampaignByIdQuery, CampaignByIdQueryVariables>;
export const CampaignDetailActionMetricsDocument = gql`
    query campaignDetailActionMetrics($dateRange: DateRange!, $campaignType: CampaignType!, $campaignId: ID, $salespointsIds: [ID!], $tableParams: TableParams) {
  campaignDetailActionMetrics(dateRange: $dateRange, campaignId: $campaignId, salespointsIds: $salespointsIds, campaignType: $campaignType, tableParams: $tableParams) {
    total
    campaignActionsDetail {
      id
      actions
      views
      name
      subContent {
        actions {
          downloads
          orders
          copies
          posts
        }
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCampaignDetailActionMetricsQuery__
 *
 * To run a query within a React component, call `useCampaignDetailActionMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDetailActionMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDetailActionMetricsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      campaignType: // value for 'campaignType'
 *      campaignId: // value for 'campaignId'
 *      salespointsIds: // value for 'salespointsIds'
 *      tableParams: // value for 'tableParams'
 *   },
 * });
 */
export function useCampaignDetailActionMetricsQuery(baseOptions: Apollo.QueryHookOptions<CampaignDetailActionMetricsQuery, CampaignDetailActionMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDetailActionMetricsQuery, CampaignDetailActionMetricsQueryVariables>(CampaignDetailActionMetricsDocument, options);
      }
export function useCampaignDetailActionMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDetailActionMetricsQuery, CampaignDetailActionMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDetailActionMetricsQuery, CampaignDetailActionMetricsQueryVariables>(CampaignDetailActionMetricsDocument, options);
        }
export type CampaignDetailActionMetricsQueryHookResult = ReturnType<typeof useCampaignDetailActionMetricsQuery>;
export type CampaignDetailActionMetricsLazyQueryHookResult = ReturnType<typeof useCampaignDetailActionMetricsLazyQuery>;
export type CampaignDetailActionMetricsQueryResult = Apollo.QueryResult<CampaignDetailActionMetricsQuery, CampaignDetailActionMetricsQueryVariables>;
export const CampaignInfoDocument = gql`
    query campaignInfo($id: ID!, $offset: Int, $limit: Int) {
  campaignById(id: $id) {
    id
    enabled
    name
    hideOnPlanning
    description
    isScheduled
    startDate
    endDate
    displayMode
    startDisplayDate
    endDisplayDate
    color
    useSalespointGroups
    salespointId
    supports {
      id
      name
      order
      url
      thumbnail
      fileType
    }
    tags {
      id
      label
      color
    }
    document {
      name
      tempUrl
    }
    isNew
    image {
      id
      thumbnail
      large
      medium
      small
      original
    }
    medias(offset: $offset, limit: $limit) {
      id
      name
    }
    salespointGroups {
      id
      name
    }
    tempUrl
    hasProducts
    productsAndCount(offset: $offset, limit: $limit, showDisabled: true) {
      products {
        id
        name
      }
      count
    }
    categories {
      id
      name
    }
    salespoint {
      id
      name
    }
    isNational
  }
}
    `;

/**
 * __useCampaignInfoQuery__
 *
 * To run a query within a React component, call `useCampaignInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCampaignInfoQuery(baseOptions: Apollo.QueryHookOptions<CampaignInfoQuery, CampaignInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignInfoQuery, CampaignInfoQueryVariables>(CampaignInfoDocument, options);
      }
export function useCampaignInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignInfoQuery, CampaignInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignInfoQuery, CampaignInfoQueryVariables>(CampaignInfoDocument, options);
        }
export type CampaignInfoQueryHookResult = ReturnType<typeof useCampaignInfoQuery>;
export type CampaignInfoLazyQueryHookResult = ReturnType<typeof useCampaignInfoLazyQuery>;
export type CampaignInfoQueryResult = Apollo.QueryResult<CampaignInfoQuery, CampaignInfoQueryVariables>;
export const CampaignPreorderProductsDocument = gql`
    query campaignPreorderProducts($campaignId: ID!) {
  products(filters: [{id: "campaigns", campaigns: [$campaignId]}, {id: "type", type: [physical]}], limit: 300, preorderAvailable: true) {
    count
    products {
      id
      name
      ref
      preorderAvailable
      packagingUnit
      isStockEnabled
      stock
      isMinimumOrderEnabled
      minimumOrder
      isMaximumOrderEnabled
      maximumOrder {
        period
        quantity
      }
      priceType
      price {
        basePrice {
          withTaxes
          withoutTaxes
          taxAmount
          taxPercent
        }
      }
      catalogPrice
      catalogPriceLevels {
        quantity
        price
      }
      catalogFixPricesLevelsByQuantity {
        quantity
        price
      }
      fixPricesLevelsByQuantity {
        quantity
        price {
          basePrice {
            withTaxes
            withoutTaxes
            taxAmount
            taxPercent
          }
        }
      }
      images {
        id
        original
        thumbnail
        small
      }
      availableQuantity {
        min
        max
      }
    }
  }
}
    `;

/**
 * __useCampaignPreorderProductsQuery__
 *
 * To run a query within a React component, call `useCampaignPreorderProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignPreorderProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignPreorderProductsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignPreorderProductsQuery(baseOptions: Apollo.QueryHookOptions<CampaignPreorderProductsQuery, CampaignPreorderProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignPreorderProductsQuery, CampaignPreorderProductsQueryVariables>(CampaignPreorderProductsDocument, options);
      }
export function useCampaignPreorderProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignPreorderProductsQuery, CampaignPreorderProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignPreorderProductsQuery, CampaignPreorderProductsQueryVariables>(CampaignPreorderProductsDocument, options);
        }
export type CampaignPreorderProductsQueryHookResult = ReturnType<typeof useCampaignPreorderProductsQuery>;
export type CampaignPreorderProductsLazyQueryHookResult = ReturnType<typeof useCampaignPreorderProductsLazyQuery>;
export type CampaignPreorderProductsQueryResult = Apollo.QueryResult<CampaignPreorderProductsQuery, CampaignPreorderProductsQueryVariables>;
export const CampaignsQueryDocument = gql`
    query campaignsQuery($salespointGroups: [ID], $category: ID, $dateRange: DateRangeOptional, $types: [CampaignType!], $scopes: [CampaignScope], $tagIds: [ID!], $salespointIds: [ID!], $categoryIds: [ID!], $keyword: String, $ids: [ID!]) {
  campaigns(salespointGroups: $salespointGroups, category: $category, dateRange: $dateRange, types: $types, scopes: $scopes, salespointIds: $salespointIds, categoryIds: $categoryIds, tagIds: $tagIds, keyword: $keyword, ids: $ids) {
    campaigns {
      id
      name
      enabled
      description
      isScheduled
      startDate
      endDate
      displayMode
      startDisplayDate
      endDisplayDate
      hideOnPlanning
      isLocal
      isVisible
      color
      tags {
        id
        label
        color
      }
      isNew
      image {
        thumbnail
        large
        medium
        small
        original
      }
      hasProducts
      hasPreorderProducts
      preorderEndDate
      preorderDaysRemaining
      medias {
        id
      }
      createdAt
      userHasWritePermission
      salespoint {
        id
        name
      }
      categories {
        clientId
        id
        name
        displayCampaignsCategory
      }
    }
  }
}
    `;

/**
 * __useCampaignsQueryQuery__
 *
 * To run a query within a React component, call `useCampaignsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQueryQuery({
 *   variables: {
 *      salespointGroups: // value for 'salespointGroups'
 *      category: // value for 'category'
 *      dateRange: // value for 'dateRange'
 *      types: // value for 'types'
 *      scopes: // value for 'scopes'
 *      tagIds: // value for 'tagIds'
 *      salespointIds: // value for 'salespointIds'
 *      categoryIds: // value for 'categoryIds'
 *      keyword: // value for 'keyword'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCampaignsQueryQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsQueryQuery, CampaignsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQueryQuery, CampaignsQueryQueryVariables>(CampaignsQueryDocument, options);
      }
export function useCampaignsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQueryQuery, CampaignsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQueryQuery, CampaignsQueryQueryVariables>(CampaignsQueryDocument, options);
        }
export type CampaignsQueryQueryHookResult = ReturnType<typeof useCampaignsQueryQuery>;
export type CampaignsQueryLazyQueryHookResult = ReturnType<typeof useCampaignsQueryLazyQuery>;
export type CampaignsQueryQueryResult = Apollo.QueryResult<CampaignsQueryQuery, CampaignsQueryQueryVariables>;
export const CampaignsForPreorderFilterDocument = gql`
    query campaignsForPreorderFilter($salespointGroups: [ID]) {
  campaignsPerPeriods(types: [DEFAULT, MARKETING], salespointGroups: $salespointGroups) {
    allCampaigns {
      id
      name
      hasPreorderProducts
    }
  }
}
    `;

/**
 * __useCampaignsForPreorderFilterQuery__
 *
 * To run a query within a React component, call `useCampaignsForPreorderFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsForPreorderFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsForPreorderFilterQuery({
 *   variables: {
 *      salespointGroups: // value for 'salespointGroups'
 *   },
 * });
 */
export function useCampaignsForPreorderFilterQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsForPreorderFilterQuery, CampaignsForPreorderFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsForPreorderFilterQuery, CampaignsForPreorderFilterQueryVariables>(CampaignsForPreorderFilterDocument, options);
      }
export function useCampaignsForPreorderFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsForPreorderFilterQuery, CampaignsForPreorderFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsForPreorderFilterQuery, CampaignsForPreorderFilterQueryVariables>(CampaignsForPreorderFilterDocument, options);
        }
export type CampaignsForPreorderFilterQueryHookResult = ReturnType<typeof useCampaignsForPreorderFilterQuery>;
export type CampaignsForPreorderFilterLazyQueryHookResult = ReturnType<typeof useCampaignsForPreorderFilterLazyQuery>;
export type CampaignsForPreorderFilterQueryResult = Apollo.QueryResult<CampaignsForPreorderFilterQuery, CampaignsForPreorderFilterQueryVariables>;
export const CampaignsPerPeriodsDocument = gql`
    query campaignsPerPeriods($salespointGroups: [ID], $category: ID, $types: [CampaignType!]!, $scopes: [CampaignScope], $tagIds: [ID!], $salespointIds: [ID!], $categoryIds: [ID!], $keyword: String, $preorderStatuses: [CampaignPreorderStatus!], $salespointId: ID) {
  campaignsPerPeriods(salespointGroups: $salespointGroups, category: $category, types: $types, scopes: $scopes, salespointIds: $salespointIds, categoryIds: $categoryIds, tagIds: $tagIds, keyword: $keyword, preorderStatuses: $preorderStatuses, salespointId: $salespointId) {
    allCampaigns {
      ...CampaignFragment
      hasPreorderProducts
      preorderEndDate
      preorderDaysRemaining
      preorderStatus(salespointId: $salespointId)
    }
    ongoing {
      ...CampaignFragment
      hasPreorderProducts
      preorderEndDate
      preorderDaysRemaining
      preorderStatus(salespointId: $salespointId)
    }
    scheduled {
      ...CampaignFragment
      hasPreorderProducts
      preorderEndDate
      preorderDaysRemaining
      preorderStatus(salespointId: $salespointId)
    }
    permanent {
      ...CampaignFragment
      hasPreorderProducts
      preorderEndDate
      preorderDaysRemaining
      preorderStatus(salespointId: $salespointId)
    }
    ended {
      ...CampaignFragment
      hasPreorderProducts
      preorderEndDate
      preorderDaysRemaining
      preorderStatus(salespointId: $salespointId)
    }
  }
}
    ${CampaignFragmentFragmentDoc}`;

/**
 * __useCampaignsPerPeriodsQuery__
 *
 * To run a query within a React component, call `useCampaignsPerPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsPerPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsPerPeriodsQuery({
 *   variables: {
 *      salespointGroups: // value for 'salespointGroups'
 *      category: // value for 'category'
 *      types: // value for 'types'
 *      scopes: // value for 'scopes'
 *      tagIds: // value for 'tagIds'
 *      salespointIds: // value for 'salespointIds'
 *      categoryIds: // value for 'categoryIds'
 *      keyword: // value for 'keyword'
 *      preorderStatuses: // value for 'preorderStatuses'
 *      salespointId: // value for 'salespointId'
 *   },
 * });
 */
export function useCampaignsPerPeriodsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsPerPeriodsQuery, CampaignsPerPeriodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsPerPeriodsQuery, CampaignsPerPeriodsQueryVariables>(CampaignsPerPeriodsDocument, options);
      }
export function useCampaignsPerPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsPerPeriodsQuery, CampaignsPerPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsPerPeriodsQuery, CampaignsPerPeriodsQueryVariables>(CampaignsPerPeriodsDocument, options);
        }
export type CampaignsPerPeriodsQueryHookResult = ReturnType<typeof useCampaignsPerPeriodsQuery>;
export type CampaignsPerPeriodsLazyQueryHookResult = ReturnType<typeof useCampaignsPerPeriodsLazyQuery>;
export type CampaignsPerPeriodsQueryResult = Apollo.QueryResult<CampaignsPerPeriodsQuery, CampaignsPerPeriodsQueryVariables>;
export const CanRegisterDocument = gql`
    query canRegister($token: String!) {
  canRegister(token: $token) {
    email
    userId
    error
    loginViaSso
    firstname
    lastname
    phone
    mobilePhone
    activity
    roleId
    roleSlug
    roleName
  }
}
    `;

/**
 * __useCanRegisterQuery__
 *
 * To run a query within a React component, call `useCanRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanRegisterQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCanRegisterQuery(baseOptions: Apollo.QueryHookOptions<CanRegisterQuery, CanRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanRegisterQuery, CanRegisterQueryVariables>(CanRegisterDocument, options);
      }
export function useCanRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanRegisterQuery, CanRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanRegisterQuery, CanRegisterQueryVariables>(CanRegisterDocument, options);
        }
export type CanRegisterQueryHookResult = ReturnType<typeof useCanRegisterQuery>;
export type CanRegisterLazyQueryHookResult = ReturnType<typeof useCanRegisterLazyQuery>;
export type CanRegisterQueryResult = Apollo.QueryResult<CanRegisterQuery, CanRegisterQueryVariables>;
export const CanResetPasswordDocument = gql`
    query canResetPassword($token: String!) {
  canResetPassword(token: $token)
}
    `;

/**
 * __useCanResetPasswordQuery__
 *
 * To run a query within a React component, call `useCanResetPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanResetPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanResetPasswordQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCanResetPasswordQuery(baseOptions: Apollo.QueryHookOptions<CanResetPasswordQuery, CanResetPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanResetPasswordQuery, CanResetPasswordQueryVariables>(CanResetPasswordDocument, options);
      }
export function useCanResetPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanResetPasswordQuery, CanResetPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanResetPasswordQuery, CanResetPasswordQueryVariables>(CanResetPasswordDocument, options);
        }
export type CanResetPasswordQueryHookResult = ReturnType<typeof useCanResetPasswordQuery>;
export type CanResetPasswordLazyQueryHookResult = ReturnType<typeof useCanResetPasswordLazyQuery>;
export type CanResetPasswordQueryResult = Apollo.QueryResult<CanResetPasswordQuery, CanResetPasswordQueryVariables>;
export const CartDocument = gql`
    query cart {
  cart {
    userId
    shippingFees {
      fees
      providerId
      error
    }
    totalWithShippingFees {
      basePrice {
        withTaxes
        withoutTaxes
        taxAmount
        taxPercent
      }
    }
    items {
      packInfo {
        id
        name
        ref
        productsInPack {
          id
          name
          ref
        }
      }
      subId
      comment
      productId
      providerId
      files {
        id
        url
        originalName
      }
      options {
        id
        name
        price
        image {
          id
          small
        }
        description
      }
      variationByQuantity {
        quantity
        values
      }
      unitPrice {
        basePrice {
          withoutTaxes
        }
      }
      totalPrice {
        basePrice {
          withoutTaxes
        }
      }
      totalPricePerLocations {
        locationId
        quantity
        basePrice {
          withoutTaxes
        }
      }
      product {
        id
        providerId
        name
        description
        isMaximumOrderEnabled
        providerName
        maximumOrder {
          quantity
          period
        }
        isMinimumOrderEnabled
        minimumOrder
        availableQuantity {
          min
          max
        }
        catalogFixPricesLevelsByQuantity {
          quantity
          price
        }
        catalogPriceLevels {
          quantity
          price
        }
        catalogPrice
        fixPricesLevelsByQuantity {
          quantity
          price {
            basePrice {
              withTaxes
              withoutTaxes
              taxAmount
              taxPercent
            }
          }
        }
        priceType
        isStockEnabled
        stock
        packagingUnit
        price {
          basePrice {
            withTaxes
            withoutTaxes
            taxAmount
            taxPercent
          }
        }
        isCustomizable
        type
        images {
          thumbnail
          large
          small
          medium
          original
        }
        tags {
          id
          label
          color
        }
        productOptions {
          id
        }
        isManyOptionsSelectable
        shouldHaveAtLeastOneOptionSelected
        shouldHaveExactOptionsSelected
        numberOfExactOptions
        isCommentEnabled
        userCanAddFiles
        isRoutingFileEnabled
        userCanComment
        userCanUpload
      }
      type
      quantity
      selectedFixPrice
      quantitiesPerLocation {
        locationId
        quantity
      }
    }
    vouchers {
      name
      amount
    }
    total {
      basePrice {
        withTaxes
        withoutTaxes
        taxAmount
        taxPercent
      }
    }
  }
}
    `;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartQuery(baseOptions?: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const CheckCartProductsAvailabilityDocument = gql`
    query checkCartProductsAvailability {
  checkCartProductsAvailability
}
    `;

/**
 * __useCheckCartProductsAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckCartProductsAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCartProductsAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCartProductsAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckCartProductsAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<CheckCartProductsAvailabilityQuery, CheckCartProductsAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCartProductsAvailabilityQuery, CheckCartProductsAvailabilityQueryVariables>(CheckCartProductsAvailabilityDocument, options);
      }
export function useCheckCartProductsAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCartProductsAvailabilityQuery, CheckCartProductsAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCartProductsAvailabilityQuery, CheckCartProductsAvailabilityQueryVariables>(CheckCartProductsAvailabilityDocument, options);
        }
export type CheckCartProductsAvailabilityQueryHookResult = ReturnType<typeof useCheckCartProductsAvailabilityQuery>;
export type CheckCartProductsAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckCartProductsAvailabilityLazyQuery>;
export type CheckCartProductsAvailabilityQueryResult = Apollo.QueryResult<CheckCartProductsAvailabilityQuery, CheckCartProductsAvailabilityQueryVariables>;
export const ClientBriefOptionsDocument = gql`
    query clientBriefOptions {
  me {
    id
    providerBriefClientId
    client {
      briefOptions {
        ... on BriefOptions {
          type
          internalReference
          visualReference
          delivery
          wishDelivery
          budget
          workflow
          contextGoalsIssues
          description
          targeting
          offer
          customerJourney
          campaignDates
          launchDates
          validityDates
          campaignType
          lever
          support
          workType
          campaignLevel
          governance
          groupedNotifications
        }
        ... on BriefHyundaiOptions {
          type
          internalReference
          visualReference
          delivery
          wishDelivery
          budget
          budgetType
          activityType
          modelType
          communicationType
          briefType
          workflow
          contextGoalsIssues
          description
          targeting
          offer
          customerJourney
          campaignDates
          launchDates
          validityDates
          campaignType
          lever
          support
          workType
          campaignLevel
        }
      }
    }
  }
}
    `;

/**
 * __useClientBriefOptionsQuery__
 *
 * To run a query within a React component, call `useClientBriefOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientBriefOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientBriefOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientBriefOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ClientBriefOptionsQuery, ClientBriefOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientBriefOptionsQuery, ClientBriefOptionsQueryVariables>(ClientBriefOptionsDocument, options);
      }
export function useClientBriefOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientBriefOptionsQuery, ClientBriefOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientBriefOptionsQuery, ClientBriefOptionsQueryVariables>(ClientBriefOptionsDocument, options);
        }
export type ClientBriefOptionsQueryHookResult = ReturnType<typeof useClientBriefOptionsQuery>;
export type ClientBriefOptionsLazyQueryHookResult = ReturnType<typeof useClientBriefOptionsLazyQuery>;
export type ClientBriefOptionsQueryResult = Apollo.QueryResult<ClientBriefOptionsQuery, ClientBriefOptionsQueryVariables>;
export const ClientNameDocument = gql`
    query clientName {
  me {
    id
    client {
      id
      name
    }
  }
}
    `;

/**
 * __useClientNameQuery__
 *
 * To run a query within a React component, call `useClientNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientNameQuery(baseOptions?: Apollo.QueryHookOptions<ClientNameQuery, ClientNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientNameQuery, ClientNameQueryVariables>(ClientNameDocument, options);
      }
export function useClientNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientNameQuery, ClientNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientNameQuery, ClientNameQueryVariables>(ClientNameDocument, options);
        }
export type ClientNameQueryHookResult = ReturnType<typeof useClientNameQuery>;
export type ClientNameLazyQueryHookResult = ReturnType<typeof useClientNameLazyQuery>;
export type ClientNameQueryResult = Apollo.QueryResult<ClientNameQuery, ClientNameQueryVariables>;
export const ClientSsoDocument = gql`
    query clientSso {
  me {
    id
    client {
      id
      defaultSsoId
    }
  }
}
    `;

/**
 * __useClientSsoQuery__
 *
 * To run a query within a React component, call `useClientSsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientSsoQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientSsoQuery(baseOptions?: Apollo.QueryHookOptions<ClientSsoQuery, ClientSsoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientSsoQuery, ClientSsoQueryVariables>(ClientSsoDocument, options);
      }
export function useClientSsoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientSsoQuery, ClientSsoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientSsoQuery, ClientSsoQueryVariables>(ClientSsoDocument, options);
        }
export type ClientSsoQueryHookResult = ReturnType<typeof useClientSsoQuery>;
export type ClientSsoLazyQueryHookResult = ReturnType<typeof useClientSsoLazyQuery>;
export type ClientSsoQueryResult = Apollo.QueryResult<ClientSsoQuery, ClientSsoQueryVariables>;
export const ClientsOfUserDocument = gql`
    query clientsOfUser {
  clientsOfUser {
    name
    clientId
    providerInfo {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useClientsOfUserQuery__
 *
 * To run a query within a React component, call `useClientsOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsOfUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientsOfUserQuery(baseOptions?: Apollo.QueryHookOptions<ClientsOfUserQuery, ClientsOfUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsOfUserQuery, ClientsOfUserQueryVariables>(ClientsOfUserDocument, options);
      }
export function useClientsOfUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsOfUserQuery, ClientsOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsOfUserQuery, ClientsOfUserQueryVariables>(ClientsOfUserDocument, options);
        }
export type ClientsOfUserQueryHookResult = ReturnType<typeof useClientsOfUserQuery>;
export type ClientsOfUserLazyQueryHookResult = ReturnType<typeof useClientsOfUserLazyQuery>;
export type ClientsOfUserQueryResult = Apollo.QueryResult<ClientsOfUserQuery, ClientsOfUserQueryVariables>;
export const CombinedAmplifyCampaignsListQueryDocument = gql`
    query combinedAmplifyCampaignsListQuery($postCalendarId: ID, $target: TargetType!, $salesPoints: [ID], $globals: [String], $startAt: Date, $endAt: Date, $offset: Int, $limit: Int, $socialNetwork: String, $sort: AmplifyCampaignsListSortArgs) {
  getAmplifyCampaignsTotalMetrics(postCalendarId: $postCalendarId, target: $target, salesPoints: $salesPoints, socialNetwork: $socialNetwork, globals: $globals, startAt: $startAt, endAt: $endAt) {
    campaignsCount
    spentBudget
    spentReach
    spentInteractions
  }
  getAmplifyCampaigns(postCalendarId: $postCalendarId, target: $target, socialNetwork: $socialNetwork, salesPoints: $salesPoints, globals: $globals, startAt: $startAt, endAt: $endAt, offset: $offset, limit: $limit, sort: $sort) {
    count
    campaigns {
      id
      name
      target {
        type
        salesPoints {
          name
        }
        onGlobals
      }
      socialNetwork
      authorRole
      author {
        id
        fullName
      }
      post {
        id
        type
        preview {
          type
          content
          videoThumbnail
          targettedNetworks
          dates {
            start
            end
          }
        }
        target {
          type
        }
        socialNetworkTarget
      }
      status
      totalStatus {
        done
        error
        terminated
      }
      adsCount
      totalBudget
      perPostBudget
      spentBudget
      callToAction
      spentReach
      spentInteraction
      cpi
      connection
      isDefaultChalandiseZone
      startAt
      endAt
      optimizationGoal
      specialCategories
    }
  }
}
    `;

/**
 * __useCombinedAmplifyCampaignsListQueryQuery__
 *
 * To run a query within a React component, call `useCombinedAmplifyCampaignsListQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCombinedAmplifyCampaignsListQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedAmplifyCampaignsListQueryQuery({
 *   variables: {
 *      postCalendarId: // value for 'postCalendarId'
 *      target: // value for 'target'
 *      salesPoints: // value for 'salesPoints'
 *      globals: // value for 'globals'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      socialNetwork: // value for 'socialNetwork'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCombinedAmplifyCampaignsListQueryQuery(baseOptions: Apollo.QueryHookOptions<CombinedAmplifyCampaignsListQueryQuery, CombinedAmplifyCampaignsListQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CombinedAmplifyCampaignsListQueryQuery, CombinedAmplifyCampaignsListQueryQueryVariables>(CombinedAmplifyCampaignsListQueryDocument, options);
      }
export function useCombinedAmplifyCampaignsListQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CombinedAmplifyCampaignsListQueryQuery, CombinedAmplifyCampaignsListQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CombinedAmplifyCampaignsListQueryQuery, CombinedAmplifyCampaignsListQueryQueryVariables>(CombinedAmplifyCampaignsListQueryDocument, options);
        }
export type CombinedAmplifyCampaignsListQueryQueryHookResult = ReturnType<typeof useCombinedAmplifyCampaignsListQueryQuery>;
export type CombinedAmplifyCampaignsListQueryLazyQueryHookResult = ReturnType<typeof useCombinedAmplifyCampaignsListQueryLazyQuery>;
export type CombinedAmplifyCampaignsListQueryQueryResult = Apollo.QueryResult<CombinedAmplifyCampaignsListQueryQuery, CombinedAmplifyCampaignsListQueryQueryVariables>;
export const CreateShortUrlDocument = gql`
    query createShortURL($url: String!) {
  createShortURL(url: $url) {
    link
  }
}
    `;

/**
 * __useCreateShortUrlQuery__
 *
 * To run a query within a React component, call `useCreateShortUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateShortUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateShortUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateShortUrlQuery(baseOptions: Apollo.QueryHookOptions<CreateShortUrlQuery, CreateShortUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateShortUrlQuery, CreateShortUrlQueryVariables>(CreateShortUrlDocument, options);
      }
export function useCreateShortUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateShortUrlQuery, CreateShortUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateShortUrlQuery, CreateShortUrlQueryVariables>(CreateShortUrlDocument, options);
        }
export type CreateShortUrlQueryHookResult = ReturnType<typeof useCreateShortUrlQuery>;
export type CreateShortUrlLazyQueryHookResult = ReturnType<typeof useCreateShortUrlLazyQuery>;
export type CreateShortUrlQueryResult = Apollo.QueryResult<CreateShortUrlQuery, CreateShortUrlQueryVariables>;
export const DeleteShippingFeesDocument = gql`
    mutation deleteShippingFees($id: ID!) {
  deleteShippingFees(id: $id)
}
    `;
export type DeleteShippingFeesMutationFn = Apollo.MutationFunction<DeleteShippingFeesMutation, DeleteShippingFeesMutationVariables>;

/**
 * __useDeleteShippingFeesMutation__
 *
 * To run a mutation, you first call `useDeleteShippingFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShippingFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShippingFeesMutation, { data, loading, error }] = useDeleteShippingFeesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShippingFeesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShippingFeesMutation, DeleteShippingFeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShippingFeesMutation, DeleteShippingFeesMutationVariables>(DeleteShippingFeesDocument, options);
      }
export type DeleteShippingFeesMutationHookResult = ReturnType<typeof useDeleteShippingFeesMutation>;
export type DeleteShippingFeesMutationResult = Apollo.MutationResult<DeleteShippingFeesMutation>;
export type DeleteShippingFeesMutationOptions = Apollo.BaseMutationOptions<DeleteShippingFeesMutation, DeleteShippingFeesMutationVariables>;
export const ExportAmplifyCampaignDocument = gql`
    query exportAmplifyCampaign($campaignId: ID!, $sort: AmplifyAdsListSortArgs) {
  exportAmplifyCampaign(campaignId: $campaignId, sort: $sort)
}
    `;

/**
 * __useExportAmplifyCampaignQuery__
 *
 * To run a query within a React component, call `useExportAmplifyCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAmplifyCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportAmplifyCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExportAmplifyCampaignQuery(baseOptions: Apollo.QueryHookOptions<ExportAmplifyCampaignQuery, ExportAmplifyCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportAmplifyCampaignQuery, ExportAmplifyCampaignQueryVariables>(ExportAmplifyCampaignDocument, options);
      }
export function useExportAmplifyCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportAmplifyCampaignQuery, ExportAmplifyCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportAmplifyCampaignQuery, ExportAmplifyCampaignQueryVariables>(ExportAmplifyCampaignDocument, options);
        }
export type ExportAmplifyCampaignQueryHookResult = ReturnType<typeof useExportAmplifyCampaignQuery>;
export type ExportAmplifyCampaignLazyQueryHookResult = ReturnType<typeof useExportAmplifyCampaignLazyQuery>;
export type ExportAmplifyCampaignQueryResult = Apollo.QueryResult<ExportAmplifyCampaignQuery, ExportAmplifyCampaignQueryVariables>;
export const ExportAmplifyCampaignsDocument = gql`
    query exportAmplifyCampaigns($postCalendarId: ID, $target: TargetType!, $salesPoints: [ID], $globals: [String], $socialNetwork: String, $startAt: Date, $endAt: Date, $sort: AmplifyCampaignsListSortArgs) {
  exportAmplifyCampaigns(postCalendarId: $postCalendarId, target: $target, salesPoints: $salesPoints, socialNetwork: $socialNetwork, globals: $globals, startAt: $startAt, endAt: $endAt, sort: $sort)
}
    `;

/**
 * __useExportAmplifyCampaignsQuery__
 *
 * To run a query within a React component, call `useExportAmplifyCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAmplifyCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportAmplifyCampaignsQuery({
 *   variables: {
 *      postCalendarId: // value for 'postCalendarId'
 *      target: // value for 'target'
 *      salesPoints: // value for 'salesPoints'
 *      globals: // value for 'globals'
 *      socialNetwork: // value for 'socialNetwork'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExportAmplifyCampaignsQuery(baseOptions: Apollo.QueryHookOptions<ExportAmplifyCampaignsQuery, ExportAmplifyCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportAmplifyCampaignsQuery, ExportAmplifyCampaignsQueryVariables>(ExportAmplifyCampaignsDocument, options);
      }
export function useExportAmplifyCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportAmplifyCampaignsQuery, ExportAmplifyCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportAmplifyCampaignsQuery, ExportAmplifyCampaignsQueryVariables>(ExportAmplifyCampaignsDocument, options);
        }
export type ExportAmplifyCampaignsQueryHookResult = ReturnType<typeof useExportAmplifyCampaignsQuery>;
export type ExportAmplifyCampaignsLazyQueryHookResult = ReturnType<typeof useExportAmplifyCampaignsLazyQuery>;
export type ExportAmplifyCampaignsQueryResult = Apollo.QueryResult<ExportAmplifyCampaignsQuery, ExportAmplifyCampaignsQueryVariables>;
export const FolderByIdDocument = gql`
    query folderById($id: ID!) {
  folderById(id: $id) {
    id
    name
    parent
    salespointsGroups {
      id
      name
    }
    validFrom
    validTo
  }
}
    `;

/**
 * __useFolderByIdQuery__
 *
 * To run a query within a React component, call `useFolderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFolderByIdQuery(baseOptions: Apollo.QueryHookOptions<FolderByIdQuery, FolderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderByIdQuery, FolderByIdQueryVariables>(FolderByIdDocument, options);
      }
export function useFolderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderByIdQuery, FolderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderByIdQuery, FolderByIdQueryVariables>(FolderByIdDocument, options);
        }
export type FolderByIdQueryHookResult = ReturnType<typeof useFolderByIdQuery>;
export type FolderByIdLazyQueryHookResult = ReturnType<typeof useFolderByIdLazyQuery>;
export type FolderByIdQueryResult = Apollo.QueryResult<FolderByIdQuery, FolderByIdQueryVariables>;
export const FoldersDocument = gql`
    query folders($sort: FolderSort, $folderId: ID, $salespointsGroups: [ID], $bypassSalespointsGroups: Boolean) {
  folders(sort: $sort, folderId: $folderId, salespointsGroups: $salespointsGroups, bypassSalespointsGroups: $bypassSalespointsGroups) {
    id
    name
    parent
    enabled
    validFrom
    validTo
    salespointsGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useFoldersQuery__
 *
 * To run a query within a React component, call `useFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoldersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      folderId: // value for 'folderId'
 *      salespointsGroups: // value for 'salespointsGroups'
 *      bypassSalespointsGroups: // value for 'bypassSalespointsGroups'
 *   },
 * });
 */
export function useFoldersQuery(baseOptions?: Apollo.QueryHookOptions<FoldersQuery, FoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoldersQuery, FoldersQueryVariables>(FoldersDocument, options);
      }
export function useFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoldersQuery, FoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoldersQuery, FoldersQueryVariables>(FoldersDocument, options);
        }
export type FoldersQueryHookResult = ReturnType<typeof useFoldersQuery>;
export type FoldersLazyQueryHookResult = ReturnType<typeof useFoldersLazyQuery>;
export type FoldersQueryResult = Apollo.QueryResult<FoldersQuery, FoldersQueryVariables>;
export const FoldersForNavigationDocument = gql`
    query foldersForNavigation($sort: FolderSort, $folderId: ID, $salespointsGroups: [ID], $bypassSalespointsGroups: Boolean) {
  folders(sort: $sort, folderId: $folderId, salespointsGroups: $salespointsGroups, bypassSalespointsGroups: $bypassSalespointsGroups) {
    id
    name
    parent
    enabled
    validFrom
    validTo
    salespointsGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useFoldersForNavigationQuery__
 *
 * To run a query within a React component, call `useFoldersForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoldersForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoldersForNavigationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      folderId: // value for 'folderId'
 *      salespointsGroups: // value for 'salespointsGroups'
 *      bypassSalespointsGroups: // value for 'bypassSalespointsGroups'
 *   },
 * });
 */
export function useFoldersForNavigationQuery(baseOptions?: Apollo.QueryHookOptions<FoldersForNavigationQuery, FoldersForNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoldersForNavigationQuery, FoldersForNavigationQueryVariables>(FoldersForNavigationDocument, options);
      }
export function useFoldersForNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoldersForNavigationQuery, FoldersForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoldersForNavigationQuery, FoldersForNavigationQueryVariables>(FoldersForNavigationDocument, options);
        }
export type FoldersForNavigationQueryHookResult = ReturnType<typeof useFoldersForNavigationQuery>;
export type FoldersForNavigationLazyQueryHookResult = ReturnType<typeof useFoldersForNavigationLazyQuery>;
export type FoldersForNavigationQueryResult = Apollo.QueryResult<FoldersForNavigationQuery, FoldersForNavigationQueryVariables>;
export const GetAllClientsIdsDocument = gql`
    query getAllClientsIds {
  getAllClients {
    clientId
    name
  }
}
    `;

/**
 * __useGetAllClientsIdsQuery__
 *
 * To run a query within a React component, call `useGetAllClientsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientsIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientsIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClientsIdsQuery, GetAllClientsIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientsIdsQuery, GetAllClientsIdsQueryVariables>(GetAllClientsIdsDocument, options);
      }
export function useGetAllClientsIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientsIdsQuery, GetAllClientsIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientsIdsQuery, GetAllClientsIdsQueryVariables>(GetAllClientsIdsDocument, options);
        }
export type GetAllClientsIdsQueryHookResult = ReturnType<typeof useGetAllClientsIdsQuery>;
export type GetAllClientsIdsLazyQueryHookResult = ReturnType<typeof useGetAllClientsIdsLazyQuery>;
export type GetAllClientsIdsQueryResult = Apollo.QueryResult<GetAllClientsIdsQuery, GetAllClientsIdsQueryVariables>;
export const GetAllUsersDocument = gql`
    query getAllUsers($offset: Int, $limit: Int) {
  getAllUsers(offset: $offset, limit: $limit) {
    id
    firstname
    fullName
    lastname
    mobilePhone
    email
    enabled
    activity
    canEdit
    registered
    lastActivityDay
    role {
      id
      name
      absoluteSlug
    }
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetAmplifyAccountsDocument = gql`
    query getAmplifyAccounts($socialNetworkUser: Int, $offset: Int, $limit: Int, $isLinked: Boolean, $keyword: String!) {
  getAmplifyAccounts(socialNetworkUser: $socialNetworkUser, offset: $offset, limit: $limit, isLinked: $isLinked, keyword: $keyword) {
    count
    accounts {
      id
      name
      isLinked
      isActive
    }
  }
}
    `;

/**
 * __useGetAmplifyAccountsQuery__
 *
 * To run a query within a React component, call `useGetAmplifyAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmplifyAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmplifyAccountsQuery({
 *   variables: {
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      isLinked: // value for 'isLinked'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useGetAmplifyAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetAmplifyAccountsQuery, GetAmplifyAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmplifyAccountsQuery, GetAmplifyAccountsQueryVariables>(GetAmplifyAccountsDocument, options);
      }
export function useGetAmplifyAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmplifyAccountsQuery, GetAmplifyAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmplifyAccountsQuery, GetAmplifyAccountsQueryVariables>(GetAmplifyAccountsDocument, options);
        }
export type GetAmplifyAccountsQueryHookResult = ReturnType<typeof useGetAmplifyAccountsQuery>;
export type GetAmplifyAccountsLazyQueryHookResult = ReturnType<typeof useGetAmplifyAccountsLazyQuery>;
export type GetAmplifyAccountsQueryResult = Apollo.QueryResult<GetAmplifyAccountsQuery, GetAmplifyAccountsQueryVariables>;
export const GetAmplifyCampaignAdsDocument = gql`
    query getAmplifyCampaignAds($campaignId: ID!, $offset: Int, $limit: Int, $sort: AmplifyAdsListSortArgs) {
  getAmplifyCampaignAds(campaignId: $campaignId, offset: $offset, limit: $limit, sort: $sort) {
    count
    ads {
      id
      target {
        id
        name
      }
      status
      stoppedDate
      totalBudget
      spentBudget
      spentReach
      spentInteraction
      cpi
      errorMessage
    }
  }
}
    `;

/**
 * __useGetAmplifyCampaignAdsQuery__
 *
 * To run a query within a React component, call `useGetAmplifyCampaignAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmplifyCampaignAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmplifyCampaignAdsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAmplifyCampaignAdsQuery(baseOptions: Apollo.QueryHookOptions<GetAmplifyCampaignAdsQuery, GetAmplifyCampaignAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmplifyCampaignAdsQuery, GetAmplifyCampaignAdsQueryVariables>(GetAmplifyCampaignAdsDocument, options);
      }
export function useGetAmplifyCampaignAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmplifyCampaignAdsQuery, GetAmplifyCampaignAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmplifyCampaignAdsQuery, GetAmplifyCampaignAdsQueryVariables>(GetAmplifyCampaignAdsDocument, options);
        }
export type GetAmplifyCampaignAdsQueryHookResult = ReturnType<typeof useGetAmplifyCampaignAdsQuery>;
export type GetAmplifyCampaignAdsLazyQueryHookResult = ReturnType<typeof useGetAmplifyCampaignAdsLazyQuery>;
export type GetAmplifyCampaignAdsQueryResult = Apollo.QueryResult<GetAmplifyCampaignAdsQuery, GetAmplifyCampaignAdsQueryVariables>;
export const GetBase64PmWithBucketUrlDocument = gql`
    query getBase64PmWithBucketUrl($url: String!) {
  getBase64PmWithBucketUrl(url: $url)
}
    `;

/**
 * __useGetBase64PmWithBucketUrlQuery__
 *
 * To run a query within a React component, call `useGetBase64PmWithBucketUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBase64PmWithBucketUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBase64PmWithBucketUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetBase64PmWithBucketUrlQuery(baseOptions: Apollo.QueryHookOptions<GetBase64PmWithBucketUrlQuery, GetBase64PmWithBucketUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBase64PmWithBucketUrlQuery, GetBase64PmWithBucketUrlQueryVariables>(GetBase64PmWithBucketUrlDocument, options);
      }
export function useGetBase64PmWithBucketUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBase64PmWithBucketUrlQuery, GetBase64PmWithBucketUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBase64PmWithBucketUrlQuery, GetBase64PmWithBucketUrlQueryVariables>(GetBase64PmWithBucketUrlDocument, options);
        }
export type GetBase64PmWithBucketUrlQueryHookResult = ReturnType<typeof useGetBase64PmWithBucketUrlQuery>;
export type GetBase64PmWithBucketUrlLazyQueryHookResult = ReturnType<typeof useGetBase64PmWithBucketUrlLazyQuery>;
export type GetBase64PmWithBucketUrlQueryResult = Apollo.QueryResult<GetBase64PmWithBucketUrlQuery, GetBase64PmWithBucketUrlQueryVariables>;
export const GetBasicUserInfoDocument = gql`
    query getBasicUserInfo {
  me {
    id
    email
    selectedSalesPointId
    selectedSalesPoint {
      id
      name
    }
    languagePreference
    role {
      id
      permissions
      name
    }
  }
}
    `;

/**
 * __useGetBasicUserInfoQuery__
 *
 * To run a query within a React component, call `useGetBasicUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBasicUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetBasicUserInfoQuery, GetBasicUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicUserInfoQuery, GetBasicUserInfoQueryVariables>(GetBasicUserInfoDocument, options);
      }
export function useGetBasicUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicUserInfoQuery, GetBasicUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicUserInfoQuery, GetBasicUserInfoQueryVariables>(GetBasicUserInfoDocument, options);
        }
export type GetBasicUserInfoQueryHookResult = ReturnType<typeof useGetBasicUserInfoQuery>;
export type GetBasicUserInfoLazyQueryHookResult = ReturnType<typeof useGetBasicUserInfoLazyQuery>;
export type GetBasicUserInfoQueryResult = Apollo.QueryResult<GetBasicUserInfoQuery, GetBasicUserInfoQueryVariables>;
export const GetBriefClientFeaturesDocument = gql`
    query getBriefClientFeatures($id: ID!) {
  briefById(id: $id) {
    id
    client {
      f
    }
  }
}
    `;

/**
 * __useGetBriefClientFeaturesQuery__
 *
 * To run a query within a React component, call `useGetBriefClientFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBriefClientFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBriefClientFeaturesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBriefClientFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetBriefClientFeaturesQuery, GetBriefClientFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBriefClientFeaturesQuery, GetBriefClientFeaturesQueryVariables>(GetBriefClientFeaturesDocument, options);
      }
export function useGetBriefClientFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBriefClientFeaturesQuery, GetBriefClientFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBriefClientFeaturesQuery, GetBriefClientFeaturesQueryVariables>(GetBriefClientFeaturesDocument, options);
        }
export type GetBriefClientFeaturesQueryHookResult = ReturnType<typeof useGetBriefClientFeaturesQuery>;
export type GetBriefClientFeaturesLazyQueryHookResult = ReturnType<typeof useGetBriefClientFeaturesLazyQuery>;
export type GetBriefClientFeaturesQueryResult = Apollo.QueryResult<GetBriefClientFeaturesQuery, GetBriefClientFeaturesQueryVariables>;
export const GetBriefConceptionUrlStateDocument = gql`
    query getBriefConceptionUrlState($id: ID!) {
  briefById(id: $id) {
    id
    conception {
      id
      url
    }
  }
}
    `;

/**
 * __useGetBriefConceptionUrlStateQuery__
 *
 * To run a query within a React component, call `useGetBriefConceptionUrlStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBriefConceptionUrlStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBriefConceptionUrlStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBriefConceptionUrlStateQuery(baseOptions: Apollo.QueryHookOptions<GetBriefConceptionUrlStateQuery, GetBriefConceptionUrlStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBriefConceptionUrlStateQuery, GetBriefConceptionUrlStateQueryVariables>(GetBriefConceptionUrlStateDocument, options);
      }
export function useGetBriefConceptionUrlStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBriefConceptionUrlStateQuery, GetBriefConceptionUrlStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBriefConceptionUrlStateQuery, GetBriefConceptionUrlStateQueryVariables>(GetBriefConceptionUrlStateDocument, options);
        }
export type GetBriefConceptionUrlStateQueryHookResult = ReturnType<typeof useGetBriefConceptionUrlStateQuery>;
export type GetBriefConceptionUrlStateLazyQueryHookResult = ReturnType<typeof useGetBriefConceptionUrlStateLazyQuery>;
export type GetBriefConceptionUrlStateQueryResult = Apollo.QueryResult<GetBriefConceptionUrlStateQuery, GetBriefConceptionUrlStateQueryVariables>;
export const AdCampaignForm_GetCampaignDetailsDocument = gql`
    query AdCampaignForm_getCampaignDetails($id: ID!) {
  me {
    id
    client {
      id
      name
    }
  }
  getAmplifyCampaignDetails(id: $id) {
    id
    name
    adsCount
    totalBudget
    perPostBudget
    spentBudget
    spentReach
    spentInteraction
    cpi
    optimizationGoal
    specialCategories
    connection
    isDefaultChalandiseZone
    advantagePlusOption
    geoRadius
    startAt
    endAt
    sexTargeting
    ageTargeting
    sexOfTarget
    minAgeTarget
    maxAgeTarget
    target {
      type
      salesPoints {
        id
        name
      }
      onGlobals
    }
    targetingInterests {
      facebookKey
      name
    }
    targetingCountries {
      facebookKey
      name
    }
    targetingGeolocations {
      facebookKey
      name
    }
    post {
      id
      authorRole
      scheduledAt
      type
      preview {
        type
        content
        videoThumbnail
        caption
        targettedNetworks
        dates {
          start
          end
        }
      }
      amplifyAvailableTargets {
        salesPoints {
          id
          name
          isAmplifyConnectionOptionAvailable
        }
        onGlobals
        isGlobalConnectionOptionAvailable
      }
    }
  }
}
    `;

/**
 * __useAdCampaignForm_GetCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useAdCampaignForm_GetCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdCampaignForm_GetCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdCampaignForm_GetCampaignDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdCampaignForm_GetCampaignDetailsQuery(baseOptions: Apollo.QueryHookOptions<AdCampaignForm_GetCampaignDetailsQuery, AdCampaignForm_GetCampaignDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdCampaignForm_GetCampaignDetailsQuery, AdCampaignForm_GetCampaignDetailsQueryVariables>(AdCampaignForm_GetCampaignDetailsDocument, options);
      }
export function useAdCampaignForm_GetCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdCampaignForm_GetCampaignDetailsQuery, AdCampaignForm_GetCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdCampaignForm_GetCampaignDetailsQuery, AdCampaignForm_GetCampaignDetailsQueryVariables>(AdCampaignForm_GetCampaignDetailsDocument, options);
        }
export type AdCampaignForm_GetCampaignDetailsQueryHookResult = ReturnType<typeof useAdCampaignForm_GetCampaignDetailsQuery>;
export type AdCampaignForm_GetCampaignDetailsLazyQueryHookResult = ReturnType<typeof useAdCampaignForm_GetCampaignDetailsLazyQuery>;
export type AdCampaignForm_GetCampaignDetailsQueryResult = Apollo.QueryResult<AdCampaignForm_GetCampaignDetailsQuery, AdCampaignForm_GetCampaignDetailsQueryVariables>;
export const GetDefaultChiliIdsDocument = gql`
    query getDefaultChiliIds {
  getChiliConfig {
    clientId
    workspaceId
    watermarkId
    viewPreferencesId
    exportPreferences {
      id
      exportId
      label
    }
    updatedBy {
      id
      fullName
    }
    updatedAt
  }
}
    `;

/**
 * __useGetDefaultChiliIdsQuery__
 *
 * To run a query within a React component, call `useGetDefaultChiliIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultChiliIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultChiliIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultChiliIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultChiliIdsQuery, GetDefaultChiliIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultChiliIdsQuery, GetDefaultChiliIdsQueryVariables>(GetDefaultChiliIdsDocument, options);
      }
export function useGetDefaultChiliIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultChiliIdsQuery, GetDefaultChiliIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultChiliIdsQuery, GetDefaultChiliIdsQueryVariables>(GetDefaultChiliIdsDocument, options);
        }
export type GetDefaultChiliIdsQueryHookResult = ReturnType<typeof useGetDefaultChiliIdsQuery>;
export type GetDefaultChiliIdsLazyQueryHookResult = ReturnType<typeof useGetDefaultChiliIdsLazyQuery>;
export type GetDefaultChiliIdsQueryResult = Apollo.QueryResult<GetDefaultChiliIdsQuery, GetDefaultChiliIdsQueryVariables>;
export const ClientFeatureDocument = gql`
    query clientFeature {
  me {
    id
    client {
      id
      f
    }
  }
}
    `;

/**
 * __useClientFeatureQuery__
 *
 * To run a query within a React component, call `useClientFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFeatureQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientFeatureQuery(baseOptions?: Apollo.QueryHookOptions<ClientFeatureQuery, ClientFeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFeatureQuery, ClientFeatureQueryVariables>(ClientFeatureDocument, options);
      }
export function useClientFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFeatureQuery, ClientFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFeatureQuery, ClientFeatureQueryVariables>(ClientFeatureDocument, options);
        }
export type ClientFeatureQueryHookResult = ReturnType<typeof useClientFeatureQuery>;
export type ClientFeatureLazyQueryHookResult = ReturnType<typeof useClientFeatureLazyQuery>;
export type ClientFeatureQueryResult = Apollo.QueryResult<ClientFeatureQuery, ClientFeatureQueryVariables>;
export const TargetingStep_GetCountryListDocument = gql`
    query TargetingStep_getCountryList($query: String!) {
  getCountryList(query: $query) {
    data {
      facebookKey
      name
    }
  }
}
    `;

/**
 * __useTargetingStep_GetCountryListQuery__
 *
 * To run a query within a React component, call `useTargetingStep_GetCountryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetingStep_GetCountryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetingStep_GetCountryListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTargetingStep_GetCountryListQuery(baseOptions: Apollo.QueryHookOptions<TargetingStep_GetCountryListQuery, TargetingStep_GetCountryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetingStep_GetCountryListQuery, TargetingStep_GetCountryListQueryVariables>(TargetingStep_GetCountryListDocument, options);
      }
export function useTargetingStep_GetCountryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetingStep_GetCountryListQuery, TargetingStep_GetCountryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetingStep_GetCountryListQuery, TargetingStep_GetCountryListQueryVariables>(TargetingStep_GetCountryListDocument, options);
        }
export type TargetingStep_GetCountryListQueryHookResult = ReturnType<typeof useTargetingStep_GetCountryListQuery>;
export type TargetingStep_GetCountryListLazyQueryHookResult = ReturnType<typeof useTargetingStep_GetCountryListLazyQuery>;
export type TargetingStep_GetCountryListQueryResult = Apollo.QueryResult<TargetingStep_GetCountryListQuery, TargetingStep_GetCountryListQueryVariables>;
export const GetCustomDynVarDocument = gql`
    query getCustomDynVar {
  getCustomDynVar {
    slug
    description
    label
  }
}
    `;

/**
 * __useGetCustomDynVarQuery__
 *
 * To run a query within a React component, call `useGetCustomDynVarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomDynVarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomDynVarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomDynVarQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomDynVarQuery, GetCustomDynVarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomDynVarQuery, GetCustomDynVarQueryVariables>(GetCustomDynVarDocument, options);
      }
export function useGetCustomDynVarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomDynVarQuery, GetCustomDynVarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomDynVarQuery, GetCustomDynVarQueryVariables>(GetCustomDynVarDocument, options);
        }
export type GetCustomDynVarQueryHookResult = ReturnType<typeof useGetCustomDynVarQuery>;
export type GetCustomDynVarLazyQueryHookResult = ReturnType<typeof useGetCustomDynVarLazyQuery>;
export type GetCustomDynVarQueryResult = Apollo.QueryResult<GetCustomDynVarQuery, GetCustomDynVarQueryVariables>;
export const GetCustomVisualUrlDocument = gql`
    query getCustomVisualUrl($salesPointId: ID!) {
  getCustomVisualUrl(salesPointId: $salesPointId) {
    url
    filename
  }
}
    `;

/**
 * __useGetCustomVisualUrlQuery__
 *
 * To run a query within a React component, call `useGetCustomVisualUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomVisualUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomVisualUrlQuery({
 *   variables: {
 *      salesPointId: // value for 'salesPointId'
 *   },
 * });
 */
export function useGetCustomVisualUrlQuery(baseOptions: Apollo.QueryHookOptions<GetCustomVisualUrlQuery, GetCustomVisualUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomVisualUrlQuery, GetCustomVisualUrlQueryVariables>(GetCustomVisualUrlDocument, options);
      }
export function useGetCustomVisualUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomVisualUrlQuery, GetCustomVisualUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomVisualUrlQuery, GetCustomVisualUrlQueryVariables>(GetCustomVisualUrlDocument, options);
        }
export type GetCustomVisualUrlQueryHookResult = ReturnType<typeof useGetCustomVisualUrlQuery>;
export type GetCustomVisualUrlLazyQueryHookResult = ReturnType<typeof useGetCustomVisualUrlLazyQuery>;
export type GetCustomVisualUrlQueryResult = Apollo.QueryResult<GetCustomVisualUrlQuery, GetCustomVisualUrlQueryVariables>;
export const GetOrderedProductPdfUrlDocument = gql`
    query getOrderedProductPDFUrl($productId: ID!, $subId: ID!, $preview: Boolean) {
  getOrderedProductPDFUrl(productId: $productId, subId: $subId, preview: $preview)
}
    `;

/**
 * __useGetOrderedProductPdfUrlQuery__
 *
 * To run a query within a React component, call `useGetOrderedProductPdfUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderedProductPdfUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderedProductPdfUrlQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      subId: // value for 'subId'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useGetOrderedProductPdfUrlQuery(baseOptions: Apollo.QueryHookOptions<GetOrderedProductPdfUrlQuery, GetOrderedProductPdfUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderedProductPdfUrlQuery, GetOrderedProductPdfUrlQueryVariables>(GetOrderedProductPdfUrlDocument, options);
      }
export function useGetOrderedProductPdfUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderedProductPdfUrlQuery, GetOrderedProductPdfUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderedProductPdfUrlQuery, GetOrderedProductPdfUrlQueryVariables>(GetOrderedProductPdfUrlDocument, options);
        }
export type GetOrderedProductPdfUrlQueryHookResult = ReturnType<typeof useGetOrderedProductPdfUrlQuery>;
export type GetOrderedProductPdfUrlLazyQueryHookResult = ReturnType<typeof useGetOrderedProductPdfUrlLazyQuery>;
export type GetOrderedProductPdfUrlQueryResult = Apollo.QueryResult<GetOrderedProductPdfUrlQuery, GetOrderedProductPdfUrlQueryVariables>;
export const GroupsDocument = gql`
    query groups {
  salesPointsGroups {
    id
    name
  }
}
    `;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const GetHashtagsDocument = gql`
    query getHashtags {
  getHashtags
}
    `;

/**
 * __useGetHashtagsQuery__
 *
 * To run a query within a React component, call `useGetHashtagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHashtagsQuery(baseOptions?: Apollo.QueryHookOptions<GetHashtagsQuery, GetHashtagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHashtagsQuery, GetHashtagsQueryVariables>(GetHashtagsDocument, options);
      }
export function useGetHashtagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHashtagsQuery, GetHashtagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHashtagsQuery, GetHashtagsQueryVariables>(GetHashtagsDocument, options);
        }
export type GetHashtagsQueryHookResult = ReturnType<typeof useGetHashtagsQuery>;
export type GetHashtagsLazyQueryHookResult = ReturnType<typeof useGetHashtagsLazyQuery>;
export type GetHashtagsQueryResult = Apollo.QueryResult<GetHashtagsQuery, GetHashtagsQueryVariables>;
export const GetImportFileSpecificationsDocument = gql`
    query getImportFileSpecifications($socialNetwork: SocialNetwork!, $type: ImportFileForPostType!, $socialNetworks: [SocialNetwork]) {
  getImportFileSpecifications(socialNetwork: $socialNetwork, type: $type, socialNetworks: $socialNetworks) {
    allowedExtensions
    minSize
    maxSize
    minFormat
    maxFormat
    minResolution
    maxResolution
    minFiles
    maxFiles
    minDuration
    maxDuration
  }
}
    `;

/**
 * __useGetImportFileSpecificationsQuery__
 *
 * To run a query within a React component, call `useGetImportFileSpecificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportFileSpecificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportFileSpecificationsQuery({
 *   variables: {
 *      socialNetwork: // value for 'socialNetwork'
 *      type: // value for 'type'
 *      socialNetworks: // value for 'socialNetworks'
 *   },
 * });
 */
export function useGetImportFileSpecificationsQuery(baseOptions: Apollo.QueryHookOptions<GetImportFileSpecificationsQuery, GetImportFileSpecificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportFileSpecificationsQuery, GetImportFileSpecificationsQueryVariables>(GetImportFileSpecificationsDocument, options);
      }
export function useGetImportFileSpecificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportFileSpecificationsQuery, GetImportFileSpecificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportFileSpecificationsQuery, GetImportFileSpecificationsQueryVariables>(GetImportFileSpecificationsDocument, options);
        }
export type GetImportFileSpecificationsQueryHookResult = ReturnType<typeof useGetImportFileSpecificationsQuery>;
export type GetImportFileSpecificationsLazyQueryHookResult = ReturnType<typeof useGetImportFileSpecificationsLazyQuery>;
export type GetImportFileSpecificationsQueryResult = Apollo.QueryResult<GetImportFileSpecificationsQuery, GetImportFileSpecificationsQueryVariables>;
export const GetImportFileSpecificationsForAllSocialNetworksDocument = gql`
    query getImportFileSpecificationsForAllSocialNetworks {
  getImportFileSpecificationsForAllSocialNetworks {
    socialNetwork
    types {
      type
      specs {
        allowedExtensions
        minSize
        maxSize
        minFormat
        maxFormat
        minResolution
        maxResolution
        minFiles
        maxFiles
      }
    }
  }
}
    `;

/**
 * __useGetImportFileSpecificationsForAllSocialNetworksQuery__
 *
 * To run a query within a React component, call `useGetImportFileSpecificationsForAllSocialNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportFileSpecificationsForAllSocialNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportFileSpecificationsForAllSocialNetworksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImportFileSpecificationsForAllSocialNetworksQuery(baseOptions?: Apollo.QueryHookOptions<GetImportFileSpecificationsForAllSocialNetworksQuery, GetImportFileSpecificationsForAllSocialNetworksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportFileSpecificationsForAllSocialNetworksQuery, GetImportFileSpecificationsForAllSocialNetworksQueryVariables>(GetImportFileSpecificationsForAllSocialNetworksDocument, options);
      }
export function useGetImportFileSpecificationsForAllSocialNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportFileSpecificationsForAllSocialNetworksQuery, GetImportFileSpecificationsForAllSocialNetworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportFileSpecificationsForAllSocialNetworksQuery, GetImportFileSpecificationsForAllSocialNetworksQueryVariables>(GetImportFileSpecificationsForAllSocialNetworksDocument, options);
        }
export type GetImportFileSpecificationsForAllSocialNetworksQueryHookResult = ReturnType<typeof useGetImportFileSpecificationsForAllSocialNetworksQuery>;
export type GetImportFileSpecificationsForAllSocialNetworksLazyQueryHookResult = ReturnType<typeof useGetImportFileSpecificationsForAllSocialNetworksLazyQuery>;
export type GetImportFileSpecificationsForAllSocialNetworksQueryResult = Apollo.QueryResult<GetImportFileSpecificationsForAllSocialNetworksQuery, GetImportFileSpecificationsForAllSocialNetworksQueryVariables>;
export const TargetingStep_GetInterestListDocument = gql`
    query TargetingStep_getInterestList($query: String!) {
  getInterestList(query: $query) {
    data {
      facebookKey
      name
    }
  }
}
    `;

/**
 * __useTargetingStep_GetInterestListQuery__
 *
 * To run a query within a React component, call `useTargetingStep_GetInterestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetingStep_GetInterestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetingStep_GetInterestListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTargetingStep_GetInterestListQuery(baseOptions: Apollo.QueryHookOptions<TargetingStep_GetInterestListQuery, TargetingStep_GetInterestListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetingStep_GetInterestListQuery, TargetingStep_GetInterestListQueryVariables>(TargetingStep_GetInterestListDocument, options);
      }
export function useTargetingStep_GetInterestListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetingStep_GetInterestListQuery, TargetingStep_GetInterestListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetingStep_GetInterestListQuery, TargetingStep_GetInterestListQueryVariables>(TargetingStep_GetInterestListDocument, options);
        }
export type TargetingStep_GetInterestListQueryHookResult = ReturnType<typeof useTargetingStep_GetInterestListQuery>;
export type TargetingStep_GetInterestListLazyQueryHookResult = ReturnType<typeof useTargetingStep_GetInterestListLazyQuery>;
export type TargetingStep_GetInterestListQueryResult = Apollo.QueryResult<TargetingStep_GetInterestListQuery, TargetingStep_GetInterestListQueryVariables>;
export const GetLinkMetadataDocument = gql`
    query getLinkMetadata($link: String!) {
  getLinkMetadata(link: $link) {
    source
    title
    description
    image
  }
}
    `;

/**
 * __useGetLinkMetadataQuery__
 *
 * To run a query within a React component, call `useGetLinkMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkMetadataQuery({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useGetLinkMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>(GetLinkMetadataDocument, options);
      }
export function useGetLinkMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>(GetLinkMetadataDocument, options);
        }
export type GetLinkMetadataQueryHookResult = ReturnType<typeof useGetLinkMetadataQuery>;
export type GetLinkMetadataLazyQueryHookResult = ReturnType<typeof useGetLinkMetadataLazyQuery>;
export type GetLinkMetadataQueryResult = Apollo.QueryResult<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>;
export const GetMentionListDocument = gql`
    query getMentionList($query: String!) {
  getMentionList(query: $query) {
    data {
      id
      name
      url
    }
  }
}
    `;

/**
 * __useGetMentionListQuery__
 *
 * To run a query within a React component, call `useGetMentionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentionListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetMentionListQuery(baseOptions: Apollo.QueryHookOptions<GetMentionListQuery, GetMentionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentionListQuery, GetMentionListQueryVariables>(GetMentionListDocument, options);
      }
export function useGetMentionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentionListQuery, GetMentionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentionListQuery, GetMentionListQueryVariables>(GetMentionListDocument, options);
        }
export type GetMentionListQueryHookResult = ReturnType<typeof useGetMentionListQuery>;
export type GetMentionListLazyQueryHookResult = ReturnType<typeof useGetMentionListLazyQuery>;
export type GetMentionListQueryResult = Apollo.QueryResult<GetMentionListQuery, GetMentionListQueryVariables>;
export const GetOrderArchiveUrlDocument = gql`
    query getOrderArchiveUrl($orderId: ID!, $productId: ID, $subId: ID) {
  getOrderArchiveUrl(orderId: $orderId, productId: $productId, subId: $subId)
}
    `;

/**
 * __useGetOrderArchiveUrlQuery__
 *
 * To run a query within a React component, call `useGetOrderArchiveUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderArchiveUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderArchiveUrlQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productId: // value for 'productId'
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useGetOrderArchiveUrlQuery(baseOptions: Apollo.QueryHookOptions<GetOrderArchiveUrlQuery, GetOrderArchiveUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderArchiveUrlQuery, GetOrderArchiveUrlQueryVariables>(GetOrderArchiveUrlDocument, options);
      }
export function useGetOrderArchiveUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderArchiveUrlQuery, GetOrderArchiveUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderArchiveUrlQuery, GetOrderArchiveUrlQueryVariables>(GetOrderArchiveUrlDocument, options);
        }
export type GetOrderArchiveUrlQueryHookResult = ReturnType<typeof useGetOrderArchiveUrlQuery>;
export type GetOrderArchiveUrlLazyQueryHookResult = ReturnType<typeof useGetOrderArchiveUrlLazyQuery>;
export type GetOrderArchiveUrlQueryResult = Apollo.QueryResult<GetOrderArchiveUrlQuery, GetOrderArchiveUrlQueryVariables>;
export const GetPmPhotosBySalesPointIdDocument = gql`
    query getPmPhotosBySalesPointId($id: ID!) {
  getPmPhotosBySalesPoint(id: $id)
}
    `;

/**
 * __useGetPmPhotosBySalesPointIdQuery__
 *
 * To run a query within a React component, call `useGetPmPhotosBySalesPointIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmPhotosBySalesPointIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmPhotosBySalesPointIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPmPhotosBySalesPointIdQuery(baseOptions: Apollo.QueryHookOptions<GetPmPhotosBySalesPointIdQuery, GetPmPhotosBySalesPointIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmPhotosBySalesPointIdQuery, GetPmPhotosBySalesPointIdQueryVariables>(GetPmPhotosBySalesPointIdDocument, options);
      }
export function useGetPmPhotosBySalesPointIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmPhotosBySalesPointIdQuery, GetPmPhotosBySalesPointIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmPhotosBySalesPointIdQuery, GetPmPhotosBySalesPointIdQueryVariables>(GetPmPhotosBySalesPointIdDocument, options);
        }
export type GetPmPhotosBySalesPointIdQueryHookResult = ReturnType<typeof useGetPmPhotosBySalesPointIdQuery>;
export type GetPmPhotosBySalesPointIdLazyQueryHookResult = ReturnType<typeof useGetPmPhotosBySalesPointIdLazyQuery>;
export type GetPmPhotosBySalesPointIdQueryResult = Apollo.QueryResult<GetPmPhotosBySalesPointIdQuery, GetPmPhotosBySalesPointIdQueryVariables>;
export const GetPostCalendarDetailsDocument = gql`
    query getPostCalendarDetails($publishId: ID!) {
  getPostCalendarDetails(publishId: $publishId) {
    ...PostFragment
    link
    dynamicLink
    cover {
      path
      mimeType
    }
    avatar {
      path
      mimeType
    }
    medias {
      path
      mimeType
    }
    thumb {
      path
      mimeType
    }
    carouselItems {
      position
      link
      title
      description
      callToAction
      media {
        path
        mimeType
      }
    }
    event {
      title
      startAt
      endAt
      callToAction
      terms
      couponCode
    }
    organicTargeting {
      sexTargeting
      sexOfTarget
      ageTargeting
      minAgeTarget
      maxAgeTarget
      targetingInterests {
        facebookKey
        name
      }
      targetingCountries {
        facebookKey
        name
      }
      targetingGeolocations {
        facebookKey
        name
      }
    }
  }
}
    ${PostFragmentFragmentDoc}`;

/**
 * __useGetPostCalendarDetailsQuery__
 *
 * To run a query within a React component, call `useGetPostCalendarDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCalendarDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCalendarDetailsQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useGetPostCalendarDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPostCalendarDetailsQuery, GetPostCalendarDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCalendarDetailsQuery, GetPostCalendarDetailsQueryVariables>(GetPostCalendarDetailsDocument, options);
      }
export function useGetPostCalendarDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCalendarDetailsQuery, GetPostCalendarDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCalendarDetailsQuery, GetPostCalendarDetailsQueryVariables>(GetPostCalendarDetailsDocument, options);
        }
export type GetPostCalendarDetailsQueryHookResult = ReturnType<typeof useGetPostCalendarDetailsQuery>;
export type GetPostCalendarDetailsLazyQueryHookResult = ReturnType<typeof useGetPostCalendarDetailsLazyQuery>;
export type GetPostCalendarDetailsQueryResult = Apollo.QueryResult<GetPostCalendarDetailsQuery, GetPostCalendarDetailsQueryVariables>;
export const GetProviderInvoiceUrlDocument = gql`
    query getProviderInvoiceUrl($orderId: ID!, $path: String!) {
  getProviderInvoiceUrl(orderId: $orderId, path: $path)
}
    `;

/**
 * __useGetProviderInvoiceUrlQuery__
 *
 * To run a query within a React component, call `useGetProviderInvoiceUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderInvoiceUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderInvoiceUrlQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetProviderInvoiceUrlQuery(baseOptions: Apollo.QueryHookOptions<GetProviderInvoiceUrlQuery, GetProviderInvoiceUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderInvoiceUrlQuery, GetProviderInvoiceUrlQueryVariables>(GetProviderInvoiceUrlDocument, options);
      }
export function useGetProviderInvoiceUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderInvoiceUrlQuery, GetProviderInvoiceUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderInvoiceUrlQuery, GetProviderInvoiceUrlQueryVariables>(GetProviderInvoiceUrlDocument, options);
        }
export type GetProviderInvoiceUrlQueryHookResult = ReturnType<typeof useGetProviderInvoiceUrlQuery>;
export type GetProviderInvoiceUrlLazyQueryHookResult = ReturnType<typeof useGetProviderInvoiceUrlLazyQuery>;
export type GetProviderInvoiceUrlQueryResult = Apollo.QueryResult<GetProviderInvoiceUrlQuery, GetProviderInvoiceUrlQueryVariables>;
export const GetSalesPointsByKeywordDocument = gql`
    query getSalesPointsByKeyword($keyword: String!, $limit: Int!, $offset: Int!, $socialNetwork: SocialNetwork, $socialNetworks: [SocialNetwork], $type: SocialLinkType) {
  salesPointsByKeyword(keyword: $keyword, limit: $limit, offset: $offset, socialNetwork: $socialNetwork, socialNetworks: $socialNetworks, type: $type) {
    count
    salesPoints {
      id
      name
      social {
        linkedPages {
          facebook
          google
          instagram
          twitter
        }
      }
    }
  }
}
    `;

/**
 * __useGetSalesPointsByKeywordQuery__
 *
 * To run a query within a React component, call `useGetSalesPointsByKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPointsByKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPointsByKeywordQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      socialNetwork: // value for 'socialNetwork'
 *      socialNetworks: // value for 'socialNetworks'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSalesPointsByKeywordQuery(baseOptions: Apollo.QueryHookOptions<GetSalesPointsByKeywordQuery, GetSalesPointsByKeywordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPointsByKeywordQuery, GetSalesPointsByKeywordQueryVariables>(GetSalesPointsByKeywordDocument, options);
      }
export function useGetSalesPointsByKeywordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPointsByKeywordQuery, GetSalesPointsByKeywordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPointsByKeywordQuery, GetSalesPointsByKeywordQueryVariables>(GetSalesPointsByKeywordDocument, options);
        }
export type GetSalesPointsByKeywordQueryHookResult = ReturnType<typeof useGetSalesPointsByKeywordQuery>;
export type GetSalesPointsByKeywordLazyQueryHookResult = ReturnType<typeof useGetSalesPointsByKeywordLazyQuery>;
export type GetSalesPointsByKeywordQueryResult = Apollo.QueryResult<GetSalesPointsByKeywordQuery, GetSalesPointsByKeywordQueryVariables>;
export const GetSalesPointsGroupsByKeywordDocument = gql`
    query getSalesPointsGroupsByKeyword($keyword: String!, $limit: Int!, $offset: Int!, $socialNetwork: SocialNetwork, $socialNetworks: [SocialNetwork], $type: SocialLinkType) {
  salesPointsGroupsByKeyword(keyword: $keyword, limit: $limit, offset: $offset, socialNetwork: $socialNetwork, socialNetworks: $socialNetworks, type: $type) {
    count
    salesPointsGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useGetSalesPointsGroupsByKeywordQuery__
 *
 * To run a query within a React component, call `useGetSalesPointsGroupsByKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPointsGroupsByKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPointsGroupsByKeywordQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      socialNetwork: // value for 'socialNetwork'
 *      socialNetworks: // value for 'socialNetworks'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSalesPointsGroupsByKeywordQuery(baseOptions: Apollo.QueryHookOptions<GetSalesPointsGroupsByKeywordQuery, GetSalesPointsGroupsByKeywordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPointsGroupsByKeywordQuery, GetSalesPointsGroupsByKeywordQueryVariables>(GetSalesPointsGroupsByKeywordDocument, options);
      }
export function useGetSalesPointsGroupsByKeywordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPointsGroupsByKeywordQuery, GetSalesPointsGroupsByKeywordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPointsGroupsByKeywordQuery, GetSalesPointsGroupsByKeywordQueryVariables>(GetSalesPointsGroupsByKeywordDocument, options);
        }
export type GetSalesPointsGroupsByKeywordQueryHookResult = ReturnType<typeof useGetSalesPointsGroupsByKeywordQuery>;
export type GetSalesPointsGroupsByKeywordLazyQueryHookResult = ReturnType<typeof useGetSalesPointsGroupsByKeywordLazyQuery>;
export type GetSalesPointsGroupsByKeywordQueryResult = Apollo.QueryResult<GetSalesPointsGroupsByKeywordQuery, GetSalesPointsGroupsByKeywordQueryVariables>;
export const GetSalesPointsTargetNetworkDetailByIdsDocument = gql`
    query getSalesPointsTargetNetworkDetailByIds($salespointIds: [ID!], $salespointGroupIds: [ID!], $socialNetworks: [SocialNetwork]) {
  getSalesPointsTargetNetworkDetailByIds(salespointIds: $salespointIds, salespointGroupIds: $salespointGroupIds, socialNetworks: $socialNetworks) {
    total
    facebook
    google
    instagram
    linkedin
  }
}
    `;

/**
 * __useGetSalesPointsTargetNetworkDetailByIdsQuery__
 *
 * To run a query within a React component, call `useGetSalesPointsTargetNetworkDetailByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPointsTargetNetworkDetailByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPointsTargetNetworkDetailByIdsQuery({
 *   variables: {
 *      salespointIds: // value for 'salespointIds'
 *      salespointGroupIds: // value for 'salespointGroupIds'
 *      socialNetworks: // value for 'socialNetworks'
 *   },
 * });
 */
export function useGetSalesPointsTargetNetworkDetailByIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesPointsTargetNetworkDetailByIdsQuery, GetSalesPointsTargetNetworkDetailByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPointsTargetNetworkDetailByIdsQuery, GetSalesPointsTargetNetworkDetailByIdsQueryVariables>(GetSalesPointsTargetNetworkDetailByIdsDocument, options);
      }
export function useGetSalesPointsTargetNetworkDetailByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPointsTargetNetworkDetailByIdsQuery, GetSalesPointsTargetNetworkDetailByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPointsTargetNetworkDetailByIdsQuery, GetSalesPointsTargetNetworkDetailByIdsQueryVariables>(GetSalesPointsTargetNetworkDetailByIdsDocument, options);
        }
export type GetSalesPointsTargetNetworkDetailByIdsQueryHookResult = ReturnType<typeof useGetSalesPointsTargetNetworkDetailByIdsQuery>;
export type GetSalesPointsTargetNetworkDetailByIdsLazyQueryHookResult = ReturnType<typeof useGetSalesPointsTargetNetworkDetailByIdsLazyQuery>;
export type GetSalesPointsTargetNetworkDetailByIdsQueryResult = Apollo.QueryResult<GetSalesPointsTargetNetworkDetailByIdsQuery, GetSalesPointsTargetNetworkDetailByIdsQueryVariables>;
export const GetSalespointLinkedSocialNetworkCountDocument = gql`
    query getSalespointLinkedSocialNetworkCount($socialNetwork: SocialNetwork!, $salespointGroupIds: [ID!], $salespointIds: [ID!]) {
  getSalespointLinkedSocialNetworkCount(socialNetwork: $socialNetwork, salespointGroupIds: $salespointGroupIds, salespointIds: $salespointIds) {
    linked
    notLinked
  }
}
    `;

/**
 * __useGetSalespointLinkedSocialNetworkCountQuery__
 *
 * To run a query within a React component, call `useGetSalespointLinkedSocialNetworkCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalespointLinkedSocialNetworkCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalespointLinkedSocialNetworkCountQuery({
 *   variables: {
 *      socialNetwork: // value for 'socialNetwork'
 *      salespointGroupIds: // value for 'salespointGroupIds'
 *      salespointIds: // value for 'salespointIds'
 *   },
 * });
 */
export function useGetSalespointLinkedSocialNetworkCountQuery(baseOptions: Apollo.QueryHookOptions<GetSalespointLinkedSocialNetworkCountQuery, GetSalespointLinkedSocialNetworkCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalespointLinkedSocialNetworkCountQuery, GetSalespointLinkedSocialNetworkCountQueryVariables>(GetSalespointLinkedSocialNetworkCountDocument, options);
      }
export function useGetSalespointLinkedSocialNetworkCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalespointLinkedSocialNetworkCountQuery, GetSalespointLinkedSocialNetworkCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalespointLinkedSocialNetworkCountQuery, GetSalespointLinkedSocialNetworkCountQueryVariables>(GetSalespointLinkedSocialNetworkCountDocument, options);
        }
export type GetSalespointLinkedSocialNetworkCountQueryHookResult = ReturnType<typeof useGetSalespointLinkedSocialNetworkCountQuery>;
export type GetSalespointLinkedSocialNetworkCountLazyQueryHookResult = ReturnType<typeof useGetSalespointLinkedSocialNetworkCountLazyQuery>;
export type GetSalespointLinkedSocialNetworkCountQueryResult = Apollo.QueryResult<GetSalespointLinkedSocialNetworkCountQuery, GetSalespointLinkedSocialNetworkCountQueryVariables>;
export const GetShippingFeeDocument = gql`
    query getShippingFee($id: ID!) {
  getShippingFees(id: $id) {
    enabled
    name
    maxWeight
    shippingFeesGridPerWeight {
      fees
      weight
    }
    freeShipping
    isAllSalesPoints
    salesPointsIds {
      id
      name
    }
    salespointGroupsIds {
      id
      name
    }
    id
  }
}
    `;

/**
 * __useGetShippingFeeQuery__
 *
 * To run a query within a React component, call `useGetShippingFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingFeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShippingFeeQuery(baseOptions: Apollo.QueryHookOptions<GetShippingFeeQuery, GetShippingFeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingFeeQuery, GetShippingFeeQueryVariables>(GetShippingFeeDocument, options);
      }
export function useGetShippingFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingFeeQuery, GetShippingFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingFeeQuery, GetShippingFeeQueryVariables>(GetShippingFeeDocument, options);
        }
export type GetShippingFeeQueryHookResult = ReturnType<typeof useGetShippingFeeQuery>;
export type GetShippingFeeLazyQueryHookResult = ReturnType<typeof useGetShippingFeeLazyQuery>;
export type GetShippingFeeQueryResult = Apollo.QueryResult<GetShippingFeeQuery, GetShippingFeeQueryVariables>;
export const GetSocialNetworkAccountsDocument = gql`
    query getSocialNetworkAccounts($socialNetwork: SocialNetwork!, $socialNetworkUser: Int, $offset: Int, $limit: Int, $isLinked: Boolean, $keyword: String!) {
  getSocialNetworkAccounts(socialNetwork: $socialNetwork, socialNetworkUser: $socialNetworkUser, offset: $offset, limit: $limit, isLinked: $isLinked, keyword: $keyword) {
    count
    socialNetworkAccounts {
      id
      name
      isLinked
      url
      haveInstagramAccount
    }
  }
}
    `;

/**
 * __useGetSocialNetworkAccountsQuery__
 *
 * To run a query within a React component, call `useGetSocialNetworkAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialNetworkAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialNetworkAccountsQuery({
 *   variables: {
 *      socialNetwork: // value for 'socialNetwork'
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      isLinked: // value for 'isLinked'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useGetSocialNetworkAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialNetworkAccountsQuery, GetSocialNetworkAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialNetworkAccountsQuery, GetSocialNetworkAccountsQueryVariables>(GetSocialNetworkAccountsDocument, options);
      }
export function useGetSocialNetworkAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialNetworkAccountsQuery, GetSocialNetworkAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialNetworkAccountsQuery, GetSocialNetworkAccountsQueryVariables>(GetSocialNetworkAccountsDocument, options);
        }
export type GetSocialNetworkAccountsQueryHookResult = ReturnType<typeof useGetSocialNetworkAccountsQuery>;
export type GetSocialNetworkAccountsLazyQueryHookResult = ReturnType<typeof useGetSocialNetworkAccountsLazyQuery>;
export type GetSocialNetworkAccountsQueryResult = Apollo.QueryResult<GetSocialNetworkAccountsQuery, GetSocialNetworkAccountsQueryVariables>;
export const GetSocialNetworkUsersDocument = gql`
    query getSocialNetworkUsers($socialNetwork: SocialNetwork!) {
  getSocialNetworkUsers(socialNetwork: $socialNetwork) {
    id
    username
    isTokenValid
    connected
    accountType
    socialNetwork
    mainAccount
    isSystemUser
  }
}
    `;

/**
 * __useGetSocialNetworkUsersQuery__
 *
 * To run a query within a React component, call `useGetSocialNetworkUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialNetworkUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialNetworkUsersQuery({
 *   variables: {
 *      socialNetwork: // value for 'socialNetwork'
 *   },
 * });
 */
export function useGetSocialNetworkUsersQuery(baseOptions: Apollo.QueryHookOptions<GetSocialNetworkUsersQuery, GetSocialNetworkUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialNetworkUsersQuery, GetSocialNetworkUsersQueryVariables>(GetSocialNetworkUsersDocument, options);
      }
export function useGetSocialNetworkUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialNetworkUsersQuery, GetSocialNetworkUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialNetworkUsersQuery, GetSocialNetworkUsersQueryVariables>(GetSocialNetworkUsersDocument, options);
        }
export type GetSocialNetworkUsersQueryHookResult = ReturnType<typeof useGetSocialNetworkUsersQuery>;
export type GetSocialNetworkUsersLazyQueryHookResult = ReturnType<typeof useGetSocialNetworkUsersLazyQuery>;
export type GetSocialNetworkUsersQueryResult = Apollo.QueryResult<GetSocialNetworkUsersQuery, GetSocialNetworkUsersQueryVariables>;
export const GetStateSaveChiliBySalespointDocument = gql`
    query getStateSaveChiliBySalespoint {
  getStateSaveChiliBySalespoint
}
    `;

/**
 * __useGetStateSaveChiliBySalespointQuery__
 *
 * To run a query within a React component, call `useGetStateSaveChiliBySalespointQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateSaveChiliBySalespointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateSaveChiliBySalespointQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStateSaveChiliBySalespointQuery(baseOptions?: Apollo.QueryHookOptions<GetStateSaveChiliBySalespointQuery, GetStateSaveChiliBySalespointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateSaveChiliBySalespointQuery, GetStateSaveChiliBySalespointQueryVariables>(GetStateSaveChiliBySalespointDocument, options);
      }
export function useGetStateSaveChiliBySalespointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateSaveChiliBySalespointQuery, GetStateSaveChiliBySalespointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateSaveChiliBySalespointQuery, GetStateSaveChiliBySalespointQueryVariables>(GetStateSaveChiliBySalespointDocument, options);
        }
export type GetStateSaveChiliBySalespointQueryHookResult = ReturnType<typeof useGetStateSaveChiliBySalespointQuery>;
export type GetStateSaveChiliBySalespointLazyQueryHookResult = ReturnType<typeof useGetStateSaveChiliBySalespointLazyQuery>;
export type GetStateSaveChiliBySalespointQueryResult = Apollo.QueryResult<GetStateSaveChiliBySalespointQuery, GetStateSaveChiliBySalespointQueryVariables>;
export const GetTagsMediasDocument = gql`
    query getTagsMedias($offset: Int, $limit: Int, $sort: TagsSort, $filter: TagsFilters) {
  tags(offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
    tags {
      id
      label
      tagGroup {
        id
        name
      }
      enabled
    }
    count
  }
}
    `;

/**
 * __useGetTagsMediasQuery__
 *
 * To run a query within a React component, call `useGetTagsMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsMediasQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTagsMediasQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsMediasQuery, GetTagsMediasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsMediasQuery, GetTagsMediasQueryVariables>(GetTagsMediasDocument, options);
      }
export function useGetTagsMediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsMediasQuery, GetTagsMediasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsMediasQuery, GetTagsMediasQueryVariables>(GetTagsMediasDocument, options);
        }
export type GetTagsMediasQueryHookResult = ReturnType<typeof useGetTagsMediasQuery>;
export type GetTagsMediasLazyQueryHookResult = ReturnType<typeof useGetTagsMediasLazyQuery>;
export type GetTagsMediasQueryResult = Apollo.QueryResult<GetTagsMediasQuery, GetTagsMediasQueryVariables>;
export const GetUrlColorCssDocument = gql`
    query getUrlColorCss {
  getUrlColorCss {
    url
  }
}
    `;

/**
 * __useGetUrlColorCssQuery__
 *
 * To run a query within a React component, call `useGetUrlColorCssQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUrlColorCssQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUrlColorCssQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUrlColorCssQuery(baseOptions?: Apollo.QueryHookOptions<GetUrlColorCssQuery, GetUrlColorCssQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUrlColorCssQuery, GetUrlColorCssQueryVariables>(GetUrlColorCssDocument, options);
      }
export function useGetUrlColorCssLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUrlColorCssQuery, GetUrlColorCssQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUrlColorCssQuery, GetUrlColorCssQueryVariables>(GetUrlColorCssDocument, options);
        }
export type GetUrlColorCssQueryHookResult = ReturnType<typeof useGetUrlColorCssQuery>;
export type GetUrlColorCssLazyQueryHookResult = ReturnType<typeof useGetUrlColorCssLazyQuery>;
export type GetUrlColorCssQueryResult = Apollo.QueryResult<GetUrlColorCssQuery, GetUrlColorCssQueryVariables>;
export const GetUserAvailableSocialNetworksDocument = gql`
    query getUserAvailableSocialNetworks {
  getUserAvailableSocialNetworks
}
    `;

/**
 * __useGetUserAvailableSocialNetworksQuery__
 *
 * To run a query within a React component, call `useGetUserAvailableSocialNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAvailableSocialNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAvailableSocialNetworksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAvailableSocialNetworksQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAvailableSocialNetworksQuery, GetUserAvailableSocialNetworksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAvailableSocialNetworksQuery, GetUserAvailableSocialNetworksQueryVariables>(GetUserAvailableSocialNetworksDocument, options);
      }
export function useGetUserAvailableSocialNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAvailableSocialNetworksQuery, GetUserAvailableSocialNetworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAvailableSocialNetworksQuery, GetUserAvailableSocialNetworksQueryVariables>(GetUserAvailableSocialNetworksDocument, options);
        }
export type GetUserAvailableSocialNetworksQueryHookResult = ReturnType<typeof useGetUserAvailableSocialNetworksQuery>;
export type GetUserAvailableSocialNetworksLazyQueryHookResult = ReturnType<typeof useGetUserAvailableSocialNetworksLazyQuery>;
export type GetUserAvailableSocialNetworksQueryResult = Apollo.QueryResult<GetUserAvailableSocialNetworksQuery, GetUserAvailableSocialNetworksQueryVariables>;
export const HierarchyMediaDocument = gql`
    query hierarchyMedia($id: ID!) {
  hierarchyMedia(id: $id) {
    name
    folderId
  }
}
    `;

/**
 * __useHierarchyMediaQuery__
 *
 * To run a query within a React component, call `useHierarchyMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyMediaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHierarchyMediaQuery(baseOptions: Apollo.QueryHookOptions<HierarchyMediaQuery, HierarchyMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HierarchyMediaQuery, HierarchyMediaQueryVariables>(HierarchyMediaDocument, options);
      }
export function useHierarchyMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HierarchyMediaQuery, HierarchyMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HierarchyMediaQuery, HierarchyMediaQueryVariables>(HierarchyMediaDocument, options);
        }
export type HierarchyMediaQueryHookResult = ReturnType<typeof useHierarchyMediaQuery>;
export type HierarchyMediaLazyQueryHookResult = ReturnType<typeof useHierarchyMediaLazyQuery>;
export type HierarchyMediaQueryResult = Apollo.QueryResult<HierarchyMediaQuery, HierarchyMediaQueryVariables>;
export const HomePageAllSettingsDocument = gql`
    query homePageAllSettings {
  getAllHomePageSettings {
    id
    lang
    slides {
      enabled
      order
      sliderType
      slidesDetails {
        id
        title
        secondaryText
        textColor
        buttonDisplay
        buttonText
        redirectionLink
        order
        image {
          thumbnail
          large
          medium
          small
          original
        }
      }
    }
    campaign {
      enabled
      title
      text
      buttonText
      buttonLink
      customCampaignsEnabled
      campaignIds {
        campaignId
        order
      }
      order
    }
    callToAction {
      enabled
      order
      callToActions {
        order
        title
        secondaryText
        buttonName
        redirectionUrl
      }
    }
    shop {
      enabled
      order
      title
    }
    library {
      enabled
      order
      title
    }
    planning {
      enabled
      order
      title
    }
  }
}
    `;

/**
 * __useHomePageAllSettingsQuery__
 *
 * To run a query within a React component, call `useHomePageAllSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageAllSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageAllSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageAllSettingsQuery(baseOptions?: Apollo.QueryHookOptions<HomePageAllSettingsQuery, HomePageAllSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageAllSettingsQuery, HomePageAllSettingsQueryVariables>(HomePageAllSettingsDocument, options);
      }
export function useHomePageAllSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageAllSettingsQuery, HomePageAllSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageAllSettingsQuery, HomePageAllSettingsQueryVariables>(HomePageAllSettingsDocument, options);
        }
export type HomePageAllSettingsQueryHookResult = ReturnType<typeof useHomePageAllSettingsQuery>;
export type HomePageAllSettingsLazyQueryHookResult = ReturnType<typeof useHomePageAllSettingsLazyQuery>;
export type HomePageAllSettingsQueryResult = Apollo.QueryResult<HomePageAllSettingsQuery, HomePageAllSettingsQueryVariables>;
export const HomePageSettingsDocument = gql`
    query homePageSettings {
  getHomePageSettings {
    id
    lang
    slides {
      enabled
      order
      sliderType
      slidesDetails {
        id
        title
        secondaryText
        textColor
        buttonDisplay
        buttonText
        redirectionLink
        order
        image {
          original
        }
      }
    }
    campaign {
      enabled
      title
      text
      buttonText
      buttonLink
      customCampaignsEnabled
      campaignIds {
        campaignId
        order
      }
      order
    }
    callToAction {
      enabled
      order
      callToActions {
        order
        title
        secondaryText
        buttonName
        redirectionUrl
      }
    }
    shop {
      enabled
      order
      title
    }
    library {
      enabled
      order
      title
    }
    planning {
      enabled
      order
      title
    }
  }
}
    `;

/**
 * __useHomePageSettingsQuery__
 *
 * To run a query within a React component, call `useHomePageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageSettingsQuery(baseOptions?: Apollo.QueryHookOptions<HomePageSettingsQuery, HomePageSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageSettingsQuery, HomePageSettingsQueryVariables>(HomePageSettingsDocument, options);
      }
export function useHomePageSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageSettingsQuery, HomePageSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageSettingsQuery, HomePageSettingsQueryVariables>(HomePageSettingsDocument, options);
        }
export type HomePageSettingsQueryHookResult = ReturnType<typeof useHomePageSettingsQuery>;
export type HomePageSettingsLazyQueryHookResult = ReturnType<typeof useHomePageSettingsLazyQuery>;
export type HomePageSettingsQueryResult = Apollo.QueryResult<HomePageSettingsQuery, HomePageSettingsQueryVariables>;
export const HomepageCampaignsDocument = gql`
    query homepageCampaigns($salespointGroups: [ID], $types: [CampaignType!]!) {
  campaignsPerPeriods(salespointGroups: $salespointGroups, types: $types) {
    homepageCampaigns {
      ...CampaignFragment
      hasPreorderProducts
      preorderEndDate
      preorderDaysRemaining
    }
  }
}
    ${CampaignFragmentFragmentDoc}`;

/**
 * __useHomepageCampaignsQuery__
 *
 * To run a query within a React component, call `useHomepageCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageCampaignsQuery({
 *   variables: {
 *      salespointGroups: // value for 'salespointGroups'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useHomepageCampaignsQuery(baseOptions: Apollo.QueryHookOptions<HomepageCampaignsQuery, HomepageCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomepageCampaignsQuery, HomepageCampaignsQueryVariables>(HomepageCampaignsDocument, options);
      }
export function useHomepageCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomepageCampaignsQuery, HomepageCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomepageCampaignsQuery, HomepageCampaignsQueryVariables>(HomepageCampaignsDocument, options);
        }
export type HomepageCampaignsQueryHookResult = ReturnType<typeof useHomepageCampaignsQuery>;
export type HomepageCampaignsLazyQueryHookResult = ReturnType<typeof useHomepageCampaignsLazyQuery>;
export type HomepageCampaignsQueryResult = Apollo.QueryResult<HomepageCampaignsQuery, HomepageCampaignsQueryVariables>;
export const LanguageSelectOptionsDocument = gql`
    query languageSelectOptions {
  languageSelectOptions
}
    `;

/**
 * __useLanguageSelectOptionsQuery__
 *
 * To run a query within a React component, call `useLanguageSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguageSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<LanguageSelectOptionsQuery, LanguageSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguageSelectOptionsQuery, LanguageSelectOptionsQueryVariables>(LanguageSelectOptionsDocument, options);
      }
export function useLanguageSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguageSelectOptionsQuery, LanguageSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguageSelectOptionsQuery, LanguageSelectOptionsQueryVariables>(LanguageSelectOptionsDocument, options);
        }
export type LanguageSelectOptionsQueryHookResult = ReturnType<typeof useLanguageSelectOptionsQuery>;
export type LanguageSelectOptionsLazyQueryHookResult = ReturnType<typeof useLanguageSelectOptionsLazyQuery>;
export type LanguageSelectOptionsQueryResult = Apollo.QueryResult<LanguageSelectOptionsQuery, LanguageSelectOptionsQueryVariables>;
export const GetPostCalendarDetails_And_Client_NameDocument = gql`
    query getPostCalendarDetails_and_client_name($publishId: ID!) {
  me {
    id
    client {
      id
      name
    }
  }
  getPostCalendarDetails(publishId: $publishId) {
    id
    levelEditable
    type
    description
    rawDescription
    htmlDescription
    caller
    socialNetworksDescription {
      facebook
      instagram
      linkedin
      google
      twitter
    }
    socialNetworksRawDescription {
      facebook
      instagram
      linkedin
      google
      twitter
    }
    scheduledAt
    validationDate
    validatorRole
    socialNetworkTarget
    isDraft
    status
    callToAction
    target {
      type
      globals
      onSalesPoints
      onGlobals
      targetToExclude
      salespointGroups {
        id
        name
      }
      salesPoints {
        id
        name
      }
    }
    link
    dynamicLink
    cover {
      path
      mimeType
    }
    avatar {
      path
      mimeType
    }
    medias {
      path
      mimeType
      size
      width
      height
      extension
    }
    thumb {
      path
      mimeType
    }
    carouselItems {
      position
      link
      title
      description
      callToAction
      media {
        path
        mimeType
      }
    }
    event {
      title
      startAt
      endAt
      callToAction
      terms
      couponCode
    }
    organicTargeting {
      sexTargeting
      sexOfTarget
      ageTargeting
      minAgeTarget
      maxAgeTarget
      targetingInterests {
        facebookKey
        name
      }
      targetingCountries {
        facebookKey
        name
      }
      targetingGeolocations {
        facebookKey
        name
      }
      cityKeysTarget
    }
  }
}
    `;

/**
 * __useGetPostCalendarDetails_And_Client_NameQuery__
 *
 * To run a query within a React component, call `useGetPostCalendarDetails_And_Client_NameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCalendarDetails_And_Client_NameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCalendarDetails_And_Client_NameQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useGetPostCalendarDetails_And_Client_NameQuery(baseOptions: Apollo.QueryHookOptions<GetPostCalendarDetails_And_Client_NameQuery, GetPostCalendarDetails_And_Client_NameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCalendarDetails_And_Client_NameQuery, GetPostCalendarDetails_And_Client_NameQueryVariables>(GetPostCalendarDetails_And_Client_NameDocument, options);
      }
export function useGetPostCalendarDetails_And_Client_NameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCalendarDetails_And_Client_NameQuery, GetPostCalendarDetails_And_Client_NameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCalendarDetails_And_Client_NameQuery, GetPostCalendarDetails_And_Client_NameQueryVariables>(GetPostCalendarDetails_And_Client_NameDocument, options);
        }
export type GetPostCalendarDetails_And_Client_NameQueryHookResult = ReturnType<typeof useGetPostCalendarDetails_And_Client_NameQuery>;
export type GetPostCalendarDetails_And_Client_NameLazyQueryHookResult = ReturnType<typeof useGetPostCalendarDetails_And_Client_NameLazyQuery>;
export type GetPostCalendarDetails_And_Client_NameQueryResult = Apollo.QueryResult<GetPostCalendarDetails_And_Client_NameQuery, GetPostCalendarDetails_And_Client_NameQueryVariables>;
export const MediaByIdDocument = gql`
    query mediaById($id: ID!) {
  mediaById(id: $id) {
    id
    type
    name
    fileType
    thumbnail
    validFrom
    validTo
    details {
      description
      tips
      size
      tags {
        id
        label
      }
    }
    salespointsGroups {
      id
      name
    }
    campaigns {
      id
      name
    }
    images {
      thumbnail
      large
    }
  }
}
    `;

/**
 * __useMediaByIdQuery__
 *
 * To run a query within a React component, call `useMediaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaByIdQuery(baseOptions: Apollo.QueryHookOptions<MediaByIdQuery, MediaByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaByIdQuery, MediaByIdQueryVariables>(MediaByIdDocument, options);
      }
export function useMediaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaByIdQuery, MediaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaByIdQuery, MediaByIdQueryVariables>(MediaByIdDocument, options);
        }
export type MediaByIdQueryHookResult = ReturnType<typeof useMediaByIdQuery>;
export type MediaByIdLazyQueryHookResult = ReturnType<typeof useMediaByIdLazyQuery>;
export type MediaByIdQueryResult = Apollo.QueryResult<MediaByIdQuery, MediaByIdQueryVariables>;
export const MediaByIdChiliDocument = gql`
    query mediaByIdChili($id: ID!) {
  mediaById(id: $id) {
    id
    type
    name
    fileType
    thumbnail
    isDownloadByEmail
    chiliDetails {
      documentId
      documentDownloadSettingsId
      documentWorkspaceId
      documentViewPrefsId
      exportTypeIds
    }
    validFrom
    validTo
    details {
      description
      tips
      size
      tags {
        id
        label
      }
    }
    salespointsGroups {
      id
      name
    }
    campaigns {
      id
      name
    }
    images {
      thumbnail
    }
  }
}
    `;

/**
 * __useMediaByIdChiliQuery__
 *
 * To run a query within a React component, call `useMediaByIdChiliQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaByIdChiliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaByIdChiliQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaByIdChiliQuery(baseOptions: Apollo.QueryHookOptions<MediaByIdChiliQuery, MediaByIdChiliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaByIdChiliQuery, MediaByIdChiliQueryVariables>(MediaByIdChiliDocument, options);
      }
export function useMediaByIdChiliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaByIdChiliQuery, MediaByIdChiliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaByIdChiliQuery, MediaByIdChiliQueryVariables>(MediaByIdChiliDocument, options);
        }
export type MediaByIdChiliQueryHookResult = ReturnType<typeof useMediaByIdChiliQuery>;
export type MediaByIdChiliLazyQueryHookResult = ReturnType<typeof useMediaByIdChiliLazyQuery>;
export type MediaByIdChiliQueryResult = Apollo.QueryResult<MediaByIdChiliQuery, MediaByIdChiliQueryVariables>;
export const MediaFilterGroupsDocument = gql`
    query mediaFilterGroups($filters: [MediaFilterInput], $folderId: ID, $types: [MediaTypeFilter], $bypassSalespointsGroups: Boolean) {
  mediaFilterGroups(filters: $filters, folderId: $folderId, types: $types, bypassSalespointsGroups: $bypassSalespointsGroups) {
    id
    name
    type
    options {
      id
      name
      count
    }
  }
}
    `;

/**
 * __useMediaFilterGroupsQuery__
 *
 * To run a query within a React component, call `useMediaFilterGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaFilterGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaFilterGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      folderId: // value for 'folderId'
 *      types: // value for 'types'
 *      bypassSalespointsGroups: // value for 'bypassSalespointsGroups'
 *   },
 * });
 */
export function useMediaFilterGroupsQuery(baseOptions?: Apollo.QueryHookOptions<MediaFilterGroupsQuery, MediaFilterGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaFilterGroupsQuery, MediaFilterGroupsQueryVariables>(MediaFilterGroupsDocument, options);
      }
export function useMediaFilterGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaFilterGroupsQuery, MediaFilterGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaFilterGroupsQuery, MediaFilterGroupsQueryVariables>(MediaFilterGroupsDocument, options);
        }
export type MediaFilterGroupsQueryHookResult = ReturnType<typeof useMediaFilterGroupsQuery>;
export type MediaFilterGroupsLazyQueryHookResult = ReturnType<typeof useMediaFilterGroupsLazyQuery>;
export type MediaFilterGroupsQueryResult = Apollo.QueryResult<MediaFilterGroupsQuery, MediaFilterGroupsQueryVariables>;
export const MediasDocument = gql`
    query medias($offset: Int, $limit: Int, $sort: MediaSort, $folderId: ID, $filters: [MediaFilterInput], $keyword: String, $searchInSubfolders: Boolean, $bypassSalespointsGroups: Boolean, $salespointsGroups: [ID], $campaignId: ID, $includeHighlighted: Boolean, $excludeDisabledForAdmin: Boolean, $types: [MediaTypeFilter]) {
  medias(offset: $offset, limit: $limit, sort: $sort, folderId: $folderId, filters: $filters, keyword: $keyword, searchInSubfolders: $searchInSubfolders, bypassSalespointsGroups: $bypassSalespointsGroups, salespointsGroups: $salespointsGroups, campaignId: $campaignId, includeHighlighted: $includeHighlighted, excludeDisabledForAdmin: $excludeDisabledForAdmin, types: $types) {
    count
    highlighted {
      tag {
        id
        label
        enabled
        createdAt
        updatedAt
        library {
          isHighlighted
          highlightOrder
        }
      }
      medias {
        id
        name
        type
        details {
          description
          tips
          size
          mimetype
          tags {
            id
            label
          }
        }
        fileType
        thumbnail
        tempUrl
        enabled
        images {
          thumbnail
          large
          medium
          small
        }
      }
    }
    medias {
      id
      name
      details {
        description
        tips
        size
        mimetype
        tags {
          id
          label
        }
      }
      type
      fileType
      thumbnail
      tempUrl
      enabled
      images {
        thumbnail
        large
        medium
        small
      }
    }
  }
}
    `;

/**
 * __useMediasQuery__
 *
 * To run a query within a React component, call `useMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediasQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      folderId: // value for 'folderId'
 *      filters: // value for 'filters'
 *      keyword: // value for 'keyword'
 *      searchInSubfolders: // value for 'searchInSubfolders'
 *      bypassSalespointsGroups: // value for 'bypassSalespointsGroups'
 *      salespointsGroups: // value for 'salespointsGroups'
 *      campaignId: // value for 'campaignId'
 *      includeHighlighted: // value for 'includeHighlighted'
 *      excludeDisabledForAdmin: // value for 'excludeDisabledForAdmin'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useMediasQuery(baseOptions?: Apollo.QueryHookOptions<MediasQuery, MediasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediasQuery, MediasQueryVariables>(MediasDocument, options);
      }
export function useMediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediasQuery, MediasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediasQuery, MediasQueryVariables>(MediasDocument, options);
        }
export type MediasQueryHookResult = ReturnType<typeof useMediasQuery>;
export type MediasLazyQueryHookResult = ReturnType<typeof useMediasLazyQuery>;
export type MediasQueryResult = Apollo.QueryResult<MediasQuery, MediasQueryVariables>;
export const Medias_For_Upload_ModalDocument = gql`
    query medias_for_upload_modal($offset: Int, $limit: Int, $sort: MediaSort, $folderId: ID, $filters: [MediaFilterInput], $keyword: String, $bypassSalespointsGroups: Boolean, $salespointsGroups: [ID], $campaignId: ID, $includeHighlighted: Boolean, $excludeDisabledForAdmin: Boolean) {
  medias(offset: $offset, limit: $limit, sort: $sort, folderId: $folderId, filters: $filters, keyword: $keyword, bypassSalespointsGroups: $bypassSalespointsGroups, salespointsGroups: $salespointsGroups, campaignId: $campaignId, includeHighlighted: $includeHighlighted, excludeDisabledForAdmin: $excludeDisabledForAdmin) {
    count
    medias {
      id
      name
      fileType
      details {
        size
        mimetype
        extension
        width
        height
      }
      tempUrl
      thumbnail
      images {
        medium
      }
    }
  }
}
    `;

/**
 * __useMedias_For_Upload_ModalQuery__
 *
 * To run a query within a React component, call `useMedias_For_Upload_ModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedias_For_Upload_ModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedias_For_Upload_ModalQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      folderId: // value for 'folderId'
 *      filters: // value for 'filters'
 *      keyword: // value for 'keyword'
 *      bypassSalespointsGroups: // value for 'bypassSalespointsGroups'
 *      salespointsGroups: // value for 'salespointsGroups'
 *      campaignId: // value for 'campaignId'
 *      includeHighlighted: // value for 'includeHighlighted'
 *      excludeDisabledForAdmin: // value for 'excludeDisabledForAdmin'
 *   },
 * });
 */
export function useMedias_For_Upload_ModalQuery(baseOptions?: Apollo.QueryHookOptions<Medias_For_Upload_ModalQuery, Medias_For_Upload_ModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Medias_For_Upload_ModalQuery, Medias_For_Upload_ModalQueryVariables>(Medias_For_Upload_ModalDocument, options);
      }
export function useMedias_For_Upload_ModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Medias_For_Upload_ModalQuery, Medias_For_Upload_ModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Medias_For_Upload_ModalQuery, Medias_For_Upload_ModalQueryVariables>(Medias_For_Upload_ModalDocument, options);
        }
export type Medias_For_Upload_ModalQueryHookResult = ReturnType<typeof useMedias_For_Upload_ModalQuery>;
export type Medias_For_Upload_ModalLazyQueryHookResult = ReturnType<typeof useMedias_For_Upload_ModalLazyQuery>;
export type Medias_For_Upload_ModalQueryResult = Apollo.QueryResult<Medias_For_Upload_ModalQuery, Medias_For_Upload_ModalQueryVariables>;
export const OrderDetailsDocument = gql`
    query orderDetails($orderId: ID!) {
  orderDetails(orderId: $orderId) {
    id
    orderNumber
    trackingNumber
    trackingURL
    userId
    status
    receipt
    totalProductsQuantity
    date
    items {
      productId
      subId
      packInfo {
        id
        name
        ref
        productsInPack {
          id
          name
          ref
        }
      }
      product {
        id
        name
        ref
        description
        isCustomizable
        price {
          basePrice {
            withoutTaxes
          }
        }
        images {
          small
        }
        tags {
          id
          label
          color
        }
        highQualityAsset {
          url
          name
        }
      }
      quantity
      variationByQuantity {
        quantity
        values
      }
    }
    addresses {
      shipping {
        firstname
        lastname
        company
        phone
        address
        postalCode
        city
        country
      }
      billing {
        firstname
        lastname
        company
        phone
        address
        postalCode
        city
        country
      }
    }
    vouchers {
      name
      amount
    }
    total {
      basePrice {
        withoutTaxes
        withTaxes
        taxPercent
        taxAmount
      }
    }
    totalWithFees {
      basePrice {
        withoutTaxes
        taxPercent
        taxAmount
        withTaxes
      }
      discountedPrice {
        withoutTaxes
        withTaxes
        taxAmount
        taxPercent
      }
    }
  }
}
    `;

/**
 * __useOrderDetailsQuery__
 *
 * To run a query within a React component, call `useOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<OrderDetailsQuery, OrderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderDetailsQuery, OrderDetailsQueryVariables>(OrderDetailsDocument, options);
      }
export function useOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderDetailsQuery, OrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderDetailsQuery, OrderDetailsQueryVariables>(OrderDetailsDocument, options);
        }
export type OrderDetailsQueryHookResult = ReturnType<typeof useOrderDetailsQuery>;
export type OrderDetailsLazyQueryHookResult = ReturnType<typeof useOrderDetailsLazyQuery>;
export type OrderDetailsQueryResult = Apollo.QueryResult<OrderDetailsQuery, OrderDetailsQueryVariables>;
export const OrderDetailsWithModerationDocument = gql`
    query orderDetailsWithModeration($orderId: ID!) {
  orderDetails(orderId: $orderId) {
    id
    affairCode
    parentOrderId
    sisterOrderCount
    orderNumber
    trackingNumber
    trackingURL
    userId
    status
    receipt
    totalProductsQuantity
    date
    validationDate
    roleValidator
    reason
    isPurchaseOrder
    shippingFees
    isValidator
    paymentInfo {
      currentStatus
      stripePaymentMethod
    }
    author {
      id
      fullName
      email
    }
    salespoint {
      id
      name
    }
    client {
      id
      shopOptions {
        isShippingFeesEnabled
        displayTaxes
        billingAddress {
          address
          additionalAddress
          company
          city
          country
          postalCode
        }
      }
    }
    paymentMethod {
      type
      documentType
    }
    messages {
      id
      content
      createdAt
      isCancelledReason
    }
    validator {
      id
      fullName
    }
    hasArchive
    items {
      hasArchive
      productId
      subId
      comment
      files {
        id
        originalName
        url
      }
      options {
        id
        name
        price
      }
      unitPrice {
        basePrice {
          withoutTaxes
        }
      }
      totalPrice {
        basePrice {
          withoutTaxes
        }
      }
      product {
        id
        name
        ref
        description
        isCustomizable
        packagingUnit
        price {
          basePrice {
            withoutTaxes
          }
        }
        images {
          thumbnail
        }
        tags {
          id
          label
          color
        }
        highQualityAsset {
          url
          name
        }
      }
      quantity
      variationByQuantity {
        quantity
        values
      }
    }
    addresses {
      shipping {
        firstname
        lastname
        company
        phone
        address
        postalCode
        city
        country
        salespoint {
          name
        }
      }
      billing {
        firstname
        lastname
        company
        phone
        address
        postalCode
        city
        country
      }
    }
    vouchers {
      name
      amount
    }
    total {
      basePrice {
        withoutTaxes
        withTaxes
        taxPercent
        taxAmount
      }
    }
    totalWithFees {
      basePrice {
        withoutTaxes
        taxPercent
        taxAmount
        withTaxes
      }
      discountedPrice {
        withoutTaxes
        withTaxes
        taxAmount
        taxPercent
      }
    }
    totalWithShippingFees {
      basePrice {
        withTaxes
        withoutTaxes
        taxAmount
        taxPercent
      }
      discountedPrice {
        withoutTaxes
        withTaxes
        taxAmount
        taxPercent
      }
    }
  }
}
    `;

/**
 * __useOrderDetailsWithModerationQuery__
 *
 * To run a query within a React component, call `useOrderDetailsWithModerationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailsWithModerationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailsWithModerationQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderDetailsWithModerationQuery(baseOptions: Apollo.QueryHookOptions<OrderDetailsWithModerationQuery, OrderDetailsWithModerationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderDetailsWithModerationQuery, OrderDetailsWithModerationQueryVariables>(OrderDetailsWithModerationDocument, options);
      }
export function useOrderDetailsWithModerationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderDetailsWithModerationQuery, OrderDetailsWithModerationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderDetailsWithModerationQuery, OrderDetailsWithModerationQueryVariables>(OrderDetailsWithModerationDocument, options);
        }
export type OrderDetailsWithModerationQueryHookResult = ReturnType<typeof useOrderDetailsWithModerationQuery>;
export type OrderDetailsWithModerationLazyQueryHookResult = ReturnType<typeof useOrderDetailsWithModerationLazyQuery>;
export type OrderDetailsWithModerationQueryResult = Apollo.QueryResult<OrderDetailsWithModerationQuery, OrderDetailsWithModerationQueryVariables>;
export const OrdersByUserIdDocument = gql`
    query ordersByUserId($offset: Int, $limit: Int, $sort: Direction, $filter: OrderFilter, $salespointsIds: [ID], $groupsIds: [ID]) {
  ordersByUserId(offset: $offset, limit: $limit, sort: $sort, filter: $filter, salespointsIds: $salespointsIds, groupsIds: $groupsIds) {
    count
    totalWithoutTaxes
    orders {
      id
      isValidator
      orderNumber
      trackingNumber
      trackingURL
      userId
      status
      receipt
      totalProductsQuantity
      date
      isPurchaseOrder
      paymentMethod {
        type
        documentType
      }
      paymentInfo {
        currentStatus
        stripePaymentMethod
      }
      author {
        id
        fullName
      }
      salespoint {
        id
        name
      }
      items {
        productId
        subId
        providerId
        packInfo {
          id
          name
          ref
          productsInPack {
            id
            name
            ref
          }
        }
        product {
          id
          name
          ref
          description
          isCustomizable
          type
          images {
            small
          }
          tags {
            id
            label
            color
          }
          highQualityAsset {
            url
            name
          }
        }
        variationByQuantity {
          quantity
          values
        }
        quantity
      }
      addresses {
        shipping {
          firstname
          lastname
          company
          phone
          address
          postalCode
          city
          country
        }
        billing {
          firstname
          lastname
          company
          phone
          address
          postalCode
          city
          country
        }
      }
      vouchers {
        name
        amount
      }
      provider {
        name
      }
      total {
        basePrice {
          withoutTaxes
          withTaxes
          taxPercent
          taxAmount
        }
        discountedPrice {
          withoutTaxes
          withTaxes
          taxAmount
          taxPercent
        }
      }
      totalWithFees {
        basePrice {
          withoutTaxes
          taxPercent
          taxAmount
          withTaxes
        }
        discountedPrice {
          withoutTaxes
          withTaxes
          taxAmount
          taxPercent
        }
      }
      totalWithShippingFees {
        basePrice {
          withoutTaxes
          withTaxes
          taxPercent
          taxAmount
        }
      }
      providerInvoice {
        path
      }
    }
  }
}
    `;

/**
 * __useOrdersByUserIdQuery__
 *
 * To run a query within a React component, call `useOrdersByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersByUserIdQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      salespointsIds: // value for 'salespointsIds'
 *      groupsIds: // value for 'groupsIds'
 *   },
 * });
 */
export function useOrdersByUserIdQuery(baseOptions?: Apollo.QueryHookOptions<OrdersByUserIdQuery, OrdersByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersByUserIdQuery, OrdersByUserIdQueryVariables>(OrdersByUserIdDocument, options);
      }
export function useOrdersByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersByUserIdQuery, OrdersByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersByUserIdQuery, OrdersByUserIdQueryVariables>(OrdersByUserIdDocument, options);
        }
export type OrdersByUserIdQueryHookResult = ReturnType<typeof useOrdersByUserIdQuery>;
export type OrdersByUserIdLazyQueryHookResult = ReturnType<typeof useOrdersByUserIdLazyQuery>;
export type OrdersByUserIdQueryResult = Apollo.QueryResult<OrdersByUserIdQuery, OrdersByUserIdQueryVariables>;
export const ParentOrderByIdDocument = gql`
    query parentOrderById($parentOrderId: ID!) {
  parentOrderById(parentOrderId: $parentOrderId) {
    orderNumber
  }
}
    `;

/**
 * __useParentOrderByIdQuery__
 *
 * To run a query within a React component, call `useParentOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParentOrderByIdQuery({
 *   variables: {
 *      parentOrderId: // value for 'parentOrderId'
 *   },
 * });
 */
export function useParentOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<ParentOrderByIdQuery, ParentOrderByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParentOrderByIdQuery, ParentOrderByIdQueryVariables>(ParentOrderByIdDocument, options);
      }
export function useParentOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParentOrderByIdQuery, ParentOrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParentOrderByIdQuery, ParentOrderByIdQueryVariables>(ParentOrderByIdDocument, options);
        }
export type ParentOrderByIdQueryHookResult = ReturnType<typeof useParentOrderByIdQuery>;
export type ParentOrderByIdLazyQueryHookResult = ReturnType<typeof useParentOrderByIdLazyQuery>;
export type ParentOrderByIdQueryResult = Apollo.QueryResult<ParentOrderByIdQuery, ParentOrderByIdQueryVariables>;
export const PaymentSelectOptionsDocument = gql`
    query paymentSelectOptions {
  paymentSelectOptions
}
    `;

/**
 * __usePaymentSelectOptionsQuery__
 *
 * To run a query within a React component, call `usePaymentSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentSelectOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentSelectOptionsQuery, PaymentSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentSelectOptionsQuery, PaymentSelectOptionsQueryVariables>(PaymentSelectOptionsDocument, options);
      }
export function usePaymentSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentSelectOptionsQuery, PaymentSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentSelectOptionsQuery, PaymentSelectOptionsQueryVariables>(PaymentSelectOptionsDocument, options);
        }
export type PaymentSelectOptionsQueryHookResult = ReturnType<typeof usePaymentSelectOptionsQuery>;
export type PaymentSelectOptionsLazyQueryHookResult = ReturnType<typeof usePaymentSelectOptionsLazyQuery>;
export type PaymentSelectOptionsQueryResult = Apollo.QueryResult<PaymentSelectOptionsQuery, PaymentSelectOptionsQueryVariables>;
export const PreorderForCampaignDocument = gql`
    query preorderForCampaign($campaignId: ID!, $salesPointId: ID!) {
  preorderForCampaign(campaignId: $campaignId, salesPointId: $salesPointId) {
    id
    status
    ref
    submittedAt
    items {
      productId
      quantity
    }
  }
}
    `;

/**
 * __usePreorderForCampaignQuery__
 *
 * To run a query within a React component, call `usePreorderForCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreorderForCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreorderForCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      salesPointId: // value for 'salesPointId'
 *   },
 * });
 */
export function usePreorderForCampaignQuery(baseOptions: Apollo.QueryHookOptions<PreorderForCampaignQuery, PreorderForCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreorderForCampaignQuery, PreorderForCampaignQueryVariables>(PreorderForCampaignDocument, options);
      }
export function usePreorderForCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreorderForCampaignQuery, PreorderForCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreorderForCampaignQuery, PreorderForCampaignQueryVariables>(PreorderForCampaignDocument, options);
        }
export type PreorderForCampaignQueryHookResult = ReturnType<typeof usePreorderForCampaignQuery>;
export type PreorderForCampaignLazyQueryHookResult = ReturnType<typeof usePreorderForCampaignLazyQuery>;
export type PreorderForCampaignQueryResult = Apollo.QueryResult<PreorderForCampaignQuery, PreorderForCampaignQueryVariables>;
export const PreordersByUserIdDocument = gql`
    query preordersByUserId($offset: Int, $limit: Int, $sort: Direction, $sortBy: PreorderSortField, $filter: PreorderFilter, $salespointsIds: [ID!], $groupsIds: [ID!]) {
  preorders(offset: $offset, limit: $limit, sort: $sort, sortBy: $sortBy, filter: $filter, salespointsIds: $salespointsIds, groupsIds: $groupsIds) {
    count
    totalWithoutTaxes
    preorders {
      id
      ref
      status
      statusUx
      submittedAt
      createdAt
      salesPointId
      salesPointName
      providerName
      productsCount
      totalWithoutTaxes
      totalWithTaxes
      items {
        productId
        quantity
      }
      user {
        id
        firstname
        lastname
      }
      salesPoint {
        id
        name
      }
      campaign {
        id
        name
        preorderEndDate
      }
    }
  }
}
    `;

/**
 * __usePreordersByUserIdQuery__
 *
 * To run a query within a React component, call `usePreordersByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreordersByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreordersByUserIdQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *      salespointsIds: // value for 'salespointsIds'
 *      groupsIds: // value for 'groupsIds'
 *   },
 * });
 */
export function usePreordersByUserIdQuery(baseOptions?: Apollo.QueryHookOptions<PreordersByUserIdQuery, PreordersByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreordersByUserIdQuery, PreordersByUserIdQueryVariables>(PreordersByUserIdDocument, options);
      }
export function usePreordersByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreordersByUserIdQuery, PreordersByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreordersByUserIdQuery, PreordersByUserIdQueryVariables>(PreordersByUserIdDocument, options);
        }
export type PreordersByUserIdQueryHookResult = ReturnType<typeof usePreordersByUserIdQuery>;
export type PreordersByUserIdLazyQueryHookResult = ReturnType<typeof usePreordersByUserIdLazyQuery>;
export type PreordersByUserIdQueryResult = Apollo.QueryResult<PreordersByUserIdQuery, PreordersByUserIdQueryVariables>;
export const ProductByIdDocument = gql`
    query productById($id: ID!, $isQueryFromUpdateProductAdmin: Boolean) {
  productById(id: $id, isQueryFromUpdateProductAdmin: $isQueryFromUpdateProductAdmin) {
    id
    name
    providerId
    isBriefCrm
    crmSupports {
      id
      key
      value
      label
    }
    workType {
      id
      key
      value
      label
    }
    other
    isShowcase
    showcaseText
    availableQuantity {
      max
      min
    }
    userCanComment
    userCanUpload
    userCanAddFiles
    isRoutingFileEnabled
    packagingUnit
    isStockEnabled
    stock
    isMinimumOrderEnabled
    minimumOrder
    isMaximumOrderEnabled
    isGovernanceEnabled
    requiresOrderValidation
    maximumOrder {
      quantity
      period
    }
    maximumOrderExceptions {
      salespointGroupsIds
      salespointsIds
      quantity
      period
    }
    price {
      basePrice {
        withTaxes
        withoutTaxes
        taxAmount
        taxPercent
      }
    }
    catalogPriceLevels {
      quantity
      price
    }
    catalogFixPricesLevelsByQuantity {
      quantity
      price
    }
    fixPricesLevelsByQuantity {
      quantity
      price {
        basePrice {
          withTaxes
          withoutTaxes
          taxAmount
          taxPercent
        }
      }
    }
    priceType
    ref
    description
    isCustomizable
    images {
      id
      thumbnail
      large
      small
      medium
      original
      originName
      mime
    }
    campaigns {
      id
      name
    }
    tags {
      id
      label
      color
    }
    productOptions {
      id
      name
      price
      description
      position
      image {
        thumbnail
        large
        small
        medium
        original
      }
    }
    tips
    technicalCharacteristics
    type
    highQualityAsset {
      url
      name
    }
    lowQualityAsset {
      url
      name
      id
      mime
    }
    isPurchaseOrder
    isCommentEnabled
    documentId
    documentDownloadSettingsId
    documentWorkspaceId
    documentViewPrefsId
    exportTypeIds
    watermarkPreview
    useSalespointGroups
    useEnabledDates
    useLaunchDate
    useValidDate
    deliveryDate
    enabledDate
    disabledDate
    disabled
    isProposeForDownload
    isManyOptionsSelectable
    shouldHaveAtLeastOneOptionSelected
    shouldHaveExactOptionsSelected
    numberOfExactOptions
    paidMediaCampaignName
    isPaidMediaProduct
    hasVariation
    variation {
      name
      slug
      fixed
      values
    }
    variationByQuantity {
      quantity
      values
    }
    isDownloadByEmail
    contextGoalsIssues
    targeting
    productsInPack {
      product {
        id
        providerId
        name
        isBriefCrm
        isShowcase
        showcaseText
        availableQuantity {
          max
          min
        }
        userCanComment
        userCanUpload
        isRoutingFileEnabled
        packagingUnit
        isStockEnabled
        stock
        isMinimumOrderEnabled
        minimumOrder
        isMaximumOrderEnabled
        maximumOrder {
          quantity
          period
        }
        maximumOrderExceptions {
          salespointGroupsIds
          salespointsIds
          quantity
          period
        }
        price {
          basePrice {
            withTaxes
            withoutTaxes
            taxAmount
            taxPercent
          }
        }
        catalogPrice
        catalogPriceLevels {
          quantity
          price
        }
        catalogFixPricesLevelsByQuantity {
          quantity
          price
        }
        fixPricesLevelsByQuantity {
          quantity
          price {
            basePrice {
              withTaxes
              withoutTaxes
              taxAmount
              taxPercent
            }
          }
        }
        priceType
        ref
        isCustomizable
        images {
          id
          original
          originName
        }
        isPurchaseOrder
        isCommentEnabled
        documentId
        documentDownloadSettingsId
        documentWorkspaceId
        documentViewPrefsId
        exportTypeIds
        watermarkPreview
        hasVariation
        variation {
          name
          slug
          fixed
          values
        }
        variationByQuantity {
          quantity
          values
        }
      }
      position
    }
    isPack
    preorderAvailable
  }
}
    `;

/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isQueryFromUpdateProductAdmin: // value for 'isQueryFromUpdateProductAdmin'
 *   },
 * });
 */
export function useProductByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
      }
export function useProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, options);
        }
export type ProductByIdQueryHookResult = ReturnType<typeof useProductByIdQuery>;
export type ProductByIdLazyQueryHookResult = ReturnType<typeof useProductByIdLazyQuery>;
export type ProductByIdQueryResult = Apollo.QueryResult<ProductByIdQuery, ProductByIdQueryVariables>;
export const ProductFilterGroupsDocument = gql`
    query productFilterGroups($filters: [ProductFilterInput]) {
  productFilterGroups(filters: $filters) {
    name
    id
    filters {
      id
      name
      type
      details {
        options {
          id
          name
          count
        }
      }
    }
  }
}
    `;

/**
 * __useProductFilterGroupsQuery__
 *
 * To run a query within a React component, call `useProductFilterGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFilterGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFilterGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProductFilterGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ProductFilterGroupsQuery, ProductFilterGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFilterGroupsQuery, ProductFilterGroupsQueryVariables>(ProductFilterGroupsDocument, options);
      }
export function useProductFilterGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFilterGroupsQuery, ProductFilterGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFilterGroupsQuery, ProductFilterGroupsQueryVariables>(ProductFilterGroupsDocument, options);
        }
export type ProductFilterGroupsQueryHookResult = ReturnType<typeof useProductFilterGroupsQuery>;
export type ProductFilterGroupsLazyQueryHookResult = ReturnType<typeof useProductFilterGroupsLazyQuery>;
export type ProductFilterGroupsQueryResult = Apollo.QueryResult<ProductFilterGroupsQuery, ProductFilterGroupsQueryVariables>;
export const ProductsDocument = gql`
    query products($offset: Int, $limit: Int, $filters: [ProductFilterInput], $sort: ProductSort, $keyword: String, $separateHighlights: Boolean = true, $preorderAvailable: Boolean = false) {
  products(offset: $offset, limit: $limit, filters: $filters, sort: $sort, keyword: $keyword, separateHighlights: $separateHighlights, preorderAvailable: $preorderAvailable) {
    products {
      clientId
      id
      name
      isHighlighted
      isBriefCrm
      isShowcase
      showcaseText
      price {
        basePrice {
          withTaxes
          withoutTaxes
          taxAmount
          taxPercent
        }
      }
      catalogPriceLevels {
        quantity
        price
      }
      fixPricesLevelsByQuantity {
        quantity
        price {
          basePrice {
            withTaxes
            withoutTaxes
            taxAmount
            taxPercent
          }
        }
      }
      priceType
      description
      isCustomizable
      highQualityAsset {
        url
        name
      }
      lowQualityAsset {
        url
        name
      }
      images {
        thumbnail
        large
        small
        medium
        original
      }
      tags {
        id
        label
        color
      }
      tips
      type
      description
      ref
      productOptions {
        id
        price
      }
      shouldHaveAtLeastOneOptionSelected
      shouldHaveExactOptionsSelected
      numberOfExactOptions
      isCustomizable
      tips
      stock
      isStockEnabled
      packagingUnit
      isPack
      productsInPack {
        product {
          id
          name
          images {
            id
            original
            originName
          }
          price {
            basePrice {
              withTaxes
              withoutTaxes
              taxAmount
              taxPercent
            }
          }
          priceType
          catalogPrice
          catalogPriceLevels {
            price
            quantity
          }
          catalogFixPricesLevelsByQuantity {
            quantity
            price
          }
          priceType
        }
        position
      }
    }
    highlightedProducts {
      id
      name
      type
      isShowcase
      isBriefCrm
      showcaseText
      price {
        basePrice {
          withoutTaxes
        }
      }
      catalogPriceLevels {
        quantity
        price
      }
      fixPricesLevelsByQuantity {
        quantity
        price {
          basePrice {
            withTaxes
            withoutTaxes
            taxAmount
            taxPercent
          }
        }
      }
      priceType
      description
      highQualityAsset {
        url
        name
      }
      lowQualityAsset {
        url
        name
      }
      images {
        medium
      }
      isHighlighted
      tags {
        id
        label
        color
      }
      useEnabledDates
      useLaunchDate
      useValidDate
      deliveryDate
      enabledDate
      disabledDate
      productOptions {
        id
        price
      }
      shouldHaveAtLeastOneOptionSelected
      shouldHaveExactOptionsSelected
      numberOfExactOptions
      packagingUnit
      isCustomizable
      isPack
      productsInPack {
        product {
          id
          name
          images {
            id
            original
            originName
          }
          price {
            basePrice {
              withTaxes
              withoutTaxes
              taxAmount
              taxPercent
            }
          }
          priceType
          catalogPrice
          catalogPriceLevels {
            price
          }
          catalogFixPricesLevelsByQuantity {
            quantity
            price
          }
          priceType
        }
        position
      }
    }
    count
    highlightedCount
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      keyword: // value for 'keyword'
 *      separateHighlights: // value for 'separateHighlights'
 *      preorderAvailable: // value for 'preorderAvailable'
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const ProductsOfTypeExistDocument = gql`
    query productsOfTypeExist($type: AllowedProductType!) {
  productsOfTypeExist(type: $type)
}
    `;

/**
 * __useProductsOfTypeExistQuery__
 *
 * To run a query within a React component, call `useProductsOfTypeExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsOfTypeExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsOfTypeExistQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProductsOfTypeExistQuery(baseOptions: Apollo.QueryHookOptions<ProductsOfTypeExistQuery, ProductsOfTypeExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsOfTypeExistQuery, ProductsOfTypeExistQueryVariables>(ProductsOfTypeExistDocument, options);
      }
export function useProductsOfTypeExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsOfTypeExistQuery, ProductsOfTypeExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsOfTypeExistQuery, ProductsOfTypeExistQueryVariables>(ProductsOfTypeExistDocument, options);
        }
export type ProductsOfTypeExistQueryHookResult = ReturnType<typeof useProductsOfTypeExistQuery>;
export type ProductsOfTypeExistLazyQueryHookResult = ReturnType<typeof useProductsOfTypeExistLazyQuery>;
export type ProductsOfTypeExistQueryResult = Apollo.QueryResult<ProductsOfTypeExistQuery, ProductsOfTypeExistQueryVariables>;
export const ProviderTypeDocument = gql`
    query providerType {
  me {
    id
    providerInfo {
      id
      linkedClients {
        providerType
      }
    }
  }
}
    `;

/**
 * __useProviderTypeQuery__
 *
 * To run a query within a React component, call `useProviderTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderTypeQuery(baseOptions?: Apollo.QueryHookOptions<ProviderTypeQuery, ProviderTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderTypeQuery, ProviderTypeQueryVariables>(ProviderTypeDocument, options);
      }
export function useProviderTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderTypeQuery, ProviderTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderTypeQuery, ProviderTypeQueryVariables>(ProviderTypeDocument, options);
        }
export type ProviderTypeQueryHookResult = ReturnType<typeof useProviderTypeQuery>;
export type ProviderTypeLazyQueryHookResult = ReturnType<typeof useProviderTypeLazyQuery>;
export type ProviderTypeQueryResult = Apollo.QueryResult<ProviderTypeQuery, ProviderTypeQueryVariables>;
export const ProviderUserInfoDocument = gql`
    query providerUserInfo($id: ID!) {
  userById(id: $id) {
    id
    firstname
    lastname
    phone
    mobilePhone
    activity
    enabled
    email
    languagePreference
    registered
    role {
      id
      name
      slug
    }
    salesPointGroups {
      id
      name
      client {
        name
      }
    }
  }
}
    `;

/**
 * __useProviderUserInfoQuery__
 *
 * To run a query within a React component, call `useProviderUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderUserInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderUserInfoQuery(baseOptions: Apollo.QueryHookOptions<ProviderUserInfoQuery, ProviderUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderUserInfoQuery, ProviderUserInfoQueryVariables>(ProviderUserInfoDocument, options);
      }
export function useProviderUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderUserInfoQuery, ProviderUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderUserInfoQuery, ProviderUserInfoQueryVariables>(ProviderUserInfoDocument, options);
        }
export type ProviderUserInfoQueryHookResult = ReturnType<typeof useProviderUserInfoQuery>;
export type ProviderUserInfoLazyQueryHookResult = ReturnType<typeof useProviderUserInfoLazyQuery>;
export type ProviderUserInfoQueryResult = Apollo.QueryResult<ProviderUserInfoQuery, ProviderUserInfoQueryVariables>;
export const RoleDocument = gql`
    query role($roleId: ID!) {
  role(roleId: $roleId) {
    id
    name
    slug
    canEdit
    permissionsSettings {
      name
      enabled
    }
    isForkable
    parent {
      id
      slug
      permissionsSettings {
        name
        enabled
      }
    }
  }
}
    `;

/**
 * __useRoleQuery__
 *
 * To run a query within a React component, call `useRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRoleQuery(baseOptions: Apollo.QueryHookOptions<RoleQuery, RoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
      }
export function useRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleQuery, RoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
        }
export type RoleQueryHookResult = ReturnType<typeof useRoleQuery>;
export type RoleLazyQueryHookResult = ReturnType<typeof useRoleLazyQuery>;
export type RoleQueryResult = Apollo.QueryResult<RoleQuery, RoleQueryVariables>;
export const RolesDocument = gql`
    query roles {
  roles {
    id
    name
    slug
    absoluteSlug
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const RolesDetailsDocument = gql`
    query rolesDetails($forkable: Boolean) {
  rolesDetails(forkable: $forkable) {
    id
    name
    slug
    userCount
    updatedAt
    isForkable
  }
}
    `;

/**
 * __useRolesDetailsQuery__
 *
 * To run a query within a React component, call `useRolesDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesDetailsQuery({
 *   variables: {
 *      forkable: // value for 'forkable'
 *   },
 * });
 */
export function useRolesDetailsQuery(baseOptions?: Apollo.QueryHookOptions<RolesDetailsQuery, RolesDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesDetailsQuery, RolesDetailsQueryVariables>(RolesDetailsDocument, options);
      }
export function useRolesDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesDetailsQuery, RolesDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesDetailsQuery, RolesDetailsQueryVariables>(RolesDetailsDocument, options);
        }
export type RolesDetailsQueryHookResult = ReturnType<typeof useRolesDetailsQuery>;
export type RolesDetailsLazyQueryHookResult = ReturnType<typeof useRolesDetailsLazyQuery>;
export type RolesDetailsQueryResult = Apollo.QueryResult<RolesDetailsQuery, RolesDetailsQueryVariables>;
export const RolesUserCanPromoteToDocument = gql`
    query rolesUserCanPromoteTo {
  rolesUserCanPromoteTo {
    id
    name
    slug
    absoluteSlug
  }
}
    `;

/**
 * __useRolesUserCanPromoteToQuery__
 *
 * To run a query within a React component, call `useRolesUserCanPromoteToQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesUserCanPromoteToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesUserCanPromoteToQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesUserCanPromoteToQuery(baseOptions?: Apollo.QueryHookOptions<RolesUserCanPromoteToQuery, RolesUserCanPromoteToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesUserCanPromoteToQuery, RolesUserCanPromoteToQueryVariables>(RolesUserCanPromoteToDocument, options);
      }
export function useRolesUserCanPromoteToLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesUserCanPromoteToQuery, RolesUserCanPromoteToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesUserCanPromoteToQuery, RolesUserCanPromoteToQueryVariables>(RolesUserCanPromoteToDocument, options);
        }
export type RolesUserCanPromoteToQueryHookResult = ReturnType<typeof useRolesUserCanPromoteToQuery>;
export type RolesUserCanPromoteToLazyQueryHookResult = ReturnType<typeof useRolesUserCanPromoteToLazyQuery>;
export type RolesUserCanPromoteToQueryResult = Apollo.QueryResult<RolesUserCanPromoteToQuery, RolesUserCanPromoteToQueryVariables>;
export const SalesPointsListDocument = gql`
    query salesPointsList($offset: Int, $limit: Int, $filter: SalesPointFilter, $sort: SalesPointSort) {
  salesPoints(offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    count
    enabledSalesPointsCount
    salesPoints {
      id
      name
      enabled
      location {
        address
        postalCode
        city
        country
      }
      social {
        linkedPages {
          facebook
          instagram
          google
          twitter
        }
      }
    }
  }
}
    `;

/**
 * __useSalesPointsListQuery__
 *
 * To run a query within a React component, call `useSalesPointsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesPointsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesPointsListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSalesPointsListQuery(baseOptions?: Apollo.QueryHookOptions<SalesPointsListQuery, SalesPointsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesPointsListQuery, SalesPointsListQueryVariables>(SalesPointsListDocument, options);
      }
export function useSalesPointsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesPointsListQuery, SalesPointsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesPointsListQuery, SalesPointsListQueryVariables>(SalesPointsListDocument, options);
        }
export type SalesPointsListQueryHookResult = ReturnType<typeof useSalesPointsListQuery>;
export type SalesPointsListLazyQueryHookResult = ReturnType<typeof useSalesPointsListLazyQuery>;
export type SalesPointsListQueryResult = Apollo.QueryResult<SalesPointsListQuery, SalesPointsListQueryVariables>;
export const ShippingListDocument = gql`
    query shippingList($keyword: String) {
  shippingList(keyword: $keyword) {
    id
    isAllSalesPoints
    name
    maxWeight
    freeShipping
    shippingFeesGridPerWeight {
      fees
      weight
    }
    enabled
    salespointGroupsIds {
      name
      id
    }
    salesPointsIds {
      id
      name
    }
  }
}
    `;

/**
 * __useShippingListQuery__
 *
 * To run a query within a React component, call `useShippingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingListQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useShippingListQuery(baseOptions?: Apollo.QueryHookOptions<ShippingListQuery, ShippingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingListQuery, ShippingListQueryVariables>(ShippingListDocument, options);
      }
export function useShippingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingListQuery, ShippingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingListQuery, ShippingListQueryVariables>(ShippingListDocument, options);
        }
export type ShippingListQueryHookResult = ReturnType<typeof useShippingListQuery>;
export type ShippingListLazyQueryHookResult = ReturnType<typeof useShippingListLazyQuery>;
export type ShippingListQueryResult = Apollo.QueryResult<ShippingListQuery, ShippingListQueryVariables>;
export const SimpleCartDocument = gql`
    query simpleCart {
  cart {
    userId
    items {
      subId
      quantity
      productId
      quantitiesPerLocation {
        locationId
        quantity
      }
    }
  }
}
    `;

/**
 * __useSimpleCartQuery__
 *
 * To run a query within a React component, call `useSimpleCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useSimpleCartQuery(baseOptions?: Apollo.QueryHookOptions<SimpleCartQuery, SimpleCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimpleCartQuery, SimpleCartQueryVariables>(SimpleCartDocument, options);
      }
export function useSimpleCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimpleCartQuery, SimpleCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimpleCartQuery, SimpleCartQueryVariables>(SimpleCartDocument, options);
        }
export type SimpleCartQueryHookResult = ReturnType<typeof useSimpleCartQuery>;
export type SimpleCartLazyQueryHookResult = ReturnType<typeof useSimpleCartLazyQuery>;
export type SimpleCartQueryResult = Apollo.QueryResult<SimpleCartQuery, SimpleCartQueryVariables>;
export const TagByIdDocument = gql`
    query tagById($id: ID!) {
  tagById(id: $id) {
    id
    types
    label
    color
    tagGroup {
      id
    }
    enabled
    countries
    useSalespoints
    salespointGroups {
      id
      name
    }
    salesPoints {
      id
      name
    }
    shop {
      products {
        id
        name
      }
      displayOnProducts
    }
    library {
      medias {
        id
        name
      }
      isHighlighted
      highlightOrder
    }
    createdAt
    updatedAt
    updatedBy {
      fullName
    }
  }
}
    `;

/**
 * __useTagByIdQuery__
 *
 * To run a query within a React component, call `useTagByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagByIdQuery(baseOptions: Apollo.QueryHookOptions<TagByIdQuery, TagByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagByIdQuery, TagByIdQueryVariables>(TagByIdDocument, options);
      }
export function useTagByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagByIdQuery, TagByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagByIdQuery, TagByIdQueryVariables>(TagByIdDocument, options);
        }
export type TagByIdQueryHookResult = ReturnType<typeof useTagByIdQuery>;
export type TagByIdLazyQueryHookResult = ReturnType<typeof useTagByIdLazyQuery>;
export type TagByIdQueryResult = Apollo.QueryResult<TagByIdQuery, TagByIdQueryVariables>;
export const TagGroupByIdDocument = gql`
    query tagGroupById($id: ID!) {
  tagGroupById(id: $id) {
    id
    name
    tags {
      id
      label
    }
    order
    enabled
    useSalespoints
    salespointGroups {
      id
    }
    salesPoints {
      id
    }
    createdAt
    updatedAt
    updatedBy {
      id
      fullName
    }
  }
}
    `;

/**
 * __useTagGroupByIdQuery__
 *
 * To run a query within a React component, call `useTagGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<TagGroupByIdQuery, TagGroupByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagGroupByIdQuery, TagGroupByIdQueryVariables>(TagGroupByIdDocument, options);
      }
export function useTagGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagGroupByIdQuery, TagGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagGroupByIdQuery, TagGroupByIdQueryVariables>(TagGroupByIdDocument, options);
        }
export type TagGroupByIdQueryHookResult = ReturnType<typeof useTagGroupByIdQuery>;
export type TagGroupByIdLazyQueryHookResult = ReturnType<typeof useTagGroupByIdLazyQuery>;
export type TagGroupByIdQueryResult = Apollo.QueryResult<TagGroupByIdQuery, TagGroupByIdQueryVariables>;
export const TagsDocument = gql`
    query tags {
  tags {
    tags {
      id
      label
    }
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const TagsWithDetailsDocument = gql`
    query tagsWithDetails {
  tags {
    tags {
      id
      label
      color
      tagGroup {
        id
        name
      }
      enabled
      createdAt
      updatedAt
      updatedBy {
        id
        fullName
      }
      shop {
        products {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useTagsWithDetailsQuery__
 *
 * To run a query within a React component, call `useTagsWithDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsWithDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsWithDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsWithDetailsQuery(baseOptions?: Apollo.QueryHookOptions<TagsWithDetailsQuery, TagsWithDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsWithDetailsQuery, TagsWithDetailsQueryVariables>(TagsWithDetailsDocument, options);
      }
export function useTagsWithDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsWithDetailsQuery, TagsWithDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsWithDetailsQuery, TagsWithDetailsQueryVariables>(TagsWithDetailsDocument, options);
        }
export type TagsWithDetailsQueryHookResult = ReturnType<typeof useTagsWithDetailsQuery>;
export type TagsWithDetailsLazyQueryHookResult = ReturnType<typeof useTagsWithDetailsLazyQuery>;
export type TagsWithDetailsQueryResult = Apollo.QueryResult<TagsWithDetailsQuery, TagsWithDetailsQueryVariables>;
export const UserByIdDocument = gql`
    query userById($id: ID!) {
  userById(id: $id) {
    id
    firstname
    lastname
    phone
    mobilePhone
    activity
    canEdit
    enabled
    email
    languagePreference
    defaultStoreId
    registered
    role {
      id
      name
      slug
    }
    salesPoints {
      id
      name
      location {
        address
        city
      }
      enabled
    }
  }
}
    `;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const UserDetailDocument = gql`
    query userDetail {
  me {
    id
    firstname
    lastname
    activity
    email
    phone
    mobilePhone
    clientId
    selectedSalesPointId
    languagePreference
    salesPoints {
      id
      name
      email
      code
      tvaCode
      enabled
      RCS
      secondaryName
      siretCode
      phone
      affairCode
      longDescription
      shortDescription
      paymentOptions
      languageOptions
      salespointGroups {
        id
      }
      contactDetails {
        phoneNumber
        email
        website
        twitterLink
        facebookLink
        pinterestLink
        instagramLink
        youtubeLink
        linkedinLink
        foursquareLink
        vimeoLink
        xingLink
        contacts {
          id
          firstname
          lastname
          phone
          activity
          email
        }
      }
      location {
        address
        postalCode
        city
        country
        additionalAddress
        longitude
        latitude
      }
      images {
        thumbnail
        large
        small
        medium
        original
      }
      openingHours {
        day
        isOpen
        sessions {
          start
          end
          isAllDay
        }
      }
      users {
        id
        lastname
        firstname
        phone
        mobilePhone
        email
      }
      specialOpeningHours {
        id
        from
        to
        isOpen
        hoursFrom
        hoursTo
      }
    }
    role {
      id
      permissions
      name
      slug
    }
  }
}
    `;

/**
 * __useUserDetailQuery__
 *
 * To run a query within a React component, call `useUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDetailQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
      }
export function useUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
        }
export type UserDetailQueryHookResult = ReturnType<typeof useUserDetailQuery>;
export type UserDetailLazyQueryHookResult = ReturnType<typeof useUserDetailLazyQuery>;
export type UserDetailQueryResult = Apollo.QueryResult<UserDetailQuery, UserDetailQueryVariables>;
export const UserDetailsSalespointDocument = gql`
    query userDetailsSalespoint {
  me {
    id
    firstname
    lastname
    fullName
    selectedSalesPointId
    phone
    mobilePhone
    role {
      id
      permissions
    }
    salesPoints {
      id
      code
      name
      location {
        address
        postalCode
        city
        country
        additionalAddress
        longitude
        latitude
      }
    }
  }
}
    `;

/**
 * __useUserDetailsSalespointQuery__
 *
 * To run a query within a React component, call `useUserDetailsSalespointQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsSalespointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsSalespointQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDetailsSalespointQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailsSalespointQuery, UserDetailsSalespointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsSalespointQuery, UserDetailsSalespointQueryVariables>(UserDetailsSalespointDocument, options);
      }
export function useUserDetailsSalespointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsSalespointQuery, UserDetailsSalespointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsSalespointQuery, UserDetailsSalespointQueryVariables>(UserDetailsSalespointDocument, options);
        }
export type UserDetailsSalespointQueryHookResult = ReturnType<typeof useUserDetailsSalespointQuery>;
export type UserDetailsSalespointLazyQueryHookResult = ReturnType<typeof useUserDetailsSalespointLazyQuery>;
export type UserDetailsSalespointQueryResult = Apollo.QueryResult<UserDetailsSalespointQuery, UserDetailsSalespointQueryVariables>;
export const UserDetailEmailDocument = gql`
    query userDetailEmail {
  me {
    id
    email
    clientId
  }
}
    `;

/**
 * __useUserDetailEmailQuery__
 *
 * To run a query within a React component, call `useUserDetailEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailEmailQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDetailEmailQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailEmailQuery, UserDetailEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailEmailQuery, UserDetailEmailQueryVariables>(UserDetailEmailDocument, options);
      }
export function useUserDetailEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailEmailQuery, UserDetailEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailEmailQuery, UserDetailEmailQueryVariables>(UserDetailEmailDocument, options);
        }
export type UserDetailEmailQueryHookResult = ReturnType<typeof useUserDetailEmailQuery>;
export type UserDetailEmailLazyQueryHookResult = ReturnType<typeof useUserDetailEmailLazyQuery>;
export type UserDetailEmailQueryResult = Apollo.QueryResult<UserDetailEmailQuery, UserDetailEmailQueryVariables>;
export const UserFeaturesDocument = gql`
    query userFeatures {
  me {
    id
    role {
      id
      permissions
      slug
    }
    client {
      id
      f
      clientId
    }
  }
}
    `;

/**
 * __useUserFeaturesQuery__
 *
 * To run a query within a React component, call `useUserFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<UserFeaturesQuery, UserFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFeaturesQuery, UserFeaturesQueryVariables>(UserFeaturesDocument, options);
      }
export function useUserFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFeaturesQuery, UserFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFeaturesQuery, UserFeaturesQueryVariables>(UserFeaturesDocument, options);
        }
export type UserFeaturesQueryHookResult = ReturnType<typeof useUserFeaturesQuery>;
export type UserFeaturesLazyQueryHookResult = ReturnType<typeof useUserFeaturesLazyQuery>;
export type UserFeaturesQueryResult = Apollo.QueryResult<UserFeaturesQuery, UserFeaturesQueryVariables>;
export const UserInfoForContentDocument = gql`
    query userInfoForContent {
  me {
    id
    firstname
    lastname
    phone
    mobilePhone
    activity
    canEdit
    enabled
    email
    languagePreference
    defaultStoreId
    registered
    role {
      id
      name
      slug
    }
    salesPoints {
      id
      name
      location {
        address
        city
      }
      enabled
    }
  }
}
    `;

/**
 * __useUserInfoForContentQuery__
 *
 * To run a query within a React component, call `useUserInfoForContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoForContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoForContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoForContentQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoForContentQuery, UserInfoForContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoForContentQuery, UserInfoForContentQueryVariables>(UserInfoForContentDocument, options);
      }
export function useUserInfoForContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoForContentQuery, UserInfoForContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoForContentQuery, UserInfoForContentQueryVariables>(UserInfoForContentDocument, options);
        }
export type UserInfoForContentQueryHookResult = ReturnType<typeof useUserInfoForContentQuery>;
export type UserInfoForContentLazyQueryHookResult = ReturnType<typeof useUserInfoForContentLazyQuery>;
export type UserInfoForContentQueryResult = Apollo.QueryResult<UserInfoForContentQuery, UserInfoForContentQueryVariables>;
export const UserMailDocument = gql`
    query userMail {
  me {
    id
    email
    client {
      id
      homepageFeature
    }
    role {
      id
      slug
    }
  }
}
    `;

/**
 * __useUserMailQuery__
 *
 * To run a query within a React component, call `useUserMailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMailQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMailQuery(baseOptions?: Apollo.QueryHookOptions<UserMailQuery, UserMailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMailQuery, UserMailQueryVariables>(UserMailDocument, options);
      }
export function useUserMailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMailQuery, UserMailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMailQuery, UserMailQueryVariables>(UserMailDocument, options);
        }
export type UserMailQueryHookResult = ReturnType<typeof useUserMailQuery>;
export type UserMailLazyQueryHookResult = ReturnType<typeof useUserMailLazyQuery>;
export type UserMailQueryResult = Apollo.QueryResult<UserMailQuery, UserMailQueryVariables>;
export const UserPersonalInfoDocument = gql`
    query userPersonalInfo {
  me {
    id
    firstname
    lastname
    activity
    mobilePhone
    phone
    email
    languagePreference
    loginViaSso
  }
}
    `;

/**
 * __useUserPersonalInfoQuery__
 *
 * To run a query within a React component, call `useUserPersonalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPersonalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPersonalInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPersonalInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserPersonalInfoQuery, UserPersonalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPersonalInfoQuery, UserPersonalInfoQueryVariables>(UserPersonalInfoDocument, options);
      }
export function useUserPersonalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPersonalInfoQuery, UserPersonalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPersonalInfoQuery, UserPersonalInfoQueryVariables>(UserPersonalInfoDocument, options);
        }
export type UserPersonalInfoQueryHookResult = ReturnType<typeof useUserPersonalInfoQuery>;
export type UserPersonalInfoLazyQueryHookResult = ReturnType<typeof useUserPersonalInfoLazyQuery>;
export type UserPersonalInfoQueryResult = Apollo.QueryResult<UserPersonalInfoQuery, UserPersonalInfoQueryVariables>;
export const UserRoleDocument = gql`
    query userRole {
  userRole {
    id
    permissions
    name
    slug
    absoluteSlug
  }
}
    `;

/**
 * __useUserRoleQuery__
 *
 * To run a query within a React component, call `useUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRoleQuery(baseOptions?: Apollo.QueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
      }
export function useUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
        }
export type UserRoleQueryHookResult = ReturnType<typeof useUserRoleQuery>;
export type UserRoleLazyQueryHookResult = ReturnType<typeof useUserRoleLazyQuery>;
export type UserRoleQueryResult = Apollo.QueryResult<UserRoleQuery, UserRoleQueryVariables>;
export const UserSelectedSalesPointDocument = gql`
    query userSelectedSalesPoint {
  me {
    id
    selectedSalesPoint {
      id
      name
      email
      affairCode
      code
      tvaCode
      enabled
      RCS
      secondaryName
      siretCode
      phone
      fax
      shortDescription
      longDescription
      paymentOptions
      languageOptions
      contactDetails {
        phoneNumber
        email
        website
        twitterLink
        facebookLink
        pinterestLink
        instagramLink
        youtubeLink
        linkedinLink
        foursquareLink
        vimeoLink
        xingLink
        contacts {
          id
          firstname
          lastname
          phone
          activity
          email
        }
      }
      location {
        address
        postalCode
        city
        country
        additionalAddress
        longitude
        latitude
      }
      images {
        id
        thumbnail
        large
        medium
        small
        original
      }
      openingHours {
        day
        isOpen
        sessions {
          start
          end
          isAllDay
        }
      }
      users {
        id
        lastname
        firstname
        phone
        mobilePhone
        email
      }
      specialOpeningHours {
        id
        from
        to
        isOpen
        hoursFrom
        hoursTo
      }
      salespointGroups {
        id
      }
    }
  }
}
    `;

/**
 * __useUserSelectedSalesPointQuery__
 *
 * To run a query within a React component, call `useUserSelectedSalesPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectedSalesPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectedSalesPointQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSelectedSalesPointQuery(baseOptions?: Apollo.QueryHookOptions<UserSelectedSalesPointQuery, UserSelectedSalesPointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSelectedSalesPointQuery, UserSelectedSalesPointQueryVariables>(UserSelectedSalesPointDocument, options);
      }
export function useUserSelectedSalesPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSelectedSalesPointQuery, UserSelectedSalesPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSelectedSalesPointQuery, UserSelectedSalesPointQueryVariables>(UserSelectedSalesPointDocument, options);
        }
export type UserSelectedSalesPointQueryHookResult = ReturnType<typeof useUserSelectedSalesPointQuery>;
export type UserSelectedSalesPointLazyQueryHookResult = ReturnType<typeof useUserSelectedSalesPointLazyQuery>;
export type UserSelectedSalesPointQueryResult = Apollo.QueryResult<UserSelectedSalesPointQuery, UserSelectedSalesPointQueryVariables>;
export const UserSelectedSalesPointCustomFieldsDocument = gql`
    query userSelectedSalesPointCustomFields {
  me {
    id
    selectedSalesPoint {
      id
      name
      orderedCustomFields {
        definition {
          id
          assetType
          clientId
          type
          slug
          label
          visible
          description
          updatedAt
        }
        textValue
      }
    }
  }
}
    `;

/**
 * __useUserSelectedSalesPointCustomFieldsQuery__
 *
 * To run a query within a React component, call `useUserSelectedSalesPointCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectedSalesPointCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectedSalesPointCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSelectedSalesPointCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<UserSelectedSalesPointCustomFieldsQuery, UserSelectedSalesPointCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSelectedSalesPointCustomFieldsQuery, UserSelectedSalesPointCustomFieldsQueryVariables>(UserSelectedSalesPointCustomFieldsDocument, options);
      }
export function useUserSelectedSalesPointCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSelectedSalesPointCustomFieldsQuery, UserSelectedSalesPointCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSelectedSalesPointCustomFieldsQuery, UserSelectedSalesPointCustomFieldsQueryVariables>(UserSelectedSalesPointCustomFieldsDocument, options);
        }
export type UserSelectedSalesPointCustomFieldsQueryHookResult = ReturnType<typeof useUserSelectedSalesPointCustomFieldsQuery>;
export type UserSelectedSalesPointCustomFieldsLazyQueryHookResult = ReturnType<typeof useUserSelectedSalesPointCustomFieldsLazyQuery>;
export type UserSelectedSalesPointCustomFieldsQueryResult = Apollo.QueryResult<UserSelectedSalesPointCustomFieldsQuery, UserSelectedSalesPointCustomFieldsQueryVariables>;
export const UserSelectedSalesPointLocationsDocument = gql`
    query userSelectedSalesPointLocations {
  me {
    id
    selectedSalesPoint {
      id
      name
      code
      publicLocation {
        address
        postalCode
        additionalAddress
        city
        country
        locationCode
      }
      locations {
        id
        name
        address
        postalCode
        additionalAddress
        city
        country
        locationCode
      }
    }
  }
}
    `;

/**
 * __useUserSelectedSalesPointLocationsQuery__
 *
 * To run a query within a React component, call `useUserSelectedSalesPointLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectedSalesPointLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectedSalesPointLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSelectedSalesPointLocationsQuery(baseOptions?: Apollo.QueryHookOptions<UserSelectedSalesPointLocationsQuery, UserSelectedSalesPointLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSelectedSalesPointLocationsQuery, UserSelectedSalesPointLocationsQueryVariables>(UserSelectedSalesPointLocationsDocument, options);
      }
export function useUserSelectedSalesPointLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSelectedSalesPointLocationsQuery, UserSelectedSalesPointLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSelectedSalesPointLocationsQuery, UserSelectedSalesPointLocationsQueryVariables>(UserSelectedSalesPointLocationsDocument, options);
        }
export type UserSelectedSalesPointLocationsQueryHookResult = ReturnType<typeof useUserSelectedSalesPointLocationsQuery>;
export type UserSelectedSalesPointLocationsLazyQueryHookResult = ReturnType<typeof useUserSelectedSalesPointLocationsLazyQuery>;
export type UserSelectedSalesPointLocationsQueryResult = Apollo.QueryResult<UserSelectedSalesPointLocationsQuery, UserSelectedSalesPointLocationsQueryVariables>;
export const UserSocialDetailsDocument = gql`
    query userSocialDetails($socialNetwork: String!, $socialNetworks: [SocialNetwork]) {
  me {
    id
    salesPoints(socialNetwork: $socialNetwork, socialNetworks: $socialNetworks) {
      id
      name
      social {
        linkedPages {
          facebook
          instagram
          twitter
          google
          linkedin
        }
      }
    }
    role {
      id
      permissions
    }
  }
}
    `;

/**
 * __useUserSocialDetailsQuery__
 *
 * To run a query within a React component, call `useUserSocialDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSocialDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSocialDetailsQuery({
 *   variables: {
 *      socialNetwork: // value for 'socialNetwork'
 *      socialNetworks: // value for 'socialNetworks'
 *   },
 * });
 */
export function useUserSocialDetailsQuery(baseOptions: Apollo.QueryHookOptions<UserSocialDetailsQuery, UserSocialDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSocialDetailsQuery, UserSocialDetailsQueryVariables>(UserSocialDetailsDocument, options);
      }
export function useUserSocialDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSocialDetailsQuery, UserSocialDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSocialDetailsQuery, UserSocialDetailsQueryVariables>(UserSocialDetailsDocument, options);
        }
export type UserSocialDetailsQueryHookResult = ReturnType<typeof useUserSocialDetailsQuery>;
export type UserSocialDetailsLazyQueryHookResult = ReturnType<typeof useUserSocialDetailsLazyQuery>;
export type UserSocialDetailsQueryResult = Apollo.QueryResult<UserSocialDetailsQuery, UserSocialDetailsQueryVariables>;
export const UsersDocument = gql`
    query users($offset: Int, $limit: Int, $filter: UserFilter, $sort: UserSort) {
  users(offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    count
    users {
      id
      firstname
      fullName
      lastname
      mobilePhone
      email
      enabled
      activity
      canEdit
      registered
      lastActivityDay
      role {
        id
        name
        absoluteSlug
      }
    }
    providerId
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const GetAllClientsDocument = gql`
    query getAllClients {
  getAllClients {
    id
    name
    clientId
  }
}
    `;

/**
 * __useGetAllClientsQuery__
 *
 * To run a query within a React component, call `useGetAllClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
      }
export function useGetAllClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientsQuery, GetAllClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientsQuery, GetAllClientsQueryVariables>(GetAllClientsDocument, options);
        }
export type GetAllClientsQueryHookResult = ReturnType<typeof useGetAllClientsQuery>;
export type GetAllClientsLazyQueryHookResult = ReturnType<typeof useGetAllClientsLazyQuery>;
export type GetAllClientsQueryResult = Apollo.QueryResult<GetAllClientsQuery, GetAllClientsQueryVariables>;
export const ExportAmplifyUsersBudgetDocument = gql`
    query exportAmplifyUsersBudget {
  exportAmplifyUsersBudget
}
    `;

/**
 * __useExportAmplifyUsersBudgetQuery__
 *
 * To run a query within a React component, call `useExportAmplifyUsersBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportAmplifyUsersBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportAmplifyUsersBudgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportAmplifyUsersBudgetQuery(baseOptions?: Apollo.QueryHookOptions<ExportAmplifyUsersBudgetQuery, ExportAmplifyUsersBudgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportAmplifyUsersBudgetQuery, ExportAmplifyUsersBudgetQueryVariables>(ExportAmplifyUsersBudgetDocument, options);
      }
export function useExportAmplifyUsersBudgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportAmplifyUsersBudgetQuery, ExportAmplifyUsersBudgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportAmplifyUsersBudgetQuery, ExportAmplifyUsersBudgetQueryVariables>(ExportAmplifyUsersBudgetDocument, options);
        }
export type ExportAmplifyUsersBudgetQueryHookResult = ReturnType<typeof useExportAmplifyUsersBudgetQuery>;
export type ExportAmplifyUsersBudgetLazyQueryHookResult = ReturnType<typeof useExportAmplifyUsersBudgetLazyQuery>;
export type ExportAmplifyUsersBudgetQueryResult = Apollo.QueryResult<ExportAmplifyUsersBudgetQuery, ExportAmplifyUsersBudgetQueryVariables>;
export const ImportAmplifyUsersBudgetDocument = gql`
    mutation importAmplifyUsersBudget($file: Upload!) {
  importAmplifyUsersBudget(file: $file) {
    id
    creations {
      spent
      granted
      budgetIsLimited
      datesAreLimited
      startDate
      endDate
    }
    updates {
      spent
      granted
      budgetIsLimited
      datesAreLimited
      startDate
      endDate
    }
    fails {
      ref
      error
      fields {
        field
        error
      }
    }
    importError
  }
}
    `;
export type ImportAmplifyUsersBudgetMutationFn = Apollo.MutationFunction<ImportAmplifyUsersBudgetMutation, ImportAmplifyUsersBudgetMutationVariables>;

/**
 * __useImportAmplifyUsersBudgetMutation__
 *
 * To run a mutation, you first call `useImportAmplifyUsersBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAmplifyUsersBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAmplifyUsersBudgetMutation, { data, loading, error }] = useImportAmplifyUsersBudgetMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportAmplifyUsersBudgetMutation(baseOptions?: Apollo.MutationHookOptions<ImportAmplifyUsersBudgetMutation, ImportAmplifyUsersBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportAmplifyUsersBudgetMutation, ImportAmplifyUsersBudgetMutationVariables>(ImportAmplifyUsersBudgetDocument, options);
      }
export type ImportAmplifyUsersBudgetMutationHookResult = ReturnType<typeof useImportAmplifyUsersBudgetMutation>;
export type ImportAmplifyUsersBudgetMutationResult = Apollo.MutationResult<ImportAmplifyUsersBudgetMutation>;
export type ImportAmplifyUsersBudgetMutationOptions = Apollo.BaseMutationOptions<ImportAmplifyUsersBudgetMutation, ImportAmplifyUsersBudgetMutationVariables>;
export const UsersBudgetListDocument = gql`
    query usersBudgetList($offset: Int, $limit: Int, $filter: UserFilter, $sort: UserSort, $socialNetwork: String) {
  users(offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    count
    users {
      id
      fullName
      email
      enabled
      salesPoints(socialNetwork: $socialNetwork) {
        id
        name
      }
      role {
        id
        name
        permissions
      }
      amplifyBudget {
        budgetIsLimited
        granted
        leftToSpend
        datesAreLimited
        startDate
        endDate
      }
    }
  }
}
    `;

/**
 * __useUsersBudgetListQuery__
 *
 * To run a query within a React component, call `useUsersBudgetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersBudgetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersBudgetListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      socialNetwork: // value for 'socialNetwork'
 *   },
 * });
 */
export function useUsersBudgetListQuery(baseOptions?: Apollo.QueryHookOptions<UsersBudgetListQuery, UsersBudgetListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersBudgetListQuery, UsersBudgetListQueryVariables>(UsersBudgetListDocument, options);
      }
export function useUsersBudgetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersBudgetListQuery, UsersBudgetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersBudgetListQuery, UsersBudgetListQueryVariables>(UsersBudgetListDocument, options);
        }
export type UsersBudgetListQueryHookResult = ReturnType<typeof useUsersBudgetListQuery>;
export type UsersBudgetListLazyQueryHookResult = ReturnType<typeof useUsersBudgetListLazyQuery>;
export type UsersBudgetListQueryResult = Apollo.QueryResult<UsersBudgetListQuery, UsersBudgetListQueryVariables>;
export const UpsertUserAmplifyBudgetDocument = gql`
    mutation upsertUserAmplifyBudget($userId: ID!, $budgetIsLimited: Boolean!, $granted: Int, $datesAreLimited: Boolean!, $startDate: Date, $endDate: Date) {
  upsertUserAmplifyBudget(userId: $userId, budgetIsLimited: $budgetIsLimited, granted: $granted, datesAreLimited: $datesAreLimited, startDate: $startDate, endDate: $endDate) {
    userId
    budgetIsLimited
    granted
    leftToSpend
    datesAreLimited
    startDate
    endDate
  }
}
    `;
export type UpsertUserAmplifyBudgetMutationFn = Apollo.MutationFunction<UpsertUserAmplifyBudgetMutation, UpsertUserAmplifyBudgetMutationVariables>;

/**
 * __useUpsertUserAmplifyBudgetMutation__
 *
 * To run a mutation, you first call `useUpsertUserAmplifyBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserAmplifyBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserAmplifyBudgetMutation, { data, loading, error }] = useUpsertUserAmplifyBudgetMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      budgetIsLimited: // value for 'budgetIsLimited'
 *      granted: // value for 'granted'
 *      datesAreLimited: // value for 'datesAreLimited'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useUpsertUserAmplifyBudgetMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserAmplifyBudgetMutation, UpsertUserAmplifyBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserAmplifyBudgetMutation, UpsertUserAmplifyBudgetMutationVariables>(UpsertUserAmplifyBudgetDocument, options);
      }
export type UpsertUserAmplifyBudgetMutationHookResult = ReturnType<typeof useUpsertUserAmplifyBudgetMutation>;
export type UpsertUserAmplifyBudgetMutationResult = Apollo.MutationResult<UpsertUserAmplifyBudgetMutation>;
export type UpsertUserAmplifyBudgetMutationOptions = Apollo.BaseMutationOptions<UpsertUserAmplifyBudgetMutation, UpsertUserAmplifyBudgetMutationVariables>;
export const CreateApiKeyDocument = gql`
    mutation createApiKey {
  createApiKey {
    apiKey
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const GetApiKeysDocument = gql`
    query getApiKeys {
  me {
    id
    client {
      apiKeys {
        user {
          id
          fullName
        }
        apiKey
      }
    }
  }
}
    `;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysQueryResult = Apollo.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const RevokeApiKeyDocument = gql`
    mutation revokeApiKey($apiKey: String!) {
  revokeApiKey(apiKey: $apiKey)
}
    `;
export type RevokeApiKeyMutationFn = Apollo.MutationFunction<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;

/**
 * __useRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiKeyMutation, { data, loading, error }] = useRevokeApiKeyMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useRevokeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>(RevokeApiKeyDocument, options);
      }
export type RevokeApiKeyMutationHookResult = ReturnType<typeof useRevokeApiKeyMutation>;
export type RevokeApiKeyMutationResult = Apollo.MutationResult<RevokeApiKeyMutation>;
export type RevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const DownloadBlacklistFileDocument = gql`
    query downloadBlacklistFile {
  downloadBlacklistFile
}
    `;

/**
 * __useDownloadBlacklistFileQuery__
 *
 * To run a query within a React component, call `useDownloadBlacklistFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadBlacklistFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadBlacklistFileQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownloadBlacklistFileQuery(baseOptions?: Apollo.QueryHookOptions<DownloadBlacklistFileQuery, DownloadBlacklistFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadBlacklistFileQuery, DownloadBlacklistFileQueryVariables>(DownloadBlacklistFileDocument, options);
      }
export function useDownloadBlacklistFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadBlacklistFileQuery, DownloadBlacklistFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadBlacklistFileQuery, DownloadBlacklistFileQueryVariables>(DownloadBlacklistFileDocument, options);
        }
export type DownloadBlacklistFileQueryHookResult = ReturnType<typeof useDownloadBlacklistFileQuery>;
export type DownloadBlacklistFileLazyQueryHookResult = ReturnType<typeof useDownloadBlacklistFileLazyQuery>;
export type DownloadBlacklistFileQueryResult = Apollo.QueryResult<DownloadBlacklistFileQuery, DownloadBlacklistFileQueryVariables>;
export const UploadBlacklistDocument = gql`
    mutation uploadBlacklist($file: Upload!) {
  uploadBlacklist(file: $file)
}
    `;
export type UploadBlacklistMutationFn = Apollo.MutationFunction<UploadBlacklistMutation, UploadBlacklistMutationVariables>;

/**
 * __useUploadBlacklistMutation__
 *
 * To run a mutation, you first call `useUploadBlacklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBlacklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBlacklistMutation, { data, loading, error }] = useUploadBlacklistMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadBlacklistMutation(baseOptions?: Apollo.MutationHookOptions<UploadBlacklistMutation, UploadBlacklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBlacklistMutation, UploadBlacklistMutationVariables>(UploadBlacklistDocument, options);
      }
export type UploadBlacklistMutationHookResult = ReturnType<typeof useUploadBlacklistMutation>;
export type UploadBlacklistMutationResult = Apollo.MutationResult<UploadBlacklistMutation>;
export type UploadBlacklistMutationOptions = Apollo.BaseMutationOptions<UploadBlacklistMutation, UploadBlacklistMutationVariables>;
export const CreateCampaignCategoryDocument = gql`
    mutation createCampaignCategory($category: CampaignCategoryInput!, $type: CampaignType) {
  createCampaignCategory(category: $category, type: $type) {
    id
    name
    enabled
    displayMode
    startDisplayDate
    endDisplayDate
    useSalespointGroups
    isVisible
    salespointGroups {
      id
      name
    }
    campaigns {
      id
      name
    }
    order
    clientId
    displayCampaignsCategory
  }
}
    `;
export type CreateCampaignCategoryMutationFn = Apollo.MutationFunction<CreateCampaignCategoryMutation, CreateCampaignCategoryMutationVariables>;

/**
 * __useCreateCampaignCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCampaignCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignCategoryMutation, { data, loading, error }] = useCreateCampaignCategoryMutation({
 *   variables: {
 *      category: // value for 'category'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateCampaignCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignCategoryMutation, CreateCampaignCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignCategoryMutation, CreateCampaignCategoryMutationVariables>(CreateCampaignCategoryDocument, options);
      }
export type CreateCampaignCategoryMutationHookResult = ReturnType<typeof useCreateCampaignCategoryMutation>;
export type CreateCampaignCategoryMutationResult = Apollo.MutationResult<CreateCampaignCategoryMutation>;
export type CreateCampaignCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCampaignCategoryMutation, CreateCampaignCategoryMutationVariables>;
export const DeleteCampaignCategoryDocument = gql`
    mutation deleteCampaignCategory($id: ID!) {
  deleteCampaignCategory(id: $id)
}
    `;
export type DeleteCampaignCategoryMutationFn = Apollo.MutationFunction<DeleteCampaignCategoryMutation, DeleteCampaignCategoryMutationVariables>;

/**
 * __useDeleteCampaignCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignCategoryMutation, { data, loading, error }] = useDeleteCampaignCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampaignCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignCategoryMutation, DeleteCampaignCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignCategoryMutation, DeleteCampaignCategoryMutationVariables>(DeleteCampaignCategoryDocument, options);
      }
export type DeleteCampaignCategoryMutationHookResult = ReturnType<typeof useDeleteCampaignCategoryMutation>;
export type DeleteCampaignCategoryMutationResult = Apollo.MutationResult<DeleteCampaignCategoryMutation>;
export type DeleteCampaignCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignCategoryMutation, DeleteCampaignCategoryMutationVariables>;
export const CampaignCategoriesDocument = gql`
    query campaignCategories($bypassVisibility: Boolean, $salespointGroups: [ID], $keyword: String, $types: [CampaignType!]) {
  campaignCategories(bypassVisibility: $bypassVisibility, salespointGroups: $salespointGroups, keyword: $keyword, types: $types) {
    id
    name
    enabled
    isVisible
    displayMode
    startDisplayDate
    endDisplayDate
    useSalespointGroups
    salespointGroups {
      id
      name
    }
    order
    clientId
  }
}
    `;

/**
 * __useCampaignCategoriesQuery__
 *
 * To run a query within a React component, call `useCampaignCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignCategoriesQuery({
 *   variables: {
 *      bypassVisibility: // value for 'bypassVisibility'
 *      salespointGroups: // value for 'salespointGroups'
 *      keyword: // value for 'keyword'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useCampaignCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CampaignCategoriesQuery, CampaignCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignCategoriesQuery, CampaignCategoriesQueryVariables>(CampaignCategoriesDocument, options);
      }
export function useCampaignCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignCategoriesQuery, CampaignCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignCategoriesQuery, CampaignCategoriesQueryVariables>(CampaignCategoriesDocument, options);
        }
export type CampaignCategoriesQueryHookResult = ReturnType<typeof useCampaignCategoriesQuery>;
export type CampaignCategoriesLazyQueryHookResult = ReturnType<typeof useCampaignCategoriesLazyQuery>;
export type CampaignCategoriesQueryResult = Apollo.QueryResult<CampaignCategoriesQuery, CampaignCategoriesQueryVariables>;
export const SetCampaignCategoriesOrderDocument = gql`
    mutation setCampaignCategoriesOrder($categoriesOrder: [CampaignCategoriesOrderInput!]!) {
  setCampaignCategoriesOrder(categoriesOrder: $categoriesOrder) {
    id
    name
    enabled
    displayMode
    startDisplayDate
    isVisible
    endDisplayDate
    useSalespointGroups
    salespointGroups {
      id
      name
    }
    campaigns {
      id
      name
    }
    order
    clientId
  }
}
    `;
export type SetCampaignCategoriesOrderMutationFn = Apollo.MutationFunction<SetCampaignCategoriesOrderMutation, SetCampaignCategoriesOrderMutationVariables>;

/**
 * __useSetCampaignCategoriesOrderMutation__
 *
 * To run a mutation, you first call `useSetCampaignCategoriesOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCampaignCategoriesOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCampaignCategoriesOrderMutation, { data, loading, error }] = useSetCampaignCategoriesOrderMutation({
 *   variables: {
 *      categoriesOrder: // value for 'categoriesOrder'
 *   },
 * });
 */
export function useSetCampaignCategoriesOrderMutation(baseOptions?: Apollo.MutationHookOptions<SetCampaignCategoriesOrderMutation, SetCampaignCategoriesOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCampaignCategoriesOrderMutation, SetCampaignCategoriesOrderMutationVariables>(SetCampaignCategoriesOrderDocument, options);
      }
export type SetCampaignCategoriesOrderMutationHookResult = ReturnType<typeof useSetCampaignCategoriesOrderMutation>;
export type SetCampaignCategoriesOrderMutationResult = Apollo.MutationResult<SetCampaignCategoriesOrderMutation>;
export type SetCampaignCategoriesOrderMutationOptions = Apollo.BaseMutationOptions<SetCampaignCategoriesOrderMutation, SetCampaignCategoriesOrderMutationVariables>;
export const UpdateCampaignCategoryDocument = gql`
    mutation updateCampaignCategory($id: ID!, $updates: CampaignCategoryUpdateInput!) {
  updateCampaignCategory(id: $id, updates: $updates) {
    id
    name
    enabled
    displayMode
    startDisplayDate
    isVisible
    endDisplayDate
    useSalespointGroups
    salespointGroups {
      id
      name
    }
    campaigns {
      id
      name
    }
    order
    clientId
    displayCampaignsCategory
  }
}
    `;
export type UpdateCampaignCategoryMutationFn = Apollo.MutationFunction<UpdateCampaignCategoryMutation, UpdateCampaignCategoryMutationVariables>;

/**
 * __useUpdateCampaignCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignCategoryMutation, { data, loading, error }] = useUpdateCampaignCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCampaignCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignCategoryMutation, UpdateCampaignCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignCategoryMutation, UpdateCampaignCategoryMutationVariables>(UpdateCampaignCategoryDocument, options);
      }
export type UpdateCampaignCategoryMutationHookResult = ReturnType<typeof useUpdateCampaignCategoryMutation>;
export type UpdateCampaignCategoryMutationResult = Apollo.MutationResult<UpdateCampaignCategoryMutation>;
export type UpdateCampaignCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignCategoryMutation, UpdateCampaignCategoryMutationVariables>;
export const CampaignsDocument = gql`
    query campaigns($salespointGroups: [ID], $bypassVisibility: Boolean, $limit: Int, $sort: CampaignSort, $types: [CampaignType!]) {
  campaigns(salespointGroups: $salespointGroups, bypassVisibility: $bypassVisibility, limit: $limit, sort: $sort, types: $types) {
    campaigns {
      id
      name
      enabled
      isScheduled
      startDate
      endDate
      displayMode
      startDisplayDate
      endDisplayDate
      categories {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      salespointGroups: // value for 'salespointGroups'
 *      bypassVisibility: // value for 'bypassVisibility'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($campaign: CampaignInput!, $campaignFile: Upload, $supports: [CampaignSupportCreationInput], $image: Upload, $type: CampaignType) {
  createCampaign(campaign: $campaign, campaignFile: $campaignFile, image: $image, supports: $supports, type: $type) {
    id
    name
    description
    startDate
    color
    tags {
      id
      label
      color
    }
    endDate
    isNew
    image {
      thumbnail
      large
      medium
      small
      original
    }
    hasProducts
  }
}
    `;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      campaignFile: // value for 'campaignFile'
 *      supports: // value for 'supports'
 *      image: // value for 'image'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const DeleteCampaignDocument = gql`
    mutation deleteCampaign($id: ID!) {
  deleteCampaign(id: $id)
}
    `;
export type DeleteCampaignMutationFn = Apollo.MutationFunction<DeleteCampaignMutation, DeleteCampaignMutationVariables>;

/**
 * __useDeleteCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignMutation, { data, loading, error }] = useDeleteCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignMutation, DeleteCampaignMutationVariables>(DeleteCampaignDocument, options);
      }
export type DeleteCampaignMutationHookResult = ReturnType<typeof useDeleteCampaignMutation>;
export type DeleteCampaignMutationResult = Apollo.MutationResult<DeleteCampaignMutation>;
export type DeleteCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>;
export const ToggleCampaignEnabledDocument = gql`
    mutation toggleCampaignEnabled($id: ID!) {
  toggleCampaignEnabled(id: $id) {
    id
    enabled
  }
}
    `;
export type ToggleCampaignEnabledMutationFn = Apollo.MutationFunction<ToggleCampaignEnabledMutation, ToggleCampaignEnabledMutationVariables>;

/**
 * __useToggleCampaignEnabledMutation__
 *
 * To run a mutation, you first call `useToggleCampaignEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCampaignEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCampaignEnabledMutation, { data, loading, error }] = useToggleCampaignEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCampaignEnabledMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCampaignEnabledMutation, ToggleCampaignEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCampaignEnabledMutation, ToggleCampaignEnabledMutationVariables>(ToggleCampaignEnabledDocument, options);
      }
export type ToggleCampaignEnabledMutationHookResult = ReturnType<typeof useToggleCampaignEnabledMutation>;
export type ToggleCampaignEnabledMutationResult = Apollo.MutationResult<ToggleCampaignEnabledMutation>;
export type ToggleCampaignEnabledMutationOptions = Apollo.BaseMutationOptions<ToggleCampaignEnabledMutation, ToggleCampaignEnabledMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($id: ID!, $updates: CampaignInput!, $supports: [CampaignSupportCreationInput], $campaignFile: Upload, $deleteFile: Boolean, $image: Upload, $deleteImage: Boolean) {
  updateCampaign(id: $id, updates: $updates, campaignFile: $campaignFile, supports: $supports, deleteFile: $deleteFile, image: $image, deleteImage: $deleteImage)
}
    `;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *      supports: // value for 'supports'
 *      campaignFile: // value for 'campaignFile'
 *      deleteFile: // value for 'deleteFile'
 *      image: // value for 'image'
 *      deleteImage: // value for 'deleteImage'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const UpdateChiliConfigDocument = gql`
    mutation updateChiliConfig($config: ChiliConfigInput!) {
  updateChiliConfig(config: $config) {
    clientId
  }
}
    `;
export type UpdateChiliConfigMutationFn = Apollo.MutationFunction<UpdateChiliConfigMutation, UpdateChiliConfigMutationVariables>;

/**
 * __useUpdateChiliConfigMutation__
 *
 * To run a mutation, you first call `useUpdateChiliConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChiliConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChiliConfigMutation, { data, loading, error }] = useUpdateChiliConfigMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateChiliConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChiliConfigMutation, UpdateChiliConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChiliConfigMutation, UpdateChiliConfigMutationVariables>(UpdateChiliConfigDocument, options);
      }
export type UpdateChiliConfigMutationHookResult = ReturnType<typeof useUpdateChiliConfigMutation>;
export type UpdateChiliConfigMutationResult = Apollo.MutationResult<UpdateChiliConfigMutation>;
export type UpdateChiliConfigMutationOptions = Apollo.BaseMutationOptions<UpdateChiliConfigMutation, UpdateChiliConfigMutationVariables>;
export const AddHashtagDocument = gql`
    mutation addHashtag($name: String!) {
  addHashtag(name: $name)
}
    `;
export type AddHashtagMutationFn = Apollo.MutationFunction<AddHashtagMutation, AddHashtagMutationVariables>;

/**
 * __useAddHashtagMutation__
 *
 * To run a mutation, you first call `useAddHashtagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHashtagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHashtagMutation, { data, loading, error }] = useAddHashtagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddHashtagMutation(baseOptions?: Apollo.MutationHookOptions<AddHashtagMutation, AddHashtagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddHashtagMutation, AddHashtagMutationVariables>(AddHashtagDocument, options);
      }
export type AddHashtagMutationHookResult = ReturnType<typeof useAddHashtagMutation>;
export type AddHashtagMutationResult = Apollo.MutationResult<AddHashtagMutation>;
export type AddHashtagMutationOptions = Apollo.BaseMutationOptions<AddHashtagMutation, AddHashtagMutationVariables>;
export const DeleteHashtagDocument = gql`
    mutation deleteHashtag($name: String!) {
  deleteHashtag(name: $name)
}
    `;
export type DeleteHashtagMutationFn = Apollo.MutationFunction<DeleteHashtagMutation, DeleteHashtagMutationVariables>;

/**
 * __useDeleteHashtagMutation__
 *
 * To run a mutation, you first call `useDeleteHashtagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHashtagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHashtagMutation, { data, loading, error }] = useDeleteHashtagMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteHashtagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHashtagMutation, DeleteHashtagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHashtagMutation, DeleteHashtagMutationVariables>(DeleteHashtagDocument, options);
      }
export type DeleteHashtagMutationHookResult = ReturnType<typeof useDeleteHashtagMutation>;
export type DeleteHashtagMutationResult = Apollo.MutationResult<DeleteHashtagMutation>;
export type DeleteHashtagMutationOptions = Apollo.BaseMutationOptions<DeleteHashtagMutation, DeleteHashtagMutationVariables>;
export const HashtagsDocument = gql`
    query hashtags {
  getHashtags
}
    `;

/**
 * __useHashtagsQuery__
 *
 * To run a query within a React component, call `useHashtagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHashtagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHashtagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHashtagsQuery(baseOptions?: Apollo.QueryHookOptions<HashtagsQuery, HashtagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HashtagsQuery, HashtagsQueryVariables>(HashtagsDocument, options);
      }
export function useHashtagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HashtagsQuery, HashtagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HashtagsQuery, HashtagsQueryVariables>(HashtagsDocument, options);
        }
export type HashtagsQueryHookResult = ReturnType<typeof useHashtagsQuery>;
export type HashtagsLazyQueryHookResult = ReturnType<typeof useHashtagsLazyQuery>;
export type HashtagsQueryResult = Apollo.QueryResult<HashtagsQuery, HashtagsQueryVariables>;
export const CreateHelpBlockDocument = gql`
    mutation createHelpBlock($lang: AvailableLang!, $create: HelpBlockInput!) {
  createHelpBlock(lang: $lang, create: $create) {
    id
    title
    order
  }
}
    `;
export type CreateHelpBlockMutationFn = Apollo.MutationFunction<CreateHelpBlockMutation, CreateHelpBlockMutationVariables>;

/**
 * __useCreateHelpBlockMutation__
 *
 * To run a mutation, you first call `useCreateHelpBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHelpBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHelpBlockMutation, { data, loading, error }] = useCreateHelpBlockMutation({
 *   variables: {
 *      lang: // value for 'lang'
 *      create: // value for 'create'
 *   },
 * });
 */
export function useCreateHelpBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreateHelpBlockMutation, CreateHelpBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHelpBlockMutation, CreateHelpBlockMutationVariables>(CreateHelpBlockDocument, options);
      }
export type CreateHelpBlockMutationHookResult = ReturnType<typeof useCreateHelpBlockMutation>;
export type CreateHelpBlockMutationResult = Apollo.MutationResult<CreateHelpBlockMutation>;
export type CreateHelpBlockMutationOptions = Apollo.BaseMutationOptions<CreateHelpBlockMutation, CreateHelpBlockMutationVariables>;
export const DeleteHelpBlockDocument = gql`
    mutation deleteHelpBlock($id: ID!) {
  deleteHelpBlock(id: $id)
}
    `;
export type DeleteHelpBlockMutationFn = Apollo.MutationFunction<DeleteHelpBlockMutation, DeleteHelpBlockMutationVariables>;

/**
 * __useDeleteHelpBlockMutation__
 *
 * To run a mutation, you first call `useDeleteHelpBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHelpBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHelpBlockMutation, { data, loading, error }] = useDeleteHelpBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHelpBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHelpBlockMutation, DeleteHelpBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHelpBlockMutation, DeleteHelpBlockMutationVariables>(DeleteHelpBlockDocument, options);
      }
export type DeleteHelpBlockMutationHookResult = ReturnType<typeof useDeleteHelpBlockMutation>;
export type DeleteHelpBlockMutationResult = Apollo.MutationResult<DeleteHelpBlockMutation>;
export type DeleteHelpBlockMutationOptions = Apollo.BaseMutationOptions<DeleteHelpBlockMutation, DeleteHelpBlockMutationVariables>;
export const GetHelpBlocksByLangDocument = gql`
    query getHelpBlocksByLang($lang: AvailableLang!) {
  getHelpBlocksByLang(lang: $lang) {
    id
    title
    order
  }
}
    `;

/**
 * __useGetHelpBlocksByLangQuery__
 *
 * To run a query within a React component, call `useGetHelpBlocksByLangQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpBlocksByLangQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpBlocksByLangQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetHelpBlocksByLangQuery(baseOptions: Apollo.QueryHookOptions<GetHelpBlocksByLangQuery, GetHelpBlocksByLangQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelpBlocksByLangQuery, GetHelpBlocksByLangQueryVariables>(GetHelpBlocksByLangDocument, options);
      }
export function useGetHelpBlocksByLangLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelpBlocksByLangQuery, GetHelpBlocksByLangQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelpBlocksByLangQuery, GetHelpBlocksByLangQueryVariables>(GetHelpBlocksByLangDocument, options);
        }
export type GetHelpBlocksByLangQueryHookResult = ReturnType<typeof useGetHelpBlocksByLangQuery>;
export type GetHelpBlocksByLangLazyQueryHookResult = ReturnType<typeof useGetHelpBlocksByLangLazyQuery>;
export type GetHelpBlocksByLangQueryResult = Apollo.QueryResult<GetHelpBlocksByLangQuery, GetHelpBlocksByLangQueryVariables>;
export const SetHelpBlockOrderDocument = gql`
    mutation setHelpBlockOrder($updates: [HelpBlockOrder!]!) {
  setHelpBlockOrder(updates: $updates) {
    id
    title
    order
  }
}
    `;
export type SetHelpBlockOrderMutationFn = Apollo.MutationFunction<SetHelpBlockOrderMutation, SetHelpBlockOrderMutationVariables>;

/**
 * __useSetHelpBlockOrderMutation__
 *
 * To run a mutation, you first call `useSetHelpBlockOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHelpBlockOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHelpBlockOrderMutation, { data, loading, error }] = useSetHelpBlockOrderMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useSetHelpBlockOrderMutation(baseOptions?: Apollo.MutationHookOptions<SetHelpBlockOrderMutation, SetHelpBlockOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHelpBlockOrderMutation, SetHelpBlockOrderMutationVariables>(SetHelpBlockOrderDocument, options);
      }
export type SetHelpBlockOrderMutationHookResult = ReturnType<typeof useSetHelpBlockOrderMutation>;
export type SetHelpBlockOrderMutationResult = Apollo.MutationResult<SetHelpBlockOrderMutation>;
export type SetHelpBlockOrderMutationOptions = Apollo.BaseMutationOptions<SetHelpBlockOrderMutation, SetHelpBlockOrderMutationVariables>;
export const UpdateHelpBlockDocument = gql`
    mutation updateHelpBlock($id: ID!, $update: HelpBlockInput!) {
  updateHelpBlock(id: $id, update: $update) {
    id
    title
    order
  }
}
    `;
export type UpdateHelpBlockMutationFn = Apollo.MutationFunction<UpdateHelpBlockMutation, UpdateHelpBlockMutationVariables>;

/**
 * __useUpdateHelpBlockMutation__
 *
 * To run a mutation, you first call `useUpdateHelpBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHelpBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHelpBlockMutation, { data, loading, error }] = useUpdateHelpBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateHelpBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHelpBlockMutation, UpdateHelpBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHelpBlockMutation, UpdateHelpBlockMutationVariables>(UpdateHelpBlockDocument, options);
      }
export type UpdateHelpBlockMutationHookResult = ReturnType<typeof useUpdateHelpBlockMutation>;
export type UpdateHelpBlockMutationResult = Apollo.MutationResult<UpdateHelpBlockMutation>;
export type UpdateHelpBlockMutationOptions = Apollo.BaseMutationOptions<UpdateHelpBlockMutation, UpdateHelpBlockMutationVariables>;
export const UpdateColorsDocument = gql`
    mutation UpdateColors($primaryHex: String!) {
  updateColors(primaryHex: $primaryHex)
}
    `;
export type UpdateColorsMutationFn = Apollo.MutationFunction<UpdateColorsMutation, UpdateColorsMutationVariables>;

/**
 * __useUpdateColorsMutation__
 *
 * To run a mutation, you first call `useUpdateColorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateColorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateColorsMutation, { data, loading, error }] = useUpdateColorsMutation({
 *   variables: {
 *      primaryHex: // value for 'primaryHex'
 *   },
 * });
 */
export function useUpdateColorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateColorsMutation, UpdateColorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateColorsMutation, UpdateColorsMutationVariables>(UpdateColorsDocument, options);
      }
export type UpdateColorsMutationHookResult = ReturnType<typeof useUpdateColorsMutation>;
export type UpdateColorsMutationResult = Apollo.MutationResult<UpdateColorsMutation>;
export type UpdateColorsMutationOptions = Apollo.BaseMutationOptions<UpdateColorsMutation, UpdateColorsMutationVariables>;
export const UploadLogoDocument = gql`
    mutation uploadLogo($file: Upload!) {
  uploadLogo(file: $file)
}
    `;
export type UploadLogoMutationFn = Apollo.MutationFunction<UploadLogoMutation, UploadLogoMutationVariables>;

/**
 * __useUploadLogoMutation__
 *
 * To run a mutation, you first call `useUploadLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadLogoMutation, { data, loading, error }] = useUploadLogoMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadLogoMutation(baseOptions?: Apollo.MutationHookOptions<UploadLogoMutation, UploadLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadLogoMutation, UploadLogoMutationVariables>(UploadLogoDocument, options);
      }
export type UploadLogoMutationHookResult = ReturnType<typeof useUploadLogoMutation>;
export type UploadLogoMutationResult = Apollo.MutationResult<UploadLogoMutation>;
export type UploadLogoMutationOptions = Apollo.BaseMutationOptions<UploadLogoMutation, UploadLogoMutationVariables>;
export const DownloadMilestonesFileDocument = gql`
    query downloadMilestonesFile {
  downloadMilestonesFile
}
    `;

/**
 * __useDownloadMilestonesFileQuery__
 *
 * To run a query within a React component, call `useDownloadMilestonesFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadMilestonesFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadMilestonesFileQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownloadMilestonesFileQuery(baseOptions?: Apollo.QueryHookOptions<DownloadMilestonesFileQuery, DownloadMilestonesFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadMilestonesFileQuery, DownloadMilestonesFileQueryVariables>(DownloadMilestonesFileDocument, options);
      }
export function useDownloadMilestonesFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadMilestonesFileQuery, DownloadMilestonesFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadMilestonesFileQuery, DownloadMilestonesFileQueryVariables>(DownloadMilestonesFileDocument, options);
        }
export type DownloadMilestonesFileQueryHookResult = ReturnType<typeof useDownloadMilestonesFileQuery>;
export type DownloadMilestonesFileLazyQueryHookResult = ReturnType<typeof useDownloadMilestonesFileLazyQuery>;
export type DownloadMilestonesFileQueryResult = Apollo.QueryResult<DownloadMilestonesFileQuery, DownloadMilestonesFileQueryVariables>;
export const UploadMilestonesDocument = gql`
    mutation uploadMilestones($file: Upload!) {
  uploadMilestones(file: $file)
}
    `;
export type UploadMilestonesMutationFn = Apollo.MutationFunction<UploadMilestonesMutation, UploadMilestonesMutationVariables>;

/**
 * __useUploadMilestonesMutation__
 *
 * To run a mutation, you first call `useUploadMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMilestonesMutation, { data, loading, error }] = useUploadMilestonesMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadMilestonesMutation(baseOptions?: Apollo.MutationHookOptions<UploadMilestonesMutation, UploadMilestonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMilestonesMutation, UploadMilestonesMutationVariables>(UploadMilestonesDocument, options);
      }
export type UploadMilestonesMutationHookResult = ReturnType<typeof useUploadMilestonesMutation>;
export type UploadMilestonesMutationResult = Apollo.MutationResult<UploadMilestonesMutation>;
export type UploadMilestonesMutationOptions = Apollo.BaseMutationOptions<UploadMilestonesMutation, UploadMilestonesMutationVariables>;
export const AddModerationExceptionDocument = gql`
    mutation addModerationException($governanceId: ID!, $data: GovernanceExceptionInput!) {
  addGovernanceException(governanceId: $governanceId, data: $data) {
    id
    name
    enabled
    nationalValidator
    localValidator
    salesPoints {
      id
      name
    }
  }
}
    `;
export type AddModerationExceptionMutationFn = Apollo.MutationFunction<AddModerationExceptionMutation, AddModerationExceptionMutationVariables>;

/**
 * __useAddModerationExceptionMutation__
 *
 * To run a mutation, you first call `useAddModerationExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddModerationExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addModerationExceptionMutation, { data, loading, error }] = useAddModerationExceptionMutation({
 *   variables: {
 *      governanceId: // value for 'governanceId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddModerationExceptionMutation(baseOptions?: Apollo.MutationHookOptions<AddModerationExceptionMutation, AddModerationExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddModerationExceptionMutation, AddModerationExceptionMutationVariables>(AddModerationExceptionDocument, options);
      }
export type AddModerationExceptionMutationHookResult = ReturnType<typeof useAddModerationExceptionMutation>;
export type AddModerationExceptionMutationResult = Apollo.MutationResult<AddModerationExceptionMutation>;
export type AddModerationExceptionMutationOptions = Apollo.BaseMutationOptions<AddModerationExceptionMutation, AddModerationExceptionMutationVariables>;
export const GetModerationDocument = gql`
    query getModeration($type: GovernanceTypes!) {
  governance(type: $type) {
    id
    type
    enabled
    mode
    nationalValidator
    localValidator
    exceptions {
      id
      name
      enabled
      nationalValidator
      localValidator
      salesPoints {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetModerationQuery__
 *
 * To run a query within a React component, call `useGetModerationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModerationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModerationQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetModerationQuery(baseOptions: Apollo.QueryHookOptions<GetModerationQuery, GetModerationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModerationQuery, GetModerationQueryVariables>(GetModerationDocument, options);
      }
export function useGetModerationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModerationQuery, GetModerationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModerationQuery, GetModerationQueryVariables>(GetModerationDocument, options);
        }
export type GetModerationQueryHookResult = ReturnType<typeof useGetModerationQuery>;
export type GetModerationLazyQueryHookResult = ReturnType<typeof useGetModerationLazyQuery>;
export type GetModerationQueryResult = Apollo.QueryResult<GetModerationQuery, GetModerationQueryVariables>;
export const DeleteModerationExceptionDocument = gql`
    mutation deleteModerationException($id: ID!) {
  deleteGovernanceException(id: $id)
}
    `;
export type DeleteModerationExceptionMutationFn = Apollo.MutationFunction<DeleteModerationExceptionMutation, DeleteModerationExceptionMutationVariables>;

/**
 * __useDeleteModerationExceptionMutation__
 *
 * To run a mutation, you first call `useDeleteModerationExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModerationExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModerationExceptionMutation, { data, loading, error }] = useDeleteModerationExceptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteModerationExceptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModerationExceptionMutation, DeleteModerationExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModerationExceptionMutation, DeleteModerationExceptionMutationVariables>(DeleteModerationExceptionDocument, options);
      }
export type DeleteModerationExceptionMutationHookResult = ReturnType<typeof useDeleteModerationExceptionMutation>;
export type DeleteModerationExceptionMutationResult = Apollo.MutationResult<DeleteModerationExceptionMutation>;
export type DeleteModerationExceptionMutationOptions = Apollo.BaseMutationOptions<DeleteModerationExceptionMutation, DeleteModerationExceptionMutationVariables>;
export const UpdateModerationDocument = gql`
    mutation updateModeration($id: ID!, $data: GovernanceInput!) {
  updateGovernance(id: $id, data: $data) {
    id
    type
    enabled
    mode
    nationalValidator
    localValidator
    exceptions {
      id
      name
      enabled
      nationalValidator
      localValidator
      salesPoints {
        id
        name
      }
    }
  }
}
    `;
export type UpdateModerationMutationFn = Apollo.MutationFunction<UpdateModerationMutation, UpdateModerationMutationVariables>;

/**
 * __useUpdateModerationMutation__
 *
 * To run a mutation, you first call `useUpdateModerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModerationMutation, { data, loading, error }] = useUpdateModerationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateModerationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModerationMutation, UpdateModerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModerationMutation, UpdateModerationMutationVariables>(UpdateModerationDocument, options);
      }
export type UpdateModerationMutationHookResult = ReturnType<typeof useUpdateModerationMutation>;
export type UpdateModerationMutationResult = Apollo.MutationResult<UpdateModerationMutation>;
export type UpdateModerationMutationOptions = Apollo.BaseMutationOptions<UpdateModerationMutation, UpdateModerationMutationVariables>;
export const UpdateModerationExceptionDocument = gql`
    mutation updateModerationException($id: ID!, $data: GovernanceExceptionInput!) {
  updateGovernanceException(id: $id, data: $data) {
    id
    name
    enabled
    nationalValidator
    localValidator
    salesPoints {
      id
      name
    }
  }
}
    `;
export type UpdateModerationExceptionMutationFn = Apollo.MutationFunction<UpdateModerationExceptionMutation, UpdateModerationExceptionMutationVariables>;

/**
 * __useUpdateModerationExceptionMutation__
 *
 * To run a mutation, you first call `useUpdateModerationExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModerationExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModerationExceptionMutation, { data, loading, error }] = useUpdateModerationExceptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateModerationExceptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModerationExceptionMutation, UpdateModerationExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModerationExceptionMutation, UpdateModerationExceptionMutationVariables>(UpdateModerationExceptionDocument, options);
      }
export type UpdateModerationExceptionMutationHookResult = ReturnType<typeof useUpdateModerationExceptionMutation>;
export type UpdateModerationExceptionMutationResult = Apollo.MutationResult<UpdateModerationExceptionMutation>;
export type UpdateModerationExceptionMutationOptions = Apollo.BaseMutationOptions<UpdateModerationExceptionMutation, UpdateModerationExceptionMutationVariables>;
export const CreatePostTemplateTagDocument = gql`
    mutation createPostTemplateTag($tag: PostTemplateTagInput!) {
  createPostTemplateTag(tag: $tag) {
    id
  }
}
    `;
export type CreatePostTemplateTagMutationFn = Apollo.MutationFunction<CreatePostTemplateTagMutation, CreatePostTemplateTagMutationVariables>;

/**
 * __useCreatePostTemplateTagMutation__
 *
 * To run a mutation, you first call `useCreatePostTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostTemplateTagMutation, { data, loading, error }] = useCreatePostTemplateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreatePostTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostTemplateTagMutation, CreatePostTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostTemplateTagMutation, CreatePostTemplateTagMutationVariables>(CreatePostTemplateTagDocument, options);
      }
export type CreatePostTemplateTagMutationHookResult = ReturnType<typeof useCreatePostTemplateTagMutation>;
export type CreatePostTemplateTagMutationResult = Apollo.MutationResult<CreatePostTemplateTagMutation>;
export type CreatePostTemplateTagMutationOptions = Apollo.BaseMutationOptions<CreatePostTemplateTagMutation, CreatePostTemplateTagMutationVariables>;
export const CreatePostTemplateTagGroupDocument = gql`
    mutation createPostTemplateTagGroup($tagGroup: PostTemplateTagGroupInput!) {
  createPostTemplateTagGroup(tagGroup: $tagGroup) {
    id
  }
}
    `;
export type CreatePostTemplateTagGroupMutationFn = Apollo.MutationFunction<CreatePostTemplateTagGroupMutation, CreatePostTemplateTagGroupMutationVariables>;

/**
 * __useCreatePostTemplateTagGroupMutation__
 *
 * To run a mutation, you first call `useCreatePostTemplateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostTemplateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostTemplateTagGroupMutation, { data, loading, error }] = useCreatePostTemplateTagGroupMutation({
 *   variables: {
 *      tagGroup: // value for 'tagGroup'
 *   },
 * });
 */
export function useCreatePostTemplateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostTemplateTagGroupMutation, CreatePostTemplateTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostTemplateTagGroupMutation, CreatePostTemplateTagGroupMutationVariables>(CreatePostTemplateTagGroupDocument, options);
      }
export type CreatePostTemplateTagGroupMutationHookResult = ReturnType<typeof useCreatePostTemplateTagGroupMutation>;
export type CreatePostTemplateTagGroupMutationResult = Apollo.MutationResult<CreatePostTemplateTagGroupMutation>;
export type CreatePostTemplateTagGroupMutationOptions = Apollo.BaseMutationOptions<CreatePostTemplateTagGroupMutation, CreatePostTemplateTagGroupMutationVariables>;
export const DeletePostTemplateTagDocument = gql`
    mutation deletePostTemplateTag($id: ID!) {
  deletePostTemplateTag(id: $id)
}
    `;
export type DeletePostTemplateTagMutationFn = Apollo.MutationFunction<DeletePostTemplateTagMutation, DeletePostTemplateTagMutationVariables>;

/**
 * __useDeletePostTemplateTagMutation__
 *
 * To run a mutation, you first call `useDeletePostTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostTemplateTagMutation, { data, loading, error }] = useDeletePostTemplateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostTemplateTagMutation, DeletePostTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostTemplateTagMutation, DeletePostTemplateTagMutationVariables>(DeletePostTemplateTagDocument, options);
      }
export type DeletePostTemplateTagMutationHookResult = ReturnType<typeof useDeletePostTemplateTagMutation>;
export type DeletePostTemplateTagMutationResult = Apollo.MutationResult<DeletePostTemplateTagMutation>;
export type DeletePostTemplateTagMutationOptions = Apollo.BaseMutationOptions<DeletePostTemplateTagMutation, DeletePostTemplateTagMutationVariables>;
export const DeletePostTemplateTagGroupDocument = gql`
    mutation deletePostTemplateTagGroup($id: ID!) {
  deletePostTemplateTagGroup(id: $id)
}
    `;
export type DeletePostTemplateTagGroupMutationFn = Apollo.MutationFunction<DeletePostTemplateTagGroupMutation, DeletePostTemplateTagGroupMutationVariables>;

/**
 * __useDeletePostTemplateTagGroupMutation__
 *
 * To run a mutation, you first call `useDeletePostTemplateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostTemplateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostTemplateTagGroupMutation, { data, loading, error }] = useDeletePostTemplateTagGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostTemplateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostTemplateTagGroupMutation, DeletePostTemplateTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostTemplateTagGroupMutation, DeletePostTemplateTagGroupMutationVariables>(DeletePostTemplateTagGroupDocument, options);
      }
export type DeletePostTemplateTagGroupMutationHookResult = ReturnType<typeof useDeletePostTemplateTagGroupMutation>;
export type DeletePostTemplateTagGroupMutationResult = Apollo.MutationResult<DeletePostTemplateTagGroupMutation>;
export type DeletePostTemplateTagGroupMutationOptions = Apollo.BaseMutationOptions<DeletePostTemplateTagGroupMutation, DeletePostTemplateTagGroupMutationVariables>;
export const PostTemplateTagGroupsDocument = gql`
    query postTemplateTagGroups {
  postTemplateTagGroups {
    tagGroups {
      id
      name
      created_at
      updated_at
      enabled
    }
  }
}
    `;

/**
 * __usePostTemplateTagGroupsQuery__
 *
 * To run a query within a React component, call `usePostTemplateTagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostTemplateTagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostTemplateTagGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostTemplateTagGroupsQuery(baseOptions?: Apollo.QueryHookOptions<PostTemplateTagGroupsQuery, PostTemplateTagGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostTemplateTagGroupsQuery, PostTemplateTagGroupsQueryVariables>(PostTemplateTagGroupsDocument, options);
      }
export function usePostTemplateTagGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostTemplateTagGroupsQuery, PostTemplateTagGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostTemplateTagGroupsQuery, PostTemplateTagGroupsQueryVariables>(PostTemplateTagGroupsDocument, options);
        }
export type PostTemplateTagGroupsQueryHookResult = ReturnType<typeof usePostTemplateTagGroupsQuery>;
export type PostTemplateTagGroupsLazyQueryHookResult = ReturnType<typeof usePostTemplateTagGroupsLazyQuery>;
export type PostTemplateTagGroupsQueryResult = Apollo.QueryResult<PostTemplateTagGroupsQuery, PostTemplateTagGroupsQueryVariables>;
export const PostTemplateTagsDocument = gql`
    query postTemplateTags {
  postTemplateTags {
    tags {
      id
      name
      tagGroup {
        name
      }
      created_at
      updated_at
      enabled
    }
  }
}
    `;

/**
 * __usePostTemplateTagsQuery__
 *
 * To run a query within a React component, call `usePostTemplateTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostTemplateTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostTemplateTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostTemplateTagsQuery(baseOptions?: Apollo.QueryHookOptions<PostTemplateTagsQuery, PostTemplateTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostTemplateTagsQuery, PostTemplateTagsQueryVariables>(PostTemplateTagsDocument, options);
      }
export function usePostTemplateTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostTemplateTagsQuery, PostTemplateTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostTemplateTagsQuery, PostTemplateTagsQueryVariables>(PostTemplateTagsDocument, options);
        }
export type PostTemplateTagsQueryHookResult = ReturnType<typeof usePostTemplateTagsQuery>;
export type PostTemplateTagsLazyQueryHookResult = ReturnType<typeof usePostTemplateTagsLazyQuery>;
export type PostTemplateTagsQueryResult = Apollo.QueryResult<PostTemplateTagsQuery, PostTemplateTagsQueryVariables>;
export const UpdatePostTemplateTagDocument = gql`
    mutation updatePostTemplateTag($id: ID!, $updates: PostTemplateTagInput!) {
  updatePostTemplateTag(id: $id, updates: $updates) {
    id
  }
}
    `;
export type UpdatePostTemplateTagMutationFn = Apollo.MutationFunction<UpdatePostTemplateTagMutation, UpdatePostTemplateTagMutationVariables>;

/**
 * __useUpdatePostTemplateTagMutation__
 *
 * To run a mutation, you first call `useUpdatePostTemplateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostTemplateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostTemplateTagMutation, { data, loading, error }] = useUpdatePostTemplateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdatePostTemplateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostTemplateTagMutation, UpdatePostTemplateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostTemplateTagMutation, UpdatePostTemplateTagMutationVariables>(UpdatePostTemplateTagDocument, options);
      }
export type UpdatePostTemplateTagMutationHookResult = ReturnType<typeof useUpdatePostTemplateTagMutation>;
export type UpdatePostTemplateTagMutationResult = Apollo.MutationResult<UpdatePostTemplateTagMutation>;
export type UpdatePostTemplateTagMutationOptions = Apollo.BaseMutationOptions<UpdatePostTemplateTagMutation, UpdatePostTemplateTagMutationVariables>;
export const UpdatePostTemplateTagGroupDocument = gql`
    mutation updatePostTemplateTagGroup($id: ID!, $updates: PostTemplateTagGroupInput!) {
  updatePostTemplateTagGroup(id: $id, updates: $updates) {
    id
  }
}
    `;
export type UpdatePostTemplateTagGroupMutationFn = Apollo.MutationFunction<UpdatePostTemplateTagGroupMutation, UpdatePostTemplateTagGroupMutationVariables>;

/**
 * __useUpdatePostTemplateTagGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePostTemplateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostTemplateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostTemplateTagGroupMutation, { data, loading, error }] = useUpdatePostTemplateTagGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdatePostTemplateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostTemplateTagGroupMutation, UpdatePostTemplateTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostTemplateTagGroupMutation, UpdatePostTemplateTagGroupMutationVariables>(UpdatePostTemplateTagGroupDocument, options);
      }
export type UpdatePostTemplateTagGroupMutationHookResult = ReturnType<typeof useUpdatePostTemplateTagGroupMutation>;
export type UpdatePostTemplateTagGroupMutationResult = Apollo.MutationResult<UpdatePostTemplateTagGroupMutation>;
export type UpdatePostTemplateTagGroupMutationOptions = Apollo.BaseMutationOptions<UpdatePostTemplateTagGroupMutation, UpdatePostTemplateTagGroupMutationVariables>;
export const AdminProductCategoriesScreen_GetParentProductCategoriesDocument = gql`
    query AdminProductCategoriesScreen_getParentProductCategories {
  getProductCategories {
    ... on ParentProductCategory {
      id
      title
      enabled
      position
    }
  }
}
    `;

/**
 * __useAdminProductCategoriesScreen_GetParentProductCategoriesQuery__
 *
 * To run a query within a React component, call `useAdminProductCategoriesScreen_GetParentProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductCategoriesScreen_GetParentProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductCategoriesScreen_GetParentProductCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminProductCategoriesScreen_GetParentProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AdminProductCategoriesScreen_GetParentProductCategoriesQuery, AdminProductCategoriesScreen_GetParentProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductCategoriesScreen_GetParentProductCategoriesQuery, AdminProductCategoriesScreen_GetParentProductCategoriesQueryVariables>(AdminProductCategoriesScreen_GetParentProductCategoriesDocument, options);
      }
export function useAdminProductCategoriesScreen_GetParentProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductCategoriesScreen_GetParentProductCategoriesQuery, AdminProductCategoriesScreen_GetParentProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductCategoriesScreen_GetParentProductCategoriesQuery, AdminProductCategoriesScreen_GetParentProductCategoriesQueryVariables>(AdminProductCategoriesScreen_GetParentProductCategoriesDocument, options);
        }
export type AdminProductCategoriesScreen_GetParentProductCategoriesQueryHookResult = ReturnType<typeof useAdminProductCategoriesScreen_GetParentProductCategoriesQuery>;
export type AdminProductCategoriesScreen_GetParentProductCategoriesLazyQueryHookResult = ReturnType<typeof useAdminProductCategoriesScreen_GetParentProductCategoriesLazyQuery>;
export type AdminProductCategoriesScreen_GetParentProductCategoriesQueryResult = Apollo.QueryResult<AdminProductCategoriesScreen_GetParentProductCategoriesQuery, AdminProductCategoriesScreen_GetParentProductCategoriesQueryVariables>;
export const AdminProductCategoriesForm_CreateChildProductCategoryDocument = gql`
    mutation AdminProductCategoriesForm_createChildProductCategory($input: ChildProductCategoryInput!, $newImage: Upload) {
  createChildProductCategory(input: $input, newImage: $newImage) {
    id
    parentId
  }
}
    `;
export type AdminProductCategoriesForm_CreateChildProductCategoryMutationFn = Apollo.MutationFunction<AdminProductCategoriesForm_CreateChildProductCategoryMutation, AdminProductCategoriesForm_CreateChildProductCategoryMutationVariables>;

/**
 * __useAdminProductCategoriesForm_CreateChildProductCategoryMutation__
 *
 * To run a mutation, you first call `useAdminProductCategoriesForm_CreateChildProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminProductCategoriesForm_CreateChildProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminProductCategoriesFormCreateChildProductCategoryMutation, { data, loading, error }] = useAdminProductCategoriesForm_CreateChildProductCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *      newImage: // value for 'newImage'
 *   },
 * });
 */
export function useAdminProductCategoriesForm_CreateChildProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminProductCategoriesForm_CreateChildProductCategoryMutation, AdminProductCategoriesForm_CreateChildProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminProductCategoriesForm_CreateChildProductCategoryMutation, AdminProductCategoriesForm_CreateChildProductCategoryMutationVariables>(AdminProductCategoriesForm_CreateChildProductCategoryDocument, options);
      }
export type AdminProductCategoriesForm_CreateChildProductCategoryMutationHookResult = ReturnType<typeof useAdminProductCategoriesForm_CreateChildProductCategoryMutation>;
export type AdminProductCategoriesForm_CreateChildProductCategoryMutationResult = Apollo.MutationResult<AdminProductCategoriesForm_CreateChildProductCategoryMutation>;
export type AdminProductCategoriesForm_CreateChildProductCategoryMutationOptions = Apollo.BaseMutationOptions<AdminProductCategoriesForm_CreateChildProductCategoryMutation, AdminProductCategoriesForm_CreateChildProductCategoryMutationVariables>;
export const AdminProductCategoriesForm_CreateParentProductCategoryDocument = gql`
    mutation AdminProductCategoriesForm_createParentProductCategory($input: ParentProductCategoryInput!) {
  createParentProductCategory(input: $input) {
    id
    title
    enabled
  }
}
    `;
export type AdminProductCategoriesForm_CreateParentProductCategoryMutationFn = Apollo.MutationFunction<AdminProductCategoriesForm_CreateParentProductCategoryMutation, AdminProductCategoriesForm_CreateParentProductCategoryMutationVariables>;

/**
 * __useAdminProductCategoriesForm_CreateParentProductCategoryMutation__
 *
 * To run a mutation, you first call `useAdminProductCategoriesForm_CreateParentProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminProductCategoriesForm_CreateParentProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminProductCategoriesFormCreateParentProductCategoryMutation, { data, loading, error }] = useAdminProductCategoriesForm_CreateParentProductCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminProductCategoriesForm_CreateParentProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminProductCategoriesForm_CreateParentProductCategoryMutation, AdminProductCategoriesForm_CreateParentProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminProductCategoriesForm_CreateParentProductCategoryMutation, AdminProductCategoriesForm_CreateParentProductCategoryMutationVariables>(AdminProductCategoriesForm_CreateParentProductCategoryDocument, options);
      }
export type AdminProductCategoriesForm_CreateParentProductCategoryMutationHookResult = ReturnType<typeof useAdminProductCategoriesForm_CreateParentProductCategoryMutation>;
export type AdminProductCategoriesForm_CreateParentProductCategoryMutationResult = Apollo.MutationResult<AdminProductCategoriesForm_CreateParentProductCategoryMutation>;
export type AdminProductCategoriesForm_CreateParentProductCategoryMutationOptions = Apollo.BaseMutationOptions<AdminProductCategoriesForm_CreateParentProductCategoryMutation, AdminProductCategoriesForm_CreateParentProductCategoryMutationVariables>;
export const AdminProductCategoriesForm_GetChildProductCategoriesDocument = gql`
    query AdminProductCategoriesForm_getChildProductCategories($parentId: ID!) {
  getProductCategories(parentId: $parentId) {
    ... on ChildProductCategory {
      id
      title
      enabled
      position
    }
  }
}
    `;

/**
 * __useAdminProductCategoriesForm_GetChildProductCategoriesQuery__
 *
 * To run a query within a React component, call `useAdminProductCategoriesForm_GetChildProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProductCategoriesForm_GetChildProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProductCategoriesForm_GetChildProductCategoriesQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useAdminProductCategoriesForm_GetChildProductCategoriesQuery(baseOptions: Apollo.QueryHookOptions<AdminProductCategoriesForm_GetChildProductCategoriesQuery, AdminProductCategoriesForm_GetChildProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminProductCategoriesForm_GetChildProductCategoriesQuery, AdminProductCategoriesForm_GetChildProductCategoriesQueryVariables>(AdminProductCategoriesForm_GetChildProductCategoriesDocument, options);
      }
export function useAdminProductCategoriesForm_GetChildProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminProductCategoriesForm_GetChildProductCategoriesQuery, AdminProductCategoriesForm_GetChildProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminProductCategoriesForm_GetChildProductCategoriesQuery, AdminProductCategoriesForm_GetChildProductCategoriesQueryVariables>(AdminProductCategoriesForm_GetChildProductCategoriesDocument, options);
        }
export type AdminProductCategoriesForm_GetChildProductCategoriesQueryHookResult = ReturnType<typeof useAdminProductCategoriesForm_GetChildProductCategoriesQuery>;
export type AdminProductCategoriesForm_GetChildProductCategoriesLazyQueryHookResult = ReturnType<typeof useAdminProductCategoriesForm_GetChildProductCategoriesLazyQuery>;
export type AdminProductCategoriesForm_GetChildProductCategoriesQueryResult = Apollo.QueryResult<AdminProductCategoriesForm_GetChildProductCategoriesQuery, AdminProductCategoriesForm_GetChildProductCategoriesQueryVariables>;
export const UpdateChildProductCategoryDocument = gql`
    mutation updateChildProductCategory($id: ID!, $input: ChildProductCategoryInput!, $newImage: Upload, $deleteImage: Boolean) {
  updateChildProductCategory(id: $id, input: $input, newImage: $newImage, deleteImage: $deleteImage) {
    id
    title
    description
    enabled
    image {
      id
      original
    }
    products {
      id
      name
    }
  }
}
    `;
export type UpdateChildProductCategoryMutationFn = Apollo.MutationFunction<UpdateChildProductCategoryMutation, UpdateChildProductCategoryMutationVariables>;

/**
 * __useUpdateChildProductCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateChildProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChildProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChildProductCategoryMutation, { data, loading, error }] = useUpdateChildProductCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      newImage: // value for 'newImage'
 *      deleteImage: // value for 'deleteImage'
 *   },
 * });
 */
export function useUpdateChildProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChildProductCategoryMutation, UpdateChildProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChildProductCategoryMutation, UpdateChildProductCategoryMutationVariables>(UpdateChildProductCategoryDocument, options);
      }
export type UpdateChildProductCategoryMutationHookResult = ReturnType<typeof useUpdateChildProductCategoryMutation>;
export type UpdateChildProductCategoryMutationResult = Apollo.MutationResult<UpdateChildProductCategoryMutation>;
export type UpdateChildProductCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateChildProductCategoryMutation, UpdateChildProductCategoryMutationVariables>;
export const AdminProductCategoriesForm_UpdateParentProductCategoryDocument = gql`
    mutation AdminProductCategoriesForm_updateParentProductCategory($id: ID!, $input: ParentProductCategoryInput!) {
  updateParentProductCategory(id: $id, input: $input) {
    id
    title
    enabled
    salespointGroups {
      id
      name
    }
  }
}
    `;
export type AdminProductCategoriesForm_UpdateParentProductCategoryMutationFn = Apollo.MutationFunction<AdminProductCategoriesForm_UpdateParentProductCategoryMutation, AdminProductCategoriesForm_UpdateParentProductCategoryMutationVariables>;

/**
 * __useAdminProductCategoriesForm_UpdateParentProductCategoryMutation__
 *
 * To run a mutation, you first call `useAdminProductCategoriesForm_UpdateParentProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminProductCategoriesForm_UpdateParentProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminProductCategoriesFormUpdateParentProductCategoryMutation, { data, loading, error }] = useAdminProductCategoriesForm_UpdateParentProductCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminProductCategoriesForm_UpdateParentProductCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminProductCategoriesForm_UpdateParentProductCategoryMutation, AdminProductCategoriesForm_UpdateParentProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminProductCategoriesForm_UpdateParentProductCategoryMutation, AdminProductCategoriesForm_UpdateParentProductCategoryMutationVariables>(AdminProductCategoriesForm_UpdateParentProductCategoryDocument, options);
      }
export type AdminProductCategoriesForm_UpdateParentProductCategoryMutationHookResult = ReturnType<typeof useAdminProductCategoriesForm_UpdateParentProductCategoryMutation>;
export type AdminProductCategoriesForm_UpdateParentProductCategoryMutationResult = Apollo.MutationResult<AdminProductCategoriesForm_UpdateParentProductCategoryMutation>;
export type AdminProductCategoriesForm_UpdateParentProductCategoryMutationOptions = Apollo.BaseMutationOptions<AdminProductCategoriesForm_UpdateParentProductCategoryMutation, AdminProductCategoriesForm_UpdateParentProductCategoryMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($id: ID!) {
  deleteProduct(id: $id)
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const ProductsAvailableInPackDocument = gql`
    query productsAvailableInPack($keyword: String) {
  products(offset: 0, limit: 300, showDisabled: true, fromPack: true, keyword: $keyword, sort: {criteria: name, direction: asc}) {
    products {
      id
      name
      images {
        id
        original
        originName
      }
      price {
        basePrice {
          withTaxes
          withoutTaxes
          taxAmount
          taxPercent
        }
      }
      priceType
      catalogPrice
      catalogPriceLevels {
        price
      }
      catalogFixPricesLevelsByQuantity {
        quantity
        price
      }
      priceType
    }
    count
  }
}
    `;

/**
 * __useProductsAvailableInPackQuery__
 *
 * To run a query within a React component, call `useProductsAvailableInPackQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsAvailableInPackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsAvailableInPackQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useProductsAvailableInPackQuery(baseOptions?: Apollo.QueryHookOptions<ProductsAvailableInPackQuery, ProductsAvailableInPackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsAvailableInPackQuery, ProductsAvailableInPackQueryVariables>(ProductsAvailableInPackDocument, options);
      }
export function useProductsAvailableInPackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsAvailableInPackQuery, ProductsAvailableInPackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsAvailableInPackQuery, ProductsAvailableInPackQueryVariables>(ProductsAvailableInPackDocument, options);
        }
export type ProductsAvailableInPackQueryHookResult = ReturnType<typeof useProductsAvailableInPackQuery>;
export type ProductsAvailableInPackLazyQueryHookResult = ReturnType<typeof useProductsAvailableInPackLazyQuery>;
export type ProductsAvailableInPackQueryResult = Apollo.QueryResult<ProductsAvailableInPackQuery, ProductsAvailableInPackQueryVariables>;
export const ChildProductCategoriesByKeywordDocument = gql`
    query childProductCategoriesByKeyword($keyword: String) {
  childProductCategoriesByKeyword(keyword: $keyword, offset: 0, limit: 50) {
    id
    title
    enabled
    parentId
  }
}
    `;

/**
 * __useChildProductCategoriesByKeywordQuery__
 *
 * To run a query within a React component, call `useChildProductCategoriesByKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildProductCategoriesByKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildProductCategoriesByKeywordQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useChildProductCategoriesByKeywordQuery(baseOptions?: Apollo.QueryHookOptions<ChildProductCategoriesByKeywordQuery, ChildProductCategoriesByKeywordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChildProductCategoriesByKeywordQuery, ChildProductCategoriesByKeywordQueryVariables>(ChildProductCategoriesByKeywordDocument, options);
      }
export function useChildProductCategoriesByKeywordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChildProductCategoriesByKeywordQuery, ChildProductCategoriesByKeywordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChildProductCategoriesByKeywordQuery, ChildProductCategoriesByKeywordQueryVariables>(ChildProductCategoriesByKeywordDocument, options);
        }
export type ChildProductCategoriesByKeywordQueryHookResult = ReturnType<typeof useChildProductCategoriesByKeywordQuery>;
export type ChildProductCategoriesByKeywordLazyQueryHookResult = ReturnType<typeof useChildProductCategoriesByKeywordLazyQuery>;
export type ChildProductCategoriesByKeywordQueryResult = Apollo.QueryResult<ChildProductCategoriesByKeywordQuery, ChildProductCategoriesByKeywordQueryVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($product: InputProduct!, $lowQualityAsset: Upload, $tempLowQualityAsset: TempFileInput, $highQualityAsset: Upload, $images: [ImageInput], $duplicateProductInfos: InputDuplicateInfos) {
  createProduct(product: $product, lowQualityAsset: $lowQualityAsset, tempLowQualityAsset: $tempLowQualityAsset, highQualityAsset: $highQualityAsset, images: $images, duplicateProductInfos: $duplicateProductInfos) {
    id
    name
    isCustomizable
    type
    catalogPrice
    ref
    description
    tips
    price {
      basePrice {
        withoutTaxes
      }
    }
    disabled
    salespointGroups {
      id
    }
    stock
    isStockEnabled
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      product: // value for 'product'
 *      lowQualityAsset: // value for 'lowQualityAsset'
 *      tempLowQualityAsset: // value for 'tempLowQualityAsset'
 *      highQualityAsset: // value for 'highQualityAsset'
 *      images: // value for 'images'
 *      duplicateProductInfos: // value for 'duplicateProductInfos'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($id: ID!, $updates: InputProduct!, $lowQualityAsset: Upload, $tempLowQualityAsset: TempFileInput, $deleteLowQualityAsset: Boolean, $highQualityAsset: Upload, $deleteHighQualityAsset: Boolean, $images: [ImageInput], $deleteOptionsAssets: [InputDeleteOptionsAssets]) {
  updateProduct(id: $id, updates: $updates, lowQualityAsset: $lowQualityAsset, tempLowQualityAsset: $tempLowQualityAsset, deleteLowQualityAsset: $deleteLowQualityAsset, highQualityAsset: $highQualityAsset, deleteHighQualityAsset: $deleteHighQualityAsset, images: $images, deleteOptionsAssets: $deleteOptionsAssets)
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *      lowQualityAsset: // value for 'lowQualityAsset'
 *      tempLowQualityAsset: // value for 'tempLowQualityAsset'
 *      deleteLowQualityAsset: // value for 'deleteLowQualityAsset'
 *      highQualityAsset: // value for 'highQualityAsset'
 *      deleteHighQualityAsset: // value for 'deleteHighQualityAsset'
 *      images: // value for 'images'
 *      deleteOptionsAssets: // value for 'deleteOptionsAssets'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const GetProductsDocument = gql`
    query getProducts($filters: [ProductFilterInput]) {
  products(limit: 0, sort: {direction: desc, criteria: createdAt}, showDisabled: true, separateHighlights: false, filters: $filters) {
    products {
      id
      name
      isCustomizable
      ref
      disabled
      catalogPrice
      catalogFixPricesLevelsByQuantity {
        quantity
        price
      }
      priceType
      stock
      isStockEnabled
      packagingUnit
      isShowcase
      isBriefCrm
      isPack
    }
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const CancelProductsImportJobDocument = gql`
    mutation cancelProductsImportJob($jobId: ID!) {
  cancelProductsImportJob(jobId: $jobId)
}
    `;
export type CancelProductsImportJobMutationFn = Apollo.MutationFunction<CancelProductsImportJobMutation, CancelProductsImportJobMutationVariables>;

/**
 * __useCancelProductsImportJobMutation__
 *
 * To run a mutation, you first call `useCancelProductsImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProductsImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProductsImportJobMutation, { data, loading, error }] = useCancelProductsImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelProductsImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelProductsImportJobMutation, CancelProductsImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelProductsImportJobMutation, CancelProductsImportJobMutationVariables>(CancelProductsImportJobDocument, options);
      }
export type CancelProductsImportJobMutationHookResult = ReturnType<typeof useCancelProductsImportJobMutation>;
export type CancelProductsImportJobMutationResult = Apollo.MutationResult<CancelProductsImportJobMutation>;
export type CancelProductsImportJobMutationOptions = Apollo.BaseMutationOptions<CancelProductsImportJobMutation, CancelProductsImportJobMutationVariables>;
export const CommitProductsImportJobDocument = gql`
    mutation commitProductsImportJob($jobId: ID!) {
  commitProductsImportJob(jobId: $jobId)
}
    `;
export type CommitProductsImportJobMutationFn = Apollo.MutationFunction<CommitProductsImportJobMutation, CommitProductsImportJobMutationVariables>;

/**
 * __useCommitProductsImportJobMutation__
 *
 * To run a mutation, you first call `useCommitProductsImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitProductsImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitProductsImportJobMutation, { data, loading, error }] = useCommitProductsImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCommitProductsImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CommitProductsImportJobMutation, CommitProductsImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitProductsImportJobMutation, CommitProductsImportJobMutationVariables>(CommitProductsImportJobDocument, options);
      }
export type CommitProductsImportJobMutationHookResult = ReturnType<typeof useCommitProductsImportJobMutation>;
export type CommitProductsImportJobMutationResult = Apollo.MutationResult<CommitProductsImportJobMutation>;
export type CommitProductsImportJobMutationOptions = Apollo.BaseMutationOptions<CommitProductsImportJobMutation, CommitProductsImportJobMutationVariables>;
export const ExportProductsDocument = gql`
    mutation exportProducts($sort: ProductSort, $format: String) {
  exportProducts(sort: $sort, format: $format)
}
    `;
export type ExportProductsMutationFn = Apollo.MutationFunction<ExportProductsMutation, ExportProductsMutationVariables>;

/**
 * __useExportProductsMutation__
 *
 * To run a mutation, you first call `useExportProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportProductsMutation, { data, loading, error }] = useExportProductsMutation({
 *   variables: {
 *      sort: // value for 'sort'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportProductsMutation(baseOptions?: Apollo.MutationHookOptions<ExportProductsMutation, ExportProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportProductsMutation, ExportProductsMutationVariables>(ExportProductsDocument, options);
      }
export type ExportProductsMutationHookResult = ReturnType<typeof useExportProductsMutation>;
export type ExportProductsMutationResult = Apollo.MutationResult<ExportProductsMutation>;
export type ExportProductsMutationOptions = Apollo.BaseMutationOptions<ExportProductsMutation, ExportProductsMutationVariables>;
export const ImportProductsDocument = gql`
    mutation importProducts($file: Upload!) {
  importProducts(file: $file) {
    jobId
    updates
    successful
    errors
    importError
  }
}
    `;
export type ImportProductsMutationFn = Apollo.MutationFunction<ImportProductsMutation, ImportProductsMutationVariables>;

/**
 * __useImportProductsMutation__
 *
 * To run a mutation, you first call `useImportProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importProductsMutation, { data, loading, error }] = useImportProductsMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportProductsMutation(baseOptions?: Apollo.MutationHookOptions<ImportProductsMutation, ImportProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportProductsMutation, ImportProductsMutationVariables>(ImportProductsDocument, options);
      }
export type ImportProductsMutationHookResult = ReturnType<typeof useImportProductsMutation>;
export type ImportProductsMutationResult = Apollo.MutationResult<ImportProductsMutation>;
export type ImportProductsMutationOptions = Apollo.BaseMutationOptions<ImportProductsMutation, ImportProductsMutationVariables>;
export const ToggleProductEnabledDocument = gql`
    mutation toggleProductEnabled($id: ID!) {
  toggleProductEnabled(id: $id) {
    id
    disabled
  }
}
    `;
export type ToggleProductEnabledMutationFn = Apollo.MutationFunction<ToggleProductEnabledMutation, ToggleProductEnabledMutationVariables>;

/**
 * __useToggleProductEnabledMutation__
 *
 * To run a mutation, you first call `useToggleProductEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProductEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProductEnabledMutation, { data, loading, error }] = useToggleProductEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleProductEnabledMutation(baseOptions?: Apollo.MutationHookOptions<ToggleProductEnabledMutation, ToggleProductEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleProductEnabledMutation, ToggleProductEnabledMutationVariables>(ToggleProductEnabledDocument, options);
      }
export type ToggleProductEnabledMutationHookResult = ReturnType<typeof useToggleProductEnabledMutation>;
export type ToggleProductEnabledMutationResult = Apollo.MutationResult<ToggleProductEnabledMutation>;
export type ToggleProductEnabledMutationOptions = Apollo.BaseMutationOptions<ToggleProductEnabledMutation, ToggleProductEnabledMutationVariables>;
export const CancelSalespointGroupsImportJobDocument = gql`
    mutation cancelSalespointGroupsImportJob($jobId: ID!) {
  cancelSalespointGroupsImportJob(jobId: $jobId)
}
    `;
export type CancelSalespointGroupsImportJobMutationFn = Apollo.MutationFunction<CancelSalespointGroupsImportJobMutation, CancelSalespointGroupsImportJobMutationVariables>;

/**
 * __useCancelSalespointGroupsImportJobMutation__
 *
 * To run a mutation, you first call `useCancelSalespointGroupsImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSalespointGroupsImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSalespointGroupsImportJobMutation, { data, loading, error }] = useCancelSalespointGroupsImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelSalespointGroupsImportJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelSalespointGroupsImportJobMutation, CancelSalespointGroupsImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSalespointGroupsImportJobMutation, CancelSalespointGroupsImportJobMutationVariables>(CancelSalespointGroupsImportJobDocument, options);
      }
export type CancelSalespointGroupsImportJobMutationHookResult = ReturnType<typeof useCancelSalespointGroupsImportJobMutation>;
export type CancelSalespointGroupsImportJobMutationResult = Apollo.MutationResult<CancelSalespointGroupsImportJobMutation>;
export type CancelSalespointGroupsImportJobMutationOptions = Apollo.BaseMutationOptions<CancelSalespointGroupsImportJobMutation, CancelSalespointGroupsImportJobMutationVariables>;
export const SalesPointsGroups_CommitSalespointGroupsImportJobDocument = gql`
    mutation SalesPointsGroups_commitSalespointGroupsImportJob($jobId: ID!) {
  commitSalespointGroupsImportJob(jobId: $jobId)
}
    `;
export type SalesPointsGroups_CommitSalespointGroupsImportJobMutationFn = Apollo.MutationFunction<SalesPointsGroups_CommitSalespointGroupsImportJobMutation, SalesPointsGroups_CommitSalespointGroupsImportJobMutationVariables>;

/**
 * __useSalesPointsGroups_CommitSalespointGroupsImportJobMutation__
 *
 * To run a mutation, you first call `useSalesPointsGroups_CommitSalespointGroupsImportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesPointsGroups_CommitSalespointGroupsImportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesPointsGroupsCommitSalespointGroupsImportJobMutation, { data, loading, error }] = useSalesPointsGroups_CommitSalespointGroupsImportJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useSalesPointsGroups_CommitSalespointGroupsImportJobMutation(baseOptions?: Apollo.MutationHookOptions<SalesPointsGroups_CommitSalespointGroupsImportJobMutation, SalesPointsGroups_CommitSalespointGroupsImportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesPointsGroups_CommitSalespointGroupsImportJobMutation, SalesPointsGroups_CommitSalespointGroupsImportJobMutationVariables>(SalesPointsGroups_CommitSalespointGroupsImportJobDocument, options);
      }
export type SalesPointsGroups_CommitSalespointGroupsImportJobMutationHookResult = ReturnType<typeof useSalesPointsGroups_CommitSalespointGroupsImportJobMutation>;
export type SalesPointsGroups_CommitSalespointGroupsImportJobMutationResult = Apollo.MutationResult<SalesPointsGroups_CommitSalespointGroupsImportJobMutation>;
export type SalesPointsGroups_CommitSalespointGroupsImportJobMutationOptions = Apollo.BaseMutationOptions<SalesPointsGroups_CommitSalespointGroupsImportJobMutation, SalesPointsGroups_CommitSalespointGroupsImportJobMutationVariables>;
export const CreateSalespointGroupDocument = gql`
    mutation createSalespointGroup($salespointGroup: salespointGroupInput!) {
  createSalespointGroup(salespointGroup: $salespointGroup) {
    id
    name
    salespoints {
      id
      name
    }
    campaigns {
      id
      name
    }
    products {
      id
      name
    }
    paymentMethodId
    enabled
    medias {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      fullName
    }
  }
}
    `;
export type CreateSalespointGroupMutationFn = Apollo.MutationFunction<CreateSalespointGroupMutation, CreateSalespointGroupMutationVariables>;

/**
 * __useCreateSalespointGroupMutation__
 *
 * To run a mutation, you first call `useCreateSalespointGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalespointGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalespointGroupMutation, { data, loading, error }] = useCreateSalespointGroupMutation({
 *   variables: {
 *      salespointGroup: // value for 'salespointGroup'
 *   },
 * });
 */
export function useCreateSalespointGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalespointGroupMutation, CreateSalespointGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalespointGroupMutation, CreateSalespointGroupMutationVariables>(CreateSalespointGroupDocument, options);
      }
export type CreateSalespointGroupMutationHookResult = ReturnType<typeof useCreateSalespointGroupMutation>;
export type CreateSalespointGroupMutationResult = Apollo.MutationResult<CreateSalespointGroupMutation>;
export type CreateSalespointGroupMutationOptions = Apollo.BaseMutationOptions<CreateSalespointGroupMutation, CreateSalespointGroupMutationVariables>;
export const DeleteSalespointGroupDocument = gql`
    mutation deleteSalespointGroup($id: ID!) {
  deleteSalespointGroup(id: $id)
}
    `;
export type DeleteSalespointGroupMutationFn = Apollo.MutationFunction<DeleteSalespointGroupMutation, DeleteSalespointGroupMutationVariables>;

/**
 * __useDeleteSalespointGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSalespointGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSalespointGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSalespointGroupMutation, { data, loading, error }] = useDeleteSalespointGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSalespointGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSalespointGroupMutation, DeleteSalespointGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSalespointGroupMutation, DeleteSalespointGroupMutationVariables>(DeleteSalespointGroupDocument, options);
      }
export type DeleteSalespointGroupMutationHookResult = ReturnType<typeof useDeleteSalespointGroupMutation>;
export type DeleteSalespointGroupMutationResult = Apollo.MutationResult<DeleteSalespointGroupMutation>;
export type DeleteSalespointGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSalespointGroupMutation, DeleteSalespointGroupMutationVariables>;
export const SalesPointsGroups_ExportSalespointGroupsDocument = gql`
    mutation SalesPointsGroups_exportSalespointGroups {
  exportSalespointGroups
}
    `;
export type SalesPointsGroups_ExportSalespointGroupsMutationFn = Apollo.MutationFunction<SalesPointsGroups_ExportSalespointGroupsMutation, SalesPointsGroups_ExportSalespointGroupsMutationVariables>;

/**
 * __useSalesPointsGroups_ExportSalespointGroupsMutation__
 *
 * To run a mutation, you first call `useSalesPointsGroups_ExportSalespointGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesPointsGroups_ExportSalespointGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesPointsGroupsExportSalespointGroupsMutation, { data, loading, error }] = useSalesPointsGroups_ExportSalespointGroupsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSalesPointsGroups_ExportSalespointGroupsMutation(baseOptions?: Apollo.MutationHookOptions<SalesPointsGroups_ExportSalespointGroupsMutation, SalesPointsGroups_ExportSalespointGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesPointsGroups_ExportSalespointGroupsMutation, SalesPointsGroups_ExportSalespointGroupsMutationVariables>(SalesPointsGroups_ExportSalespointGroupsDocument, options);
      }
export type SalesPointsGroups_ExportSalespointGroupsMutationHookResult = ReturnType<typeof useSalesPointsGroups_ExportSalespointGroupsMutation>;
export type SalesPointsGroups_ExportSalespointGroupsMutationResult = Apollo.MutationResult<SalesPointsGroups_ExportSalespointGroupsMutation>;
export type SalesPointsGroups_ExportSalespointGroupsMutationOptions = Apollo.BaseMutationOptions<SalesPointsGroups_ExportSalespointGroupsMutation, SalesPointsGroups_ExportSalespointGroupsMutationVariables>;
export const SalesPointsGroupsInfo_GetClientPaymentSettingsDocument = gql`
    query SalesPointsGroupsInfo_getClientPaymentSettings {
  me {
    id
    client {
      id
      paymentMethods {
        id
        type
        name
        isSystem
      }
    }
  }
}
    `;

/**
 * __useSalesPointsGroupsInfo_GetClientPaymentSettingsQuery__
 *
 * To run a query within a React component, call `useSalesPointsGroupsInfo_GetClientPaymentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesPointsGroupsInfo_GetClientPaymentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesPointsGroupsInfo_GetClientPaymentSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesPointsGroupsInfo_GetClientPaymentSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SalesPointsGroupsInfo_GetClientPaymentSettingsQuery, SalesPointsGroupsInfo_GetClientPaymentSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesPointsGroupsInfo_GetClientPaymentSettingsQuery, SalesPointsGroupsInfo_GetClientPaymentSettingsQueryVariables>(SalesPointsGroupsInfo_GetClientPaymentSettingsDocument, options);
      }
export function useSalesPointsGroupsInfo_GetClientPaymentSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesPointsGroupsInfo_GetClientPaymentSettingsQuery, SalesPointsGroupsInfo_GetClientPaymentSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesPointsGroupsInfo_GetClientPaymentSettingsQuery, SalesPointsGroupsInfo_GetClientPaymentSettingsQueryVariables>(SalesPointsGroupsInfo_GetClientPaymentSettingsDocument, options);
        }
export type SalesPointsGroupsInfo_GetClientPaymentSettingsQueryHookResult = ReturnType<typeof useSalesPointsGroupsInfo_GetClientPaymentSettingsQuery>;
export type SalesPointsGroupsInfo_GetClientPaymentSettingsLazyQueryHookResult = ReturnType<typeof useSalesPointsGroupsInfo_GetClientPaymentSettingsLazyQuery>;
export type SalesPointsGroupsInfo_GetClientPaymentSettingsQueryResult = Apollo.QueryResult<SalesPointsGroupsInfo_GetClientPaymentSettingsQuery, SalesPointsGroupsInfo_GetClientPaymentSettingsQueryVariables>;
export const GetUserSalespointsGroupsDocument = gql`
    query getUserSalespointsGroups {
  getUserSalespointsGroups {
    groupId
    name
    salespointsCount
    enabled
  }
}
    `;

/**
 * __useGetUserSalespointsGroupsQuery__
 *
 * To run a query within a React component, call `useGetUserSalespointsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSalespointsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSalespointsGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSalespointsGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserSalespointsGroupsQuery, GetUserSalespointsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSalespointsGroupsQuery, GetUserSalespointsGroupsQueryVariables>(GetUserSalespointsGroupsDocument, options);
      }
export function useGetUserSalespointsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSalespointsGroupsQuery, GetUserSalespointsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSalespointsGroupsQuery, GetUserSalespointsGroupsQueryVariables>(GetUserSalespointsGroupsDocument, options);
        }
export type GetUserSalespointsGroupsQueryHookResult = ReturnType<typeof useGetUserSalespointsGroupsQuery>;
export type GetUserSalespointsGroupsLazyQueryHookResult = ReturnType<typeof useGetUserSalespointsGroupsLazyQuery>;
export type GetUserSalespointsGroupsQueryResult = Apollo.QueryResult<GetUserSalespointsGroupsQuery, GetUserSalespointsGroupsQueryVariables>;
export const SalesPointsGroups_ImportSalespointGroupsDocument = gql`
    mutation SalesPointsGroups_importSalespointGroups($file: Upload!) {
  importSalespointGroups(csvFile: $file) {
    jobId
    successful
    updates
    errors
    importError
  }
}
    `;
export type SalesPointsGroups_ImportSalespointGroupsMutationFn = Apollo.MutationFunction<SalesPointsGroups_ImportSalespointGroupsMutation, SalesPointsGroups_ImportSalespointGroupsMutationVariables>;

/**
 * __useSalesPointsGroups_ImportSalespointGroupsMutation__
 *
 * To run a mutation, you first call `useSalesPointsGroups_ImportSalespointGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesPointsGroups_ImportSalespointGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesPointsGroupsImportSalespointGroupsMutation, { data, loading, error }] = useSalesPointsGroups_ImportSalespointGroupsMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSalesPointsGroups_ImportSalespointGroupsMutation(baseOptions?: Apollo.MutationHookOptions<SalesPointsGroups_ImportSalespointGroupsMutation, SalesPointsGroups_ImportSalespointGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesPointsGroups_ImportSalespointGroupsMutation, SalesPointsGroups_ImportSalespointGroupsMutationVariables>(SalesPointsGroups_ImportSalespointGroupsDocument, options);
      }
export type SalesPointsGroups_ImportSalespointGroupsMutationHookResult = ReturnType<typeof useSalesPointsGroups_ImportSalespointGroupsMutation>;
export type SalesPointsGroups_ImportSalespointGroupsMutationResult = Apollo.MutationResult<SalesPointsGroups_ImportSalespointGroupsMutation>;
export type SalesPointsGroups_ImportSalespointGroupsMutationOptions = Apollo.BaseMutationOptions<SalesPointsGroups_ImportSalespointGroupsMutation, SalesPointsGroups_ImportSalespointGroupsMutationVariables>;
export const SalesPointsGroupsDocument = gql`
    query salesPointsGroups {
  salesPointsGroups {
    id
    name
    salespoints {
      id
      name
    }
    enabled
  }
}
    `;

/**
 * __useSalesPointsGroupsQuery__
 *
 * To run a query within a React component, call `useSalesPointsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesPointsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesPointsGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesPointsGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SalesPointsGroupsQuery, SalesPointsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesPointsGroupsQuery, SalesPointsGroupsQueryVariables>(SalesPointsGroupsDocument, options);
      }
export function useSalesPointsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesPointsGroupsQuery, SalesPointsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesPointsGroupsQuery, SalesPointsGroupsQueryVariables>(SalesPointsGroupsDocument, options);
        }
export type SalesPointsGroupsQueryHookResult = ReturnType<typeof useSalesPointsGroupsQuery>;
export type SalesPointsGroupsLazyQueryHookResult = ReturnType<typeof useSalesPointsGroupsLazyQuery>;
export type SalesPointsGroupsQueryResult = Apollo.QueryResult<SalesPointsGroupsQuery, SalesPointsGroupsQueryVariables>;
export const UpdateSalespointGroupDocument = gql`
    mutation updateSalespointGroup($id: ID!, $updates: salespointGroupInput!) {
  updateSalespointGroup(id: $id, updates: $updates)
}
    `;
export type UpdateSalespointGroupMutationFn = Apollo.MutationFunction<UpdateSalespointGroupMutation, UpdateSalespointGroupMutationVariables>;

/**
 * __useUpdateSalespointGroupMutation__
 *
 * To run a mutation, you first call `useUpdateSalespointGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalespointGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalespointGroupMutation, { data, loading, error }] = useUpdateSalespointGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateSalespointGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalespointGroupMutation, UpdateSalespointGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalespointGroupMutation, UpdateSalespointGroupMutationVariables>(UpdateSalespointGroupDocument, options);
      }
export type UpdateSalespointGroupMutationHookResult = ReturnType<typeof useUpdateSalespointGroupMutation>;
export type UpdateSalespointGroupMutationResult = Apollo.MutationResult<UpdateSalespointGroupMutation>;
export type UpdateSalespointGroupMutationOptions = Apollo.BaseMutationOptions<UpdateSalespointGroupMutation, UpdateSalespointGroupMutationVariables>;
export const ShopGeneralCategories_GetClientShopCategoriesOptionsDocument = gql`
    query ShopGeneralCategories_getClientShopCategoriesOptions {
  me {
    id
    client {
      id
      shopOptions {
        categories {
          enabled
          showAllProductsLinkEnabled
        }
      }
    }
  }
}
    `;

/**
 * __useShopGeneralCategories_GetClientShopCategoriesOptionsQuery__
 *
 * To run a query within a React component, call `useShopGeneralCategories_GetClientShopCategoriesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralCategories_GetClientShopCategoriesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopGeneralCategories_GetClientShopCategoriesOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopGeneralCategories_GetClientShopCategoriesOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ShopGeneralCategories_GetClientShopCategoriesOptionsQuery, ShopGeneralCategories_GetClientShopCategoriesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopGeneralCategories_GetClientShopCategoriesOptionsQuery, ShopGeneralCategories_GetClientShopCategoriesOptionsQueryVariables>(ShopGeneralCategories_GetClientShopCategoriesOptionsDocument, options);
      }
export function useShopGeneralCategories_GetClientShopCategoriesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopGeneralCategories_GetClientShopCategoriesOptionsQuery, ShopGeneralCategories_GetClientShopCategoriesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopGeneralCategories_GetClientShopCategoriesOptionsQuery, ShopGeneralCategories_GetClientShopCategoriesOptionsQueryVariables>(ShopGeneralCategories_GetClientShopCategoriesOptionsDocument, options);
        }
export type ShopGeneralCategories_GetClientShopCategoriesOptionsQueryHookResult = ReturnType<typeof useShopGeneralCategories_GetClientShopCategoriesOptionsQuery>;
export type ShopGeneralCategories_GetClientShopCategoriesOptionsLazyQueryHookResult = ReturnType<typeof useShopGeneralCategories_GetClientShopCategoriesOptionsLazyQuery>;
export type ShopGeneralCategories_GetClientShopCategoriesOptionsQueryResult = Apollo.QueryResult<ShopGeneralCategories_GetClientShopCategoriesOptionsQuery, ShopGeneralCategories_GetClientShopCategoriesOptionsQueryVariables>;
export const ShopGeneralCategories_UpdateClientShopCategoriesOptionsDocument = gql`
    mutation ShopGeneralCategories_updateClientShopCategoriesOptions($shopOptions: ShopOptionsInput!) {
  updateClientShopOptions(shopOptions: $shopOptions) {
    id
    shopOptions {
      categories {
        enabled
        showAllProductsLinkEnabled
      }
    }
  }
}
    `;
export type ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationFn = Apollo.MutationFunction<ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation, ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationVariables>;

/**
 * __useShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation__
 *
 * To run a mutation, you first call `useShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopGeneralCategoriesUpdateClientShopCategoriesOptionsMutation, { data, loading, error }] = useShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation({
 *   variables: {
 *      shopOptions: // value for 'shopOptions'
 *   },
 * });
 */
export function useShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation(baseOptions?: Apollo.MutationHookOptions<ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation, ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation, ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationVariables>(ShopGeneralCategories_UpdateClientShopCategoriesOptionsDocument, options);
      }
export type ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationHookResult = ReturnType<typeof useShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation>;
export type ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationResult = Apollo.MutationResult<ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation>;
export type ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationOptions = Apollo.BaseMutationOptions<ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutation, ShopGeneralCategories_UpdateClientShopCategoriesOptionsMutationVariables>;
export const ShopGeneralAddPayment_CreatePaymentMethodDocument = gql`
    mutation ShopGeneralAddPayment_createPaymentMethod($paymentMethod: PaymentMethodInput!) {
  createPaymentMethod(paymentMethod: $paymentMethod) {
    id
    type
    isSystem
    name
    salesPointGroupsCount
  }
}
    `;
export type ShopGeneralAddPayment_CreatePaymentMethodMutationFn = Apollo.MutationFunction<ShopGeneralAddPayment_CreatePaymentMethodMutation, ShopGeneralAddPayment_CreatePaymentMethodMutationVariables>;

/**
 * __useShopGeneralAddPayment_CreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useShopGeneralAddPayment_CreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralAddPayment_CreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopGeneralAddPaymentCreatePaymentMethodMutation, { data, loading, error }] = useShopGeneralAddPayment_CreatePaymentMethodMutation({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useShopGeneralAddPayment_CreatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<ShopGeneralAddPayment_CreatePaymentMethodMutation, ShopGeneralAddPayment_CreatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopGeneralAddPayment_CreatePaymentMethodMutation, ShopGeneralAddPayment_CreatePaymentMethodMutationVariables>(ShopGeneralAddPayment_CreatePaymentMethodDocument, options);
      }
export type ShopGeneralAddPayment_CreatePaymentMethodMutationHookResult = ReturnType<typeof useShopGeneralAddPayment_CreatePaymentMethodMutation>;
export type ShopGeneralAddPayment_CreatePaymentMethodMutationResult = Apollo.MutationResult<ShopGeneralAddPayment_CreatePaymentMethodMutation>;
export type ShopGeneralAddPayment_CreatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<ShopGeneralAddPayment_CreatePaymentMethodMutation, ShopGeneralAddPayment_CreatePaymentMethodMutationVariables>;
export const ShopGeneralPayment_DeletePaymentMethodDocument = gql`
    mutation ShopGeneralPayment_deletePaymentMethod($id: ID!) {
  deletePaymentMethod(id: $id) {
    id
    name
  }
}
    `;
export type ShopGeneralPayment_DeletePaymentMethodMutationFn = Apollo.MutationFunction<ShopGeneralPayment_DeletePaymentMethodMutation, ShopGeneralPayment_DeletePaymentMethodMutationVariables>;

/**
 * __useShopGeneralPayment_DeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useShopGeneralPayment_DeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralPayment_DeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopGeneralPaymentDeletePaymentMethodMutation, { data, loading, error }] = useShopGeneralPayment_DeletePaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShopGeneralPayment_DeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<ShopGeneralPayment_DeletePaymentMethodMutation, ShopGeneralPayment_DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopGeneralPayment_DeletePaymentMethodMutation, ShopGeneralPayment_DeletePaymentMethodMutationVariables>(ShopGeneralPayment_DeletePaymentMethodDocument, options);
      }
export type ShopGeneralPayment_DeletePaymentMethodMutationHookResult = ReturnType<typeof useShopGeneralPayment_DeletePaymentMethodMutation>;
export type ShopGeneralPayment_DeletePaymentMethodMutationResult = Apollo.MutationResult<ShopGeneralPayment_DeletePaymentMethodMutation>;
export type ShopGeneralPayment_DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<ShopGeneralPayment_DeletePaymentMethodMutation, ShopGeneralPayment_DeletePaymentMethodMutationVariables>;
export const ShopGeneralFormPayment_GetPaymentMethodByIdDocument = gql`
    query ShopGeneralFormPayment_getPaymentMethodById($id: ID!) {
  getPaymentMethodById(id: $id) {
    id
    isSystem
    type
    documentType
    name
    cartText
    salesPointGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useShopGeneralFormPayment_GetPaymentMethodByIdQuery__
 *
 * To run a query within a React component, call `useShopGeneralFormPayment_GetPaymentMethodByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralFormPayment_GetPaymentMethodByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopGeneralFormPayment_GetPaymentMethodByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShopGeneralFormPayment_GetPaymentMethodByIdQuery(baseOptions: Apollo.QueryHookOptions<ShopGeneralFormPayment_GetPaymentMethodByIdQuery, ShopGeneralFormPayment_GetPaymentMethodByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopGeneralFormPayment_GetPaymentMethodByIdQuery, ShopGeneralFormPayment_GetPaymentMethodByIdQueryVariables>(ShopGeneralFormPayment_GetPaymentMethodByIdDocument, options);
      }
export function useShopGeneralFormPayment_GetPaymentMethodByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopGeneralFormPayment_GetPaymentMethodByIdQuery, ShopGeneralFormPayment_GetPaymentMethodByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopGeneralFormPayment_GetPaymentMethodByIdQuery, ShopGeneralFormPayment_GetPaymentMethodByIdQueryVariables>(ShopGeneralFormPayment_GetPaymentMethodByIdDocument, options);
        }
export type ShopGeneralFormPayment_GetPaymentMethodByIdQueryHookResult = ReturnType<typeof useShopGeneralFormPayment_GetPaymentMethodByIdQuery>;
export type ShopGeneralFormPayment_GetPaymentMethodByIdLazyQueryHookResult = ReturnType<typeof useShopGeneralFormPayment_GetPaymentMethodByIdLazyQuery>;
export type ShopGeneralFormPayment_GetPaymentMethodByIdQueryResult = Apollo.QueryResult<ShopGeneralFormPayment_GetPaymentMethodByIdQuery, ShopGeneralFormPayment_GetPaymentMethodByIdQueryVariables>;
export const ShopGeneralAddPayment_SalesPointsGroupsDocument = gql`
    query ShopGeneralAddPayment_salesPointsGroups {
  salesPointsGroups {
    id
    name
  }
}
    `;

/**
 * __useShopGeneralAddPayment_SalesPointsGroupsQuery__
 *
 * To run a query within a React component, call `useShopGeneralAddPayment_SalesPointsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralAddPayment_SalesPointsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopGeneralAddPayment_SalesPointsGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopGeneralAddPayment_SalesPointsGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ShopGeneralAddPayment_SalesPointsGroupsQuery, ShopGeneralAddPayment_SalesPointsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopGeneralAddPayment_SalesPointsGroupsQuery, ShopGeneralAddPayment_SalesPointsGroupsQueryVariables>(ShopGeneralAddPayment_SalesPointsGroupsDocument, options);
      }
export function useShopGeneralAddPayment_SalesPointsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopGeneralAddPayment_SalesPointsGroupsQuery, ShopGeneralAddPayment_SalesPointsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopGeneralAddPayment_SalesPointsGroupsQuery, ShopGeneralAddPayment_SalesPointsGroupsQueryVariables>(ShopGeneralAddPayment_SalesPointsGroupsDocument, options);
        }
export type ShopGeneralAddPayment_SalesPointsGroupsQueryHookResult = ReturnType<typeof useShopGeneralAddPayment_SalesPointsGroupsQuery>;
export type ShopGeneralAddPayment_SalesPointsGroupsLazyQueryHookResult = ReturnType<typeof useShopGeneralAddPayment_SalesPointsGroupsLazyQuery>;
export type ShopGeneralAddPayment_SalesPointsGroupsQueryResult = Apollo.QueryResult<ShopGeneralAddPayment_SalesPointsGroupsQuery, ShopGeneralAddPayment_SalesPointsGroupsQueryVariables>;
export const ShopGeneralFormPayment_UpdatePaymentMethodDocument = gql`
    mutation ShopGeneralFormPayment_updatePaymentMethod($id: ID!, $paymentMethod: PaymentMethodInput!) {
  updatePaymentMethod(id: $id, paymentMethod: $paymentMethod) {
    id
    isSystem
    type
    documentType
    name
    cartText
    salesPointGroups {
      id
    }
  }
}
    `;
export type ShopGeneralFormPayment_UpdatePaymentMethodMutationFn = Apollo.MutationFunction<ShopGeneralFormPayment_UpdatePaymentMethodMutation, ShopGeneralFormPayment_UpdatePaymentMethodMutationVariables>;

/**
 * __useShopGeneralFormPayment_UpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useShopGeneralFormPayment_UpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralFormPayment_UpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopGeneralFormPaymentUpdatePaymentMethodMutation, { data, loading, error }] = useShopGeneralFormPayment_UpdatePaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useShopGeneralFormPayment_UpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<ShopGeneralFormPayment_UpdatePaymentMethodMutation, ShopGeneralFormPayment_UpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopGeneralFormPayment_UpdatePaymentMethodMutation, ShopGeneralFormPayment_UpdatePaymentMethodMutationVariables>(ShopGeneralFormPayment_UpdatePaymentMethodDocument, options);
      }
export type ShopGeneralFormPayment_UpdatePaymentMethodMutationHookResult = ReturnType<typeof useShopGeneralFormPayment_UpdatePaymentMethodMutation>;
export type ShopGeneralFormPayment_UpdatePaymentMethodMutationResult = Apollo.MutationResult<ShopGeneralFormPayment_UpdatePaymentMethodMutation>;
export type ShopGeneralFormPayment_UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<ShopGeneralFormPayment_UpdatePaymentMethodMutation, ShopGeneralFormPayment_UpdatePaymentMethodMutationVariables>;
export const ShopGeneralPayment_GetClientPaymentSettingsDocument = gql`
    query ShopGeneralPayment_getClientPaymentSettings {
  me {
    id
    client {
      id
      paymentMethods {
        id
        type
        isSystem
        name
        salesPointGroupsCount
      }
      shopOptions {
        displayTaxes
        defaultPaymentMethodId
        billingAddress {
          address
          additionalAddress
          company
          city
          country
          postalCode
        }
      }
    }
  }
}
    `;

/**
 * __useShopGeneralPayment_GetClientPaymentSettingsQuery__
 *
 * To run a query within a React component, call `useShopGeneralPayment_GetClientPaymentSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralPayment_GetClientPaymentSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopGeneralPayment_GetClientPaymentSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopGeneralPayment_GetClientPaymentSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ShopGeneralPayment_GetClientPaymentSettingsQuery, ShopGeneralPayment_GetClientPaymentSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopGeneralPayment_GetClientPaymentSettingsQuery, ShopGeneralPayment_GetClientPaymentSettingsQueryVariables>(ShopGeneralPayment_GetClientPaymentSettingsDocument, options);
      }
export function useShopGeneralPayment_GetClientPaymentSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopGeneralPayment_GetClientPaymentSettingsQuery, ShopGeneralPayment_GetClientPaymentSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopGeneralPayment_GetClientPaymentSettingsQuery, ShopGeneralPayment_GetClientPaymentSettingsQueryVariables>(ShopGeneralPayment_GetClientPaymentSettingsDocument, options);
        }
export type ShopGeneralPayment_GetClientPaymentSettingsQueryHookResult = ReturnType<typeof useShopGeneralPayment_GetClientPaymentSettingsQuery>;
export type ShopGeneralPayment_GetClientPaymentSettingsLazyQueryHookResult = ReturnType<typeof useShopGeneralPayment_GetClientPaymentSettingsLazyQuery>;
export type ShopGeneralPayment_GetClientPaymentSettingsQueryResult = Apollo.QueryResult<ShopGeneralPayment_GetClientPaymentSettingsQuery, ShopGeneralPayment_GetClientPaymentSettingsQueryVariables>;
export const ShopGeneralPayment_UpdateClientShopOptionsDocument = gql`
    mutation ShopGeneralPayment_updateClientShopOptions($shopOptions: ShopOptionsInput!) {
  updateClientShopOptions(shopOptions: $shopOptions) {
    id
    shopOptions {
      defaultPaymentMethodId
      displayTaxes
      displayStockAlert
      stockAlertRecipients {
        id
        fullName
      }
      billingAddress {
        address
        additionalAddress
        city
        country
        postalCode
      }
    }
  }
}
    `;
export type ShopGeneralPayment_UpdateClientShopOptionsMutationFn = Apollo.MutationFunction<ShopGeneralPayment_UpdateClientShopOptionsMutation, ShopGeneralPayment_UpdateClientShopOptionsMutationVariables>;

/**
 * __useShopGeneralPayment_UpdateClientShopOptionsMutation__
 *
 * To run a mutation, you first call `useShopGeneralPayment_UpdateClientShopOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralPayment_UpdateClientShopOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopGeneralPaymentUpdateClientShopOptionsMutation, { data, loading, error }] = useShopGeneralPayment_UpdateClientShopOptionsMutation({
 *   variables: {
 *      shopOptions: // value for 'shopOptions'
 *   },
 * });
 */
export function useShopGeneralPayment_UpdateClientShopOptionsMutation(baseOptions?: Apollo.MutationHookOptions<ShopGeneralPayment_UpdateClientShopOptionsMutation, ShopGeneralPayment_UpdateClientShopOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopGeneralPayment_UpdateClientShopOptionsMutation, ShopGeneralPayment_UpdateClientShopOptionsMutationVariables>(ShopGeneralPayment_UpdateClientShopOptionsDocument, options);
      }
export type ShopGeneralPayment_UpdateClientShopOptionsMutationHookResult = ReturnType<typeof useShopGeneralPayment_UpdateClientShopOptionsMutation>;
export type ShopGeneralPayment_UpdateClientShopOptionsMutationResult = Apollo.MutationResult<ShopGeneralPayment_UpdateClientShopOptionsMutation>;
export type ShopGeneralPayment_UpdateClientShopOptionsMutationOptions = Apollo.BaseMutationOptions<ShopGeneralPayment_UpdateClientShopOptionsMutation, ShopGeneralPayment_UpdateClientShopOptionsMutationVariables>;
export const ShopGeneralShippingFees_GetClientShopShippingFeesOptionsDocument = gql`
    query ShopGeneralShippingFees_getClientShopShippingFeesOptions {
  me {
    id
    client {
      id
      shopOptions {
        isShippingFeesEnabled
      }
    }
  }
}
    `;

/**
 * __useShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery__
 *
 * To run a query within a React component, call `useShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery, ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery, ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQueryVariables>(ShopGeneralShippingFees_GetClientShopShippingFeesOptionsDocument, options);
      }
export function useShopGeneralShippingFees_GetClientShopShippingFeesOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery, ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery, ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQueryVariables>(ShopGeneralShippingFees_GetClientShopShippingFeesOptionsDocument, options);
        }
export type ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQueryHookResult = ReturnType<typeof useShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery>;
export type ShopGeneralShippingFees_GetClientShopShippingFeesOptionsLazyQueryHookResult = ReturnType<typeof useShopGeneralShippingFees_GetClientShopShippingFeesOptionsLazyQuery>;
export type ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQueryResult = Apollo.QueryResult<ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQuery, ShopGeneralShippingFees_GetClientShopShippingFeesOptionsQueryVariables>;
export const ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionDocument = gql`
    mutation ShopGeneralShippingFees_updateClientShopShippingFeesOption($shopOptions: ShopOptionsInput!) {
  updateClientShopOptions(shopOptions: $shopOptions) {
    id
    shopOptions {
      isShippingFeesEnabled
    }
  }
}
    `;
export type ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationFn = Apollo.MutationFunction<ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation, ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationVariables>;

/**
 * __useShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation__
 *
 * To run a mutation, you first call `useShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopGeneralShippingFeesUpdateClientShopShippingFeesOptionMutation, { data, loading, error }] = useShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation({
 *   variables: {
 *      shopOptions: // value for 'shopOptions'
 *   },
 * });
 */
export function useShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation(baseOptions?: Apollo.MutationHookOptions<ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation, ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation, ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationVariables>(ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionDocument, options);
      }
export type ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationHookResult = ReturnType<typeof useShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation>;
export type ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationResult = Apollo.MutationResult<ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation>;
export type ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationOptions = Apollo.BaseMutationOptions<ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutation, ShopGeneralShippingFees_UpdateClientShopShippingFeesOptionMutationVariables>;
export const ShopGetClientStocksSettingsDocument = gql`
    query ShopGetClientStocksSettings {
  me {
    id
    client {
      id
      shopOptions {
        displayTaxes
        defaultPaymentMethodId
        displayStockAlert
        stockAlertRecipients {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useShopGetClientStocksSettingsQuery__
 *
 * To run a query within a React component, call `useShopGetClientStocksSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopGetClientStocksSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopGetClientStocksSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopGetClientStocksSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ShopGetClientStocksSettingsQuery, ShopGetClientStocksSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopGetClientStocksSettingsQuery, ShopGetClientStocksSettingsQueryVariables>(ShopGetClientStocksSettingsDocument, options);
      }
export function useShopGetClientStocksSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopGetClientStocksSettingsQuery, ShopGetClientStocksSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopGetClientStocksSettingsQuery, ShopGetClientStocksSettingsQueryVariables>(ShopGetClientStocksSettingsDocument, options);
        }
export type ShopGetClientStocksSettingsQueryHookResult = ReturnType<typeof useShopGetClientStocksSettingsQuery>;
export type ShopGetClientStocksSettingsLazyQueryHookResult = ReturnType<typeof useShopGetClientStocksSettingsLazyQuery>;
export type ShopGetClientStocksSettingsQueryResult = Apollo.QueryResult<ShopGetClientStocksSettingsQuery, ShopGetClientStocksSettingsQueryVariables>;
export const ShopGetUsersDocument = gql`
    query ShopGetUsers($filter: UserFilter) {
  users(filter: $filter) {
    users {
      id
      fullName
    }
  }
}
    `;

/**
 * __useShopGetUsersQuery__
 *
 * To run a query within a React component, call `useShopGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useShopGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<ShopGetUsersQuery, ShopGetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopGetUsersQuery, ShopGetUsersQueryVariables>(ShopGetUsersDocument, options);
      }
export function useShopGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopGetUsersQuery, ShopGetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopGetUsersQuery, ShopGetUsersQueryVariables>(ShopGetUsersDocument, options);
        }
export type ShopGetUsersQueryHookResult = ReturnType<typeof useShopGetUsersQuery>;
export type ShopGetUsersLazyQueryHookResult = ReturnType<typeof useShopGetUsersLazyQuery>;
export type ShopGetUsersQueryResult = Apollo.QueryResult<ShopGetUsersQuery, ShopGetUsersQueryVariables>;
export const AddAmplifyAccountsDocument = gql`
    mutation addAmplifyAccounts($networkReferers: [String!]!, $socialNetworkUser: Int!) {
  addAmplifyAccounts(networkReferers: $networkReferers, socialNetworkUser: $socialNetworkUser) {
    id
  }
}
    `;
export type AddAmplifyAccountsMutationFn = Apollo.MutationFunction<AddAmplifyAccountsMutation, AddAmplifyAccountsMutationVariables>;

/**
 * __useAddAmplifyAccountsMutation__
 *
 * To run a mutation, you first call `useAddAmplifyAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAmplifyAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAmplifyAccountsMutation, { data, loading, error }] = useAddAmplifyAccountsMutation({
 *   variables: {
 *      networkReferers: // value for 'networkReferers'
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *   },
 * });
 */
export function useAddAmplifyAccountsMutation(baseOptions?: Apollo.MutationHookOptions<AddAmplifyAccountsMutation, AddAmplifyAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAmplifyAccountsMutation, AddAmplifyAccountsMutationVariables>(AddAmplifyAccountsDocument, options);
      }
export type AddAmplifyAccountsMutationHookResult = ReturnType<typeof useAddAmplifyAccountsMutation>;
export type AddAmplifyAccountsMutationResult = Apollo.MutationResult<AddAmplifyAccountsMutation>;
export type AddAmplifyAccountsMutationOptions = Apollo.BaseMutationOptions<AddAmplifyAccountsMutation, AddAmplifyAccountsMutationVariables>;
export const DisconnectUserFromFacebookDocument = gql`
    mutation disconnectUserFromFacebook($socialNetworkUser: Int!) {
  disconnectUserFromFacebook(socialNetworkUser: $socialNetworkUser)
}
    `;
export type DisconnectUserFromFacebookMutationFn = Apollo.MutationFunction<DisconnectUserFromFacebookMutation, DisconnectUserFromFacebookMutationVariables>;

/**
 * __useDisconnectUserFromFacebookMutation__
 *
 * To run a mutation, you first call `useDisconnectUserFromFacebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectUserFromFacebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectUserFromFacebookMutation, { data, loading, error }] = useDisconnectUserFromFacebookMutation({
 *   variables: {
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *   },
 * });
 */
export function useDisconnectUserFromFacebookMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectUserFromFacebookMutation, DisconnectUserFromFacebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectUserFromFacebookMutation, DisconnectUserFromFacebookMutationVariables>(DisconnectUserFromFacebookDocument, options);
      }
export type DisconnectUserFromFacebookMutationHookResult = ReturnType<typeof useDisconnectUserFromFacebookMutation>;
export type DisconnectUserFromFacebookMutationResult = Apollo.MutationResult<DisconnectUserFromFacebookMutation>;
export type DisconnectUserFromFacebookMutationOptions = Apollo.BaseMutationOptions<DisconnectUserFromFacebookMutation, DisconnectUserFromFacebookMutationVariables>;
export const GetAccountsFromFacebookDocument = gql`
    query getAccountsFromFacebook($socialNetworkUser: Int!, $previousToken: String, $nextToken: String) {
  getAccountsFromFacebook(socialNetworkUser: $socialNetworkUser, previousToken: $previousToken, nextToken: $nextToken) {
    nextToken
    previousToken
    accounts {
      id
      name
      alreadyRecord
    }
  }
}
    `;

/**
 * __useGetAccountsFromFacebookQuery__
 *
 * To run a query within a React component, call `useGetAccountsFromFacebookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsFromFacebookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsFromFacebookQuery({
 *   variables: {
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *      previousToken: // value for 'previousToken'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetAccountsFromFacebookQuery(baseOptions: Apollo.QueryHookOptions<GetAccountsFromFacebookQuery, GetAccountsFromFacebookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsFromFacebookQuery, GetAccountsFromFacebookQueryVariables>(GetAccountsFromFacebookDocument, options);
      }
export function useGetAccountsFromFacebookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsFromFacebookQuery, GetAccountsFromFacebookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsFromFacebookQuery, GetAccountsFromFacebookQueryVariables>(GetAccountsFromFacebookDocument, options);
        }
export type GetAccountsFromFacebookQueryHookResult = ReturnType<typeof useGetAccountsFromFacebookQuery>;
export type GetAccountsFromFacebookLazyQueryHookResult = ReturnType<typeof useGetAccountsFromFacebookLazyQuery>;
export type GetAccountsFromFacebookQueryResult = Apollo.QueryResult<GetAccountsFromFacebookQuery, GetAccountsFromFacebookQueryVariables>;
export const GetAmplifyAccountFromSocialNetworkDocument = gql`
    query getAmplifyAccountFromSocialNetwork($socialNetworkUser: Int!, $previousToken: String, $nextToken: String) {
  getAmplifyAccountFromSocialNetwork(socialNetworkUser: $socialNetworkUser, previousToken: $previousToken, nextToken: $nextToken) {
    nextToken
    previousToken
    adAccounts {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAmplifyAccountFromSocialNetworkQuery__
 *
 * To run a query within a React component, call `useGetAmplifyAccountFromSocialNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmplifyAccountFromSocialNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmplifyAccountFromSocialNetworkQuery({
 *   variables: {
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *      previousToken: // value for 'previousToken'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetAmplifyAccountFromSocialNetworkQuery(baseOptions: Apollo.QueryHookOptions<GetAmplifyAccountFromSocialNetworkQuery, GetAmplifyAccountFromSocialNetworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmplifyAccountFromSocialNetworkQuery, GetAmplifyAccountFromSocialNetworkQueryVariables>(GetAmplifyAccountFromSocialNetworkDocument, options);
      }
export function useGetAmplifyAccountFromSocialNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmplifyAccountFromSocialNetworkQuery, GetAmplifyAccountFromSocialNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmplifyAccountFromSocialNetworkQuery, GetAmplifyAccountFromSocialNetworkQueryVariables>(GetAmplifyAccountFromSocialNetworkDocument, options);
        }
export type GetAmplifyAccountFromSocialNetworkQueryHookResult = ReturnType<typeof useGetAmplifyAccountFromSocialNetworkQuery>;
export type GetAmplifyAccountFromSocialNetworkLazyQueryHookResult = ReturnType<typeof useGetAmplifyAccountFromSocialNetworkLazyQuery>;
export type GetAmplifyAccountFromSocialNetworkQueryResult = Apollo.QueryResult<GetAmplifyAccountFromSocialNetworkQuery, GetAmplifyAccountFromSocialNetworkQueryVariables>;
export const UpdateMainAccountDocument = gql`
    mutation updateMainAccount($id: ID!) {
  updateMainAccount(id: $id)
}
    `;
export type UpdateMainAccountMutationFn = Apollo.MutationFunction<UpdateMainAccountMutation, UpdateMainAccountMutationVariables>;

/**
 * __useUpdateMainAccountMutation__
 *
 * To run a mutation, you first call `useUpdateMainAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMainAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMainAccountMutation, { data, loading, error }] = useUpdateMainAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMainAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMainAccountMutation, UpdateMainAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMainAccountMutation, UpdateMainAccountMutationVariables>(UpdateMainAccountDocument, options);
      }
export type UpdateMainAccountMutationHookResult = ReturnType<typeof useUpdateMainAccountMutation>;
export type UpdateMainAccountMutationResult = Apollo.MutationResult<UpdateMainAccountMutation>;
export type UpdateMainAccountMutationOptions = Apollo.BaseMutationOptions<UpdateMainAccountMutation, UpdateMainAccountMutationVariables>;
export const AddGoogleAccountsDocument = gql`
    mutation addGoogleAccounts($networkReferers: [String!]!, $socialNetworkUser: Int!) {
  addGoogleAccounts(networkReferers: $networkReferers, socialNetworkUser: $socialNetworkUser) {
    id
  }
}
    `;
export type AddGoogleAccountsMutationFn = Apollo.MutationFunction<AddGoogleAccountsMutation, AddGoogleAccountsMutationVariables>;

/**
 * __useAddGoogleAccountsMutation__
 *
 * To run a mutation, you first call `useAddGoogleAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGoogleAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGoogleAccountsMutation, { data, loading, error }] = useAddGoogleAccountsMutation({
 *   variables: {
 *      networkReferers: // value for 'networkReferers'
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *   },
 * });
 */
export function useAddGoogleAccountsMutation(baseOptions?: Apollo.MutationHookOptions<AddGoogleAccountsMutation, AddGoogleAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGoogleAccountsMutation, AddGoogleAccountsMutationVariables>(AddGoogleAccountsDocument, options);
      }
export type AddGoogleAccountsMutationHookResult = ReturnType<typeof useAddGoogleAccountsMutation>;
export type AddGoogleAccountsMutationResult = Apollo.MutationResult<AddGoogleAccountsMutation>;
export type AddGoogleAccountsMutationOptions = Apollo.BaseMutationOptions<AddGoogleAccountsMutation, AddGoogleAccountsMutationVariables>;
export const DisconnectUserFromGoogleDocument = gql`
    mutation disconnectUserFromGoogle($socialNetworkUser: Int!) {
  disconnectUserFromGoogle(socialNetworkUser: $socialNetworkUser)
}
    `;
export type DisconnectUserFromGoogleMutationFn = Apollo.MutationFunction<DisconnectUserFromGoogleMutation, DisconnectUserFromGoogleMutationVariables>;

/**
 * __useDisconnectUserFromGoogleMutation__
 *
 * To run a mutation, you first call `useDisconnectUserFromGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectUserFromGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectUserFromGoogleMutation, { data, loading, error }] = useDisconnectUserFromGoogleMutation({
 *   variables: {
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *   },
 * });
 */
export function useDisconnectUserFromGoogleMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectUserFromGoogleMutation, DisconnectUserFromGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectUserFromGoogleMutation, DisconnectUserFromGoogleMutationVariables>(DisconnectUserFromGoogleDocument, options);
      }
export type DisconnectUserFromGoogleMutationHookResult = ReturnType<typeof useDisconnectUserFromGoogleMutation>;
export type DisconnectUserFromGoogleMutationResult = Apollo.MutationResult<DisconnectUserFromGoogleMutation>;
export type DisconnectUserFromGoogleMutationOptions = Apollo.BaseMutationOptions<DisconnectUserFromGoogleMutation, DisconnectUserFromGoogleMutationVariables>;
export const GetAvailableGoogleAccountsDocument = gql`
    query getAvailableGoogleAccounts($groupId: ID!, $socialNetworkUser: Int!, $token: String, $keyword: String) {
  getAvailableGoogleAccounts(groupId: $groupId, socialNetworkUser: $socialNetworkUser, token: $token, keyword: $keyword) {
    nextToken
    previousToken
    socialNetworkAccounts {
      id
      name
      alreadyRecord
      networkReferer
    }
  }
}
    `;

/**
 * __useGetAvailableGoogleAccountsQuery__
 *
 * To run a query within a React component, call `useGetAvailableGoogleAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableGoogleAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableGoogleAccountsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *      token: // value for 'token'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useGetAvailableGoogleAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableGoogleAccountsQuery, GetAvailableGoogleAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableGoogleAccountsQuery, GetAvailableGoogleAccountsQueryVariables>(GetAvailableGoogleAccountsDocument, options);
      }
export function useGetAvailableGoogleAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableGoogleAccountsQuery, GetAvailableGoogleAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableGoogleAccountsQuery, GetAvailableGoogleAccountsQueryVariables>(GetAvailableGoogleAccountsDocument, options);
        }
export type GetAvailableGoogleAccountsQueryHookResult = ReturnType<typeof useGetAvailableGoogleAccountsQuery>;
export type GetAvailableGoogleAccountsLazyQueryHookResult = ReturnType<typeof useGetAvailableGoogleAccountsLazyQuery>;
export type GetAvailableGoogleAccountsQueryResult = Apollo.QueryResult<GetAvailableGoogleAccountsQuery, GetAvailableGoogleAccountsQueryVariables>;
export const GetGoogleAccountsGroupsDocument = gql`
    query getGoogleAccountsGroups($socialNetworkUser: Int!) {
  getGoogleAccountsGroups(socialNetworkUser: $socialNetworkUser) {
    networkReferer
    name
    type
  }
}
    `;

/**
 * __useGetGoogleAccountsGroupsQuery__
 *
 * To run a query within a React component, call `useGetGoogleAccountsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleAccountsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleAccountsGroupsQuery({
 *   variables: {
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *   },
 * });
 */
export function useGetGoogleAccountsGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetGoogleAccountsGroupsQuery, GetGoogleAccountsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoogleAccountsGroupsQuery, GetGoogleAccountsGroupsQueryVariables>(GetGoogleAccountsGroupsDocument, options);
      }
export function useGetGoogleAccountsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoogleAccountsGroupsQuery, GetGoogleAccountsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoogleAccountsGroupsQuery, GetGoogleAccountsGroupsQueryVariables>(GetGoogleAccountsGroupsDocument, options);
        }
export type GetGoogleAccountsGroupsQueryHookResult = ReturnType<typeof useGetGoogleAccountsGroupsQuery>;
export type GetGoogleAccountsGroupsLazyQueryHookResult = ReturnType<typeof useGetGoogleAccountsGroupsLazyQuery>;
export type GetGoogleAccountsGroupsQueryResult = Apollo.QueryResult<GetGoogleAccountsGroupsQuery, GetGoogleAccountsGroupsQueryVariables>;
export const AddLinkedinAccountsDocument = gql`
    mutation addLinkedinAccounts($networkReferers: [String!]!, $socialNetworkUser: Int!) {
  addLinkedinAccounts(networkReferers: $networkReferers, socialNetworkUser: $socialNetworkUser) {
    id
  }
}
    `;
export type AddLinkedinAccountsMutationFn = Apollo.MutationFunction<AddLinkedinAccountsMutation, AddLinkedinAccountsMutationVariables>;

/**
 * __useAddLinkedinAccountsMutation__
 *
 * To run a mutation, you first call `useAddLinkedinAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLinkedinAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLinkedinAccountsMutation, { data, loading, error }] = useAddLinkedinAccountsMutation({
 *   variables: {
 *      networkReferers: // value for 'networkReferers'
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *   },
 * });
 */
export function useAddLinkedinAccountsMutation(baseOptions?: Apollo.MutationHookOptions<AddLinkedinAccountsMutation, AddLinkedinAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLinkedinAccountsMutation, AddLinkedinAccountsMutationVariables>(AddLinkedinAccountsDocument, options);
      }
export type AddLinkedinAccountsMutationHookResult = ReturnType<typeof useAddLinkedinAccountsMutation>;
export type AddLinkedinAccountsMutationResult = Apollo.MutationResult<AddLinkedinAccountsMutation>;
export type AddLinkedinAccountsMutationOptions = Apollo.BaseMutationOptions<AddLinkedinAccountsMutation, AddLinkedinAccountsMutationVariables>;
export const DisconnectUserFromLinkedinDocument = gql`
    mutation disconnectUserFromLinkedin($socialNetworkUser: Int!) {
  disconnectUserFromLinkedin(socialNetworkUser: $socialNetworkUser)
}
    `;
export type DisconnectUserFromLinkedinMutationFn = Apollo.MutationFunction<DisconnectUserFromLinkedinMutation, DisconnectUserFromLinkedinMutationVariables>;

/**
 * __useDisconnectUserFromLinkedinMutation__
 *
 * To run a mutation, you first call `useDisconnectUserFromLinkedinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectUserFromLinkedinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectUserFromLinkedinMutation, { data, loading, error }] = useDisconnectUserFromLinkedinMutation({
 *   variables: {
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *   },
 * });
 */
export function useDisconnectUserFromLinkedinMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectUserFromLinkedinMutation, DisconnectUserFromLinkedinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectUserFromLinkedinMutation, DisconnectUserFromLinkedinMutationVariables>(DisconnectUserFromLinkedinDocument, options);
      }
export type DisconnectUserFromLinkedinMutationHookResult = ReturnType<typeof useDisconnectUserFromLinkedinMutation>;
export type DisconnectUserFromLinkedinMutationResult = Apollo.MutationResult<DisconnectUserFromLinkedinMutation>;
export type DisconnectUserFromLinkedinMutationOptions = Apollo.BaseMutationOptions<DisconnectUserFromLinkedinMutation, DisconnectUserFromLinkedinMutationVariables>;
export const GetAccountsFromLinkedinDocument = gql`
    query getAccountsFromLinkedin($socialNetworkUser: Int!) {
  getAccountsFromLinkedin(socialNetworkUser: $socialNetworkUser) {
    accounts {
      id
      name
      alreadyRecord
    }
  }
}
    `;

/**
 * __useGetAccountsFromLinkedinQuery__
 *
 * To run a query within a React component, call `useGetAccountsFromLinkedinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsFromLinkedinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsFromLinkedinQuery({
 *   variables: {
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *   },
 * });
 */
export function useGetAccountsFromLinkedinQuery(baseOptions: Apollo.QueryHookOptions<GetAccountsFromLinkedinQuery, GetAccountsFromLinkedinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsFromLinkedinQuery, GetAccountsFromLinkedinQueryVariables>(GetAccountsFromLinkedinDocument, options);
      }
export function useGetAccountsFromLinkedinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsFromLinkedinQuery, GetAccountsFromLinkedinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsFromLinkedinQuery, GetAccountsFromLinkedinQueryVariables>(GetAccountsFromLinkedinDocument, options);
        }
export type GetAccountsFromLinkedinQueryHookResult = ReturnType<typeof useGetAccountsFromLinkedinQuery>;
export type GetAccountsFromLinkedinLazyQueryHookResult = ReturnType<typeof useGetAccountsFromLinkedinLazyQuery>;
export type GetAccountsFromLinkedinQueryResult = Apollo.QueryResult<GetAccountsFromLinkedinQuery, GetAccountsFromLinkedinQueryVariables>;
export const AddFacebookAccountDocument = gql`
    mutation addFacebookAccount($url: String, $networkReferers: [String!], $socialNetworkUser: Int!, $systemUser: Boolean) {
  addFacebookAccount(url: $url, networkReferers: $networkReferers, socialNetworkUser: $socialNetworkUser, systemUser: $systemUser) {
    id
  }
}
    `;
export type AddFacebookAccountMutationFn = Apollo.MutationFunction<AddFacebookAccountMutation, AddFacebookAccountMutationVariables>;

/**
 * __useAddFacebookAccountMutation__
 *
 * To run a mutation, you first call `useAddFacebookAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFacebookAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFacebookAccountMutation, { data, loading, error }] = useAddFacebookAccountMutation({
 *   variables: {
 *      url: // value for 'url'
 *      networkReferers: // value for 'networkReferers'
 *      socialNetworkUser: // value for 'socialNetworkUser'
 *      systemUser: // value for 'systemUser'
 *   },
 * });
 */
export function useAddFacebookAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddFacebookAccountMutation, AddFacebookAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFacebookAccountMutation, AddFacebookAccountMutationVariables>(AddFacebookAccountDocument, options);
      }
export type AddFacebookAccountMutationHookResult = ReturnType<typeof useAddFacebookAccountMutation>;
export type AddFacebookAccountMutationResult = Apollo.MutationResult<AddFacebookAccountMutation>;
export type AddFacebookAccountMutationOptions = Apollo.BaseMutationOptions<AddFacebookAccountMutation, AddFacebookAccountMutationVariables>;
export const RefreshFacebookAccountsDocument = gql`
    mutation refreshFacebookAccounts($accountIds: [ID!]!) {
  refreshFacebookAccounts(accountIds: $accountIds)
}
    `;
export type RefreshFacebookAccountsMutationFn = Apollo.MutationFunction<RefreshFacebookAccountsMutation, RefreshFacebookAccountsMutationVariables>;

/**
 * __useRefreshFacebookAccountsMutation__
 *
 * To run a mutation, you first call `useRefreshFacebookAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshFacebookAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshFacebookAccountsMutation, { data, loading, error }] = useRefreshFacebookAccountsMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useRefreshFacebookAccountsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshFacebookAccountsMutation, RefreshFacebookAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshFacebookAccountsMutation, RefreshFacebookAccountsMutationVariables>(RefreshFacebookAccountsDocument, options);
      }
export type RefreshFacebookAccountsMutationHookResult = ReturnType<typeof useRefreshFacebookAccountsMutation>;
export type RefreshFacebookAccountsMutationResult = Apollo.MutationResult<RefreshFacebookAccountsMutation>;
export type RefreshFacebookAccountsMutationOptions = Apollo.BaseMutationOptions<RefreshFacebookAccountsMutation, RefreshFacebookAccountsMutationVariables>;
export const DeleteAmplifyAccountsDocument = gql`
    mutation deleteAmplifyAccounts($accountIds: [ID!]!) {
  deleteAmplifyAccounts(accountIds: $accountIds) {
    success
    partialSuccess
  }
}
    `;
export type DeleteAmplifyAccountsMutationFn = Apollo.MutationFunction<DeleteAmplifyAccountsMutation, DeleteAmplifyAccountsMutationVariables>;

/**
 * __useDeleteAmplifyAccountsMutation__
 *
 * To run a mutation, you first call `useDeleteAmplifyAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAmplifyAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAmplifyAccountsMutation, { data, loading, error }] = useDeleteAmplifyAccountsMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useDeleteAmplifyAccountsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAmplifyAccountsMutation, DeleteAmplifyAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAmplifyAccountsMutation, DeleteAmplifyAccountsMutationVariables>(DeleteAmplifyAccountsDocument, options);
      }
export type DeleteAmplifyAccountsMutationHookResult = ReturnType<typeof useDeleteAmplifyAccountsMutation>;
export type DeleteAmplifyAccountsMutationResult = Apollo.MutationResult<DeleteAmplifyAccountsMutation>;
export type DeleteAmplifyAccountsMutationOptions = Apollo.BaseMutationOptions<DeleteAmplifyAccountsMutation, DeleteAmplifyAccountsMutationVariables>;
export const DeleteSocialNetworkAccountsDocument = gql`
    mutation deleteSocialNetworkAccounts($accountIds: [ID!]!, $socialNetwork: SocialNetwork!) {
  deleteSocialNetworkAccounts(accountIds: $accountIds, socialNetwork: $socialNetwork) {
    success
    partialSuccess
  }
}
    `;
export type DeleteSocialNetworkAccountsMutationFn = Apollo.MutationFunction<DeleteSocialNetworkAccountsMutation, DeleteSocialNetworkAccountsMutationVariables>;

/**
 * __useDeleteSocialNetworkAccountsMutation__
 *
 * To run a mutation, you first call `useDeleteSocialNetworkAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialNetworkAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocialNetworkAccountsMutation, { data, loading, error }] = useDeleteSocialNetworkAccountsMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *      socialNetwork: // value for 'socialNetwork'
 *   },
 * });
 */
export function useDeleteSocialNetworkAccountsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSocialNetworkAccountsMutation, DeleteSocialNetworkAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSocialNetworkAccountsMutation, DeleteSocialNetworkAccountsMutationVariables>(DeleteSocialNetworkAccountsDocument, options);
      }
export type DeleteSocialNetworkAccountsMutationHookResult = ReturnType<typeof useDeleteSocialNetworkAccountsMutation>;
export type DeleteSocialNetworkAccountsMutationResult = Apollo.MutationResult<DeleteSocialNetworkAccountsMutation>;
export type DeleteSocialNetworkAccountsMutationOptions = Apollo.BaseMutationOptions<DeleteSocialNetworkAccountsMutation, DeleteSocialNetworkAccountsMutationVariables>;
export const GetSocialNetworkSsoLinkDocument = gql`
    query getSocialNetworkSSOLink($socialNetwork: SocialNetwork!, $redirectURL: String!) {
  getSocialNetworkSSOLink(socialNetwork: $socialNetwork, redirectURL: $redirectURL)
}
    `;

/**
 * __useGetSocialNetworkSsoLinkQuery__
 *
 * To run a query within a React component, call `useGetSocialNetworkSsoLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialNetworkSsoLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialNetworkSsoLinkQuery({
 *   variables: {
 *      socialNetwork: // value for 'socialNetwork'
 *      redirectURL: // value for 'redirectURL'
 *   },
 * });
 */
export function useGetSocialNetworkSsoLinkQuery(baseOptions: Apollo.QueryHookOptions<GetSocialNetworkSsoLinkQuery, GetSocialNetworkSsoLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialNetworkSsoLinkQuery, GetSocialNetworkSsoLinkQueryVariables>(GetSocialNetworkSsoLinkDocument, options);
      }
export function useGetSocialNetworkSsoLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialNetworkSsoLinkQuery, GetSocialNetworkSsoLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialNetworkSsoLinkQuery, GetSocialNetworkSsoLinkQueryVariables>(GetSocialNetworkSsoLinkDocument, options);
        }
export type GetSocialNetworkSsoLinkQueryHookResult = ReturnType<typeof useGetSocialNetworkSsoLinkQuery>;
export type GetSocialNetworkSsoLinkLazyQueryHookResult = ReturnType<typeof useGetSocialNetworkSsoLinkLazyQuery>;
export type GetSocialNetworkSsoLinkQueryResult = Apollo.QueryResult<GetSocialNetworkSsoLinkQuery, GetSocialNetworkSsoLinkQueryVariables>;
export const GetAmplifyGlobalAccountDocument = gql`
    query getAmplifyGlobalAccount($label: String!) {
  getAmplifyGlobalAccount(label: $label) {
    id
    name
    isActive
    isLinked
    networkReferer
    url
  }
}
    `;

/**
 * __useGetAmplifyGlobalAccountQuery__
 *
 * To run a query within a React component, call `useGetAmplifyGlobalAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmplifyGlobalAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmplifyGlobalAccountQuery({
 *   variables: {
 *      label: // value for 'label'
 *   },
 * });
 */
export function useGetAmplifyGlobalAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAmplifyGlobalAccountQuery, GetAmplifyGlobalAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmplifyGlobalAccountQuery, GetAmplifyGlobalAccountQueryVariables>(GetAmplifyGlobalAccountDocument, options);
      }
export function useGetAmplifyGlobalAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmplifyGlobalAccountQuery, GetAmplifyGlobalAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmplifyGlobalAccountQuery, GetAmplifyGlobalAccountQueryVariables>(GetAmplifyGlobalAccountDocument, options);
        }
export type GetAmplifyGlobalAccountQueryHookResult = ReturnType<typeof useGetAmplifyGlobalAccountQuery>;
export type GetAmplifyGlobalAccountLazyQueryHookResult = ReturnType<typeof useGetAmplifyGlobalAccountLazyQuery>;
export type GetAmplifyGlobalAccountQueryResult = Apollo.QueryResult<GetAmplifyGlobalAccountQuery, GetAmplifyGlobalAccountQueryVariables>;
export const GetInstagramUrlDocument = gql`
    query getInstagramUrl($label: String!) {
  getSocialNetworkGlobalAccount(socialNetwork: instagram, label: $label) {
    url
  }
}
    `;

/**
 * __useGetInstagramUrlQuery__
 *
 * To run a query within a React component, call `useGetInstagramUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstagramUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstagramUrlQuery({
 *   variables: {
 *      label: // value for 'label'
 *   },
 * });
 */
export function useGetInstagramUrlQuery(baseOptions: Apollo.QueryHookOptions<GetInstagramUrlQuery, GetInstagramUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstagramUrlQuery, GetInstagramUrlQueryVariables>(GetInstagramUrlDocument, options);
      }
export function useGetInstagramUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstagramUrlQuery, GetInstagramUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstagramUrlQuery, GetInstagramUrlQueryVariables>(GetInstagramUrlDocument, options);
        }
export type GetInstagramUrlQueryHookResult = ReturnType<typeof useGetInstagramUrlQuery>;
export type GetInstagramUrlLazyQueryHookResult = ReturnType<typeof useGetInstagramUrlLazyQuery>;
export type GetInstagramUrlQueryResult = Apollo.QueryResult<GetInstagramUrlQuery, GetInstagramUrlQueryVariables>;
export const GetSocialNetworkGlobalAccountDocument = gql`
    query getSocialNetworkGlobalAccount($socialNetwork: SocialNetwork!, $label: String!) {
  getSocialNetworkGlobalAccount(socialNetwork: $socialNetwork, label: $label) {
    id
    name
    isActive
    isLinked
    networkReferer
    url
    haveInstagramAccount
  }
}
    `;

/**
 * __useGetSocialNetworkGlobalAccountQuery__
 *
 * To run a query within a React component, call `useGetSocialNetworkGlobalAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialNetworkGlobalAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialNetworkGlobalAccountQuery({
 *   variables: {
 *      socialNetwork: // value for 'socialNetwork'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useGetSocialNetworkGlobalAccountQuery(baseOptions: Apollo.QueryHookOptions<GetSocialNetworkGlobalAccountQuery, GetSocialNetworkGlobalAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialNetworkGlobalAccountQuery, GetSocialNetworkGlobalAccountQueryVariables>(GetSocialNetworkGlobalAccountDocument, options);
      }
export function useGetSocialNetworkGlobalAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialNetworkGlobalAccountQuery, GetSocialNetworkGlobalAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialNetworkGlobalAccountQuery, GetSocialNetworkGlobalAccountQueryVariables>(GetSocialNetworkGlobalAccountDocument, options);
        }
export type GetSocialNetworkGlobalAccountQueryHookResult = ReturnType<typeof useGetSocialNetworkGlobalAccountQuery>;
export type GetSocialNetworkGlobalAccountLazyQueryHookResult = ReturnType<typeof useGetSocialNetworkGlobalAccountLazyQuery>;
export type GetSocialNetworkGlobalAccountQueryResult = Apollo.QueryResult<GetSocialNetworkGlobalAccountQuery, GetSocialNetworkGlobalAccountQueryVariables>;
export const LinkGlobalAmplifyAccountDocument = gql`
    mutation linkGlobalAmplifyAccount($accountId: ID!, $label: String!) {
  linkGlobalAmplifyAccount(accountId: $accountId, label: $label)
}
    `;
export type LinkGlobalAmplifyAccountMutationFn = Apollo.MutationFunction<LinkGlobalAmplifyAccountMutation, LinkGlobalAmplifyAccountMutationVariables>;

/**
 * __useLinkGlobalAmplifyAccountMutation__
 *
 * To run a mutation, you first call `useLinkGlobalAmplifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkGlobalAmplifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkGlobalAmplifyAccountMutation, { data, loading, error }] = useLinkGlobalAmplifyAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useLinkGlobalAmplifyAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkGlobalAmplifyAccountMutation, LinkGlobalAmplifyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkGlobalAmplifyAccountMutation, LinkGlobalAmplifyAccountMutationVariables>(LinkGlobalAmplifyAccountDocument, options);
      }
export type LinkGlobalAmplifyAccountMutationHookResult = ReturnType<typeof useLinkGlobalAmplifyAccountMutation>;
export type LinkGlobalAmplifyAccountMutationResult = Apollo.MutationResult<LinkGlobalAmplifyAccountMutation>;
export type LinkGlobalAmplifyAccountMutationOptions = Apollo.BaseMutationOptions<LinkGlobalAmplifyAccountMutation, LinkGlobalAmplifyAccountMutationVariables>;
export const LinkGlobalSocialNetworkAccountDocument = gql`
    mutation linkGlobalSocialNetworkAccount($accountId: ID!, $label: String!, $socialNetwork: SocialNetwork!) {
  linkGlobalSocialNetworkAccount(accountId: $accountId, label: $label, socialNetwork: $socialNetwork)
}
    `;
export type LinkGlobalSocialNetworkAccountMutationFn = Apollo.MutationFunction<LinkGlobalSocialNetworkAccountMutation, LinkGlobalSocialNetworkAccountMutationVariables>;

/**
 * __useLinkGlobalSocialNetworkAccountMutation__
 *
 * To run a mutation, you first call `useLinkGlobalSocialNetworkAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkGlobalSocialNetworkAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkGlobalSocialNetworkAccountMutation, { data, loading, error }] = useLinkGlobalSocialNetworkAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      label: // value for 'label'
 *      socialNetwork: // value for 'socialNetwork'
 *   },
 * });
 */
export function useLinkGlobalSocialNetworkAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkGlobalSocialNetworkAccountMutation, LinkGlobalSocialNetworkAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkGlobalSocialNetworkAccountMutation, LinkGlobalSocialNetworkAccountMutationVariables>(LinkGlobalSocialNetworkAccountDocument, options);
      }
export type LinkGlobalSocialNetworkAccountMutationHookResult = ReturnType<typeof useLinkGlobalSocialNetworkAccountMutation>;
export type LinkGlobalSocialNetworkAccountMutationResult = Apollo.MutationResult<LinkGlobalSocialNetworkAccountMutation>;
export type LinkGlobalSocialNetworkAccountMutationOptions = Apollo.BaseMutationOptions<LinkGlobalSocialNetworkAccountMutation, LinkGlobalSocialNetworkAccountMutationVariables>;
export const UnlinkGlobalAmplifyAccountDocument = gql`
    mutation unlinkGlobalAmplifyAccount($label: String!) {
  unlinkGlobalAmplifyAccount(label: $label)
}
    `;
export type UnlinkGlobalAmplifyAccountMutationFn = Apollo.MutationFunction<UnlinkGlobalAmplifyAccountMutation, UnlinkGlobalAmplifyAccountMutationVariables>;

/**
 * __useUnlinkGlobalAmplifyAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkGlobalAmplifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkGlobalAmplifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkGlobalAmplifyAccountMutation, { data, loading, error }] = useUnlinkGlobalAmplifyAccountMutation({
 *   variables: {
 *      label: // value for 'label'
 *   },
 * });
 */
export function useUnlinkGlobalAmplifyAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkGlobalAmplifyAccountMutation, UnlinkGlobalAmplifyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkGlobalAmplifyAccountMutation, UnlinkGlobalAmplifyAccountMutationVariables>(UnlinkGlobalAmplifyAccountDocument, options);
      }
export type UnlinkGlobalAmplifyAccountMutationHookResult = ReturnType<typeof useUnlinkGlobalAmplifyAccountMutation>;
export type UnlinkGlobalAmplifyAccountMutationResult = Apollo.MutationResult<UnlinkGlobalAmplifyAccountMutation>;
export type UnlinkGlobalAmplifyAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkGlobalAmplifyAccountMutation, UnlinkGlobalAmplifyAccountMutationVariables>;
export const UnlinkGlobalSocialNetworkAccountDocument = gql`
    mutation unlinkGlobalSocialNetworkAccount($label: String!, $socialNetwork: SocialNetwork!) {
  unlinkGlobalSocialNetworkAccount(label: $label, socialNetwork: $socialNetwork)
}
    `;
export type UnlinkGlobalSocialNetworkAccountMutationFn = Apollo.MutationFunction<UnlinkGlobalSocialNetworkAccountMutation, UnlinkGlobalSocialNetworkAccountMutationVariables>;

/**
 * __useUnlinkGlobalSocialNetworkAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkGlobalSocialNetworkAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkGlobalSocialNetworkAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkGlobalSocialNetworkAccountMutation, { data, loading, error }] = useUnlinkGlobalSocialNetworkAccountMutation({
 *   variables: {
 *      label: // value for 'label'
 *      socialNetwork: // value for 'socialNetwork'
 *   },
 * });
 */
export function useUnlinkGlobalSocialNetworkAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkGlobalSocialNetworkAccountMutation, UnlinkGlobalSocialNetworkAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkGlobalSocialNetworkAccountMutation, UnlinkGlobalSocialNetworkAccountMutationVariables>(UnlinkGlobalSocialNetworkAccountDocument, options);
      }
export type UnlinkGlobalSocialNetworkAccountMutationHookResult = ReturnType<typeof useUnlinkGlobalSocialNetworkAccountMutation>;
export type UnlinkGlobalSocialNetworkAccountMutationResult = Apollo.MutationResult<UnlinkGlobalSocialNetworkAccountMutation>;
export type UnlinkGlobalSocialNetworkAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkGlobalSocialNetworkAccountMutation, UnlinkGlobalSocialNetworkAccountMutationVariables>;
export const AddTwitterAccountDocument = gql`
    mutation addTwitterAccount($redirectURL: String!, $oauthToken: String!, $oauthVerifier: String!) {
  addTwitterAccount(redirectURL: $redirectURL, oauthToken: $oauthToken, oauthVerifier: $oauthVerifier) {
    id
  }
}
    `;
export type AddTwitterAccountMutationFn = Apollo.MutationFunction<AddTwitterAccountMutation, AddTwitterAccountMutationVariables>;

/**
 * __useAddTwitterAccountMutation__
 *
 * To run a mutation, you first call `useAddTwitterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTwitterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTwitterAccountMutation, { data, loading, error }] = useAddTwitterAccountMutation({
 *   variables: {
 *      redirectURL: // value for 'redirectURL'
 *      oauthToken: // value for 'oauthToken'
 *      oauthVerifier: // value for 'oauthVerifier'
 *   },
 * });
 */
export function useAddTwitterAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddTwitterAccountMutation, AddTwitterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTwitterAccountMutation, AddTwitterAccountMutationVariables>(AddTwitterAccountDocument, options);
      }
export type AddTwitterAccountMutationHookResult = ReturnType<typeof useAddTwitterAccountMutation>;
export type AddTwitterAccountMutationResult = Apollo.MutationResult<AddTwitterAccountMutation>;
export type AddTwitterAccountMutationOptions = Apollo.BaseMutationOptions<AddTwitterAccountMutation, AddTwitterAccountMutationVariables>;
export const ConnectUserToFacebookDocument = gql`
    mutation connectUserToFacebook($code: String!, $accountType: String!, $redirectURL: String!) {
  connectUserToFacebook(code: $code, accountType: $accountType, redirectURL: $redirectURL) {
    username
    isTokenValid
    connected
    accountType
    id
    socialNetwork
  }
}
    `;
export type ConnectUserToFacebookMutationFn = Apollo.MutationFunction<ConnectUserToFacebookMutation, ConnectUserToFacebookMutationVariables>;

/**
 * __useConnectUserToFacebookMutation__
 *
 * To run a mutation, you first call `useConnectUserToFacebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectUserToFacebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectUserToFacebookMutation, { data, loading, error }] = useConnectUserToFacebookMutation({
 *   variables: {
 *      code: // value for 'code'
 *      accountType: // value for 'accountType'
 *      redirectURL: // value for 'redirectURL'
 *   },
 * });
 */
export function useConnectUserToFacebookMutation(baseOptions?: Apollo.MutationHookOptions<ConnectUserToFacebookMutation, ConnectUserToFacebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectUserToFacebookMutation, ConnectUserToFacebookMutationVariables>(ConnectUserToFacebookDocument, options);
      }
export type ConnectUserToFacebookMutationHookResult = ReturnType<typeof useConnectUserToFacebookMutation>;
export type ConnectUserToFacebookMutationResult = Apollo.MutationResult<ConnectUserToFacebookMutation>;
export type ConnectUserToFacebookMutationOptions = Apollo.BaseMutationOptions<ConnectUserToFacebookMutation, ConnectUserToFacebookMutationVariables>;
export const ConnectUserToGoogleDocument = gql`
    mutation connectUserToGoogle($code: String!, $accountType: String!, $redirectURL: String!) {
  connectUserToGoogle(code: $code, accountType: $accountType, redirectURL: $redirectURL) {
    username
    isTokenValid
    connected
    accountType
    id
    socialNetwork
  }
}
    `;
export type ConnectUserToGoogleMutationFn = Apollo.MutationFunction<ConnectUserToGoogleMutation, ConnectUserToGoogleMutationVariables>;

/**
 * __useConnectUserToGoogleMutation__
 *
 * To run a mutation, you first call `useConnectUserToGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectUserToGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectUserToGoogleMutation, { data, loading, error }] = useConnectUserToGoogleMutation({
 *   variables: {
 *      code: // value for 'code'
 *      accountType: // value for 'accountType'
 *      redirectURL: // value for 'redirectURL'
 *   },
 * });
 */
export function useConnectUserToGoogleMutation(baseOptions?: Apollo.MutationHookOptions<ConnectUserToGoogleMutation, ConnectUserToGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectUserToGoogleMutation, ConnectUserToGoogleMutationVariables>(ConnectUserToGoogleDocument, options);
      }
export type ConnectUserToGoogleMutationHookResult = ReturnType<typeof useConnectUserToGoogleMutation>;
export type ConnectUserToGoogleMutationResult = Apollo.MutationResult<ConnectUserToGoogleMutation>;
export type ConnectUserToGoogleMutationOptions = Apollo.BaseMutationOptions<ConnectUserToGoogleMutation, ConnectUserToGoogleMutationVariables>;
export const ConnectUserToLinkedinDocument = gql`
    mutation connectUserToLinkedin($code: String!, $accountType: String!, $redirectURL: String!, $state: String!) {
  connectUserToLinkedin(code: $code, accountType: $accountType, redirectURL: $redirectURL, state: $state) {
    username
    isTokenValid
    connected
    accountType
    id
    socialNetwork
  }
}
    `;
export type ConnectUserToLinkedinMutationFn = Apollo.MutationFunction<ConnectUserToLinkedinMutation, ConnectUserToLinkedinMutationVariables>;

/**
 * __useConnectUserToLinkedinMutation__
 *
 * To run a mutation, you first call `useConnectUserToLinkedinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectUserToLinkedinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectUserToLinkedinMutation, { data, loading, error }] = useConnectUserToLinkedinMutation({
 *   variables: {
 *      code: // value for 'code'
 *      accountType: // value for 'accountType'
 *      redirectURL: // value for 'redirectURL'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useConnectUserToLinkedinMutation(baseOptions?: Apollo.MutationHookOptions<ConnectUserToLinkedinMutation, ConnectUserToLinkedinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectUserToLinkedinMutation, ConnectUserToLinkedinMutationVariables>(ConnectUserToLinkedinDocument, options);
      }
export type ConnectUserToLinkedinMutationHookResult = ReturnType<typeof useConnectUserToLinkedinMutation>;
export type ConnectUserToLinkedinMutationResult = Apollo.MutationResult<ConnectUserToLinkedinMutation>;
export type ConnectUserToLinkedinMutationOptions = Apollo.BaseMutationOptions<ConnectUserToLinkedinMutation, ConnectUserToLinkedinMutationVariables>;
export const GetJwtTokenDocument = gql`
    query GetJwtToken($email: String!, $iat: Int) {
  getJwtToken(email: $email, iat: $iat) {
    token
  }
}
    `;

/**
 * __useGetJwtTokenQuery__
 *
 * To run a query within a React component, call `useGetJwtTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJwtTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJwtTokenQuery({
 *   variables: {
 *      email: // value for 'email'
 *      iat: // value for 'iat'
 *   },
 * });
 */
export function useGetJwtTokenQuery(baseOptions: Apollo.QueryHookOptions<GetJwtTokenQuery, GetJwtTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJwtTokenQuery, GetJwtTokenQueryVariables>(GetJwtTokenDocument, options);
      }
export function useGetJwtTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJwtTokenQuery, GetJwtTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJwtTokenQuery, GetJwtTokenQueryVariables>(GetJwtTokenDocument, options);
        }
export type GetJwtTokenQueryHookResult = ReturnType<typeof useGetJwtTokenQuery>;
export type GetJwtTokenLazyQueryHookResult = ReturnType<typeof useGetJwtTokenLazyQuery>;
export type GetJwtTokenQueryResult = Apollo.QueryResult<GetJwtTokenQuery, GetJwtTokenQueryVariables>;
export const AssociateUserToSalesPointGroupsDocument = gql`
    mutation associateUserToSalesPointGroups($groupIds: [ID!]!, $userId: ID!) {
  associateUserToSalesPointGroups(groupIds: $groupIds, userId: $userId)
}
    `;
export type AssociateUserToSalesPointGroupsMutationFn = Apollo.MutationFunction<AssociateUserToSalesPointGroupsMutation, AssociateUserToSalesPointGroupsMutationVariables>;

/**
 * __useAssociateUserToSalesPointGroupsMutation__
 *
 * To run a mutation, you first call `useAssociateUserToSalesPointGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateUserToSalesPointGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateUserToSalesPointGroupsMutation, { data, loading, error }] = useAssociateUserToSalesPointGroupsMutation({
 *   variables: {
 *      groupIds: // value for 'groupIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssociateUserToSalesPointGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AssociateUserToSalesPointGroupsMutation, AssociateUserToSalesPointGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateUserToSalesPointGroupsMutation, AssociateUserToSalesPointGroupsMutationVariables>(AssociateUserToSalesPointGroupsDocument, options);
      }
export type AssociateUserToSalesPointGroupsMutationHookResult = ReturnType<typeof useAssociateUserToSalesPointGroupsMutation>;
export type AssociateUserToSalesPointGroupsMutationResult = Apollo.MutationResult<AssociateUserToSalesPointGroupsMutation>;
export type AssociateUserToSalesPointGroupsMutationOptions = Apollo.BaseMutationOptions<AssociateUserToSalesPointGroupsMutation, AssociateUserToSalesPointGroupsMutationVariables>;
export const DissociateUserFromSalesPointGroupsDocument = gql`
    mutation dissociateUserFromSalesPointGroups($groupIds: [ID!]!, $userId: ID!) {
  dissociateUserFromSalesPointGroups(groupIds: $groupIds, userId: $userId)
}
    `;
export type DissociateUserFromSalesPointGroupsMutationFn = Apollo.MutationFunction<DissociateUserFromSalesPointGroupsMutation, DissociateUserFromSalesPointGroupsMutationVariables>;

/**
 * __useDissociateUserFromSalesPointGroupsMutation__
 *
 * To run a mutation, you first call `useDissociateUserFromSalesPointGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDissociateUserFromSalesPointGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dissociateUserFromSalesPointGroupsMutation, { data, loading, error }] = useDissociateUserFromSalesPointGroupsMutation({
 *   variables: {
 *      groupIds: // value for 'groupIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDissociateUserFromSalesPointGroupsMutation(baseOptions?: Apollo.MutationHookOptions<DissociateUserFromSalesPointGroupsMutation, DissociateUserFromSalesPointGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DissociateUserFromSalesPointGroupsMutation, DissociateUserFromSalesPointGroupsMutationVariables>(DissociateUserFromSalesPointGroupsDocument, options);
      }
export type DissociateUserFromSalesPointGroupsMutationHookResult = ReturnType<typeof useDissociateUserFromSalesPointGroupsMutation>;
export type DissociateUserFromSalesPointGroupsMutationResult = Apollo.MutationResult<DissociateUserFromSalesPointGroupsMutation>;
export type DissociateUserFromSalesPointGroupsMutationOptions = Apollo.BaseMutationOptions<DissociateUserFromSalesPointGroupsMutation, DissociateUserFromSalesPointGroupsMutationVariables>;
export const ProviderSalespointsGroupsDocument = gql`
    query providerSalespointsGroups($keyword: String, $offset: Int, $limit: Int, $idProvider: ID) {
  providerSalespointsGroups(keyword: $keyword, offset: $offset, limit: $limit, idProvider: $idProvider) {
    count
    salesPointsGroups {
      id
      name
      client {
        name
      }
    }
  }
}
    `;

/**
 * __useProviderSalespointsGroupsQuery__
 *
 * To run a query within a React component, call `useProviderSalespointsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderSalespointsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderSalespointsGroupsQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      idProvider: // value for 'idProvider'
 *   },
 * });
 */
export function useProviderSalespointsGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ProviderSalespointsGroupsQuery, ProviderSalespointsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderSalespointsGroupsQuery, ProviderSalespointsGroupsQueryVariables>(ProviderSalespointsGroupsDocument, options);
      }
export function useProviderSalespointsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderSalespointsGroupsQuery, ProviderSalespointsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderSalespointsGroupsQuery, ProviderSalespointsGroupsQueryVariables>(ProviderSalespointsGroupsDocument, options);
        }
export type ProviderSalespointsGroupsQueryHookResult = ReturnType<typeof useProviderSalespointsGroupsQuery>;
export type ProviderSalespointsGroupsLazyQueryHookResult = ReturnType<typeof useProviderSalespointsGroupsLazyQuery>;
export type ProviderSalespointsGroupsQueryResult = Apollo.QueryResult<ProviderSalespointsGroupsQuery, ProviderSalespointsGroupsQueryVariables>;
export const ArchiveBriefDocument = gql`
    mutation archiveBrief($briefId: ID!, $toBeArchived: Boolean!) {
  archiveBrief(briefId: $briefId, toBeArchived: $toBeArchived)
}
    `;
export type ArchiveBriefMutationFn = Apollo.MutationFunction<ArchiveBriefMutation, ArchiveBriefMutationVariables>;

/**
 * __useArchiveBriefMutation__
 *
 * To run a mutation, you first call `useArchiveBriefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveBriefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveBriefMutation, { data, loading, error }] = useArchiveBriefMutation({
 *   variables: {
 *      briefId: // value for 'briefId'
 *      toBeArchived: // value for 'toBeArchived'
 *   },
 * });
 */
export function useArchiveBriefMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveBriefMutation, ArchiveBriefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveBriefMutation, ArchiveBriefMutationVariables>(ArchiveBriefDocument, options);
      }
export type ArchiveBriefMutationHookResult = ReturnType<typeof useArchiveBriefMutation>;
export type ArchiveBriefMutationResult = Apollo.MutationResult<ArchiveBriefMutation>;
export type ArchiveBriefMutationOptions = Apollo.BaseMutationOptions<ArchiveBriefMutation, ArchiveBriefMutationVariables>;
export const BriefsCountDocumentsDocument = gql`
    query briefsCountDocuments($getArchived: Boolean!) {
  briefsCountDocuments(getArchived: $getArchived) {
    countArchived
    countNotArchived
  }
}
    `;

/**
 * __useBriefsCountDocumentsQuery__
 *
 * To run a query within a React component, call `useBriefsCountDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefsCountDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefsCountDocumentsQuery({
 *   variables: {
 *      getArchived: // value for 'getArchived'
 *   },
 * });
 */
export function useBriefsCountDocumentsQuery(baseOptions: Apollo.QueryHookOptions<BriefsCountDocumentsQuery, BriefsCountDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefsCountDocumentsQuery, BriefsCountDocumentsQueryVariables>(BriefsCountDocumentsDocument, options);
      }
export function useBriefsCountDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefsCountDocumentsQuery, BriefsCountDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefsCountDocumentsQuery, BriefsCountDocumentsQueryVariables>(BriefsCountDocumentsDocument, options);
        }
export type BriefsCountDocumentsQueryHookResult = ReturnType<typeof useBriefsCountDocumentsQuery>;
export type BriefsCountDocumentsLazyQueryHookResult = ReturnType<typeof useBriefsCountDocumentsLazyQuery>;
export type BriefsCountDocumentsQueryResult = Apollo.QueryResult<BriefsCountDocumentsQuery, BriefsCountDocumentsQueryVariables>;
export const CreateBriefCommentDocument = gql`
    mutation createBriefComment($id: ID!, $comment: String!) {
  addBriefComment(briefId: $id, comment: $comment) {
    id
  }
}
    `;
export type CreateBriefCommentMutationFn = Apollo.MutationFunction<CreateBriefCommentMutation, CreateBriefCommentMutationVariables>;

/**
 * __useCreateBriefCommentMutation__
 *
 * To run a mutation, you first call `useCreateBriefCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBriefCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBriefCommentMutation, { data, loading, error }] = useCreateBriefCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateBriefCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBriefCommentMutation, CreateBriefCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBriefCommentMutation, CreateBriefCommentMutationVariables>(CreateBriefCommentDocument, options);
      }
export type CreateBriefCommentMutationHookResult = ReturnType<typeof useCreateBriefCommentMutation>;
export type CreateBriefCommentMutationResult = Apollo.MutationResult<CreateBriefCommentMutation>;
export type CreateBriefCommentMutationOptions = Apollo.BaseMutationOptions<CreateBriefCommentMutation, CreateBriefCommentMutationVariables>;
export const CreateMultipleBriefsDocument = gql`
    mutation createMultipleBriefs($briefs: [InputBrief!]!, $createDrafts: Boolean!) {
  createMultipleBriefs(briefs: $briefs, createDrafts: $createDrafts) {
    id
  }
}
    `;
export type CreateMultipleBriefsMutationFn = Apollo.MutationFunction<CreateMultipleBriefsMutation, CreateMultipleBriefsMutationVariables>;

/**
 * __useCreateMultipleBriefsMutation__
 *
 * To run a mutation, you first call `useCreateMultipleBriefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultipleBriefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultipleBriefsMutation, { data, loading, error }] = useCreateMultipleBriefsMutation({
 *   variables: {
 *      briefs: // value for 'briefs'
 *      createDrafts: // value for 'createDrafts'
 *   },
 * });
 */
export function useCreateMultipleBriefsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultipleBriefsMutation, CreateMultipleBriefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultipleBriefsMutation, CreateMultipleBriefsMutationVariables>(CreateMultipleBriefsDocument, options);
      }
export type CreateMultipleBriefsMutationHookResult = ReturnType<typeof useCreateMultipleBriefsMutation>;
export type CreateMultipleBriefsMutationResult = Apollo.MutationResult<CreateMultipleBriefsMutation>;
export type CreateMultipleBriefsMutationOptions = Apollo.BaseMutationOptions<CreateMultipleBriefsMutation, CreateMultipleBriefsMutationVariables>;
export const TransitionBriefsByDateDocument = gql`
    mutation transitionBriefsByDate {
  transitionBriefsByDate
}
    `;
export type TransitionBriefsByDateMutationFn = Apollo.MutationFunction<TransitionBriefsByDateMutation, TransitionBriefsByDateMutationVariables>;

/**
 * __useTransitionBriefsByDateMutation__
 *
 * To run a mutation, you first call `useTransitionBriefsByDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionBriefsByDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionBriefsByDateMutation, { data, loading, error }] = useTransitionBriefsByDateMutation({
 *   variables: {
 *   },
 * });
 */
export function useTransitionBriefsByDateMutation(baseOptions?: Apollo.MutationHookOptions<TransitionBriefsByDateMutation, TransitionBriefsByDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransitionBriefsByDateMutation, TransitionBriefsByDateMutationVariables>(TransitionBriefsByDateDocument, options);
      }
export type TransitionBriefsByDateMutationHookResult = ReturnType<typeof useTransitionBriefsByDateMutation>;
export type TransitionBriefsByDateMutationResult = Apollo.MutationResult<TransitionBriefsByDateMutation>;
export type TransitionBriefsByDateMutationOptions = Apollo.BaseMutationOptions<TransitionBriefsByDateMutation, TransitionBriefsByDateMutationVariables>;
export const SendGroupedBriefNotificationsDocument = gql`
    mutation sendGroupedBriefNotifications {
  sendGroupedBriefNotifications
}
    `;
export type SendGroupedBriefNotificationsMutationFn = Apollo.MutationFunction<SendGroupedBriefNotificationsMutation, SendGroupedBriefNotificationsMutationVariables>;

/**
 * __useSendGroupedBriefNotificationsMutation__
 *
 * To run a mutation, you first call `useSendGroupedBriefNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGroupedBriefNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGroupedBriefNotificationsMutation, { data, loading, error }] = useSendGroupedBriefNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendGroupedBriefNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SendGroupedBriefNotificationsMutation, SendGroupedBriefNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGroupedBriefNotificationsMutation, SendGroupedBriefNotificationsMutationVariables>(SendGroupedBriefNotificationsDocument, options);
      }
export type SendGroupedBriefNotificationsMutationHookResult = ReturnType<typeof useSendGroupedBriefNotificationsMutation>;
export type SendGroupedBriefNotificationsMutationResult = Apollo.MutationResult<SendGroupedBriefNotificationsMutation>;
export type SendGroupedBriefNotificationsMutationOptions = Apollo.BaseMutationOptions<SendGroupedBriefNotificationsMutation, SendGroupedBriefNotificationsMutationVariables>;
export const DeleteBriefMediaDocument = gql`
    mutation deleteBriefMedia($mediaIds: [ID!]!) {
  deleteBriefMedia(mediaIds: $mediaIds)
}
    `;
export type DeleteBriefMediaMutationFn = Apollo.MutationFunction<DeleteBriefMediaMutation, DeleteBriefMediaMutationVariables>;

/**
 * __useDeleteBriefMediaMutation__
 *
 * To run a mutation, you first call `useDeleteBriefMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBriefMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBriefMediaMutation, { data, loading, error }] = useDeleteBriefMediaMutation({
 *   variables: {
 *      mediaIds: // value for 'mediaIds'
 *   },
 * });
 */
export function useDeleteBriefMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBriefMediaMutation, DeleteBriefMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBriefMediaMutation, DeleteBriefMediaMutationVariables>(DeleteBriefMediaDocument, options);
      }
export type DeleteBriefMediaMutationHookResult = ReturnType<typeof useDeleteBriefMediaMutation>;
export type DeleteBriefMediaMutationResult = Apollo.MutationResult<DeleteBriefMediaMutation>;
export type DeleteBriefMediaMutationOptions = Apollo.BaseMutationOptions<DeleteBriefMediaMutation, DeleteBriefMediaMutationVariables>;
export const ExportBriefsDocument = gql`
    mutation exportBriefs($format: BriefExportType, $filter: BriefsFilter) {
  exportBriefs(format: $format, filter: $filter)
}
    `;
export type ExportBriefsMutationFn = Apollo.MutationFunction<ExportBriefsMutation, ExportBriefsMutationVariables>;

/**
 * __useExportBriefsMutation__
 *
 * To run a mutation, you first call `useExportBriefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportBriefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportBriefsMutation, { data, loading, error }] = useExportBriefsMutation({
 *   variables: {
 *      format: // value for 'format'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportBriefsMutation(baseOptions?: Apollo.MutationHookOptions<ExportBriefsMutation, ExportBriefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportBriefsMutation, ExportBriefsMutationVariables>(ExportBriefsDocument, options);
      }
export type ExportBriefsMutationHookResult = ReturnType<typeof useExportBriefsMutation>;
export type ExportBriefsMutationResult = Apollo.MutationResult<ExportBriefsMutation>;
export type ExportBriefsMutationOptions = Apollo.BaseMutationOptions<ExportBriefsMutation, ExportBriefsMutationVariables>;
export const AvailableAdressesDocument = gql`
    query availableAdresses($id: ID!) {
  salesPointById(id: $id) {
    id
    defaultLocations {
      shipping {
        id
        name
        address
        postalCode
        city
        country
        additionalAddress
      }
    }
    publicLocation {
      id
      name
      address
      postalCode
      city
      country
      additionalAddress
    }
    locations {
      id
      name
      address
      postalCode
      city
      country
      additionalAddress
    }
  }
}
    `;

/**
 * __useAvailableAdressesQuery__
 *
 * To run a query within a React component, call `useAvailableAdressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAdressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAdressesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAvailableAdressesQuery(baseOptions: Apollo.QueryHookOptions<AvailableAdressesQuery, AvailableAdressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableAdressesQuery, AvailableAdressesQueryVariables>(AvailableAdressesDocument, options);
      }
export function useAvailableAdressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableAdressesQuery, AvailableAdressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableAdressesQuery, AvailableAdressesQueryVariables>(AvailableAdressesDocument, options);
        }
export type AvailableAdressesQueryHookResult = ReturnType<typeof useAvailableAdressesQuery>;
export type AvailableAdressesLazyQueryHookResult = ReturnType<typeof useAvailableAdressesLazyQuery>;
export type AvailableAdressesQueryResult = Apollo.QueryResult<AvailableAdressesQuery, AvailableAdressesQueryVariables>;
export const AvailableBriefCampaignsDocument = gql`
    query availableBriefCampaigns($limit: Int, $offset: Int, $sort: CampaignSort) {
  campaigns(limit: $limit, offset: $offset, sort: $sort) {
    campaigns {
      id
      name
      startDate
      endDate
      enabled
    }
    count
  }
}
    `;

/**
 * __useAvailableBriefCampaignsQuery__
 *
 * To run a query within a React component, call `useAvailableBriefCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableBriefCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableBriefCampaignsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAvailableBriefCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableBriefCampaignsQuery, AvailableBriefCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableBriefCampaignsQuery, AvailableBriefCampaignsQueryVariables>(AvailableBriefCampaignsDocument, options);
      }
export function useAvailableBriefCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableBriefCampaignsQuery, AvailableBriefCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableBriefCampaignsQuery, AvailableBriefCampaignsQueryVariables>(AvailableBriefCampaignsDocument, options);
        }
export type AvailableBriefCampaignsQueryHookResult = ReturnType<typeof useAvailableBriefCampaignsQuery>;
export type AvailableBriefCampaignsLazyQueryHookResult = ReturnType<typeof useAvailableBriefCampaignsLazyQuery>;
export type AvailableBriefCampaignsQueryResult = Apollo.QueryResult<AvailableBriefCampaignsQuery, AvailableBriefCampaignsQueryVariables>;
export const GetBriefActivityDocument = gql`
    query getBriefActivity($id: ID!) {
  briefActivity(briefId: $id) {
    activity {
      id
      action
      createdAt
      comment {
        id
        message
      }
      author {
        id
        firstname
        lastname
      }
      content {
        status {
          from
          to
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetBriefActivityQuery__
 *
 * To run a query within a React component, call `useGetBriefActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBriefActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBriefActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBriefActivityQuery(baseOptions: Apollo.QueryHookOptions<GetBriefActivityQuery, GetBriefActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBriefActivityQuery, GetBriefActivityQueryVariables>(GetBriefActivityDocument, options);
      }
export function useGetBriefActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBriefActivityQuery, GetBriefActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBriefActivityQuery, GetBriefActivityQueryVariables>(GetBriefActivityDocument, options);
        }
export type GetBriefActivityQueryHookResult = ReturnType<typeof useGetBriefActivityQuery>;
export type GetBriefActivityLazyQueryHookResult = ReturnType<typeof useGetBriefActivityLazyQuery>;
export type GetBriefActivityQueryResult = Apollo.QueryResult<GetBriefActivityQuery, GetBriefActivityQueryVariables>;
export const BriefAttachmentsDocument = gql`
    query briefAttachments($id: ID!) {
  briefById(id: $id) {
    id
    attachments {
      id
      filename
      mimetype
      thumbnail
      filename
      createdAt
      createdBy {
        id
        firstname
        lastname
      }
      tag
      url
    }
    quoteOptions {
      amount
      comment
    }
  }
}
    `;

/**
 * __useBriefAttachmentsQuery__
 *
 * To run a query within a React component, call `useBriefAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefAttachmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<BriefAttachmentsQuery, BriefAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefAttachmentsQuery, BriefAttachmentsQueryVariables>(BriefAttachmentsDocument, options);
      }
export function useBriefAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefAttachmentsQuery, BriefAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefAttachmentsQuery, BriefAttachmentsQueryVariables>(BriefAttachmentsDocument, options);
        }
export type BriefAttachmentsQueryHookResult = ReturnType<typeof useBriefAttachmentsQuery>;
export type BriefAttachmentsLazyQueryHookResult = ReturnType<typeof useBriefAttachmentsLazyQuery>;
export type BriefAttachmentsQueryResult = Apollo.QueryResult<BriefAttachmentsQuery, BriefAttachmentsQueryVariables>;
export const GetBriefDocument = gql`
    query getBrief($id: ID!) {
  briefById(id: $id) {
    id
    isArchived
    isProduct
    isCommentEnabled
    comment
    attribute
    productAttribute
    attachments {
      id
      filename
      thumbnail
      url
      tag
    }
    quoteOptions {
      amount
      comment
    }
    client {
      id
      clientId
      briefOptions {
        ... on BriefOptions {
          type
          internalReference
          visualReference
          delivery
          wishDelivery
          budget
          workflow
          governance
          quoteComment
          quoteAmount
          contextGoalsIssues
          description
          targeting
          offer
          customerJourney
          campaignDates
          launchDates
          validityDates
          campaignType
          lever
          support
          workType
          campaignLevel
        }
        ... on BriefHyundaiOptions {
          type
          internalReference
          visualReference
          delivery
          wishDelivery
          budget
          budgetType
          activityType
          modelType
          communicationType
          briefType
          workflow
          governance
          quoteComment
          quoteAmount
          contextGoalsIssues
          description
          targeting
          offer
          customerJourney
          campaignDates
          launchDates
          validityDates
          campaignType
          lever
          support
          workType
          campaignLevel
        }
      }
    }
    author {
      id
      firstname
      lastname
      email
      role {
        id
        absoluteSlug
      }
    }
    salesPoint {
      id
      name
    }
    contacts {
      firstName
      lastName
      email
      phoneNumber
    }
    format
    description
    createdAt
    deliveryDeadline
    deliveryOption
    internalReference
    medium
    name
    type
    status
    campaign {
      id
      name
    }
    campaignId
    campaignStart
    campaignEnd
    validStartDate
    validEndDate
    productId
    deliveryDate
    useLaunchDate
    useValidDate
    shippingAddresses {
      name
      address
      additionalAddress
      postalCode
      city
      country
      quantity
    }
    referenceVisuals {
      id
      filename
      url
      mimetype
      thumbnail
    }
    contextGoalsIssues
    targeting
    offer
    customerJourney
    campaignType
    briefSpecClient {
      id
      key
      value
      label
      parentId
      children {
        id
        key
        value
        label
        parentId
      }
    }
    other
    budget
    ... on BriefHyundai {
      budgetType
      modelType
      activityType
      briefType
      communicationType
      typesLabel {
        activityTypeLabel
        communicationTypeLabel
        modelTypeLabel
        budgetTypeLabel
      }
    }
  }
}
    `;

/**
 * __useGetBriefQuery__
 *
 * To run a query within a React component, call `useGetBriefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBriefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBriefQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBriefQuery(baseOptions: Apollo.QueryHookOptions<GetBriefQuery, GetBriefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBriefQuery, GetBriefQueryVariables>(GetBriefDocument, options);
      }
export function useGetBriefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBriefQuery, GetBriefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBriefQuery, GetBriefQueryVariables>(GetBriefDocument, options);
        }
export type GetBriefQueryHookResult = ReturnType<typeof useGetBriefQuery>;
export type GetBriefLazyQueryHookResult = ReturnType<typeof useGetBriefLazyQuery>;
export type GetBriefQueryResult = Apollo.QueryResult<GetBriefQuery, GetBriefQueryVariables>;
export const BriefCommentsDocument = gql`
    query briefComments($id: ID!, $limit: Int, $offset: Int) {
  briefComments(briefId: $id, limit: $limit, offset: $offset) {
    comments {
      id
      message
      author {
        id
        fullName
      }
      createdAt
      activity {
        id
        action
        content {
          status {
            to
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBriefCommentsQuery__
 *
 * To run a query within a React component, call `useBriefCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBriefCommentsQuery(baseOptions: Apollo.QueryHookOptions<BriefCommentsQuery, BriefCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefCommentsQuery, BriefCommentsQueryVariables>(BriefCommentsDocument, options);
      }
export function useBriefCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefCommentsQuery, BriefCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefCommentsQuery, BriefCommentsQueryVariables>(BriefCommentsDocument, options);
        }
export type BriefCommentsQueryHookResult = ReturnType<typeof useBriefCommentsQuery>;
export type BriefCommentsLazyQueryHookResult = ReturnType<typeof useBriefCommentsLazyQuery>;
export type BriefCommentsQueryResult = Apollo.QueryResult<BriefCommentsQuery, BriefCommentsQueryVariables>;
export const BriefCommentsCountDocument = gql`
    query briefCommentsCount($id: ID!, $limit: Int, $offset: Int) {
  briefComments(briefId: $id, limit: $limit, offset: $offset) {
    count
  }
}
    `;

/**
 * __useBriefCommentsCountQuery__
 *
 * To run a query within a React component, call `useBriefCommentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefCommentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefCommentsCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBriefCommentsCountQuery(baseOptions: Apollo.QueryHookOptions<BriefCommentsCountQuery, BriefCommentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefCommentsCountQuery, BriefCommentsCountQueryVariables>(BriefCommentsCountDocument, options);
      }
export function useBriefCommentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefCommentsCountQuery, BriefCommentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefCommentsCountQuery, BriefCommentsCountQueryVariables>(BriefCommentsCountDocument, options);
        }
export type BriefCommentsCountQueryHookResult = ReturnType<typeof useBriefCommentsCountQuery>;
export type BriefCommentsCountLazyQueryHookResult = ReturnType<typeof useBriefCommentsCountLazyQuery>;
export type BriefCommentsCountQueryResult = Apollo.QueryResult<BriefCommentsCountQuery, BriefCommentsCountQueryVariables>;
export const GetBriefConceptionLinkDocument = gql`
    query getBriefConceptionLink($id: ID!) {
  briefById(id: $id) {
    id
    status
    name
    createdAt
    reference
    author {
      firstname
      lastname
    }
    awaitingNewConception
    conception {
      id
      api
      url
    }
  }
}
    `;

/**
 * __useGetBriefConceptionLinkQuery__
 *
 * To run a query within a React component, call `useGetBriefConceptionLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBriefConceptionLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBriefConceptionLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBriefConceptionLinkQuery(baseOptions: Apollo.QueryHookOptions<GetBriefConceptionLinkQuery, GetBriefConceptionLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBriefConceptionLinkQuery, GetBriefConceptionLinkQueryVariables>(GetBriefConceptionLinkDocument, options);
      }
export function useGetBriefConceptionLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBriefConceptionLinkQuery, GetBriefConceptionLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBriefConceptionLinkQuery, GetBriefConceptionLinkQueryVariables>(GetBriefConceptionLinkDocument, options);
        }
export type GetBriefConceptionLinkQueryHookResult = ReturnType<typeof useGetBriefConceptionLinkQuery>;
export type GetBriefConceptionLinkLazyQueryHookResult = ReturnType<typeof useGetBriefConceptionLinkLazyQuery>;
export type GetBriefConceptionLinkQueryResult = Apollo.QueryResult<GetBriefConceptionLinkQuery, GetBriefConceptionLinkQueryVariables>;
export const BriefHistoryDocument = gql`
    query briefHistory($id: ID!) {
  briefActivity(briefId: $id) {
    activity {
      id
      author {
        id
        firstname
        lastname
      }
      action
      content {
        status {
          from
          to
        }
        file {
          id
          filename
          url
        }
        decision
        updatedFields
      }
      comment {
        message
      }
      createdAt
    }
  }
}
    `;

/**
 * __useBriefHistoryQuery__
 *
 * To run a query within a React component, call `useBriefHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefHistoryQuery(baseOptions: Apollo.QueryHookOptions<BriefHistoryQuery, BriefHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefHistoryQuery, BriefHistoryQueryVariables>(BriefHistoryDocument, options);
      }
export function useBriefHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefHistoryQuery, BriefHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefHistoryQuery, BriefHistoryQueryVariables>(BriefHistoryDocument, options);
        }
export type BriefHistoryQueryHookResult = ReturnType<typeof useBriefHistoryQuery>;
export type BriefHistoryLazyQueryHookResult = ReturnType<typeof useBriefHistoryLazyQuery>;
export type BriefHistoryQueryResult = Apollo.QueryResult<BriefHistoryQuery, BriefHistoryQueryVariables>;
export const BriefOverviewDocument = gql`
    query briefOverview($id: ID!) {
  briefById(id: $id) {
    id
    isArchived
    isProduct
    author {
      id
      firstname
      lastname
    }
    createdAt
    name
    briefNumber
    status
    validStartDate
    validEndDate
    shippingAddresses {
      postalCode
    }
    conception {
      api
    }
    client {
      f
    }
  }
}
    `;

/**
 * __useBriefOverviewQuery__
 *
 * To run a query within a React component, call `useBriefOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefOverviewQuery(baseOptions: Apollo.QueryHookOptions<BriefOverviewQuery, BriefOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefOverviewQuery, BriefOverviewQueryVariables>(BriefOverviewDocument, options);
      }
export function useBriefOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefOverviewQuery, BriefOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefOverviewQuery, BriefOverviewQueryVariables>(BriefOverviewDocument, options);
        }
export type BriefOverviewQueryHookResult = ReturnType<typeof useBriefOverviewQuery>;
export type BriefOverviewLazyQueryHookResult = ReturnType<typeof useBriefOverviewLazyQuery>;
export type BriefOverviewQueryResult = Apollo.QueryResult<BriefOverviewQuery, BriefOverviewQueryVariables>;
export const BriefReferenceVisualsDocument = gql`
    query briefReferenceVisuals($id: ID!) {
  briefById(id: $id) {
    id
    referenceVisuals {
      id
      filename
      mimetype
      thumbnail
      filename
      url
    }
  }
}
    `;

/**
 * __useBriefReferenceVisualsQuery__
 *
 * To run a query within a React component, call `useBriefReferenceVisualsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefReferenceVisualsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefReferenceVisualsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefReferenceVisualsQuery(baseOptions: Apollo.QueryHookOptions<BriefReferenceVisualsQuery, BriefReferenceVisualsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefReferenceVisualsQuery, BriefReferenceVisualsQueryVariables>(BriefReferenceVisualsDocument, options);
      }
export function useBriefReferenceVisualsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefReferenceVisualsQuery, BriefReferenceVisualsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefReferenceVisualsQuery, BriefReferenceVisualsQueryVariables>(BriefReferenceVisualsDocument, options);
        }
export type BriefReferenceVisualsQueryHookResult = ReturnType<typeof useBriefReferenceVisualsQuery>;
export type BriefReferenceVisualsLazyQueryHookResult = ReturnType<typeof useBriefReferenceVisualsLazyQuery>;
export type BriefReferenceVisualsQueryResult = Apollo.QueryResult<BriefReferenceVisualsQuery, BriefReferenceVisualsQueryVariables>;
export const BriefSummaryDocument = gql`
    query briefSummary($id: ID!) {
  briefById(id: $id) {
    id
    contacts {
      firstName
      lastName
      email
      phoneNumber
    }
    salesPoint {
      id
      name
    }
    createdAt
    medium
    format
    description
    internalReference
    name
    type
    campaignId
    deliveryDeadline
    deliveryOption
    status
  }
}
    `;

/**
 * __useBriefSummaryQuery__
 *
 * To run a query within a React component, call `useBriefSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefSummaryQuery(baseOptions: Apollo.QueryHookOptions<BriefSummaryQuery, BriefSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefSummaryQuery, BriefSummaryQueryVariables>(BriefSummaryDocument, options);
      }
export function useBriefSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefSummaryQuery, BriefSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefSummaryQuery, BriefSummaryQueryVariables>(BriefSummaryDocument, options);
        }
export type BriefSummaryQueryHookResult = ReturnType<typeof useBriefSummaryQuery>;
export type BriefSummaryLazyQueryHookResult = ReturnType<typeof useBriefSummaryLazyQuery>;
export type BriefSummaryQueryResult = Apollo.QueryResult<BriefSummaryQuery, BriefSummaryQueryVariables>;
export const BriefSpecificationsDocument = gql`
    query briefSpecifications {
  briefTechnicalSpecifications {
    value
    mediums {
      value
      formats {
        value
        defaultDescription
      }
    }
  }
  briefOtherTechnicalSpecifications {
    activities {
      api
      value
    }
    specs {
      api
      value
      models {
        api
        value
      }
      communications {
        api
        value
      }
    }
  }
  briefCampaignType {
    label
    value
  }
}
    `;

/**
 * __useBriefSpecificationsQuery__
 *
 * To run a query within a React component, call `useBriefSpecificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefSpecificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefSpecificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBriefSpecificationsQuery(baseOptions?: Apollo.QueryHookOptions<BriefSpecificationsQuery, BriefSpecificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefSpecificationsQuery, BriefSpecificationsQueryVariables>(BriefSpecificationsDocument, options);
      }
export function useBriefSpecificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefSpecificationsQuery, BriefSpecificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefSpecificationsQuery, BriefSpecificationsQueryVariables>(BriefSpecificationsDocument, options);
        }
export type BriefSpecificationsQueryHookResult = ReturnType<typeof useBriefSpecificationsQuery>;
export type BriefSpecificationsLazyQueryHookResult = ReturnType<typeof useBriefSpecificationsLazyQuery>;
export type BriefSpecificationsQueryResult = Apollo.QueryResult<BriefSpecificationsQuery, BriefSpecificationsQueryVariables>;
export const BriefDeliveryOptionDocument = gql`
    query briefDeliveryOption($id: ID!) {
  briefById(id: $id) {
    deliveryOption
  }
}
    `;

/**
 * __useBriefDeliveryOptionQuery__
 *
 * To run a query within a React component, call `useBriefDeliveryOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefDeliveryOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefDeliveryOptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefDeliveryOptionQuery(baseOptions: Apollo.QueryHookOptions<BriefDeliveryOptionQuery, BriefDeliveryOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefDeliveryOptionQuery, BriefDeliveryOptionQueryVariables>(BriefDeliveryOptionDocument, options);
      }
export function useBriefDeliveryOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefDeliveryOptionQuery, BriefDeliveryOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefDeliveryOptionQuery, BriefDeliveryOptionQueryVariables>(BriefDeliveryOptionDocument, options);
        }
export type BriefDeliveryOptionQueryHookResult = ReturnType<typeof useBriefDeliveryOptionQuery>;
export type BriefDeliveryOptionLazyQueryHookResult = ReturnType<typeof useBriefDeliveryOptionLazyQuery>;
export type BriefDeliveryOptionQueryResult = Apollo.QueryResult<BriefDeliveryOptionQuery, BriefDeliveryOptionQueryVariables>;
export const GetBriefsDocument = gql`
    query getBriefs($offset: Int, $limit: Int, $filter: BriefsFilter, $sortField: SortField) {
  briefs(offset: $offset, limit: $limit, filter: $filter, sortField: $sortField) {
    count
    briefs {
      id
      name
      briefNumber
      description
      internalReference
      author {
        firstname
        lastname
      }
      attachments {
        id
      }
      status
      createdAt
      salesPoint {
        id
        name
      }
      isArchived
      isProduct
      briefSpecClient {
        id
        key
        label
      }
    }
  }
}
    `;

/**
 * __useGetBriefsQuery__
 *
 * To run a query within a React component, call `useGetBriefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBriefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBriefsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useGetBriefsQuery(baseOptions?: Apollo.QueryHookOptions<GetBriefsQuery, GetBriefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBriefsQuery, GetBriefsQueryVariables>(GetBriefsDocument, options);
      }
export function useGetBriefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBriefsQuery, GetBriefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBriefsQuery, GetBriefsQueryVariables>(GetBriefsDocument, options);
        }
export type GetBriefsQueryHookResult = ReturnType<typeof useGetBriefsQuery>;
export type GetBriefsLazyQueryHookResult = ReturnType<typeof useGetBriefsLazyQuery>;
export type GetBriefsQueryResult = Apollo.QueryResult<GetBriefsQuery, GetBriefsQueryVariables>;
export const CampaignSummaryDocument = gql`
    query campaignSummary($id: ID!) {
  campaignById(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useCampaignSummaryQuery__
 *
 * To run a query within a React component, call `useCampaignSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignSummaryQuery(baseOptions: Apollo.QueryHookOptions<CampaignSummaryQuery, CampaignSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignSummaryQuery, CampaignSummaryQueryVariables>(CampaignSummaryDocument, options);
      }
export function useCampaignSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignSummaryQuery, CampaignSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignSummaryQuery, CampaignSummaryQueryVariables>(CampaignSummaryDocument, options);
        }
export type CampaignSummaryQueryHookResult = ReturnType<typeof useCampaignSummaryQuery>;
export type CampaignSummaryLazyQueryHookResult = ReturnType<typeof useCampaignSummaryLazyQuery>;
export type CampaignSummaryQueryResult = Apollo.QueryResult<CampaignSummaryQuery, CampaignSummaryQueryVariables>;
export const GetCampaignsDocument = gql`
    query getCampaigns($salespointGroups: [ID], $types: [CampaignType!], $sort: CampaignSort, $keyword: String, $isFilteredOnEndDate: Boolean) {
  campaigns(salespointGroups: $salespointGroups, types: $types, sort: $sort, keyword: $keyword, isFilteredOnEndDate: $isFilteredOnEndDate) {
    campaigns {
      id
      name
      startDate
      endDate
      enabled
    }
  }
}
    `;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      salespointGroups: // value for 'salespointGroups'
 *      types: // value for 'types'
 *      sort: // value for 'sort'
 *      keyword: // value for 'keyword'
 *      isFilteredOnEndDate: // value for 'isFilteredOnEndDate'
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetInformationsToCreateBriefDocument = gql`
    query getInformationsToCreateBrief($offset: Int, $limit: Int, $filter: SalesPointFilter, $types: [CampaignType!]) {
  salesPoints(offset: $offset, limit: $limit, filter: $filter) {
    count
    enabledSalesPointsCount
    salesPoints {
      id
      name
      enabled
    }
  }
  campaigns(types: $types) {
    count
    campaigns {
      id
      name
    }
  }
  me {
    id
    firstname
    lastname
    phone
    email
    defaultStoreId
    selectedSalesPointId
    selectedSalesPoint {
      salespointGroups {
        id
      }
      defaultLocations {
        shipping {
          id
          name
          address
          postalCode
          city
          country
          additionalAddress
        }
      }
      publicLocation {
        address
        postalCode
        city
        country
        additionalAddress
      }
      locations {
        id
        name
        address
        postalCode
        city
        country
        additionalAddress
      }
    }
    salesPoints {
      id
      name
      salespointGroups {
        id
      }
    }
  }
  briefTechnicalSpecifications {
    value
    mediums {
      value
      formats {
        value
        defaultDescription
      }
    }
  }
}
    `;

/**
 * __useGetInformationsToCreateBriefQuery__
 *
 * To run a query within a React component, call `useGetInformationsToCreateBriefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInformationsToCreateBriefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInformationsToCreateBriefQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetInformationsToCreateBriefQuery(baseOptions?: Apollo.QueryHookOptions<GetInformationsToCreateBriefQuery, GetInformationsToCreateBriefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInformationsToCreateBriefQuery, GetInformationsToCreateBriefQueryVariables>(GetInformationsToCreateBriefDocument, options);
      }
export function useGetInformationsToCreateBriefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInformationsToCreateBriefQuery, GetInformationsToCreateBriefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInformationsToCreateBriefQuery, GetInformationsToCreateBriefQueryVariables>(GetInformationsToCreateBriefDocument, options);
        }
export type GetInformationsToCreateBriefQueryHookResult = ReturnType<typeof useGetInformationsToCreateBriefQuery>;
export type GetInformationsToCreateBriefLazyQueryHookResult = ReturnType<typeof useGetInformationsToCreateBriefLazyQuery>;
export type GetInformationsToCreateBriefQueryResult = Apollo.QueryResult<GetInformationsToCreateBriefQuery, GetInformationsToCreateBriefQueryVariables>;
export const GetLatestEventDocument = gql`
    query getLatestEvent($briefId: ID!, $filter: BriefActivityFilter, $sort: BriefActivitySort) {
  briefActivity(briefId: $briefId, filter: $filter, sort: $sort) {
    activity {
      id
      createdAt
      content {
        status {
          to
          from
        }
      }
    }
  }
}
    `;

/**
 * __useGetLatestEventQuery__
 *
 * To run a query within a React component, call `useGetLatestEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestEventQuery({
 *   variables: {
 *      briefId: // value for 'briefId'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetLatestEventQuery(baseOptions: Apollo.QueryHookOptions<GetLatestEventQuery, GetLatestEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestEventQuery, GetLatestEventQueryVariables>(GetLatestEventDocument, options);
      }
export function useGetLatestEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestEventQuery, GetLatestEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestEventQuery, GetLatestEventQueryVariables>(GetLatestEventDocument, options);
        }
export type GetLatestEventQueryHookResult = ReturnType<typeof useGetLatestEventQuery>;
export type GetLatestEventLazyQueryHookResult = ReturnType<typeof useGetLatestEventLazyQuery>;
export type GetLatestEventQueryResult = Apollo.QueryResult<GetLatestEventQuery, GetLatestEventQueryVariables>;
export const GetRoleDocument = gql`
    query getRole {
  me {
    id
    selectedSalesPoint {
      salespointGroups {
        name
        id
      }
    }
    role {
      id
      slug
      absoluteSlug
    }
  }
}
    `;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const MySalespointGroupsDocument = gql`
    query mySalespointGroups {
  me {
    id
    selectedSalesPoint {
      id
      name
      salespointGroups {
        id
      }
    }
  }
}
    `;

/**
 * __useMySalespointGroupsQuery__
 *
 * To run a query within a React component, call `useMySalespointGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySalespointGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySalespointGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySalespointGroupsQuery(baseOptions?: Apollo.QueryHookOptions<MySalespointGroupsQuery, MySalespointGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySalespointGroupsQuery, MySalespointGroupsQueryVariables>(MySalespointGroupsDocument, options);
      }
export function useMySalespointGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySalespointGroupsQuery, MySalespointGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySalespointGroupsQuery, MySalespointGroupsQueryVariables>(MySalespointGroupsDocument, options);
        }
export type MySalespointGroupsQueryHookResult = ReturnType<typeof useMySalespointGroupsQuery>;
export type MySalespointGroupsLazyQueryHookResult = ReturnType<typeof useMySalespointGroupsLazyQuery>;
export type MySalespointGroupsQueryResult = Apollo.QueryResult<MySalespointGroupsQuery, MySalespointGroupsQueryVariables>;
export const GetProofHqReviewerLinkDocument = gql`
    query getProofHqReviewerLink($briefId: ID!) {
  getProofHqReviewerLink(briefId: $briefId)
}
    `;

/**
 * __useGetProofHqReviewerLinkQuery__
 *
 * To run a query within a React component, call `useGetProofHqReviewerLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProofHqReviewerLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProofHqReviewerLinkQuery({
 *   variables: {
 *      briefId: // value for 'briefId'
 *   },
 * });
 */
export function useGetProofHqReviewerLinkQuery(baseOptions: Apollo.QueryHookOptions<GetProofHqReviewerLinkQuery, GetProofHqReviewerLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProofHqReviewerLinkQuery, GetProofHqReviewerLinkQueryVariables>(GetProofHqReviewerLinkDocument, options);
      }
export function useGetProofHqReviewerLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProofHqReviewerLinkQuery, GetProofHqReviewerLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProofHqReviewerLinkQuery, GetProofHqReviewerLinkQueryVariables>(GetProofHqReviewerLinkDocument, options);
        }
export type GetProofHqReviewerLinkQueryHookResult = ReturnType<typeof useGetProofHqReviewerLinkQuery>;
export type GetProofHqReviewerLinkLazyQueryHookResult = ReturnType<typeof useGetProofHqReviewerLinkLazyQuery>;
export type GetProofHqReviewerLinkQueryResult = Apollo.QueryResult<GetProofHqReviewerLinkQuery, GetProofHqReviewerLinkQueryVariables>;
export const GetSalespointInfoByIdDocument = gql`
    query getSalespointInfoById($id: ID!) {
  salesPointById(id: $id) {
    id
    name
    email
    phone
    contactDetails {
      website
    }
    salespointGroups {
      id
    }
    defaultLocations {
      shipping {
        id
        name
        address
        postalCode
        city
        country
        additionalAddress
      }
    }
    publicLocation {
      id
      name
      address
      postalCode
      city
      country
      additionalAddress
    }
    locations {
      id
      name
      address
      postalCode
      city
      country
      additionalAddress
    }
  }
}
    `;

/**
 * __useGetSalespointInfoByIdQuery__
 *
 * To run a query within a React component, call `useGetSalespointInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalespointInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalespointInfoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSalespointInfoByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSalespointInfoByIdQuery, GetSalespointInfoByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalespointInfoByIdQuery, GetSalespointInfoByIdQueryVariables>(GetSalespointInfoByIdDocument, options);
      }
export function useGetSalespointInfoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalespointInfoByIdQuery, GetSalespointInfoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalespointInfoByIdQuery, GetSalespointInfoByIdQueryVariables>(GetSalespointInfoByIdDocument, options);
        }
export type GetSalespointInfoByIdQueryHookResult = ReturnType<typeof useGetSalespointInfoByIdQuery>;
export type GetSalespointInfoByIdLazyQueryHookResult = ReturnType<typeof useGetSalespointInfoByIdLazyQuery>;
export type GetSalespointInfoByIdQueryResult = Apollo.QueryResult<GetSalespointInfoByIdQuery, GetSalespointInfoByIdQueryVariables>;
export const BriefShippingAddressesDocument = gql`
    query briefShippingAddresses($id: ID!) {
  briefById(id: $id) {
    id
    shippingAddresses {
      name
      address
      additionalAddress
      postalCode
      city
      country
      quantity
    }
  }
}
    `;

/**
 * __useBriefShippingAddressesQuery__
 *
 * To run a query within a React component, call `useBriefShippingAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefShippingAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefShippingAddressesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBriefShippingAddressesQuery(baseOptions: Apollo.QueryHookOptions<BriefShippingAddressesQuery, BriefShippingAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefShippingAddressesQuery, BriefShippingAddressesQueryVariables>(BriefShippingAddressesDocument, options);
      }
export function useBriefShippingAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefShippingAddressesQuery, BriefShippingAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefShippingAddressesQuery, BriefShippingAddressesQueryVariables>(BriefShippingAddressesDocument, options);
        }
export type BriefShippingAddressesQueryHookResult = ReturnType<typeof useBriefShippingAddressesQuery>;
export type BriefShippingAddressesLazyQueryHookResult = ReturnType<typeof useBriefShippingAddressesLazyQuery>;
export type BriefShippingAddressesQueryResult = Apollo.QueryResult<BriefShippingAddressesQuery, BriefShippingAddressesQueryVariables>;
export const SalesPointsOptionsByKeywordDocument = gql`
    query salesPointsOptionsByKeyword($keyword: String!, $limit: Int!, $offset: Int!) {
  salesPointsByKeyword(keyword: $keyword, limit: $limit, offset: $offset, includeDisabled: false) {
    enabledSalesPointsCount
    salesPoints {
      id
      name
    }
  }
}
    `;

/**
 * __useSalesPointsOptionsByKeywordQuery__
 *
 * To run a query within a React component, call `useSalesPointsOptionsByKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesPointsOptionsByKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesPointsOptionsByKeywordQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSalesPointsOptionsByKeywordQuery(baseOptions: Apollo.QueryHookOptions<SalesPointsOptionsByKeywordQuery, SalesPointsOptionsByKeywordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesPointsOptionsByKeywordQuery, SalesPointsOptionsByKeywordQueryVariables>(SalesPointsOptionsByKeywordDocument, options);
      }
export function useSalesPointsOptionsByKeywordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesPointsOptionsByKeywordQuery, SalesPointsOptionsByKeywordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesPointsOptionsByKeywordQuery, SalesPointsOptionsByKeywordQueryVariables>(SalesPointsOptionsByKeywordDocument, options);
        }
export type SalesPointsOptionsByKeywordQueryHookResult = ReturnType<typeof useSalesPointsOptionsByKeywordQuery>;
export type SalesPointsOptionsByKeywordLazyQueryHookResult = ReturnType<typeof useSalesPointsOptionsByKeywordLazyQuery>;
export type SalesPointsOptionsByKeywordQueryResult = Apollo.QueryResult<SalesPointsOptionsByKeywordQuery, SalesPointsOptionsByKeywordQueryVariables>;
export const SubmitBriefAttachmentsDocument = gql`
    mutation submitBriefAttachments($id: ID!, $attachments: [ID]!, $tag: InputBriefMediaTag!, $sendNotificationMail: Boolean, $quoteOptions: InputBriefQuoteOptions) {
  submitBriefAttachments(briefId: $id, attachments: $attachments, tag: $tag, sendNotificationMail: $sendNotificationMail, quoteOptions: $quoteOptions) {
    id
    status
  }
}
    `;
export type SubmitBriefAttachmentsMutationFn = Apollo.MutationFunction<SubmitBriefAttachmentsMutation, SubmitBriefAttachmentsMutationVariables>;

/**
 * __useSubmitBriefAttachmentsMutation__
 *
 * To run a mutation, you first call `useSubmitBriefAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBriefAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBriefAttachmentsMutation, { data, loading, error }] = useSubmitBriefAttachmentsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attachments: // value for 'attachments'
 *      tag: // value for 'tag'
 *      sendNotificationMail: // value for 'sendNotificationMail'
 *      quoteOptions: // value for 'quoteOptions'
 *   },
 * });
 */
export function useSubmitBriefAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBriefAttachmentsMutation, SubmitBriefAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBriefAttachmentsMutation, SubmitBriefAttachmentsMutationVariables>(SubmitBriefAttachmentsDocument, options);
      }
export type SubmitBriefAttachmentsMutationHookResult = ReturnType<typeof useSubmitBriefAttachmentsMutation>;
export type SubmitBriefAttachmentsMutationResult = Apollo.MutationResult<SubmitBriefAttachmentsMutation>;
export type SubmitBriefAttachmentsMutationOptions = Apollo.BaseMutationOptions<SubmitBriefAttachmentsMutation, SubmitBriefAttachmentsMutationVariables>;
export const SubmitBriefConceptionDocument = gql`
    mutation submitBriefConception($briefId: ID!, $mediaId: ID!, $api: BriefApi!) {
  submitBriefConception(briefId: $briefId, mediaId: $mediaId, api: $api) {
    id
  }
}
    `;
export type SubmitBriefConceptionMutationFn = Apollo.MutationFunction<SubmitBriefConceptionMutation, SubmitBriefConceptionMutationVariables>;

/**
 * __useSubmitBriefConceptionMutation__
 *
 * To run a mutation, you first call `useSubmitBriefConceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBriefConceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBriefConceptionMutation, { data, loading, error }] = useSubmitBriefConceptionMutation({
 *   variables: {
 *      briefId: // value for 'briefId'
 *      mediaId: // value for 'mediaId'
 *      api: // value for 'api'
 *   },
 * });
 */
export function useSubmitBriefConceptionMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBriefConceptionMutation, SubmitBriefConceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBriefConceptionMutation, SubmitBriefConceptionMutationVariables>(SubmitBriefConceptionDocument, options);
      }
export type SubmitBriefConceptionMutationHookResult = ReturnType<typeof useSubmitBriefConceptionMutation>;
export type SubmitBriefConceptionMutationResult = Apollo.MutationResult<SubmitBriefConceptionMutation>;
export type SubmitBriefConceptionMutationOptions = Apollo.BaseMutationOptions<SubmitBriefConceptionMutation, SubmitBriefConceptionMutationVariables>;
export const UpdateBriefDocument = gql`
    mutation updateBrief($id: ID!, $brief: InputBrief!, $editDraft: Boolean!) {
  updateBrief(id: $id, brief: $brief, editDraft: $editDraft) {
    id
  }
}
    `;
export type UpdateBriefMutationFn = Apollo.MutationFunction<UpdateBriefMutation, UpdateBriefMutationVariables>;

/**
 * __useUpdateBriefMutation__
 *
 * To run a mutation, you first call `useUpdateBriefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBriefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBriefMutation, { data, loading, error }] = useUpdateBriefMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brief: // value for 'brief'
 *      editDraft: // value for 'editDraft'
 *   },
 * });
 */
export function useUpdateBriefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBriefMutation, UpdateBriefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBriefMutation, UpdateBriefMutationVariables>(UpdateBriefDocument, options);
      }
export type UpdateBriefMutationHookResult = ReturnType<typeof useUpdateBriefMutation>;
export type UpdateBriefMutationResult = Apollo.MutationResult<UpdateBriefMutation>;
export type UpdateBriefMutationOptions = Apollo.BaseMutationOptions<UpdateBriefMutation, UpdateBriefMutationVariables>;
export const UpdateBriefStatusDocument = gql`
    mutation updateBriefStatus($id: ID!, $status: BriefStatus!, $comment: String) {
  updateBriefStatus(briefId: $id, status: $status, comment: $comment) {
    id
  }
}
    `;
export type UpdateBriefStatusMutationFn = Apollo.MutationFunction<UpdateBriefStatusMutation, UpdateBriefStatusMutationVariables>;

/**
 * __useUpdateBriefStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBriefStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBriefStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBriefStatusMutation, { data, loading, error }] = useUpdateBriefStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateBriefStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBriefStatusMutation, UpdateBriefStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBriefStatusMutation, UpdateBriefStatusMutationVariables>(UpdateBriefStatusDocument, options);
      }
export type UpdateBriefStatusMutationHookResult = ReturnType<typeof useUpdateBriefStatusMutation>;
export type UpdateBriefStatusMutationResult = Apollo.MutationResult<UpdateBriefStatusMutation>;
export type UpdateBriefStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBriefStatusMutation, UpdateBriefStatusMutationVariables>;
export const UploadBriefMediaDocument = gql`
    mutation uploadBriefMedia($files: [Upload!], $urls: [InputMediaUrl!]) {
  uploadBriefMedia(files: $files, urls: $urls) {
    id
    filename
    url
    mimetype
    thumbnail
  }
}
    `;
export type UploadBriefMediaMutationFn = Apollo.MutationFunction<UploadBriefMediaMutation, UploadBriefMediaMutationVariables>;

/**
 * __useUploadBriefMediaMutation__
 *
 * To run a mutation, you first call `useUploadBriefMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBriefMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBriefMediaMutation, { data, loading, error }] = useUploadBriefMediaMutation({
 *   variables: {
 *      files: // value for 'files'
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useUploadBriefMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadBriefMediaMutation, UploadBriefMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBriefMediaMutation, UploadBriefMediaMutationVariables>(UploadBriefMediaDocument, options);
      }
export type UploadBriefMediaMutationHookResult = ReturnType<typeof useUploadBriefMediaMutation>;
export type UploadBriefMediaMutationResult = Apollo.MutationResult<UploadBriefMediaMutation>;
export type UploadBriefMediaMutationOptions = Apollo.BaseMutationOptions<UploadBriefMediaMutation, UploadBriefMediaMutationVariables>;
export const BriefsForPlanningDocument = gql`
    query briefsForPlanning($dateStart: Date!, $dateEnd: Date!, $filter: BriefsForPlanningFilter) {
  briefsForPlanning(dateStart: $dateStart, dateEnd: $dateEnd, filter: $filter) {
    id
    name
    status
    validStartDate
    validEndDate
    salesPointId
    briefSpecClient {
      id
      key
      value
      label
      parentId
      children {
        id
        key
        value
        label
      }
    }
  }
}
    `;

/**
 * __useBriefsForPlanningQuery__
 *
 * To run a query within a React component, call `useBriefsForPlanningQuery` and pass it any options that fit your needs.
 * When your component renders, `useBriefsForPlanningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBriefsForPlanningQuery({
 *   variables: {
 *      dateStart: // value for 'dateStart'
 *      dateEnd: // value for 'dateEnd'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBriefsForPlanningQuery(baseOptions: Apollo.QueryHookOptions<BriefsForPlanningQuery, BriefsForPlanningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BriefsForPlanningQuery, BriefsForPlanningQueryVariables>(BriefsForPlanningDocument, options);
      }
export function useBriefsForPlanningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BriefsForPlanningQuery, BriefsForPlanningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BriefsForPlanningQuery, BriefsForPlanningQueryVariables>(BriefsForPlanningDocument, options);
        }
export type BriefsForPlanningQueryHookResult = ReturnType<typeof useBriefsForPlanningQuery>;
export type BriefsForPlanningLazyQueryHookResult = ReturnType<typeof useBriefsForPlanningLazyQuery>;
export type BriefsForPlanningQueryResult = Apollo.QueryResult<BriefsForPlanningQuery, BriefsForPlanningQueryVariables>;
export const GetBriefsCountDocument = gql`
    query getBriefsCount($offset: Int, $limit: Int, $filter: BriefsFilter) {
  briefs(offset: $offset, limit: $limit, filter: $filter) {
    count
  }
}
    `;

/**
 * __useGetBriefsCountQuery__
 *
 * To run a query within a React component, call `useGetBriefsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBriefsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBriefsCountQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBriefsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetBriefsCountQuery, GetBriefsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBriefsCountQuery, GetBriefsCountQueryVariables>(GetBriefsCountDocument, options);
      }
export function useGetBriefsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBriefsCountQuery, GetBriefsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBriefsCountQuery, GetBriefsCountQueryVariables>(GetBriefsCountDocument, options);
        }
export type GetBriefsCountQueryHookResult = ReturnType<typeof useGetBriefsCountQuery>;
export type GetBriefsCountLazyQueryHookResult = ReturnType<typeof useGetBriefsCountLazyQuery>;
export type GetBriefsCountQueryResult = Apollo.QueryResult<GetBriefsCountQuery, GetBriefsCountQueryVariables>;
export const GetMediaByIdDocument = gql`
    query getMediaById($id: ID!) {
  mediaById(id: $id) {
    id
    details {
      description
      tips
      size
      tags {
        id
        label
      }
    }
    fileType
    name
    url
    thumbnail
    images {
      large
    }
    type
  }
}
    `;

/**
 * __useGetMediaByIdQuery__
 *
 * To run a query within a React component, call `useGetMediaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMediaByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMediaByIdQuery, GetMediaByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaByIdQuery, GetMediaByIdQueryVariables>(GetMediaByIdDocument, options);
      }
export function useGetMediaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaByIdQuery, GetMediaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaByIdQuery, GetMediaByIdQueryVariables>(GetMediaByIdDocument, options);
        }
export type GetMediaByIdQueryHookResult = ReturnType<typeof useGetMediaByIdQuery>;
export type GetMediaByIdLazyQueryHookResult = ReturnType<typeof useGetMediaByIdLazyQuery>;
export type GetMediaByIdQueryResult = Apollo.QueryResult<GetMediaByIdQuery, GetMediaByIdQueryVariables>;
export const UpdateCartWithProductsAvailabilityDocument = gql`
    mutation updateCartWithProductsAvailability {
  updateCartWithProductsAvailability {
    changes {
      item {
        product {
          name
        }
      }
      removed
      removedCount
    }
    cart {
      userId
      items {
        productId
        quantity
        totalPrice {
          basePrice {
            withoutTaxes
          }
        }
        product {
          id
          stock
          isStockEnabled
        }
        variationByQuantity {
          quantity
          values
        }
      }
      total {
        basePrice {
          withTaxes
          withoutTaxes
          taxAmount
          taxPercent
        }
      }
    }
  }
}
    `;
export type UpdateCartWithProductsAvailabilityMutationFn = Apollo.MutationFunction<UpdateCartWithProductsAvailabilityMutation, UpdateCartWithProductsAvailabilityMutationVariables>;

/**
 * __useUpdateCartWithProductsAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateCartWithProductsAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartWithProductsAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartWithProductsAvailabilityMutation, { data, loading, error }] = useUpdateCartWithProductsAvailabilityMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateCartWithProductsAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartWithProductsAvailabilityMutation, UpdateCartWithProductsAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartWithProductsAvailabilityMutation, UpdateCartWithProductsAvailabilityMutationVariables>(UpdateCartWithProductsAvailabilityDocument, options);
      }
export type UpdateCartWithProductsAvailabilityMutationHookResult = ReturnType<typeof useUpdateCartWithProductsAvailabilityMutation>;
export type UpdateCartWithProductsAvailabilityMutationResult = Apollo.MutationResult<UpdateCartWithProductsAvailabilityMutation>;
export type UpdateCartWithProductsAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateCartWithProductsAvailabilityMutation, UpdateCartWithProductsAvailabilityMutationVariables>;
export const DownloadLibraryMediasDocument = gql`
    mutation downloadLibraryMedias($ids: [ID!]!) {
  downloadLibraryMedias(ids: $ids) {
    url
    filename
  }
}
    `;
export type DownloadLibraryMediasMutationFn = Apollo.MutationFunction<DownloadLibraryMediasMutation, DownloadLibraryMediasMutationVariables>;

/**
 * __useDownloadLibraryMediasMutation__
 *
 * To run a mutation, you first call `useDownloadLibraryMediasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadLibraryMediasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadLibraryMediasMutation, { data, loading, error }] = useDownloadLibraryMediasMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDownloadLibraryMediasMutation(baseOptions?: Apollo.MutationHookOptions<DownloadLibraryMediasMutation, DownloadLibraryMediasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadLibraryMediasMutation, DownloadLibraryMediasMutationVariables>(DownloadLibraryMediasDocument, options);
      }
export type DownloadLibraryMediasMutationHookResult = ReturnType<typeof useDownloadLibraryMediasMutation>;
export type DownloadLibraryMediasMutationResult = Apollo.MutationResult<DownloadLibraryMediasMutation>;
export type DownloadLibraryMediasMutationOptions = Apollo.BaseMutationOptions<DownloadLibraryMediasMutation, DownloadLibraryMediasMutationVariables>;
export const GetFolderFiltersDocument = gql`
    query getFolderFilters($id: ID!) {
  folderById(id: $id) {
    salespointsGroups {
      id
      name
    }
    validFrom
    validTo
  }
}
    `;

/**
 * __useGetFolderFiltersQuery__
 *
 * To run a query within a React component, call `useGetFolderFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFolderFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFolderFiltersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFolderFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetFolderFiltersQuery, GetFolderFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFolderFiltersQuery, GetFolderFiltersQueryVariables>(GetFolderFiltersDocument, options);
      }
export function useGetFolderFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFolderFiltersQuery, GetFolderFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFolderFiltersQuery, GetFolderFiltersQueryVariables>(GetFolderFiltersDocument, options);
        }
export type GetFolderFiltersQueryHookResult = ReturnType<typeof useGetFolderFiltersQuery>;
export type GetFolderFiltersLazyQueryHookResult = ReturnType<typeof useGetFolderFiltersLazyQuery>;
export type GetFolderFiltersQueryResult = Apollo.QueryResult<GetFolderFiltersQuery, GetFolderFiltersQueryVariables>;
export const HighlightedMediasDocument = gql`
    query highlightedMedias($bypassSalespointsGroups: Boolean, $salespointsGroups: [ID], $excludeDisabledForAdmin: Boolean = false) {
  highlightedMedias(bypassSalespointsGroups: $bypassSalespointsGroups, salespointsGroups: $salespointsGroups, excludeDisabledForAdmin: $excludeDisabledForAdmin) {
    totalCount
    tag {
      id
      label
      enabled
      createdAt
      updatedAt
      library {
        isHighlighted
        highlightOrder
      }
    }
    medias {
      id
      name
      type
      details {
        description
        tips
        size
        mimetype
        tags {
          id
          label
        }
      }
      fileType
      thumbnail
      tempUrl
      enabled
      images {
        thumbnail
        large
        medium
        small
      }
    }
  }
}
    `;

/**
 * __useHighlightedMediasQuery__
 *
 * To run a query within a React component, call `useHighlightedMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightedMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightedMediasQuery({
 *   variables: {
 *      bypassSalespointsGroups: // value for 'bypassSalespointsGroups'
 *      salespointsGroups: // value for 'salespointsGroups'
 *      excludeDisabledForAdmin: // value for 'excludeDisabledForAdmin'
 *   },
 * });
 */
export function useHighlightedMediasQuery(baseOptions?: Apollo.QueryHookOptions<HighlightedMediasQuery, HighlightedMediasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightedMediasQuery, HighlightedMediasQueryVariables>(HighlightedMediasDocument, options);
      }
export function useHighlightedMediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightedMediasQuery, HighlightedMediasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightedMediasQuery, HighlightedMediasQueryVariables>(HighlightedMediasDocument, options);
        }
export type HighlightedMediasQueryHookResult = ReturnType<typeof useHighlightedMediasQuery>;
export type HighlightedMediasLazyQueryHookResult = ReturnType<typeof useHighlightedMediasLazyQuery>;
export type HighlightedMediasQueryResult = Apollo.QueryResult<HighlightedMediasQuery, HighlightedMediasQueryVariables>;
export const InfiniteMediasDocument = gql`
    query infiniteMedias($offset: Int = 0, $limit: Int = 30, $sort: MediaSort, $folderId: ID, $filters: [MediaFilterInput], $keyword: String, $searchInSubfolders: Boolean = false, $bypassSalespointsGroups: Boolean, $salespointsGroups: [ID], $campaignId: ID, $includeHighlighted: Boolean = false, $excludeDisabledForAdmin: Boolean = false, $types: [MediaTypeFilter]) {
  medias(offset: $offset, limit: $limit, sort: $sort, folderId: $folderId, filters: $filters, keyword: $keyword, searchInSubfolders: $searchInSubfolders, bypassSalespointsGroups: $bypassSalespointsGroups, salespointsGroups: $salespointsGroups, campaignId: $campaignId, includeHighlighted: $includeHighlighted, excludeDisabledForAdmin: $excludeDisabledForAdmin, types: $types) {
    count
    medias {
      id
      name
      type
      details {
        description
        tips
        size
        mimetype
        tags {
          id
          label
        }
      }
      fileType
      thumbnail
      tempUrl
      enabled
      images {
        thumbnail
        large
        medium
        small
      }
    }
    highlighted {
      tag {
        id
        label
        enabled
        createdAt
        updatedAt
        library {
          isHighlighted
          highlightOrder
        }
      }
      medias {
        id
        name
        type
        details {
          description
          tips
          size
          mimetype
          tags {
            id
            label
          }
        }
        fileType
        thumbnail
        tempUrl
        enabled
        images {
          thumbnail
          large
          medium
          small
        }
      }
    }
  }
}
    `;

/**
 * __useInfiniteMediasQuery__
 *
 * To run a query within a React component, call `useInfiniteMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfiniteMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfiniteMediasQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      folderId: // value for 'folderId'
 *      filters: // value for 'filters'
 *      keyword: // value for 'keyword'
 *      searchInSubfolders: // value for 'searchInSubfolders'
 *      bypassSalespointsGroups: // value for 'bypassSalespointsGroups'
 *      salespointsGroups: // value for 'salespointsGroups'
 *      campaignId: // value for 'campaignId'
 *      includeHighlighted: // value for 'includeHighlighted'
 *      excludeDisabledForAdmin: // value for 'excludeDisabledForAdmin'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useInfiniteMediasQuery(baseOptions?: Apollo.QueryHookOptions<InfiniteMediasQuery, InfiniteMediasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfiniteMediasQuery, InfiniteMediasQueryVariables>(InfiniteMediasDocument, options);
      }
export function useInfiniteMediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfiniteMediasQuery, InfiniteMediasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfiniteMediasQuery, InfiniteMediasQueryVariables>(InfiniteMediasDocument, options);
        }
export type InfiniteMediasQueryHookResult = ReturnType<typeof useInfiniteMediasQuery>;
export type InfiniteMediasLazyQueryHookResult = ReturnType<typeof useInfiniteMediasLazyQuery>;
export type InfiniteMediasQueryResult = Apollo.QueryResult<InfiniteMediasQuery, InfiniteMediasQueryVariables>;
export const MoveLibraryMediasDocument = gql`
    mutation moveLibraryMedias($ids: [ID!]!, $targetFolder: ID) {
  moveLibraryMedias(ids: $ids, targetFolder: $targetFolder)
}
    `;
export type MoveLibraryMediasMutationFn = Apollo.MutationFunction<MoveLibraryMediasMutation, MoveLibraryMediasMutationVariables>;

/**
 * __useMoveLibraryMediasMutation__
 *
 * To run a mutation, you first call `useMoveLibraryMediasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLibraryMediasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLibraryMediasMutation, { data, loading, error }] = useMoveLibraryMediasMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      targetFolder: // value for 'targetFolder'
 *   },
 * });
 */
export function useMoveLibraryMediasMutation(baseOptions?: Apollo.MutationHookOptions<MoveLibraryMediasMutation, MoveLibraryMediasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveLibraryMediasMutation, MoveLibraryMediasMutationVariables>(MoveLibraryMediasDocument, options);
      }
export type MoveLibraryMediasMutationHookResult = ReturnType<typeof useMoveLibraryMediasMutation>;
export type MoveLibraryMediasMutationResult = Apollo.MutationResult<MoveLibraryMediasMutation>;
export type MoveLibraryMediasMutationOptions = Apollo.BaseMutationOptions<MoveLibraryMediasMutation, MoveLibraryMediasMutationVariables>;
export const CommitOrderPaymentDocument = gql`
    mutation commitOrderPayment($orderIds: [ID!]!, $stripePaymentMethod: StripePaymentMethod) {
  commitOrderPayment(orderIds: $orderIds, stripePaymentMethod: $stripePaymentMethod)
}
    `;
export type CommitOrderPaymentMutationFn = Apollo.MutationFunction<CommitOrderPaymentMutation, CommitOrderPaymentMutationVariables>;

/**
 * __useCommitOrderPaymentMutation__
 *
 * To run a mutation, you first call `useCommitOrderPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitOrderPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitOrderPaymentMutation, { data, loading, error }] = useCommitOrderPaymentMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *      stripePaymentMethod: // value for 'stripePaymentMethod'
 *   },
 * });
 */
export function useCommitOrderPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CommitOrderPaymentMutation, CommitOrderPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitOrderPaymentMutation, CommitOrderPaymentMutationVariables>(CommitOrderPaymentDocument, options);
      }
export type CommitOrderPaymentMutationHookResult = ReturnType<typeof useCommitOrderPaymentMutation>;
export type CommitOrderPaymentMutationResult = Apollo.MutationResult<CommitOrderPaymentMutation>;
export type CommitOrderPaymentMutationOptions = Apollo.BaseMutationOptions<CommitOrderPaymentMutation, CommitOrderPaymentMutationVariables>;
export const GetOrdersToValidateDocument = gql`
    query getOrdersToValidate($offset: Int, $limit: Int, $filter: OrderFilter, $sort: Direction) {
  ordersToValidate(offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    count
    orders {
      id
      isValidator
      orderNumber
      trackingNumber
      trackingURL
      userId
      status
      receipt
      totalProductsQuantity
      date
      isPurchaseOrder
      paymentMethod {
        type
        documentType
      }
      paymentInfo {
        currentStatus
        stripePaymentMethod
      }
      author {
        id
        fullName
      }
      salespoint {
        id
        name
      }
      items {
        productId
        subId
        product {
          id
          name
          ref
          description
          isCustomizable
          type
          images {
            small
          }
          tags {
            id
            label
            color
          }
          highQualityAsset {
            url
            name
          }
        }
        variationByQuantity {
          quantity
          values
        }
        quantity
      }
      addresses {
        shipping {
          firstname
          lastname
          company
          phone
          address
          postalCode
          city
          country
        }
        billing {
          firstname
          lastname
          company
          phone
          address
          postalCode
          city
          country
        }
      }
      vouchers {
        name
        amount
      }
      provider {
        name
      }
      total {
        basePrice {
          withoutTaxes
          withTaxes
          taxPercent
          taxAmount
        }
        discountedPrice {
          withoutTaxes
          withTaxes
          taxAmount
          taxPercent
        }
      }
      totalWithFees {
        basePrice {
          withoutTaxes
          taxPercent
          taxAmount
          withTaxes
        }
        discountedPrice {
          withoutTaxes
          withTaxes
          taxAmount
          taxPercent
        }
      }
      totalWithShippingFees {
        basePrice {
          withoutTaxes
          withTaxes
          taxPercent
          taxAmount
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrdersToValidateQuery__
 *
 * To run a query within a React component, call `useGetOrdersToValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersToValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersToValidateQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrdersToValidateQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersToValidateQuery, GetOrdersToValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersToValidateQuery, GetOrdersToValidateQueryVariables>(GetOrdersToValidateDocument, options);
      }
export function useGetOrdersToValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersToValidateQuery, GetOrdersToValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersToValidateQuery, GetOrdersToValidateQueryVariables>(GetOrdersToValidateDocument, options);
        }
export type GetOrdersToValidateQueryHookResult = ReturnType<typeof useGetOrdersToValidateQuery>;
export type GetOrdersToValidateLazyQueryHookResult = ReturnType<typeof useGetOrdersToValidateLazyQuery>;
export type GetOrdersToValidateQueryResult = Apollo.QueryResult<GetOrdersToValidateQuery, GetOrdersToValidateQueryVariables>;
export const GetOrdersValidatedDocument = gql`
    query getOrdersValidated($offset: Int, $limit: Int, $filter: OrderFilter, $sort: Direction) {
  ordersValidated(offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    count
    orders {
      id
      orderNumber
      status
      date
      total {
        basePrice {
          withTaxes
          withoutTaxes
        }
      }
      totalWithShippingFees {
        basePrice {
          withTaxes
          withoutTaxes
        }
      }
      salespoint {
        id
        name
      }
      provider {
        name
      }
      author {
        email
        fullName
      }
      items {
        productId
        quantity
      }
    }
  }
}
    `;

/**
 * __useGetOrdersValidatedQuery__
 *
 * To run a query within a React component, call `useGetOrdersValidatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersValidatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersValidatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrdersValidatedQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersValidatedQuery, GetOrdersValidatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersValidatedQuery, GetOrdersValidatedQueryVariables>(GetOrdersValidatedDocument, options);
      }
export function useGetOrdersValidatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersValidatedQuery, GetOrdersValidatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersValidatedQuery, GetOrdersValidatedQueryVariables>(GetOrdersValidatedDocument, options);
        }
export type GetOrdersValidatedQueryHookResult = ReturnType<typeof useGetOrdersValidatedQuery>;
export type GetOrdersValidatedLazyQueryHookResult = ReturnType<typeof useGetOrdersValidatedLazyQuery>;
export type GetOrdersValidatedQueryResult = Apollo.QueryResult<GetOrdersValidatedQuery, GetOrdersValidatedQueryVariables>;
export const ValidateOrdersDocument = gql`
    mutation validateOrders($ordersIds: [ID!]!, $action: String!, $reason: String) {
  validateOrders(orderIds: $ordersIds, action: $action, reason: $reason)
}
    `;
export type ValidateOrdersMutationFn = Apollo.MutationFunction<ValidateOrdersMutation, ValidateOrdersMutationVariables>;

/**
 * __useValidateOrdersMutation__
 *
 * To run a mutation, you first call `useValidateOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOrdersMutation, { data, loading, error }] = useValidateOrdersMutation({
 *   variables: {
 *      ordersIds: // value for 'ordersIds'
 *      action: // value for 'action'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useValidateOrdersMutation(baseOptions?: Apollo.MutationHookOptions<ValidateOrdersMutation, ValidateOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateOrdersMutation, ValidateOrdersMutationVariables>(ValidateOrdersDocument, options);
      }
export type ValidateOrdersMutationHookResult = ReturnType<typeof useValidateOrdersMutation>;
export type ValidateOrdersMutationResult = Apollo.MutationResult<ValidateOrdersMutation>;
export type ValidateOrdersMutationOptions = Apollo.BaseMutationOptions<ValidateOrdersMutation, ValidateOrdersMutationVariables>;
export const AddMultipleItemsToCartDocument = gql`
    mutation addMultipleItemsToCart($items: [CartItemInput]) {
  addMultipleItemsToCart(items: $items) {
    items {
      productId
      providerId
      packInfo {
        id
        name
        ref
        productsInPack {
          id
          name
          ref
        }
      }
      files {
        id
        originalName
      }
      subId
    }
  }
}
    `;
export type AddMultipleItemsToCartMutationFn = Apollo.MutationFunction<AddMultipleItemsToCartMutation, AddMultipleItemsToCartMutationVariables>;

/**
 * __useAddMultipleItemsToCartMutation__
 *
 * To run a mutation, you first call `useAddMultipleItemsToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMultipleItemsToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMultipleItemsToCartMutation, { data, loading, error }] = useAddMultipleItemsToCartMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useAddMultipleItemsToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddMultipleItemsToCartMutation, AddMultipleItemsToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMultipleItemsToCartMutation, AddMultipleItemsToCartMutationVariables>(AddMultipleItemsToCartDocument, options);
      }
export type AddMultipleItemsToCartMutationHookResult = ReturnType<typeof useAddMultipleItemsToCartMutation>;
export type AddMultipleItemsToCartMutationResult = Apollo.MutationResult<AddMultipleItemsToCartMutation>;
export type AddMultipleItemsToCartMutationOptions = Apollo.BaseMutationOptions<AddMultipleItemsToCartMutation, AddMultipleItemsToCartMutationVariables>;
export const ProductInfo_AddCartItemFilesDocument = gql`
    mutation ProductInfo_addCartItemFiles($productId: ID!, $packId: ID, $subId: ID, $files: [Upload!], $existingFileIds: [ID!]) {
  addCartItemFiles(productId: $productId, packId: $packId, subId: $subId, files: $files, existingFileIds: $existingFileIds) {
    userId
    items {
      productId
      files {
        id
        originalName
      }
    }
  }
}
    `;
export type ProductInfo_AddCartItemFilesMutationFn = Apollo.MutationFunction<ProductInfo_AddCartItemFilesMutation, ProductInfo_AddCartItemFilesMutationVariables>;

/**
 * __useProductInfo_AddCartItemFilesMutation__
 *
 * To run a mutation, you first call `useProductInfo_AddCartItemFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductInfo_AddCartItemFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productInfoAddCartItemFilesMutation, { data, loading, error }] = useProductInfo_AddCartItemFilesMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      packId: // value for 'packId'
 *      subId: // value for 'subId'
 *      files: // value for 'files'
 *      existingFileIds: // value for 'existingFileIds'
 *   },
 * });
 */
export function useProductInfo_AddCartItemFilesMutation(baseOptions?: Apollo.MutationHookOptions<ProductInfo_AddCartItemFilesMutation, ProductInfo_AddCartItemFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductInfo_AddCartItemFilesMutation, ProductInfo_AddCartItemFilesMutationVariables>(ProductInfo_AddCartItemFilesDocument, options);
      }
export type ProductInfo_AddCartItemFilesMutationHookResult = ReturnType<typeof useProductInfo_AddCartItemFilesMutation>;
export type ProductInfo_AddCartItemFilesMutationResult = Apollo.MutationResult<ProductInfo_AddCartItemFilesMutation>;
export type ProductInfo_AddCartItemFilesMutationOptions = Apollo.BaseMutationOptions<ProductInfo_AddCartItemFilesMutation, ProductInfo_AddCartItemFilesMutationVariables>;
export const ProductInfo_DeleteCartItemFileDocument = gql`
    mutation ProductInfo_deleteCartItemFile($fileId: ID!) {
  deleteCartItemFile(fileId: $fileId) {
    userId
    items {
      productId
      files {
        id
        originalName
      }
    }
  }
}
    `;
export type ProductInfo_DeleteCartItemFileMutationFn = Apollo.MutationFunction<ProductInfo_DeleteCartItemFileMutation, ProductInfo_DeleteCartItemFileMutationVariables>;

/**
 * __useProductInfo_DeleteCartItemFileMutation__
 *
 * To run a mutation, you first call `useProductInfo_DeleteCartItemFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductInfo_DeleteCartItemFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productInfoDeleteCartItemFileMutation, { data, loading, error }] = useProductInfo_DeleteCartItemFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useProductInfo_DeleteCartItemFileMutation(baseOptions?: Apollo.MutationHookOptions<ProductInfo_DeleteCartItemFileMutation, ProductInfo_DeleteCartItemFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductInfo_DeleteCartItemFileMutation, ProductInfo_DeleteCartItemFileMutationVariables>(ProductInfo_DeleteCartItemFileDocument, options);
      }
export type ProductInfo_DeleteCartItemFileMutationHookResult = ReturnType<typeof useProductInfo_DeleteCartItemFileMutation>;
export type ProductInfo_DeleteCartItemFileMutationResult = Apollo.MutationResult<ProductInfo_DeleteCartItemFileMutation>;
export type ProductInfo_DeleteCartItemFileMutationOptions = Apollo.BaseMutationOptions<ProductInfo_DeleteCartItemFileMutation, ProductInfo_DeleteCartItemFileMutationVariables>;
export const CancelOrderByProviderDocument = gql`
    mutation cancelOrderByProvider($orderId: ID!, $reason: String!) {
  cancelOrderByProvider(orderId: $orderId, reason: $reason) {
    id
    status
    reason
    messages {
      content
      isCancelledReason
    }
  }
}
    `;
export type CancelOrderByProviderMutationFn = Apollo.MutationFunction<CancelOrderByProviderMutation, CancelOrderByProviderMutationVariables>;

/**
 * __useCancelOrderByProviderMutation__
 *
 * To run a mutation, you first call `useCancelOrderByProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderByProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderByProviderMutation, { data, loading, error }] = useCancelOrderByProviderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelOrderByProviderMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrderByProviderMutation, CancelOrderByProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrderByProviderMutation, CancelOrderByProviderMutationVariables>(CancelOrderByProviderDocument, options);
      }
export type CancelOrderByProviderMutationHookResult = ReturnType<typeof useCancelOrderByProviderMutation>;
export type CancelOrderByProviderMutationResult = Apollo.MutationResult<CancelOrderByProviderMutation>;
export type CancelOrderByProviderMutationOptions = Apollo.BaseMutationOptions<CancelOrderByProviderMutation, CancelOrderByProviderMutationVariables>;
export const GetPaidMediaCampaignDocument = gql`
    query getPaidMediaCampaign($orderId: ID!, $clientId: String!) {
  getPaidMediaCampaign(orderId: $orderId, clientId: $clientId) {
    id
  }
}
    `;

/**
 * __useGetPaidMediaCampaignQuery__
 *
 * To run a query within a React component, call `useGetPaidMediaCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaidMediaCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaidMediaCampaignQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetPaidMediaCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetPaidMediaCampaignQuery, GetPaidMediaCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaidMediaCampaignQuery, GetPaidMediaCampaignQueryVariables>(GetPaidMediaCampaignDocument, options);
      }
export function useGetPaidMediaCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaidMediaCampaignQuery, GetPaidMediaCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaidMediaCampaignQuery, GetPaidMediaCampaignQueryVariables>(GetPaidMediaCampaignDocument, options);
        }
export type GetPaidMediaCampaignQueryHookResult = ReturnType<typeof useGetPaidMediaCampaignQuery>;
export type GetPaidMediaCampaignLazyQueryHookResult = ReturnType<typeof useGetPaidMediaCampaignLazyQuery>;
export type GetPaidMediaCampaignQueryResult = Apollo.QueryResult<GetPaidMediaCampaignQuery, GetPaidMediaCampaignQueryVariables>;
export const ReplaceFileProductDocument = gql`
    mutation replaceFileProduct($orderId: ID!, $productId: ID!, $file: Upload!, $subId: ID) {
  replaceFileValidationOrders(orderId: $orderId, productId: $productId, file: $file, subId: $subId)
}
    `;
export type ReplaceFileProductMutationFn = Apollo.MutationFunction<ReplaceFileProductMutation, ReplaceFileProductMutationVariables>;

/**
 * __useReplaceFileProductMutation__
 *
 * To run a mutation, you first call `useReplaceFileProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceFileProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceFileProductMutation, { data, loading, error }] = useReplaceFileProductMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productId: // value for 'productId'
 *      file: // value for 'file'
 *      subId: // value for 'subId'
 *   },
 * });
 */
export function useReplaceFileProductMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceFileProductMutation, ReplaceFileProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceFileProductMutation, ReplaceFileProductMutationVariables>(ReplaceFileProductDocument, options);
      }
export type ReplaceFileProductMutationHookResult = ReturnType<typeof useReplaceFileProductMutation>;
export type ReplaceFileProductMutationResult = Apollo.MutationResult<ReplaceFileProductMutation>;
export type ReplaceFileProductMutationOptions = Apollo.BaseMutationOptions<ReplaceFileProductMutation, ReplaceFileProductMutationVariables>;
export const OrderDetails_OrderDetailsProviderDocument = gql`
    query OrderDetails_orderDetailsProvider($orderId: ID!) {
  orderDetailsProvider(orderId: $orderId) {
    id
    orderNumber
    trackingNumber
    trackingURL
    userId
    eskerNumber
    status
    receipt
    totalProductsQuantity
    date
    shippingFees
    client {
      id
      clientId
      shopOptions {
        isShippingFeesEnabled
        displayTaxes
      }
    }
    paymentMethod {
      type
      documentType
    }
    messages {
      id
      content
      createdAt
      isCancelledReason
    }
    author {
      email
    }
    validator {
      email
    }
    hasArchive
    items {
      hasArchive
      comment
      productId
      subId
      options {
        name
      }
      product {
        id
        name
        ref
        description
        isCustomizable
        isPaidMediaProduct
        packagingUnit
        images {
          small
        }
        tags {
          id
          label
          color
        }
        highQualityAsset {
          url
          name
        }
      }
      quantity
      variationByQuantity {
        quantity
        values
      }
    }
    addresses {
      shipping {
        firstname
        lastname
        company
        phone
        address
        postalCode
        city
        country
      }
      billing {
        firstname
        lastname
        company
        phone
        address
        postalCode
        city
        country
      }
    }
    vouchers {
      name
      amount
    }
    total {
      basePrice {
        withoutTaxes
        withTaxes
        taxPercent
        taxAmount
      }
    }
    totalWithFees {
      basePrice {
        withoutTaxes
        taxPercent
        taxAmount
        withTaxes
      }
      discountedPrice {
        withoutTaxes
        withTaxes
        taxAmount
        taxPercent
      }
    }
    totalWithShippingFees {
      basePrice {
        withTaxes
        withoutTaxes
        taxAmount
        taxPercent
      }
      discountedPrice {
        withoutTaxes
        withTaxes
        taxAmount
        taxPercent
      }
    }
    paymentInfo {
      isMultiProvider
      status {
        date
        value
      }
      currentStatus
      paymentIntentId
      stripePaymentMethod
      stripeUrl
      stripeFee
      transfers {
        stripeUrl
        transferOriginId
        orderNumber
      }
    }
    providerInvoice {
      filename
      path
      created_at
    }
  }
}
    `;

/**
 * __useOrderDetails_OrderDetailsProviderQuery__
 *
 * To run a query within a React component, call `useOrderDetails_OrderDetailsProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetails_OrderDetailsProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetails_OrderDetailsProviderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderDetails_OrderDetailsProviderQuery(baseOptions: Apollo.QueryHookOptions<OrderDetails_OrderDetailsProviderQuery, OrderDetails_OrderDetailsProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderDetails_OrderDetailsProviderQuery, OrderDetails_OrderDetailsProviderQueryVariables>(OrderDetails_OrderDetailsProviderDocument, options);
      }
export function useOrderDetails_OrderDetailsProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderDetails_OrderDetailsProviderQuery, OrderDetails_OrderDetailsProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderDetails_OrderDetailsProviderQuery, OrderDetails_OrderDetailsProviderQueryVariables>(OrderDetails_OrderDetailsProviderDocument, options);
        }
export type OrderDetails_OrderDetailsProviderQueryHookResult = ReturnType<typeof useOrderDetails_OrderDetailsProviderQuery>;
export type OrderDetails_OrderDetailsProviderLazyQueryHookResult = ReturnType<typeof useOrderDetails_OrderDetailsProviderLazyQuery>;
export type OrderDetails_OrderDetailsProviderQueryResult = Apollo.QueryResult<OrderDetails_OrderDetailsProviderQuery, OrderDetails_OrderDetailsProviderQueryVariables>;
export const OrdersByProviderDocument = gql`
    query ordersByProvider($offset: Int, $limit: Int, $sort: Direction, $filter: OrderFilter) {
  ordersByProvider(offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
    count
    orders {
      id
      orderNumber
      trackingNumber
      trackingURL
      userId
      status
      receipt
      totalProductsQuantity
      date
      paymentMethod {
        type
      }
      items {
        productId
        subId
        product {
          id
          name
          ref
          description
          isCustomizable
          images {
            small
          }
          tags {
            id
            label
            color
          }
          highQualityAsset {
            url
            name
          }
        }
        quantity
      }
      addresses {
        shipping {
          firstname
          lastname
          company
          phone
          address
          postalCode
          city
          country
        }
        billing {
          firstname
          lastname
          company
          phone
          address
          postalCode
          city
          country
        }
      }
      vouchers {
        name
        amount
      }
      total {
        basePrice {
          withoutTaxes
          withTaxes
          taxPercent
          taxAmount
        }
        discountedPrice {
          withoutTaxes
          withTaxes
          taxAmount
          taxPercent
        }
      }
      totalWithShippingFees {
        basePrice {
          withoutTaxes
          taxPercent
          taxAmount
          withTaxes
        }
        discountedPrice {
          withoutTaxes
          withTaxes
          taxAmount
          taxPercent
        }
      }
      paymentInfo {
        isMultiProvider
        status {
          date
          value
        }
        currentStatus
        paymentIntentId
        stripePaymentMethod
        stripeUrl
        stripeFee
        transfers {
          stripeUrl
          transferOriginId
          orderNumber
        }
      }
      providerInvoice {
        filename
        path
        created_at
      }
    }
  }
}
    `;

/**
 * __useOrdersByProviderQuery__
 *
 * To run a query within a React component, call `useOrdersByProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersByProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersByProviderQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrdersByProviderQuery(baseOptions?: Apollo.QueryHookOptions<OrdersByProviderQuery, OrdersByProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersByProviderQuery, OrdersByProviderQueryVariables>(OrdersByProviderDocument, options);
      }
export function useOrdersByProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersByProviderQuery, OrdersByProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersByProviderQuery, OrdersByProviderQueryVariables>(OrdersByProviderDocument, options);
        }
export type OrdersByProviderQueryHookResult = ReturnType<typeof useOrdersByProviderQuery>;
export type OrdersByProviderLazyQueryHookResult = ReturnType<typeof useOrdersByProviderLazyQuery>;
export type OrdersByProviderQueryResult = Apollo.QueryResult<OrdersByProviderQuery, OrdersByProviderQueryVariables>;
export const ArchiveAllNotificationsDocument = gql`
    mutation archiveAllNotifications($filters: NotificationFilters!) {
  archiveAllNotifications(filters: $filters) {
    success
  }
}
    `;
export type ArchiveAllNotificationsMutationFn = Apollo.MutationFunction<ArchiveAllNotificationsMutation, ArchiveAllNotificationsMutationVariables>;

/**
 * __useArchiveAllNotificationsMutation__
 *
 * To run a mutation, you first call `useArchiveAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAllNotificationsMutation, { data, loading, error }] = useArchiveAllNotificationsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useArchiveAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAllNotificationsMutation, ArchiveAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAllNotificationsMutation, ArchiveAllNotificationsMutationVariables>(ArchiveAllNotificationsDocument, options);
      }
export type ArchiveAllNotificationsMutationHookResult = ReturnType<typeof useArchiveAllNotificationsMutation>;
export type ArchiveAllNotificationsMutationResult = Apollo.MutationResult<ArchiveAllNotificationsMutation>;
export type ArchiveAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ArchiveAllNotificationsMutation, ArchiveAllNotificationsMutationVariables>;
export const ArchiveNotificationsDocument = gql`
    mutation archiveNotifications($ids: [ID]!) {
  archiveNotifications(ids: $ids) {
    success
  }
}
    `;
export type ArchiveNotificationsMutationFn = Apollo.MutationFunction<ArchiveNotificationsMutation, ArchiveNotificationsMutationVariables>;

/**
 * __useArchiveNotificationsMutation__
 *
 * To run a mutation, you first call `useArchiveNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNotificationsMutation, { data, loading, error }] = useArchiveNotificationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useArchiveNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNotificationsMutation, ArchiveNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNotificationsMutation, ArchiveNotificationsMutationVariables>(ArchiveNotificationsDocument, options);
      }
export type ArchiveNotificationsMutationHookResult = ReturnType<typeof useArchiveNotificationsMutation>;
export type ArchiveNotificationsMutationResult = Apollo.MutationResult<ArchiveNotificationsMutation>;
export type ArchiveNotificationsMutationOptions = Apollo.BaseMutationOptions<ArchiveNotificationsMutation, ArchiveNotificationsMutationVariables>;
export const ExportNotificationsListDocument = gql`
    query exportNotificationsList($filters: NotificationFilters!) {
  exportNotificationsList(filters: $filters) {
    mediaLink
  }
}
    `;

/**
 * __useExportNotificationsListQuery__
 *
 * To run a query within a React component, call `useExportNotificationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportNotificationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportNotificationsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportNotificationsListQuery(baseOptions: Apollo.QueryHookOptions<ExportNotificationsListQuery, ExportNotificationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportNotificationsListQuery, ExportNotificationsListQueryVariables>(ExportNotificationsListDocument, options);
      }
export function useExportNotificationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportNotificationsListQuery, ExportNotificationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportNotificationsListQuery, ExportNotificationsListQueryVariables>(ExportNotificationsListDocument, options);
        }
export type ExportNotificationsListQueryHookResult = ReturnType<typeof useExportNotificationsListQuery>;
export type ExportNotificationsListLazyQueryHookResult = ReturnType<typeof useExportNotificationsListLazyQuery>;
export type ExportNotificationsListQueryResult = Apollo.QueryResult<ExportNotificationsListQuery, ExportNotificationsListQueryVariables>;
export const GetNotificationDetailsDocument = gql`
    query getNotificationDetails($id: ID!, $status: NotificationReplyStatus!) {
  getNotificationDetails(id: $id, status: $status) {
    replies {
      id
      message
      type
      createdAt
      status
      validationDate
      validatorRole
      validator {
        id
        fullName
      }
      author {
        id
        fullName
      }
    }
    notification {
      id
      isRead
      isAnswered
      isLiked
      isHidden
      isUpdated
      rating
      recommandation
      picture
      video
      postId
      createdAt
      type
      message
      url
      notificationId
      author
      socialNetwork
      salesPointTargeted {
        id
        name
      }
      isPendingApproval
    }
    post {
      id
      socialNetworkPostId
      description
      textDescription
      createdAt
      author {
        id
        firstname
        lastname
      }
      authorRole
      type
      totalStatus {
        posted
        error
        other
      }
      status
      target {
        type
      }
      socialNetworkTarget
      analyze {
        engagementRate
        totalReactions
        shares
        comments
        engagement
        reach
        insightPaid
        insightUnpaid
        likes
        love
        care
        haha
        wow
        sorry
        anger
      }
      medias {
        path
        mimeType
      }
      thumb {
        path
        mimeType
      }
      avatar {
        path
        mimeType
      }
      cover {
        path
        mimeType
      }
      link
      carouselItems {
        media {
          path
          mimeType
        }
      }
      authorId
      isDraft
      isDeletable
      isDuplicatable
      isEditable
      isAmplified
      salesPointTargeted {
        name
      }
      socialNetworkPostUrl
    }
  }
}
    `;

/**
 * __useGetNotificationDetailsQuery__
 *
 * To run a query within a React component, call `useGetNotificationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetNotificationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationDetailsQuery, GetNotificationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationDetailsQuery, GetNotificationDetailsQueryVariables>(GetNotificationDetailsDocument, options);
      }
export function useGetNotificationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationDetailsQuery, GetNotificationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationDetailsQuery, GetNotificationDetailsQueryVariables>(GetNotificationDetailsDocument, options);
        }
export type GetNotificationDetailsQueryHookResult = ReturnType<typeof useGetNotificationDetailsQuery>;
export type GetNotificationDetailsLazyQueryHookResult = ReturnType<typeof useGetNotificationDetailsLazyQuery>;
export type GetNotificationDetailsQueryResult = Apollo.QueryResult<GetNotificationDetailsQuery, GetNotificationDetailsQueryVariables>;
export const GetNotificationsListDocument = gql`
    query getNotificationsList($filters: NotificationFilters!, $offset: Int, $limit: Int, $toValidate: Boolean) {
  getNotificationsList(filters: $filters, offset: $offset, limit: $limit, toValidate: $toValidate) {
    count
    notifications {
      id
      type
      socialNetwork
      author
      isRead
      isAnswered
      isLiked
      isHidden
      isAlert
      isUpdated
      rating
      recommandation
      picture
      video
      postId
      createdAt
      type
      message
      url
      notificationId
      salesPointTargeted {
        id
        name
        publicName
        secondaryName
      }
      isPendingApproval
    }
  }
}
    `;

/**
 * __useGetNotificationsListQuery__
 *
 * To run a query within a React component, call `useGetNotificationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      toValidate: // value for 'toValidate'
 *   },
 * });
 */
export function useGetNotificationsListQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsListQuery, GetNotificationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsListQuery, GetNotificationsListQueryVariables>(GetNotificationsListDocument, options);
      }
export function useGetNotificationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsListQuery, GetNotificationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsListQuery, GetNotificationsListQueryVariables>(GetNotificationsListDocument, options);
        }
export type GetNotificationsListQueryHookResult = ReturnType<typeof useGetNotificationsListQuery>;
export type GetNotificationsListLazyQueryHookResult = ReturnType<typeof useGetNotificationsListLazyQuery>;
export type GetNotificationsListQueryResult = Apollo.QueryResult<GetNotificationsListQuery, GetNotificationsListQueryVariables>;
export const UserStoreCodesDocument = gql`
    query userStoreCodes {
  me {
    id
    salesPoints {
      id
      name
    }
  }
}
    `;

/**
 * __useUserStoreCodesQuery__
 *
 * To run a query within a React component, call `useUserStoreCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserStoreCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStoreCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserStoreCodesQuery(baseOptions?: Apollo.QueryHookOptions<UserStoreCodesQuery, UserStoreCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserStoreCodesQuery, UserStoreCodesQueryVariables>(UserStoreCodesDocument, options);
      }
export function useUserStoreCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserStoreCodesQuery, UserStoreCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserStoreCodesQuery, UserStoreCodesQueryVariables>(UserStoreCodesDocument, options);
        }
export type UserStoreCodesQueryHookResult = ReturnType<typeof useUserStoreCodesQuery>;
export type UserStoreCodesLazyQueryHookResult = ReturnType<typeof useUserStoreCodesLazyQuery>;
export type UserStoreCodesQueryResult = Apollo.QueryResult<UserStoreCodesQuery, UserStoreCodesQueryVariables>;
export const ReplyToNotificationsDocument = gql`
    mutation replyToNotifications($notificationsIds: [ID!]!, $message: String!, $replyAll: Boolean) {
  replyToNotifications(notificationsIds: $notificationsIds, message: $message, replyAll: $replyAll) {
    success
    partialSuccess
  }
}
    `;
export type ReplyToNotificationsMutationFn = Apollo.MutationFunction<ReplyToNotificationsMutation, ReplyToNotificationsMutationVariables>;

/**
 * __useReplyToNotificationsMutation__
 *
 * To run a mutation, you first call `useReplyToNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyToNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyToNotificationsMutation, { data, loading, error }] = useReplyToNotificationsMutation({
 *   variables: {
 *      notificationsIds: // value for 'notificationsIds'
 *      message: // value for 'message'
 *      replyAll: // value for 'replyAll'
 *   },
 * });
 */
export function useReplyToNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReplyToNotificationsMutation, ReplyToNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyToNotificationsMutation, ReplyToNotificationsMutationVariables>(ReplyToNotificationsDocument, options);
      }
export type ReplyToNotificationsMutationHookResult = ReturnType<typeof useReplyToNotificationsMutation>;
export type ReplyToNotificationsMutationResult = Apollo.MutationResult<ReplyToNotificationsMutation>;
export type ReplyToNotificationsMutationOptions = Apollo.BaseMutationOptions<ReplyToNotificationsMutation, ReplyToNotificationsMutationVariables>;
export const ToggleLikeNotificationsDocument = gql`
    mutation toggleLikeNotifications($ids: [ID]!) {
  toggleLikeNotifications(ids: $ids) {
    success
    partialSuccess
  }
}
    `;
export type ToggleLikeNotificationsMutationFn = Apollo.MutationFunction<ToggleLikeNotificationsMutation, ToggleLikeNotificationsMutationVariables>;

/**
 * __useToggleLikeNotificationsMutation__
 *
 * To run a mutation, you first call `useToggleLikeNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLikeNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLikeNotificationsMutation, { data, loading, error }] = useToggleLikeNotificationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useToggleLikeNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLikeNotificationsMutation, ToggleLikeNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLikeNotificationsMutation, ToggleLikeNotificationsMutationVariables>(ToggleLikeNotificationsDocument, options);
      }
export type ToggleLikeNotificationsMutationHookResult = ReturnType<typeof useToggleLikeNotificationsMutation>;
export type ToggleLikeNotificationsMutationResult = Apollo.MutationResult<ToggleLikeNotificationsMutation>;
export type ToggleLikeNotificationsMutationOptions = Apollo.BaseMutationOptions<ToggleLikeNotificationsMutation, ToggleLikeNotificationsMutationVariables>;
export const ToggleNotificationsVisibilityDocument = gql`
    mutation toggleNotificationsVisibility($notifications: [InputNotification], $hide: Boolean) {
  toggleNotificationsVisibility(notifications: $notifications, hide: $hide) {
    success
    partialSuccess
  }
}
    `;
export type ToggleNotificationsVisibilityMutationFn = Apollo.MutationFunction<ToggleNotificationsVisibilityMutation, ToggleNotificationsVisibilityMutationVariables>;

/**
 * __useToggleNotificationsVisibilityMutation__
 *
 * To run a mutation, you first call `useToggleNotificationsVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleNotificationsVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleNotificationsVisibilityMutation, { data, loading, error }] = useToggleNotificationsVisibilityMutation({
 *   variables: {
 *      notifications: // value for 'notifications'
 *      hide: // value for 'hide'
 *   },
 * });
 */
export function useToggleNotificationsVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleNotificationsVisibilityMutation, ToggleNotificationsVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleNotificationsVisibilityMutation, ToggleNotificationsVisibilityMutationVariables>(ToggleNotificationsVisibilityDocument, options);
      }
export type ToggleNotificationsVisibilityMutationHookResult = ReturnType<typeof useToggleNotificationsVisibilityMutation>;
export type ToggleNotificationsVisibilityMutationResult = Apollo.MutationResult<ToggleNotificationsVisibilityMutation>;
export type ToggleNotificationsVisibilityMutationOptions = Apollo.BaseMutationOptions<ToggleNotificationsVisibilityMutation, ToggleNotificationsVisibilityMutationVariables>;
export const ValidateNotificationRepliesDocument = gql`
    mutation validateNotificationReplies($notificationId: ID!, $repliesIds: [ID!]!, $action: NotificationReplyStatus!) {
  validateNotificationReplies(notificationId: $notificationId, repliesIds: $repliesIds, action: $action) {
    success
    partialSuccess
  }
}
    `;
export type ValidateNotificationRepliesMutationFn = Apollo.MutationFunction<ValidateNotificationRepliesMutation, ValidateNotificationRepliesMutationVariables>;

/**
 * __useValidateNotificationRepliesMutation__
 *
 * To run a mutation, you first call `useValidateNotificationRepliesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateNotificationRepliesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateNotificationRepliesMutation, { data, loading, error }] = useValidateNotificationRepliesMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *      repliesIds: // value for 'repliesIds'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useValidateNotificationRepliesMutation(baseOptions?: Apollo.MutationHookOptions<ValidateNotificationRepliesMutation, ValidateNotificationRepliesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateNotificationRepliesMutation, ValidateNotificationRepliesMutationVariables>(ValidateNotificationRepliesDocument, options);
      }
export type ValidateNotificationRepliesMutationHookResult = ReturnType<typeof useValidateNotificationRepliesMutation>;
export type ValidateNotificationRepliesMutationResult = Apollo.MutationResult<ValidateNotificationRepliesMutation>;
export type ValidateNotificationRepliesMutationOptions = Apollo.BaseMutationOptions<ValidateNotificationRepliesMutation, ValidateNotificationRepliesMutationVariables>;
export const DeletePostTemplateDocument = gql`
    mutation deletePostTemplate($id: ID!) {
  deletePostTemplate(id: $id)
}
    `;
export type DeletePostTemplateMutationFn = Apollo.MutationFunction<DeletePostTemplateMutation, DeletePostTemplateMutationVariables>;

/**
 * __useDeletePostTemplateMutation__
 *
 * To run a mutation, you first call `useDeletePostTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostTemplateMutation, { data, loading, error }] = useDeletePostTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostTemplateMutation, DeletePostTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostTemplateMutation, DeletePostTemplateMutationVariables>(DeletePostTemplateDocument, options);
      }
export type DeletePostTemplateMutationHookResult = ReturnType<typeof useDeletePostTemplateMutation>;
export type DeletePostTemplateMutationResult = Apollo.MutationResult<DeletePostTemplateMutation>;
export type DeletePostTemplateMutationOptions = Apollo.BaseMutationOptions<DeletePostTemplateMutation, DeletePostTemplateMutationVariables>;
export const GetPostTemplateDetailsDocument = gql`
    query getPostTemplateDetails($id: ID!) {
  getPostTemplateDetails(id: $id) {
    id
    name
    displayStatus
    type
    socialNetworks
    useSalespointsGroups
    salespointsGroups {
      name
    }
    isScheduled
    startDate
    endDate
    isUsable
    tags {
      id
      name
    }
    templateBodyData {
      textDescription
      author {
        id
        fullName
      }
      authorRole
      preview {
        type
        videoThumbnail
        content
        caption
        targettedNetworks
        dates {
          start
          end
        }
        promoCode
      }
    }
  }
}
    `;

/**
 * __useGetPostTemplateDetailsQuery__
 *
 * To run a query within a React component, call `useGetPostTemplateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostTemplateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostTemplateDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostTemplateDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPostTemplateDetailsQuery, GetPostTemplateDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostTemplateDetailsQuery, GetPostTemplateDetailsQueryVariables>(GetPostTemplateDetailsDocument, options);
      }
export function useGetPostTemplateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostTemplateDetailsQuery, GetPostTemplateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostTemplateDetailsQuery, GetPostTemplateDetailsQueryVariables>(GetPostTemplateDetailsDocument, options);
        }
export type GetPostTemplateDetailsQueryHookResult = ReturnType<typeof useGetPostTemplateDetailsQuery>;
export type GetPostTemplateDetailsLazyQueryHookResult = ReturnType<typeof useGetPostTemplateDetailsLazyQuery>;
export type GetPostTemplateDetailsQueryResult = Apollo.QueryResult<GetPostTemplateDetailsQuery, GetPostTemplateDetailsQueryVariables>;
export const GetPostTemplateListDocument = gql`
    query getPostTemplateList($filters: PostTemplateListFilters, $sort: PostTemplateListSort, $offset: Int, $limit: Int) {
  getPostTemplateList(filters: $filters, sort: $sort, offset: $offset, limit: $limit) {
    count
    templates {
      mongoId
      id
      name
      type
      socialNetworks
      displayStatus
      useSalespointsGroups
      salespointsGroups {
        name
        salespoints {
          name
        }
      }
      isScheduled
      startDate
      endDate
      templateBodyData {
        textDescription
        htmlDescription
        socialNetworksDescription {
          facebook
          instagram
          google
          linkedin
          twitter
        }
        socialNetworksRawDescription {
          facebook
          instagram
          google
          linkedin
          twitter
        }
        author {
          id
          fullName
        }
        authorRole
        preview {
          type
          videoThumbnail
          content
          targettedNetworks
          dates {
            start
            end
          }
          promoCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetPostTemplateListQuery__
 *
 * To run a query within a React component, call `useGetPostTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostTemplateListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<GetPostTemplateListQuery, GetPostTemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostTemplateListQuery, GetPostTemplateListQueryVariables>(GetPostTemplateListDocument, options);
      }
export function useGetPostTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostTemplateListQuery, GetPostTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostTemplateListQuery, GetPostTemplateListQueryVariables>(GetPostTemplateListDocument, options);
        }
export type GetPostTemplateListQueryHookResult = ReturnType<typeof useGetPostTemplateListQuery>;
export type GetPostTemplateListLazyQueryHookResult = ReturnType<typeof useGetPostTemplateListLazyQuery>;
export type GetPostTemplateListQueryResult = Apollo.QueryResult<GetPostTemplateListQuery, GetPostTemplateListQueryVariables>;
export const PostTemplateTagFiltersDocument = gql`
    query postTemplateTagFilters($keyword: String, $postTemplateListFilters: PostTemplateListFilters) {
  postTemplateTagFilters(keyword: $keyword, postTemplateListFilters: $postTemplateListFilters) {
    id
    name
    tags {
      id
      name
      countMatchingTemplates
    }
  }
}
    `;

/**
 * __usePostTemplateTagFiltersQuery__
 *
 * To run a query within a React component, call `usePostTemplateTagFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostTemplateTagFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostTemplateTagFiltersQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      postTemplateListFilters: // value for 'postTemplateListFilters'
 *   },
 * });
 */
export function usePostTemplateTagFiltersQuery(baseOptions?: Apollo.QueryHookOptions<PostTemplateTagFiltersQuery, PostTemplateTagFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostTemplateTagFiltersQuery, PostTemplateTagFiltersQueryVariables>(PostTemplateTagFiltersDocument, options);
      }
export function usePostTemplateTagFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostTemplateTagFiltersQuery, PostTemplateTagFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostTemplateTagFiltersQuery, PostTemplateTagFiltersQueryVariables>(PostTemplateTagFiltersDocument, options);
        }
export type PostTemplateTagFiltersQueryHookResult = ReturnType<typeof usePostTemplateTagFiltersQuery>;
export type PostTemplateTagFiltersLazyQueryHookResult = ReturnType<typeof usePostTemplateTagFiltersLazyQuery>;
export type PostTemplateTagFiltersQueryResult = Apollo.QueryResult<PostTemplateTagFiltersQuery, PostTemplateTagFiltersQueryVariables>;
export const PostDetails_GetPostCalendarDetailsDocument = gql`
    query PostDetails_getPostCalendarDetails($publishId: ID!) {
  getPostCalendarDetails(publishId: $publishId) {
    id
    ...PostDetailsPublish
  }
}
    ${PostDetailsPublishFragmentDoc}`;

/**
 * __usePostDetails_GetPostCalendarDetailsQuery__
 *
 * To run a query within a React component, call `usePostDetails_GetPostCalendarDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetails_GetPostCalendarDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetails_GetPostCalendarDetailsQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function usePostDetails_GetPostCalendarDetailsQuery(baseOptions: Apollo.QueryHookOptions<PostDetails_GetPostCalendarDetailsQuery, PostDetails_GetPostCalendarDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostDetails_GetPostCalendarDetailsQuery, PostDetails_GetPostCalendarDetailsQueryVariables>(PostDetails_GetPostCalendarDetailsDocument, options);
      }
export function usePostDetails_GetPostCalendarDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostDetails_GetPostCalendarDetailsQuery, PostDetails_GetPostCalendarDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostDetails_GetPostCalendarDetailsQuery, PostDetails_GetPostCalendarDetailsQueryVariables>(PostDetails_GetPostCalendarDetailsDocument, options);
        }
export type PostDetails_GetPostCalendarDetailsQueryHookResult = ReturnType<typeof usePostDetails_GetPostCalendarDetailsQuery>;
export type PostDetails_GetPostCalendarDetailsLazyQueryHookResult = ReturnType<typeof usePostDetails_GetPostCalendarDetailsLazyQuery>;
export type PostDetails_GetPostCalendarDetailsQueryResult = Apollo.QueryResult<PostDetails_GetPostCalendarDetailsQuery, PostDetails_GetPostCalendarDetailsQueryVariables>;
export const PostDetails_GetSocialNetworkPostDetailsDocument = gql`
    query PostDetails_getSocialNetworkPostDetails($publishId: ID!) {
  getSocialNetworkPostDetails(publishId: $publishId) {
    id
    socialNetworkPostUrl
    postCalendarId
    salesPointTargeted {
      name
    }
    ...PostDetailsPublish
  }
}
    ${PostDetailsPublishFragmentDoc}`;

/**
 * __usePostDetails_GetSocialNetworkPostDetailsQuery__
 *
 * To run a query within a React component, call `usePostDetails_GetSocialNetworkPostDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetails_GetSocialNetworkPostDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetails_GetSocialNetworkPostDetailsQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function usePostDetails_GetSocialNetworkPostDetailsQuery(baseOptions: Apollo.QueryHookOptions<PostDetails_GetSocialNetworkPostDetailsQuery, PostDetails_GetSocialNetworkPostDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostDetails_GetSocialNetworkPostDetailsQuery, PostDetails_GetSocialNetworkPostDetailsQueryVariables>(PostDetails_GetSocialNetworkPostDetailsDocument, options);
      }
export function usePostDetails_GetSocialNetworkPostDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostDetails_GetSocialNetworkPostDetailsQuery, PostDetails_GetSocialNetworkPostDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostDetails_GetSocialNetworkPostDetailsQuery, PostDetails_GetSocialNetworkPostDetailsQueryVariables>(PostDetails_GetSocialNetworkPostDetailsDocument, options);
        }
export type PostDetails_GetSocialNetworkPostDetailsQueryHookResult = ReturnType<typeof usePostDetails_GetSocialNetworkPostDetailsQuery>;
export type PostDetails_GetSocialNetworkPostDetailsLazyQueryHookResult = ReturnType<typeof usePostDetails_GetSocialNetworkPostDetailsLazyQuery>;
export type PostDetails_GetSocialNetworkPostDetailsQueryResult = Apollo.QueryResult<PostDetails_GetSocialNetworkPostDetailsQuery, PostDetails_GetSocialNetworkPostDetailsQueryVariables>;
export const GetPublishTotalStatsDocument = gql`
    query getPublishTotalStats($args: SearchPublishListArgs!) {
  getPublishTotalStats(args: $args) {
    total
    reach
    engagement
  }
}
    `;

/**
 * __useGetPublishTotalStatsQuery__
 *
 * To run a query within a React component, call `useGetPublishTotalStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishTotalStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishTotalStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetPublishTotalStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPublishTotalStatsQuery, GetPublishTotalStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishTotalStatsQuery, GetPublishTotalStatsQueryVariables>(GetPublishTotalStatsDocument, options);
      }
export function useGetPublishTotalStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishTotalStatsQuery, GetPublishTotalStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishTotalStatsQuery, GetPublishTotalStatsQueryVariables>(GetPublishTotalStatsDocument, options);
        }
export type GetPublishTotalStatsQueryHookResult = ReturnType<typeof useGetPublishTotalStatsQuery>;
export type GetPublishTotalStatsLazyQueryHookResult = ReturnType<typeof useGetPublishTotalStatsLazyQuery>;
export type GetPublishTotalStatsQueryResult = Apollo.QueryResult<GetPublishTotalStatsQuery, GetPublishTotalStatsQueryVariables>;
export const ExportPublishListDocument = gql`
    query exportPublishList($args: SearchPublishListArgs!, $sort: PublishListSortArgs) {
  exportPublishList(args: $args, sort: $sort) {
    mediaLink
  }
}
    `;

/**
 * __useExportPublishListQuery__
 *
 * To run a query within a React component, call `useExportPublishListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPublishListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPublishListQuery({
 *   variables: {
 *      args: // value for 'args'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useExportPublishListQuery(baseOptions: Apollo.QueryHookOptions<ExportPublishListQuery, ExportPublishListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPublishListQuery, ExportPublishListQueryVariables>(ExportPublishListDocument, options);
      }
export function useExportPublishListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPublishListQuery, ExportPublishListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPublishListQuery, ExportPublishListQueryVariables>(ExportPublishListDocument, options);
        }
export type ExportPublishListQueryHookResult = ReturnType<typeof useExportPublishListQuery>;
export type ExportPublishListLazyQueryHookResult = ReturnType<typeof useExportPublishListLazyQuery>;
export type ExportPublishListQueryResult = Apollo.QueryResult<ExportPublishListQuery, ExportPublishListQueryVariables>;
export const GetMilestonesDocument = gql`
    query getMilestones($start: Date!, $end: Date!) {
  getMilestones(start: $start, end: $end) {
    start
    end
    name
  }
}
    `;

/**
 * __useGetMilestonesQuery__
 *
 * To run a query within a React component, call `useGetMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMilestonesQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetMilestonesQuery(baseOptions: Apollo.QueryHookOptions<GetMilestonesQuery, GetMilestonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMilestonesQuery, GetMilestonesQueryVariables>(GetMilestonesDocument, options);
      }
export function useGetMilestonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMilestonesQuery, GetMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMilestonesQuery, GetMilestonesQueryVariables>(GetMilestonesDocument, options);
        }
export type GetMilestonesQueryHookResult = ReturnType<typeof useGetMilestonesQuery>;
export type GetMilestonesLazyQueryHookResult = ReturnType<typeof useGetMilestonesLazyQuery>;
export type GetMilestonesQueryResult = Apollo.QueryResult<GetMilestonesQuery, GetMilestonesQueryVariables>;
export const GetPublishListForCalendarDocument = gql`
    query getPublishListForCalendar($args: SearchPublishListArgs!, $sort: PublishListSortArgs!) {
  getPublishListForCalendar(args: $args, sort: $sort) {
    id
    postCalendarId
    socialNetworkTarget
    textDescription
    scheduledAt
    status
  }
}
    `;

/**
 * __useGetPublishListForCalendarQuery__
 *
 * To run a query within a React component, call `useGetPublishListForCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishListForCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishListForCalendarQuery({
 *   variables: {
 *      args: // value for 'args'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPublishListForCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetPublishListForCalendarQuery, GetPublishListForCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishListForCalendarQuery, GetPublishListForCalendarQueryVariables>(GetPublishListForCalendarDocument, options);
      }
export function useGetPublishListForCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishListForCalendarQuery, GetPublishListForCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishListForCalendarQuery, GetPublishListForCalendarQueryVariables>(GetPublishListForCalendarDocument, options);
        }
export type GetPublishListForCalendarQueryHookResult = ReturnType<typeof useGetPublishListForCalendarQuery>;
export type GetPublishListForCalendarLazyQueryHookResult = ReturnType<typeof useGetPublishListForCalendarLazyQuery>;
export type GetPublishListForCalendarQueryResult = Apollo.QueryResult<GetPublishListForCalendarQuery, GetPublishListForCalendarQueryVariables>;
export const GetPublishListDocument = gql`
    query getPublishList($args: SearchPublishListArgs!, $sort: PublishListSortArgs!, $offset: Int, $limit: Int) {
  getPublishList(args: $args, sort: $sort, offset: $offset, limit: $limit) {
    count
    posts {
      ...PostsListItemPost
    }
  }
}
    ${PostsListItemPostFragmentDoc}`;

/**
 * __useGetPublishListQuery__
 *
 * To run a query within a React component, call `useGetPublishListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishListQuery({
 *   variables: {
 *      args: // value for 'args'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPublishListQuery(baseOptions: Apollo.QueryHookOptions<GetPublishListQuery, GetPublishListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishListQuery, GetPublishListQueryVariables>(GetPublishListDocument, options);
      }
export function useGetPublishListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishListQuery, GetPublishListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishListQuery, GetPublishListQueryVariables>(GetPublishListDocument, options);
        }
export type GetPublishListQueryHookResult = ReturnType<typeof useGetPublishListQuery>;
export type GetPublishListLazyQueryHookResult = ReturnType<typeof useGetPublishListLazyQuery>;
export type GetPublishListQueryResult = Apollo.QueryResult<GetPublishListQuery, GetPublishListQueryVariables>;
export const DeleteSocialPostDocument = gql`
    mutation deleteSocialPost($publishId: ID!) {
  deleteSocialPost(publishId: $publishId)
}
    `;
export type DeleteSocialPostMutationFn = Apollo.MutationFunction<DeleteSocialPostMutation, DeleteSocialPostMutationVariables>;

/**
 * __useDeleteSocialPostMutation__
 *
 * To run a mutation, you first call `useDeleteSocialPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocialPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocialPostMutation, { data, loading, error }] = useDeleteSocialPostMutation({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useDeleteSocialPostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSocialPostMutation, DeleteSocialPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSocialPostMutation, DeleteSocialPostMutationVariables>(DeleteSocialPostDocument, options);
      }
export type DeleteSocialPostMutationHookResult = ReturnType<typeof useDeleteSocialPostMutation>;
export type DeleteSocialPostMutationResult = Apollo.MutationResult<DeleteSocialPostMutation>;
export type DeleteSocialPostMutationOptions = Apollo.BaseMutationOptions<DeleteSocialPostMutation, DeleteSocialPostMutationVariables>;
export const ExportPostCalendarPostsDocument = gql`
    query exportPostCalendarPosts($publishId: ID!) {
  exportPostCalendarPosts(publishId: $publishId) {
    mediaLink
  }
}
    `;

/**
 * __useExportPostCalendarPostsQuery__
 *
 * To run a query within a React component, call `useExportPostCalendarPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPostCalendarPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPostCalendarPostsQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useExportPostCalendarPostsQuery(baseOptions: Apollo.QueryHookOptions<ExportPostCalendarPostsQuery, ExportPostCalendarPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPostCalendarPostsQuery, ExportPostCalendarPostsQueryVariables>(ExportPostCalendarPostsDocument, options);
      }
export function useExportPostCalendarPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPostCalendarPostsQuery, ExportPostCalendarPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPostCalendarPostsQuery, ExportPostCalendarPostsQueryVariables>(ExportPostCalendarPostsDocument, options);
        }
export type ExportPostCalendarPostsQueryHookResult = ReturnType<typeof useExportPostCalendarPostsQuery>;
export type ExportPostCalendarPostsLazyQueryHookResult = ReturnType<typeof useExportPostCalendarPostsLazyQuery>;
export type ExportPostCalendarPostsQueryResult = Apollo.QueryResult<ExportPostCalendarPostsQuery, ExportPostCalendarPostsQueryVariables>;
export const GetPostCalendarPostsDocument = gql`
    query getPostCalendarPosts($publishId: ID!, $sort: PublishListSortArgs) {
  getPostCalendarPosts(publishId: $publishId, sort: $sort) {
    success
    data {
      id
      errorMessage
      ...PostsDetailsListItemPublish
    }
  }
}
    ${PostsDetailsListItemPublishFragmentDoc}`;

/**
 * __useGetPostCalendarPostsQuery__
 *
 * To run a query within a React component, call `useGetPostCalendarPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCalendarPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCalendarPostsQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPostCalendarPostsQuery(baseOptions: Apollo.QueryHookOptions<GetPostCalendarPostsQuery, GetPostCalendarPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCalendarPostsQuery, GetPostCalendarPostsQueryVariables>(GetPostCalendarPostsDocument, options);
      }
export function useGetPostCalendarPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCalendarPostsQuery, GetPostCalendarPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCalendarPostsQuery, GetPostCalendarPostsQueryVariables>(GetPostCalendarPostsDocument, options);
        }
export type GetPostCalendarPostsQueryHookResult = ReturnType<typeof useGetPostCalendarPostsQuery>;
export type GetPostCalendarPostsLazyQueryHookResult = ReturnType<typeof useGetPostCalendarPostsLazyQuery>;
export type GetPostCalendarPostsQueryResult = Apollo.QueryResult<GetPostCalendarPostsQuery, GetPostCalendarPostsQueryVariables>;
export const GetSocialTotalGraphStatsDocument = gql`
    query getSocialTotalGraphStats($args: AnalyzeQueryArgs!) {
  getSocialTotalGraphStats(args: $args) {
    fansAdded
    reach
    engagement
  }
}
    `;

/**
 * __useGetSocialTotalGraphStatsQuery__
 *
 * To run a query within a React component, call `useGetSocialTotalGraphStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialTotalGraphStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialTotalGraphStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetSocialTotalGraphStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialTotalGraphStatsQuery, GetSocialTotalGraphStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialTotalGraphStatsQuery, GetSocialTotalGraphStatsQueryVariables>(GetSocialTotalGraphStatsDocument, options);
      }
export function useGetSocialTotalGraphStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialTotalGraphStatsQuery, GetSocialTotalGraphStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialTotalGraphStatsQuery, GetSocialTotalGraphStatsQueryVariables>(GetSocialTotalGraphStatsDocument, options);
        }
export type GetSocialTotalGraphStatsQueryHookResult = ReturnType<typeof useGetSocialTotalGraphStatsQuery>;
export type GetSocialTotalGraphStatsLazyQueryHookResult = ReturnType<typeof useGetSocialTotalGraphStatsLazyQuery>;
export type GetSocialTotalGraphStatsQueryResult = Apollo.QueryResult<GetSocialTotalGraphStatsQuery, GetSocialTotalGraphStatsQueryVariables>;
export const GetSocialCityStatsDocument = gql`
    query getSocialCityStats($args: AnalyzeQueryArgs!) {
  getSocialCityStats(args: $args) {
    name
    fans
    popularityPercent
  }
}
    `;

/**
 * __useGetSocialCityStatsQuery__
 *
 * To run a query within a React component, call `useGetSocialCityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialCityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialCityStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetSocialCityStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialCityStatsQuery, GetSocialCityStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialCityStatsQuery, GetSocialCityStatsQueryVariables>(GetSocialCityStatsDocument, options);
      }
export function useGetSocialCityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialCityStatsQuery, GetSocialCityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialCityStatsQuery, GetSocialCityStatsQueryVariables>(GetSocialCityStatsDocument, options);
        }
export type GetSocialCityStatsQueryHookResult = ReturnType<typeof useGetSocialCityStatsQuery>;
export type GetSocialCityStatsLazyQueryHookResult = ReturnType<typeof useGetSocialCityStatsLazyQuery>;
export type GetSocialCityStatsQueryResult = Apollo.QueryResult<GetSocialCityStatsQuery, GetSocialCityStatsQueryVariables>;
export const GetSocialComparisonStatsDocument = gql`
    query getSocialComparisonStats($args: AnalyzeQueryArgs!) {
  getSocialComparisonStats(args: $args) {
    fans {
      national
      salesPoint
    }
    reach {
      national
      salesPoint
    }
    engagement {
      national
      salesPoint
    }
  }
}
    `;

/**
 * __useGetSocialComparisonStatsQuery__
 *
 * To run a query within a React component, call `useGetSocialComparisonStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialComparisonStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialComparisonStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetSocialComparisonStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialComparisonStatsQuery, GetSocialComparisonStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialComparisonStatsQuery, GetSocialComparisonStatsQueryVariables>(GetSocialComparisonStatsDocument, options);
      }
export function useGetSocialComparisonStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialComparisonStatsQuery, GetSocialComparisonStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialComparisonStatsQuery, GetSocialComparisonStatsQueryVariables>(GetSocialComparisonStatsDocument, options);
        }
export type GetSocialComparisonStatsQueryHookResult = ReturnType<typeof useGetSocialComparisonStatsQuery>;
export type GetSocialComparisonStatsLazyQueryHookResult = ReturnType<typeof useGetSocialComparisonStatsLazyQuery>;
export type GetSocialComparisonStatsQueryResult = Apollo.QueryResult<GetSocialComparisonStatsQuery, GetSocialComparisonStatsQueryVariables>;
export const GetSocialPerformanceStatsDocument = gql`
    query getSocialPerformanceStats($args: AnalyzeQueryArgs!) {
  getSocialPerformanceStats(args: $args) {
    date
    stats {
      fans
      reach
      engagement
    }
  }
}
    `;

/**
 * __useGetSocialPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useGetSocialPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialPerformanceStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetSocialPerformanceStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialPerformanceStatsQuery, GetSocialPerformanceStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialPerformanceStatsQuery, GetSocialPerformanceStatsQueryVariables>(GetSocialPerformanceStatsDocument, options);
      }
export function useGetSocialPerformanceStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialPerformanceStatsQuery, GetSocialPerformanceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialPerformanceStatsQuery, GetSocialPerformanceStatsQueryVariables>(GetSocialPerformanceStatsDocument, options);
        }
export type GetSocialPerformanceStatsQueryHookResult = ReturnType<typeof useGetSocialPerformanceStatsQuery>;
export type GetSocialPerformanceStatsLazyQueryHookResult = ReturnType<typeof useGetSocialPerformanceStatsLazyQuery>;
export type GetSocialPerformanceStatsQueryResult = Apollo.QueryResult<GetSocialPerformanceStatsQuery, GetSocialPerformanceStatsQueryVariables>;
export const GetSocialDemographicStatsDocument = gql`
    query getSocialDemographicStats($args: AnalyzeQueryArgs!) {
  getSocialDemographicStats(args: $args) {
    gender {
      key
      total
    }
    age {
      key
      total
    }
    locale {
      key
      total
    }
  }
}
    `;

/**
 * __useGetSocialDemographicStatsQuery__
 *
 * To run a query within a React component, call `useGetSocialDemographicStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialDemographicStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialDemographicStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetSocialDemographicStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialDemographicStatsQuery, GetSocialDemographicStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialDemographicStatsQuery, GetSocialDemographicStatsQueryVariables>(GetSocialDemographicStatsDocument, options);
      }
export function useGetSocialDemographicStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialDemographicStatsQuery, GetSocialDemographicStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialDemographicStatsQuery, GetSocialDemographicStatsQueryVariables>(GetSocialDemographicStatsDocument, options);
        }
export type GetSocialDemographicStatsQueryHookResult = ReturnType<typeof useGetSocialDemographicStatsQuery>;
export type GetSocialDemographicStatsLazyQueryHookResult = ReturnType<typeof useGetSocialDemographicStatsLazyQuery>;
export type GetSocialDemographicStatsQueryResult = Apollo.QueryResult<GetSocialDemographicStatsQuery, GetSocialDemographicStatsQueryVariables>;
export const ExportSocialSalesPointStatsListDocument = gql`
    query exportSocialSalesPointStatsList($args: AnalyzeSalesPointStatsListQueryArgs!, $orderBy: AnalyzeSalesPointStatsListQueryOrderBy, $direction: Direction) {
  exportSocialSalesPointStatsList(args: $args, orderBy: $orderBy, direction: $direction) {
    mediaLink
  }
}
    `;

/**
 * __useExportSocialSalesPointStatsListQuery__
 *
 * To run a query within a React component, call `useExportSocialSalesPointStatsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSocialSalesPointStatsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSocialSalesPointStatsListQuery({
 *   variables: {
 *      args: // value for 'args'
 *      orderBy: // value for 'orderBy'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useExportSocialSalesPointStatsListQuery(baseOptions: Apollo.QueryHookOptions<ExportSocialSalesPointStatsListQuery, ExportSocialSalesPointStatsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSocialSalesPointStatsListQuery, ExportSocialSalesPointStatsListQueryVariables>(ExportSocialSalesPointStatsListDocument, options);
      }
export function useExportSocialSalesPointStatsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSocialSalesPointStatsListQuery, ExportSocialSalesPointStatsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSocialSalesPointStatsListQuery, ExportSocialSalesPointStatsListQueryVariables>(ExportSocialSalesPointStatsListDocument, options);
        }
export type ExportSocialSalesPointStatsListQueryHookResult = ReturnType<typeof useExportSocialSalesPointStatsListQuery>;
export type ExportSocialSalesPointStatsListLazyQueryHookResult = ReturnType<typeof useExportSocialSalesPointStatsListLazyQuery>;
export type ExportSocialSalesPointStatsListQueryResult = Apollo.QueryResult<ExportSocialSalesPointStatsListQuery, ExportSocialSalesPointStatsListQueryVariables>;
export const QueryDocument = gql`
    query Query($args: AnalyzeSalesPointStatsListQueryArgs!, $offset: Int, $limit: Int, $orderBy: AnalyzeSalesPointStatsListQueryOrderBy, $direction: Direction) {
  getSocialSalesPointStatsList(args: $args, offset: $offset, limit: $limit, orderBy: $orderBy, direction: $direction) {
    success
    pageInfos {
      page
      totalResult
      totalPage
    }
    data {
      id
      url
      salesPoint {
        id
        name
      }
      fans
      fansLost
      fansAdded
      engagement
      reach
      posts
      followers
    }
  }
}
    `;

/**
 * __useQueryQuery__
 *
 * To run a query within a React component, call `useQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryQuery({
 *   variables: {
 *      args: // value for 'args'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useQueryQuery(baseOptions: Apollo.QueryHookOptions<QueryQuery, QueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryQuery, QueryQueryVariables>(QueryDocument, options);
      }
export function useQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryQuery, QueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryQuery, QueryQueryVariables>(QueryDocument, options);
        }
export type QueryQueryHookResult = ReturnType<typeof useQueryQuery>;
export type QueryLazyQueryHookResult = ReturnType<typeof useQueryLazyQuery>;
export type QueryQueryResult = Apollo.QueryResult<QueryQuery, QueryQueryVariables>;
export const GetSocialTotalListStatsDocument = gql`
    query getSocialTotalListStats($args: AnalyzeQueryArgs!) {
  getSocialTotalListStats(args: $args) {
    fans
    fansLost
    fansAdded
    reach
    engagement
    posts
    followers
  }
}
    `;

/**
 * __useGetSocialTotalListStatsQuery__
 *
 * To run a query within a React component, call `useGetSocialTotalListStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialTotalListStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialTotalListStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetSocialTotalListStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSocialTotalListStatsQuery, GetSocialTotalListStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialTotalListStatsQuery, GetSocialTotalListStatsQueryVariables>(GetSocialTotalListStatsDocument, options);
      }
export function useGetSocialTotalListStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialTotalListStatsQuery, GetSocialTotalListStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialTotalListStatsQuery, GetSocialTotalListStatsQueryVariables>(GetSocialTotalListStatsDocument, options);
        }
export type GetSocialTotalListStatsQueryHookResult = ReturnType<typeof useGetSocialTotalListStatsQuery>;
export type GetSocialTotalListStatsLazyQueryHookResult = ReturnType<typeof useGetSocialTotalListStatsLazyQuery>;
export type GetSocialTotalListStatsQueryResult = Apollo.QueryResult<GetSocialTotalListStatsQuery, GetSocialTotalListStatsQueryVariables>;
export const CampaignMetricsDocument = gql`
    query campaignMetrics($dateRange: DateRange!, $roleIds: [ID], $campaignId: ID, $salespointsIds: [ID!], $salespointGroupsIds: [ID!], $campaignType: CampaignType!, $offset: Int, $limit: Int, $keyword: String) {
  campaignMetrics(dateRange: $dateRange, roleIds: $roleIds, campaignId: $campaignId, salespointsIds: $salespointsIds, campaignType: $campaignType, salespointGroupsIds: $salespointGroupsIds) {
    pageViews {
      count
      variationPercentage
    }
    pageViewsPerDay {
      date
      count
    }
    downloadsPerDay {
      date
      fileDownload
      supportDownload
    }
    campaignDownloadDetails(offset: $offset, limit: $limit, keyword: $keyword) {
      count
      campaignDownloadDetails {
        fileName
        campaignName
        downloads
        copies
      }
    }
    downloads {
      count
      variationPercentage
    }
  }
}
    `;

/**
 * __useCampaignMetricsQuery__
 *
 * To run a query within a React component, call `useCampaignMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignMetricsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      roleIds: // value for 'roleIds'
 *      campaignId: // value for 'campaignId'
 *      salespointsIds: // value for 'salespointsIds'
 *      salespointGroupsIds: // value for 'salespointGroupsIds'
 *      campaignType: // value for 'campaignType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useCampaignMetricsQuery(baseOptions: Apollo.QueryHookOptions<CampaignMetricsQuery, CampaignMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignMetricsQuery, CampaignMetricsQueryVariables>(CampaignMetricsDocument, options);
      }
export function useCampaignMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignMetricsQuery, CampaignMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignMetricsQuery, CampaignMetricsQueryVariables>(CampaignMetricsDocument, options);
        }
export type CampaignMetricsQueryHookResult = ReturnType<typeof useCampaignMetricsQuery>;
export type CampaignMetricsLazyQueryHookResult = ReturnType<typeof useCampaignMetricsLazyQuery>;
export type CampaignMetricsQueryResult = Apollo.QueryResult<CampaignMetricsQuery, CampaignMetricsQueryVariables>;
export const KpiAndGraphQueryDocument = gql`
    query kpiAndGraphQuery($dateRange: DateRange!, $roleIds: [ID], $salespointsIds: [ID!], $salespointGroupsIds: [ID!], $tableParams: TableParams) {
  downloadMetrics(dateRange: $dateRange, roleIds: $roleIds, salespointsIds: $salespointsIds, salespointGroupsIds: $salespointGroupsIds, tableParams: $tableParams) {
    downloads {
      count
      variationPercentage
    }
    copiedLinks {
      count
      variationPercentage
    }
    downloadsPerDay {
      date
      downloads
    }
  }
}
    `;

/**
 * __useKpiAndGraphQueryQuery__
 *
 * To run a query within a React component, call `useKpiAndGraphQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiAndGraphQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiAndGraphQueryQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      roleIds: // value for 'roleIds'
 *      salespointsIds: // value for 'salespointsIds'
 *      salespointGroupsIds: // value for 'salespointGroupsIds'
 *      tableParams: // value for 'tableParams'
 *   },
 * });
 */
export function useKpiAndGraphQueryQuery(baseOptions: Apollo.QueryHookOptions<KpiAndGraphQueryQuery, KpiAndGraphQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiAndGraphQueryQuery, KpiAndGraphQueryQueryVariables>(KpiAndGraphQueryDocument, options);
      }
export function useKpiAndGraphQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiAndGraphQueryQuery, KpiAndGraphQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiAndGraphQueryQuery, KpiAndGraphQueryQueryVariables>(KpiAndGraphQueryDocument, options);
        }
export type KpiAndGraphQueryQueryHookResult = ReturnType<typeof useKpiAndGraphQueryQuery>;
export type KpiAndGraphQueryLazyQueryHookResult = ReturnType<typeof useKpiAndGraphQueryLazyQuery>;
export type KpiAndGraphQueryQueryResult = Apollo.QueryResult<KpiAndGraphQueryQuery, KpiAndGraphQueryQueryVariables>;
export const DownloadTableQueryDocument = gql`
    query downloadTableQuery($dateRange: DateRange!, $roleIds: [ID], $salespointsIds: [ID!], $salespointGroupsIds: [ID!], $tableParams: TableParams) {
  downloadMetrics(dateRange: $dateRange, roleIds: $roleIds, salespointsIds: $salespointsIds, salespointGroupsIds: $salespointGroupsIds) {
    downloadDetails(tableParams: $tableParams) {
      count
      downloadDetails {
        id
        name
        format
        downloads
      }
    }
  }
}
    `;

/**
 * __useDownloadTableQueryQuery__
 *
 * To run a query within a React component, call `useDownloadTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadTableQueryQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      roleIds: // value for 'roleIds'
 *      salespointsIds: // value for 'salespointsIds'
 *      salespointGroupsIds: // value for 'salespointGroupsIds'
 *      tableParams: // value for 'tableParams'
 *   },
 * });
 */
export function useDownloadTableQueryQuery(baseOptions: Apollo.QueryHookOptions<DownloadTableQueryQuery, DownloadTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadTableQueryQuery, DownloadTableQueryQueryVariables>(DownloadTableQueryDocument, options);
      }
export function useDownloadTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadTableQueryQuery, DownloadTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadTableQueryQuery, DownloadTableQueryQueryVariables>(DownloadTableQueryDocument, options);
        }
export type DownloadTableQueryQueryHookResult = ReturnType<typeof useDownloadTableQueryQuery>;
export type DownloadTableQueryLazyQueryHookResult = ReturnType<typeof useDownloadTableQueryLazyQuery>;
export type DownloadTableQueryQueryResult = Apollo.QueryResult<DownloadTableQueryQuery, DownloadTableQueryQueryVariables>;
export const MongoDbMetricsDocument = gql`
    query mongoDbMetrics($filter: PlatformMetricsFilter) {
  platformGraphMetrics(filter: $filter) {
    total {
      login {
        count
        variationPercentage
      }
      downloads {
        count
        variationPercentage
      }
      postsPublished {
        count
        variationPercentage
      }
      ordersPassed {
        count
        variationPercentage
      }
      turnover {
        count
        variationPercentage
      }
    }
    metrics {
      login {
        type
        count
        variationPercentage
      }
      posts {
        type
        count
        variationPercentage
      }
      postSources {
        type
        count
        variationPercentage
      }
    }
    lineGraphMetrics {
      date
      login
      downloads
      postsPublished
      ordersPassed
      turnover
    }
  }
}
    `;

/**
 * __useMongoDbMetricsQuery__
 *
 * To run a query within a React component, call `useMongoDbMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMongoDbMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMongoDbMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMongoDbMetricsQuery(baseOptions?: Apollo.QueryHookOptions<MongoDbMetricsQuery, MongoDbMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MongoDbMetricsQuery, MongoDbMetricsQueryVariables>(MongoDbMetricsDocument, options);
      }
export function useMongoDbMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MongoDbMetricsQuery, MongoDbMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MongoDbMetricsQuery, MongoDbMetricsQueryVariables>(MongoDbMetricsDocument, options);
        }
export type MongoDbMetricsQueryHookResult = ReturnType<typeof useMongoDbMetricsQuery>;
export type MongoDbMetricsLazyQueryHookResult = ReturnType<typeof useMongoDbMetricsLazyQuery>;
export type MongoDbMetricsQueryResult = Apollo.QueryResult<MongoDbMetricsQuery, MongoDbMetricsQueryVariables>;
export const ExportEngagementMetricsDocument = gql`
    mutation exportEngagementMetrics($filter: PlatformMetricsFilter, $groupBy: ExportEngagementType!) {
  exportEngagementMetrics(filter: $filter, groupBy: $groupBy)
}
    `;
export type ExportEngagementMetricsMutationFn = Apollo.MutationFunction<ExportEngagementMetricsMutation, ExportEngagementMetricsMutationVariables>;

/**
 * __useExportEngagementMetricsMutation__
 *
 * To run a mutation, you first call `useExportEngagementMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEngagementMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEngagementMetricsMutation, { data, loading, error }] = useExportEngagementMetricsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useExportEngagementMetricsMutation(baseOptions?: Apollo.MutationHookOptions<ExportEngagementMetricsMutation, ExportEngagementMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEngagementMetricsMutation, ExportEngagementMetricsMutationVariables>(ExportEngagementMetricsDocument, options);
      }
export type ExportEngagementMetricsMutationHookResult = ReturnType<typeof useExportEngagementMetricsMutation>;
export type ExportEngagementMetricsMutationResult = Apollo.MutationResult<ExportEngagementMetricsMutation>;
export type ExportEngagementMetricsMutationOptions = Apollo.BaseMutationOptions<ExportEngagementMetricsMutation, ExportEngagementMetricsMutationVariables>;
export const PlatformListMetricsBySalespointDocument = gql`
    query platformListMetricsBySalespoint($filter: PlatformMetricsFilter, $sort: PlatformListMetricsSort, $offset: Int, $limit: Int) {
  platformListMetricsBySalesPoint(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    total {
      login
      loginDevices {
        web
        app
      }
      posts {
        web
        app
      }
      plannifications {
        planned
        immediate
      }
      paps
      downloads
      orders
    }
    metrics {
      usersCount
      salespoint
      login
      loginDevices {
        web
        app
      }
      posts {
        web
        app
      }
      paps
      downloads
      orders
    }
    userTotal(filter: $filter)
    totalResult
  }
}
    `;

/**
 * __usePlatformListMetricsBySalespointQuery__
 *
 * To run a query within a React component, call `usePlatformListMetricsBySalespointQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformListMetricsBySalespointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformListMetricsBySalespointQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlatformListMetricsBySalespointQuery(baseOptions?: Apollo.QueryHookOptions<PlatformListMetricsBySalespointQuery, PlatformListMetricsBySalespointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformListMetricsBySalespointQuery, PlatformListMetricsBySalespointQueryVariables>(PlatformListMetricsBySalespointDocument, options);
      }
export function usePlatformListMetricsBySalespointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformListMetricsBySalespointQuery, PlatformListMetricsBySalespointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformListMetricsBySalespointQuery, PlatformListMetricsBySalespointQueryVariables>(PlatformListMetricsBySalespointDocument, options);
        }
export type PlatformListMetricsBySalespointQueryHookResult = ReturnType<typeof usePlatformListMetricsBySalespointQuery>;
export type PlatformListMetricsBySalespointLazyQueryHookResult = ReturnType<typeof usePlatformListMetricsBySalespointLazyQuery>;
export type PlatformListMetricsBySalespointQueryResult = Apollo.QueryResult<PlatformListMetricsBySalespointQuery, PlatformListMetricsBySalespointQueryVariables>;
export const PlatformListMetricsByUserDocument = gql`
    query platformListMetricsByUser($filter: PlatformMetricsFilter, $sort: PlatformListMetricsSort, $offset: Int, $limit: Int) {
  platformListMetricsByUser(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    total {
      login
      loginDevices {
        web
        app
      }
      posts {
        web
        app
      }
      plannifications {
        planned
        immediate
      }
      paps
      downloads
      orders
    }
    metrics {
      user
      userRole
      salesPointsCount
      plannifications {
        planned
        immediate
      }
      login
      loginDevices {
        web
        app
      }
      posts {
        web
        app
      }
      paps
      downloads
      orders
    }
    totalResult
  }
}
    `;

/**
 * __usePlatformListMetricsByUserQuery__
 *
 * To run a query within a React component, call `usePlatformListMetricsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformListMetricsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformListMetricsByUserQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlatformListMetricsByUserQuery(baseOptions?: Apollo.QueryHookOptions<PlatformListMetricsByUserQuery, PlatformListMetricsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformListMetricsByUserQuery, PlatformListMetricsByUserQueryVariables>(PlatformListMetricsByUserDocument, options);
      }
export function usePlatformListMetricsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformListMetricsByUserQuery, PlatformListMetricsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformListMetricsByUserQuery, PlatformListMetricsByUserQueryVariables>(PlatformListMetricsByUserDocument, options);
        }
export type PlatformListMetricsByUserQueryHookResult = ReturnType<typeof usePlatformListMetricsByUserQuery>;
export type PlatformListMetricsByUserLazyQueryHookResult = ReturnType<typeof usePlatformListMetricsByUserLazyQuery>;
export type PlatformListMetricsByUserQueryResult = Apollo.QueryResult<PlatformListMetricsByUserQuery, PlatformListMetricsByUserQueryVariables>;
export const GetSalesPointsGroupsDocument = gql`
    query getSalesPointsGroups($filter: SalesPointFilter) {
  salesPointsGroups(filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __useGetSalesPointsGroupsQuery__
 *
 * To run a query within a React component, call `useGetSalesPointsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesPointsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesPointsGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSalesPointsGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesPointsGroupsQuery, GetSalesPointsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesPointsGroupsQuery, GetSalesPointsGroupsQueryVariables>(GetSalesPointsGroupsDocument, options);
      }
export function useGetSalesPointsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesPointsGroupsQuery, GetSalesPointsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesPointsGroupsQuery, GetSalesPointsGroupsQueryVariables>(GetSalesPointsGroupsDocument, options);
        }
export type GetSalesPointsGroupsQueryHookResult = ReturnType<typeof useGetSalesPointsGroupsQuery>;
export type GetSalesPointsGroupsLazyQueryHookResult = ReturnType<typeof useGetSalesPointsGroupsLazyQuery>;
export type GetSalesPointsGroupsQueryResult = Apollo.QueryResult<GetSalesPointsGroupsQuery, GetSalesPointsGroupsQueryVariables>;
export const SalesPointsDocument = gql`
    query salesPoints($offset: Int, $limit: Int, $filter: SalesPointFilter, $sort: SalesPointSort) {
  salesPoints(offset: $offset, limit: $limit, filter: $filter, sort: $sort) {
    count
    enabledSalesPointsCount
    salesPoints {
      id
      name
    }
  }
}
    `;

/**
 * __useSalesPointsQuery__
 *
 * To run a query within a React component, call `useSalesPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesPointsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSalesPointsQuery(baseOptions?: Apollo.QueryHookOptions<SalesPointsQuery, SalesPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesPointsQuery, SalesPointsQueryVariables>(SalesPointsDocument, options);
      }
export function useSalesPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesPointsQuery, SalesPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesPointsQuery, SalesPointsQueryVariables>(SalesPointsDocument, options);
        }
export type SalesPointsQueryHookResult = ReturnType<typeof useSalesPointsQuery>;
export type SalesPointsLazyQueryHookResult = ReturnType<typeof useSalesPointsLazyQuery>;
export type SalesPointsQueryResult = Apollo.QueryResult<SalesPointsQuery, SalesPointsQueryVariables>;
export const MediaAndProductMetricsDocument = gql`
    query mediaAndProductMetrics($dateRange: DateRange!, $roleIds: [ID], $salespointsIds: [ID!], $salespointGroupsIds: [ID!]) {
  mediaAndProductMetrics(dateRange: $dateRange, roleIds: $roleIds, salespointsIds: $salespointsIds, salespointGroupsIds: $salespointGroupsIds) {
    downloadedMedias {
      payloads {
        itemId
        name
        type
        nbrEvent
      }
      variationPercentage
      count
    }
    copiedMediaLink {
      count
      variationPercentage
    }
    nbrActivatedMedias {
      count
      variationPercentage
    }
  }
}
    `;

/**
 * __useMediaAndProductMetricsQuery__
 *
 * To run a query within a React component, call `useMediaAndProductMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAndProductMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAndProductMetricsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      roleIds: // value for 'roleIds'
 *      salespointsIds: // value for 'salespointsIds'
 *      salespointGroupsIds: // value for 'salespointGroupsIds'
 *   },
 * });
 */
export function useMediaAndProductMetricsQuery(baseOptions: Apollo.QueryHookOptions<MediaAndProductMetricsQuery, MediaAndProductMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaAndProductMetricsQuery, MediaAndProductMetricsQueryVariables>(MediaAndProductMetricsDocument, options);
      }
export function useMediaAndProductMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaAndProductMetricsQuery, MediaAndProductMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaAndProductMetricsQuery, MediaAndProductMetricsQueryVariables>(MediaAndProductMetricsDocument, options);
        }
export type MediaAndProductMetricsQueryHookResult = ReturnType<typeof useMediaAndProductMetricsQuery>;
export type MediaAndProductMetricsLazyQueryHookResult = ReturnType<typeof useMediaAndProductMetricsLazyQuery>;
export type MediaAndProductMetricsQueryResult = Apollo.QueryResult<MediaAndProductMetricsQuery, MediaAndProductMetricsQueryVariables>;
export const CampaignDocument = gql`
    query campaign($paidMediaCampaignId: ID!, $networks: [String]) {
  getPaidMediaCampaignDetails(paidMediaCampaignId: $paidMediaCampaignId, networks: $networks) {
    id
    campaignName
    campaignType
    startDate
    endDate
    currency
    networks
    status
    cost
    salesPoint {
      id
      name
    }
    spend
    impressions
    reach
    engagement
    distribution {
      spend {
        socialNetwork
        value
      }
      impressions {
        socialNetwork
        value
      }
      reach {
        socialNetwork
        value
      }
      engagement {
        socialNetwork
        value
      }
    }
    clicks
    cpc
    cpm
    purchase
    total_purchase
    avg_purchase
    margin
  }
}
    `;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      paidMediaCampaignId: // value for 'paidMediaCampaignId'
 *      networks: // value for 'networks'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CampaignsListDocument = gql`
    query campaignsList($salesPointsIds: [ID!], $filters: FilterPaidMedia) {
  getPaidMediaCampaignList(salesPointsIds: $salesPointsIds, filters: $filters) {
    id
    salesPointId
    orderId
    campaignName
    campaignType
    startDate
    endDate
    interfaceSlug
    cost
    currency
    status
    networks
    salesPoint {
      id
      name
    }
  }
}
    `;

/**
 * __useCampaignsListQuery__
 *
 * To run a query within a React component, call `useCampaignsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsListQuery({
 *   variables: {
 *      salesPointsIds: // value for 'salesPointsIds'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCampaignsListQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsListQuery, CampaignsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsListQuery, CampaignsListQueryVariables>(CampaignsListDocument, options);
      }
export function useCampaignsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsListQuery, CampaignsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsListQuery, CampaignsListQueryVariables>(CampaignsListDocument, options);
        }
export type CampaignsListQueryHookResult = ReturnType<typeof useCampaignsListQuery>;
export type CampaignsListLazyQueryHookResult = ReturnType<typeof useCampaignsListLazyQuery>;
export type CampaignsListQueryResult = Apollo.QueryResult<CampaignsListQuery, CampaignsListQueryVariables>;
export const DailyStatsDocument = gql`
    query dailyStats($paidMediaCampaignId: ID!, $networks: [String]) {
  getPaidMediaCampaignDailyInsight(paidMediaCampaignId: $paidMediaCampaignId, networks: $networks) {
    date
    impressions
    reach
    engagement
    clicks
  }
}
    `;

/**
 * __useDailyStatsQuery__
 *
 * To run a query within a React component, call `useDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyStatsQuery({
 *   variables: {
 *      paidMediaCampaignId: // value for 'paidMediaCampaignId'
 *      networks: // value for 'networks'
 *   },
 * });
 */
export function useDailyStatsQuery(baseOptions: Apollo.QueryHookOptions<DailyStatsQuery, DailyStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyStatsQuery, DailyStatsQueryVariables>(DailyStatsDocument, options);
      }
export function useDailyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyStatsQuery, DailyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyStatsQuery, DailyStatsQueryVariables>(DailyStatsDocument, options);
        }
export type DailyStatsQueryHookResult = ReturnType<typeof useDailyStatsQuery>;
export type DailyStatsLazyQueryHookResult = ReturnType<typeof useDailyStatsLazyQuery>;
export type DailyStatsQueryResult = Apollo.QueryResult<DailyStatsQuery, DailyStatsQueryVariables>;
export const GooglePmhMetricsDocument = gql`
    query googlePmhMetrics($filter: GooglePmMetricsFilter) {
  googlePmMetrics(filter: $filter) {
    metrics {
      WEBSITE_CLICKS
      BUSINESS_BOOKINGS
      BUSINESS_FOOD_ORDERS
      BUSINESS_FOOD_MENU_CLICKS
      BUSINESS_IMPRESSIONS_DESKTOP_SEARCH
      BUSINESS_IMPRESSIONS_DESKTOP_MAPS
      BUSINESS_IMPRESSIONS_MOBILE_MAPS
      BUSINESS_IMPRESSIONS_MOBILE_SEARCH
      BUSINESS_CONVERSATIONS
      BUSINESS_DIRECTION_REQUESTS
      CALL_CLICKS
      CLICKS_PREV
      SEARCH_PREV
      BUSINESS_IMPRESSIONS_DESKTOP_SEARCH
      REVIEWS {
        AVERAGE
        ONE
        TWO
        THREE
        FOUR
        FIVE
        HAS_REPLY
        TOTAL
        TOTAL_PERIOD
        TOTAL_PREV
      }
      GRAPH
      PM {
        sync
        need
        no_sync
        no
      }
    }
  }
}
    `;

/**
 * __useGooglePmhMetricsQuery__
 *
 * To run a query within a React component, call `useGooglePmhMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGooglePmhMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGooglePmhMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGooglePmhMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GooglePmhMetricsQuery, GooglePmhMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GooglePmhMetricsQuery, GooglePmhMetricsQueryVariables>(GooglePmhMetricsDocument, options);
      }
export function useGooglePmhMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GooglePmhMetricsQuery, GooglePmhMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GooglePmhMetricsQuery, GooglePmhMetricsQueryVariables>(GooglePmhMetricsDocument, options);
        }
export type GooglePmhMetricsQueryHookResult = ReturnType<typeof useGooglePmhMetricsQuery>;
export type GooglePmhMetricsLazyQueryHookResult = ReturnType<typeof useGooglePmhMetricsLazyQuery>;
export type GooglePmhMetricsQueryResult = Apollo.QueryResult<GooglePmhMetricsQuery, GooglePmhMetricsQueryVariables>;
export const UberallGraphMetricsDocument = gql`
    query UberallGraphMetrics($filter: UberallMetricsFilter) {
  uberallGraphMetrics(filter: $filter) {
    total {
      search {
        count
        variationPercentage
      }
      views {
        count
        variationPercentage
      }
      clicks {
        count
        variationPercentage
      }
    }
    metrics {
      search {
        direct
        indirect
      }
      views {
        maps {
          date
          count
        }
        search {
          date
          count
        }
      }
      clicks {
        website {
          date
          count
        }
        driving_direction {
          date
          count
        }
        phone {
          date
          count
        }
      }
    }
  }
}
    `;

/**
 * __useUberallGraphMetricsQuery__
 *
 * To run a query within a React component, call `useUberallGraphMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUberallGraphMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUberallGraphMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUberallGraphMetricsQuery(baseOptions?: Apollo.QueryHookOptions<UberallGraphMetricsQuery, UberallGraphMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UberallGraphMetricsQuery, UberallGraphMetricsQueryVariables>(UberallGraphMetricsDocument, options);
      }
export function useUberallGraphMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UberallGraphMetricsQuery, UberallGraphMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UberallGraphMetricsQuery, UberallGraphMetricsQueryVariables>(UberallGraphMetricsDocument, options);
        }
export type UberallGraphMetricsQueryHookResult = ReturnType<typeof useUberallGraphMetricsQuery>;
export type UberallGraphMetricsLazyQueryHookResult = ReturnType<typeof useUberallGraphMetricsLazyQuery>;
export type UberallGraphMetricsQueryResult = Apollo.QueryResult<UberallGraphMetricsQuery, UberallGraphMetricsQueryVariables>;
export const ProductMetricsDocument = gql`
    query productMetrics($productId: ID!) {
  productMetrics(productId: $productId) {
    salespointCounts {
      downloads
      orders
      actions
      totalSalespoints
    }
  }
}
    `;

/**
 * __useProductMetricsQuery__
 *
 * To run a query within a React component, call `useProductMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMetricsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductMetricsQuery(baseOptions: Apollo.QueryHookOptions<ProductMetricsQuery, ProductMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMetricsQuery, ProductMetricsQueryVariables>(ProductMetricsDocument, options);
      }
export function useProductMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMetricsQuery, ProductMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMetricsQuery, ProductMetricsQueryVariables>(ProductMetricsDocument, options);
        }
export type ProductMetricsQueryHookResult = ReturnType<typeof useProductMetricsQuery>;
export type ProductMetricsLazyQueryHookResult = ReturnType<typeof useProductMetricsLazyQuery>;
export type ProductMetricsQueryResult = Apollo.QueryResult<ProductMetricsQuery, ProductMetricsQueryVariables>;
export const ProductMetricsSalespointCountsDocument = gql`
    query productMetricsSalespointCounts($productId: ID!) {
  productMetricsSalespointCounts(productId: $productId) {
    salespointCounts {
      downloads
      orders
      actions
      totalSalespoints
    }
  }
}
    `;

/**
 * __useProductMetricsSalespointCountsQuery__
 *
 * To run a query within a React component, call `useProductMetricsSalespointCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMetricsSalespointCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMetricsSalespointCountsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductMetricsSalespointCountsQuery(baseOptions: Apollo.QueryHookOptions<ProductMetricsSalespointCountsQuery, ProductMetricsSalespointCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMetricsSalespointCountsQuery, ProductMetricsSalespointCountsQueryVariables>(ProductMetricsSalespointCountsDocument, options);
      }
export function useProductMetricsSalespointCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMetricsSalespointCountsQuery, ProductMetricsSalespointCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMetricsSalespointCountsQuery, ProductMetricsSalespointCountsQueryVariables>(ProductMetricsSalespointCountsDocument, options);
        }
export type ProductMetricsSalespointCountsQueryHookResult = ReturnType<typeof useProductMetricsSalespointCountsQuery>;
export type ProductMetricsSalespointCountsLazyQueryHookResult = ReturnType<typeof useProductMetricsSalespointCountsLazyQuery>;
export type ProductMetricsSalespointCountsQueryResult = Apollo.QueryResult<ProductMetricsSalespointCountsQuery, ProductMetricsSalespointCountsQueryVariables>;
export const ProductMetricsSalespointDetailsDocument = gql`
    query productMetricsSalespointDetails($productId: ID!, $tableParams: TableParams) {
  productMetricsSalespointDetails(productId: $productId, tableParams: $tableParams) {
    salespointDetails(tableParams: $tableParams) {
      count
      salespointDetails {
        name
        downloads
        orders
        actions
      }
    }
  }
}
    `;

/**
 * __useProductMetricsSalespointDetailsQuery__
 *
 * To run a query within a React component, call `useProductMetricsSalespointDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMetricsSalespointDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMetricsSalespointDetailsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      tableParams: // value for 'tableParams'
 *   },
 * });
 */
export function useProductMetricsSalespointDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductMetricsSalespointDetailsQuery, ProductMetricsSalespointDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMetricsSalespointDetailsQuery, ProductMetricsSalespointDetailsQueryVariables>(ProductMetricsSalespointDetailsDocument, options);
      }
export function useProductMetricsSalespointDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMetricsSalespointDetailsQuery, ProductMetricsSalespointDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMetricsSalespointDetailsQuery, ProductMetricsSalespointDetailsQueryVariables>(ProductMetricsSalespointDetailsDocument, options);
        }
export type ProductMetricsSalespointDetailsQueryHookResult = ReturnType<typeof useProductMetricsSalespointDetailsQuery>;
export type ProductMetricsSalespointDetailsLazyQueryHookResult = ReturnType<typeof useProductMetricsSalespointDetailsLazyQuery>;
export type ProductMetricsSalespointDetailsQueryResult = Apollo.QueryResult<ProductMetricsSalespointDetailsQuery, ProductMetricsSalespointDetailsQueryVariables>;
export const TableMetricsDocument = gql`
    query tableMetrics($productId: ID!, $tableParams: TableParams) {
  productMetrics(productId: $productId) {
    salespointDetails(tableParams: $tableParams) {
      count
      salespointDetails {
        name
        downloads
        orders
        actions
      }
    }
  }
}
    `;

/**
 * __useTableMetricsQuery__
 *
 * To run a query within a React component, call `useTableMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableMetricsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      tableParams: // value for 'tableParams'
 *   },
 * });
 */
export function useTableMetricsQuery(baseOptions: Apollo.QueryHookOptions<TableMetricsQuery, TableMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableMetricsQuery, TableMetricsQueryVariables>(TableMetricsDocument, options);
      }
export function useTableMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableMetricsQuery, TableMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableMetricsQuery, TableMetricsQueryVariables>(TableMetricsDocument, options);
        }
export type TableMetricsQueryHookResult = ReturnType<typeof useTableMetricsQuery>;
export type TableMetricsLazyQueryHookResult = ReturnType<typeof useTableMetricsLazyQuery>;
export type TableMetricsQueryResult = Apollo.QueryResult<TableMetricsQuery, TableMetricsQueryVariables>;
export const MarketPlaceMetricsDocument = gql`
    query marketPlaceMetrics($dateRange: DateRange!, $roleIds: [ID], $salespointsIds: [ID!], $salespointGroupsIds: [ID!], $additionalParams: OrderMetricsParams) {
  orderMetrics(dateRange: $dateRange, roleIds: $roleIds, salespointsIds: $salespointsIds, salespointGroupsIds: $salespointGroupsIds) {
    orders {
      count
      variationPercentage
    }
    turnover {
      count
      variationPercentage
    }
    avgTurnoverPerOrder {
      count
      variationPercentage
    }
    avgOrdersPerUser {
      count
      variationPercentage
    }
    turnoverAndOrdersPerDay {
      date
      turnover
      orders
    }
    productDetails(additionalParams: $additionalParams) {
      count
      productDetails {
        productId
        name
        reference
        type
        downloads
        orders
        packsQuantity
      }
    }
  }
}
    `;

/**
 * __useMarketPlaceMetricsQuery__
 *
 * To run a query within a React component, call `useMarketPlaceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketPlaceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketPlaceMetricsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      roleIds: // value for 'roleIds'
 *      salespointsIds: // value for 'salespointsIds'
 *      salespointGroupsIds: // value for 'salespointGroupsIds'
 *      additionalParams: // value for 'additionalParams'
 *   },
 * });
 */
export function useMarketPlaceMetricsQuery(baseOptions: Apollo.QueryHookOptions<MarketPlaceMetricsQuery, MarketPlaceMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketPlaceMetricsQuery, MarketPlaceMetricsQueryVariables>(MarketPlaceMetricsDocument, options);
      }
export function useMarketPlaceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketPlaceMetricsQuery, MarketPlaceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketPlaceMetricsQuery, MarketPlaceMetricsQueryVariables>(MarketPlaceMetricsDocument, options);
        }
export type MarketPlaceMetricsQueryHookResult = ReturnType<typeof useMarketPlaceMetricsQuery>;
export type MarketPlaceMetricsLazyQueryHookResult = ReturnType<typeof useMarketPlaceMetricsLazyQuery>;
export type MarketPlaceMetricsQueryResult = Apollo.QueryResult<MarketPlaceMetricsQuery, MarketPlaceMetricsQueryVariables>;
export const PackOrderMetricsDocument = gql`
    query packOrderMetrics($dateRange: DateRange!, $roleIds: [ID], $salespointsIds: [ID!], $salespointGroupsIds: [ID!], $additionalParams: OrderMetricsParams) {
  packOrderMetrics(dateRange: $dateRange, roleIds: $roleIds, salespointsIds: $salespointsIds, salespointGroupsIds: $salespointGroupsIds) {
    packDetails(additionalParams: $additionalParams) {
      count
      packDetails {
        packId
        name
        reference
        productsInPackCount
        quantityOfProductOrdered
        turnoverOfProductOrdered
      }
    }
  }
}
    `;

/**
 * __usePackOrderMetricsQuery__
 *
 * To run a query within a React component, call `usePackOrderMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackOrderMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackOrderMetricsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      roleIds: // value for 'roleIds'
 *      salespointsIds: // value for 'salespointsIds'
 *      salespointGroupsIds: // value for 'salespointGroupsIds'
 *      additionalParams: // value for 'additionalParams'
 *   },
 * });
 */
export function usePackOrderMetricsQuery(baseOptions: Apollo.QueryHookOptions<PackOrderMetricsQuery, PackOrderMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackOrderMetricsQuery, PackOrderMetricsQueryVariables>(PackOrderMetricsDocument, options);
      }
export function usePackOrderMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackOrderMetricsQuery, PackOrderMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackOrderMetricsQuery, PackOrderMetricsQueryVariables>(PackOrderMetricsDocument, options);
        }
export type PackOrderMetricsQueryHookResult = ReturnType<typeof usePackOrderMetricsQuery>;
export type PackOrderMetricsLazyQueryHookResult = ReturnType<typeof usePackOrderMetricsLazyQuery>;
export type PackOrderMetricsQueryResult = Apollo.QueryResult<PackOrderMetricsQuery, PackOrderMetricsQueryVariables>;
export const ExportMetricsArrayDocument = gql`
    mutation exportMetricsArray($dateRange: DateRange, $exportType: ExportTypes!, $exportArgsJSON: String, $format: UploadFormat) {
  exportMetricsArray(dateRange: $dateRange, exportType: $exportType, exportArgsJSON: $exportArgsJSON, format: $format)
}
    `;
export type ExportMetricsArrayMutationFn = Apollo.MutationFunction<ExportMetricsArrayMutation, ExportMetricsArrayMutationVariables>;

/**
 * __useExportMetricsArrayMutation__
 *
 * To run a mutation, you first call `useExportMetricsArrayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMetricsArrayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMetricsArrayMutation, { data, loading, error }] = useExportMetricsArrayMutation({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      exportType: // value for 'exportType'
 *      exportArgsJSON: // value for 'exportArgsJSON'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportMetricsArrayMutation(baseOptions?: Apollo.MutationHookOptions<ExportMetricsArrayMutation, ExportMetricsArrayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportMetricsArrayMutation, ExportMetricsArrayMutationVariables>(ExportMetricsArrayDocument, options);
      }
export type ExportMetricsArrayMutationHookResult = ReturnType<typeof useExportMetricsArrayMutation>;
export type ExportMetricsArrayMutationResult = Apollo.MutationResult<ExportMetricsArrayMutation>;
export type ExportMetricsArrayMutationOptions = Apollo.BaseMutationOptions<ExportMetricsArrayMutation, ExportMetricsArrayMutationVariables>;
export const DownloadAnswerTemplatesFileDocument = gql`
    query downloadAnswerTemplatesFile {
  downloadAnswerTemplatesFile
}
    `;

/**
 * __useDownloadAnswerTemplatesFileQuery__
 *
 * To run a query within a React component, call `useDownloadAnswerTemplatesFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAnswerTemplatesFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAnswerTemplatesFileQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownloadAnswerTemplatesFileQuery(baseOptions?: Apollo.QueryHookOptions<DownloadAnswerTemplatesFileQuery, DownloadAnswerTemplatesFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadAnswerTemplatesFileQuery, DownloadAnswerTemplatesFileQueryVariables>(DownloadAnswerTemplatesFileDocument, options);
      }
export function useDownloadAnswerTemplatesFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAnswerTemplatesFileQuery, DownloadAnswerTemplatesFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadAnswerTemplatesFileQuery, DownloadAnswerTemplatesFileQueryVariables>(DownloadAnswerTemplatesFileDocument, options);
        }
export type DownloadAnswerTemplatesFileQueryHookResult = ReturnType<typeof useDownloadAnswerTemplatesFileQuery>;
export type DownloadAnswerTemplatesFileLazyQueryHookResult = ReturnType<typeof useDownloadAnswerTemplatesFileLazyQuery>;
export type DownloadAnswerTemplatesFileQueryResult = Apollo.QueryResult<DownloadAnswerTemplatesFileQuery, DownloadAnswerTemplatesFileQueryVariables>;
export const UploadAnswerTemplatesDocument = gql`
    mutation uploadAnswerTemplates($file: Upload!) {
  uploadAnswerTemplates(file: $file)
}
    `;
export type UploadAnswerTemplatesMutationFn = Apollo.MutationFunction<UploadAnswerTemplatesMutation, UploadAnswerTemplatesMutationVariables>;

/**
 * __useUploadAnswerTemplatesMutation__
 *
 * To run a mutation, you first call `useUploadAnswerTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAnswerTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAnswerTemplatesMutation, { data, loading, error }] = useUploadAnswerTemplatesMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAnswerTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<UploadAnswerTemplatesMutation, UploadAnswerTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAnswerTemplatesMutation, UploadAnswerTemplatesMutationVariables>(UploadAnswerTemplatesDocument, options);
      }
export type UploadAnswerTemplatesMutationHookResult = ReturnType<typeof useUploadAnswerTemplatesMutation>;
export type UploadAnswerTemplatesMutationResult = Apollo.MutationResult<UploadAnswerTemplatesMutation>;
export type UploadAnswerTemplatesMutationOptions = Apollo.BaseMutationOptions<UploadAnswerTemplatesMutation, UploadAnswerTemplatesMutationVariables>;
export const ConsolidatePostDocument = gql`
    mutation consolidatePost($publishId: ID!) {
  consolidatePost(publishId: $publishId)
}
    `;
export type ConsolidatePostMutationFn = Apollo.MutationFunction<ConsolidatePostMutation, ConsolidatePostMutationVariables>;

/**
 * __useConsolidatePostMutation__
 *
 * To run a mutation, you first call `useConsolidatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidatePostMutation, { data, loading, error }] = useConsolidatePostMutation({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useConsolidatePostMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidatePostMutation, ConsolidatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsolidatePostMutation, ConsolidatePostMutationVariables>(ConsolidatePostDocument, options);
      }
export type ConsolidatePostMutationHookResult = ReturnType<typeof useConsolidatePostMutation>;
export type ConsolidatePostMutationResult = Apollo.MutationResult<ConsolidatePostMutation>;
export type ConsolidatePostMutationOptions = Apollo.BaseMutationOptions<ConsolidatePostMutation, ConsolidatePostMutationVariables>;
export const GetAmplifyCampaignDetailsDocument = gql`
    query getAmplifyCampaignDetails($id: ID!) {
  getAmplifyCampaignDetails(id: $id) {
    id
    name
    target {
      type
      salesPoints {
        name
      }
      onGlobals
    }
    authorRole
    author {
      id
      fullName
    }
    geoRadius
    post {
      id
      type
      preview {
        type
        content
        videoThumbnail
        caption
        targettedNetworks
        dates {
          start
          end
        }
      }
      target {
        type
      }
      author {
        id
        fullName
        role {
          id
          name
        }
      }
      socialNetworkTarget
    }
    status
    totalStatus {
      done
      error
      terminated
    }
    adsCount
    totalBudget
    perPostBudget
    spentBudget
    spentReach
    spentInteraction
    cpi
    connection
    isDefaultChalandiseZone
    startAt
    endAt
    sexOfTarget
    minAgeTarget
    maxAgeTarget
    optimizationGoal
    targetingInterests {
      facebookKey
      name
    }
    targetingCountries {
      facebookKey
      name
    }
    targetingGeolocations {
      facebookKey
      name
    }
  }
}
    `;

/**
 * __useGetAmplifyCampaignDetailsQuery__
 *
 * To run a query within a React component, call `useGetAmplifyCampaignDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmplifyCampaignDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmplifyCampaignDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAmplifyCampaignDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAmplifyCampaignDetailsQuery, GetAmplifyCampaignDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmplifyCampaignDetailsQuery, GetAmplifyCampaignDetailsQueryVariables>(GetAmplifyCampaignDetailsDocument, options);
      }
export function useGetAmplifyCampaignDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmplifyCampaignDetailsQuery, GetAmplifyCampaignDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmplifyCampaignDetailsQuery, GetAmplifyCampaignDetailsQueryVariables>(GetAmplifyCampaignDetailsDocument, options);
        }
export type GetAmplifyCampaignDetailsQueryHookResult = ReturnType<typeof useGetAmplifyCampaignDetailsQuery>;
export type GetAmplifyCampaignDetailsLazyQueryHookResult = ReturnType<typeof useGetAmplifyCampaignDetailsLazyQuery>;
export type GetAmplifyCampaignDetailsQueryResult = Apollo.QueryResult<GetAmplifyCampaignDetailsQuery, GetAmplifyCampaignDetailsQueryVariables>;
export const GetPostCalendarDetailsForAdminDocument = gql`
    query getPostCalendarDetailsForAdmin($publishId: ID!) {
  getPostCalendarDetails(publishId: $publishId) {
    id
    ...PostPreviewPublish
    target {
      type
    }
    createdAt
    scheduledAt
    type
    totalPosts
    authorRole
    author {
      id
      fullName
    }
    socialNetworkTarget
    socialNetworkAccountUrl
    socialNetworkPostUrl
    status
    avatar {
      path
    }
    medias {
      path
      mimeType
    }
    thumb {
      path
      mimeType
    }
    event {
      title
      startAt
      endAt
      callToAction
      terms
      couponCode
    }
  }
}
    ${PostPreviewPublishFragmentDoc}`;

/**
 * __useGetPostCalendarDetailsForAdminQuery__
 *
 * To run a query within a React component, call `useGetPostCalendarDetailsForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCalendarDetailsForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCalendarDetailsForAdminQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useGetPostCalendarDetailsForAdminQuery(baseOptions: Apollo.QueryHookOptions<GetPostCalendarDetailsForAdminQuery, GetPostCalendarDetailsForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCalendarDetailsForAdminQuery, GetPostCalendarDetailsForAdminQueryVariables>(GetPostCalendarDetailsForAdminDocument, options);
      }
export function useGetPostCalendarDetailsForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCalendarDetailsForAdminQuery, GetPostCalendarDetailsForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCalendarDetailsForAdminQuery, GetPostCalendarDetailsForAdminQueryVariables>(GetPostCalendarDetailsForAdminDocument, options);
        }
export type GetPostCalendarDetailsForAdminQueryHookResult = ReturnType<typeof useGetPostCalendarDetailsForAdminQuery>;
export type GetPostCalendarDetailsForAdminLazyQueryHookResult = ReturnType<typeof useGetPostCalendarDetailsForAdminLazyQuery>;
export type GetPostCalendarDetailsForAdminQueryResult = Apollo.QueryResult<GetPostCalendarDetailsForAdminQuery, GetPostCalendarDetailsForAdminQueryVariables>;
export const GetPostCalendarPostsForAdminDocument = gql`
    query getPostCalendarPostsForAdmin($publishId: ID!) {
  getPostCalendarPosts(publishId: $publishId) {
    success
    data {
      id
      socialNetworkTarget
      status
      errorStatus
      errorMessage
      socialNetworkAccountUrl
      socialNetworkPostUrl
      socialNetworkPage {
        id
        url
        name
      }
      salesPointTargeted {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetPostCalendarPostsForAdminQuery__
 *
 * To run a query within a React component, call `useGetPostCalendarPostsForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostCalendarPostsForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostCalendarPostsForAdminQuery({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useGetPostCalendarPostsForAdminQuery(baseOptions: Apollo.QueryHookOptions<GetPostCalendarPostsForAdminQuery, GetPostCalendarPostsForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostCalendarPostsForAdminQuery, GetPostCalendarPostsForAdminQueryVariables>(GetPostCalendarPostsForAdminDocument, options);
      }
export function useGetPostCalendarPostsForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostCalendarPostsForAdminQuery, GetPostCalendarPostsForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostCalendarPostsForAdminQuery, GetPostCalendarPostsForAdminQueryVariables>(GetPostCalendarPostsForAdminDocument, options);
        }
export type GetPostCalendarPostsForAdminQueryHookResult = ReturnType<typeof useGetPostCalendarPostsForAdminQuery>;
export type GetPostCalendarPostsForAdminLazyQueryHookResult = ReturnType<typeof useGetPostCalendarPostsForAdminLazyQuery>;
export type GetPostCalendarPostsForAdminQueryResult = Apollo.QueryResult<GetPostCalendarPostsForAdminQuery, GetPostCalendarPostsForAdminQueryVariables>;
export const MarkAllErrorPostsAsDoneDocument = gql`
    mutation markAllErrorPostsAsDone($publishId: ID!) {
  markAllErrorPostsAsDone(publishId: $publishId)
}
    `;
export type MarkAllErrorPostsAsDoneMutationFn = Apollo.MutationFunction<MarkAllErrorPostsAsDoneMutation, MarkAllErrorPostsAsDoneMutationVariables>;

/**
 * __useMarkAllErrorPostsAsDoneMutation__
 *
 * To run a mutation, you first call `useMarkAllErrorPostsAsDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllErrorPostsAsDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllErrorPostsAsDoneMutation, { data, loading, error }] = useMarkAllErrorPostsAsDoneMutation({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useMarkAllErrorPostsAsDoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllErrorPostsAsDoneMutation, MarkAllErrorPostsAsDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllErrorPostsAsDoneMutation, MarkAllErrorPostsAsDoneMutationVariables>(MarkAllErrorPostsAsDoneDocument, options);
      }
export type MarkAllErrorPostsAsDoneMutationHookResult = ReturnType<typeof useMarkAllErrorPostsAsDoneMutation>;
export type MarkAllErrorPostsAsDoneMutationResult = Apollo.MutationResult<MarkAllErrorPostsAsDoneMutation>;
export type MarkAllErrorPostsAsDoneMutationOptions = Apollo.BaseMutationOptions<MarkAllErrorPostsAsDoneMutation, MarkAllErrorPostsAsDoneMutationVariables>;
export const MarkErrorPostsAsDoneDocument = gql`
    mutation markErrorPostsAsDone($publishId: ID!, $postIds: [ID!]!) {
  markErrorPostsAsDone(publishId: $publishId, postIds: $postIds)
}
    `;
export type MarkErrorPostsAsDoneMutationFn = Apollo.MutationFunction<MarkErrorPostsAsDoneMutation, MarkErrorPostsAsDoneMutationVariables>;

/**
 * __useMarkErrorPostsAsDoneMutation__
 *
 * To run a mutation, you first call `useMarkErrorPostsAsDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkErrorPostsAsDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markErrorPostsAsDoneMutation, { data, loading, error }] = useMarkErrorPostsAsDoneMutation({
 *   variables: {
 *      publishId: // value for 'publishId'
 *      postIds: // value for 'postIds'
 *   },
 * });
 */
export function useMarkErrorPostsAsDoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkErrorPostsAsDoneMutation, MarkErrorPostsAsDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkErrorPostsAsDoneMutation, MarkErrorPostsAsDoneMutationVariables>(MarkErrorPostsAsDoneDocument, options);
      }
export type MarkErrorPostsAsDoneMutationHookResult = ReturnType<typeof useMarkErrorPostsAsDoneMutation>;
export type MarkErrorPostsAsDoneMutationResult = Apollo.MutationResult<MarkErrorPostsAsDoneMutation>;
export type MarkErrorPostsAsDoneMutationOptions = Apollo.BaseMutationOptions<MarkErrorPostsAsDoneMutation, MarkErrorPostsAsDoneMutationVariables>;
export const ResetCampaignDocument = gql`
    mutation resetCampaign($id: ID!) {
  resetCampaign(id: $id)
}
    `;
export type ResetCampaignMutationFn = Apollo.MutationFunction<ResetCampaignMutation, ResetCampaignMutationVariables>;

/**
 * __useResetCampaignMutation__
 *
 * To run a mutation, you first call `useResetCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCampaignMutation, { data, loading, error }] = useResetCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ResetCampaignMutation, ResetCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCampaignMutation, ResetCampaignMutationVariables>(ResetCampaignDocument, options);
      }
export type ResetCampaignMutationHookResult = ReturnType<typeof useResetCampaignMutation>;
export type ResetCampaignMutationResult = Apollo.MutationResult<ResetCampaignMutation>;
export type ResetCampaignMutationOptions = Apollo.BaseMutationOptions<ResetCampaignMutation, ResetCampaignMutationVariables>;
export const ResetErrorPostsDocument = gql`
    mutation resetErrorPosts($publishId: ID!) {
  resetErrorPosts(publishId: $publishId)
}
    `;
export type ResetErrorPostsMutationFn = Apollo.MutationFunction<ResetErrorPostsMutation, ResetErrorPostsMutationVariables>;

/**
 * __useResetErrorPostsMutation__
 *
 * To run a mutation, you first call `useResetErrorPostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetErrorPostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetErrorPostsMutation, { data, loading, error }] = useResetErrorPostsMutation({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useResetErrorPostsMutation(baseOptions?: Apollo.MutationHookOptions<ResetErrorPostsMutation, ResetErrorPostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetErrorPostsMutation, ResetErrorPostsMutationVariables>(ResetErrorPostsDocument, options);
      }
export type ResetErrorPostsMutationHookResult = ReturnType<typeof useResetErrorPostsMutation>;
export type ResetErrorPostsMutationResult = Apollo.MutationResult<ResetErrorPostsMutation>;
export type ResetErrorPostsMutationOptions = Apollo.BaseMutationOptions<ResetErrorPostsMutation, ResetErrorPostsMutationVariables>;
export const StopPostsDocument = gql`
    mutation stopPosts($publishId: ID!) {
  stopPosts(publishId: $publishId)
}
    `;
export type StopPostsMutationFn = Apollo.MutationFunction<StopPostsMutation, StopPostsMutationVariables>;

/**
 * __useStopPostsMutation__
 *
 * To run a mutation, you first call `useStopPostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopPostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopPostsMutation, { data, loading, error }] = useStopPostsMutation({
 *   variables: {
 *      publishId: // value for 'publishId'
 *   },
 * });
 */
export function useStopPostsMutation(baseOptions?: Apollo.MutationHookOptions<StopPostsMutation, StopPostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopPostsMutation, StopPostsMutationVariables>(StopPostsDocument, options);
      }
export type StopPostsMutationHookResult = ReturnType<typeof useStopPostsMutation>;
export type StopPostsMutationResult = Apollo.MutationResult<StopPostsMutation>;
export type StopPostsMutationOptions = Apollo.BaseMutationOptions<StopPostsMutation, StopPostsMutationVariables>;
export const DeletePastSpecialOpeningHoursDocument = gql`
    mutation deletePastSpecialOpeningHours($clientId: String) {
  deletePastSpecialOpeningHours(clientId: $clientId)
}
    `;
export type DeletePastSpecialOpeningHoursMutationFn = Apollo.MutationFunction<DeletePastSpecialOpeningHoursMutation, DeletePastSpecialOpeningHoursMutationVariables>;

/**
 * __useDeletePastSpecialOpeningHoursMutation__
 *
 * To run a mutation, you first call `useDeletePastSpecialOpeningHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePastSpecialOpeningHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePastSpecialOpeningHoursMutation, { data, loading, error }] = useDeletePastSpecialOpeningHoursMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useDeletePastSpecialOpeningHoursMutation(baseOptions?: Apollo.MutationHookOptions<DeletePastSpecialOpeningHoursMutation, DeletePastSpecialOpeningHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePastSpecialOpeningHoursMutation, DeletePastSpecialOpeningHoursMutationVariables>(DeletePastSpecialOpeningHoursDocument, options);
      }
export type DeletePastSpecialOpeningHoursMutationHookResult = ReturnType<typeof useDeletePastSpecialOpeningHoursMutation>;
export type DeletePastSpecialOpeningHoursMutationResult = Apollo.MutationResult<DeletePastSpecialOpeningHoursMutation>;
export type DeletePastSpecialOpeningHoursMutationOptions = Apollo.BaseMutationOptions<DeletePastSpecialOpeningHoursMutation, DeletePastSpecialOpeningHoursMutationVariables>;
export const ResetSalesPointDocument = gql`
    mutation resetSalesPoint($args: ResetSalesPointArgs!) {
  resetSalesPoint(args: $args) {
    success
  }
}
    `;
export type ResetSalesPointMutationFn = Apollo.MutationFunction<ResetSalesPointMutation, ResetSalesPointMutationVariables>;

/**
 * __useResetSalesPointMutation__
 *
 * To run a mutation, you first call `useResetSalesPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSalesPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSalesPointMutation, { data, loading, error }] = useResetSalesPointMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useResetSalesPointMutation(baseOptions?: Apollo.MutationHookOptions<ResetSalesPointMutation, ResetSalesPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetSalesPointMutation, ResetSalesPointMutationVariables>(ResetSalesPointDocument, options);
      }
export type ResetSalesPointMutationHookResult = ReturnType<typeof useResetSalesPointMutation>;
export type ResetSalesPointMutationResult = Apollo.MutationResult<ResetSalesPointMutation>;
export type ResetSalesPointMutationOptions = Apollo.BaseMutationOptions<ResetSalesPointMutation, ResetSalesPointMutationVariables>;
export const AddNewsDocument = gql`
    mutation addNews($news: NewsInput!, $image: Upload) {
  addNews(news: $news, image: $image) {
    id
  }
}
    `;
export type AddNewsMutationFn = Apollo.MutationFunction<AddNewsMutation, AddNewsMutationVariables>;

/**
 * __useAddNewsMutation__
 *
 * To run a mutation, you first call `useAddNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewsMutation, { data, loading, error }] = useAddNewsMutation({
 *   variables: {
 *      news: // value for 'news'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useAddNewsMutation(baseOptions?: Apollo.MutationHookOptions<AddNewsMutation, AddNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewsMutation, AddNewsMutationVariables>(AddNewsDocument, options);
      }
export type AddNewsMutationHookResult = ReturnType<typeof useAddNewsMutation>;
export type AddNewsMutationResult = Apollo.MutationResult<AddNewsMutation>;
export type AddNewsMutationOptions = Apollo.BaseMutationOptions<AddNewsMutation, AddNewsMutationVariables>;
export const UpdateNewsDocument = gql`
    mutation updateNews($id: ID!, $news: NewsInput!, $newImage: Upload, $deleteImage: Boolean) {
  updateNews(id: $id, news: $news, newImage: $newImage, deleteImage: $deleteImage) {
    id
    contents {
      lang
      title
    }
  }
}
    `;
export type UpdateNewsMutationFn = Apollo.MutationFunction<UpdateNewsMutation, UpdateNewsMutationVariables>;

/**
 * __useUpdateNewsMutation__
 *
 * To run a mutation, you first call `useUpdateNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsMutation, { data, loading, error }] = useUpdateNewsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      news: // value for 'news'
 *      newImage: // value for 'newImage'
 *      deleteImage: // value for 'deleteImage'
 *   },
 * });
 */
export function useUpdateNewsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsMutation, UpdateNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsMutation, UpdateNewsMutationVariables>(UpdateNewsDocument, options);
      }
export type UpdateNewsMutationHookResult = ReturnType<typeof useUpdateNewsMutation>;
export type UpdateNewsMutationResult = Apollo.MutationResult<UpdateNewsMutation>;
export type UpdateNewsMutationOptions = Apollo.BaseMutationOptions<UpdateNewsMutation, UpdateNewsMutationVariables>;
export const NewsListScreen_GetNewsListDocument = gql`
    query NewsListScreen_getNewsList {
  getNewsList {
    id
    contents {
      lang
      title
    }
  }
}
    `;

/**
 * __useNewsListScreen_GetNewsListQuery__
 *
 * To run a query within a React component, call `useNewsListScreen_GetNewsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsListScreen_GetNewsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsListScreen_GetNewsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewsListScreen_GetNewsListQuery(baseOptions?: Apollo.QueryHookOptions<NewsListScreen_GetNewsListQuery, NewsListScreen_GetNewsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsListScreen_GetNewsListQuery, NewsListScreen_GetNewsListQueryVariables>(NewsListScreen_GetNewsListDocument, options);
      }
export function useNewsListScreen_GetNewsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsListScreen_GetNewsListQuery, NewsListScreen_GetNewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsListScreen_GetNewsListQuery, NewsListScreen_GetNewsListQueryVariables>(NewsListScreen_GetNewsListDocument, options);
        }
export type NewsListScreen_GetNewsListQueryHookResult = ReturnType<typeof useNewsListScreen_GetNewsListQuery>;
export type NewsListScreen_GetNewsListLazyQueryHookResult = ReturnType<typeof useNewsListScreen_GetNewsListLazyQuery>;
export type NewsListScreen_GetNewsListQueryResult = Apollo.QueryResult<NewsListScreen_GetNewsListQuery, NewsListScreen_GetNewsListQueryVariables>;
export const GetAllClientsOrganizationDocument = gql`
    query getAllClientsOrganization {
  getAllClients {
    id
    name
    clientId
  }
}
    `;

/**
 * __useGetAllClientsOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAllClientsOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientsOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientsOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientsOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClientsOrganizationQuery, GetAllClientsOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientsOrganizationQuery, GetAllClientsOrganizationQueryVariables>(GetAllClientsOrganizationDocument, options);
      }
export function useGetAllClientsOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientsOrganizationQuery, GetAllClientsOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientsOrganizationQuery, GetAllClientsOrganizationQueryVariables>(GetAllClientsOrganizationDocument, options);
        }
export type GetAllClientsOrganizationQueryHookResult = ReturnType<typeof useGetAllClientsOrganizationQuery>;
export type GetAllClientsOrganizationLazyQueryHookResult = ReturnType<typeof useGetAllClientsOrganizationLazyQuery>;
export type GetAllClientsOrganizationQueryResult = Apollo.QueryResult<GetAllClientsOrganizationQuery, GetAllClientsOrganizationQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($client: ClientInfo!) {
  createClient(client: $client) {
    id
    name
    clientId
    features {
      name
      enabled
    }
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      client: // value for 'client'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const ExportBriefSpecClientsDocument = gql`
    mutation exportBriefSpecClients($clientId: String!) {
  exportBriefSpecClients(clientId: $clientId)
}
    `;
export type ExportBriefSpecClientsMutationFn = Apollo.MutationFunction<ExportBriefSpecClientsMutation, ExportBriefSpecClientsMutationVariables>;

/**
 * __useExportBriefSpecClientsMutation__
 *
 * To run a mutation, you first call `useExportBriefSpecClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportBriefSpecClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportBriefSpecClientsMutation, { data, loading, error }] = useExportBriefSpecClientsMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useExportBriefSpecClientsMutation(baseOptions?: Apollo.MutationHookOptions<ExportBriefSpecClientsMutation, ExportBriefSpecClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportBriefSpecClientsMutation, ExportBriefSpecClientsMutationVariables>(ExportBriefSpecClientsDocument, options);
      }
export type ExportBriefSpecClientsMutationHookResult = ReturnType<typeof useExportBriefSpecClientsMutation>;
export type ExportBriefSpecClientsMutationResult = Apollo.MutationResult<ExportBriefSpecClientsMutation>;
export type ExportBriefSpecClientsMutationOptions = Apollo.BaseMutationOptions<ExportBriefSpecClientsMutation, ExportBriefSpecClientsMutationVariables>;
export const ImportBriefTechnicalSpecificationsDocument = gql`
    mutation importBriefTechnicalSpecifications($file: Upload!, $clientId: String!) {
  importBriefTechnicalSpecifications(file: $file, clientId: $clientId)
}
    `;
export type ImportBriefTechnicalSpecificationsMutationFn = Apollo.MutationFunction<ImportBriefTechnicalSpecificationsMutation, ImportBriefTechnicalSpecificationsMutationVariables>;

/**
 * __useImportBriefTechnicalSpecificationsMutation__
 *
 * To run a mutation, you first call `useImportBriefTechnicalSpecificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportBriefTechnicalSpecificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importBriefTechnicalSpecificationsMutation, { data, loading, error }] = useImportBriefTechnicalSpecificationsMutation({
 *   variables: {
 *      file: // value for 'file'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useImportBriefTechnicalSpecificationsMutation(baseOptions?: Apollo.MutationHookOptions<ImportBriefTechnicalSpecificationsMutation, ImportBriefTechnicalSpecificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportBriefTechnicalSpecificationsMutation, ImportBriefTechnicalSpecificationsMutationVariables>(ImportBriefTechnicalSpecificationsDocument, options);
      }
export type ImportBriefTechnicalSpecificationsMutationHookResult = ReturnType<typeof useImportBriefTechnicalSpecificationsMutation>;
export type ImportBriefTechnicalSpecificationsMutationResult = Apollo.MutationResult<ImportBriefTechnicalSpecificationsMutation>;
export type ImportBriefTechnicalSpecificationsMutationOptions = Apollo.BaseMutationOptions<ImportBriefTechnicalSpecificationsMutation, ImportBriefTechnicalSpecificationsMutationVariables>;
export const SyncVirtualUserAccountsDocument = gql`
    mutation syncVirtualUserAccounts($clientId: String!) {
  syncVirtualUserAccounts(clientId: $clientId)
}
    `;
export type SyncVirtualUserAccountsMutationFn = Apollo.MutationFunction<SyncVirtualUserAccountsMutation, SyncVirtualUserAccountsMutationVariables>;

/**
 * __useSyncVirtualUserAccountsMutation__
 *
 * To run a mutation, you first call `useSyncVirtualUserAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncVirtualUserAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncVirtualUserAccountsMutation, { data, loading, error }] = useSyncVirtualUserAccountsMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSyncVirtualUserAccountsMutation(baseOptions?: Apollo.MutationHookOptions<SyncVirtualUserAccountsMutation, SyncVirtualUserAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncVirtualUserAccountsMutation, SyncVirtualUserAccountsMutationVariables>(SyncVirtualUserAccountsDocument, options);
      }
export type SyncVirtualUserAccountsMutationHookResult = ReturnType<typeof useSyncVirtualUserAccountsMutation>;
export type SyncVirtualUserAccountsMutationResult = Apollo.MutationResult<SyncVirtualUserAccountsMutation>;
export type SyncVirtualUserAccountsMutationOptions = Apollo.BaseMutationOptions<SyncVirtualUserAccountsMutation, SyncVirtualUserAccountsMutationVariables>;
export const SynchroClientPmImagesDocument = gql`
    mutation synchroClientPmImages($slugClient: String!) {
  synchroClientPmImages(slugClient: $slugClient)
}
    `;
export type SynchroClientPmImagesMutationFn = Apollo.MutationFunction<SynchroClientPmImagesMutation, SynchroClientPmImagesMutationVariables>;

/**
 * __useSynchroClientPmImagesMutation__
 *
 * To run a mutation, you first call `useSynchroClientPmImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSynchroClientPmImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [synchroClientPmImagesMutation, { data, loading, error }] = useSynchroClientPmImagesMutation({
 *   variables: {
 *      slugClient: // value for 'slugClient'
 *   },
 * });
 */
export function useSynchroClientPmImagesMutation(baseOptions?: Apollo.MutationHookOptions<SynchroClientPmImagesMutation, SynchroClientPmImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SynchroClientPmImagesMutation, SynchroClientPmImagesMutationVariables>(SynchroClientPmImagesDocument, options);
      }
export type SynchroClientPmImagesMutationHookResult = ReturnType<typeof useSynchroClientPmImagesMutation>;
export type SynchroClientPmImagesMutationResult = Apollo.MutationResult<SynchroClientPmImagesMutation>;
export type SynchroClientPmImagesMutationOptions = Apollo.BaseMutationOptions<SynchroClientPmImagesMutation, SynchroClientPmImagesMutationVariables>;
export const UpdateClientPmServicesDocument = gql`
    mutation updateClientPmServices($id: ID!) {
  updateClientPmServices(id: $id)
}
    `;
export type UpdateClientPmServicesMutationFn = Apollo.MutationFunction<UpdateClientPmServicesMutation, UpdateClientPmServicesMutationVariables>;

/**
 * __useUpdateClientPmServicesMutation__
 *
 * To run a mutation, you first call `useUpdateClientPmServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientPmServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientPmServicesMutation, { data, loading, error }] = useUpdateClientPmServicesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateClientPmServicesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientPmServicesMutation, UpdateClientPmServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientPmServicesMutation, UpdateClientPmServicesMutationVariables>(UpdateClientPmServicesDocument, options);
      }
export type UpdateClientPmServicesMutationHookResult = ReturnType<typeof useUpdateClientPmServicesMutation>;
export type UpdateClientPmServicesMutationResult = Apollo.MutationResult<UpdateClientPmServicesMutation>;
export type UpdateClientPmServicesMutationOptions = Apollo.BaseMutationOptions<UpdateClientPmServicesMutation, UpdateClientPmServicesMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($id: ID!, $client: ClientInfo!) {
  updateClient(id: $id, client: $client) {
    id
    name
    clientId
    homepageFeature
    features {
      name
      enabled
    }
    socialOptions {
      cronActivated
    }
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      client: // value for 'client'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateClientPmAttributesDocument = gql`
    mutation updateClientPmAttributes($id: ID!) {
  updateClientPmAttributes(id: $id)
}
    `;
export type UpdateClientPmAttributesMutationFn = Apollo.MutationFunction<UpdateClientPmAttributesMutation, UpdateClientPmAttributesMutationVariables>;

/**
 * __useUpdateClientPmAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateClientPmAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientPmAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientPmAttributesMutation, { data, loading, error }] = useUpdateClientPmAttributesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateClientPmAttributesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientPmAttributesMutation, UpdateClientPmAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientPmAttributesMutation, UpdateClientPmAttributesMutationVariables>(UpdateClientPmAttributesDocument, options);
      }
export type UpdateClientPmAttributesMutationHookResult = ReturnType<typeof useUpdateClientPmAttributesMutation>;
export type UpdateClientPmAttributesMutationResult = Apollo.MutationResult<UpdateClientPmAttributesMutation>;
export type UpdateClientPmAttributesMutationOptions = Apollo.BaseMutationOptions<UpdateClientPmAttributesMutation, UpdateClientPmAttributesMutationVariables>;
export const GeneratePaidMediaCampaignsDocument = gql`
    mutation generatePaidMediaCampaigns($file: Upload!) {
  generatePaidMediaCampaigns(file: $file)
}
    `;
export type GeneratePaidMediaCampaignsMutationFn = Apollo.MutationFunction<GeneratePaidMediaCampaignsMutation, GeneratePaidMediaCampaignsMutationVariables>;

/**
 * __useGeneratePaidMediaCampaignsMutation__
 *
 * To run a mutation, you first call `useGeneratePaidMediaCampaignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePaidMediaCampaignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePaidMediaCampaignsMutation, { data, loading, error }] = useGeneratePaidMediaCampaignsMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useGeneratePaidMediaCampaignsMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePaidMediaCampaignsMutation, GeneratePaidMediaCampaignsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePaidMediaCampaignsMutation, GeneratePaidMediaCampaignsMutationVariables>(GeneratePaidMediaCampaignsDocument, options);
      }
export type GeneratePaidMediaCampaignsMutationHookResult = ReturnType<typeof useGeneratePaidMediaCampaignsMutation>;
export type GeneratePaidMediaCampaignsMutationResult = Apollo.MutationResult<GeneratePaidMediaCampaignsMutation>;
export type GeneratePaidMediaCampaignsMutationOptions = Apollo.BaseMutationOptions<GeneratePaidMediaCampaignsMutation, GeneratePaidMediaCampaignsMutationVariables>;
export const ProviderListDocument = gql`
    query providerList {
  providers {
    id
    name
    slug
    usersCount
    enabled
  }
}
    `;

/**
 * __useProviderListQuery__
 *
 * To run a query within a React component, call `useProviderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderListQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderListQuery(baseOptions?: Apollo.QueryHookOptions<ProviderListQuery, ProviderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderListQuery, ProviderListQueryVariables>(ProviderListDocument, options);
      }
export function useProviderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderListQuery, ProviderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderListQuery, ProviderListQueryVariables>(ProviderListDocument, options);
        }
export type ProviderListQueryHookResult = ReturnType<typeof useProviderListQuery>;
export type ProviderListLazyQueryHookResult = ReturnType<typeof useProviderListLazyQuery>;
export type ProviderListQueryResult = Apollo.QueryResult<ProviderListQuery, ProviderListQueryVariables>;
export const AddProviderDocument = gql`
    mutation addProvider($provider: ProviderInput!) {
  addProvider(provider: $provider) {
    id
  }
}
    `;
export type AddProviderMutationFn = Apollo.MutationFunction<AddProviderMutation, AddProviderMutationVariables>;

/**
 * __useAddProviderMutation__
 *
 * To run a mutation, you first call `useAddProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProviderMutation, { data, loading, error }] = useAddProviderMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useAddProviderMutation(baseOptions?: Apollo.MutationHookOptions<AddProviderMutation, AddProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProviderMutation, AddProviderMutationVariables>(AddProviderDocument, options);
      }
export type AddProviderMutationHookResult = ReturnType<typeof useAddProviderMutation>;
export type AddProviderMutationResult = Apollo.MutationResult<AddProviderMutation>;
export type AddProviderMutationOptions = Apollo.BaseMutationOptions<AddProviderMutation, AddProviderMutationVariables>;
export const UpdateProviderDocument = gql`
    mutation updateProvider($providerId: ID!, $providerToUpdate: ProviderUpdateInput!) {
  updateProvider(providerId: $providerId, providerToUpdate: $providerToUpdate) {
    id
  }
}
    `;
export type UpdateProviderMutationFn = Apollo.MutationFunction<UpdateProviderMutation, UpdateProviderMutationVariables>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      providerToUpdate: // value for 'providerToUpdate'
 *   },
 * });
 */
export function useUpdateProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument, options);
      }
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const LaunchSocialCronDocument = gql`
    mutation launchSocialCron($path: String!) {
  launchSocialCron(path: $path)
}
    `;
export type LaunchSocialCronMutationFn = Apollo.MutationFunction<LaunchSocialCronMutation, LaunchSocialCronMutationVariables>;

/**
 * __useLaunchSocialCronMutation__
 *
 * To run a mutation, you first call `useLaunchSocialCronMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchSocialCronMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchSocialCronMutation, { data, loading, error }] = useLaunchSocialCronMutation({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useLaunchSocialCronMutation(baseOptions?: Apollo.MutationHookOptions<LaunchSocialCronMutation, LaunchSocialCronMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LaunchSocialCronMutation, LaunchSocialCronMutationVariables>(LaunchSocialCronDocument, options);
      }
export type LaunchSocialCronMutationHookResult = ReturnType<typeof useLaunchSocialCronMutation>;
export type LaunchSocialCronMutationResult = Apollo.MutationResult<LaunchSocialCronMutation>;
export type LaunchSocialCronMutationOptions = Apollo.BaseMutationOptions<LaunchSocialCronMutation, LaunchSocialCronMutationVariables>;
export const WebhookConsolidateDocument = gql`
    mutation webhookConsolidate($id: ID!) {
  webhookConsolidate(id: $id)
}
    `;
export type WebhookConsolidateMutationFn = Apollo.MutationFunction<WebhookConsolidateMutation, WebhookConsolidateMutationVariables>;

/**
 * __useWebhookConsolidateMutation__
 *
 * To run a mutation, you first call `useWebhookConsolidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebhookConsolidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webhookConsolidateMutation, { data, loading, error }] = useWebhookConsolidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebhookConsolidateMutation(baseOptions?: Apollo.MutationHookOptions<WebhookConsolidateMutation, WebhookConsolidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebhookConsolidateMutation, WebhookConsolidateMutationVariables>(WebhookConsolidateDocument, options);
      }
export type WebhookConsolidateMutationHookResult = ReturnType<typeof useWebhookConsolidateMutation>;
export type WebhookConsolidateMutationResult = Apollo.MutationResult<WebhookConsolidateMutation>;
export type WebhookConsolidateMutationOptions = Apollo.BaseMutationOptions<WebhookConsolidateMutation, WebhookConsolidateMutationVariables>;
export const WebhookCreateDocument = gql`
    mutation webhookCreate($id: ID!) {
  webhookCreate(id: $id)
}
    `;
export type WebhookCreateMutationFn = Apollo.MutationFunction<WebhookCreateMutation, WebhookCreateMutationVariables>;

/**
 * __useWebhookCreateMutation__
 *
 * To run a mutation, you first call `useWebhookCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebhookCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [webhookCreateMutation, { data, loading, error }] = useWebhookCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebhookCreateMutation(baseOptions?: Apollo.MutationHookOptions<WebhookCreateMutation, WebhookCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WebhookCreateMutation, WebhookCreateMutationVariables>(WebhookCreateDocument, options);
      }
export type WebhookCreateMutationHookResult = ReturnType<typeof useWebhookCreateMutation>;
export type WebhookCreateMutationResult = Apollo.MutationResult<WebhookCreateMutation>;
export type WebhookCreateMutationOptions = Apollo.BaseMutationOptions<WebhookCreateMutation, WebhookCreateMutationVariables>;
export const GetPostsWebhookListDocument = gql`
    query getPostsWebhookList {
  getPostsWebhookList {
    id
    socialNetworkPostId
    postCalendarId
    facebookPage
    webhookData {
      author
      authorId
      message
      url
      postAt
      socialNetworkNotificationId
      socialNetworkAccountId
    }
  }
}
    `;

/**
 * __useGetPostsWebhookListQuery__
 *
 * To run a query within a React component, call `useGetPostsWebhookListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsWebhookListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsWebhookListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPostsWebhookListQuery(baseOptions?: Apollo.QueryHookOptions<GetPostsWebhookListQuery, GetPostsWebhookListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsWebhookListQuery, GetPostsWebhookListQueryVariables>(GetPostsWebhookListDocument, options);
      }
export function useGetPostsWebhookListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsWebhookListQuery, GetPostsWebhookListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsWebhookListQuery, GetPostsWebhookListQueryVariables>(GetPostsWebhookListDocument, options);
        }
export type GetPostsWebhookListQueryHookResult = ReturnType<typeof useGetPostsWebhookListQuery>;
export type GetPostsWebhookListLazyQueryHookResult = ReturnType<typeof useGetPostsWebhookListLazyQuery>;
export type GetPostsWebhookListQueryResult = Apollo.QueryResult<GetPostsWebhookListQuery, GetPostsWebhookListQueryVariables>;